import { useQuery, UseQueryOptions, useInfiniteQuery, UseInfiniteQueryOptions, useMutation, UseMutationOptions, QueryFunctionContext } from 'react-query';
import { useFetchData } from '@/fetcher/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
};

export type ActiveReportBulkDemandPrint = {
  __typename?: 'ActiveReportBulkDemandPrint';
  presignedUrl?: Maybe<Scalars['String']>;
};

export type ActiveReportCreatePriceCard = {
  __typename?: 'ActiveReportCreatePriceCard';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportCreatePriceCardForTshirts = {
  __typename?: 'ActiveReportCreatePriceCardForTshirts';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportDemandPrint = {
  __typename?: 'ActiveReportDemandPrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportEstimatePrint = {
  __typename?: 'ActiveReportEstimatePrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportOutsourcerSalesPrint = {
  __typename?: 'ActiveReportOutsourcerSalesPrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportReceiveOrderPrint = {
  __typename?: 'ActiveReportReceiveOrderPrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportSendOrderPrint = {
  __typename?: 'ActiveReportSendOrderPrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type ActiveReportShipmentPrint = {
  __typename?: 'ActiveReportShipmentPrint';
  pdfBase64?: Maybe<Scalars['String']>;
};

export type Address = Node & {
  __typename?: 'Address';
  city1: Scalars['String'];
  city2: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  prefectures: Scalars['String'];
  prefecturesCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  zipCode1: Scalars['String'];
  zipCode2: Scalars['String'];
};

export type AddressConnection = {
  __typename?: 'AddressConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AddressEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Address` and its cursor. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Address>;
};

/** An enumeration. */
export enum AddressSortEnum {
  City1Asc = 'CITY1_ASC',
  City1Desc = 'CITY1_DESC',
  City2Asc = 'CITY2_ASC',
  City2Desc = 'CITY2_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PrefecturesAsc = 'PREFECTURES_ASC',
  PrefecturesCodeAsc = 'PREFECTURES_CODE_ASC',
  PrefecturesCodeDesc = 'PREFECTURES_CODE_DESC',
  PrefecturesDesc = 'PREFECTURES_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  ZipCode1Asc = 'ZIP_CODE1_ASC',
  ZipCode1Desc = 'ZIP_CODE1_DESC',
  ZipCode2Asc = 'ZIP_CODE2_ASC',
  ZipCode2Desc = 'ZIP_CODE2_DESC'
}

export type Agent = Node & {
  __typename?: 'Agent';
  agentId?: Maybe<Scalars['ID']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  printers?: Maybe<Array<Maybe<Printer>>>;
  search?: Maybe<Scalars['String']>;
};

export type AgentConnection = {
  __typename?: 'AgentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Agent` and its cursor. */
export type AgentEdge = {
  __typename?: 'AgentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Agent>;
};

export type ApprovalSendOrder = {
  orderId: Scalars['Decimal'];
  versionUuid: Scalars['String'];
};

export type ApproveTrustInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  trustInventoryId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type ApproveTrustInventoryPayload = {
  __typename?: 'ApproveTrustInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type Arrival = Node & {
  __typename?: 'Arrival';
  arrivalDate: Scalars['String'];
  arrivalDetails?: Maybe<ArrivalDetailConnection>;
  arrivalId: Scalars['ID'];
  arrivalMemo?: Maybe<Scalars['String']>;
  arrivalTaxDetail?: Maybe<ArrivalTaxDetailConnection>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['Int']>;
  purchase?: Maybe<Purchase>;
  purchaseRemark?: Maybe<Scalars['String']>;
  purchaseVoucherType: Scalars['String'];
  sendOrder?: Maybe<SendOrder>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type ArrivalArrivalDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ArrivalDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArrivalArrivalTaxDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ArrivalConnection = {
  __typename?: 'ArrivalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArrivalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ArrivalDetail = Node & {
  __typename?: 'ArrivalDetail';
  arrival?: Maybe<Arrival>;
  arrivalDetailStatus?: Maybe<Scalars['String']>;
  arrivalId: Scalars['ID'];
  arrivalQuantity?: Maybe<Scalars['Float']>;
  arrivalTradeTypeCode: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  purchasePriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  sendOrderDetailGroupNumbering?: Maybe<Scalars['Int']>;
  sendOrderDetailNumbering?: Maybe<Scalars['Int']>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouse?: Maybe<Warehouse>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type ArrivalDetailConnection = {
  __typename?: 'ArrivalDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArrivalDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ArrivalDetail` and its cursor. */
export type ArrivalDetailEdge = {
  __typename?: 'ArrivalDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArrivalDetail>;
};

export type ArrivalDetailFilter = {
  detailMainFlg?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum ArrivalDetailSortEnum {
  ArrivalDetailStatusAsc = 'ARRIVAL_DETAIL_STATUS_ASC',
  ArrivalDetailStatusDesc = 'ARRIVAL_DETAIL_STATUS_DESC',
  ArrivalIdAsc = 'ARRIVAL_ID_ASC',
  ArrivalIdDesc = 'ARRIVAL_ID_DESC',
  ArrivalQuantityAsc = 'ARRIVAL_QUANTITY_ASC',
  ArrivalQuantityDesc = 'ARRIVAL_QUANTITY_DESC',
  ArrivalTradeTypeCodeAsc = 'ARRIVAL_TRADE_TYPE_CODE_ASC',
  ArrivalTradeTypeCodeDesc = 'ARRIVAL_TRADE_TYPE_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  PurchasePriceAsc = 'PURCHASE_PRICE_ASC',
  PurchasePriceDesc = 'PURCHASE_PRICE_DESC',
  PurchasePriceDollarAsc = 'PURCHASE_PRICE_DOLLAR_ASC',
  PurchasePriceDollarDesc = 'PURCHASE_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  SendOrderDetailGroupNumberingAsc = 'SEND_ORDER_DETAIL_GROUP_NUMBERING_ASC',
  SendOrderDetailGroupNumberingDesc = 'SEND_ORDER_DETAIL_GROUP_NUMBERING_DESC',
  SendOrderDetailNumberingAsc = 'SEND_ORDER_DETAIL_NUMBERING_ASC',
  SendOrderDetailNumberingDesc = 'SEND_ORDER_DETAIL_NUMBERING_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalQuantityAsc = 'TOTAL_QUANTITY_ASC',
  TotalQuantityDesc = 'TOTAL_QUANTITY_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

/** A Relay edge containing a `Arrival` and its cursor. */
export type ArrivalEdge = {
  __typename?: 'ArrivalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Arrival>;
};

/** An enumeration. */
export enum ArrivalSortEnum {
  ArrivalDateAsc = 'ARRIVAL_DATE_ASC',
  ArrivalDateDesc = 'ARRIVAL_DATE_DESC',
  ArrivalIdAsc = 'ARRIVAL_ID_ASC',
  ArrivalIdDesc = 'ARRIVAL_ID_DESC',
  ArrivalMemoAsc = 'ARRIVAL_MEMO_ASC',
  ArrivalMemoDesc = 'ARRIVAL_MEMO_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PurchaseRemarkAsc = 'PURCHASE_REMARK_ASC',
  PurchaseRemarkDesc = 'PURCHASE_REMARK_DESC',
  PurchaseVoucherTypeAsc = 'PURCHASE_VOUCHER_TYPE_ASC',
  PurchaseVoucherTypeDesc = 'PURCHASE_VOUCHER_TYPE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ArrivalTaxDetail = Node & {
  __typename?: 'ArrivalTaxDetail';
  arrivalId?: Maybe<Scalars['Int']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  exciseTax?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  purchaseId?: Maybe<Scalars['Int']>;
  taxExcluded?: Maybe<Scalars['Float']>;
  taxIncluded?: Maybe<Scalars['Float']>;
  taxRoundType: Scalars['String'];
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ArrivalTaxDetailConnection = {
  __typename?: 'ArrivalTaxDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArrivalTaxDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ArrivalTaxDetail` and its cursor. */
export type ArrivalTaxDetailEdge = {
  __typename?: 'ArrivalTaxDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArrivalTaxDetail>;
};

/** An enumeration. */
export enum ArrivalTaxDetailSortEnum {
  ArrivalIdAsc = 'ARRIVAL_ID_ASC',
  ArrivalIdDesc = 'ARRIVAL_ID_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  ExciseTaxAsc = 'EXCISE_TAX_ASC',
  ExciseTaxDesc = 'EXCISE_TAX_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  PurchaseIdAsc = 'PURCHASE_ID_ASC',
  PurchaseIdDesc = 'PURCHASE_ID_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TaxExcludedAsc = 'TAX_EXCLUDED_ASC',
  TaxExcludedDesc = 'TAX_EXCLUDED_DESC',
  TaxIncludedAsc = 'TAX_INCLUDED_ASC',
  TaxIncludedDesc = 'TAX_INCLUDED_DESC',
  TaxRoundTypeAsc = 'TAX_ROUND_TYPE_ASC',
  TaxRoundTypeDesc = 'TAX_ROUND_TYPE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type AutoDeposit = Node & {
  __typename?: 'AutoDeposit';
  autoDepositId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  demandDetailId: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type AutoDepositConnection = {
  __typename?: 'AutoDepositConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoDepositEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AutoDepositDetail = Node & {
  __typename?: 'AutoDepositDetail';
  autoDepositDivision: Scalars['String'];
  autoDepositId: Scalars['ID'];
  autoDepositPrice: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type AutoDepositDetailConnection = {
  __typename?: 'AutoDepositDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoDepositDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AutoDepositDetail` and its cursor. */
export type AutoDepositDetailEdge = {
  __typename?: 'AutoDepositDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoDepositDetail>;
};

/** An enumeration. */
export enum AutoDepositDetailSortEnum {
  AutoDepositDivisionAsc = 'AUTO_DEPOSIT_DIVISION_ASC',
  AutoDepositDivisionDesc = 'AUTO_DEPOSIT_DIVISION_DESC',
  AutoDepositIdAsc = 'AUTO_DEPOSIT_ID_ASC',
  AutoDepositIdDesc = 'AUTO_DEPOSIT_ID_DESC',
  AutoDepositPriceAsc = 'AUTO_DEPOSIT_PRICE_ASC',
  AutoDepositPriceDesc = 'AUTO_DEPOSIT_PRICE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `AutoDeposit` and its cursor. */
export type AutoDepositEdge = {
  __typename?: 'AutoDepositEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoDeposit>;
};

/** An enumeration. */
export enum AutoDepositSortEnum {
  AutoDepositIdAsc = 'AUTO_DEPOSIT_ID_ASC',
  AutoDepositIdDesc = 'AUTO_DEPOSIT_ID_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DemandDetailIdAsc = 'DEMAND_DETAIL_ID_ASC',
  DemandDetailIdDesc = 'DEMAND_DETAIL_ID_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type AutoWithdrawal = Node & {
  __typename?: 'AutoWithdrawal';
  autoPayId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  paymentDetailId: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type AutoWithdrawalConnection = {
  __typename?: 'AutoWithdrawalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoWithdrawalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AutoWithdrawalDetail = Node & {
  __typename?: 'AutoWithdrawalDetail';
  autoPayDivision: Scalars['String'];
  autoPayId: Scalars['ID'];
  autoPayPrice: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type AutoWithdrawalDetailConnection = {
  __typename?: 'AutoWithdrawalDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoWithdrawalDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AutoWithdrawalDetail` and its cursor. */
export type AutoWithdrawalDetailEdge = {
  __typename?: 'AutoWithdrawalDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoWithdrawalDetail>;
};

/** An enumeration. */
export enum AutoWithdrawalDetailSortEnum {
  AutoPayDivisionAsc = 'AUTO_PAY_DIVISION_ASC',
  AutoPayDivisionDesc = 'AUTO_PAY_DIVISION_DESC',
  AutoPayIdAsc = 'AUTO_PAY_ID_ASC',
  AutoPayIdDesc = 'AUTO_PAY_ID_DESC',
  AutoPayPriceAsc = 'AUTO_PAY_PRICE_ASC',
  AutoPayPriceDesc = 'AUTO_PAY_PRICE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `AutoWithdrawal` and its cursor. */
export type AutoWithdrawalEdge = {
  __typename?: 'AutoWithdrawalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoWithdrawal>;
};

/** An enumeration. */
export enum AutoWithdrawalSortEnum {
  AutoPayIdAsc = 'AUTO_PAY_ID_ASC',
  AutoPayIdDesc = 'AUTO_PAY_ID_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  PaymentDetailIdAsc = 'PAYMENT_DETAIL_ID_ASC',
  PaymentDetailIdDesc = 'PAYMENT_DETAIL_ID_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type BeforeDemandClosing = Node & {
  __typename?: 'BeforeDemandClosing';
  beforeDemandRemain?: Maybe<Scalars['Int']>;
  carryOverPrice?: Maybe<Scalars['Int']>;
  closingDate?: Maybe<Scalars['Date']>;
  collectExpectedDate?: Maybe<Scalars['Date']>;
  currentDemandExpectRemain?: Maybe<Scalars['Int']>;
  customerFuri?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  demandCode?: Maybe<Scalars['String']>;
  depositPriceTotalInAccountMonth?: Maybe<Scalars['Int']>;
  exciseTaxPer8?: Maybe<Scalars['Float']>;
  exciseTaxPer10?: Maybe<Scalars['Float']>;
  exciseTaxTotal?: Maybe<Scalars['Int']>;
  excludedTaxTotalDemandPrice?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  includedTaxTotalDemandPrice?: Maybe<Scalars['Int']>;
  taxExcludedPer8?: Maybe<Scalars['Float']>;
  taxExcludedPer10?: Maybe<Scalars['Float']>;
};

export type BeforeDemandClosingConnection = {
  __typename?: 'BeforeDemandClosingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BeforeDemandClosingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `BeforeDemandClosing` and its cursor. */
export type BeforeDemandClosingEdge = {
  __typename?: 'BeforeDemandClosingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BeforeDemandClosing>;
};

export type BulkDemandPrintInput = {
  carryOverPriceFlg: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  demandIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  detailStatus: Scalars['String'];
  excluedeZeroDemand: Scalars['String'];
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type BulkDemandPrintPayload = {
  __typename?: 'BulkDemandPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  base64?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

export type ClothProgress = Node & {
  __typename?: 'ClothProgress';
  Warehouse?: Maybe<Warehouse>;
  clothProgressArraival?: Maybe<Array<Maybe<ClothProgressArraival>>>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  groupNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  orderDetailStatus: Scalars['String'];
  orderId: Scalars['ID'];
  orderQuantity?: Maybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  purchasePriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  receivedQuantity?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type ClothProgressArraival = {
  __typename?: 'ClothProgressArraival';
  arrivalDate?: Maybe<Scalars['Date']>;
  arrivalQuantity?: Maybe<Scalars['Float']>;
};

export type ClothProgressConnection = {
  __typename?: 'ClothProgressConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClothProgressEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ClothProgress` and its cursor. */
export type ClothProgressEdge = {
  __typename?: 'ClothProgressEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ClothProgress>;
};

export type ClothProgressFilter = {
  clothGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDateFrom: Scalars['Date'];
  orderDateTo: Scalars['Date'];
  orderDetailStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum ClothProgressSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  GroupNumberingAsc = 'GROUP_NUMBERING_ASC',
  GroupNumberingDesc = 'GROUP_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OrderDetailStatusAsc = 'ORDER_DETAIL_STATUS_ASC',
  OrderDetailStatusDesc = 'ORDER_DETAIL_STATUS_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  OrderQuantityAsc = 'ORDER_QUANTITY_ASC',
  OrderQuantityDesc = 'ORDER_QUANTITY_DESC',
  OrderTradeTypeCodeAsc = 'ORDER_TRADE_TYPE_CODE_ASC',
  OrderTradeTypeCodeDesc = 'ORDER_TRADE_TYPE_CODE_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  PurchasePriceAsc = 'PURCHASE_PRICE_ASC',
  PurchasePriceDesc = 'PURCHASE_PRICE_DESC',
  PurchasePriceDollarAsc = 'PURCHASE_PRICE_DOLLAR_ASC',
  PurchasePriceDollarDesc = 'PURCHASE_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  ReceivedQuantityAsc = 'RECEIVED_QUANTITY_ASC',
  ReceivedQuantityDesc = 'RECEIVED_QUANTITY_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalQuantityAsc = 'TOTAL_QUANTITY_ASC',
  TotalQuantityDesc = 'TOTAL_QUANTITY_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type CollectionStatus = Node & {
  __typename?: 'CollectionStatus';
  collectExpectedAfterNextMonth?: Maybe<Scalars['Float']>;
  collectExpectedLastMonth?: Maybe<Scalars['Float']>;
  collectExpectedNextMonth?: Maybe<Scalars['Float']>;
  collectExpectedThisMonth?: Maybe<Scalars['Float']>;
  collectedNeedThisMonth?: Maybe<Scalars['Float']>;
  collectedRate?: Maybe<Scalars['Float']>;
  collectedThisMonth?: Maybe<Scalars['Float']>;
  demandCode?: Maybe<Scalars['String']>;
  demandName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  remainedLastMonth?: Maybe<Scalars['Float']>;
  remainedThisMonth?: Maybe<Scalars['Float']>;
  remainedThisMonthEnd?: Maybe<Scalars['Float']>;
  userName?: Maybe<Scalars['String']>;
};

export type CollectionStatusConnection = {
  __typename?: 'CollectionStatusConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionStatusEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CollectionStatus` and its cursor. */
export type CollectionStatusEdge = {
  __typename?: 'CollectionStatusEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionStatus>;
};

export type Component = Node & {
  __typename?: 'Component';
  componentDetail?: Maybe<ComponentDetailConnection>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  finishedProductCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  productView?: Maybe<ProductView>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type ComponentComponentDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ComponentConnection = {
  __typename?: 'ComponentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComponentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ComponentDetail = Node & {
  __typename?: 'ComponentDetail';
  component?: Maybe<Component>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  finishedProductCode: Scalars['String'];
  frontNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  productPartsCode: Scalars['String'];
  productView?: Maybe<ProductView>;
  quantity: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ComponentDetailConnection = {
  __typename?: 'ComponentDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComponentDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ComponentDetail` and its cursor. */
export type ComponentDetailEdge = {
  __typename?: 'ComponentDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ComponentDetail>;
};

/** An enumeration. */
export enum ComponentDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  FinishedProductCodeAsc = 'FINISHED_PRODUCT_CODE_ASC',
  FinishedProductCodeDesc = 'FINISHED_PRODUCT_CODE_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  ProductPartsCodeAsc = 'PRODUCT_PARTS_CODE_ASC',
  ProductPartsCodeDesc = 'PRODUCT_PARTS_CODE_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ComponentDetailWithPrice = {
  __typename?: 'ComponentDetailWithPrice';
  attributeName?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productPartsCode?: Maybe<Scalars['String']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Decimal']>;
  salesUnitPrice?: Maybe<Scalars['Decimal']>;
  stockQuantity?: Maybe<Scalars['Decimal']>;
};

/** A Relay edge containing a `Component` and its cursor. */
export type ComponentEdge = {
  __typename?: 'ComponentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Component>;
};

/** An enumeration. */
export enum ComponentSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  FinishedProductCodeAsc = 'FINISHED_PRODUCT_CODE_ASC',
  FinishedProductCodeDesc = 'FINISHED_PRODUCT_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ComponentWithPrice = {
  __typename?: 'ComponentWithPrice';
  componentDetail?: Maybe<Array<Maybe<ComponentDetailWithPrice>>>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  finishedProductCode?: Maybe<Scalars['String']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Decimal']>;
};

export type ComponentWithPriceFilter = {
  finishedProductCode: Scalars['String'];
  targetDate: Scalars['Date'];
  warehouseCode: Scalars['String'];
};

export type Corporation = Node & {
  __typename?: 'Corporation';
  bankAccountCode?: Maybe<Scalars['String']>;
  bankAccountFuri?: Maybe<Scalars['String']>;
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountRelation?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bankFuri?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchOfficeCode?: Maybe<Scalars['String']>;
  branchOfficeFuri?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  corpAddress?: Maybe<Scalars['String']>;
  corpEmail?: Maybe<Scalars['String']>;
  corpFax1?: Maybe<Scalars['String']>;
  corpFax2?: Maybe<Scalars['String']>;
  corpFax3?: Maybe<Scalars['String']>;
  corpId: Scalars['ID'];
  corpMemo?: Maybe<Scalars['String']>;
  corpName?: Maybe<Scalars['String']>;
  corpTel1?: Maybe<Scalars['String']>;
  corpTel1TypeName?: Maybe<Scalars['String']>;
  corpTel2?: Maybe<Scalars['String']>;
  corpTel2TypeName?: Maybe<Scalars['String']>;
  corpTel3?: Maybe<Scalars['String']>;
  corpTel3TypeName?: Maybe<Scalars['String']>;
  corpZipCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  invoiceRegistrationCode?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type CorporationConnection = {
  __typename?: 'CorporationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CorporationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Corporation` and its cursor. */
export type CorporationEdge = {
  __typename?: 'CorporationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Corporation>;
};

/** An enumeration. */
export enum CorporationSortEnum {
  BankAccountCodeAsc = 'BANK_ACCOUNT_CODE_ASC',
  BankAccountCodeDesc = 'BANK_ACCOUNT_CODE_DESC',
  BankAccountFuriAsc = 'BANK_ACCOUNT_FURI_ASC',
  BankAccountFuriDesc = 'BANK_ACCOUNT_FURI_DESC',
  BankAccountNameAsc = 'BANK_ACCOUNT_NAME_ASC',
  BankAccountNameDesc = 'BANK_ACCOUNT_NAME_DESC',
  BankAccountRelationAsc = 'BANK_ACCOUNT_RELATION_ASC',
  BankAccountRelationDesc = 'BANK_ACCOUNT_RELATION_DESC',
  BankAccountTypeAsc = 'BANK_ACCOUNT_TYPE_ASC',
  BankAccountTypeDesc = 'BANK_ACCOUNT_TYPE_DESC',
  BankCodeAsc = 'BANK_CODE_ASC',
  BankCodeDesc = 'BANK_CODE_DESC',
  BankFuriAsc = 'BANK_FURI_ASC',
  BankFuriDesc = 'BANK_FURI_DESC',
  BankNameAsc = 'BANK_NAME_ASC',
  BankNameDesc = 'BANK_NAME_DESC',
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeFuriAsc = 'BRANCH_OFFICE_FURI_ASC',
  BranchOfficeFuriDesc = 'BRANCH_OFFICE_FURI_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CorpAddressAsc = 'CORP_ADDRESS_ASC',
  CorpAddressDesc = 'CORP_ADDRESS_DESC',
  CorpEmailAsc = 'CORP_EMAIL_ASC',
  CorpEmailDesc = 'CORP_EMAIL_DESC',
  CorpFax1Asc = 'CORP_FAX1_ASC',
  CorpFax1Desc = 'CORP_FAX1_DESC',
  CorpFax2Asc = 'CORP_FAX2_ASC',
  CorpFax2Desc = 'CORP_FAX2_DESC',
  CorpFax3Asc = 'CORP_FAX3_ASC',
  CorpFax3Desc = 'CORP_FAX3_DESC',
  CorpIdAsc = 'CORP_ID_ASC',
  CorpIdDesc = 'CORP_ID_DESC',
  CorpMemoAsc = 'CORP_MEMO_ASC',
  CorpMemoDesc = 'CORP_MEMO_DESC',
  CorpNameAsc = 'CORP_NAME_ASC',
  CorpNameDesc = 'CORP_NAME_DESC',
  CorpTel1Asc = 'CORP_TEL1_ASC',
  CorpTel1Desc = 'CORP_TEL1_DESC',
  CorpTel1TypeNameAsc = 'CORP_TEL1_TYPE_NAME_ASC',
  CorpTel1TypeNameDesc = 'CORP_TEL1_TYPE_NAME_DESC',
  CorpTel2Asc = 'CORP_TEL2_ASC',
  CorpTel2Desc = 'CORP_TEL2_DESC',
  CorpTel2TypeNameAsc = 'CORP_TEL2_TYPE_NAME_ASC',
  CorpTel2TypeNameDesc = 'CORP_TEL2_TYPE_NAME_DESC',
  CorpTel3Asc = 'CORP_TEL3_ASC',
  CorpTel3Desc = 'CORP_TEL3_DESC',
  CorpTel3TypeNameAsc = 'CORP_TEL3_TYPE_NAME_ASC',
  CorpTel3TypeNameDesc = 'CORP_TEL3_TYPE_NAME_DESC',
  CorpZipCodeAsc = 'CORP_ZIP_CODE_ASC',
  CorpZipCodeDesc = 'CORP_ZIP_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  InvoiceRegistrationCodeAsc = 'INVOICE_REGISTRATION_CODE_ASC',
  InvoiceRegistrationCodeDesc = 'INVOICE_REGISTRATION_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type CreateAdjudstDetailList = {
  adjustQuantity: Scalars['Decimal'];
  damageQuantity: Scalars['Decimal'];
  detailMemo?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  numbering: Scalars['Int'];
  productCode: Scalars['String'];
  stockQuantity: Scalars['Decimal'];
};

export type CreateArrivalDetail = {
  arrivalDetailStatus?: InputMaybe<Scalars['String']>;
  arrivalQuantity?: InputMaybe<Scalars['Float']>;
  arrivalTradeTypeCode: Scalars['String'];
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  sendOrderDetailGroupNumbering?: InputMaybe<Scalars['Int']>;
  sendOrderDetailNumbering?: InputMaybe<Scalars['Int']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateArrivalInput = {
  arrivalDate: Scalars['String'];
  arrivalDetails?: InputMaybe<Array<InputMaybe<CreateArrivalDetail>>>;
  arrivalMemo?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingTiming?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  poCode?: InputMaybe<Scalars['String']>;
  purchaseRemark?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorTaxType: Scalars['String'];
};

export type CreateArrivalPayload = {
  __typename?: 'CreateArrivalPayload';
  arrival?: Maybe<Arrival>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateAutomaticWithdrawal = {
  automticWithdrawalDetails?: InputMaybe<Array<InputMaybe<CreateAutomaticWithdrawalDetail>>>;
  currentPaymentPrice?: InputMaybe<Scalars['Decimal']>;
  currentTransferPrice?: InputMaybe<Scalars['Decimal']>;
  depositPrice?: InputMaybe<Scalars['Decimal']>;
  differencePrice?: InputMaybe<Scalars['Decimal']>;
  payDate: Scalars['Date'];
  paymentId: Scalars['Int'];
  paymentMemo?: InputMaybe<Scalars['String']>;
  paymentTaxAdjustDetails?: InputMaybe<Array<InputMaybe<UpsertPaymentTaxAdjustDetailEx>>>;
  paymentVersionUuid: Scalars['String'];
  userCode?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
};

export type CreateAutomaticWithdrawalDetail = {
  payDivisionCode?: InputMaybe<Scalars['String']>;
  payDivisionDetail?: InputMaybe<Scalars['String']>;
  payPrice: Scalars['Decimal'];
};

export type CreateAutomaticWithdrawalsInput = {
  automaticWithdrawals: Array<InputMaybe<CreateAutomaticWithdrawal>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateAutomaticWithdrawalsPayload = {
  __typename?: 'CreateAutomaticWithdrawalsPayload';
  automaticWithdrawal?: Maybe<Withdrawal>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateBudgetList = {
  budgetDate: Scalars['String'];
  budgetPrice?: InputMaybe<Scalars['Decimal']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type CreateBulkDepositDetail = {
  demandCode: Scalars['String'];
  depositDate: Scalars['Date'];
  depositPriceMain: Scalars['Decimal'];
  depositPriceSub: Scalars['Decimal'];
};

export type CreateBulkDepositInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demandMonth: Scalars['Date'];
  depositDivisionCodeMain: Scalars['String'];
  depositDivisionCodeSub: Scalars['String'];
  depositList: Array<InputMaybe<CreateBulkDepositDetail>>;
};

export type CreateBulkDepositPayload = {
  __typename?: 'CreateBulkDepositPayload';
  allResult?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  resultList?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type CreateComponentDetail = {
  frontNumbering: Scalars['Int'];
  productPartsCode: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type CreateComponentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  componentDetail: Array<InputMaybe<CreateComponentDetail>>;
  finishedProductCode: Scalars['String'];
};

export type CreateComponentPayload = {
  __typename?: 'CreateComponentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  component?: Maybe<Component>;
};

export type CreateCustomerBudgetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerLists: Array<InputMaybe<CreateCustomerList>>;
};

export type CreateCustomerBudgetPayload = {
  __typename?: 'CreateCustomerBudgetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerBudget?: Maybe<CustomerBudget>;
};

export type CreateCustomerInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLabelFlg?: InputMaybe<Scalars['String']>;
  billSendDivision?: InputMaybe<Scalars['String']>;
  billSite?: InputMaybe<Scalars['Int']>;
  businessAmebaFlg?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectCycleCode?: InputMaybe<Scalars['String']>;
  collectDate?: InputMaybe<Scalars['Int']>;
  collectDays?: InputMaybe<Scalars['Int']>;
  collectMethodCode?: InputMaybe<Scalars['String']>;
  creditLimitPrice?: InputMaybe<Scalars['Decimal']>;
  customerArea?: InputMaybe<Scalars['String']>;
  customerFuri: Scalars['String'];
  customerGroup?: InputMaybe<Scalars['String']>;
  customerMemo?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerRank?: InputMaybe<Scalars['String']>;
  customerUnitpriceType: Scalars['String'];
  customerUser?: InputMaybe<Scalars['String']>;
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCode?: InputMaybe<Scalars['String']>;
  designAmebaFlg?: InputMaybe<Scalars['String']>;
  divisionBundle?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  inventoryControlUnit: Scalars['String'];
  outsourcerCode?: InputMaybe<Scalars['String']>;
  prescribeDemandReport?: InputMaybe<Scalars['String']>;
  prescribeSalesReport?: InputMaybe<Scalars['String']>;
  priceRoundType: Scalars['String'];
  ratio: Scalars['Float'];
  reportOutputUnit: Scalars['String'];
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUserEmail1?: InputMaybe<Scalars['String']>;
  salesUserEmail2?: InputMaybe<Scalars['String']>;
  salesUserEmail3?: InputMaybe<Scalars['String']>;
  salesUserName1?: InputMaybe<Scalars['String']>;
  salesUserName2?: InputMaybe<Scalars['String']>;
  salesUserName3?: InputMaybe<Scalars['String']>;
  taxRoundType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeStopFlg?: InputMaybe<Scalars['String']>;
  transferShareCost?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
  userDivisionCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateCustomerList = {
  budgetLists: Array<InputMaybe<CreateBudgetList>>;
  customerCode: Scalars['String'];
};

export type CreateCustomerPayload = {
  __typename?: 'CreateCustomerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

export type CreateCustomerPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  priceList: Array<InputMaybe<CreatePriceList>>;
};

export type CreateCustomerPricePayload = {
  __typename?: 'CreateCustomerPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerPrice?: Maybe<CustomerPrice>;
};

export type CreateCustomerPriceWithBulkImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceList?: InputMaybe<Array<InputMaybe<CreatePriceListWithBulkImport>>>;
};

export type CreateCustomerPriceWithBulkImportPayload = {
  __typename?: 'CreateCustomerPriceWithBulkImportPayload';
  allResult?: Maybe<Scalars['Boolean']>;
  clientMutationId?: Maybe<Scalars['String']>;
  resultDatas?: Maybe<Array<Maybe<CreateCustomerResultData>>>;
};

export type CreateCustomerPriceWithImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  priceList?: InputMaybe<Array<InputMaybe<CreatePriceListWithImport>>>;
};

export type CreateCustomerPriceWithImportPayload = {
  __typename?: 'CreateCustomerPriceWithImportPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  resultDatas?: Maybe<Array<Maybe<CreateCustomerResultData>>>;
};

export type CreateCustomerProductGroupPublicationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerProductGroupPublicationUpdateList: Array<InputMaybe<CustomerProductGroupPublicationInput>>;
};

export type CreateCustomerProductGroupPublicationPayload = {
  __typename?: 'CreateCustomerProductGroupPublicationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateCustomerProductGroupPublicationWithImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerProductGroupPublicationImportList: Array<InputMaybe<CustomerProductGroupPublicationWithImportInput>>;
};

export type CreateCustomerProductGroupPublicationWithImportPayload = {
  __typename?: 'CreateCustomerProductGroupPublicationWithImportPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  importResults?: Maybe<Array<Maybe<CustomerProductGroupPublicationWithImportResultData>>>;
};

export type CreateCustomerProductPublicationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerProductPublicationUpdateList: Array<InputMaybe<CustomerProductPublicationInput>>;
};

export type CreateCustomerProductPublicationPayload = {
  __typename?: 'CreateCustomerProductPublicationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type CreateCustomerProductPublicationWithImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerProductPublicationImportList: Array<InputMaybe<CustomerProductPublicationWithImportInput>>;
};

export type CreateCustomerProductPublicationWithImportPayload = {
  __typename?: 'CreateCustomerProductPublicationWithImportPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  importResults?: Maybe<Array<Maybe<CustomerProductPublicationWithImportResultData>>>;
};

export type CreateCustomerResultData = {
  __typename?: 'CreateCustomerResultData';
  importFlg?: Maybe<Scalars['Boolean']>;
};

export type CreateCustomerUserBelong = {
  customerCode?: InputMaybe<Scalars['String']>;
  customerGroup?: InputMaybe<Scalars['String']>;
  customerUserId?: InputMaybe<Scalars['Int']>;
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
};

export type CreateCustomerUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerUserBelong?: InputMaybe<Array<InputMaybe<CreateCustomerUserBelong>>>;
  customerUserName: Scalars['String'];
  email: Scalars['String'];
  initialConfirmationDate?: InputMaybe<Scalars['Date']>;
  password: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  termsOfUseVersion?: InputMaybe<Scalars['Int']>;
  updateConfirmationDate?: InputMaybe<Scalars['Date']>;
};

export type CreateCustomerUserPayload = {
  __typename?: 'CreateCustomerUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerUser?: Maybe<CustomerUser>;
};

export type CreateDeliverInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerUser?: InputMaybe<Scalars['String']>;
  deliveryDestinationName: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateDeliverPayload = {
  __typename?: 'CreateDeliverPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deliver?: Maybe<Deliver>;
};

export type CreateDemandInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingDate: Scalars['Date'];
  demandCodes: Array<InputMaybe<Scalars['String']>>;
};

export type CreateDemandPayload = {
  __typename?: 'CreateDemandPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  demand?: Maybe<Demand>;
};

export type CreateDepositDemand = {
  demandId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type CreateDepositDetail = {
  billDate?: InputMaybe<Scalars['Date']>;
  depositDivisionCode: Scalars['String'];
  depositDivisionDetail?: InputMaybe<Scalars['String']>;
  depositPrice: Scalars['Decimal'];
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering: Scalars['Int'];
};

export type CreateDepositInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demandCode: Scalars['String'];
  demandIds: Array<InputMaybe<CreateDepositDemand>>;
  depositDate: Scalars['Date'];
  depositDetails: Array<InputMaybe<CreateDepositDetail>>;
  depositRemark?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
};

export type CreateDepositPayload = {
  __typename?: 'CreateDepositPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deposit?: Maybe<Deposit>;
};

export type CreateDirectPurchaseDetail = {
  day: Scalars['Int'];
  largeClassCode?: InputMaybe<Scalars['String']>;
  largeClassName?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  middleClassCode?: InputMaybe<Scalars['String']>;
  middleClassName?: InputMaybe<Scalars['String']>;
  month: Scalars['Int'];
  price: Scalars['Float'];
  retailPrice?: InputMaybe<Scalars['Float']>;
  shopCode: Scalars['String'];
  shopName?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorName?: InputMaybe<Scalars['String']>;
  voucherNo: Scalars['String'];
  year: Scalars['Int'];
};

export type CreateDirectPurchaseInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  purchaseDetails?: InputMaybe<Array<InputMaybe<CreateDirectPurchaseDetail>>>;
};

export type CreateDirectPurchasePayload = {
  __typename?: 'CreateDirectPurchasePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  resultDatas?: Maybe<Array<Maybe<ResultData>>>;
};

export type CreateDirectWipDetail = {
  divisionCode: Scalars['String'];
  price: Scalars['Float'];
  purchaseDate: Scalars['String'];
  remark?: InputMaybe<Scalars['String']>;
  taxationDivision: Scalars['String'];
  vendorCode: Scalars['String'];
};

export type CreateDirectWipInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  wipDetails?: InputMaybe<Array<InputMaybe<CreateDirectWipDetail>>>;
};

export type CreateDirectWipPayload = {
  __typename?: 'CreateDirectWipPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  resultDatas?: Maybe<Array<Maybe<WipResultData>>>;
};

export type CreateDispTrustInventory = Node & {
  __typename?: 'CreateDispTrustInventory';
  beforeInventoryQuantity?: Maybe<Scalars['Float']>;
  currentInputQuantity?: Maybe<Scalars['Float']>;
  currentInputTotalTaxExcluded?: Maybe<Scalars['Float']>;
  currentReturnQuantity?: Maybe<Scalars['Float']>;
  currentReturnTotalTaxExcluded?: Maybe<Scalars['Float']>;
  currentStockQuantity?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  physicalInventory?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDegits?: Maybe<Scalars['Int']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
};

export type CreateDispTrustInventoryConnection = {
  __typename?: 'CreateDispTrustInventoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreateDispTrustInventoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CreateDispTrustInventory` and its cursor. */
export type CreateDispTrustInventoryEdge = {
  __typename?: 'CreateDispTrustInventoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CreateDispTrustInventory>;
};

export type CreateDivisionFinancialDate = {
  financialStage: Scalars['String'];
  targetGrossMarginRate: Scalars['Decimal'];
};

export type CreateDivisionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionFinancialDetail?: InputMaybe<Array<InputMaybe<CreateDivisionFinancialDate>>>;
  divisionName: Scalars['String'];
  divistionType: Scalars['String'];
  recordHighSales?: InputMaybe<Scalars['Decimal']>;
  windowName: Scalars['String'];
};

export type CreateDivisionPayload = {
  __typename?: 'CreateDivisionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
};

export type CreateEstimateDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  divisionName?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  janCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  receiveDetailTradeType: Scalars['String'];
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  salesUnitPrice?: InputMaybe<Scalars['Float']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
};

export type CreateEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  customerUser?: InputMaybe<Scalars['String']>;
  deliverPeriod?: InputMaybe<Scalars['String']>;
  deliverPlace?: InputMaybe<Scalars['String']>;
  estimateDate: Scalars['String'];
  estimateDetails?: InputMaybe<Array<InputMaybe<CreateEstimateDetail>>>;
  estimateRemark?: InputMaybe<Scalars['String']>;
  estimateTitle?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeMethod?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
};

export type CreateEstimatePayload = {
  __typename?: 'CreateEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimate?: Maybe<Estimate>;
};

export type CreateFkorderInformationAttachment = {
  filename: Scalars['String'];
  s3Key: Scalars['String'];
};

export type CreateFkorderInformationAttachmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateFkorderInformationAttachmentPayload = {
  __typename?: 'CreateFkorderInformationAttachmentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  s3Key: Scalars['String'];
  url: Scalars['String'];
};

export type CreateFkorderInformationInput = {
  attachments?: InputMaybe<Array<InputMaybe<CreateFkorderInformationAttachment>>>;
  body: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  informationType: Scalars['String'];
  postedAt: Scalars['Date'];
  publicationFrom: Scalars['Date'];
  publicationTo: Scalars['Date'];
  title: Scalars['String'];
};

export type CreateFkorderInformationPayload = {
  __typename?: 'CreateFkorderInformationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fkorderInformation?: Maybe<FkorderInformation>;
};

export type CreateInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inventoryBaseFrom: Scalars['Date'];
  inventoryBaseTo: Scalars['Date'];
  inventoryName: Scalars['String'];
};

export type CreateInventoryPayload = {
  __typename?: 'CreateInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inventory?: Maybe<Inventory>;
};

export type CreateOutsourcerSalesDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
};

export type CreateOutsourcerSalesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  salesDate: Scalars['String'];
  salesDetails?: InputMaybe<Array<InputMaybe<CreateOutsourcerSalesDetail>>>;
  salesRemark?: InputMaybe<Scalars['String']>;
};

export type CreateOutsourcerSalesPayload = {
  __typename?: 'CreateOutsourcerSalesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sales?: Maybe<Sales>;
};

export type CreatePaymentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingDate: Scalars['Date'];
  vendorCodes: Array<InputMaybe<Scalars['String']>>;
};

export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
};

export type CreatePriceCard = {
  productCode?: InputMaybe<Scalars['String']>;
  productCopy?: InputMaybe<Scalars['Int']>;
};

export type CreatePriceCardForTshirts = {
  copies?: InputMaybe<Scalars['Int']>;
  janCode1: Scalars['String'];
  janCode2?: InputMaybe<Scalars['String']>;
  janCode3?: InputMaybe<Scalars['String']>;
  janCode4?: InputMaybe<Scalars['String']>;
  note1?: InputMaybe<Scalars['String']>;
  note2?: InputMaybe<Scalars['String']>;
  note3?: InputMaybe<Scalars['String']>;
  note4?: InputMaybe<Scalars['String']>;
  printName: Scalars['String'];
};

export type CreatePriceList = {
  customerCode?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  sellingUnitPrice?: InputMaybe<Scalars['Decimal']>;
  startDate?: InputMaybe<Scalars['String']>;
  uniqueCode?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type CreatePriceListWithBulkImport = {
  janCode: Scalars['String'];
  sellingUnitPrice: Scalars['Decimal'];
  startDate: Scalars['String'];
  updateType?: InputMaybe<UpdateType>;
};

export type CreatePriceListWithImport = {
  customerCode: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  sellingUnitPrice: Scalars['Decimal'];
  startDate: Scalars['String'];
  updateType?: InputMaybe<UpdateType>;
};

export type CreateProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clothGroup?: InputMaybe<Scalars['String']>;
  componentDivision?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  designUserCode?: InputMaybe<Scalars['String']>;
  discontinueFlg?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  inventoryControlFlg?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  manufacturer?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxPurchaseOrderQty?: InputMaybe<Scalars['Int']>;
  notIncludedSku?: InputMaybe<Scalars['String']>;
  planningUserCode?: InputMaybe<Scalars['String']>;
  productFuri?: InputMaybe<Scalars['String']>;
  productGroupId1?: InputMaybe<Scalars['Int']>;
  productGroupId2?: InputMaybe<Scalars['Int']>;
  productGroupId3?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
  productPrice: Array<InputMaybe<CreateProductPrice>>;
  productVariants: Array<InputMaybe<CreateProductVariant>>;
  purchaseOrderLeadTime?: InputMaybe<Scalars['Int']>;
  quantityDecimalDigits?: InputMaybe<Scalars['Int']>;
  receiveOrderLot?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  unitCode?: InputMaybe<Scalars['String']>;
  unitDollarDecimalDigits?: InputMaybe<Scalars['Int']>;
  unitYenDecimalDigits?: InputMaybe<Scalars['Int']>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type CreateProductPayload = {
  __typename?: 'CreateProductPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

export type CreateProductPrice = {
  endDate: Scalars['Date'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Decimal']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Decimal']>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  salesUnitPrice?: InputMaybe<Scalars['Decimal']>;
  startDate: Scalars['Date'];
};

export type CreateProductVariant = {
  attr1?: InputMaybe<Scalars['String']>;
  attr2?: InputMaybe<Scalars['String']>;
  baseStockQuantity?: InputMaybe<Scalars['Int']>;
  discontinueFlg?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: InputMaybe<Scalars['Int']>;
  endOfSalesDate?: InputMaybe<Scalars['String']>;
  fcCode1?: InputMaybe<Scalars['String']>;
  fcCode2?: InputMaybe<Scalars['String']>;
  fcCode3?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber1?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber2?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber3?: InputMaybe<Scalars['String']>;
  firstArrivalDate?: InputMaybe<Scalars['String']>;
  innerCartonSize?: InputMaybe<Scalars['String']>;
  innerCartonUnit?: InputMaybe<Scalars['Int']>;
  innerCartonWeight?: InputMaybe<Scalars['String']>;
  lotGroupCode?: InputMaybe<Scalars['Int']>;
  minimumLot?: InputMaybe<Scalars['Int']>;
  outerCartonDept?: InputMaybe<Scalars['Decimal']>;
  outerCartonHeight?: InputMaybe<Scalars['Decimal']>;
  outerCartonUnit?: InputMaybe<Scalars['Int']>;
  outerCartonWeight?: InputMaybe<Scalars['String']>;
  outerCartonWidth?: InputMaybe<Scalars['Decimal']>;
  productAttrMemo?: InputMaybe<Scalars['String']>;
  productBodySize?: InputMaybe<Scalars['String']>;
  productBodyWeight?: InputMaybe<Scalars['String']>;
  productImage1?: InputMaybe<Scalars['String']>;
  productImage2?: InputMaybe<Scalars['String']>;
  productImage3?: InputMaybe<Scalars['String']>;
  productImage4?: InputMaybe<Scalars['String']>;
  productImage5?: InputMaybe<Scalars['String']>;
  productImage6?: InputMaybe<Scalars['String']>;
  productPackageSize?: InputMaybe<Scalars['String']>;
  productPackageWeight?: InputMaybe<Scalars['String']>;
  publicationOption?: InputMaybe<Scalars['String']>;
  purchaseOrderStandardStock?: InputMaybe<Scalars['Int']>;
};

export type CreateProductionDetailList = {
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering: Scalars['Int'];
  partsQuantity: Scalars['Decimal'];
  productPartsCode: Scalars['String'];
  quantity: Scalars['Decimal'];
};

export type CreateProductionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  finishedProductCode: Scalars['String'];
  finishedQuantity: Scalars['Decimal'];
  productionDetailList: Array<InputMaybe<CreateProductionDetailList>>;
  productionMemo?: InputMaybe<Scalars['String']>;
  productionOrderDate: Scalars['Date'];
  warehouseCode: Scalars['String'];
};

export type CreateProductionPayload = {
  __typename?: 'CreateProductionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  production?: Maybe<Production>;
};

export type CreateReceiveOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderPrice?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderUnit?: InputMaybe<Scalars['Float']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateReceiveOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDate: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  receiveDetails?: InputMaybe<Array<InputMaybe<CreateReceiveOrderDetail>>>;
  receiveOrderDate: Scalars['String'];
  receiveOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderRemarks?: InputMaybe<Scalars['String']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: InputMaybe<Scalars['String']>;
  salesDate?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesUserCode: Scalars['String'];
};

export type CreateReceiveOrderPayload = {
  __typename?: 'CreateReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type CreateReturnReceiveOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderPrice?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderUnit?: InputMaybe<Scalars['Float']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateReturnReceiveOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDate: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  receiveDetails?: InputMaybe<Array<InputMaybe<CreateReturnReceiveOrderDetail>>>;
  receiveOrderDate: Scalars['String'];
  receiveOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderRemarks?: InputMaybe<Scalars['String']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: InputMaybe<Scalars['String']>;
  salesDate?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesUserCode: Scalars['String'];
};

export type CreateReturnReceiveOrderPayload = {
  __typename?: 'CreateReturnReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type CreateReturnSendOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  orderQuantity?: InputMaybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateReturnSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  orderDate: Scalars['String'];
  orderMemo?: InputMaybe<Scalars['String']>;
  orderRemarks?: InputMaybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: InputMaybe<Scalars['String']>;
  sendOrderDetails?: InputMaybe<Array<InputMaybe<CreateReturnSendOrderDetail>>>;
  shippingCode: Scalars['String'];
  shippingTypeCode: Scalars['String'];
  vendorCode: Scalars['String'];
};

export type CreateReturnSendOrderPayload = {
  __typename?: 'CreateReturnSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type CreateSendOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  orderQuantity?: InputMaybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  orderDate: Scalars['String'];
  orderMemo?: InputMaybe<Scalars['String']>;
  orderRemarks?: InputMaybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: InputMaybe<Scalars['String']>;
  sendOrderDetails?: InputMaybe<Array<InputMaybe<CreateSendOrderDetail>>>;
  shippingCode: Scalars['String'];
  shippingTypeCode: Scalars['String'];
  vendorCode: Scalars['String'];
};

export type CreateSendOrderLotInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotGroupName: Scalars['String'];
  minimumLot: Scalars['String'];
  purchaseOrderLeadTime?: InputMaybe<Scalars['String']>;
};

export type CreateSendOrderLotPayload = {
  __typename?: 'CreateSendOrderLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
};

export type CreateSendOrderPayload = {
  __typename?: 'CreateSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type CreateShipmentDetail = {
  deliveryDetailTradeType: Scalars['String'];
  deliveryOrderQuantity?: InputMaybe<Scalars['Float']>;
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveOrderDetailNumbering?: InputMaybe<Scalars['Int']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type CreateShipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingTiming?: InputMaybe<Scalars['String']>;
  collectExpectedDate?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  deliveryOrderDate: Scalars['String'];
  deliveryOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  salesRemark?: InputMaybe<Scalars['String']>;
  shipmentDetails?: InputMaybe<Array<InputMaybe<CreateShipmentDetail>>>;
  userCode?: InputMaybe<Scalars['String']>;
};

export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  shipment?: Maybe<Shipment>;
};

export type CreateStockAdjustInput = {
  adjustDate: Scalars['Date'];
  adjustDetailList?: InputMaybe<Array<InputMaybe<CreateAdjudstDetailList>>>;
  adjustMemo?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseCode: Scalars['String'];
};

export type CreateStockAdjustPayload = {
  __typename?: 'CreateStockAdjustPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  stockAdjust?: Maybe<StockAdjust>;
};

export type CreateTrustInventoryDetail = {
  damageQuantity: Scalars['Float'];
  detailMemo?: InputMaybe<Scalars['String']>;
  physicalInventory: Scalars['Float'];
  productCode: Scalars['String'];
  sellingUnitPrice: Scalars['Float'];
};

export type CreateTrustInventoryDetailJanUnit = {
  damageQuantity: Scalars['Float'];
  detailMemo?: InputMaybe<Scalars['String']>;
  physicalInventory: Scalars['Float'];
  sellingUnitPrice: Scalars['Float'];
  uniqueCode: Scalars['String'];
};

export type CreateTrustInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryTo: Scalars['Date'];
  salesDate: Scalars['Date'];
  salesMonth: Scalars['String'];
  trustInventoryDetail?: InputMaybe<Array<InputMaybe<CreateTrustInventoryDetail>>>;
  trustInventoryRemark?: InputMaybe<Scalars['String']>;
};

export type CreateTrustInventoryJanUnitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryTo: Scalars['Date'];
  salesDate: Scalars['Date'];
  salesMonth: Scalars['String'];
  trustInventoryDetail?: InputMaybe<Array<InputMaybe<CreateTrustInventoryDetailJanUnit>>>;
  trustInventoryRemark?: InputMaybe<Scalars['String']>;
};

export type CreateTrustInventoryJanUnitPayload = {
  __typename?: 'CreateTrustInventoryJanUnitPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type CreateTrustInventoryPayload = {
  __typename?: 'CreateTrustInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type CreateUserInput = {
  approvalPrivilege?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  priorityWarehouseCode?: InputMaybe<Scalars['String']>;
  subDivision1?: InputMaybe<Scalars['String']>;
  subDivision2?: InputMaybe<Scalars['String']>;
  subDivision3?: InputMaybe<Scalars['String']>;
  subDivision4?: InputMaybe<Scalars['String']>;
  superUser?: InputMaybe<Scalars['String']>;
  systemAdminFlg?: InputMaybe<Scalars['String']>;
  trustInventoryApprovalPrivilege?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
  userName: Scalars['String'];
  userType: Scalars['String'];
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CreateVendorInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  bankAccountCode?: InputMaybe<Scalars['String']>;
  bankAccountFuri?: InputMaybe<Scalars['String']>;
  bankAccountName?: InputMaybe<Scalars['String']>;
  bankAccountRelation?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  bankFuri?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  billSendDivision?: InputMaybe<Scalars['String']>;
  branchOfficeCode?: InputMaybe<Scalars['String']>;
  branchOfficeFuri?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerUser?: InputMaybe<Scalars['String']>;
  ediInfo?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  factoryCode?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  invoiceDivision?: InputMaybe<Scalars['String']>;
  invoiceRegistrationCode?: InputMaybe<Scalars['String']>;
  paymentCycle?: InputMaybe<Scalars['String']>;
  paymentDate?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  priceRoundType: Scalars['String'];
  productGroup?: InputMaybe<Scalars['String']>;
  purposeGroup: Scalars['String'];
  reportOutputUnit: Scalars['String'];
  taxRoundType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeStopFlg?: InputMaybe<Scalars['String']>;
  transferCondition?: InputMaybe<Scalars['String']>;
  transferCustomCode1?: InputMaybe<Scalars['String']>;
  transferCustomCode2?: InputMaybe<Scalars['String']>;
  transferMethodCode?: InputMaybe<Scalars['String']>;
  transferShareCost?: InputMaybe<Scalars['String']>;
  vendorClosingGroup?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorFuri: Scalars['String'];
  vendorMemo?: InputMaybe<Scalars['String']>;
  vendorName: Scalars['String'];
  vendorTaxType: Scalars['String'];
  vendorTradeDivision: Scalars['String'];
  vendorUnitpriceType?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateVendorPayload = {
  __typename?: 'CreateVendorPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
};

export type CreateWarehouseInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  isCountTarget?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  warehouseMemo?: InputMaybe<Scalars['String']>;
  warehouseName: Scalars['String'];
  warehouseType: Scalars['String'];
  warehouseUser?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateWarehouseMoveDetailList = {
  detailMemo?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  moveQuantity: Scalars['Decimal'];
  numbering: Scalars['Int'];
  productCode: Scalars['String'];
  transferProductCode?: InputMaybe<Scalars['String']>;
};

export type CreateWarehouseMoveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  moveDate: Scalars['Date'];
  moveWarehouseDestination: Scalars['String'];
  moveWarehouseSource: Scalars['String'];
  warehouseMoveDetailList: Array<InputMaybe<CreateWarehouseMoveDetailList>>;
  warehouseMoveMemo?: InputMaybe<Scalars['String']>;
  warehouseMoveMethod: Scalars['String'];
};

export type CreateWarehouseMovePayload = {
  __typename?: 'CreateWarehouseMovePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouseMove?: Maybe<WarehouseMove>;
};

export type CreateWarehousePayload = {
  __typename?: 'CreateWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouse?: Maybe<Warehouse>;
};

export type CreateWithdrawalDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering: Scalars['Int'];
  payDivisionCode: Scalars['String'];
  payDivisionDetail?: InputMaybe<Scalars['String']>;
  payPrice: Scalars['Decimal'];
};

export type CreateWithdrawalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  payDate: Scalars['Date'];
  payRemark?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  withdrawalDetails?: InputMaybe<Array<InputMaybe<CreateWithdrawalDetail>>>;
};

export type CreateWithdrawalPayload = {
  __typename?: 'CreateWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  withdrawal?: Maybe<Withdrawal>;
};

export type Customer = Node & {
  __typename?: 'Customer';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressLabelFlg: Scalars['String'];
  balanceData?: Maybe<Scalars['Float']>;
  billSendDivision?: Maybe<Scalars['String']>;
  billSite?: Maybe<Scalars['Int']>;
  businessAmebaFlg: Scalars['String'];
  closingDate?: Maybe<Scalars['Date']>;
  collectCycleCode?: Maybe<Scalars['String']>;
  collectDate?: Maybe<Scalars['Int']>;
  collectDays?: Maybe<Scalars['Int']>;
  collectMethodCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  creditLimitPrice?: Maybe<Scalars['Float']>;
  customerArea?: Maybe<Scalars['String']>;
  customerBudget?: Maybe<CustomerBudgetConnection>;
  customerCode: Scalars['String'];
  customerFuri: Scalars['String'];
  customerGroup?: Maybe<Scalars['String']>;
  customerMemo?: Maybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPositionName?: Maybe<Scalars['String']>;
  customerPostName?: Maybe<Scalars['String']>;
  customerRank?: Maybe<Scalars['String']>;
  customerUnitpriceType?: Maybe<Scalars['String']>;
  customerUser?: Maybe<Scalars['String']>;
  customerUserBelong?: Maybe<CustomerUserBelong>;
  delFlg: Scalars['String'];
  demand?: Maybe<Customer>;
  demandClosingGroupCode?: Maybe<Scalars['String']>;
  demandCode?: Maybe<Scalars['String']>;
  demandReport?: Maybe<ReportLayout>;
  depositDivision?: Maybe<DepositDivision>;
  designAmebaFlg: Scalars['String'];
  division?: Maybe<Division>;
  divisionBundle?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  honorificCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryControlUnit: Scalars['String'];
  latestDemandId?: Maybe<Scalars['Int']>;
  outsourcerCode?: Maybe<Scalars['String']>;
  prescribeDemandReport?: Maybe<Scalars['String']>;
  prescribeSalesReport?: Maybe<Scalars['String']>;
  priceRoundType?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  reportOutputUnit: Scalars['String'];
  sales?: Maybe<SalesConnection>;
  salesReport?: Maybe<ReportLayout>;
  salesTaxType?: Maybe<Scalars['String']>;
  salesTradeDivision?: Maybe<Scalars['String']>;
  salesUserEmail1?: Maybe<Scalars['String']>;
  salesUserEmail2?: Maybe<Scalars['String']>;
  salesUserEmail3?: Maybe<Scalars['String']>;
  salesUserName1?: Maybe<Scalars['String']>;
  salesUserName2?: Maybe<Scalars['String']>;
  salesUserName3?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  taxRoundType?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  tradeStopFlg: Scalars['String'];
  transferShareCost?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  user?: Maybe<User>;
  userCode?: Maybe<Scalars['String']>;
  userDivisionCode: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouse?: Maybe<Warehouse>;
  zipCode?: Maybe<Scalars['String']>;
};


export type CustomerCustomerBudgetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CustomerSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CustomerBudget = Node & {
  __typename?: 'CustomerBudget';
  budgetDate: Scalars['String'];
  budgetPrice: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  financialMonth: Scalars['Int'];
  financialStage: Scalars['Int'];
  financialYear: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type CustomerBudgetConnection = {
  __typename?: 'CustomerBudgetConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerBudgetEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomerBudget` and its cursor. */
export type CustomerBudgetEdge = {
  __typename?: 'CustomerBudgetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerBudget>;
};

export type CustomerBudgetsCustom = Node & {
  __typename?: 'CustomerBudgetsCustom';
  apr?: Maybe<Scalars['Float']>;
  aug?: Maybe<Scalars['Float']>;
  customerArea?: Maybe<Scalars['String']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  dec?: Maybe<Scalars['Float']>;
  feb?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  jan?: Maybe<Scalars['Float']>;
  jul?: Maybe<Scalars['Float']>;
  jun?: Maybe<Scalars['Float']>;
  mar?: Maybe<Scalars['Float']>;
  may?: Maybe<Scalars['Float']>;
  nov?: Maybe<Scalars['Float']>;
  oct?: Maybe<Scalars['Float']>;
  rowType?: Maybe<Scalars['String']>;
  sep?: Maybe<Scalars['Float']>;
  userCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  versionUuid?: Maybe<CustomerBudgetsVersionUuid>;
};

export type CustomerBudgetsCustomConnection = {
  __typename?: 'CustomerBudgetsCustomConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerBudgetsCustomEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomerBudgetsCustom` and its cursor. */
export type CustomerBudgetsCustomEdge = {
  __typename?: 'CustomerBudgetsCustomEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerBudgetsCustom>;
};

export type CustomerBudgetsCustomFilter = {
  customerArea?: InputMaybe<Scalars['String']>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sampleStage: Scalars['Int'];
  settingStage: Scalars['Int'];
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CustomerBudgetsVersionUuid = {
  __typename?: 'CustomerBudgetsVersionUuid';
  apr?: Maybe<Scalars['String']>;
  aug?: Maybe<Scalars['String']>;
  dec?: Maybe<Scalars['String']>;
  feb?: Maybe<Scalars['String']>;
  jan?: Maybe<Scalars['String']>;
  jul?: Maybe<Scalars['String']>;
  jun?: Maybe<Scalars['String']>;
  mar?: Maybe<Scalars['String']>;
  may?: Maybe<Scalars['String']>;
  nov?: Maybe<Scalars['String']>;
  oct?: Maybe<Scalars['String']>;
  sep?: Maybe<Scalars['String']>;
};

export type CustomerClosing = Node & {
  __typename?: 'CustomerClosing';
  closingDate: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type CustomerClosingConnection = {
  __typename?: 'CustomerClosingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerClosingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomerClosing` and its cursor. */
export type CustomerClosingEdge = {
  __typename?: 'CustomerClosingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerClosing>;
};

/** An enumeration. */
export enum CustomerClosingSortEnum {
  ClosingDateAsc = 'CLOSING_DATE_ASC',
  ClosingDateDesc = 'CLOSING_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Customer` and its cursor. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Customer>;
};

export type CustomerPrice = Node & {
  __typename?: 'CustomerPrice';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  endDate: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  product?: Maybe<Product>;
  productPrice?: Maybe<ProductPrice>;
  sellingUnitPrice: Scalars['Float'];
  startDate: Scalars['String'];
  uniqueCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type CustomerPriceConnection = {
  __typename?: 'CustomerPriceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerPriceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomerPrice` and its cursor. */
export type CustomerPriceEdge = {
  __typename?: 'CustomerPriceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerPrice>;
};

export type CustomerPriceListResult = {
  __typename?: 'CustomerPriceListResult';
  list?: Maybe<Array<Maybe<CustomerPriceNode>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CustomerPriceNode = {
  __typename?: 'CustomerPriceNode';
  activeStatus?: Maybe<Scalars['String']>;
  currentDate?: Maybe<Scalars['String']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerUnitpriceType?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  janCode?: Maybe<Scalars['String']>;
  priceRoundType?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  retailPriceExcl?: Maybe<Scalars['Float']>;
  retailPriceIncl?: Maybe<Scalars['Float']>;
  salesTaxType?: Maybe<Scalars['String']>;
  sellingPriceExcl?: Maybe<Scalars['Float']>;
  sellingPriceIncl?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  sellingUnitPriceIncl?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitYenDecimalDigits?: Maybe<Scalars['Float']>;
  versionUuid?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CustomerPriceSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  SellingUnitPriceAsc = 'SELLING_UNIT_PRICE_ASC',
  SellingUnitPriceDesc = 'SELLING_UNIT_PRICE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type CustomerProductGroupPublicationFilter = {
  customerCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  productGroupId?: InputMaybe<Scalars['String']>;
  userDivisionCode?: InputMaybe<Scalars['String']>;
};

export type CustomerProductGroupPublicationInput = {
  customerCode: Scalars['String'];
  productGroupId: Scalars['String'];
  updateType: UpdateType;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type CustomerProductGroupPublicationNode = {
  __typename?: 'CustomerProductGroupPublicationNode';
  customerCode: Scalars['String'];
  customerName?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  productGroupCode: Scalars['String'];
  productGroupId: Scalars['String'];
  productGroupName?: Maybe<Scalars['String']>;
  productGrouptypeCode?: Maybe<Scalars['String']>;
  userDivisionName?: Maybe<Scalars['String']>;
  visibilityStatus?: Maybe<Scalars['String']>;
};

export type CustomerProductGroupPublicationWithImportInput = {
  customerCode: Scalars['String'];
  productGroupId: Scalars['String'];
  updateType: UpdateType;
};

export type CustomerProductGroupPublicationWithImportResultData = {
  __typename?: 'CustomerProductGroupPublicationWithImportResultData';
  importFlg?: Maybe<Scalars['Boolean']>;
};

export type CustomerProductPublicationFilter = {
  customerCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  userDivisionCode?: InputMaybe<Scalars['String']>;
};

export type CustomerProductPublicationInput = {
  customerCode: Scalars['String'];
  productCode: Scalars['String'];
  updateType: UpdateType;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type CustomerProductPublicationNode = {
  __typename?: 'CustomerProductPublicationNode';
  customerCode: Scalars['String'];
  customerName?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  janCode?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
  userDivisionName?: Maybe<Scalars['String']>;
  visibilityStatus?: Maybe<Scalars['String']>;
};

export type CustomerProductPublicationWithImportInput = {
  customerCode: Scalars['String'];
  productCode: Scalars['String'];
  updateType: UpdateType;
};

export type CustomerProductPublicationWithImportResultData = {
  __typename?: 'CustomerProductPublicationWithImportResultData';
  importFlg?: Maybe<Scalars['Boolean']>;
};

export type CustomerSalesMonthly = Node & {
  __typename?: 'CustomerSalesMonthly';
  demandCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  totalingDepositPrice?: Maybe<Scalars['Int']>;
  totalingMonthly?: Maybe<Scalars['String']>;
  totalingPeriod?: Maybe<Scalars['String']>;
  totalingSellingPrice?: Maybe<Scalars['Int']>;
};

export type CustomerSalesMonthlyConnection = {
  __typename?: 'CustomerSalesMonthlyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerSalesMonthlyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomerSalesMonthly` and its cursor. */
export type CustomerSalesMonthlyEdge = {
  __typename?: 'CustomerSalesMonthlyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerSalesMonthly>;
};

/** An enumeration. */
export enum CustomerSortEnum {
  Address1Asc = 'ADDRESS1_ASC',
  Address1Desc = 'ADDRESS1_DESC',
  Address2Asc = 'ADDRESS2_ASC',
  Address2Desc = 'ADDRESS2_DESC',
  AddressLabelFlgAsc = 'ADDRESS_LABEL_FLG_ASC',
  AddressLabelFlgDesc = 'ADDRESS_LABEL_FLG_DESC',
  BillSendDivisionAsc = 'BILL_SEND_DIVISION_ASC',
  BillSendDivisionDesc = 'BILL_SEND_DIVISION_DESC',
  BillSiteAsc = 'BILL_SITE_ASC',
  BillSiteDesc = 'BILL_SITE_DESC',
  BusinessAmebaFlgAsc = 'BUSINESS_AMEBA_FLG_ASC',
  BusinessAmebaFlgDesc = 'BUSINESS_AMEBA_FLG_DESC',
  CollectCycleCodeAsc = 'COLLECT_CYCLE_CODE_ASC',
  CollectCycleCodeDesc = 'COLLECT_CYCLE_CODE_DESC',
  CollectDateAsc = 'COLLECT_DATE_ASC',
  CollectDateDesc = 'COLLECT_DATE_DESC',
  CollectDaysAsc = 'COLLECT_DAYS_ASC',
  CollectDaysDesc = 'COLLECT_DAYS_DESC',
  CollectMethodCodeAsc = 'COLLECT_METHOD_CODE_ASC',
  CollectMethodCodeDesc = 'COLLECT_METHOD_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CreditLimitPriceAsc = 'CREDIT_LIMIT_PRICE_ASC',
  CreditLimitPriceDesc = 'CREDIT_LIMIT_PRICE_DESC',
  CustomerAreaAsc = 'CUSTOMER_AREA_ASC',
  CustomerAreaDesc = 'CUSTOMER_AREA_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerFuriAsc = 'CUSTOMER_FURI_ASC',
  CustomerFuriDesc = 'CUSTOMER_FURI_DESC',
  CustomerGroupAsc = 'CUSTOMER_GROUP_ASC',
  CustomerGroupDesc = 'CUSTOMER_GROUP_DESC',
  CustomerMemoAsc = 'CUSTOMER_MEMO_ASC',
  CustomerMemoDesc = 'CUSTOMER_MEMO_DESC',
  CustomerNameAsc = 'CUSTOMER_NAME_ASC',
  CustomerNameDesc = 'CUSTOMER_NAME_DESC',
  CustomerPositionNameAsc = 'CUSTOMER_POSITION_NAME_ASC',
  CustomerPositionNameDesc = 'CUSTOMER_POSITION_NAME_DESC',
  CustomerPostNameAsc = 'CUSTOMER_POST_NAME_ASC',
  CustomerPostNameDesc = 'CUSTOMER_POST_NAME_DESC',
  CustomerRankAsc = 'CUSTOMER_RANK_ASC',
  CustomerRankDesc = 'CUSTOMER_RANK_DESC',
  CustomerUnitpriceTypeAsc = 'CUSTOMER_UNITPRICE_TYPE_ASC',
  CustomerUnitpriceTypeDesc = 'CUSTOMER_UNITPRICE_TYPE_DESC',
  CustomerUserAsc = 'CUSTOMER_USER_ASC',
  CustomerUserDesc = 'CUSTOMER_USER_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DemandClosingGroupCodeAsc = 'DEMAND_CLOSING_GROUP_CODE_ASC',
  DemandClosingGroupCodeDesc = 'DEMAND_CLOSING_GROUP_CODE_DESC',
  DemandCodeAsc = 'DEMAND_CODE_ASC',
  DemandCodeDesc = 'DEMAND_CODE_DESC',
  DesignAmebaFlgAsc = 'DESIGN_AMEBA_FLG_ASC',
  DesignAmebaFlgDesc = 'DESIGN_AMEBA_FLG_DESC',
  DivisionBundleAsc = 'DIVISION_BUNDLE_ASC',
  DivisionBundleDesc = 'DIVISION_BUNDLE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  HonorificCodeAsc = 'HONORIFIC_CODE_ASC',
  HonorificCodeDesc = 'HONORIFIC_CODE_DESC',
  InventoryControlUnitAsc = 'INVENTORY_CONTROL_UNIT_ASC',
  InventoryControlUnitDesc = 'INVENTORY_CONTROL_UNIT_DESC',
  OutsourcerCodeAsc = 'OUTSOURCER_CODE_ASC',
  OutsourcerCodeDesc = 'OUTSOURCER_CODE_DESC',
  PrescribeDemandReportAsc = 'PRESCRIBE_DEMAND_REPORT_ASC',
  PrescribeDemandReportDesc = 'PRESCRIBE_DEMAND_REPORT_DESC',
  PrescribeSalesReportAsc = 'PRESCRIBE_SALES_REPORT_ASC',
  PrescribeSalesReportDesc = 'PRESCRIBE_SALES_REPORT_DESC',
  PriceRoundTypeAsc = 'PRICE_ROUND_TYPE_ASC',
  PriceRoundTypeDesc = 'PRICE_ROUND_TYPE_DESC',
  RatioAsc = 'RATIO_ASC',
  RatioDesc = 'RATIO_DESC',
  ReportOutputUnitAsc = 'REPORT_OUTPUT_UNIT_ASC',
  ReportOutputUnitDesc = 'REPORT_OUTPUT_UNIT_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  SalesUserEmail1Asc = 'SALES_USER_EMAIL1_ASC',
  SalesUserEmail1Desc = 'SALES_USER_EMAIL1_DESC',
  SalesUserEmail2Asc = 'SALES_USER_EMAIL2_ASC',
  SalesUserEmail2Desc = 'SALES_USER_EMAIL2_DESC',
  SalesUserEmail3Asc = 'SALES_USER_EMAIL3_ASC',
  SalesUserEmail3Desc = 'SALES_USER_EMAIL3_DESC',
  SalesUserName1Asc = 'SALES_USER_NAME1_ASC',
  SalesUserName1Desc = 'SALES_USER_NAME1_DESC',
  SalesUserName2Asc = 'SALES_USER_NAME2_ASC',
  SalesUserName2Desc = 'SALES_USER_NAME2_DESC',
  SalesUserName3Asc = 'SALES_USER_NAME3_ASC',
  SalesUserName3Desc = 'SALES_USER_NAME3_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxRoundTypeAsc = 'TAX_ROUND_TYPE_ASC',
  TaxRoundTypeDesc = 'TAX_ROUND_TYPE_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  TradeStopFlgAsc = 'TRADE_STOP_FLG_ASC',
  TradeStopFlgDesc = 'TRADE_STOP_FLG_DESC',
  TransferShareCostAsc = 'TRANSFER_SHARE_COST_ASC',
  TransferShareCostDesc = 'TRANSFER_SHARE_COST_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  UserDivisionCodeAsc = 'USER_DIVISION_CODE_ASC',
  UserDivisionCodeDesc = 'USER_DIVISION_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export type CustomerUser = Node & {
  __typename?: 'CustomerUser';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerUserBelong?: Maybe<CustomerUserBelongConnection>;
  customerUserId: Scalars['ID'];
  customerUserName: Scalars['String'];
  delFlg: Scalars['String'];
  email: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  initialConfirmationDate?: Maybe<Scalars['DateTime']>;
  tel?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  termsOfUseVersion?: Maybe<Scalars['Int']>;
  updateConfirmationDate?: Maybe<Scalars['DateTime']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type CustomerUserCustomerUserBelongArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CustomerUserBelong = Node & {
  __typename?: 'CustomerUserBelong';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  customerGroup: Scalars['String'];
  customerUser?: Maybe<CustomerUser>;
  customerUserBelongId: Scalars['ID'];
  customerUserId: Scalars['Int'];
  deliver?: Maybe<Deliver>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type CustomerUserBelongConnection = {
  __typename?: 'CustomerUserBelongConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerUserBelongEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomerUserBelong` and its cursor. */
export type CustomerUserBelongEdge = {
  __typename?: 'CustomerUserBelongEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerUserBelong>;
};

export type CustomerUserConnection = {
  __typename?: 'CustomerUserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerUserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CustomerUser` and its cursor. */
export type CustomerUserEdge = {
  __typename?: 'CustomerUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerUser>;
};

/** An enumeration. */
export enum CustomerUserSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerUserIdAsc = 'CUSTOMER_USER_ID_ASC',
  CustomerUserIdDesc = 'CUSTOMER_USER_ID_DESC',
  CustomerUserNameAsc = 'CUSTOMER_USER_NAME_ASC',
  CustomerUserNameDesc = 'CUSTOMER_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  InitialConfirmationDateAsc = 'INITIAL_CONFIRMATION_DATE_ASC',
  InitialConfirmationDateDesc = 'INITIAL_CONFIRMATION_DATE_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  TermsOfUseVersionAsc = 'TERMS_OF_USE_VERSION_ASC',
  TermsOfUseVersionDesc = 'TERMS_OF_USE_VERSION_DESC',
  UpdateConfirmationDateAsc = 'UPDATE_CONFIRMATION_DATE_ASC',
  UpdateConfirmationDateDesc = 'UPDATE_CONFIRMATION_DATE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type CustomerWithCarryOver = Node & {
  __typename?: 'CustomerWithCarryOver';
  /** The ID of the object. */
  id: Scalars['ID'];
  salesTaxType?: Maybe<Scalars['String']>;
  targetCarryOver?: Maybe<Scalars['Float']>;
};

export type CustomerWithCarryOverConnection = {
  __typename?: 'CustomerWithCarryOverConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CustomerWithCarryOverEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomerWithCarryOver` and its cursor. */
export type CustomerWithCarryOverEdge = {
  __typename?: 'CustomerWithCarryOverEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerWithCarryOver>;
};

export type DeleteArrivalInput = {
  arrivalId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type DeleteArrivalPayload = {
  __typename?: 'DeleteArrivalPayload';
  arrival?: Maybe<Arrival>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type DeleteAutomaticWithdrawal = {
  automaticPayId: Scalars['Int'];
  paymentId: Scalars['Int'];
  paymentTaxAdjustDetails?: InputMaybe<Array<InputMaybe<DeletePaymentTaxAdjustDetailEx>>>;
  paymentVersionUuid: Scalars['String'];
  withdrawalVersionUuid?: InputMaybe<Scalars['String']>;
};

export type DeleteAutomaticWithdrawalsInput = {
  automaticWithdrawals: Array<InputMaybe<DeleteAutomaticWithdrawal>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteAutomaticWithdrawalsPayload = {
  __typename?: 'DeleteAutomaticWithdrawalsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
};

export type DeleteComponentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  finishedProductCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteComponentPayload = {
  __typename?: 'DeleteComponentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  component?: Maybe<Component>;
};

export type DeleteCustomerInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteCustomerPayload = {
  __typename?: 'DeleteCustomerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

export type DeleteCustomerUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerUserId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type DeleteCustomerUserPayload = {
  __typename?: 'DeleteCustomerUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerUser?: Maybe<CustomerUser>;
};

export type DeleteDeliverInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDestinationCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteDeliverPayload = {
  __typename?: 'DeleteDeliverPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deliver?: Maybe<Deliver>;
};

export type DeleteDemandDetailList = {
  demandId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteDemandListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demands?: InputMaybe<Array<InputMaybe<DeleteDemandDetailList>>>;
};

export type DeleteDemandListPayload = {
  __typename?: 'DeleteDemandListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type DeleteDemandTaxAdjust = {
  demandId: Scalars['Int'];
  demandTaxAdjustDetails?: InputMaybe<Array<InputMaybe<DeleteDemandTaxAdjustDetail>>>;
  versionUuid: Scalars['String'];
};

export type DeleteDemandTaxAdjustDetail = {
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type DeleteDemandTaxAdjustListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demandTaxAdjustList?: InputMaybe<Array<InputMaybe<DeleteDemandTaxAdjust>>>;
};

export type DeleteDemandTaxAdjustListPayload = {
  __typename?: 'DeleteDemandTaxAdjustListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  demandTaxAdjustDetail?: Maybe<DemandTaxAdjustDetail>;
};

export type DeleteDepositInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  depositId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type DeleteDepositPayload = {
  __typename?: 'DeleteDepositPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deposit?: Maybe<Deposit>;
};

export type DeleteDirectPurchaseDetail = {
  delFlg: Scalars['Boolean'];
  purchaseId: Scalars['String'];
};

export type DeleteDirectPurchaseInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  purchaseDetails?: InputMaybe<Array<InputMaybe<DeleteDirectPurchaseDetail>>>;
};

export type DeleteDirectPurchasePayload = {
  __typename?: 'DeleteDirectPurchasePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  purchase?: Maybe<Purchase>;
};

export type DeleteDirectWipDetail = {
  delFlg: Scalars['Boolean'];
  purchaseId: Scalars['String'];
};

export type DeleteDirectWipInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  purchaseDetails?: InputMaybe<Array<InputMaybe<DeleteDirectWipDetail>>>;
};

export type DeleteDirectWipPayload = {
  __typename?: 'DeleteDirectWipPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  purchase?: Maybe<Purchase>;
};

export type DeleteDivisionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteDivisionPayload = {
  __typename?: 'DeleteDivisionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
};

export type DeleteEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  estimateId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteEstimatePayload = {
  __typename?: 'DeleteEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimate?: Maybe<Estimate>;
};

export type DeleteFkorderInformationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  informationId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type DeleteFkorderInformationPayload = {
  __typename?: 'DeleteFkorderInformationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fkorderInformation?: Maybe<FkorderInformation>;
};

export type DeleteInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inventoryId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type DeleteInventoryPayload = {
  __typename?: 'DeleteInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inventory?: Maybe<Inventory>;
};

export type DeleteOutsourcerSalesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  salesId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteOutsourcerSalesPayload = {
  __typename?: 'DeleteOutsourcerSalesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sales?: Maybe<Sales>;
};

export type DeletePaymentDetail = {
  paymentId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeletePaymentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Array<InputMaybe<DeletePaymentDetail>>>;
};

export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
};

export type DeletePaymentTaxAdjust = {
  paymentId: Scalars['Int'];
  paymentTaxAdjustDetails?: InputMaybe<Array<InputMaybe<DeletePaymentTaxAdjustDetail>>>;
  versionUuid: Scalars['String'];
};

export type DeletePaymentTaxAdjustDetail = {
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type DeletePaymentTaxAdjustDetailEx = {
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type DeletePaymentTaxAdjustListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentTaxAdjustList?: InputMaybe<Array<InputMaybe<DeletePaymentTaxAdjust>>>;
};

export type DeletePaymentTaxAdjustListPayload = {
  __typename?: 'DeletePaymentTaxAdjustListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  paymentTaxAdjustDetail?: Maybe<PaymentTaxAdjustDetail>;
};

export type DeleteProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

export type DeleteProductionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  productionOrderId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type DeleteProductionPayload = {
  __typename?: 'DeleteProductionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  production?: Maybe<Production>;
};

export type DeleteReceiveOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteReceiveOrderPayload = {
  __typename?: 'DeleteReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type DeleteReturnReceiveOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteReturnReceiveOrderPayload = {
  __typename?: 'DeleteReturnReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type DeleteReturnSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteReturnSendOrderPayload = {
  __typename?: 'DeleteReturnSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type DeleteSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteSendOrderLotInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotGroupCode: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type DeleteSendOrderLotPayload = {
  __typename?: 'DeleteSendOrderLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
};

export type DeleteSendOrderPayload = {
  __typename?: 'DeleteSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type DeleteShipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteShipmentPayload = {
  __typename?: 'DeleteShipmentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  shipment?: Maybe<Shipment>;
};

export type DeleteStockAdjustInput = {
  adjustId: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type DeleteStockAdjustPayload = {
  __typename?: 'DeleteStockAdjustPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  stockAdjust?: Maybe<StockAdjust>;
};

export type DeleteTrustInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  trustInventoryId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteTrustInventoryPayload = {
  __typename?: 'DeleteTrustInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type DeleteVendorInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteVendorPayload = {
  __typename?: 'DeleteVendorPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
};

export type DeleteWarehouseInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type DeleteWarehouseMoveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseMoveId: Scalars['Int'];
};

export type DeleteWarehouseMovePayload = {
  __typename?: 'DeleteWarehouseMovePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouseMove?: Maybe<WarehouseMove>;
};

export type DeleteWarehousePayload = {
  __typename?: 'DeleteWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouse?: Maybe<Warehouse>;
};

export type DeleteWithdrawalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  payId: Scalars['String'];
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DeleteWithdrawalPayload = {
  __typename?: 'DeleteWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  withdrawal?: Maybe<Withdrawal>;
};

export type Deliver = Node & {
  __typename?: 'Deliver';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserBelong?: Maybe<CustomerUserBelongConnection>;
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode?: Maybe<Scalars['String']>;
  customerPositionName?: Maybe<Scalars['String']>;
  customerPostName?: Maybe<Scalars['String']>;
  customerUser?: Maybe<Scalars['String']>;
  delFlg: Scalars['String'];
  deliveryDestinationCode: Scalars['String'];
  deliveryDestinationName: Scalars['String'];
  fax?: Maybe<Scalars['String']>;
  honorificCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  tel?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};


export type DeliverCreateUserBelongArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DeliverConnection = {
  __typename?: 'DeliverConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliverEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Deliver` and its cursor. */
export type DeliverEdge = {
  __typename?: 'DeliverEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Deliver>;
};

/** An enumeration. */
export enum DeliverSortEnum {
  Address1Asc = 'ADDRESS1_ASC',
  Address1Desc = 'ADDRESS1_DESC',
  Address2Asc = 'ADDRESS2_ASC',
  Address2Desc = 'ADDRESS2_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerPositionNameAsc = 'CUSTOMER_POSITION_NAME_ASC',
  CustomerPositionNameDesc = 'CUSTOMER_POSITION_NAME_DESC',
  CustomerPostNameAsc = 'CUSTOMER_POST_NAME_ASC',
  CustomerPostNameDesc = 'CUSTOMER_POST_NAME_DESC',
  CustomerUserAsc = 'CUSTOMER_USER_ASC',
  CustomerUserDesc = 'CUSTOMER_USER_DESC',
  DeliveryDestinationCodeAsc = 'DELIVERY_DESTINATION_CODE_ASC',
  DeliveryDestinationCodeDesc = 'DELIVERY_DESTINATION_CODE_DESC',
  DeliveryDestinationNameAsc = 'DELIVERY_DESTINATION_NAME_ASC',
  DeliveryDestinationNameDesc = 'DELIVERY_DESTINATION_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  HonorificCodeAsc = 'HONORIFIC_CODE_ASC',
  HonorificCodeDesc = 'HONORIFIC_CODE_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export type Demand = Node & {
  __typename?: 'Demand';
  beforeDemandRemain: Scalars['Float'];
  carryOverPrice: Scalars['Float'];
  clearingState?: Maybe<Scalars['String']>;
  closingDate: Scalars['String'];
  closingStatusCode: Scalars['String'];
  closingTriggerId?: Maybe<Scalars['Int']>;
  collectExpectedDate: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  currentDemandExpectRemain: Scalars['Float'];
  customer?: Maybe<Customer>;
  demandCode: Scalars['String'];
  demandDate: Scalars['String'];
  demandId: Scalars['ID'];
  demandTaxAdjustDetails?: Maybe<DemandTaxAdjustDetailConnection>;
  demandTaxDetails?: Maybe<DemandTaxDetailConnection>;
  demandTradeDivision?: Maybe<Scalars['String']>;
  depositPriceTotalInAccountMonth: Scalars['Float'];
  exciseTaxTotal: Scalars['Float'];
  excludingTaxTotalDemandPrice: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  includedTaxDemandClearingPrice?: Maybe<Scalars['Float']>;
  includedTaxTotalDemandPrice: Scalars['Float'];
  sales?: Maybe<Sales>;
  salesTaxType?: Maybe<Scalars['String']>;
  totalDemandDetails?: Maybe<TotalDemandDetailConnection>;
  totalDemandFlag?: Maybe<Scalars['String']>;
  totalDemandTaxDetails?: Maybe<TotalDemandTaxDetailConnection>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type DemandDemandTaxAdjustDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DemandDemandTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DemandTotalDemandDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DemandTotalDemandTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DemandConnection = {
  __typename?: 'DemandConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DemandEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Demand` and its cursor. */
export type DemandEdge = {
  __typename?: 'DemandEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Demand>;
};

export type DemandPrintInput = {
  carryOverPriceFlg?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  demandId: Scalars['Int'];
  detailStatus?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type DemandPrintPayload = {
  __typename?: 'DemandPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DemandSortEnum {
  BeforeDemandRemainAsc = 'BEFORE_DEMAND_REMAIN_ASC',
  BeforeDemandRemainDesc = 'BEFORE_DEMAND_REMAIN_DESC',
  CarryOverPriceAsc = 'CARRY_OVER_PRICE_ASC',
  CarryOverPriceDesc = 'CARRY_OVER_PRICE_DESC',
  ClearingStateAsc = 'CLEARING_STATE_ASC',
  ClearingStateDesc = 'CLEARING_STATE_DESC',
  ClosingDateAsc = 'CLOSING_DATE_ASC',
  ClosingDateDesc = 'CLOSING_DATE_DESC',
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  ClosingTriggerIdAsc = 'CLOSING_TRIGGER_ID_ASC',
  ClosingTriggerIdDesc = 'CLOSING_TRIGGER_ID_DESC',
  CollectExpectedDateAsc = 'COLLECT_EXPECTED_DATE_ASC',
  CollectExpectedDateDesc = 'COLLECT_EXPECTED_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CurrentDemandExpectRemainAsc = 'CURRENT_DEMAND_EXPECT_REMAIN_ASC',
  CurrentDemandExpectRemainDesc = 'CURRENT_DEMAND_EXPECT_REMAIN_DESC',
  DemandCodeAsc = 'DEMAND_CODE_ASC',
  DemandCodeDesc = 'DEMAND_CODE_DESC',
  DemandDateAsc = 'DEMAND_DATE_ASC',
  DemandDateDesc = 'DEMAND_DATE_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  DemandTradeDivisionAsc = 'DEMAND_TRADE_DIVISION_ASC',
  DemandTradeDivisionDesc = 'DEMAND_TRADE_DIVISION_DESC',
  DepositPriceTotalInAccountMonthAsc = 'DEPOSIT_PRICE_TOTAL_IN_ACCOUNT_MONTH_ASC',
  DepositPriceTotalInAccountMonthDesc = 'DEPOSIT_PRICE_TOTAL_IN_ACCOUNT_MONTH_DESC',
  ExciseTaxTotalAsc = 'EXCISE_TAX_TOTAL_ASC',
  ExciseTaxTotalDesc = 'EXCISE_TAX_TOTAL_DESC',
  ExcludingTaxTotalDemandPriceAsc = 'EXCLUDING_TAX_TOTAL_DEMAND_PRICE_ASC',
  ExcludingTaxTotalDemandPriceDesc = 'EXCLUDING_TAX_TOTAL_DEMAND_PRICE_DESC',
  IncludedTaxDemandClearingPriceAsc = 'INCLUDED_TAX_DEMAND_CLEARING_PRICE_ASC',
  IncludedTaxDemandClearingPriceDesc = 'INCLUDED_TAX_DEMAND_CLEARING_PRICE_DESC',
  IncludedTaxTotalDemandPriceAsc = 'INCLUDED_TAX_TOTAL_DEMAND_PRICE_ASC',
  IncludedTaxTotalDemandPriceDesc = 'INCLUDED_TAX_TOTAL_DEMAND_PRICE_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  TotalDemandFlagAsc = 'TOTAL_DEMAND_FLAG_ASC',
  TotalDemandFlagDesc = 'TOTAL_DEMAND_FLAG_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DemandTaxAdjustDetail = Node & {
  __typename?: 'DemandTaxAdjustDetail';
  adjust?: Maybe<Scalars['Float']>;
  afterAdjustExciseTax?: Maybe<Scalars['Float']>;
  beforeAdjustExciseTax?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  demand?: Maybe<Demand>;
  demandId: Scalars['ID'];
  /** The ID of the object. */
  id: Scalars['ID'];
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DemandTaxAdjustDetailConnection = {
  __typename?: 'DemandTaxAdjustDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DemandTaxAdjustDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DemandTaxAdjustDetail` and its cursor. */
export type DemandTaxAdjustDetailEdge = {
  __typename?: 'DemandTaxAdjustDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DemandTaxAdjustDetail>;
};

/** An enumeration. */
export enum DemandTaxAdjustDetailSortEnum {
  AdjustAsc = 'ADJUST_ASC',
  AdjustDesc = 'ADJUST_DESC',
  AfterAdjustExciseTaxAsc = 'AFTER_ADJUST_EXCISE_TAX_ASC',
  AfterAdjustExciseTaxDesc = 'AFTER_ADJUST_EXCISE_TAX_DESC',
  BeforeAdjustExciseTaxAsc = 'BEFORE_ADJUST_EXCISE_TAX_ASC',
  BeforeAdjustExciseTaxDesc = 'BEFORE_ADJUST_EXCISE_TAX_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DemandTaxDetail = Node & {
  __typename?: 'DemandTaxDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  demand?: Maybe<Demand>;
  demandId: Scalars['ID'];
  exciseTax?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  taxExcluded?: Maybe<Scalars['Float']>;
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DemandTaxDetailConnection = {
  __typename?: 'DemandTaxDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DemandTaxDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DemandTaxDetail` and its cursor. */
export type DemandTaxDetailEdge = {
  __typename?: 'DemandTaxDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DemandTaxDetail>;
};

/** An enumeration. */
export enum DemandTaxDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  ExciseTaxAsc = 'EXCISE_TAX_ASC',
  ExciseTaxDesc = 'EXCISE_TAX_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TaxExcludedAsc = 'TAX_EXCLUDED_ASC',
  TaxExcludedDesc = 'TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Deposit = Node & {
  __typename?: 'Deposit';
  clearingPrice?: Maybe<Scalars['Float']>;
  closingStatusCode: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  demandCode: Scalars['String'];
  demandId?: Maybe<Scalars['Int']>;
  demandTotalInMonth: Scalars['Float'];
  depositClearingDetail?: Maybe<DepositClearingDetailConnection>;
  depositDate: Scalars['String'];
  depositDetail?: Maybe<DepositDetailConnection>;
  depositId: Scalars['ID'];
  depositPriceTotal: Scalars['Float'];
  depositRemark?: Maybe<Scalars['String']>;
  depositTotalInMonth: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  user?: Maybe<User>;
  userCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};


export type DepositDepositClearingDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DepositDepositDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DepositClearingDetail = Node & {
  __typename?: 'DepositClearingDetail';
  clearingPrice?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  demandId: Scalars['ID'];
  deposit?: Maybe<Deposit>;
  depositDate: Scalars['String'];
  depositId: Scalars['ID'];
  depositPriceTotal?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  overDepositPrice?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DepositClearingDetailConnection = {
  __typename?: 'DepositClearingDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepositClearingDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DepositClearingDetail` and its cursor. */
export type DepositClearingDetailEdge = {
  __typename?: 'DepositClearingDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DepositClearingDetail>;
};

/** An enumeration. */
export enum DepositClearingDetailSortEnum {
  ClearingPriceAsc = 'CLEARING_PRICE_ASC',
  ClearingPriceDesc = 'CLEARING_PRICE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  DepositDateAsc = 'DEPOSIT_DATE_ASC',
  DepositDateDesc = 'DEPOSIT_DATE_DESC',
  DepositIdAsc = 'DEPOSIT_ID_ASC',
  DepositIdDesc = 'DEPOSIT_ID_DESC',
  DepositPriceTotalAsc = 'DEPOSIT_PRICE_TOTAL_ASC',
  DepositPriceTotalDesc = 'DEPOSIT_PRICE_TOTAL_DESC',
  OverDepositPriceAsc = 'OVER_DEPOSIT_PRICE_ASC',
  OverDepositPriceDesc = 'OVER_DEPOSIT_PRICE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DepositConnection = {
  __typename?: 'DepositConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepositEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DepositDetail = Node & {
  __typename?: 'DepositDetail';
  billDate?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deposit?: Maybe<Deposit>;
  depositDivisionCode: Scalars['String'];
  depositDivisionDetail?: Maybe<Scalars['String']>;
  depositId: Scalars['ID'];
  depositPrice: Scalars['Float'];
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DepositDetailConnection = {
  __typename?: 'DepositDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepositDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DepositDetail` and its cursor. */
export type DepositDetailEdge = {
  __typename?: 'DepositDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DepositDetail>;
};

/** An enumeration. */
export enum DepositDetailSortEnum {
  BillDateAsc = 'BILL_DATE_ASC',
  BillDateDesc = 'BILL_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DepositDivisionCodeAsc = 'DEPOSIT_DIVISION_CODE_ASC',
  DepositDivisionCodeDesc = 'DEPOSIT_DIVISION_CODE_DESC',
  DepositDivisionDetailAsc = 'DEPOSIT_DIVISION_DETAIL_ASC',
  DepositDivisionDetailDesc = 'DEPOSIT_DIVISION_DETAIL_DESC',
  DepositIdAsc = 'DEPOSIT_ID_ASC',
  DepositIdDesc = 'DEPOSIT_ID_DESC',
  DepositPriceAsc = 'DEPOSIT_PRICE_ASC',
  DepositPriceDesc = 'DEPOSIT_PRICE_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DepositDivision = Node & {
  __typename?: 'DepositDivision';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  depositDivisionCode: Scalars['String'];
  depositDivisionName: Scalars['String'];
  depositGroupCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DepositDivisionConnection = {
  __typename?: 'DepositDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DepositDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DepositDivision` and its cursor. */
export type DepositDivisionEdge = {
  __typename?: 'DepositDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DepositDivision>;
};

/** An enumeration. */
export enum DepositDivisionSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DepositDivisionCodeAsc = 'DEPOSIT_DIVISION_CODE_ASC',
  DepositDivisionCodeDesc = 'DEPOSIT_DIVISION_CODE_DESC',
  DepositDivisionNameAsc = 'DEPOSIT_DIVISION_NAME_ASC',
  DepositDivisionNameDesc = 'DEPOSIT_DIVISION_NAME_DESC',
  DepositGroupCodeAsc = 'DEPOSIT_GROUP_CODE_ASC',
  DepositGroupCodeDesc = 'DEPOSIT_GROUP_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Deposit` and its cursor. */
export type DepositEdge = {
  __typename?: 'DepositEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Deposit>;
};

/** An enumeration. */
export enum DepositSortEnum {
  ClearingPriceAsc = 'CLEARING_PRICE_ASC',
  ClearingPriceDesc = 'CLEARING_PRICE_DESC',
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DemandCodeAsc = 'DEMAND_CODE_ASC',
  DemandCodeDesc = 'DEMAND_CODE_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  DepositDateAsc = 'DEPOSIT_DATE_ASC',
  DepositDateDesc = 'DEPOSIT_DATE_DESC',
  DepositIdAsc = 'DEPOSIT_ID_ASC',
  DepositIdDesc = 'DEPOSIT_ID_DESC',
  DepositPriceTotalAsc = 'DEPOSIT_PRICE_TOTAL_ASC',
  DepositPriceTotalDesc = 'DEPOSIT_PRICE_TOTAL_DESC',
  DepositRemarkAsc = 'DEPOSIT_REMARK_ASC',
  DepositRemarkDesc = 'DEPOSIT_REMARK_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DesignUser = Node & {
  __typename?: 'DesignUser';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  designUserCode: Scalars['String'];
  designUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DesignUserConnection = {
  __typename?: 'DesignUserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DesignUserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DesignUser` and its cursor. */
export type DesignUserEdge = {
  __typename?: 'DesignUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DesignUser>;
};

/** An enumeration. */
export enum DesignUserSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DesignUserCodeAsc = 'DESIGN_USER_CODE_ASC',
  DesignUserCodeDesc = 'DESIGN_USER_CODE_DESC',
  DesignUserNameAsc = 'DESIGN_USER_NAME_ASC',
  DesignUserNameDesc = 'DESIGN_USER_NAME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Details = Node & {
  __typename?: 'Details';
  beforeInventoryQuantity?: Maybe<Scalars['Float']>;
  currentInputQuantity?: Maybe<Scalars['Float']>;
  currentInputTotalTaxExcluded?: Maybe<Scalars['Float']>;
  currentReturnQuantity?: Maybe<Scalars['Float']>;
  currentReturnTotalTaxExcluded?: Maybe<Scalars['Float']>;
  currentStockQuantity?: Maybe<Scalars['Float']>;
  damageQuantity?: Maybe<Scalars['Float']>;
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering?: Maybe<Scalars['Int']>;
  physicalInventory?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDegits?: Maybe<Scalars['Int']>;
  salesQuantity?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  trustInventoryId?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
};

export type DetailsConnection = {
  __typename?: 'DetailsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DetailsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Details` and its cursor. */
export type DetailsEdge = {
  __typename?: 'DetailsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Details>;
};

export type DirectlyPurchase = Node & {
  __typename?: 'DirectlyPurchase';
  closingStatusCode: Scalars['String'];
  detailMemo?: Maybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  eightTax?: Maybe<Scalars['Float']>;
  eightTaxExcluded?: Maybe<Scalars['Float']>;
  exportTaxFree?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  purchaseDate: Scalars['String'];
  purchaseId: Scalars['String'];
  taxExcludedTotal?: Maybe<Scalars['Float']>;
  taxIncludedTotal?: Maybe<Scalars['Float']>;
  tenTax?: Maybe<Scalars['Float']>;
  tenTaxExcluded?: Maybe<Scalars['Float']>;
  vendorCode: Scalars['String'];
  vendorName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DirectlyPurchaseConnection = {
  __typename?: 'DirectlyPurchaseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DirectlyPurchaseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DirectlyPurchase` and its cursor. */
export type DirectlyPurchaseEdge = {
  __typename?: 'DirectlyPurchaseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DirectlyPurchase>;
};

export type DirectlyPurchaseFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isWip: Scalars['Boolean'];
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
  purchaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseVoucherType: Scalars['String'];
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Division = Node & {
  __typename?: 'Division';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerCode?: Maybe<Scalars['String']>;
  delFlg: Scalars['String'];
  divisionCode: Scalars['String'];
  divisionFinancialDate?: Maybe<DivisionFinancialDateConnection>;
  divisionName: Scalars['String'];
  divistionType: Scalars['String'];
  exchanges?: Maybe<ExchangeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  recordHighSales?: Maybe<Scalars['Float']>;
  recordHighSalesBk1?: Maybe<Scalars['Float']>;
  recordHighSalesBk2?: Maybe<Scalars['Float']>;
  recordHighSalesUpdateDate?: Maybe<Scalars['String']>;
  recordHighSalesUpdateDateBk1?: Maybe<Scalars['String']>;
  recordHighSalesUpdateDateBk2?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserCode?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserCodeBk1?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserCodeBk2?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserName?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserNameBk1?: Maybe<Scalars['String']>;
  recordHighSalesUpdateUserNameBk2?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  windowName: Scalars['String'];
};


export type DivisionDivisionFinancialDateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type DivisionExchangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DivisionConnection = {
  __typename?: 'DivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Division` and its cursor. */
export type DivisionEdge = {
  __typename?: 'DivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Division>;
};

export type DivisionFinancialDate = Node & {
  __typename?: 'DivisionFinancialDate';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  divisionCode: Scalars['String'];
  financialStage: Scalars['ID'];
  /** The ID of the object. */
  id: Scalars['ID'];
  targetGrossMarginRate?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type DivisionFinancialDateConnection = {
  __typename?: 'DivisionFinancialDateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DivisionFinancialDateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `DivisionFinancialDate` and its cursor. */
export type DivisionFinancialDateEdge = {
  __typename?: 'DivisionFinancialDateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DivisionFinancialDate>;
};

/** An enumeration. */
export enum DivisionFinancialDateSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  FinancialStageAsc = 'FINANCIAL_STAGE_ASC',
  FinancialStageDesc = 'FINANCIAL_STAGE_DESC',
  TargetGrossMarginRateAsc = 'TARGET_GROSS_MARGIN_RATE_ASC',
  TargetGrossMarginRateDesc = 'TARGET_GROSS_MARGIN_RATE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type DivisionGrades = {
  __typename?: 'DivisionGrades';
  costBetweenLastyearAndToday?: Maybe<Scalars['Int']>;
  costRate1year?: Maybe<Scalars['Float']>;
  costRate2year?: Maybe<Scalars['Float']>;
  costRateCurrent?: Maybe<Scalars['Float']>;
  dio1year?: Maybe<Scalars['Float']>;
  dio2year?: Maybe<Scalars['Float']>;
  dioCurrent?: Maybe<Scalars['Float']>;
  discontinuedProductAmount1year?: Maybe<Scalars['Float']>;
  discontinuedProductAmount2year?: Maybe<Scalars['Float']>;
  discontinuedProductAmountCurrent?: Maybe<Scalars['Float']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  grossProfitRate1year?: Maybe<Scalars['Float']>;
  grossProfitRate2year?: Maybe<Scalars['Float']>;
  grossProfitRateCurrent?: Maybe<Scalars['Float']>;
  recordHighSales?: Maybe<Scalars['Int']>;
  skuLatestOthers?: Maybe<Scalars['Int']>;
  skuLatestOthersSales?: Maybe<Scalars['Int']>;
  skuLatestOwn?: Maybe<Scalars['Int']>;
  skuLatestOwnSales?: Maybe<Scalars['Int']>;
  skuLatestOwnSalesRate?: Maybe<Scalars['Float']>;
  skuLatestSales?: Maybe<Scalars['Int']>;
  skuNewOthers?: Maybe<Scalars['Int']>;
  skuNewOwn?: Maybe<Scalars['Int']>;
  skuNewOwnRate?: Maybe<Scalars['Float']>;
  skuNewOwnSales?: Maybe<Scalars['Int']>;
  skuNewOwnSalesRate?: Maybe<Scalars['Float']>;
  skuOthers?: Maybe<Scalars['Int']>;
  skuOwn?: Maybe<Scalars['Int']>;
  skuOwnSales?: Maybe<Scalars['Int']>;
  stock1year?: Maybe<Scalars['Int']>;
  stock2year?: Maybe<Scalars['Int']>;
  stockCurrent?: Maybe<Scalars['Int']>;
  targetGrossMarginRate?: Maybe<Scalars['Float']>;
  totalSalesAmount1year?: Maybe<Scalars['Int']>;
  totalSalesAmount2year?: Maybe<Scalars['Int']>;
  totalSalesAmountCurrent?: Maybe<Scalars['Int']>;
  totalSalesCostAmount1year?: Maybe<Scalars['Int']>;
  totalSalesCostAmount2year?: Maybe<Scalars['Int']>;
  totalSalesCostAmountCurrent?: Maybe<Scalars['Int']>;
  totalSku?: Maybe<Scalars['Int']>;
  totalSkuLatest?: Maybe<Scalars['Int']>;
  totalSkuLatestOwnRate?: Maybe<Scalars['Float']>;
  totalSkuLatestOwnSales?: Maybe<Scalars['Float']>;
  totalSkuLatestRate?: Maybe<Scalars['Float']>;
  totalSkuLatestSales?: Maybe<Scalars['Float']>;
  totalSkuLatestSalesRate?: Maybe<Scalars['Float']>;
  totalSkuNew?: Maybe<Scalars['Int']>;
  totalSkuNewOwnSales?: Maybe<Scalars['Int']>;
  totalSkuNewOwnSalesRate?: Maybe<Scalars['Float']>;
  totalSkuNewRate?: Maybe<Scalars['Float']>;
  totalSkuNewSales?: Maybe<Scalars['Int']>;
  totalSkuNewSalesRate?: Maybe<Scalars['Float']>;
  totalSkuOwnSales?: Maybe<Scalars['Int']>;
  totalSkuSales?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DivisionSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  DivisionNameAsc = 'DIVISION_NAME_ASC',
  DivisionNameDesc = 'DIVISION_NAME_DESC',
  DivistionTypeAsc = 'DIVISTION_TYPE_ASC',
  DivistionTypeDesc = 'DIVISTION_TYPE_DESC',
  RecordHighSalesAsc = 'RECORD_HIGH_SALES_ASC',
  RecordHighSalesBk_1Asc = 'RECORD_HIGH_SALES_BK_1_ASC',
  RecordHighSalesBk_1Desc = 'RECORD_HIGH_SALES_BK_1_DESC',
  RecordHighSalesBk_2Asc = 'RECORD_HIGH_SALES_BK_2_ASC',
  RecordHighSalesBk_2Desc = 'RECORD_HIGH_SALES_BK_2_DESC',
  RecordHighSalesDesc = 'RECORD_HIGH_SALES_DESC',
  RecordHighSalesUpdateDateAsc = 'RECORD_HIGH_SALES_UPDATE_DATE_ASC',
  RecordHighSalesUpdateDateBk_1Asc = 'RECORD_HIGH_SALES_UPDATE_DATE_BK_1_ASC',
  RecordHighSalesUpdateDateBk_1Desc = 'RECORD_HIGH_SALES_UPDATE_DATE_BK_1_DESC',
  RecordHighSalesUpdateDateBk_2Asc = 'RECORD_HIGH_SALES_UPDATE_DATE_BK_2_ASC',
  RecordHighSalesUpdateDateBk_2Desc = 'RECORD_HIGH_SALES_UPDATE_DATE_BK_2_DESC',
  RecordHighSalesUpdateDateDesc = 'RECORD_HIGH_SALES_UPDATE_DATE_DESC',
  RecordHighSalesUpdateUserCodeAsc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_ASC',
  RecordHighSalesUpdateUserCodeBk_1Asc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_BK_1_ASC',
  RecordHighSalesUpdateUserCodeBk_1Desc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_BK_1_DESC',
  RecordHighSalesUpdateUserCodeBk_2Asc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_BK_2_ASC',
  RecordHighSalesUpdateUserCodeBk_2Desc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_BK_2_DESC',
  RecordHighSalesUpdateUserCodeDesc = 'RECORD_HIGH_SALES_UPDATE_USER_CODE_DESC',
  RecordHighSalesUpdateUserNameAsc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_ASC',
  RecordHighSalesUpdateUserNameBk_1Asc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_BK_1_ASC',
  RecordHighSalesUpdateUserNameBk_1Desc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_BK_1_DESC',
  RecordHighSalesUpdateUserNameBk_2Asc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_BK_2_ASC',
  RecordHighSalesUpdateUserNameBk_2Desc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_BK_2_DESC',
  RecordHighSalesUpdateUserNameDesc = 'RECORD_HIGH_SALES_UPDATE_USER_NAME_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WindowNameAsc = 'WINDOW_NAME_ASC',
  WindowNameDesc = 'WINDOW_NAME_DESC'
}

export type DivisionTerms = {
  __typename?: 'DivisionTerms';
  current?: Maybe<DivisionTermsFromTo>;
  currentTerm?: Maybe<DivisionTermsFromTo>;
  previousTerm?: Maybe<DivisionTermsFromTo>;
  twoTermsAgo?: Maybe<DivisionTermsFromTo>;
};

export type DivisionTermsFromTo = {
  __typename?: 'DivisionTermsFromTo';
  termFrom?: Maybe<Scalars['Date']>;
  termTo?: Maybe<Scalars['Date']>;
};

export type Estimate = Node & {
  __typename?: 'Estimate';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  customerUser?: Maybe<Scalars['String']>;
  deliverPeriod?: Maybe<Scalars['String']>;
  deliverPlace?: Maybe<Scalars['String']>;
  detailCount: Scalars['Int'];
  estimateDate: Scalars['String'];
  estimateDetails?: Maybe<EstimateDetailConnection>;
  estimateId: Scalars['ID'];
  estimatePriceTotal?: Maybe<Scalars['Float']>;
  estimateRemark?: Maybe<Scalars['String']>;
  estimateTitle?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  honorificCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  provisionalCustomerName?: Maybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  searchKeyword?: Maybe<Scalars['String']>;
  taxExcludeTotal?: Maybe<Scalars['Float']>;
  tel?: Maybe<Scalars['String']>;
  tradeMethod?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  user?: Maybe<User>;
  userCode: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type EstimateEstimateDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type EstimateConnection = {
  __typename?: 'EstimateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EstimateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EstimateDetail = Node & {
  __typename?: 'EstimateDetail';
  allRemainReceiveQuantity?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMemo?: Maybe<Scalars['String']>;
  estimate?: Maybe<Estimate>;
  estimateId: Scalars['ID'];
  frontNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType: Scalars['String'];
  receiveOrderQuantity?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  taxDivision?: Maybe<TaxDivision>;
  taxationDivision?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type EstimateDetailConnection = {
  __typename?: 'EstimateDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EstimateDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EstimateDetail` and its cursor. */
export type EstimateDetailEdge = {
  __typename?: 'EstimateDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EstimateDetail>;
};

/** An enumeration. */
export enum EstimateDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  EstimateIdAsc = 'ESTIMATE_ID_ASC',
  EstimateIdDesc = 'ESTIMATE_ID_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ReceiveDetailTradeTypeAsc = 'RECEIVE_DETAIL_TRADE_TYPE_ASC',
  ReceiveDetailTradeTypeDesc = 'RECEIVE_DETAIL_TRADE_TYPE_DESC',
  ReceiveOrderQuantityAsc = 'RECEIVE_ORDER_QUANTITY_ASC',
  ReceiveOrderQuantityDesc = 'RECEIVE_ORDER_QUANTITY_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  SellingPriceAsc = 'SELLING_PRICE_ASC',
  SellingPriceDesc = 'SELLING_PRICE_DESC',
  SellingUnitPriceAsc = 'SELLING_UNIT_PRICE_ASC',
  SellingUnitPriceDesc = 'SELLING_UNIT_PRICE_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Estimate` and its cursor. */
export type EstimateEdge = {
  __typename?: 'EstimateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Estimate>;
};

export type EstimatePrintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  estimateId: Scalars['Int'];
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  reportLayoutCode: Scalars['String'];
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type EstimatePrintPayload = {
  __typename?: 'EstimatePrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum EstimateSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerUserAsc = 'CUSTOMER_USER_ASC',
  CustomerUserDesc = 'CUSTOMER_USER_DESC',
  DeliverPeriodAsc = 'DELIVER_PERIOD_ASC',
  DeliverPeriodDesc = 'DELIVER_PERIOD_DESC',
  DeliverPlaceAsc = 'DELIVER_PLACE_ASC',
  DeliverPlaceDesc = 'DELIVER_PLACE_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  EstimateDateAsc = 'ESTIMATE_DATE_ASC',
  EstimateDateDesc = 'ESTIMATE_DATE_DESC',
  EstimateIdAsc = 'ESTIMATE_ID_ASC',
  EstimateIdDesc = 'ESTIMATE_ID_DESC',
  EstimatePriceTotalAsc = 'ESTIMATE_PRICE_TOTAL_ASC',
  EstimatePriceTotalDesc = 'ESTIMATE_PRICE_TOTAL_DESC',
  EstimateRemarkAsc = 'ESTIMATE_REMARK_ASC',
  EstimateRemarkDesc = 'ESTIMATE_REMARK_DESC',
  EstimateTitleAsc = 'ESTIMATE_TITLE_ASC',
  EstimateTitleDesc = 'ESTIMATE_TITLE_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  HonorificCodeAsc = 'HONORIFIC_CODE_ASC',
  HonorificCodeDesc = 'HONORIFIC_CODE_DESC',
  ProvisionalCustomerNameAsc = 'PROVISIONAL_CUSTOMER_NAME_ASC',
  ProvisionalCustomerNameDesc = 'PROVISIONAL_CUSTOMER_NAME_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  TradeMethodAsc = 'TRADE_METHOD_ASC',
  TradeMethodDesc = 'TRADE_METHOD_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type EstimateView = Node & {
  __typename?: 'EstimateView';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  customerName: Scalars['String'];
  customerUser?: Maybe<Scalars['String']>;
  deliverPeriod?: Maybe<Scalars['String']>;
  deliverPlace?: Maybe<Scalars['String']>;
  detailCount?: Maybe<Scalars['Int']>;
  detailSearchKeyword?: Maybe<Scalars['String']>;
  estimateDate: Scalars['String'];
  estimateId: Scalars['ID'];
  estimatePriceTotal?: Maybe<Scalars['Int']>;
  estimateRemark?: Maybe<Scalars['String']>;
  estimateTitle?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  headerSearchKeyword?: Maybe<Scalars['String']>;
  honorificCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  taxExcludeTotal?: Maybe<Scalars['Int']>;
  tel?: Maybe<Scalars['String']>;
  tradeMethod?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  userCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type EstimateViewConnection = {
  __typename?: 'EstimateViewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EstimateViewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EstimateView` and its cursor. */
export type EstimateViewEdge = {
  __typename?: 'EstimateViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EstimateView>;
};

/** An enumeration. */
export enum EstimateViewSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerNameAsc = 'CUSTOMER_NAME_ASC',
  CustomerNameDesc = 'CUSTOMER_NAME_DESC',
  CustomerUserAsc = 'CUSTOMER_USER_ASC',
  CustomerUserDesc = 'CUSTOMER_USER_DESC',
  DeliverPeriodAsc = 'DELIVER_PERIOD_ASC',
  DeliverPeriodDesc = 'DELIVER_PERIOD_DESC',
  DeliverPlaceAsc = 'DELIVER_PLACE_ASC',
  DeliverPlaceDesc = 'DELIVER_PLACE_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  DetailSearchKeywordAsc = 'DETAIL_SEARCH_KEYWORD_ASC',
  DetailSearchKeywordDesc = 'DETAIL_SEARCH_KEYWORD_DESC',
  EstimateDateAsc = 'ESTIMATE_DATE_ASC',
  EstimateDateDesc = 'ESTIMATE_DATE_DESC',
  EstimateIdAsc = 'ESTIMATE_ID_ASC',
  EstimateIdDesc = 'ESTIMATE_ID_DESC',
  EstimatePriceTotalAsc = 'ESTIMATE_PRICE_TOTAL_ASC',
  EstimatePriceTotalDesc = 'ESTIMATE_PRICE_TOTAL_DESC',
  EstimateRemarkAsc = 'ESTIMATE_REMARK_ASC',
  EstimateRemarkDesc = 'ESTIMATE_REMARK_DESC',
  EstimateTitleAsc = 'ESTIMATE_TITLE_ASC',
  EstimateTitleDesc = 'ESTIMATE_TITLE_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  HeaderSearchKeywordAsc = 'HEADER_SEARCH_KEYWORD_ASC',
  HeaderSearchKeywordDesc = 'HEADER_SEARCH_KEYWORD_DESC',
  HonorificCodeAsc = 'HONORIFIC_CODE_ASC',
  HonorificCodeDesc = 'HONORIFIC_CODE_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  TradeMethodAsc = 'TRADE_METHOD_ASC',
  TradeMethodDesc = 'TRADE_METHOD_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Exchange = Node & {
  __typename?: 'Exchange';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  divisionCode: Scalars['String'];
  endDate: Scalars['String'];
  exchangeRate: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  startDate: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExchangeConnection = {
  __typename?: 'ExchangeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ExchangeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Exchange` and its cursor. */
export type ExchangeEdge = {
  __typename?: 'ExchangeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Exchange>;
};

export type ExecuteDeleteReturnProcessReceiveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecuteDeleteReturnProcessReceivePayload = {
  __typename?: 'ExecuteDeleteReturnProcessReceivePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type ExecuteDemandDecisionDeleteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecuteDemandDecisionDeletePayload = {
  __typename?: 'ExecuteDemandDecisionDeletePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type ExecuteDemandDecisionReceiveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  salesDate: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecuteDemandDecisionReceivePayload = {
  __typename?: 'ExecuteDemandDecisionReceivePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type ExecutePaymentDecisionDeleteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecutePaymentDecisionDeletePayload = {
  __typename?: 'ExecutePaymentDecisionDeletePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type ExecutePaymentDecisionSendInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecutePaymentDecisionSendPayload = {
  __typename?: 'ExecutePaymentDecisionSendPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type ExecuteReturnProcessReceiveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecuteReturnProcessReceivePayload = {
  __typename?: 'ExecuteReturnProcessReceivePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type ExecuteReturnProcessSendInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ExecuteReturnProcessSendPayload = {
  __typename?: 'ExecuteReturnProcessSendPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type FinalizeInventoryDivisionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  inventoryId: Scalars['Int'];
};

export type FinalizeInventoryDivisionPayload = {
  __typename?: 'FinalizeInventoryDivisionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inventoryId?: Maybe<Scalars['Int']>;
};

export type FinancialDate = Node & {
  __typename?: 'FinancialDate';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  financialEndDate: Scalars['String'];
  financialMonth: Scalars['ID'];
  financialStage: Scalars['ID'];
  financialStartDate: Scalars['String'];
  financialYear: Scalars['ID'];
  /** The ID of the object. */
  id: Scalars['ID'];
  realMonth: Scalars['Int'];
  realYear: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type FinancialDateConnection = {
  __typename?: 'FinancialDateConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FinancialDateEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `FinancialDate` and its cursor. */
export type FinancialDateEdge = {
  __typename?: 'FinancialDateEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FinancialDate>;
};

/** An enumeration. */
export enum FinancialDateSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  FinancialEndDateAsc = 'FINANCIAL_END_DATE_ASC',
  FinancialEndDateDesc = 'FINANCIAL_END_DATE_DESC',
  FinancialMonthAsc = 'FINANCIAL_MONTH_ASC',
  FinancialMonthDesc = 'FINANCIAL_MONTH_DESC',
  FinancialStageAsc = 'FINANCIAL_STAGE_ASC',
  FinancialStageDesc = 'FINANCIAL_STAGE_DESC',
  FinancialStartDateAsc = 'FINANCIAL_START_DATE_ASC',
  FinancialStartDateDesc = 'FINANCIAL_START_DATE_DESC',
  FinancialYearAsc = 'FINANCIAL_YEAR_ASC',
  FinancialYearDesc = 'FINANCIAL_YEAR_DESC',
  RealMonthAsc = 'REAL_MONTH_ASC',
  RealMonthDesc = 'REAL_MONTH_DESC',
  RealYearAsc = 'REAL_YEAR_ASC',
  RealYearDesc = 'REAL_YEAR_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type FkorderInformation = Node & {
  __typename?: 'FkorderInformation';
  body: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryStatus: Scalars['String'];
  divisionCode: Scalars['String'];
  fkorderInformationAttachments?: Maybe<FkorderInformationAttachmentConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  informationId: Scalars['ID'];
  informationType: Scalars['String'];
  postedAt: Scalars['String'];
  publicationFrom: Scalars['String'];
  publicationTo: Scalars['String'];
  title: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type FkorderInformationFkorderInformationAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type FkorderInformationAttachment = Node & {
  __typename?: 'FkorderInformationAttachment';
  attachmentId: Scalars['ID'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  filename: Scalars['String'];
  fkorderInformation?: Maybe<FkorderInformation>;
  /** The ID of the object. */
  id: Scalars['ID'];
  informationId: Scalars['Int'];
  path: Scalars['String'];
  presignedUrl?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type FkorderInformationAttachmentConnection = {
  __typename?: 'FkorderInformationAttachmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FkorderInformationAttachmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `FkorderInformationAttachment` and its cursor. */
export type FkorderInformationAttachmentEdge = {
  __typename?: 'FkorderInformationAttachmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FkorderInformationAttachment>;
};

export type FkorderInformationConnection = {
  __typename?: 'FkorderInformationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FkorderInformationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `FkorderInformation` and its cursor. */
export type FkorderInformationEdge = {
  __typename?: 'FkorderInformationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FkorderInformation>;
};

/** An enumeration. */
export enum FkorderInformationSortEnum {
  BodyAsc = 'BODY_ASC',
  BodyDesc = 'BODY_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveryStatusAsc = 'DELIVERY_STATUS_ASC',
  DeliveryStatusDesc = 'DELIVERY_STATUS_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  InformationIdAsc = 'INFORMATION_ID_ASC',
  InformationIdDesc = 'INFORMATION_ID_DESC',
  InformationTypeAsc = 'INFORMATION_TYPE_ASC',
  InformationTypeDesc = 'INFORMATION_TYPE_DESC',
  PostedAtAsc = 'POSTED_AT_ASC',
  PostedAtDesc = 'POSTED_AT_DESC',
  PublicationFromAsc = 'PUBLICATION_FROM_ASC',
  PublicationFromDesc = 'PUBLICATION_FROM_DESC',
  PublicationToAsc = 'PUBLICATION_TO_ASC',
  PublicationToDesc = 'PUBLICATION_TO_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type FkorderPublication = {
  __typename?: 'FkorderPublication';
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  lastPublicated?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['String']>;
  publicationStatus?: Maybe<Scalars['String']>;
};

export type ImportCustomerBudget = {
  budgetPrice: Scalars['Int'];
  customerCode: Scalars['String'];
  financialMonth: Scalars['Int'];
  financialStage: Scalars['String'];
};

export type ImportCustomerBudgetListInput = {
  budgetLists: Array<InputMaybe<ImportCustomerBudget>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ImportCustomerBudgetListPayload = {
  __typename?: 'ImportCustomerBudgetListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerBudget?: Maybe<Array<Maybe<CustomerBudget>>>;
};

export type ImportInventoryDetailData = {
  inventoryMemo?: InputMaybe<Scalars['String']>;
  physicalInventory: Scalars['Decimal'];
  productCode: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type ImportInventoryDetailInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  inventoryDetails?: InputMaybe<Array<InputMaybe<ImportInventoryDetailData>>>;
  inventoryId: Scalars['Int'];
};

export type ImportInventoryDetailPayload = {
  __typename?: 'ImportInventoryDetailPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inventoryId?: Maybe<Scalars['Int']>;
};

export type ImportSendOrderRequestDetail = {
  orderDate: Scalars['String'];
  orderQuantity: Scalars['Float'];
  poCode?: InputMaybe<Scalars['String']>;
  productCode: Scalars['String'];
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen: Scalars['Float'];
  vendorCode: Scalars['String'];
};

export type ImportSendOrderRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Array<InputMaybe<ImportSendOrderRequestDetail>>>;
};

export type ImportSendOrderRequestPayload = {
  __typename?: 'ImportSendOrderRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<Array<Maybe<SendOrder>>>;
};

export type Information = Node & {
  __typename?: 'Information';
  approvalStatus: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  infoFromDivisionCode: Scalars['String'];
  infoToDivisionCode: Scalars['String'];
  information: Scalars['String'];
  informationId: Scalars['ID'];
  informationType: Scalars['String'];
  responseDate?: Maybe<Scalars['DateTime']>;
  responseUser?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type InformationConnection = {
  __typename?: 'InformationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InformationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InformationDetail = Node & {
  __typename?: 'InformationDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  informationId: Scalars['ID'];
  informationQuantity?: Maybe<Scalars['Float']>;
  informationTargetCode?: Maybe<Scalars['String']>;
  informationTargetNo?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type InformationDetailConnection = {
  __typename?: 'InformationDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InformationDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `InformationDetail` and its cursor. */
export type InformationDetailEdge = {
  __typename?: 'InformationDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InformationDetail>;
};

/** An enumeration. */
export enum InformationDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  InformationIdAsc = 'INFORMATION_ID_ASC',
  InformationIdDesc = 'INFORMATION_ID_DESC',
  InformationQuantityAsc = 'INFORMATION_QUANTITY_ASC',
  InformationQuantityDesc = 'INFORMATION_QUANTITY_DESC',
  InformationTargetCodeAsc = 'INFORMATION_TARGET_CODE_ASC',
  InformationTargetCodeDesc = 'INFORMATION_TARGET_CODE_DESC',
  InformationTargetNoAsc = 'INFORMATION_TARGET_NO_ASC',
  InformationTargetNoDesc = 'INFORMATION_TARGET_NO_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Information` and its cursor. */
export type InformationEdge = {
  __typename?: 'InformationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Information>;
};

/** An enumeration. */
export enum InformationSortEnum {
  ApprovalStatusAsc = 'APPROVAL_STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL_STATUS_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  InformationAsc = 'INFORMATION_ASC',
  InformationDesc = 'INFORMATION_DESC',
  InformationIdAsc = 'INFORMATION_ID_ASC',
  InformationIdDesc = 'INFORMATION_ID_DESC',
  InformationTypeAsc = 'INFORMATION_TYPE_ASC',
  InformationTypeDesc = 'INFORMATION_TYPE_DESC',
  InfoFromDivisionCodeAsc = 'INFO_FROM_DIVISION_CODE_ASC',
  InfoFromDivisionCodeDesc = 'INFO_FROM_DIVISION_CODE_DESC',
  InfoToDivisionCodeAsc = 'INFO_TO_DIVISION_CODE_ASC',
  InfoToDivisionCodeDesc = 'INFO_TO_DIVISION_CODE_DESC',
  ResponseDateAsc = 'RESPONSE_DATE_ASC',
  ResponseDateDesc = 'RESPONSE_DATE_DESC',
  ResponseUserAsc = 'RESPONSE_USER_ASC',
  ResponseUserDesc = 'RESPONSE_USER_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type InitialReceiveOrderHeader = Node & {
  __typename?: 'InitialReceiveOrderHeader';
  completedDetailCount: Scalars['Int'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerCode: Scalars['String'];
  customerGroup: Scalars['String'];
  customerWarehouseCode?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryStatus: Scalars['String'];
  demandCode: Scalars['String'];
  detailCount: Scalars['Int'];
  divisionCode: Scalars['String'];
  editedFlg?: Maybe<Scalars['String']>;
  estimateId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  orderPath: Scalars['String'];
  ordererEmail1?: Maybe<Scalars['String']>;
  ordererEmail2?: Maybe<Scalars['String']>;
  ordererEmail3?: Maybe<Scalars['String']>;
  ordererName?: Maybe<Scalars['String']>;
  ordererRemark?: Maybe<Scalars['String']>;
  ordererTel?: Maybe<Scalars['String']>;
  provisionalCustomerName?: Maybe<Scalars['String']>;
  receiveOrderDate: Scalars['String'];
  receiveOrderId: Scalars['ID'];
  receiveOrderMemo?: Maybe<Scalars['String']>;
  receiveOrderRemarks?: Maybe<Scalars['String']>;
  receiveOrderStatus: Scalars['String'];
  receiveOrderTotalPrice?: Maybe<Scalars['Float']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: Maybe<Scalars['String']>;
  salesDate?: Maybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUserCode?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  tax8Per?: Maybe<Scalars['Float']>;
  tax10Per?: Maybe<Scalars['Float']>;
  taxExcludeTotal?: Maybe<Scalars['Float']>;
  taxExcluded8Per?: Maybe<Scalars['Float']>;
  taxExcluded10Per?: Maybe<Scalars['Float']>;
  undeliveredDetailCount: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type Inventory = Node & {
  __typename?: 'Inventory';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryBaseFrom: Scalars['String'];
  inventoryBaseTo: Scalars['String'];
  inventoryDivision?: Maybe<InventoryDivisionConnection>;
  inventoryFinishFlg: Scalars['String'];
  inventoryId: Scalars['ID'];
  inventoryName: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type InventoryInventoryDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type InventoryConnection = {
  __typename?: 'InventoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InventoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InventoryDetail = Node & {
  __typename?: 'InventoryDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryId: Scalars['ID'];
  inventoryMemo?: Maybe<Scalars['String']>;
  physicalInventory?: Maybe<Scalars['Float']>;
  productCode: Scalars['String'];
  productView?: Maybe<ProductNoPriceView>;
  stockQuantity: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouse?: Maybe<Warehouse>;
  warehouseCode: Scalars['String'];
};

export type InventoryDetailConnection = {
  __typename?: 'InventoryDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InventoryDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InventoryDetailCustom = {
  __typename?: 'InventoryDetailCustom';
  result: Scalars['String'];
};

export type InventoryDetailCustomFilter = {
  divisionCode: Scalars['String'];
  inventoryDifference?: InputMaybe<Scalars['String']>;
  inventoryId: Scalars['Int'];
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

/** A Relay edge containing a `InventoryDetail` and its cursor. */
export type InventoryDetailEdge = {
  __typename?: 'InventoryDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InventoryDetail>;
};

/** An enumeration. */
export enum InventoryDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  InventoryIdAsc = 'INVENTORY_ID_ASC',
  InventoryIdDesc = 'INVENTORY_ID_DESC',
  InventoryMemoAsc = 'INVENTORY_MEMO_ASC',
  InventoryMemoDesc = 'INVENTORY_MEMO_DESC',
  PhysicalInventoryAsc = 'PHYSICAL_INVENTORY_ASC',
  PhysicalInventoryDesc = 'PHYSICAL_INVENTORY_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  StockQuantityAsc = 'STOCK_QUANTITY_ASC',
  StockQuantityDesc = 'STOCK_QUANTITY_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type InventoryDivision = Node & {
  __typename?: 'InventoryDivision';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inventory?: Maybe<Inventory>;
  inventoryDivisionStatus: Scalars['String'];
  inventoryId: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type InventoryDivisionConnection = {
  __typename?: 'InventoryDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InventoryDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `InventoryDivision` and its cursor. */
export type InventoryDivisionEdge = {
  __typename?: 'InventoryDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InventoryDivision>;
};

/** An enumeration. */
export enum InventoryDivisionSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  InventoryDivisionStatusAsc = 'INVENTORY_DIVISION_STATUS_ASC',
  InventoryDivisionStatusDesc = 'INVENTORY_DIVISION_STATUS_DESC',
  InventoryIdAsc = 'INVENTORY_ID_ASC',
  InventoryIdDesc = 'INVENTORY_ID_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Inventory` and its cursor. */
export type InventoryEdge = {
  __typename?: 'InventoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Inventory>;
};

/** An enumeration. */
export enum InventorySortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  InventoryBaseFromAsc = 'INVENTORY_BASE_FROM_ASC',
  InventoryBaseFromDesc = 'INVENTORY_BASE_FROM_DESC',
  InventoryBaseToAsc = 'INVENTORY_BASE_TO_ASC',
  InventoryBaseToDesc = 'INVENTORY_BASE_TO_DESC',
  InventoryFinishFlgAsc = 'INVENTORY_FINISH_FLG_ASC',
  InventoryFinishFlgDesc = 'INVENTORY_FINISH_FLG_DESC',
  InventoryIdAsc = 'INVENTORY_ID_ASC',
  InventoryIdDesc = 'INVENTORY_ID_DESC',
  InventoryNameAsc = 'INVENTORY_NAME_ASC',
  InventoryNameDesc = 'INVENTORY_NAME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type LotGroupProduct = Node & {
  __typename?: 'LotGroupProduct';
  attr1?: Maybe<Scalars['String']>;
  attr2?: Maybe<Scalars['String']>;
  attributeName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode: Scalars['String'];
  lotGroupCode: Scalars['String'];
  lotGroupName: Scalars['String'];
  minimumLot: Scalars['Int'];
  productCode: Scalars['String'];
  productName: Scalars['String'];
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
};

export type LotGroupProductConnection = {
  __typename?: 'LotGroupProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LotGroupProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `LotGroupProduct` and its cursor. */
export type LotGroupProductEdge = {
  __typename?: 'LotGroupProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LotGroupProduct>;
};

export type LotGroupProductFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  lotGroupCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type MonthlyStock = Node & {
  __typename?: 'MonthlyStock';
  buyReturn: Scalars['Float'];
  buyShipping: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  damageQuantity: Scalars['Float'];
  directlyReturn: Scalars['Float'];
  directlyShipping: Scalars['Float'];
  historyDate: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inputInterdivisional: Scalars['Float'];
  inputProduction: Scalars['Float'];
  inputPurpose: Scalars['Float'];
  inputStockAdjust: Scalars['Float'];
  outputInterdivisional: Scalars['Float'];
  outputProduction: Scalars['Float'];
  outputStockAdjust: Scalars['Float'];
  outsourcerReturn: Scalars['Float'];
  outsourcerShipping: Scalars['Float'];
  productCode: Scalars['String'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen: Scalars['Float'];
  purposeReturn: Scalars['Float'];
  salesUnitPrice: Scalars['Float'];
  stockQuantity: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type MonthlyStockConnection = {
  __typename?: 'MonthlyStockConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MonthlyStockEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MonthlyStock` and its cursor. */
export type MonthlyStockEdge = {
  __typename?: 'MonthlyStockEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MonthlyStock>;
};

/** An enumeration. */
export enum MonthlyStockSortEnum {
  BuyReturnAsc = 'BUY_RETURN_ASC',
  BuyReturnDesc = 'BUY_RETURN_DESC',
  BuyShippingAsc = 'BUY_SHIPPING_ASC',
  BuyShippingDesc = 'BUY_SHIPPING_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DamageQuantityAsc = 'DAMAGE_QUANTITY_ASC',
  DamageQuantityDesc = 'DAMAGE_QUANTITY_DESC',
  DirectlyReturnAsc = 'DIRECTLY_RETURN_ASC',
  DirectlyReturnDesc = 'DIRECTLY_RETURN_DESC',
  DirectlyShippingAsc = 'DIRECTLY_SHIPPING_ASC',
  DirectlyShippingDesc = 'DIRECTLY_SHIPPING_DESC',
  HistoryDateAsc = 'HISTORY_DATE_ASC',
  HistoryDateDesc = 'HISTORY_DATE_DESC',
  InputInterdivisionalAsc = 'INPUT_INTERDIVISIONAL_ASC',
  InputInterdivisionalDesc = 'INPUT_INTERDIVISIONAL_DESC',
  InputProductionAsc = 'INPUT_PRODUCTION_ASC',
  InputProductionDesc = 'INPUT_PRODUCTION_DESC',
  InputPurposeAsc = 'INPUT_PURPOSE_ASC',
  InputPurposeDesc = 'INPUT_PURPOSE_DESC',
  InputStockAdjustAsc = 'INPUT_STOCK_ADJUST_ASC',
  InputStockAdjustDesc = 'INPUT_STOCK_ADJUST_DESC',
  OutputInterdivisionalAsc = 'OUTPUT_INTERDIVISIONAL_ASC',
  OutputInterdivisionalDesc = 'OUTPUT_INTERDIVISIONAL_DESC',
  OutputProductionAsc = 'OUTPUT_PRODUCTION_ASC',
  OutputProductionDesc = 'OUTPUT_PRODUCTION_DESC',
  OutputStockAdjustAsc = 'OUTPUT_STOCK_ADJUST_ASC',
  OutputStockAdjustDesc = 'OUTPUT_STOCK_ADJUST_DESC',
  OutsourcerReturnAsc = 'OUTSOURCER_RETURN_ASC',
  OutsourcerReturnDesc = 'OUTSOURCER_RETURN_DESC',
  OutsourcerShippingAsc = 'OUTSOURCER_SHIPPING_ASC',
  OutsourcerShippingDesc = 'OUTSOURCER_SHIPPING_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  PurposeReturnAsc = 'PURPOSE_RETURN_ASC',
  PurposeReturnDesc = 'PURPOSE_RETURN_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  StockQuantityAsc = 'STOCK_QUANTITY_ASC',
  StockQuantityDesc = 'STOCK_QUANTITY_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type Mutation = {
  __typename?: 'Mutation';
  activeReportBulkDemandPrint?: Maybe<ActiveReportBulkDemandPrint>;
  activeReportCreatePriceCard?: Maybe<ActiveReportCreatePriceCard>;
  activeReportCreatePriceCardForTshirts?: Maybe<ActiveReportCreatePriceCardForTshirts>;
  activeReportDemandPrint?: Maybe<ActiveReportDemandPrint>;
  activeReportEstimatePrint?: Maybe<ActiveReportEstimatePrint>;
  activeReportOutsourcerSalesPrint?: Maybe<ActiveReportOutsourcerSalesPrint>;
  activeReportReceiveOrderPrint?: Maybe<ActiveReportReceiveOrderPrint>;
  activeReportSaleVoucherPrint?: Maybe<ActiveReportShipmentPrint>;
  activeReportSendOrderPrint?: Maybe<ActiveReportSendOrderPrint>;
  approveTrustInventory?: Maybe<ApproveTrustInventoryPayload>;
  bulkDemandPrint?: Maybe<BulkDemandPrintPayload>;
  createArrival?: Maybe<CreateArrivalPayload>;
  createAutomaticWithdrawal?: Maybe<CreateAutomaticWithdrawalsPayload>;
  createBulkDeposit?: Maybe<CreateBulkDepositPayload>;
  createComponent?: Maybe<CreateComponentPayload>;
  createCustomer?: Maybe<CreateCustomerPayload>;
  createCustomerBudget?: Maybe<CreateCustomerBudgetPayload>;
  createCustomerPrice?: Maybe<CreateCustomerPricePayload>;
  createCustomerPriceWithBulkImport?: Maybe<CreateCustomerPriceWithBulkImportPayload>;
  createCustomerPriceWithImport?: Maybe<CreateCustomerPriceWithImportPayload>;
  createCustomerProductGroupPublication?: Maybe<CreateCustomerProductGroupPublicationPayload>;
  createCustomerProductGroupPublicationWithImport?: Maybe<CreateCustomerProductGroupPublicationWithImportPayload>;
  createCustomerProductPublication?: Maybe<CreateCustomerProductPublicationPayload>;
  createCustomerProductPublicationWithImport?: Maybe<CreateCustomerProductPublicationWithImportPayload>;
  createCustomerUser?: Maybe<CreateCustomerUserPayload>;
  createDeliver?: Maybe<CreateDeliverPayload>;
  createDemand?: Maybe<CreateDemandPayload>;
  createDeposit?: Maybe<CreateDepositPayload>;
  createDirectPurchase?: Maybe<CreateDirectPurchasePayload>;
  createDirectWip?: Maybe<CreateDirectWipPayload>;
  createDivision?: Maybe<CreateDivisionPayload>;
  createEstimate?: Maybe<CreateEstimatePayload>;
  createFkorderInformation?: Maybe<CreateFkorderInformationPayload>;
  createFkorderInformationAttachment?: Maybe<CreateFkorderInformationAttachmentPayload>;
  createInventory?: Maybe<CreateInventoryPayload>;
  createOutsourcerSales?: Maybe<CreateOutsourcerSalesPayload>;
  createPayment?: Maybe<CreatePaymentPayload>;
  createProduct?: Maybe<CreateProductPayload>;
  createProduction?: Maybe<CreateProductionPayload>;
  createReceiveOrder?: Maybe<CreateReceiveOrderPayload>;
  createReturnReceiveOrder?: Maybe<CreateReturnReceiveOrderPayload>;
  createReturnSendOrder?: Maybe<CreateReturnSendOrderPayload>;
  createSendOrder?: Maybe<CreateSendOrderPayload>;
  createSendOrderLot?: Maybe<CreateSendOrderLotPayload>;
  createShipment?: Maybe<CreateShipmentPayload>;
  createStockAdjust?: Maybe<CreateStockAdjustPayload>;
  createTrustInventory?: Maybe<CreateTrustInventoryPayload>;
  createTrustInventoryJanUnit?: Maybe<CreateTrustInventoryJanUnitPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createVendor?: Maybe<CreateVendorPayload>;
  createWarehouse?: Maybe<CreateWarehousePayload>;
  createWarehouseMove?: Maybe<CreateWarehouseMovePayload>;
  createWithdrawal?: Maybe<CreateWithdrawalPayload>;
  deleteArrival?: Maybe<DeleteArrivalPayload>;
  deleteAutomaticWithdrawal?: Maybe<DeleteAutomaticWithdrawalsPayload>;
  deleteComponent?: Maybe<DeleteComponentPayload>;
  deleteCustomer?: Maybe<DeleteCustomerPayload>;
  deleteCustomerUser?: Maybe<DeleteCustomerUserPayload>;
  deleteDeliver?: Maybe<DeleteDeliverPayload>;
  deleteDemandList?: Maybe<DeleteDemandListPayload>;
  deleteDemandTaxAdjustList?: Maybe<DeleteDemandTaxAdjustListPayload>;
  deleteDeposit?: Maybe<DeleteDepositPayload>;
  deleteDirectPurchase?: Maybe<DeleteDirectPurchasePayload>;
  deleteDirectWip?: Maybe<DeleteDirectWipPayload>;
  deleteDivision?: Maybe<DeleteDivisionPayload>;
  deleteEstimate?: Maybe<DeleteEstimatePayload>;
  deleteFkorderInformation?: Maybe<DeleteFkorderInformationPayload>;
  deleteInventory?: Maybe<DeleteInventoryPayload>;
  deleteOutsourcerSales?: Maybe<DeleteOutsourcerSalesPayload>;
  deletePayment?: Maybe<DeletePaymentPayload>;
  deletePaymentTaxAdjustList?: Maybe<DeletePaymentTaxAdjustListPayload>;
  deleteProduct?: Maybe<DeleteProductPayload>;
  deleteProduction?: Maybe<DeleteProductionPayload>;
  deleteReceiveOrder?: Maybe<DeleteReceiveOrderPayload>;
  deleteReturnReceiveOrder?: Maybe<DeleteReturnReceiveOrderPayload>;
  deleteReturnSendOrder?: Maybe<DeleteReturnSendOrderPayload>;
  deleteSendOrder?: Maybe<DeleteSendOrderPayload>;
  deleteSendOrderLot?: Maybe<DeleteSendOrderLotPayload>;
  deleteShipment?: Maybe<DeleteShipmentPayload>;
  deleteStockAdjust?: Maybe<DeleteStockAdjustPayload>;
  deleteTrustInventory?: Maybe<DeleteTrustInventoryPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteVendor?: Maybe<DeleteVendorPayload>;
  deleteWarehouse?: Maybe<DeleteWarehousePayload>;
  deleteWarehouseMove?: Maybe<DeleteWarehouseMovePayload>;
  deleteWithdrawal?: Maybe<DeleteWithdrawalPayload>;
  demandPrint?: Maybe<DemandPrintPayload>;
  estimatePrint?: Maybe<EstimatePrintPayload>;
  executeDeleteReturnProcessReceive?: Maybe<ExecuteDeleteReturnProcessReceivePayload>;
  executeDemandDecisionDelete?: Maybe<ExecuteDemandDecisionDeletePayload>;
  executeDemandDecisionReceive?: Maybe<ExecuteDemandDecisionReceivePayload>;
  executePaymentDecisionDelete?: Maybe<ExecutePaymentDecisionDeletePayload>;
  executePaymentDecisionSend?: Maybe<ExecutePaymentDecisionSendPayload>;
  executeReturnProcessReceive?: Maybe<ExecuteReturnProcessReceivePayload>;
  executeReturnProcessSend?: Maybe<ExecuteReturnProcessSendPayload>;
  finalizeInventoryDivision?: Maybe<FinalizeInventoryDivisionPayload>;
  importCustomerBudget?: Maybe<ImportCustomerBudgetListPayload>;
  importInventoryDetail?: Maybe<ImportInventoryDetailPayload>;
  importSendOrderRequest?: Maybe<ImportSendOrderRequestPayload>;
  productImport?: Maybe<ProductImportPayload>;
  receiveOrderPrint?: Maybe<ReceiveOrderPrintPayload>;
  saleVoucherPrint?: Maybe<SaleVoucherPrintPayload>;
  sendBackTrustInventory?: Maybe<SendBackTrustInventoryPayload>;
  sendOrderPrint?: Maybe<SendOrderPrintPayload>;
  syncFkorderPublication?: Maybe<SyncFkorderPublicationPayload>;
  syncFkorderPublicationPreAndPublic?: Maybe<SyncFkorderPublicationPreAndPublicPayload>;
  trustSalesPrint?: Maybe<TrustSaleVoucherPrintPayload>;
  updateArrival?: Maybe<UpdateArrivalPayload>;
  updateComponent?: Maybe<UpdateComponentPayload>;
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  updateCustomerUser?: Maybe<UpdateCustomerUserPayload>;
  updateDeliver?: Maybe<UpdateDeliverPayload>;
  updateDeposit?: Maybe<UpdateDepositPayload>;
  updateDivision?: Maybe<UpdateDivisionPayload>;
  updateEstimate?: Maybe<UpdateEstimatePayload>;
  updateFkorderInformation?: Maybe<UpdateFkorderInformationPayload>;
  updateInventory?: Maybe<UpdateInventoryPayload>;
  updateOutsourcerSales?: Maybe<UpdateOutsourcerSalesPayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  updateProductGroup?: Maybe<UpdateProductGroupPayload>;
  updateProduction?: Maybe<UpdateProductionPayload>;
  updateReceiveOrder?: Maybe<UpdateReceiveOrderPayload>;
  updateReceiveOrderCorrection?: Maybe<UpdateReceiveOrderCorrectionPayload>;
  updateReceiveOrderSalesUnitPrice?: Maybe<UpdateReceiveOrderDetailSalesUnitPricePayload>;
  updateReceiveOrderStatusCancel?: Maybe<UpdateReceiveOrderStatusCancelPayload>;
  updateReceiveOrderStatusConfirmed?: Maybe<UpdateReceiveOrderStatusConfirmedPayload>;
  updateReturnReceiveOrder?: Maybe<UpdateReturnReceiveOrderPayload>;
  updateReturnSendOrder?: Maybe<UpdateReturnSendOrderPayload>;
  updateSendOrder?: Maybe<UpdateSendOrderPayload>;
  updateSendOrderApproval?: Maybe<UpdateSendOrderApprovalPayload>;
  updateSendOrderBulkApproval?: Maybe<UpdateSendOrderBulkApprovalPayload>;
  updateSendOrderLot?: Maybe<UpdateSendOrderLotPayload>;
  updateSendOrderPurchaseUnitPrice?: Maybe<UpdateSendOrderDetailPurchaseUnitPricePayload>;
  updateSendOrderRemand?: Maybe<UpdateSendOrderRemandPayload>;
  updateShipment?: Maybe<UpdateShipmentPayload>;
  updateStockAdjust?: Maybe<UpdateStockAdjustPayload>;
  updateTrustInventory?: Maybe<UpdateTrustInventoryPayload>;
  updateTrustInventoryJanUnit?: Maybe<UpdateTrustInventoryJanUnitPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateVendor?: Maybe<UpdateVendorPayload>;
  updateWarehouse?: Maybe<UpdateWarehousePayload>;
  updateWarehouseMove?: Maybe<UpdateWarehouseMovePayload>;
  updateWarehouseMoveApprove?: Maybe<UpdateWarehouseMoveApprovePayload>;
  updateWarehouseMoveReject?: Maybe<UpdateWarehouseMoveRejectPayload>;
  updateWithdrawal?: Maybe<UpdateWithdrawalPayload>;
  upsertDemandTaxAdjustList?: Maybe<UpsertDemandTaxAdjustListPayload>;
  upsertPaymentTaxAdjustList?: Maybe<UpsertPaymentTaxAdjustListPayload>;
};


export type MutationActiveReportBulkDemandPrintArgs = {
  carryOverPriceFlg: Scalars['String'];
  demandIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  detailStatus: Scalars['String'];
  excludeZeroDemandFlg?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
};


export type MutationActiveReportCreatePriceCardArgs = {
  copiesDetail?: InputMaybe<Array<InputMaybe<CreatePriceCard>>>;
  priceMode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
  titles?: InputMaybe<Scalars['String']>;
};


export type MutationActiveReportCreatePriceCardForTshirtsArgs = {
  copiesDetail?: InputMaybe<Array<InputMaybe<CreatePriceCardForTshirts>>>;
  janCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetDate: Scalars['Date'];
};


export type MutationActiveReportDemandPrintArgs = {
  carryOverPriceFlg?: InputMaybe<Scalars['String']>;
  demandId: Scalars['Int'];
  detailStatus?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
};


export type MutationActiveReportEstimatePrintArgs = {
  estimateId: Scalars['Int'];
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};


export type MutationActiveReportOutsourcerSalesPrintArgs = {
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  salesId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
};


export type MutationActiveReportReceiveOrderPrintArgs = {
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  offsetX?: InputMaybe<Scalars['String']>;
  offsetY?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['Int'];
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};


export type MutationActiveReportSaleVoucherPrintArgs = {
  deliveryOrderId: Scalars['Int'];
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  offsetX?: InputMaybe<Scalars['String']>;
  offsetY?: InputMaybe<Scalars['String']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};


export type MutationActiveReportSendOrderPrintArgs = {
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};


export type MutationApproveTrustInventoryArgs = {
  input: ApproveTrustInventoryInput;
};


export type MutationBulkDemandPrintArgs = {
  input: BulkDemandPrintInput;
};


export type MutationCreateArrivalArgs = {
  input: CreateArrivalInput;
};


export type MutationCreateAutomaticWithdrawalArgs = {
  input: CreateAutomaticWithdrawalsInput;
};


export type MutationCreateBulkDepositArgs = {
  input: CreateBulkDepositInput;
};


export type MutationCreateComponentArgs = {
  input: CreateComponentInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateCustomerBudgetArgs = {
  input: CreateCustomerBudgetInput;
};


export type MutationCreateCustomerPriceArgs = {
  input: CreateCustomerPriceInput;
};


export type MutationCreateCustomerPriceWithBulkImportArgs = {
  input: CreateCustomerPriceWithBulkImportInput;
};


export type MutationCreateCustomerPriceWithImportArgs = {
  input: CreateCustomerPriceWithImportInput;
};


export type MutationCreateCustomerProductGroupPublicationArgs = {
  input: CreateCustomerProductGroupPublicationInput;
};


export type MutationCreateCustomerProductGroupPublicationWithImportArgs = {
  input: CreateCustomerProductGroupPublicationWithImportInput;
};


export type MutationCreateCustomerProductPublicationArgs = {
  input: CreateCustomerProductPublicationInput;
};


export type MutationCreateCustomerProductPublicationWithImportArgs = {
  input: CreateCustomerProductPublicationWithImportInput;
};


export type MutationCreateCustomerUserArgs = {
  input: CreateCustomerUserInput;
};


export type MutationCreateDeliverArgs = {
  input: CreateDeliverInput;
};


export type MutationCreateDemandArgs = {
  input: CreateDemandInput;
};


export type MutationCreateDepositArgs = {
  input: CreateDepositInput;
};


export type MutationCreateDirectPurchaseArgs = {
  input: CreateDirectPurchaseInput;
};


export type MutationCreateDirectWipArgs = {
  input: CreateDirectWipInput;
};


export type MutationCreateDivisionArgs = {
  input: CreateDivisionInput;
};


export type MutationCreateEstimateArgs = {
  input: CreateEstimateInput;
};


export type MutationCreateFkorderInformationArgs = {
  input: CreateFkorderInformationInput;
};


export type MutationCreateFkorderInformationAttachmentArgs = {
  input: CreateFkorderInformationAttachmentInput;
};


export type MutationCreateInventoryArgs = {
  input: CreateInventoryInput;
};


export type MutationCreateOutsourcerSalesArgs = {
  input: CreateOutsourcerSalesInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductionArgs = {
  input: CreateProductionInput;
};


export type MutationCreateReceiveOrderArgs = {
  input: CreateReceiveOrderInput;
};


export type MutationCreateReturnReceiveOrderArgs = {
  input: CreateReturnReceiveOrderInput;
};


export type MutationCreateReturnSendOrderArgs = {
  input: CreateReturnSendOrderInput;
};


export type MutationCreateSendOrderArgs = {
  input: CreateSendOrderInput;
};


export type MutationCreateSendOrderLotArgs = {
  input: CreateSendOrderLotInput;
};


export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


export type MutationCreateStockAdjustArgs = {
  input: CreateStockAdjustInput;
};


export type MutationCreateTrustInventoryArgs = {
  input: CreateTrustInventoryInput;
};


export type MutationCreateTrustInventoryJanUnitArgs = {
  input: CreateTrustInventoryJanUnitInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVendorArgs = {
  input: CreateVendorInput;
};


export type MutationCreateWarehouseArgs = {
  input: CreateWarehouseInput;
};


export type MutationCreateWarehouseMoveArgs = {
  input: CreateWarehouseMoveInput;
};


export type MutationCreateWithdrawalArgs = {
  input: CreateWithdrawalInput;
};


export type MutationDeleteArrivalArgs = {
  input: DeleteArrivalInput;
};


export type MutationDeleteAutomaticWithdrawalArgs = {
  input: DeleteAutomaticWithdrawalsInput;
};


export type MutationDeleteComponentArgs = {
  input: DeleteComponentInput;
};


export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


export type MutationDeleteCustomerUserArgs = {
  input: DeleteCustomerUserInput;
};


export type MutationDeleteDeliverArgs = {
  input: DeleteDeliverInput;
};


export type MutationDeleteDemandListArgs = {
  input: DeleteDemandListInput;
};


export type MutationDeleteDemandTaxAdjustListArgs = {
  input: DeleteDemandTaxAdjustListInput;
};


export type MutationDeleteDepositArgs = {
  input: DeleteDepositInput;
};


export type MutationDeleteDirectPurchaseArgs = {
  input: DeleteDirectPurchaseInput;
};


export type MutationDeleteDirectWipArgs = {
  input: DeleteDirectWipInput;
};


export type MutationDeleteDivisionArgs = {
  input: DeleteDivisionInput;
};


export type MutationDeleteEstimateArgs = {
  input: DeleteEstimateInput;
};


export type MutationDeleteFkorderInformationArgs = {
  input: DeleteFkorderInformationInput;
};


export type MutationDeleteInventoryArgs = {
  input: DeleteInventoryInput;
};


export type MutationDeleteOutsourcerSalesArgs = {
  input: DeleteOutsourcerSalesInput;
};


export type MutationDeletePaymentArgs = {
  input: DeletePaymentInput;
};


export type MutationDeletePaymentTaxAdjustListArgs = {
  input: DeletePaymentTaxAdjustListInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteProductionArgs = {
  input: DeleteProductionInput;
};


export type MutationDeleteReceiveOrderArgs = {
  input: DeleteReceiveOrderInput;
};


export type MutationDeleteReturnReceiveOrderArgs = {
  input: DeleteReturnReceiveOrderInput;
};


export type MutationDeleteReturnSendOrderArgs = {
  input: DeleteReturnSendOrderInput;
};


export type MutationDeleteSendOrderArgs = {
  input: DeleteSendOrderInput;
};


export type MutationDeleteSendOrderLotArgs = {
  input: DeleteSendOrderLotInput;
};


export type MutationDeleteShipmentArgs = {
  input: DeleteShipmentInput;
};


export type MutationDeleteStockAdjustArgs = {
  input: DeleteStockAdjustInput;
};


export type MutationDeleteTrustInventoryArgs = {
  input: DeleteTrustInventoryInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteVendorArgs = {
  input: DeleteVendorInput;
};


export type MutationDeleteWarehouseArgs = {
  input: DeleteWarehouseInput;
};


export type MutationDeleteWarehouseMoveArgs = {
  input: DeleteWarehouseMoveInput;
};


export type MutationDeleteWithdrawalArgs = {
  input: DeleteWithdrawalInput;
};


export type MutationDemandPrintArgs = {
  input: DemandPrintInput;
};


export type MutationEstimatePrintArgs = {
  input: EstimatePrintInput;
};


export type MutationExecuteDeleteReturnProcessReceiveArgs = {
  input: ExecuteDeleteReturnProcessReceiveInput;
};


export type MutationExecuteDemandDecisionDeleteArgs = {
  input: ExecuteDemandDecisionDeleteInput;
};


export type MutationExecuteDemandDecisionReceiveArgs = {
  input: ExecuteDemandDecisionReceiveInput;
};


export type MutationExecutePaymentDecisionDeleteArgs = {
  input: ExecutePaymentDecisionDeleteInput;
};


export type MutationExecutePaymentDecisionSendArgs = {
  input: ExecutePaymentDecisionSendInput;
};


export type MutationExecuteReturnProcessReceiveArgs = {
  input: ExecuteReturnProcessReceiveInput;
};


export type MutationExecuteReturnProcessSendArgs = {
  input: ExecuteReturnProcessSendInput;
};


export type MutationFinalizeInventoryDivisionArgs = {
  input: FinalizeInventoryDivisionInput;
};


export type MutationImportCustomerBudgetArgs = {
  input: ImportCustomerBudgetListInput;
};


export type MutationImportInventoryDetailArgs = {
  input: ImportInventoryDetailInput;
};


export type MutationImportSendOrderRequestArgs = {
  input: ImportSendOrderRequestInput;
};


export type MutationProductImportArgs = {
  input: ProductImportInput;
};


export type MutationReceiveOrderPrintArgs = {
  input: ReceiveOrderPrintInput;
};


export type MutationSaleVoucherPrintArgs = {
  input: SaleVoucherPrintInput;
};


export type MutationSendBackTrustInventoryArgs = {
  input: SendBackTrustInventoryInput;
};


export type MutationSendOrderPrintArgs = {
  input: SendOrderPrintInput;
};


export type MutationSyncFkorderPublicationArgs = {
  input: SyncFkorderPublicationInput;
};


export type MutationSyncFkorderPublicationPreAndPublicArgs = {
  input: SyncFkorderPublicationPreAndPublicInput;
};


export type MutationTrustSalesPrintArgs = {
  input: TrustSaleVoucherPrintInput;
};


export type MutationUpdateArrivalArgs = {
  input: UpdateArrivalInput;
};


export type MutationUpdateComponentArgs = {
  input: UpdateComponentInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerUserArgs = {
  input: UpdateCustomerUserInput;
};


export type MutationUpdateDeliverArgs = {
  input: UpdateDeliverInput;
};


export type MutationUpdateDepositArgs = {
  input: UpdateDepositInput;
};


export type MutationUpdateDivisionArgs = {
  input: UpdateDivisionInput;
};


export type MutationUpdateEstimateArgs = {
  input: UpdateEstimateInput;
};


export type MutationUpdateFkorderInformationArgs = {
  input: UpdateFkorderInformationInput;
};


export type MutationUpdateInventoryArgs = {
  input: UpdateInventoryInput;
};


export type MutationUpdateOutsourcerSalesArgs = {
  input: UpdateOutsourcerSalesInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductGroupArgs = {
  input: UpdateProductGroupInput;
};


export type MutationUpdateProductionArgs = {
  input: UpdateProductionInput;
};


export type MutationUpdateReceiveOrderArgs = {
  input: UpdateReceiveOrderInput;
};


export type MutationUpdateReceiveOrderCorrectionArgs = {
  input: UpdateReceiveOrderCorrectionInput;
};


export type MutationUpdateReceiveOrderSalesUnitPriceArgs = {
  input: UpdateReceiveOrderDetailSalesUnitPriceInput;
};


export type MutationUpdateReceiveOrderStatusCancelArgs = {
  input: UpdateReceiveOrderStatusCancelInput;
};


export type MutationUpdateReceiveOrderStatusConfirmedArgs = {
  input: UpdateReceiveOrderStatusConfirmedInput;
};


export type MutationUpdateReturnReceiveOrderArgs = {
  input: UpdateReturnReceiveOrderInput;
};


export type MutationUpdateReturnSendOrderArgs = {
  input: UpdateReturnSendOrderInput;
};


export type MutationUpdateSendOrderArgs = {
  input: UpdateSendOrderInput;
};


export type MutationUpdateSendOrderApprovalArgs = {
  input: UpdateSendOrderApprovalInput;
};


export type MutationUpdateSendOrderBulkApprovalArgs = {
  input: UpdateSendOrderBulkApprovalInput;
};


export type MutationUpdateSendOrderLotArgs = {
  input: UpdateSendOrderLotInput;
};


export type MutationUpdateSendOrderPurchaseUnitPriceArgs = {
  input: UpdateSendOrderDetailPurchaseUnitPriceInput;
};


export type MutationUpdateSendOrderRemandArgs = {
  input: UpdateSendOrderRemandInput;
};


export type MutationUpdateShipmentArgs = {
  input: UpdateShipmentInput;
};


export type MutationUpdateStockAdjustArgs = {
  input: UpdateStockAdjustInput;
};


export type MutationUpdateTrustInventoryArgs = {
  input: UpdateTrustInventoryInput;
};


export type MutationUpdateTrustInventoryJanUnitArgs = {
  input: UpdateTrustInventoryJanUnitInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVendorArgs = {
  input: UpdateVendorInput;
};


export type MutationUpdateWarehouseArgs = {
  input: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseMoveArgs = {
  input: UpdateWarehouseMoveInput;
};


export type MutationUpdateWarehouseMoveApproveArgs = {
  input: UpdateWarehouseMoveApproveInput;
};


export type MutationUpdateWarehouseMoveRejectArgs = {
  input: UpdateWarehouseMoveRejectInput;
};


export type MutationUpdateWithdrawalArgs = {
  input: UpdateWithdrawalInput;
};


export type MutationUpsertDemandTaxAdjustListArgs = {
  input: UpsertDemandTaxAdjustListInput;
};


export type MutationUpsertPaymentTaxAdjustListArgs = {
  input: UpsertPaymentTaxAdjustListInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  createDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  no?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updateDate?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Notification` and its cursor. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Notification>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PartialQueryByLotGroup = Node & {
  __typename?: 'PartialQueryByLotGroup';
  current?: Maybe<PartialQueryByLotGroupCurrent>;
  currentInitialRemain: Array<Maybe<Scalars['Decimal']>>;
  existsTrade: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  initialOrder: Array<Maybe<Scalars['Decimal']>>;
  initialRemain: Array<Maybe<Scalars['Decimal']>>;
  initialStock: Array<Maybe<Scalars['Decimal']>>;
  productCodes: Array<Maybe<Scalars['String']>>;
  products: Array<Maybe<PartialQueryByLotGroupProduct>>;
  results?: Maybe<PartialQueryByLotGroupResult>;
  terms: Array<Maybe<Scalars['Date']>>;
};

export type PartialQueryByLotGroupCurrent = {
  __typename?: 'PartialQueryByLotGroupCurrent';
  arrivalSum?: Maybe<Array<Maybe<PartialQueryData>>>;
  consumption?: Maybe<Array<Maybe<PartialQueryData>>>;
  sendorder?: Maybe<Array<Maybe<PartialQueryData>>>;
  sendorderRemain?: Maybe<Array<Maybe<PartialQueryData>>>;
  sendorderSum?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentBefore?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentFix?: Maybe<Array<Maybe<PartialQueryData>>>;
  stock?: Maybe<Array<Maybe<PartialQueryData>>>;
};

export type PartialQueryByLotGroupFilter = {
  date: Scalars['Date'];
  lotGroupCode: Scalars['String'];
};

export type PartialQueryByLotGroupProduct = {
  __typename?: 'PartialQueryByLotGroupProduct';
  productCode: Scalars['String'];
  productName: Scalars['String'];
};

export type PartialQueryByLotGroupResult = {
  __typename?: 'PartialQueryByLotGroupResult';
  arrivalP1?: Maybe<Array<Maybe<PartialQueryData>>>;
  arrivalP2?: Maybe<Array<Maybe<PartialQueryData>>>;
  arrivalP3?: Maybe<Array<Maybe<PartialQueryData>>>;
  disposeP1?: Maybe<Array<Maybe<PartialQueryData>>>;
  disposeP2?: Maybe<Array<Maybe<PartialQueryData>>>;
  disposeP3?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentP1?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentP2?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentP3?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentdisposeP1?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentdisposeP2?: Maybe<Array<Maybe<PartialQueryData>>>;
  shipmentdisposeP3?: Maybe<Array<Maybe<PartialQueryData>>>;
};

export type PartialQueryByProduct = Node & {
  __typename?: 'PartialQueryByProduct';
  current: Array<Maybe<PartialQueryData>>;
  currentInitialRemain: Scalars['Decimal'];
  existsTrade: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  initialOrder: Scalars['Decimal'];
  initialRemain: Scalars['Decimal'];
  initialStock: Scalars['Decimal'];
  results: Array<Maybe<PartialQueryData>>;
  terms: Array<Maybe<Scalars['Date']>>;
};

export type PartialQueryByProductFilter = {
  date: Scalars['Date'];
  productCode: Scalars['String'];
};

export type PartialQueryData = Node & {
  __typename?: 'PartialQueryData';
  TM1: Scalars['Decimal'];
  TM2: Scalars['Decimal'];
  TM3: Scalars['Decimal'];
  TM4: Scalars['Decimal'];
  TM5: Scalars['Decimal'];
  TM6: Scalars['Decimal'];
  TM7: Scalars['Decimal'];
  TM8: Scalars['Decimal'];
  TM9: Scalars['Decimal'];
  TM10: Scalars['Decimal'];
  TM11: Scalars['Decimal'];
  TM12: Scalars['Decimal'];
  /** The ID of the object. */
  id: Scalars['ID'];
  label: Scalars['String'];
  productCode: Scalars['String'];
  type: Scalars['String'];
};

export type PayableBalance = Node & {
  __typename?: 'PayableBalance';
  beforePayableBalance?: Maybe<Scalars['Int']>;
  cash?: Maybe<Scalars['Int']>;
  draft?: Maybe<Scalars['Int']>;
  exciseTax8par?: Maybe<Scalars['Int']>;
  exciseTax10par?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  monthBalance?: Maybe<Scalars['Int']>;
  otherPayment?: Maybe<Scalars['Int']>;
  payablePrice?: Maybe<Scalars['Int']>;
  purchasePrice?: Maybe<Scalars['Int']>;
  transfer?: Maybe<Scalars['Int']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorFuri?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type PayableBalanceConnection = {
  __typename?: 'PayableBalanceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PayableBalanceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PayableBalance` and its cursor. */
export type PayableBalanceEdge = {
  __typename?: 'PayableBalanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PayableBalance>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  automaticPayId?: Maybe<Scalars['Int']>;
  automaticWithdrawal?: Maybe<Withdrawal>;
  beforePaymentRemain: Scalars['Float'];
  carryOverPrice: Scalars['Float'];
  closingDate: Scalars['String'];
  closingStatusCode: Scalars['String'];
  closingTriggerId?: Maybe<Scalars['Int']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  currentPaymentExpectRemain: Scalars['Float'];
  currentPaymentExpectRemainWithAdjust: Scalars['Float'];
  currentPaymentPrice?: Maybe<Scalars['Float']>;
  currentTotalImportPrice?: Maybe<Scalars['Float']>;
  currentTotalProgressPrice?: Maybe<Scalars['Float']>;
  currentTotalPurchasePrice?: Maybe<Scalars['Float']>;
  currentTransferPrice?: Maybe<Scalars['Float']>;
  depositPrice?: Maybe<Scalars['Float']>;
  differencePrice?: Maybe<Scalars['Float']>;
  exciseTaxTotal: Scalars['Float'];
  excludingTaxTotalPaymentPrice: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  includedTaxPaymentClearingPrice: Scalars['Float'];
  includedTaxTotalPaymentPrice: Scalars['Float'];
  includedTaxTotalPaymentPriceWithAdjust: Scalars['Float'];
  offsetPrice?: Maybe<Scalars['Float']>;
  payPriceTotalInAccountMonth: Scalars['Float'];
  paymentDate: Scalars['String'];
  paymentExpectedDate: Scalars['String'];
  paymentId: Scalars['ID'];
  paymentMemo?: Maybe<Scalars['String']>;
  paymentTaxAdjustDetails?: Maybe<PaymentTaxAdjustDetailConnection>;
  paymentTaxDetails?: Maybe<PaymentTaxDetailConnection>;
  transferFee?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode: Scalars['String'];
  vendorTaxType: Scalars['String'];
  versionUuid: Scalars['String'];
  withdrawalState: Scalars['String'];
};


export type PaymentPaymentTaxAdjustDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PaymentPaymentTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaymentDivision = Node & {
  __typename?: 'PaymentDivision';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  paymentDivisionCode: Scalars['String'];
  paymentDivisionName: Scalars['String'];
  paymentGroupCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type PaymentDivisionConnection = {
  __typename?: 'PaymentDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PaymentDivision` and its cursor. */
export type PaymentDivisionEdge = {
  __typename?: 'PaymentDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentDivision>;
};

/** An enumeration. */
export enum PaymentDivisionSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  PaymentDivisionCodeAsc = 'PAYMENT_DIVISION_CODE_ASC',
  PaymentDivisionCodeDesc = 'PAYMENT_DIVISION_CODE_DESC',
  PaymentDivisionNameAsc = 'PAYMENT_DIVISION_NAME_ASC',
  PaymentDivisionNameDesc = 'PAYMENT_DIVISION_NAME_DESC',
  PaymentGroupCodeAsc = 'PAYMENT_GROUP_CODE_ASC',
  PaymentGroupCodeDesc = 'PAYMENT_GROUP_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Payment` and its cursor. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Payment>;
};

/** An enumeration. */
export enum PaymentSortEnum {
  AutomaticPayIdAsc = 'AUTOMATIC_PAY_ID_ASC',
  AutomaticPayIdDesc = 'AUTOMATIC_PAY_ID_DESC',
  BeforePaymentRemainAsc = 'BEFORE_PAYMENT_REMAIN_ASC',
  BeforePaymentRemainDesc = 'BEFORE_PAYMENT_REMAIN_DESC',
  CarryOverPriceAsc = 'CARRY_OVER_PRICE_ASC',
  CarryOverPriceDesc = 'CARRY_OVER_PRICE_DESC',
  ClosingDateAsc = 'CLOSING_DATE_ASC',
  ClosingDateDesc = 'CLOSING_DATE_DESC',
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  ClosingTriggerIdAsc = 'CLOSING_TRIGGER_ID_ASC',
  ClosingTriggerIdDesc = 'CLOSING_TRIGGER_ID_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CurrentPaymentExpectRemainAsc = 'CURRENT_PAYMENT_EXPECT_REMAIN_ASC',
  CurrentPaymentExpectRemainDesc = 'CURRENT_PAYMENT_EXPECT_REMAIN_DESC',
  CurrentPaymentExpectRemainWithAdjustAsc = 'CURRENT_PAYMENT_EXPECT_REMAIN_WITH_ADJUST_ASC',
  CurrentPaymentExpectRemainWithAdjustDesc = 'CURRENT_PAYMENT_EXPECT_REMAIN_WITH_ADJUST_DESC',
  CurrentPaymentPriceAsc = 'CURRENT_PAYMENT_PRICE_ASC',
  CurrentPaymentPriceDesc = 'CURRENT_PAYMENT_PRICE_DESC',
  CurrentTotalImportPriceAsc = 'CURRENT_TOTAL_IMPORT_PRICE_ASC',
  CurrentTotalImportPriceDesc = 'CURRENT_TOTAL_IMPORT_PRICE_DESC',
  CurrentTotalProgressPriceAsc = 'CURRENT_TOTAL_PROGRESS_PRICE_ASC',
  CurrentTotalProgressPriceDesc = 'CURRENT_TOTAL_PROGRESS_PRICE_DESC',
  CurrentTotalPurchasePriceAsc = 'CURRENT_TOTAL_PURCHASE_PRICE_ASC',
  CurrentTotalPurchasePriceDesc = 'CURRENT_TOTAL_PURCHASE_PRICE_DESC',
  CurrentTransferPriceAsc = 'CURRENT_TRANSFER_PRICE_ASC',
  CurrentTransferPriceDesc = 'CURRENT_TRANSFER_PRICE_DESC',
  DepositPriceAsc = 'DEPOSIT_PRICE_ASC',
  DepositPriceDesc = 'DEPOSIT_PRICE_DESC',
  DifferencePriceAsc = 'DIFFERENCE_PRICE_ASC',
  DifferencePriceDesc = 'DIFFERENCE_PRICE_DESC',
  ExciseTaxTotalAsc = 'EXCISE_TAX_TOTAL_ASC',
  ExciseTaxTotalDesc = 'EXCISE_TAX_TOTAL_DESC',
  ExcludingTaxTotalPaymentPriceAsc = 'EXCLUDING_TAX_TOTAL_PAYMENT_PRICE_ASC',
  ExcludingTaxTotalPaymentPriceDesc = 'EXCLUDING_TAX_TOTAL_PAYMENT_PRICE_DESC',
  IncludedTaxPaymentClearingPriceAsc = 'INCLUDED_TAX_PAYMENT_CLEARING_PRICE_ASC',
  IncludedTaxPaymentClearingPriceDesc = 'INCLUDED_TAX_PAYMENT_CLEARING_PRICE_DESC',
  IncludedTaxTotalPaymentPriceAsc = 'INCLUDED_TAX_TOTAL_PAYMENT_PRICE_ASC',
  IncludedTaxTotalPaymentPriceDesc = 'INCLUDED_TAX_TOTAL_PAYMENT_PRICE_DESC',
  IncludedTaxTotalPaymentPriceWithAdjustAsc = 'INCLUDED_TAX_TOTAL_PAYMENT_PRICE_WITH_ADJUST_ASC',
  IncludedTaxTotalPaymentPriceWithAdjustDesc = 'INCLUDED_TAX_TOTAL_PAYMENT_PRICE_WITH_ADJUST_DESC',
  OffsetPriceAsc = 'OFFSET_PRICE_ASC',
  OffsetPriceDesc = 'OFFSET_PRICE_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC',
  PaymentExpectedDateAsc = 'PAYMENT_EXPECTED_DATE_ASC',
  PaymentExpectedDateDesc = 'PAYMENT_EXPECTED_DATE_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PaymentMemoAsc = 'PAYMENT_MEMO_ASC',
  PaymentMemoDesc = 'PAYMENT_MEMO_DESC',
  PayPriceTotalInAccountMonthAsc = 'PAY_PRICE_TOTAL_IN_ACCOUNT_MONTH_ASC',
  PayPriceTotalInAccountMonthDesc = 'PAY_PRICE_TOTAL_IN_ACCOUNT_MONTH_DESC',
  TransferFeeAsc = 'TRANSFER_FEE_ASC',
  TransferFeeDesc = 'TRANSFER_FEE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VendorTaxTypeAsc = 'VENDOR_TAX_TYPE_ASC',
  VendorTaxTypeDesc = 'VENDOR_TAX_TYPE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WithdrawalStateAsc = 'WITHDRAWAL_STATE_ASC',
  WithdrawalStateDesc = 'WITHDRAWAL_STATE_DESC'
}

export type PaymentTaxAdjustDetail = Node & {
  __typename?: 'PaymentTaxAdjustDetail';
  adjust?: Maybe<Scalars['Float']>;
  afterAdjustExciseTax?: Maybe<Scalars['Float']>;
  beforeAdjustExciseTax?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  payment?: Maybe<Payment>;
  paymentId: Scalars['ID'];
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type PaymentTaxAdjustDetailConnection = {
  __typename?: 'PaymentTaxAdjustDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTaxAdjustDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PaymentTaxAdjustDetail` and its cursor. */
export type PaymentTaxAdjustDetailEdge = {
  __typename?: 'PaymentTaxAdjustDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentTaxAdjustDetail>;
};

/** An enumeration. */
export enum PaymentTaxAdjustDetailSortEnum {
  AdjustAsc = 'ADJUST_ASC',
  AdjustDesc = 'ADJUST_DESC',
  AfterAdjustExciseTaxAsc = 'AFTER_ADJUST_EXCISE_TAX_ASC',
  AfterAdjustExciseTaxDesc = 'AFTER_ADJUST_EXCISE_TAX_DESC',
  BeforeAdjustExciseTaxAsc = 'BEFORE_ADJUST_EXCISE_TAX_ASC',
  BeforeAdjustExciseTaxDesc = 'BEFORE_ADJUST_EXCISE_TAX_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type PaymentTaxDetail = Node & {
  __typename?: 'PaymentTaxDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  exciseTax?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  payment?: Maybe<Payment>;
  paymentId: Scalars['ID'];
  taxExcluded?: Maybe<Scalars['Float']>;
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type PaymentTaxDetailConnection = {
  __typename?: 'PaymentTaxDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTaxDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PaymentTaxDetail` and its cursor. */
export type PaymentTaxDetailEdge = {
  __typename?: 'PaymentTaxDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentTaxDetail>;
};

/** An enumeration. */
export enum PaymentTaxDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  ExciseTaxAsc = 'EXCISE_TAX_ASC',
  ExciseTaxDesc = 'EXCISE_TAX_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TaxExcludedAsc = 'TAX_EXCLUDED_ASC',
  TaxExcludedDesc = 'TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type PlanningUser = Node & {
  __typename?: 'PlanningUser';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  planningUserCode: Scalars['String'];
  planningUserName: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type PlanningUserConnection = {
  __typename?: 'PlanningUserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PlanningUserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PlanningUser` and its cursor. */
export type PlanningUserEdge = {
  __typename?: 'PlanningUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PlanningUser>;
};

/** An enumeration. */
export enum PlanningUserSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  PlanningUserCodeAsc = 'PLANNING_USER_CODE_ASC',
  PlanningUserCodeDesc = 'PLANNING_USER_CODE_DESC',
  PlanningUserNameAsc = 'PLANNING_USER_NAME_ASC',
  PlanningUserNameDesc = 'PLANNING_USER_NAME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Printer = Node & {
  __typename?: 'Printer';
  description?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  localPrinter?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pdlList?: Maybe<Scalars['String']>;
  preferences?: Maybe<Scalars['String']>;
  printerId?: Maybe<Scalars['String']>;
  reachable?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateUpdated?: Maybe<Scalars['String']>;
  trays?: Maybe<Array<Maybe<Tray>>>;
};

export type Product = Node & {
  __typename?: 'Product';
  clothGroup?: Maybe<Scalars['String']>;
  componentDivision?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  designUserCode?: Maybe<Scalars['String']>;
  domOverFlg?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryControlFlg?: Maybe<Scalars['String']>;
  janCode: Scalars['String'];
  manufacturer?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  noRepeatDate?: Maybe<Scalars['DateTime']>;
  notIncludedSku: Scalars['String'];
  planningUserCode?: Maybe<Scalars['String']>;
  productFuri?: Maybe<Scalars['String']>;
  productGroup1?: Maybe<ProductGroup>;
  productGroup2?: Maybe<ProductGroup>;
  productGroup3?: Maybe<ProductGroup>;
  productGroupId1?: Maybe<Scalars['Int']>;
  productGroupId2?: Maybe<Scalars['Int']>;
  productGroupId3?: Maybe<Scalars['Int']>;
  productName: Scalars['String'];
  productPrice?: Maybe<ProductPriceConnection>;
  productVariants?: Maybe<ProductVariantConnection>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  purchaseUnitPriceYenUpdFlg: Scalars['String'];
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderLot?: Maybe<Scalars['Int']>;
  salesUnitPriceUpdFlg: Scalars['String'];
  tags?: Maybe<Scalars['JSONString']>;
  taxDivision?: Maybe<TaxDivision>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  wideUseFlg: Scalars['String'];
};


export type ProductProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Product` and its cursor. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Product>;
};

export type ProductGroup = Node & {
  __typename?: 'ProductGroup';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  productGroupCode: Scalars['String'];
  productGroupId: Scalars['ID'];
  productGroupName: Scalars['String'];
  productGrouptypeCode: Scalars['String'];
  publicationOption?: Maybe<Scalars['String']>;
  publicationScope?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ProductGroupConnection = {
  __typename?: 'ProductGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductGroup` and its cursor. */
export type ProductGroupEdge = {
  __typename?: 'ProductGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductGroup>;
};

/** An enumeration. */
export enum ProductGroupSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  ProductGrouptypeCodeAsc = 'PRODUCT_GROUPTYPE_CODE_ASC',
  ProductGrouptypeCodeDesc = 'PRODUCT_GROUPTYPE_CODE_DESC',
  ProductGroupCodeAsc = 'PRODUCT_GROUP_CODE_ASC',
  ProductGroupCodeDesc = 'PRODUCT_GROUP_CODE_DESC',
  ProductGroupIdAsc = 'PRODUCT_GROUP_ID_ASC',
  ProductGroupIdDesc = 'PRODUCT_GROUP_ID_DESC',
  ProductGroupNameAsc = 'PRODUCT_GROUP_NAME_ASC',
  ProductGroupNameDesc = 'PRODUCT_GROUP_NAME_DESC',
  PublicationOptionAsc = 'PUBLICATION_OPTION_ASC',
  PublicationOptionDesc = 'PUBLICATION_OPTION_DESC',
  PublicationScopeAsc = 'PUBLICATION_SCOPE_ASC',
  PublicationScopeDesc = 'PUBLICATION_SCOPE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ProductHistory = Node & {
  __typename?: 'ProductHistory';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productBaseHistoryId: Scalars['ID'];
  productName?: Maybe<Scalars['String']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  uniqueCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type ProductHistoryConnection = {
  __typename?: 'ProductHistoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductHistoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductHistory` and its cursor. */
export type ProductHistoryEdge = {
  __typename?: 'ProductHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductHistory>;
};

/** An enumeration. */
export enum ProductHistorySortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  ProductBaseHistoryIdAsc = 'PRODUCT_BASE_HISTORY_ID_ASC',
  ProductBaseHistoryIdDesc = 'PRODUCT_BASE_HISTORY_ID_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ProductImportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clothGroup?: InputMaybe<Scalars['String']>;
  componentDivision?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  designUserCode?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  inventoryControlFlg?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  manufacturer?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxPurchaseOrderQty?: InputMaybe<Scalars['Int']>;
  notIncludedSku?: InputMaybe<Scalars['String']>;
  planningUserCode?: InputMaybe<Scalars['String']>;
  priceUpdateFlg?: InputMaybe<Scalars['Boolean']>;
  productFuri?: InputMaybe<Scalars['String']>;
  productGroupCode1?: InputMaybe<Scalars['Int']>;
  productGroupCode2?: InputMaybe<Scalars['Int']>;
  productGroupCode3?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
  productPrices?: InputMaybe<Array<InputMaybe<ProductPriceImport>>>;
  productVariants?: InputMaybe<Array<InputMaybe<ProductVariantImport>>>;
  purchaseOrderLeadTime?: InputMaybe<Scalars['Int']>;
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Decimal']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Decimal']>;
  quantityDecimalDigits?: InputMaybe<Scalars['Int']>;
  receiveOrderLot?: InputMaybe<Scalars['Int']>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  salesUnitPrice?: InputMaybe<Scalars['Decimal']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  unitCode?: InputMaybe<Scalars['String']>;
  unitDollarDecimalDigits?: InputMaybe<Scalars['Int']>;
  unitYenDecimalDigits?: InputMaybe<Scalars['Int']>;
  updateType?: InputMaybe<ProductListUpdateType>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type ProductImportPayload = {
  __typename?: 'ProductImportPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

export enum ProductListUpdateType {
  Delete = 'DELETE',
  Deleteprice = 'DELETEPRICE',
  Insert = 'INSERT',
  None = 'NONE',
  Update = 'UPDATE'
}

export type ProductListView = Node & {
  __typename?: 'ProductListView';
  allRemainReceiveQuantity?: Maybe<Scalars['Float']>;
  attr1?: Maybe<Scalars['String']>;
  attr2?: Maybe<Scalars['String']>;
  attrNo: Scalars['Int'];
  attributeName?: Maybe<Scalars['String']>;
  baseStockQuantity?: Maybe<Scalars['Int']>;
  branchNumber: Scalars['Int'];
  clothGroup?: Maybe<Scalars['String']>;
  componentDivision?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  designUser?: Maybe<DesignUser>;
  designUserCode?: Maybe<Scalars['String']>;
  discontinueFlg?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: Maybe<Scalars['Int']>;
  domOverFlg?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endOfSalesDate?: Maybe<Scalars['String']>;
  fcCode1?: Maybe<Scalars['String']>;
  fcCode2?: Maybe<Scalars['String']>;
  fcCode3?: Maybe<Scalars['String']>;
  fcCodeBranchNumber1?: Maybe<Scalars['String']>;
  fcCodeBranchNumber2?: Maybe<Scalars['String']>;
  fcCodeBranchNumber3?: Maybe<Scalars['String']>;
  firstArrivalDate?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  innerCartonSize?: Maybe<Scalars['String']>;
  innerCartonUnit?: Maybe<Scalars['Int']>;
  innerCartonWeight?: Maybe<Scalars['String']>;
  inventoryControlFlg?: Maybe<Scalars['String']>;
  janCode: Scalars['String'];
  lotGroupCode?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  minimumLot?: Maybe<Scalars['Int']>;
  notIncludedSku: Scalars['String'];
  outerCartonDept?: Maybe<Scalars['Float']>;
  outerCartonHeight?: Maybe<Scalars['Float']>;
  outerCartonSize?: Maybe<Scalars['String']>;
  outerCartonUnit?: Maybe<Scalars['Int']>;
  outerCartonWeight?: Maybe<Scalars['String']>;
  outerCartonWidth?: Maybe<Scalars['Float']>;
  planningUser?: Maybe<PlanningUser>;
  planningUserCode?: Maybe<Scalars['String']>;
  productAttrMemo?: Maybe<Scalars['String']>;
  productBodySize?: Maybe<Scalars['String']>;
  productBodyWeight?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productFuri?: Maybe<Scalars['String']>;
  productGroup1?: Maybe<ProductGroup>;
  productGroup2?: Maybe<ProductGroup>;
  productGroup3?: Maybe<ProductGroup>;
  productGroupId1?: Maybe<Scalars['Int']>;
  productGroupId2?: Maybe<Scalars['Int']>;
  productGroupId3?: Maybe<Scalars['Int']>;
  productImage1?: Maybe<Scalars['String']>;
  productImage2?: Maybe<Scalars['String']>;
  productImage3?: Maybe<Scalars['String']>;
  productImage4?: Maybe<Scalars['String']>;
  productImage5?: Maybe<Scalars['String']>;
  productImage6?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productPackageSize?: Maybe<Scalars['String']>;
  productPackageWeight?: Maybe<Scalars['String']>;
  productPrice?: Maybe<ProductPriceConnection>;
  publicationOption?: Maybe<Scalars['String']>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  purchaseOrderStandardStock?: Maybe<Scalars['Int']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderLot?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
  startDate?: Maybe<Scalars['String']>;
  stock?: Maybe<Stock>;
  stockByDivisions?: Maybe<Array<Maybe<StockByDivision>>>;
  stockByWarehouses?: Maybe<Array<Maybe<StockByWarehouse>>>;
  tags?: Maybe<Scalars['JSONString']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  wideUseFlg: Scalars['String'];
};


export type ProductListViewProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductListViewConnection = {
  __typename?: 'ProductListViewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductListViewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductListView` and its cursor. */
export type ProductListViewEdge = {
  __typename?: 'ProductListViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductListView>;
};

/** An enumeration. */
export enum ProductListViewSortEnum {
  Attr1Asc = 'ATTR1_ASC',
  Attr1Desc = 'ATTR1_DESC',
  Attr2Asc = 'ATTR2_ASC',
  Attr2Desc = 'ATTR2_DESC',
  AttributeNameAsc = 'ATTRIBUTE_NAME_ASC',
  AttributeNameDesc = 'ATTRIBUTE_NAME_DESC',
  AttrNoAsc = 'ATTR_NO_ASC',
  AttrNoDesc = 'ATTR_NO_DESC',
  BaseStockQuantityAsc = 'BASE_STOCK_QUANTITY_ASC',
  BaseStockQuantityDesc = 'BASE_STOCK_QUANTITY_DESC',
  BranchNumberAsc = 'BRANCH_NUMBER_ASC',
  BranchNumberDesc = 'BRANCH_NUMBER_DESC',
  ClothGroupAsc = 'CLOTH_GROUP_ASC',
  ClothGroupDesc = 'CLOTH_GROUP_DESC',
  ComponentDivisionAsc = 'COMPONENT_DIVISION_ASC',
  ComponentDivisionDesc = 'COMPONENT_DIVISION_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DesignUserCodeAsc = 'DESIGN_USER_CODE_ASC',
  DesignUserCodeDesc = 'DESIGN_USER_CODE_DESC',
  DiscontinueFlgAsc = 'DISCONTINUE_FLG_ASC',
  DiscontinueFlgDesc = 'DISCONTINUE_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  DivisionStandardStockAsc = 'DIVISION_STANDARD_STOCK_ASC',
  DivisionStandardStockDesc = 'DIVISION_STANDARD_STOCK_DESC',
  DomOverFlgAsc = 'DOM_OVER_FLG_ASC',
  DomOverFlgDesc = 'DOM_OVER_FLG_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  EndOfSalesDateAsc = 'END_OF_SALES_DATE_ASC',
  EndOfSalesDateDesc = 'END_OF_SALES_DATE_DESC',
  FcCode1Asc = 'FC_CODE1_ASC',
  FcCode1Desc = 'FC_CODE1_DESC',
  FcCode2Asc = 'FC_CODE2_ASC',
  FcCode2Desc = 'FC_CODE2_DESC',
  FcCode3Asc = 'FC_CODE3_ASC',
  FcCode3Desc = 'FC_CODE3_DESC',
  FcCodeBranchNumber1Asc = 'FC_CODE_BRANCH_NUMBER1_ASC',
  FcCodeBranchNumber1Desc = 'FC_CODE_BRANCH_NUMBER1_DESC',
  FcCodeBranchNumber2Asc = 'FC_CODE_BRANCH_NUMBER2_ASC',
  FcCodeBranchNumber2Desc = 'FC_CODE_BRANCH_NUMBER2_DESC',
  FcCodeBranchNumber3Asc = 'FC_CODE_BRANCH_NUMBER3_ASC',
  FcCodeBranchNumber3Desc = 'FC_CODE_BRANCH_NUMBER3_DESC',
  FirstArrivalDateAsc = 'FIRST_ARRIVAL_DATE_ASC',
  FirstArrivalDateDesc = 'FIRST_ARRIVAL_DATE_DESC',
  InnerCartonSizeAsc = 'INNER_CARTON_SIZE_ASC',
  InnerCartonSizeDesc = 'INNER_CARTON_SIZE_DESC',
  InnerCartonUnitAsc = 'INNER_CARTON_UNIT_ASC',
  InnerCartonUnitDesc = 'INNER_CARTON_UNIT_DESC',
  InnerCartonWeightAsc = 'INNER_CARTON_WEIGHT_ASC',
  InnerCartonWeightDesc = 'INNER_CARTON_WEIGHT_DESC',
  InventoryControlFlgAsc = 'INVENTORY_CONTROL_FLG_ASC',
  InventoryControlFlgDesc = 'INVENTORY_CONTROL_FLG_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  LotGroupCodeAsc = 'LOT_GROUP_CODE_ASC',
  LotGroupCodeDesc = 'LOT_GROUP_CODE_DESC',
  ManufacturerAsc = 'MANUFACTURER_ASC',
  ManufacturerDesc = 'MANUFACTURER_DESC',
  MaterialAsc = 'MATERIAL_ASC',
  MaterialDesc = 'MATERIAL_DESC',
  MaxPurchaseOrderQtyAsc = 'MAX_PURCHASE_ORDER_QTY_ASC',
  MaxPurchaseOrderQtyDesc = 'MAX_PURCHASE_ORDER_QTY_DESC',
  MinimumLotAsc = 'MINIMUM_LOT_ASC',
  MinimumLotDesc = 'MINIMUM_LOT_DESC',
  NotIncludedSkuAsc = 'NOT_INCLUDED_SKU_ASC',
  NotIncludedSkuDesc = 'NOT_INCLUDED_SKU_DESC',
  OuterCartonDeptAsc = 'OUTER_CARTON_DEPT_ASC',
  OuterCartonDeptDesc = 'OUTER_CARTON_DEPT_DESC',
  OuterCartonHeightAsc = 'OUTER_CARTON_HEIGHT_ASC',
  OuterCartonHeightDesc = 'OUTER_CARTON_HEIGHT_DESC',
  OuterCartonSizeAsc = 'OUTER_CARTON_SIZE_ASC',
  OuterCartonSizeDesc = 'OUTER_CARTON_SIZE_DESC',
  OuterCartonUnitAsc = 'OUTER_CARTON_UNIT_ASC',
  OuterCartonUnitDesc = 'OUTER_CARTON_UNIT_DESC',
  OuterCartonWeightAsc = 'OUTER_CARTON_WEIGHT_ASC',
  OuterCartonWeightDesc = 'OUTER_CARTON_WEIGHT_DESC',
  OuterCartonWidthAsc = 'OUTER_CARTON_WIDTH_ASC',
  OuterCartonWidthDesc = 'OUTER_CARTON_WIDTH_DESC',
  PlanningUserCodeAsc = 'PLANNING_USER_CODE_ASC',
  PlanningUserCodeDesc = 'PLANNING_USER_CODE_DESC',
  ProductAttrMemoAsc = 'PRODUCT_ATTR_MEMO_ASC',
  ProductAttrMemoDesc = 'PRODUCT_ATTR_MEMO_DESC',
  ProductBodySizeAsc = 'PRODUCT_BODY_SIZE_ASC',
  ProductBodySizeDesc = 'PRODUCT_BODY_SIZE_DESC',
  ProductBodyWeightAsc = 'PRODUCT_BODY_WEIGHT_ASC',
  ProductBodyWeightDesc = 'PRODUCT_BODY_WEIGHT_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductFuriAsc = 'PRODUCT_FURI_ASC',
  ProductFuriDesc = 'PRODUCT_FURI_DESC',
  ProductGroupId1Asc = 'PRODUCT_GROUP_ID1_ASC',
  ProductGroupId1Desc = 'PRODUCT_GROUP_ID1_DESC',
  ProductGroupId2Asc = 'PRODUCT_GROUP_ID2_ASC',
  ProductGroupId2Desc = 'PRODUCT_GROUP_ID2_DESC',
  ProductGroupId3Asc = 'PRODUCT_GROUP_ID3_ASC',
  ProductGroupId3Desc = 'PRODUCT_GROUP_ID3_DESC',
  ProductImage_1Asc = 'PRODUCT_IMAGE_1_ASC',
  ProductImage_1Desc = 'PRODUCT_IMAGE_1_DESC',
  ProductImage_2Asc = 'PRODUCT_IMAGE_2_ASC',
  ProductImage_2Desc = 'PRODUCT_IMAGE_2_DESC',
  ProductImage_3Asc = 'PRODUCT_IMAGE_3_ASC',
  ProductImage_3Desc = 'PRODUCT_IMAGE_3_DESC',
  ProductImage_4Asc = 'PRODUCT_IMAGE_4_ASC',
  ProductImage_4Desc = 'PRODUCT_IMAGE_4_DESC',
  ProductImage_5Asc = 'PRODUCT_IMAGE_5_ASC',
  ProductImage_5Desc = 'PRODUCT_IMAGE_5_DESC',
  ProductImage_6Asc = 'PRODUCT_IMAGE_6_ASC',
  ProductImage_6Desc = 'PRODUCT_IMAGE_6_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ProductPackageSizeAsc = 'PRODUCT_PACKAGE_SIZE_ASC',
  ProductPackageSizeDesc = 'PRODUCT_PACKAGE_SIZE_DESC',
  ProductPackageWeightAsc = 'PRODUCT_PACKAGE_WEIGHT_ASC',
  ProductPackageWeightDesc = 'PRODUCT_PACKAGE_WEIGHT_DESC',
  PublicationOptionAsc = 'PUBLICATION_OPTION_ASC',
  PublicationOptionDesc = 'PUBLICATION_OPTION_DESC',
  PurchaseOrderLeadTimeAsc = 'PURCHASE_ORDER_LEAD_TIME_ASC',
  PurchaseOrderLeadTimeDesc = 'PURCHASE_ORDER_LEAD_TIME_DESC',
  PurchaseOrderStandardStockAsc = 'PURCHASE_ORDER_STANDARD_STOCK_ASC',
  PurchaseOrderStandardStockDesc = 'PURCHASE_ORDER_STANDARD_STOCK_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  QuantityDecimalDigitsAsc = 'QUANTITY_DECIMAL_DIGITS_ASC',
  QuantityDecimalDigitsDesc = 'QUANTITY_DECIMAL_DIGITS_DESC',
  ReceiveOrderLotAsc = 'RECEIVE_ORDER_LOT_ASC',
  ReceiveOrderLotDesc = 'RECEIVE_ORDER_LOT_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UnitCodeAsc = 'UNIT_CODE_ASC',
  UnitCodeDesc = 'UNIT_CODE_DESC',
  UnitDollarDecimalDigitsAsc = 'UNIT_DOLLAR_DECIMAL_DIGITS_ASC',
  UnitDollarDecimalDigitsDesc = 'UNIT_DOLLAR_DECIMAL_DIGITS_DESC',
  UnitYenDecimalDigitsAsc = 'UNIT_YEN_DECIMAL_DIGITS_ASC',
  UnitYenDecimalDigitsDesc = 'UNIT_YEN_DECIMAL_DIGITS_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WideUseFlgAsc = 'WIDE_USE_FLG_ASC',
  WideUseFlgDesc = 'WIDE_USE_FLG_DESC'
}

export type ProductNoPriceView = Node & {
  __typename?: 'ProductNoPriceView';
  allRemainReceiveQuantity?: Maybe<Scalars['Float']>;
  attr1?: Maybe<Scalars['String']>;
  attr2?: Maybe<Scalars['String']>;
  attrNo: Scalars['Int'];
  attributeName?: Maybe<Scalars['String']>;
  branchNumber: Scalars['Int'];
  clothGroup?: Maybe<Scalars['String']>;
  componentDivision?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  designUser?: Maybe<DesignUser>;
  designUserCode?: Maybe<Scalars['String']>;
  discontinueFlg?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: Maybe<Scalars['Int']>;
  domOverFlg?: Maybe<Scalars['String']>;
  dyProductPrice?: Maybe<ProductPriceConnection>;
  endOfSalesDate?: Maybe<Scalars['String']>;
  fcCode1?: Maybe<Scalars['String']>;
  fcCode2?: Maybe<Scalars['String']>;
  fcCode3?: Maybe<Scalars['String']>;
  fcCodeBranchNumber1?: Maybe<Scalars['String']>;
  fcCodeBranchNumber2?: Maybe<Scalars['String']>;
  fcCodeBranchNumber3?: Maybe<Scalars['String']>;
  firstArrivalDate?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  innerCartonSize?: Maybe<Scalars['String']>;
  innerCartonUnit?: Maybe<Scalars['Int']>;
  innerCartonWeight?: Maybe<Scalars['String']>;
  inventoryControlFlg?: Maybe<Scalars['String']>;
  janCode: Scalars['String'];
  lotGroupCode?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  minimumLot?: Maybe<Scalars['Int']>;
  notIncludedSku: Scalars['String'];
  outerCartonDept?: Maybe<Scalars['Float']>;
  outerCartonHeight?: Maybe<Scalars['Float']>;
  outerCartonSize?: Maybe<Scalars['String']>;
  outerCartonUnit?: Maybe<Scalars['Int']>;
  outerCartonWeight?: Maybe<Scalars['String']>;
  outerCartonWidth?: Maybe<Scalars['Float']>;
  planningUser?: Maybe<PlanningUser>;
  planningUserCode?: Maybe<Scalars['String']>;
  productAttrMemo?: Maybe<Scalars['String']>;
  productBodySize?: Maybe<Scalars['String']>;
  productBodyWeight?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productFuri?: Maybe<Scalars['String']>;
  productGroup1?: Maybe<ProductGroup>;
  productGroup2?: Maybe<ProductGroup>;
  productGroup3?: Maybe<ProductGroup>;
  productGroupId1?: Maybe<Scalars['Int']>;
  productGroupId2?: Maybe<Scalars['Int']>;
  productGroupId3?: Maybe<Scalars['Int']>;
  productImage1?: Maybe<Scalars['String']>;
  productImage2?: Maybe<Scalars['String']>;
  productImage3?: Maybe<Scalars['String']>;
  productImage4?: Maybe<Scalars['String']>;
  productImage5?: Maybe<Scalars['String']>;
  productImage6?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productPackageSize?: Maybe<Scalars['String']>;
  productPackageWeight?: Maybe<Scalars['String']>;
  productPrice?: Maybe<ProductPriceConnection>;
  publicationOption?: Maybe<Scalars['String']>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  purchaseOrderStandardStock?: Maybe<Scalars['Int']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderLot?: Maybe<Scalars['Int']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
  stock?: Maybe<Stock>;
  stockByDivisions?: Maybe<Array<Maybe<StockByDivision>>>;
  stockByWarehouses?: Maybe<Array<Maybe<StockByWarehouse>>>;
  tags?: Maybe<Scalars['JSONString']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  wideUseFlg: Scalars['String'];
};


export type ProductNoPriceViewDyProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductNoPriceViewProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductPrice = Node & {
  __typename?: 'ProductPrice';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  endDate: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  startDate: Scalars['String'];
  uniqueCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ProductPriceConnection = {
  __typename?: 'ProductPriceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductPriceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductPrice` and its cursor. */
export type ProductPriceEdge = {
  __typename?: 'ProductPriceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductPrice>;
};

export type ProductPriceImport = {
  endDate?: InputMaybe<Scalars['Date']>;
  productCode?: InputMaybe<Scalars['String']>;
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Decimal']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Decimal']>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  salesUnitPrice?: InputMaybe<Scalars['Decimal']>;
  startDate: Scalars['Date'];
  updateType?: InputMaybe<ProductListUpdateType>;
};

/** An enumeration. */
export enum ProductPriceSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** An enumeration. */
export enum ProductSortEnum {
  ClothGroupAsc = 'CLOTH_GROUP_ASC',
  ClothGroupDesc = 'CLOTH_GROUP_DESC',
  ComponentDivisionAsc = 'COMPONENT_DIVISION_ASC',
  ComponentDivisionDesc = 'COMPONENT_DIVISION_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DesignUserCodeAsc = 'DESIGN_USER_CODE_ASC',
  DesignUserCodeDesc = 'DESIGN_USER_CODE_DESC',
  DomOverFlgAsc = 'DOM_OVER_FLG_ASC',
  DomOverFlgDesc = 'DOM_OVER_FLG_DESC',
  InventoryControlFlgAsc = 'INVENTORY_CONTROL_FLG_ASC',
  InventoryControlFlgDesc = 'INVENTORY_CONTROL_FLG_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  ManufacturerAsc = 'MANUFACTURER_ASC',
  ManufacturerDesc = 'MANUFACTURER_DESC',
  MaterialAsc = 'MATERIAL_ASC',
  MaterialDesc = 'MATERIAL_DESC',
  MaxPurchaseOrderQtyAsc = 'MAX_PURCHASE_ORDER_QTY_ASC',
  MaxPurchaseOrderQtyDesc = 'MAX_PURCHASE_ORDER_QTY_DESC',
  NotIncludedSkuAsc = 'NOT_INCLUDED_SKU_ASC',
  NotIncludedSkuDesc = 'NOT_INCLUDED_SKU_DESC',
  NoRepeatDateAsc = 'NO_REPEAT_DATE_ASC',
  NoRepeatDateDesc = 'NO_REPEAT_DATE_DESC',
  PlanningUserCodeAsc = 'PLANNING_USER_CODE_ASC',
  PlanningUserCodeDesc = 'PLANNING_USER_CODE_DESC',
  ProductFuriAsc = 'PRODUCT_FURI_ASC',
  ProductFuriDesc = 'PRODUCT_FURI_DESC',
  ProductGroupId1Asc = 'PRODUCT_GROUP_ID1_ASC',
  ProductGroupId1Desc = 'PRODUCT_GROUP_ID1_DESC',
  ProductGroupId2Asc = 'PRODUCT_GROUP_ID2_ASC',
  ProductGroupId2Desc = 'PRODUCT_GROUP_ID2_DESC',
  ProductGroupId3Asc = 'PRODUCT_GROUP_ID3_ASC',
  ProductGroupId3Desc = 'PRODUCT_GROUP_ID3_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  PurchaseOrderLeadTimeAsc = 'PURCHASE_ORDER_LEAD_TIME_ASC',
  PurchaseOrderLeadTimeDesc = 'PURCHASE_ORDER_LEAD_TIME_DESC',
  PurchaseUnitPriceYenUpdFlgAsc = 'PURCHASE_UNIT_PRICE_YEN_UPD_FLG_ASC',
  PurchaseUnitPriceYenUpdFlgDesc = 'PURCHASE_UNIT_PRICE_YEN_UPD_FLG_DESC',
  QuantityDecimalDigitsAsc = 'QUANTITY_DECIMAL_DIGITS_ASC',
  QuantityDecimalDigitsDesc = 'QUANTITY_DECIMAL_DIGITS_DESC',
  ReceiveOrderLotAsc = 'RECEIVE_ORDER_LOT_ASC',
  ReceiveOrderLotDesc = 'RECEIVE_ORDER_LOT_DESC',
  SalesUnitPriceUpdFlgAsc = 'SALES_UNIT_PRICE_UPD_FLG_ASC',
  SalesUnitPriceUpdFlgDesc = 'SALES_UNIT_PRICE_UPD_FLG_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UnitCodeAsc = 'UNIT_CODE_ASC',
  UnitCodeDesc = 'UNIT_CODE_DESC',
  UnitDollarDecimalDigitsAsc = 'UNIT_DOLLAR_DECIMAL_DIGITS_ASC',
  UnitDollarDecimalDigitsDesc = 'UNIT_DOLLAR_DECIMAL_DIGITS_DESC',
  UnitYenDecimalDigitsAsc = 'UNIT_YEN_DECIMAL_DIGITS_ASC',
  UnitYenDecimalDigitsDesc = 'UNIT_YEN_DECIMAL_DIGITS_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WideUseFlgAsc = 'WIDE_USE_FLG_ASC',
  WideUseFlgDesc = 'WIDE_USE_FLG_DESC'
}

export type ProductStockByDivision = Node & {
  __typename?: 'ProductStockByDivision';
  /** The ID of the object. */
  id: Scalars['ID'];
  productCode?: Maybe<Scalars['String']>;
  stockQuantity?: Maybe<Scalars['Int']>;
};

export type ProductStockByDivisionConnection = {
  __typename?: 'ProductStockByDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductStockByDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductStockByDivision` and its cursor. */
export type ProductStockByDivisionEdge = {
  __typename?: 'ProductStockByDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductStockByDivision>;
};

export type ProductStockByWarehouse = Node & {
  __typename?: 'ProductStockByWarehouse';
  discontinueFlg?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  possibleQuantity?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  stockQuantity?: Maybe<Scalars['Int']>;
};

export type ProductStockByWarehouseConnection = {
  __typename?: 'ProductStockByWarehouseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductStockByWarehouseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductStockByWarehouse` and its cursor. */
export type ProductStockByWarehouseEdge = {
  __typename?: 'ProductStockByWarehouseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductStockByWarehouse>;
};

export type ProductStockByWarehouseEx = Node & {
  __typename?: 'ProductStockByWarehouseEx';
  discontinueFlg?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  possibleQuantity?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  stockQuantity?: Maybe<Scalars['Int']>;
};

export type ProductStockByWarehouseExConnection = {
  __typename?: 'ProductStockByWarehouseExConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductStockByWarehouseExEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductStockByWarehouseEx` and its cursor. */
export type ProductStockByWarehouseExEdge = {
  __typename?: 'ProductStockByWarehouseExEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductStockByWarehouseEx>;
};

export type ProductStockForAdjust = Node & {
  __typename?: 'ProductStockForAdjust';
  attributeName?: Maybe<Scalars['String']>;
  discontinueFlg?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  stockQuantity?: Maybe<Scalars['Int']>;
};

export type ProductStockForAdjustConnection = {
  __typename?: 'ProductStockForAdjustConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductStockForAdjustEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductStockForAdjust` and its cursor. */
export type ProductStockForAdjustEdge = {
  __typename?: 'ProductStockForAdjustEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductStockForAdjust>;
};

export type ProductVariant = Node & {
  __typename?: 'ProductVariant';
  attr1?: Maybe<Scalars['String']>;
  attr2?: Maybe<Scalars['String']>;
  attrNo: Scalars['Int'];
  attributeName?: Maybe<Scalars['String']>;
  baseStockQuantity?: Maybe<Scalars['Float']>;
  branchNumber: Scalars['Int'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  discontinueFlg: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: Maybe<Scalars['Int']>;
  endOfSalesDate?: Maybe<Scalars['String']>;
  fcCode1?: Maybe<Scalars['String']>;
  fcCode2?: Maybe<Scalars['String']>;
  fcCode3?: Maybe<Scalars['String']>;
  fcCodeBranchNumber1?: Maybe<Scalars['String']>;
  fcCodeBranchNumber2?: Maybe<Scalars['String']>;
  fcCodeBranchNumber3?: Maybe<Scalars['String']>;
  firstArrivalDate?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  innerCartonSize?: Maybe<Scalars['String']>;
  innerCartonUnit?: Maybe<Scalars['Int']>;
  innerCartonWeight?: Maybe<Scalars['String']>;
  lotGroupCode?: Maybe<Scalars['Int']>;
  minimumLot?: Maybe<Scalars['Int']>;
  outerCartonDept?: Maybe<Scalars['Float']>;
  outerCartonHeight?: Maybe<Scalars['Float']>;
  outerCartonSize?: Maybe<Scalars['String']>;
  outerCartonUnit?: Maybe<Scalars['Int']>;
  outerCartonWeight?: Maybe<Scalars['String']>;
  outerCartonWidth?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  productAttrMemo?: Maybe<Scalars['String']>;
  productBodySize?: Maybe<Scalars['String']>;
  productBodyWeight?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productImage1?: Maybe<Scalars['String']>;
  productImage2?: Maybe<Scalars['String']>;
  productImage3?: Maybe<Scalars['String']>;
  productImage4?: Maybe<Scalars['String']>;
  productImage5?: Maybe<Scalars['String']>;
  productImage6?: Maybe<Scalars['String']>;
  productPackageSize?: Maybe<Scalars['String']>;
  productPackageWeight?: Maybe<Scalars['String']>;
  publicationOption?: Maybe<Scalars['String']>;
  purchaseOrderStandardStock?: Maybe<Scalars['Int']>;
  searchKeyword?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductVariantEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductVariant` and its cursor. */
export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductVariant>;
};

export type ProductVariantImport = {
  attr1?: InputMaybe<Scalars['String']>;
  attr2?: InputMaybe<Scalars['String']>;
  attrNo?: InputMaybe<Scalars['Int']>;
  baseStockQuantity?: InputMaybe<Scalars['Int']>;
  discontinueFlg?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: InputMaybe<Scalars['Int']>;
  endOfSalesDate?: InputMaybe<Scalars['String']>;
  fcCode1?: InputMaybe<Scalars['String']>;
  fcCode2?: InputMaybe<Scalars['String']>;
  fcCode3?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber1?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber2?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber3?: InputMaybe<Scalars['String']>;
  firstArrivalDate?: InputMaybe<Scalars['String']>;
  innerCartonSize?: InputMaybe<Scalars['String']>;
  innerCartonUnit?: InputMaybe<Scalars['Int']>;
  innerCartonWeight?: InputMaybe<Scalars['String']>;
  lotGroupCode?: InputMaybe<Scalars['Int']>;
  minimumLot?: InputMaybe<Scalars['Int']>;
  outerCartonDept?: InputMaybe<Scalars['Decimal']>;
  outerCartonHeight?: InputMaybe<Scalars['Decimal']>;
  outerCartonUnit?: InputMaybe<Scalars['Int']>;
  outerCartonWeight?: InputMaybe<Scalars['String']>;
  outerCartonWidth?: InputMaybe<Scalars['Decimal']>;
  productAttrMemo?: InputMaybe<Scalars['String']>;
  productBodySize?: InputMaybe<Scalars['String']>;
  productBodyWeight?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  productImage1?: InputMaybe<Scalars['String']>;
  productImage2?: InputMaybe<Scalars['String']>;
  productImage3?: InputMaybe<Scalars['String']>;
  productImage4?: InputMaybe<Scalars['String']>;
  productImage5?: InputMaybe<Scalars['String']>;
  productImage6?: InputMaybe<Scalars['String']>;
  productPackageSize?: InputMaybe<Scalars['String']>;
  productPackageWeight?: InputMaybe<Scalars['String']>;
  publicationOption?: InputMaybe<Scalars['String']>;
  purchaseOrderStandardStock?: InputMaybe<Scalars['Int']>;
  updateType?: InputMaybe<ProductListUpdateType>;
};

/** An enumeration. */
export enum ProductVariantSortEnum {
  Attr1Asc = 'ATTR1_ASC',
  Attr1Desc = 'ATTR1_DESC',
  Attr2Asc = 'ATTR2_ASC',
  Attr2Desc = 'ATTR2_DESC',
  AttributeNameAsc = 'ATTRIBUTE_NAME_ASC',
  AttributeNameDesc = 'ATTRIBUTE_NAME_DESC',
  AttrNoAsc = 'ATTR_NO_ASC',
  AttrNoDesc = 'ATTR_NO_DESC',
  BaseStockQuantityAsc = 'BASE_STOCK_QUANTITY_ASC',
  BaseStockQuantityDesc = 'BASE_STOCK_QUANTITY_DESC',
  BranchNumberAsc = 'BRANCH_NUMBER_ASC',
  BranchNumberDesc = 'BRANCH_NUMBER_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DiscontinueFlgAsc = 'DISCONTINUE_FLG_ASC',
  DiscontinueFlgDesc = 'DISCONTINUE_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  DivisionStandardStockAsc = 'DIVISION_STANDARD_STOCK_ASC',
  DivisionStandardStockDesc = 'DIVISION_STANDARD_STOCK_DESC',
  EndOfSalesDateAsc = 'END_OF_SALES_DATE_ASC',
  EndOfSalesDateDesc = 'END_OF_SALES_DATE_DESC',
  FcCode1Asc = 'FC_CODE1_ASC',
  FcCode1Desc = 'FC_CODE1_DESC',
  FcCode2Asc = 'FC_CODE2_ASC',
  FcCode2Desc = 'FC_CODE2_DESC',
  FcCode3Asc = 'FC_CODE3_ASC',
  FcCode3Desc = 'FC_CODE3_DESC',
  FcCodeBranchNumber1Asc = 'FC_CODE_BRANCH_NUMBER1_ASC',
  FcCodeBranchNumber1Desc = 'FC_CODE_BRANCH_NUMBER1_DESC',
  FcCodeBranchNumber2Asc = 'FC_CODE_BRANCH_NUMBER2_ASC',
  FcCodeBranchNumber2Desc = 'FC_CODE_BRANCH_NUMBER2_DESC',
  FcCodeBranchNumber3Asc = 'FC_CODE_BRANCH_NUMBER3_ASC',
  FcCodeBranchNumber3Desc = 'FC_CODE_BRANCH_NUMBER3_DESC',
  FirstArrivalDateAsc = 'FIRST_ARRIVAL_DATE_ASC',
  FirstArrivalDateDesc = 'FIRST_ARRIVAL_DATE_DESC',
  InnerCartonSizeAsc = 'INNER_CARTON_SIZE_ASC',
  InnerCartonSizeDesc = 'INNER_CARTON_SIZE_DESC',
  InnerCartonUnitAsc = 'INNER_CARTON_UNIT_ASC',
  InnerCartonUnitDesc = 'INNER_CARTON_UNIT_DESC',
  InnerCartonWeightAsc = 'INNER_CARTON_WEIGHT_ASC',
  InnerCartonWeightDesc = 'INNER_CARTON_WEIGHT_DESC',
  LotGroupCodeAsc = 'LOT_GROUP_CODE_ASC',
  LotGroupCodeDesc = 'LOT_GROUP_CODE_DESC',
  MinimumLotAsc = 'MINIMUM_LOT_ASC',
  MinimumLotDesc = 'MINIMUM_LOT_DESC',
  OuterCartonDeptAsc = 'OUTER_CARTON_DEPT_ASC',
  OuterCartonDeptDesc = 'OUTER_CARTON_DEPT_DESC',
  OuterCartonHeightAsc = 'OUTER_CARTON_HEIGHT_ASC',
  OuterCartonHeightDesc = 'OUTER_CARTON_HEIGHT_DESC',
  OuterCartonSizeAsc = 'OUTER_CARTON_SIZE_ASC',
  OuterCartonSizeDesc = 'OUTER_CARTON_SIZE_DESC',
  OuterCartonUnitAsc = 'OUTER_CARTON_UNIT_ASC',
  OuterCartonUnitDesc = 'OUTER_CARTON_UNIT_DESC',
  OuterCartonWeightAsc = 'OUTER_CARTON_WEIGHT_ASC',
  OuterCartonWeightDesc = 'OUTER_CARTON_WEIGHT_DESC',
  OuterCartonWidthAsc = 'OUTER_CARTON_WIDTH_ASC',
  OuterCartonWidthDesc = 'OUTER_CARTON_WIDTH_DESC',
  ProductAttrMemoAsc = 'PRODUCT_ATTR_MEMO_ASC',
  ProductAttrMemoDesc = 'PRODUCT_ATTR_MEMO_DESC',
  ProductBodySizeAsc = 'PRODUCT_BODY_SIZE_ASC',
  ProductBodySizeDesc = 'PRODUCT_BODY_SIZE_DESC',
  ProductBodyWeightAsc = 'PRODUCT_BODY_WEIGHT_ASC',
  ProductBodyWeightDesc = 'PRODUCT_BODY_WEIGHT_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductImage_1Asc = 'PRODUCT_IMAGE_1_ASC',
  ProductImage_1Desc = 'PRODUCT_IMAGE_1_DESC',
  ProductImage_2Asc = 'PRODUCT_IMAGE_2_ASC',
  ProductImage_2Desc = 'PRODUCT_IMAGE_2_DESC',
  ProductImage_3Asc = 'PRODUCT_IMAGE_3_ASC',
  ProductImage_3Desc = 'PRODUCT_IMAGE_3_DESC',
  ProductImage_4Asc = 'PRODUCT_IMAGE_4_ASC',
  ProductImage_4Desc = 'PRODUCT_IMAGE_4_DESC',
  ProductImage_5Asc = 'PRODUCT_IMAGE_5_ASC',
  ProductImage_5Desc = 'PRODUCT_IMAGE_5_DESC',
  ProductImage_6Asc = 'PRODUCT_IMAGE_6_ASC',
  ProductImage_6Desc = 'PRODUCT_IMAGE_6_DESC',
  ProductPackageSizeAsc = 'PRODUCT_PACKAGE_SIZE_ASC',
  ProductPackageSizeDesc = 'PRODUCT_PACKAGE_SIZE_DESC',
  ProductPackageWeightAsc = 'PRODUCT_PACKAGE_WEIGHT_ASC',
  ProductPackageWeightDesc = 'PRODUCT_PACKAGE_WEIGHT_DESC',
  PublicationOptionAsc = 'PUBLICATION_OPTION_ASC',
  PublicationOptionDesc = 'PUBLICATION_OPTION_DESC',
  PurchaseOrderStandardStockAsc = 'PURCHASE_ORDER_STANDARD_STOCK_ASC',
  PurchaseOrderStandardStockDesc = 'PURCHASE_ORDER_STANDARD_STOCK_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ProductView = Node & {
  __typename?: 'ProductView';
  allRemainReceiveQuantity?: Maybe<Scalars['Float']>;
  attr1?: Maybe<Scalars['String']>;
  attr2?: Maybe<Scalars['String']>;
  attrNo: Scalars['Int'];
  attributeName?: Maybe<Scalars['String']>;
  branchNumber: Scalars['Int'];
  clothGroup?: Maybe<Scalars['String']>;
  componentDivision?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  designUser?: Maybe<DesignUser>;
  designUserCode?: Maybe<Scalars['String']>;
  discontinueFlg?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: Maybe<Scalars['Int']>;
  domOverFlg?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endOfSalesDate?: Maybe<Scalars['String']>;
  fcCode1?: Maybe<Scalars['String']>;
  fcCode2?: Maybe<Scalars['String']>;
  fcCode3?: Maybe<Scalars['String']>;
  fcCodeBranchNumber1?: Maybe<Scalars['String']>;
  fcCodeBranchNumber2?: Maybe<Scalars['String']>;
  fcCodeBranchNumber3?: Maybe<Scalars['String']>;
  firstArrivalDate?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  innerCartonSize?: Maybe<Scalars['String']>;
  innerCartonUnit?: Maybe<Scalars['Int']>;
  innerCartonWeight?: Maybe<Scalars['String']>;
  inventoryControlFlg?: Maybe<Scalars['String']>;
  janCode: Scalars['String'];
  lotGroupCode?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  minimumLot?: Maybe<Scalars['Int']>;
  notIncludedSku: Scalars['String'];
  outerCartonDept?: Maybe<Scalars['Float']>;
  outerCartonHeight?: Maybe<Scalars['Float']>;
  outerCartonSize?: Maybe<Scalars['String']>;
  outerCartonUnit?: Maybe<Scalars['Int']>;
  outerCartonWeight?: Maybe<Scalars['String']>;
  outerCartonWidth?: Maybe<Scalars['Float']>;
  planningUser?: Maybe<PlanningUser>;
  planningUserCode?: Maybe<Scalars['String']>;
  productAttrMemo?: Maybe<Scalars['String']>;
  productBodySize?: Maybe<Scalars['String']>;
  productBodyWeight?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productFuri?: Maybe<Scalars['String']>;
  productGroup1?: Maybe<ProductGroup>;
  productGroup2?: Maybe<ProductGroup>;
  productGroup3?: Maybe<ProductGroup>;
  productGroupId1?: Maybe<Scalars['Int']>;
  productGroupId2?: Maybe<Scalars['Int']>;
  productGroupId3?: Maybe<Scalars['Int']>;
  productImage1?: Maybe<Scalars['String']>;
  productImage2?: Maybe<Scalars['String']>;
  productImage3?: Maybe<Scalars['String']>;
  productImage4?: Maybe<Scalars['String']>;
  productImage5?: Maybe<Scalars['String']>;
  productImage6?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productPackageSize?: Maybe<Scalars['String']>;
  productPackageWeight?: Maybe<Scalars['String']>;
  productPrice?: Maybe<ProductPriceConnection>;
  publicationOption?: Maybe<Scalars['String']>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  purchaseOrderStandardStock?: Maybe<Scalars['Int']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderLot?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
  startDate?: Maybe<Scalars['String']>;
  stock?: Maybe<Stock>;
  stockByDivisions?: Maybe<Array<Maybe<StockByDivision>>>;
  stockByWarehouses?: Maybe<Array<Maybe<StockByWarehouse>>>;
  tags?: Maybe<Scalars['JSONString']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  wideUseFlg: Scalars['String'];
};


export type ProductViewProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductViewConnection = {
  __typename?: 'ProductViewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductView` and its cursor. */
export type ProductViewEdge = {
  __typename?: 'ProductViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductView>;
};

/** An enumeration. */
export enum ProductViewSortEnum {
  Attr1Asc = 'ATTR1_ASC',
  Attr1Desc = 'ATTR1_DESC',
  Attr2Asc = 'ATTR2_ASC',
  Attr2Desc = 'ATTR2_DESC',
  AttributeNameAsc = 'ATTRIBUTE_NAME_ASC',
  AttributeNameDesc = 'ATTRIBUTE_NAME_DESC',
  AttrNoAsc = 'ATTR_NO_ASC',
  AttrNoDesc = 'ATTR_NO_DESC',
  BranchNumberAsc = 'BRANCH_NUMBER_ASC',
  BranchNumberDesc = 'BRANCH_NUMBER_DESC',
  ClothGroupAsc = 'CLOTH_GROUP_ASC',
  ClothGroupDesc = 'CLOTH_GROUP_DESC',
  ComponentDivisionAsc = 'COMPONENT_DIVISION_ASC',
  ComponentDivisionDesc = 'COMPONENT_DIVISION_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DesignUserCodeAsc = 'DESIGN_USER_CODE_ASC',
  DesignUserCodeDesc = 'DESIGN_USER_CODE_DESC',
  DiscontinueFlgAsc = 'DISCONTINUE_FLG_ASC',
  DiscontinueFlgDesc = 'DISCONTINUE_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  DivisionStandardStockAsc = 'DIVISION_STANDARD_STOCK_ASC',
  DivisionStandardStockDesc = 'DIVISION_STANDARD_STOCK_DESC',
  DomOverFlgAsc = 'DOM_OVER_FLG_ASC',
  DomOverFlgDesc = 'DOM_OVER_FLG_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  EndOfSalesDateAsc = 'END_OF_SALES_DATE_ASC',
  EndOfSalesDateDesc = 'END_OF_SALES_DATE_DESC',
  FcCode1Asc = 'FC_CODE1_ASC',
  FcCode1Desc = 'FC_CODE1_DESC',
  FcCode2Asc = 'FC_CODE2_ASC',
  FcCode2Desc = 'FC_CODE2_DESC',
  FcCode3Asc = 'FC_CODE3_ASC',
  FcCode3Desc = 'FC_CODE3_DESC',
  FcCodeBranchNumber1Asc = 'FC_CODE_BRANCH_NUMBER1_ASC',
  FcCodeBranchNumber1Desc = 'FC_CODE_BRANCH_NUMBER1_DESC',
  FcCodeBranchNumber2Asc = 'FC_CODE_BRANCH_NUMBER2_ASC',
  FcCodeBranchNumber2Desc = 'FC_CODE_BRANCH_NUMBER2_DESC',
  FcCodeBranchNumber3Asc = 'FC_CODE_BRANCH_NUMBER3_ASC',
  FcCodeBranchNumber3Desc = 'FC_CODE_BRANCH_NUMBER3_DESC',
  FirstArrivalDateAsc = 'FIRST_ARRIVAL_DATE_ASC',
  FirstArrivalDateDesc = 'FIRST_ARRIVAL_DATE_DESC',
  InnerCartonSizeAsc = 'INNER_CARTON_SIZE_ASC',
  InnerCartonSizeDesc = 'INNER_CARTON_SIZE_DESC',
  InnerCartonUnitAsc = 'INNER_CARTON_UNIT_ASC',
  InnerCartonUnitDesc = 'INNER_CARTON_UNIT_DESC',
  InnerCartonWeightAsc = 'INNER_CARTON_WEIGHT_ASC',
  InnerCartonWeightDesc = 'INNER_CARTON_WEIGHT_DESC',
  InventoryControlFlgAsc = 'INVENTORY_CONTROL_FLG_ASC',
  InventoryControlFlgDesc = 'INVENTORY_CONTROL_FLG_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  LotGroupCodeAsc = 'LOT_GROUP_CODE_ASC',
  LotGroupCodeDesc = 'LOT_GROUP_CODE_DESC',
  ManufacturerAsc = 'MANUFACTURER_ASC',
  ManufacturerDesc = 'MANUFACTURER_DESC',
  MaterialAsc = 'MATERIAL_ASC',
  MaterialDesc = 'MATERIAL_DESC',
  MaxPurchaseOrderQtyAsc = 'MAX_PURCHASE_ORDER_QTY_ASC',
  MaxPurchaseOrderQtyDesc = 'MAX_PURCHASE_ORDER_QTY_DESC',
  MinimumLotAsc = 'MINIMUM_LOT_ASC',
  MinimumLotDesc = 'MINIMUM_LOT_DESC',
  NotIncludedSkuAsc = 'NOT_INCLUDED_SKU_ASC',
  NotIncludedSkuDesc = 'NOT_INCLUDED_SKU_DESC',
  OuterCartonDeptAsc = 'OUTER_CARTON_DEPT_ASC',
  OuterCartonDeptDesc = 'OUTER_CARTON_DEPT_DESC',
  OuterCartonHeightAsc = 'OUTER_CARTON_HEIGHT_ASC',
  OuterCartonHeightDesc = 'OUTER_CARTON_HEIGHT_DESC',
  OuterCartonSizeAsc = 'OUTER_CARTON_SIZE_ASC',
  OuterCartonSizeDesc = 'OUTER_CARTON_SIZE_DESC',
  OuterCartonUnitAsc = 'OUTER_CARTON_UNIT_ASC',
  OuterCartonUnitDesc = 'OUTER_CARTON_UNIT_DESC',
  OuterCartonWeightAsc = 'OUTER_CARTON_WEIGHT_ASC',
  OuterCartonWeightDesc = 'OUTER_CARTON_WEIGHT_DESC',
  OuterCartonWidthAsc = 'OUTER_CARTON_WIDTH_ASC',
  OuterCartonWidthDesc = 'OUTER_CARTON_WIDTH_DESC',
  PlanningUserCodeAsc = 'PLANNING_USER_CODE_ASC',
  PlanningUserCodeDesc = 'PLANNING_USER_CODE_DESC',
  ProductAttrMemoAsc = 'PRODUCT_ATTR_MEMO_ASC',
  ProductAttrMemoDesc = 'PRODUCT_ATTR_MEMO_DESC',
  ProductBodySizeAsc = 'PRODUCT_BODY_SIZE_ASC',
  ProductBodySizeDesc = 'PRODUCT_BODY_SIZE_DESC',
  ProductBodyWeightAsc = 'PRODUCT_BODY_WEIGHT_ASC',
  ProductBodyWeightDesc = 'PRODUCT_BODY_WEIGHT_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductFuriAsc = 'PRODUCT_FURI_ASC',
  ProductFuriDesc = 'PRODUCT_FURI_DESC',
  ProductGroupId1Asc = 'PRODUCT_GROUP_ID1_ASC',
  ProductGroupId1Desc = 'PRODUCT_GROUP_ID1_DESC',
  ProductGroupId2Asc = 'PRODUCT_GROUP_ID2_ASC',
  ProductGroupId2Desc = 'PRODUCT_GROUP_ID2_DESC',
  ProductGroupId3Asc = 'PRODUCT_GROUP_ID3_ASC',
  ProductGroupId3Desc = 'PRODUCT_GROUP_ID3_DESC',
  ProductImage_1Asc = 'PRODUCT_IMAGE_1_ASC',
  ProductImage_1Desc = 'PRODUCT_IMAGE_1_DESC',
  ProductImage_2Asc = 'PRODUCT_IMAGE_2_ASC',
  ProductImage_2Desc = 'PRODUCT_IMAGE_2_DESC',
  ProductImage_3Asc = 'PRODUCT_IMAGE_3_ASC',
  ProductImage_3Desc = 'PRODUCT_IMAGE_3_DESC',
  ProductImage_4Asc = 'PRODUCT_IMAGE_4_ASC',
  ProductImage_4Desc = 'PRODUCT_IMAGE_4_DESC',
  ProductImage_5Asc = 'PRODUCT_IMAGE_5_ASC',
  ProductImage_5Desc = 'PRODUCT_IMAGE_5_DESC',
  ProductImage_6Asc = 'PRODUCT_IMAGE_6_ASC',
  ProductImage_6Desc = 'PRODUCT_IMAGE_6_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ProductPackageSizeAsc = 'PRODUCT_PACKAGE_SIZE_ASC',
  ProductPackageSizeDesc = 'PRODUCT_PACKAGE_SIZE_DESC',
  ProductPackageWeightAsc = 'PRODUCT_PACKAGE_WEIGHT_ASC',
  ProductPackageWeightDesc = 'PRODUCT_PACKAGE_WEIGHT_DESC',
  PublicationOptionAsc = 'PUBLICATION_OPTION_ASC',
  PublicationOptionDesc = 'PUBLICATION_OPTION_DESC',
  PurchaseOrderLeadTimeAsc = 'PURCHASE_ORDER_LEAD_TIME_ASC',
  PurchaseOrderLeadTimeDesc = 'PURCHASE_ORDER_LEAD_TIME_DESC',
  PurchaseOrderStandardStockAsc = 'PURCHASE_ORDER_STANDARD_STOCK_ASC',
  PurchaseOrderStandardStockDesc = 'PURCHASE_ORDER_STANDARD_STOCK_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  QuantityDecimalDigitsAsc = 'QUANTITY_DECIMAL_DIGITS_ASC',
  QuantityDecimalDigitsDesc = 'QUANTITY_DECIMAL_DIGITS_DESC',
  ReceiveOrderLotAsc = 'RECEIVE_ORDER_LOT_ASC',
  ReceiveOrderLotDesc = 'RECEIVE_ORDER_LOT_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TagsAsc = 'TAGS_ASC',
  TagsDesc = 'TAGS_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UnitCodeAsc = 'UNIT_CODE_ASC',
  UnitCodeDesc = 'UNIT_CODE_DESC',
  UnitDollarDecimalDigitsAsc = 'UNIT_DOLLAR_DECIMAL_DIGITS_ASC',
  UnitDollarDecimalDigitsDesc = 'UNIT_DOLLAR_DECIMAL_DIGITS_DESC',
  UnitYenDecimalDigitsAsc = 'UNIT_YEN_DECIMAL_DIGITS_ASC',
  UnitYenDecimalDigitsDesc = 'UNIT_YEN_DECIMAL_DIGITS_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WideUseFlgAsc = 'WIDE_USE_FLG_ASC',
  WideUseFlgDesc = 'WIDE_USE_FLG_DESC'
}

export type ProductViewWithCustomer = Node & {
  __typename?: 'ProductViewWithCustomer';
  discontinueFlg?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderPossibleStock?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  stockAllQuantity?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewWithCustomerConnection = {
  __typename?: 'ProductViewWithCustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewWithCustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewWithCustomer` and its cursor. */
export type ProductViewWithCustomerEdge = {
  __typename?: 'ProductViewWithCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewWithCustomer>;
};

export type ProductViewWithOutsourcer = Node & {
  __typename?: 'ProductViewWithOutsourcer';
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewWithOutsourcerConnection = {
  __typename?: 'ProductViewWithOutsourcerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewWithOutsourcerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewWithOutsourcer` and its cursor. */
export type ProductViewWithOutsourcerEdge = {
  __typename?: 'ProductViewWithOutsourcerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewWithOutsourcer>;
};

export type ProductViewWithProductCodes = Node & {
  __typename?: 'ProductViewWithProductCodes';
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode: Scalars['String'];
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  priceRoundType?: Maybe<Scalars['String']>;
  productCode: Scalars['String'];
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityDecimalDigits: Scalars['Int'];
  receiveOrderPossibleStock?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  stockAllQuantity?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitDollarDecimalDigits: Scalars['Int'];
  unitYenDecimalDigits: Scalars['Int'];
  vendorCode?: Maybe<Scalars['String']>;
};

export type ProductViewWithProductCodesConnection = {
  __typename?: 'ProductViewWithProductCodesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewWithProductCodesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewWithProductCodes` and its cursor. */
export type ProductViewWithProductCodesEdge = {
  __typename?: 'ProductViewWithProductCodesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewWithProductCodes>;
};

export type ProductViewWithVendor = Node & {
  __typename?: 'ProductViewWithVendor';
  discontinueFlg?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderPossibleStock?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  stockAllQuantity?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewWithVendorConnection = {
  __typename?: 'ProductViewWithVendorConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewWithVendorEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewWithVendor` and its cursor. */
export type ProductViewWithVendorEdge = {
  __typename?: 'ProductViewWithVendorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewWithVendor>;
};

export type ProductViewsWithCustomer = Node & {
  __typename?: 'ProductViewsWithCustomer';
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderPossibleStock?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  stockAllQuantity?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewsWithCustomerConnection = {
  __typename?: 'ProductViewsWithCustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewsWithCustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewsWithCustomer` and its cursor. */
export type ProductViewsWithCustomerEdge = {
  __typename?: 'ProductViewsWithCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewsWithCustomer>;
};

export type ProductViewsWithOutsourcer = Node & {
  __typename?: 'ProductViewsWithOutsourcer';
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewsWithOutsourcerConnection = {
  __typename?: 'ProductViewsWithOutsourcerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewsWithOutsourcerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewsWithOutsourcer` and its cursor. */
export type ProductViewsWithOutsourcerEdge = {
  __typename?: 'ProductViewsWithOutsourcerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewsWithOutsourcer>;
};

export type ProductViewsWithVendor = Node & {
  __typename?: 'ProductViewsWithVendor';
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  maxPurchaseOrderQty?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityDecimalDigits?: Maybe<Scalars['Int']>;
  receiveOrderPossibleStock?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  stockAllQuantity?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
  unitDollarDecimalDigits?: Maybe<Scalars['Int']>;
  unitYenDecimalDigits?: Maybe<Scalars['Int']>;
  wideUseFlg?: Maybe<Scalars['String']>;
};

export type ProductViewsWithVendorConnection = {
  __typename?: 'ProductViewsWithVendorConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductViewsWithVendorEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductViewsWithVendor` and its cursor. */
export type ProductViewsWithVendorEdge = {
  __typename?: 'ProductViewsWithVendorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductViewsWithVendor>;
};

export type Production = Node & {
  __typename?: 'Production';
  component?: Maybe<Component>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  finishedProductCode: Scalars['String'];
  finishedQuantity: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  productView?: Maybe<ProductNoPriceView>;
  productionDetails?: Maybe<ProductionDetailConnection>;
  productionMemo?: Maybe<Scalars['String']>;
  productionOrderDate: Scalars['String'];
  productionOrderId: Scalars['ID'];
  receivePrice?: Maybe<Scalars['Float']>;
  receiveUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouse?: Maybe<Warehouse>;
  warehouseCode: Scalars['String'];
};


export type ProductionProductionDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProductionDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductionConnection = {
  __typename?: 'ProductionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductionDetail = Node & {
  __typename?: 'ProductionDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  defrayalPrice?: Maybe<Scalars['Float']>;
  defrayalUnitPrice?: Maybe<Scalars['Float']>;
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  partsQuantity: Scalars['Float'];
  productPartsCode: Scalars['String'];
  productView?: Maybe<ProductNoPriceView>;
  production?: Maybe<Production>;
  productionOrderId: Scalars['ID'];
  quantity: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ProductionDetailConnection = {
  __typename?: 'ProductionDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductionDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ProductionDetail` and its cursor. */
export type ProductionDetailEdge = {
  __typename?: 'ProductionDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProductionDetail>;
};

export type ProductionDetailFilter = {
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productPartsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum ProductionDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DefrayalPriceAsc = 'DEFRAYAL_PRICE_ASC',
  DefrayalPriceDesc = 'DEFRAYAL_PRICE_DESC',
  DefrayalUnitPriceAsc = 'DEFRAYAL_UNIT_PRICE_ASC',
  DefrayalUnitPriceDesc = 'DEFRAYAL_UNIT_PRICE_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  PartsQuantityAsc = 'PARTS_QUANTITY_ASC',
  PartsQuantityDesc = 'PARTS_QUANTITY_DESC',
  ProductionOrderIdAsc = 'PRODUCTION_ORDER_ID_ASC',
  ProductionOrderIdDesc = 'PRODUCTION_ORDER_ID_DESC',
  ProductPartsCodeAsc = 'PRODUCT_PARTS_CODE_ASC',
  ProductPartsCodeDesc = 'PRODUCT_PARTS_CODE_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Production` and its cursor. */
export type ProductionEdge = {
  __typename?: 'ProductionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Production>;
};

/** An enumeration. */
export enum ProductionSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  FinishedProductCodeAsc = 'FINISHED_PRODUCT_CODE_ASC',
  FinishedProductCodeDesc = 'FINISHED_PRODUCT_CODE_DESC',
  FinishedQuantityAsc = 'FINISHED_QUANTITY_ASC',
  FinishedQuantityDesc = 'FINISHED_QUANTITY_DESC',
  ProductionMemoAsc = 'PRODUCTION_MEMO_ASC',
  ProductionMemoDesc = 'PRODUCTION_MEMO_DESC',
  ProductionOrderDateAsc = 'PRODUCTION_ORDER_DATE_ASC',
  ProductionOrderDateDesc = 'PRODUCTION_ORDER_DATE_DESC',
  ProductionOrderIdAsc = 'PRODUCTION_ORDER_ID_ASC',
  ProductionOrderIdDesc = 'PRODUCTION_ORDER_ID_DESC',
  ReceivePriceAsc = 'RECEIVE_PRICE_ASC',
  ReceivePriceDesc = 'RECEIVE_PRICE_DESC',
  ReceiveUnitPriceAsc = 'RECEIVE_UNIT_PRICE_ASC',
  ReceiveUnitPriceDesc = 'RECEIVE_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type Purchase = Node & {
  __typename?: 'Purchase';
  arrival?: Maybe<Arrival>;
  arrivalId?: Maybe<Scalars['Int']>;
  arrivalTaxDetails?: Maybe<ArrivalTaxDetailConnection>;
  arrivalTaxDetailsPurchase?: Maybe<ArrivalTaxDetailConnection>;
  closingStatusCode: Scalars['String'];
  closingTiming?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['Int']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  poCode?: Maybe<Scalars['String']>;
  purchaseDate: Scalars['String'];
  purchaseDetails?: Maybe<PurchaseDetailConnection>;
  purchaseId: Scalars['ID'];
  purchaseRemark?: Maybe<Scalars['String']>;
  purchaseVoucherType: Scalars['String'];
  taxExcludedTotal?: Maybe<Scalars['Float']>;
  taxIncludedTotal?: Maybe<Scalars['Float']>;
  totalDollar?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode: Scalars['String'];
  vendorTaxType: Scalars['String'];
  vendorTradeDivision: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type PurchaseArrivalTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PurchaseArrivalTaxDetailsPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PurchasePurchaseDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PurchaseDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PurchaseAnalytics = Node & {
  __typename?: 'PurchaseAnalytics';
  configurationRate?: Maybe<Scalars['Float']>;
  configurationRateDollar?: Maybe<Scalars['Float']>;
  discountPrice?: Maybe<Scalars['Int']>;
  discountPriceDollar?: Maybe<Scalars['Int']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  netPurchasePrice?: Maybe<Scalars['Int']>;
  netPurchasePriceDollar?: Maybe<Scalars['Int']>;
  netPurchaseQuantity?: Maybe<Scalars['Int']>;
  otherPrice?: Maybe<Scalars['Int']>;
  otherPriceDollar?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  returnPrice?: Maybe<Scalars['Int']>;
  returnPriceDollar?: Maybe<Scalars['Int']>;
  returnQuantity?: Maybe<Scalars['Int']>;
  totalPurchasePrice?: Maybe<Scalars['Int']>;
  totalPurchasePriceDollar?: Maybe<Scalars['Int']>;
  totalPurchaseQuantity?: Maybe<Scalars['Int']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type PurchaseAnalyticsConnection = {
  __typename?: 'PurchaseAnalyticsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseAnalyticsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PurchaseAnalytics` and its cursor. */
export type PurchaseAnalyticsEdge = {
  __typename?: 'PurchaseAnalyticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseAnalytics>;
};

export type PurchaseConnection = {
  __typename?: 'PurchaseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PurchaseDaily = Node & {
  __typename?: 'PurchaseDaily';
  discountPrice?: Maybe<Scalars['Int']>;
  discountPriceDollar?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['Float']>;
  discountRateDollar?: Maybe<Scalars['Float']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  netPurchasePrice?: Maybe<Scalars['Int']>;
  netPurchasePriceDollar?: Maybe<Scalars['Int']>;
  netPurchaseQuantity?: Maybe<Scalars['Int']>;
  otherPrice?: Maybe<Scalars['Int']>;
  otherPriceDollar?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  returnPrice?: Maybe<Scalars['Int']>;
  returnPriceDollar?: Maybe<Scalars['Int']>;
  returnQuantity?: Maybe<Scalars['Int']>;
  returnRate?: Maybe<Scalars['Float']>;
  returnRateDollar?: Maybe<Scalars['Float']>;
  totalPurchasePrice?: Maybe<Scalars['Int']>;
  totalPurchasePriceDollar?: Maybe<Scalars['Int']>;
  totalPurchaseQuantity?: Maybe<Scalars['Int']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type PurchaseDailyConnection = {
  __typename?: 'PurchaseDailyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseDailyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PurchaseDaily` and its cursor. */
export type PurchaseDailyEdge = {
  __typename?: 'PurchaseDailyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseDaily>;
};

export type PurchaseDetail = Node & {
  __typename?: 'PurchaseDetail';
  arrivalDetailNumbering?: Maybe<Scalars['Int']>;
  clearingPrice?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchase?: Maybe<Purchase>;
  purchaseId: Scalars['ID'];
  purchasePrice?: Maybe<Scalars['Float']>;
  purchasePriceDollar?: Maybe<Scalars['Float']>;
  purchaseQuantity?: Maybe<Scalars['Float']>;
  purchaseTradeTypeCode: Scalars['String'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type PurchaseDetailConnection = {
  __typename?: 'PurchaseDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PurchaseDetail` and its cursor. */
export type PurchaseDetailEdge = {
  __typename?: 'PurchaseDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseDetail>;
};

export type PurchaseDetailFilter = {
  detailMainFlg?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** A Relay edge containing a `Purchase` and its cursor. */
export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Purchase>;
};

export type PurchaseKore = {
  __typename?: 'PurchaseKore';
  attributeName?: Maybe<Scalars['String']>;
  beforePreviousArrivalDate?: Maybe<Scalars['String']>;
  beforePreviousArrivalQuantity?: Maybe<Scalars['Float']>;
  beforePreviousDailyAverageShipmentQuantity?: Maybe<Scalars['Float']>;
  beforePreviousDio?: Maybe<Scalars['Float']>;
  beforePreviousOrderDate?: Maybe<Scalars['String']>;
  beforePreviousOrderToArrivalLeadTime?: Maybe<Scalars['Float']>;
  beforePreviousTotalShipmentCustomers?: Maybe<Scalars['Float']>;
  beforePreviousTotalShipmentQuantity?: Maybe<Scalars['Float']>;
  costRatio?: Maybe<Scalars['Float']>;
  countryCode?: Maybe<Scalars['String']>;
  daysFromBeforePreviousArrivalToPreviousArrival?: Maybe<Scalars['Float']>;
  daysFromLatestArrivalToNow?: Maybe<Scalars['Float']>;
  daysFromPreviousArrivalToLatestArrival?: Maybe<Scalars['Float']>;
  daysFromThirdPreviousArrivalToBeforePreviousArrival?: Maybe<Scalars['Float']>;
  designUserName?: Maybe<Scalars['String']>;
  domOverFlg?: Maybe<Scalars['String']>;
  firstArrivalDate?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  latestArrivalDate?: Maybe<Scalars['String']>;
  latestArrivalQuantity?: Maybe<Scalars['Float']>;
  latestDailyAverageShipmentQuantity?: Maybe<Scalars['Float']>;
  latestDio?: Maybe<Scalars['Float']>;
  latestOrderDate?: Maybe<Scalars['String']>;
  latestOrderToArrivalLeadTime?: Maybe<Scalars['Float']>;
  latestTotalShipmentCustomers?: Maybe<Scalars['Float']>;
  latestTotalShipmentQuantity?: Maybe<Scalars['Float']>;
  m1MonthsAgo?: Maybe<Scalars['Float']>;
  m2MonthsAgo?: Maybe<Scalars['Float']>;
  m3MonthsAgo?: Maybe<Scalars['Float']>;
  m4MonthsAgo?: Maybe<Scalars['Float']>;
  m5MonthsAgo?: Maybe<Scalars['Float']>;
  m6MonthsAgo?: Maybe<Scalars['Float']>;
  m7MonthsAgo?: Maybe<Scalars['Float']>;
  m8MonthsAgo?: Maybe<Scalars['Float']>;
  m9MonthsAgo?: Maybe<Scalars['Float']>;
  m10MonthsAgo?: Maybe<Scalars['Float']>;
  m11MonthsAgo?: Maybe<Scalars['Float']>;
  m12MonthsAgo?: Maybe<Scalars['Float']>;
  m13MonthsAgo?: Maybe<Scalars['Float']>;
  m14MonthsAgo?: Maybe<Scalars['Float']>;
  m15MonthsAgo?: Maybe<Scalars['Float']>;
  m16MonthsAgo?: Maybe<Scalars['Float']>;
  m17MonthsAgo?: Maybe<Scalars['Float']>;
  m18MonthsAgo?: Maybe<Scalars['Float']>;
  m19MonthsAgo?: Maybe<Scalars['Float']>;
  m20MonthsAgo?: Maybe<Scalars['Float']>;
  m21MonthsAgo?: Maybe<Scalars['Float']>;
  m22MonthsAgo?: Maybe<Scalars['Float']>;
  m23MonthsAgo?: Maybe<Scalars['Float']>;
  m24MonthsAgo?: Maybe<Scalars['Float']>;
  m25MonthsAgo?: Maybe<Scalars['Float']>;
  m26MonthsAgo?: Maybe<Scalars['Float']>;
  m27MonthsAgo?: Maybe<Scalars['Float']>;
  m28MonthsAgo?: Maybe<Scalars['Float']>;
  m29MonthsAgo?: Maybe<Scalars['Float']>;
  m30MonthsAgo?: Maybe<Scalars['Float']>;
  m31MonthsAgo?: Maybe<Scalars['Float']>;
  m32MonthsAgo?: Maybe<Scalars['Float']>;
  m33MonthsAgo?: Maybe<Scalars['Float']>;
  m34MonthsAgo?: Maybe<Scalars['Float']>;
  m35MonthsAgo?: Maybe<Scalars['Float']>;
  mCurrentMonth?: Maybe<Scalars['Float']>;
  manufacturer?: Maybe<Scalars['String']>;
  minimumLot?: Maybe<Scalars['Int']>;
  planningUserName?: Maybe<Scalars['String']>;
  previousArrivalDate?: Maybe<Scalars['String']>;
  previousArrivalQuantity?: Maybe<Scalars['Float']>;
  previousDailyAverageShipmentQuantity?: Maybe<Scalars['Float']>;
  previousDio?: Maybe<Scalars['Float']>;
  previousOrderDate?: Maybe<Scalars['String']>;
  previousOrderToArrivalLeadTime?: Maybe<Scalars['Float']>;
  previousTotalShipmentCustomers?: Maybe<Scalars['Float']>;
  previousTotalShipmentQuantity?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productGroupName1?: Maybe<Scalars['String']>;
  productGroupName2?: Maybe<Scalars['String']>;
  productGroupName3?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  remainingOrderQuantity?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  thirdPreviousArrivalDate?: Maybe<Scalars['String']>;
  thirdPreviousArrivalQuantity?: Maybe<Scalars['Float']>;
  thirdPreviousDailyAverageShipmentQuantity?: Maybe<Scalars['Float']>;
  thirdPreviousDio?: Maybe<Scalars['Float']>;
  thirdPreviousOrderDate?: Maybe<Scalars['String']>;
  thirdPreviousOrderToArrivalLeadTime?: Maybe<Scalars['Float']>;
  thirdPreviousTotalShipmentCustomers?: Maybe<Scalars['Float']>;
  thirdPreviousTotalShipmentQuantity?: Maybe<Scalars['Float']>;
  totalSalesDate?: Maybe<Scalars['Int']>;
  totalStock?: Maybe<Scalars['Int']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type PurchaseKoreConnection = {
  __typename?: 'PurchaseKoreConnection';
  edges?: Maybe<Array<Maybe<PurchaseKoreEdge>>>;
  exchangeRate?: Maybe<Scalars['Float']>;
  pageInfo?: Maybe<PurchaseKorePageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PurchaseKoreEdge = {
  __typename?: 'PurchaseKoreEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PurchaseKore>;
};

export type PurchaseKorePageInfo = {
  __typename?: 'PurchaseKorePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PurchaseSortEnum {
  ArrivalIdAsc = 'ARRIVAL_ID_ASC',
  ArrivalIdDesc = 'ARRIVAL_ID_DESC',
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  ClosingTimingAsc = 'CLOSING_TIMING_ASC',
  ClosingTimingDesc = 'CLOSING_TIMING_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PoCodeAsc = 'PO_CODE_ASC',
  PoCodeDesc = 'PO_CODE_DESC',
  PurchaseDateAsc = 'PURCHASE_DATE_ASC',
  PurchaseDateDesc = 'PURCHASE_DATE_DESC',
  PurchaseIdAsc = 'PURCHASE_ID_ASC',
  PurchaseIdDesc = 'PURCHASE_ID_DESC',
  PurchaseRemarkAsc = 'PURCHASE_REMARK_ASC',
  PurchaseRemarkDesc = 'PURCHASE_REMARK_DESC',
  PurchaseVoucherTypeAsc = 'PURCHASE_VOUCHER_TYPE_ASC',
  PurchaseVoucherTypeDesc = 'PURCHASE_VOUCHER_TYPE_DESC',
  TaxExcludedTotalAsc = 'TAX_EXCLUDED_TOTAL_ASC',
  TaxExcludedTotalDesc = 'TAX_EXCLUDED_TOTAL_DESC',
  TaxIncludedTotalAsc = 'TAX_INCLUDED_TOTAL_ASC',
  TaxIncludedTotalDesc = 'TAX_INCLUDED_TOTAL_DESC',
  TotalDollarAsc = 'TOTAL_DOLLAR_ASC',
  TotalDollarDesc = 'TOTAL_DOLLAR_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VendorTaxTypeAsc = 'VENDOR_TAX_TYPE_ASC',
  VendorTaxTypeDesc = 'VENDOR_TAX_TYPE_DESC',
  VendorTradeDivisionAsc = 'VENDOR_TRADE_DIVISION_ASC',
  VendorTradeDivisionDesc = 'VENDOR_TRADE_DIVISION_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Query = {
  __typename?: 'Query';
  address?: Maybe<Address>;
  allAgents?: Maybe<AgentConnection>;
  allArrival?: Maybe<ArrivalConnection>;
  allArrivalDetail?: Maybe<ArrivalDetailConnection>;
  allArrivalTaxDetail?: Maybe<ArrivalTaxDetailConnection>;
  allAutoDeposit?: Maybe<AutoDepositConnection>;
  allAutoDepositDetail?: Maybe<AutoDepositDetailConnection>;
  allAutoWithdrawalDetail?: Maybe<AutoWithdrawalDetailConnection>;
  allComponentDetail?: Maybe<ComponentDetailConnection>;
  allCorporation?: Maybe<CorporationConnection>;
  allCustomerClosing?: Maybe<CustomerClosingConnection>;
  allDeliver?: Maybe<DeliverConnection>;
  allDemandTaxAdjustDetail?: Maybe<DemandTaxAdjustDetailConnection>;
  allDemandTaxDetail?: Maybe<DemandTaxDetailConnection>;
  allDepositClearingDetail?: Maybe<DepositClearingDetailConnection>;
  allDepositDetail?: Maybe<DepositDetailConnection>;
  allDepositDivision?: Maybe<DepositDivisionConnection>;
  allDesignUser?: Maybe<DesignUserConnection>;
  allEstimateDetail?: Maybe<EstimateDetailConnection>;
  allInformation?: Maybe<InformationConnection>;
  allInformationDetail?: Maybe<InformationDetailConnection>;
  allInventoryDetail?: Maybe<InventoryDetailConnection>;
  allInventoryDivision?: Maybe<InventoryDivisionConnection>;
  allMonthlyStock?: Maybe<MonthlyStockConnection>;
  allPaymentDivision?: Maybe<PaymentDivisionConnection>;
  allPaymentTaxAdjustDetail?: Maybe<PaymentTaxAdjustDetailConnection>;
  allPaymentTaxDetail?: Maybe<PaymentTaxDetailConnection>;
  allPlanningUser?: Maybe<PlanningUserConnection>;
  allProductVariants?: Maybe<ProductVariantConnection>;
  allProductionDetail?: Maybe<ProductionDetailConnection>;
  allReceiveOrderDetails?: Maybe<ReceiveOrderDetailConnection>;
  allReceiveOrderHeaders?: Maybe<ReceiveOrderHeaderConnection>;
  allShipment?: Maybe<ShipmentConnection>;
  allShipmentDetail?: Maybe<ShipmentDetailConnection>;
  allStockAdjustDetail?: Maybe<StockAdjustDetailConnection>;
  allStockDisposal?: Maybe<StockDisposalConnection>;
  allStockDisposalDetail?: Maybe<StockDisposalDetailConnection>;
  allSystemSetting?: Maybe<SystemSettingConnection>;
  allTotalDemandDetail?: Maybe<TotalDemandDetailConnection>;
  allTotalDemandTaxDetail?: Maybe<TotalDemandTaxDetailConnection>;
  allTrustInventory?: Maybe<TrustInventoryConnection>;
  allTrustInventoryDetail?: Maybe<TrustInventoryDetailConnection>;
  allTrustStock?: Maybe<TrustStockConnection>;
  allVendorClosing?: Maybe<VendorClosingConnection>;
  allWarehouseMoveDetail?: Maybe<WarehouseMoveDetailConnection>;
  allWithdrawal?: Maybe<AutoWithdrawalConnection>;
  allWithdrawalDetail?: Maybe<WithdrawalDetailConnection>;
  arrival?: Maybe<Arrival>;
  arrivalDetail?: Maybe<ArrivalDetail>;
  arrivalTaxDetail?: Maybe<ArrivalTaxDetail>;
  autoDeposit?: Maybe<AutoDeposit>;
  autoDepositDetail?: Maybe<AutoDepositDetail>;
  autoWithdrawal?: Maybe<AutoWithdrawal>;
  autoWithdrawalDetail?: Maybe<AutoWithdrawalDetail>;
  component?: Maybe<Component>;
  componentDetail?: Maybe<ComponentDetail>;
  corporation?: Maybe<Corporation>;
  createDispTrustinventory?: Maybe<CreateDispTrustInventoryConnection>;
  createDispTrustinventoryUniqueCode?: Maybe<CreateDispTrustInventoryConnection>;
  customer?: Maybe<Customer>;
  customerClosing?: Maybe<CustomerClosing>;
  customerPrice?: Maybe<CustomerPrice>;
  customerUser?: Maybe<CustomerUser>;
  customersByCode?: Maybe<Array<Maybe<Customer>>>;
  deliver?: Maybe<Deliver>;
  demand?: Maybe<Demand>;
  demandTaxAdjustDetail?: Maybe<DemandTaxAdjustDetail>;
  demandTaxDetail?: Maybe<DemandTaxDetail>;
  deposit?: Maybe<Deposit>;
  depositClearingDetail?: Maybe<DepositClearingDetail>;
  depositDetail?: Maybe<DepositDetail>;
  depositDivision?: Maybe<DepositDivision>;
  designUser?: Maybe<DesignUser>;
  division?: Maybe<Division>;
  divisionFinancialDate?: Maybe<DivisionFinancialDate>;
  divisionGrades?: Maybe<Array<Maybe<DivisionGrades>>>;
  divisionTerms?: Maybe<DivisionTerms>;
  estimate?: Maybe<Estimate>;
  estimateDetail?: Maybe<EstimateDetail>;
  estimateView?: Maybe<EstimateView>;
  exchange?: Maybe<Exchange>;
  exportProductFromPurchaseKore?: Maybe<PurchaseKoreConnection>;
  financialDate?: Maybe<FinancialDate>;
  fkorderInformation?: Maybe<FkorderInformation>;
  fkorderInformationAttachment?: Maybe<FkorderInformationAttachment>;
  fkorderPublication?: Maybe<Array<Maybe<FkorderPublication>>>;
  getFinancialDate?: Maybe<FinancialDateConnection>;
  getNotification?: Maybe<NotificationConnection>;
  getTaxDivision?: Maybe<TaxDivisionConnection>;
  information?: Maybe<Information>;
  informationDetail?: Maybe<InformationDetail>;
  initialReceiveOrderHeader?: Maybe<InitialReceiveOrderHeader>;
  inventory?: Maybe<Inventory>;
  inventoryDetail?: Maybe<InventoryDetail>;
  inventoryDivision?: Maybe<InventoryDivision>;
  loginUserAgents?: Maybe<AgentConnection>;
  monthlyStock?: Maybe<MonthlyStock>;
  node?: Maybe<Node>;
  partialQueryByLotGroup?: Maybe<PartialQueryByLotGroup>;
  partialQueryByProduct?: Maybe<PartialQueryByProduct>;
  payment?: Maybe<Payment>;
  paymentDivision?: Maybe<PaymentDivision>;
  paymentTaxAdjustDetail?: Maybe<PaymentTaxAdjustDetail>;
  paymentTaxDetail?: Maybe<PaymentTaxDetail>;
  planningUser?: Maybe<PlanningUser>;
  product?: Maybe<Product>;
  productFromUniqueCode?: Maybe<Product>;
  productGroup?: Maybe<ProductGroup>;
  productHistory?: Maybe<ProductHistory>;
  productListView?: Maybe<ProductListView>;
  productNoPriceView?: Maybe<ProductNoPriceView>;
  productPrice?: Maybe<ProductPrice>;
  productVariant?: Maybe<ProductVariant>;
  productView?: Maybe<ProductView>;
  production?: Maybe<Production>;
  productionDetail?: Maybe<ProductionDetail>;
  purchase?: Maybe<Purchase>;
  purchaseDetail?: Maybe<PurchaseDetail>;
  receiveOrderDetail?: Maybe<ReceiveOrderDetail>;
  receiveOrderHeader?: Maybe<ReceiveOrderHeader>;
  receiveOrderView?: Maybe<ReceiveOrderView>;
  reportLayout?: Maybe<ReportLayout>;
  sales?: Maybe<Sales>;
  salesDetail?: Maybe<SalesDetail>;
  salesDetailWTax?: Maybe<SalesDetailWTax>;
  searchAddress?: Maybe<AddressConnection>;
  searchArrival?: Maybe<ArrivalConnection>;
  searchBeforeDemandClosing?: Maybe<BeforeDemandClosingConnection>;
  searchClosedPayment?: Maybe<PaymentConnection>;
  searchClothProgress?: Maybe<ClothProgressConnection>;
  searchCollectionPlan?: Maybe<DemandConnection>;
  searchCollectionStatus?: Maybe<CollectionStatusConnection>;
  searchComponent?: Maybe<ComponentConnection>;
  searchComponentWithPrice?: Maybe<ComponentWithPrice>;
  searchCustomer?: Maybe<CustomerConnection>;
  searchCustomerBudget?: Maybe<CustomerBudgetsCustomConnection>;
  searchCustomerDemand?: Maybe<CustomerConnection>;
  searchCustomerFromCode?: Maybe<CustomerConnection>;
  searchCustomerPrice?: Maybe<CustomerPriceConnection>;
  searchCustomerPriceList?: Maybe<CustomerPriceListResult>;
  searchCustomerProductGroupPublications?: Maybe<Array<Maybe<CustomerProductGroupPublicationNode>>>;
  searchCustomerProductPublications?: Maybe<Array<Maybe<CustomerProductPublicationNode>>>;
  searchCustomerSales?: Maybe<SalesConnection>;
  searchCustomerSalesMonthly?: Maybe<CustomerSalesMonthlyConnection>;
  searchCustomerUser?: Maybe<CustomerUserConnection>;
  searchCustomerWithCarryOver?: Maybe<CustomerWithCarryOverConnection>;
  searchDeliver?: Maybe<DeliverConnection>;
  searchDemandClosing?: Maybe<DemandConnection>;
  searchDemandCustomerSales?: Maybe<DemandConnection>;
  searchDemandHistory?: Maybe<DemandConnection>;
  searchDemandNotClearing?: Maybe<DemandConnection>;
  searchDemandReport?: Maybe<DemandConnection>;
  searchDeposit?: Maybe<DepositConnection>;
  searchDepositCustomerSales?: Maybe<DepositConnection>;
  searchDepositDemandDetail?: Maybe<DepositConnection>;
  searchDepositDivision?: Maybe<DepositDivisionConnection>;
  searchDepositDivisionKeyword?: Maybe<DepositDivisionConnection>;
  searchDirectlyPurchase?: Maybe<DirectlyPurchaseConnection>;
  searchDivision?: Maybe<DivisionConnection>;
  searchDivisionFinancialDate?: Maybe<DivisionFinancialDateConnection>;
  searchEstimate?: Maybe<EstimateConnection>;
  searchEstimateView?: Maybe<EstimateViewConnection>;
  searchExchange?: Maybe<ExchangeConnection>;
  searchFinancialDateDetail?: Maybe<SearchFinancialDateDetailConnection>;
  searchFkorderInformation?: Maybe<FkorderInformationConnection>;
  searchInternalTransaction?: Maybe<SearchInternalTransactionConnection>;
  searchInventory?: Maybe<InventoryConnection>;
  searchInventoryDetail?: Maybe<InventoryDetailConnection>;
  searchInventoryDetailCustom?: Maybe<InventoryDetailCustom>;
  searchInventoryDetailUnique?: Maybe<InventoryDetailConnection>;
  searchInventoryDivision?: Maybe<InventoryDivisionConnection>;
  searchLotGroupProduct?: Maybe<LotGroupProductConnection>;
  searchOrderName?: Maybe<SearchOrderName>;
  searchPayableBalanceList?: Maybe<PayableBalanceConnection>;
  searchPaymentDivision?: Maybe<PaymentDivisionConnection>;
  searchPaymentHistory?: Maybe<PaymentConnection>;
  searchPaymentVendorPurchase?: Maybe<PaymentConnection>;
  searchProduct?: Maybe<ProductConnection>;
  searchProductFromPurchaseKore?: Maybe<PurchaseKoreConnection>;
  searchProductFromUniqueCode?: Maybe<ProductConnection>;
  searchProductGroup?: Maybe<ProductGroupConnection>;
  searchProductGroupByCode?: Maybe<Array<Maybe<ProductGroup>>>;
  searchProductGroupFromCode?: Maybe<ProductGroupConnection>;
  searchProductHistory?: Maybe<ProductHistoryConnection>;
  searchProductListView?: Maybe<ProductListViewConnection>;
  searchProductListViewFromPriceCard?: Maybe<ProductListViewConnection>;
  searchProductNoPriceView?: Maybe<Array<Maybe<ProductNoPriceView>>>;
  searchProductPrice?: Maybe<ProductPriceConnection>;
  searchProductPriceFromTargetDate?: Maybe<ProductPriceConnection>;
  searchProductStockByDivision?: Maybe<ProductStockByDivisionConnection>;
  searchProductStockForAdjust?: Maybe<ProductStockForAdjustConnection>;
  searchProductStockForWarehouseMove?: Maybe<ProductStockByWarehouseConnection>;
  searchProductStockForWarehouseMoveEx?: Maybe<ProductStockByWarehouseExConnection>;
  searchProductView?: Maybe<ProductViewConnection>;
  searchProductViewWithCustomer?: Maybe<ProductViewWithCustomerConnection>;
  searchProductViewWithOutsourcer?: Maybe<ProductViewWithOutsourcerConnection>;
  searchProductViewWithProductCodes?: Maybe<ProductViewWithProductCodesConnection>;
  searchProductViewWithVendor?: Maybe<ProductViewWithVendorConnection>;
  searchProductViewsWithCustomer?: Maybe<ProductViewsWithCustomerConnection>;
  searchProductViewsWithOutsourcer?: Maybe<ProductViewsWithOutsourcerConnection>;
  searchProductViewsWithVendor?: Maybe<ProductViewsWithVendorConnection>;
  searchProductWithJan?: Maybe<ProductConnection>;
  searchProduction?: Maybe<ProductionConnection>;
  searchProductsByProductCodes?: Maybe<ProductViewConnection>;
  searchPurchase?: Maybe<PurchaseConnection>;
  searchPurchaseAnalyticsList?: Maybe<PurchaseAnalyticsConnection>;
  searchPurchaseDailyList?: Maybe<PurchaseDailyConnection>;
  searchPurchasePaymentDetail?: Maybe<PurchaseConnection>;
  searchPurchaseUnitHistory?: Maybe<SearchPurchaseUnitHistoryConnection>;
  searchReceivableBalanceList?: Maybe<ReceivableBalanceConnection>;
  searchReceiveOrder?: Maybe<ReceiveOrderHeaderConnection>;
  searchReceiveOrderDetail?: Maybe<SearchReceiveOrderDetailConnection>;
  searchReceiveOrderForApproval?: Maybe<ReceiveOrderHeaderConnection>;
  searchReceiveOrderForConfirmed?: Maybe<ReceiveOrderHeaderConnection>;
  searchReceiveOrderSalesUnitPriceUpdate?: Maybe<ReceiveOrderDetailConnection>;
  searchReceiveOrderView?: Maybe<ReceiveOrderViewConnection>;
  searchReceiveRemain?: Maybe<ReceiveOrderDetailConnection>;
  searchReceiveRemainByProduct?: Maybe<SearchReceiveRemainByProductConnection>;
  searchReportLayout?: Maybe<ReportLayoutConnection>;
  searchSales?: Maybe<SalesConnection>;
  searchSalesAnalyticsComparisontable?: Maybe<SalesAnalyticsComparisonTableConnection>;
  searchSalesAnalyticsCustomer?: Maybe<SalesAnalyticsCustomerConnection>;
  searchSalesAnalyticsDeliver?: Maybe<SalesAnalyticsDeliverConnection>;
  searchSalesAnalyticsDivision?: Maybe<SalesAnalyticsDivisionConnection>;
  searchSalesAnalyticsDivisionProduct?: Maybe<SalesAnalyticsDivisionProductConnection>;
  searchSalesAnalyticsProduct?: Maybe<SalesAnalyticsProductConnection>;
  searchSalesAnalyticsSalesUser?: Maybe<SalesAnalyticsSalesUserConnection>;
  searchSalesChangingListCustomer?: Maybe<SalesChangingListCustomerConnection>;
  searchSalesChangingListProduct?: Maybe<SalesChangingListProductConnection>;
  searchSalesDailyCustomer?: Maybe<SalesDailyCustomerConnection>;
  searchSalesDailyDivision?: Maybe<SalesDailyDivisionConnection>;
  searchSalesDailyProduct?: Maybe<SalesDailyProductConnection>;
  searchSalesDailySalesuser?: Maybe<SalesDailySalesUserConnection>;
  searchSalesDemandDetail?: Maybe<SalesConnection>;
  searchSalesDetailProduct?: Maybe<SalesDetailConnection>;
  searchSalesFromDeliveryOrderId?: Maybe<SalesConnection>;
  searchSalesFromDeliveryOrderId2?: Maybe<SalesConnection>;
  searchSendOrder?: Maybe<SendOrderConnection>;
  searchSendOrderDetail?: Maybe<SendOrderDetailConnection>;
  searchSendOrderLot?: Maybe<SendOrderLotConnection>;
  searchSendOrderPurchaseUnitPriceUpdate?: Maybe<SearchSendOrderPurchaseUnitPriceConnection>;
  searchSendOrderView?: Maybe<SendOrderViewConnection>;
  searchSendOrderViewUnapproved?: Maybe<SendOrderViewConnection>;
  searchSendRemain?: Maybe<SendOrderDetailConnection>;
  searchSendRemainByProduct?: Maybe<SearchSendRemainByProductConnection>;
  searchShipment?: Maybe<ShipmentConnection>;
  searchShipmentDetailProduct?: Maybe<ShipmentDetailConnection>;
  searchShopsTrustInventory?: Maybe<Array<Maybe<SearchShopsTrustInventoryDetail>>>;
  searchShopsTrustInventoryOperators?: Maybe<Array<Maybe<SearchShopsTrustInventoryOperators>>>;
  searchStockAdjust?: Maybe<StockAdjustConnection>;
  searchStockAnalyticsInventory?: Maybe<StockAnalyticsConnection>;
  searchStockAnalyticsInventoryUnique?: Maybe<StockAnalyticsConnection>;
  searchStockAnalyticsMonth?: Maybe<StockAnalyticsMonthConnection>;
  searchStockAnalyticsMonthUnique?: Maybe<StockAnalyticsMonthConnection>;
  searchStockAnalyticsTerm?: Maybe<StockAnalyticsConnection>;
  searchStockAnalyticsTermUnique?: Maybe<StockAnalyticsConnection>;
  searchStockByWarehouse?: Maybe<SearchStockByWarehouseConnection>;
  searchStockListByDivision?: Maybe<StockListByDivisionConnection>;
  searchStockListByProduct?: Maybe<StockListByProductConnection>;
  searchStockListByWarehouse?: Maybe<StockListByWarehouseConnection>;
  searchTermsAndConditions?: Maybe<TermsAndConditionsConnection>;
  searchTradeHistory?: Maybe<TradeHistoryConnection>;
  searchTradeHistoryByMonth?: Maybe<TradeHistoryByMonthConnection>;
  searchTradeHistoryForDialog?: Maybe<SearchTradeHistoryForDialogConnection>;
  searchTradeHistoryStock?: Maybe<TradeHistoryStock>;
  searchTrustInventory?: Maybe<TrustInventoryConnection>;
  searchTrustSales?: Maybe<SalesConnection>;
  searchUnitHistory?: Maybe<SearchUnitHistoryConnection>;
  searchUnitHistoryTrust?: Maybe<SearchUnitHistoryTrustConnection>;
  searchUser?: Maybe<UserConnection>;
  searchVendor?: Maybe<VendorConnection>;
  searchVendorFromCode?: Maybe<VendorConnection>;
  searchVendorPayment?: Maybe<VendorConnection>;
  searchVendorPurchase?: Maybe<PurchaseConnection>;
  searchVendorPurchaseMonthly?: Maybe<VendorPurchaseMonthlyConnection>;
  searchVendorWithCarryOver?: Maybe<VendorWithCarryOverConnection>;
  searchWarehouse?: Maybe<WarehouseConnection>;
  searchWarehouseMove?: Maybe<WarehouseMoveConnection>;
  searchWarehouseMoveDetail?: Maybe<SearchWarehouseMoveDetailConnection>;
  searchWithdrawal?: Maybe<WithdrawalConnection>;
  searchWithdrawalMonthly?: Maybe<WithDrawalsMonthlyConnection>;
  searchWithdrawalPaymentDetail?: Maybe<WithdrawalConnection>;
  searchWithdrawalVendorPurchase?: Maybe<WithdrawalConnection>;
  sendOrder?: Maybe<SendOrder>;
  sendOrderDetail?: Maybe<SendOrderDetail>;
  sendOrderLot?: Maybe<SendOrderLot>;
  sendOrderView?: Maybe<SendOrderView>;
  shipment?: Maybe<Shipment>;
  shipmentDetail?: Maybe<ShipmentDetail>;
  shipmentTaxDetail?: Maybe<ShipmentTaxDetail>;
  stockAdjust?: Maybe<StockAdjust>;
  stockAdjustDetail?: Maybe<StockAdjustDetail>;
  stockAlert?: Maybe<StockAlert>;
  stockDisposal?: Maybe<StockDisposal>;
  stockDisposalDetail?: Maybe<StockDisposalDetail>;
  svfAccessToken?: Maybe<Scalars['String']>;
  systemSetting?: Maybe<SystemSetting>;
  taxDivision?: Maybe<TaxDivision>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  totalDemandDetail?: Maybe<TotalDemandDetail>;
  totalDemandTaxDetail?: Maybe<TotalDemandTaxDetail>;
  tradeHistory?: Maybe<TradeHistory>;
  trustInventory?: Maybe<TrustInventory>;
  trustInventoryDetail?: Maybe<TrustInventoryDetail>;
  trustStock?: Maybe<TrustStock>;
  updateDispTrustinventory?: Maybe<UpdateDispTrustInventory>;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
  vendorClosing?: Maybe<VendorClosing>;
  warehouse?: Maybe<Warehouse>;
  warehouseMove?: Maybe<WarehouseMove>;
  warehouseMoveDetail?: Maybe<WarehouseMoveDetail>;
  withdrawal?: Maybe<Withdrawal>;
  withdrawalDetail?: Maybe<WithdrawalDetail>;
};


export type QueryAddressArgs = {
  id: Scalars['ID'];
};


export type QueryAllAgentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllArrivalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalSortEnum>>>;
};


export type QueryAllArrivalDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalDetailSortEnum>>>;
};


export type QueryAllArrivalTaxDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalTaxDetailSortEnum>>>;
};


export type QueryAllAutoDepositArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<AutoDepositSortEnum>>>;
};


export type QueryAllAutoDepositDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<AutoDepositDetailSortEnum>>>;
};


export type QueryAllAutoWithdrawalDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<AutoWithdrawalDetailSortEnum>>>;
};


export type QueryAllComponentDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ComponentDetailSortEnum>>>;
};


export type QueryAllCorporationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CorporationSortEnum>>>;
};


export type QueryAllCustomerClosingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerClosingSortEnum>>>;
};


export type QueryAllDeliverArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DeliverSortEnum>>>;
};


export type QueryAllDemandTaxAdjustDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandTaxAdjustDetailSortEnum>>>;
};


export type QueryAllDemandTaxDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandTaxDetailSortEnum>>>;
};


export type QueryAllDepositClearingDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositClearingDetailSortEnum>>>;
};


export type QueryAllDepositDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositDetailSortEnum>>>;
};


export type QueryAllDepositDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositDivisionSortEnum>>>;
};


export type QueryAllDesignUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DesignUserSortEnum>>>;
};


export type QueryAllEstimateDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<EstimateDetailSortEnum>>>;
};


export type QueryAllInformationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InformationSortEnum>>>;
};


export type QueryAllInformationDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InformationDetailSortEnum>>>;
};


export type QueryAllInventoryDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDetailSortEnum>>>;
};


export type QueryAllInventoryDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDivisionSortEnum>>>;
};


export type QueryAllMonthlyStockArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<MonthlyStockSortEnum>>>;
};


export type QueryAllPaymentDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentDivisionSortEnum>>>;
};


export type QueryAllPaymentTaxAdjustDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentTaxAdjustDetailSortEnum>>>;
};


export type QueryAllPaymentTaxDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentTaxDetailSortEnum>>>;
};


export type QueryAllPlanningUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PlanningUserSortEnum>>>;
};


export type QueryAllProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductVariantSortEnum>>>;
};


export type QueryAllProductionDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductionDetailSortEnum>>>;
};


export type QueryAllReceiveOrderDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderDetailSortEnum>>>;
};


export type QueryAllReceiveOrderHeadersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>>>;
};


export type QueryAllShipmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentSortEnum>>>;
};


export type QueryAllShipmentDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentDetailSortEnum>>>;
};


export type QueryAllStockAdjustDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<StockAdjustDetailSortEnum>>>;
};


export type QueryAllStockDisposalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<StockDisposalSortEnum>>>;
};


export type QueryAllStockDisposalDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<StockDisposalDetailSortEnum>>>;
};


export type QueryAllSystemSettingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SystemSettingSortEnum>>>;
};


export type QueryAllTotalDemandDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TotalDemandDetailSortEnum>>>;
};


export type QueryAllTotalDemandTaxDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TotalDemandTaxDetailSortEnum>>>;
};


export type QueryAllTrustInventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TrustInventorySortEnum>>>;
};


export type QueryAllTrustInventoryDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TrustInventoryDetailSortEnum>>>;
};


export type QueryAllTrustStockArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TrustStockSortEnum>>>;
};


export type QueryAllVendorClosingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<VendorClosingSortEnum>>>;
};


export type QueryAllWarehouseMoveDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseMoveDetailSortEnum>>>;
};


export type QueryAllWithdrawalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<AutoWithdrawalSortEnum>>>;
};


export type QueryAllWithdrawalDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WithdrawalDetailSortEnum>>>;
};


export type QueryArrivalArgs = {
  id: Scalars['ID'];
};


export type QueryArrivalDetailArgs = {
  id: Scalars['ID'];
};


export type QueryArrivalTaxDetailArgs = {
  id: Scalars['ID'];
};


export type QueryAutoDepositArgs = {
  id: Scalars['ID'];
};


export type QueryAutoDepositDetailArgs = {
  id: Scalars['ID'];
};


export type QueryAutoWithdrawalArgs = {
  id: Scalars['ID'];
};


export type QueryAutoWithdrawalDetailArgs = {
  id: Scalars['ID'];
};


export type QueryComponentArgs = {
  id: Scalars['ID'];
};


export type QueryComponentDetailArgs = {
  id: Scalars['ID'];
};


export type QueryCorporationArgs = {
  id: Scalars['ID'];
};


export type QueryCreateDispTrustinventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCreateDispTrustInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCreateDispTrustinventoryUniqueCodeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCreateDispTrustInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerClosingArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerPriceArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerUserArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersByCodeArgs = {
  filter?: InputMaybe<SearchCustomerFromCodeFilter>;
};


export type QueryDeliverArgs = {
  id: Scalars['ID'];
};


export type QueryDemandArgs = {
  id: Scalars['ID'];
};


export type QueryDemandTaxAdjustDetailArgs = {
  id: Scalars['ID'];
};


export type QueryDemandTaxDetailArgs = {
  id: Scalars['ID'];
};


export type QueryDepositArgs = {
  id: Scalars['ID'];
};


export type QueryDepositClearingDetailArgs = {
  id: Scalars['ID'];
};


export type QueryDepositDetailArgs = {
  id: Scalars['ID'];
};


export type QueryDepositDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryDesignUserArgs = {
  id: Scalars['ID'];
};


export type QueryDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryDivisionFinancialDateArgs = {
  id: Scalars['ID'];
};


export type QueryEstimateArgs = {
  id: Scalars['ID'];
};


export type QueryEstimateDetailArgs = {
  id: Scalars['ID'];
};


export type QueryEstimateViewArgs = {
  id: Scalars['ID'];
};


export type QueryExchangeArgs = {
  id: Scalars['ID'];
};


export type QueryExportProductFromPurchaseKoreArgs = {
  filter?: InputMaybe<SearchProductInPurchaseKoreFilter>;
};


export type QueryFinancialDateArgs = {
  id: Scalars['ID'];
};


export type QueryFkorderInformationArgs = {
  id: Scalars['ID'];
};


export type QueryFkorderInformationAttachmentArgs = {
  id: Scalars['ID'];
};


export type QueryGetFinancialDateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<FinancialDateSortEnum>>>;
};


export type QueryGetNotificationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  userCode: Scalars['String'];
};


export type QueryGetTaxDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TaxDivisionSortEnum>>>;
};


export type QueryInformationArgs = {
  id: Scalars['ID'];
};


export type QueryInformationDetailArgs = {
  id: Scalars['ID'];
};


export type QueryInitialReceiveOrderHeaderArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryInventoryDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryLoginUserAgentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMonthlyStockArgs = {
  id: Scalars['ID'];
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryPartialQueryByLotGroupArgs = {
  filter?: InputMaybe<PartialQueryByLotGroupFilter>;
};


export type QueryPartialQueryByProductArgs = {
  filter?: InputMaybe<PartialQueryByProductFilter>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentTaxAdjustDetailArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentTaxDetailArgs = {
  id: Scalars['ID'];
};


export type QueryPlanningUserArgs = {
  id: Scalars['ID'];
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductFromUniqueCodeArgs = {
  id: Scalars['ID'];
};


export type QueryProductGroupArgs = {
  id: Scalars['ID'];
};


export type QueryProductHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryProductListViewArgs = {
  id: Scalars['ID'];
};


export type QueryProductNoPriceViewArgs = {
  id: Scalars['ID'];
};


export type QueryProductPriceArgs = {
  id: Scalars['ID'];
};


export type QueryProductVariantArgs = {
  id: Scalars['ID'];
};


export type QueryProductViewArgs = {
  id: Scalars['ID'];
};


export type QueryProductionArgs = {
  id: Scalars['ID'];
};


export type QueryProductionDetailArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseArgs = {
  id: Scalars['ID'];
};


export type QueryPurchaseDetailArgs = {
  id: Scalars['ID'];
};


export type QueryReceiveOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QueryReceiveOrderHeaderArgs = {
  id: Scalars['ID'];
};


export type QueryReceiveOrderViewArgs = {
  id: Scalars['ID'];
};


export type QueryReportLayoutArgs = {
  id: Scalars['ID'];
};


export type QuerySalesArgs = {
  id: Scalars['ID'];
};


export type QuerySalesDetailArgs = {
  id: Scalars['ID'];
};


export type QuerySalesDetailWTaxArgs = {
  filter?: InputMaybe<SalesDetailWTaxFilter>;
};


export type QuerySearchAddressArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchAddressFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<AddressSortEnum>>>;
};


export type QuerySearchArrivalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchArrivalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalSortEnum>>>;
};


export type QuerySearchBeforeDemandClosingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchBeforeDemandClosingListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchClosedPaymentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchClosedPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentSortEnum>>>;
};


export type QuerySearchClothProgressArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ClothProgressFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ClothProgressSortEnum>>>;
};


export type QuerySearchCollectionPlanArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCollectionPlanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchCollectionStatusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCollectionStatusFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchComponentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchComponentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ComponentSortEnum>>>;
};


export type QuerySearchComponentWithPriceArgs = {
  filter?: InputMaybe<ComponentWithPriceFilter>;
};


export type QuerySearchCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customFilter?: InputMaybe<SearchCustomerFilter>;
  filter?: InputMaybe<SearchCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSortEnum>>>;
};


export type QuerySearchCustomerBudgetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CustomerBudgetsCustomFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchCustomerDemandArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerDemandFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSortEnum>>>;
};


export type QuerySearchCustomerFromCodeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerFromCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSortEnum>>>;
};


export type QuerySearchCustomerPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerPriceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerPriceSortEnum>>>;
};


export type QuerySearchCustomerPriceListArgs = {
  filter?: InputMaybe<SearchCustomerPriceFilter>;
};


export type QuerySearchCustomerProductGroupPublicationsArgs = {
  filter?: InputMaybe<CustomerProductGroupPublicationFilter>;
};


export type QuerySearchCustomerProductPublicationsArgs = {
  filter?: InputMaybe<CustomerProductPublicationFilter>;
};


export type QuerySearchCustomerSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchCustomerSalesMonthlyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerSalesMontylyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchCustomerUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CustomerUserSortEnum>>>;
};


export type QuerySearchCustomerWithCarryOverArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerWithCarryOverFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchDeliverArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SeachDeliverFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DeliverSortEnum>>>;
};


export type QuerySearchDemandClosingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandClosingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchDemandCustomerSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandCustomerSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchDemandHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchDemandNotClearingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandNotClearingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchDemandReportArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandReportFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>>>;
};


export type QuerySearchDepositArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositSortEnum>>>;
};


export type QuerySearchDepositCustomerSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositCustomerSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositSortEnum>>>;
};


export type QuerySearchDepositDemandDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositDemandDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositSortEnum>>>;
};


export type QuerySearchDepositDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositDivisionSortEnum>>>;
};


export type QuerySearchDepositDivisionKeywordArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositDivisionKeywordFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DepositDivisionSortEnum>>>;
};


export type QuerySearchDirectlyPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DirectlyPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DivisionSortEnum>>>;
};


export type QuerySearchDivisionFinancialDateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDivisionFinancialDateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<DivisionFinancialDateSortEnum>>>;
};


export type QuerySearchEstimateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchEstimateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<EstimateSortEnum>>>;
};


export type QuerySearchEstimateViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchEstimateViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<EstimateViewSortEnum>>>;
};


export type QuerySearchExchangeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchFinancialDateDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFinancialDateDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchFkorderInformationArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFkorderInformationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<FkorderInformationSortEnum>>>;
};


export type QuerySearchInternalTransactionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInternalTransactionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchInventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventorySortEnum>>>;
};


export type QuerySearchInventoryDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDetailSortEnum>>>;
};


export type QuerySearchInventoryDetailCustomArgs = {
  filter?: InputMaybe<InventoryDetailCustomFilter>;
};


export type QuerySearchInventoryDetailUniqueArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryDetailUniqueFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDetailSortEnum>>>;
};


export type QuerySearchInventoryDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDivisionSortEnum>>>;
};


export type QuerySearchLotGroupProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<LotGroupProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchOrderNameArgs = {
  filter?: InputMaybe<SearchOrderNameFilter>;
};


export type QuerySearchPayableBalanceListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPayableBalanceListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchPaymentDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPaymentDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentDivisionSortEnum>>>;
};


export type QuerySearchPaymentHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPaymentHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentSortEnum>>>;
};


export type QuerySearchPaymentVendorPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPaymentVendorPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PaymentSortEnum>>>;
};


export type QuerySearchProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  exactMatch?: InputMaybe<SearchProductExactMatch>;
  filter?: InputMaybe<SearchProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductSortEnum>>>;
};


export type QuerySearchProductFromPurchaseKoreArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductInPurchaseKoreFilter>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductFromUniqueCodeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductFromUniqueCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductSortEnum>>>;
};


export type QuerySearchProductGroupArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductGroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductGroupSortEnum>>>;
};


export type QuerySearchProductGroupByCodeArgs = {
  filter?: InputMaybe<SearchProductGroupFilter>;
};


export type QuerySearchProductGroupFromCodeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductGroupFromCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductGroupSortEnum>>>;
};


export type QuerySearchProductHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductHistorySortEnum>>>;
};


export type QuerySearchProductListViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductListViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductListViewSortEnum>>>;
};


export type QuerySearchProductListViewFromPriceCardArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductsListViewFromPriceCardFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductListViewSortEnum>>>;
};


export type QuerySearchProductNoPriceViewArgs = {
  filter?: InputMaybe<SearchProductNoPriceViewFilter>;
};


export type QuerySearchProductPriceArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductPriceFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductPriceSortEnum>>>;
};


export type QuerySearchProductPriceFromTargetDateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductPriceFromTargetDateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductPriceSortEnum>>>;
};


export type QuerySearchProductStockByDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductStockByDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductStockForAdjustArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductStockForAdjustFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductStockForWarehouseMoveArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductStockByWarehouseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductStockForWarehouseMoveExArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductStockByWarehouseExFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductViewSortEnum>>>;
};


export type QuerySearchProductViewWithCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewWithCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewWithOutsourcerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewWithOutsourcerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewWithProductCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewWithProductCodesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewWithVendorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewWithVendorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewsWithCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewsWithCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewsWithOutsourcerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewsWithOutsourcerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductViewsWithVendorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewsWithVendorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchProductWithJanArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductWithJanFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductSortEnum>>>;
};


export type QuerySearchProductionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductionSortEnum>>>;
};


export type QuerySearchProductsByProductCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductsByProductCodesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProductViewSortEnum>>>;
};


export type QuerySearchPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>>>;
};


export type QuerySearchPurchaseAnalyticsListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseAnalyticsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchPurchaseDailyListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseDailyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchPurchasePaymentDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchasePaymentDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>>>;
};


export type QuerySearchPurchaseUnitHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseUnitHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchReceivableBalanceListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceivableBalanceListFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchReceiveOrderArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>>>;
};


export type QuerySearchReceiveOrderDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchReceiveOrderForApprovalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>>>;
};


export type QuerySearchReceiveOrderForConfirmedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>>>;
};


export type QuerySearchReceiveOrderSalesUnitPriceUpdateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderSalesUnitPriceUpdateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderDetailSortEnum>>>;
};


export type QuerySearchReceiveOrderViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrdeViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderViewSortEnum>>>;
};


export type QuerySearchReceiveRemainArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderRemainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderDetailSortEnum>>>;
};


export type QuerySearchReceiveRemainByProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveRemainByProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchReportLayoutArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReportLayoutFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ReportLayoutSortEnum>>>;
};


export type QuerySearchSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchSalesAnalyticsComparisontableArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsComparisonTableFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsDeliverArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDeliverFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsDivisionProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDivisionProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesAnalyticsSalesUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsSalesUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesChangingListCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesChangingListCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesChangingListProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesChangingListProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesDailyCustomerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyCustomerFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesDailyDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesDailyProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesDailySalesuserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailySalesUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSalesDemandDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDemandDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchSalesDetailProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesDetailSortEnum>>>;
};


export type QuerySearchSalesFromDeliveryOrderIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFromDeliveryOrderIdFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchSalesFromDeliveryOrderId2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFromDeliveryOrderId2Filter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchSendOrderArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderSortEnum>>>;
};


export type QuerySearchSendOrderDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderDetailSortEnum>>>;
};


export type QuerySearchSendOrderLotArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderLotFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderLotSortEnum>>>;
};


export type QuerySearchSendOrderPurchaseUnitPriceUpdateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderPurchaseUnitPriceUpdateFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchSendOrderViewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderViewFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderViewSortEnum>>>;
};


export type QuerySearchSendOrderViewUnapprovedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderViewUnapprovedFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderViewSortEnum>>>;
};


export type QuerySearchSendRemainArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderRemainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderDetailSortEnum>>>;
};


export type QuerySearchSendRemainByProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendRemainByProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchShipmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customSort?: InputMaybe<Array<InputMaybe<ShipmentCustomSortEnum>>>;
  filter?: InputMaybe<SearchShipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentSortEnum>>>;
};


export type QuerySearchShipmentDetailProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchShipmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentDetailSortEnum>>>;
};


export type QuerySearchShopsTrustInventoryArgs = {
  filter?: InputMaybe<SearchShopsTrustInventoryFilter>;
};


export type QuerySearchShopsTrustInventoryOperatorsArgs = {
  filter?: InputMaybe<SearchShopsTrustInventoryOperatorsFilter>;
};


export type QuerySearchStockAdjustArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAdjustFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<StockAdjustSortEnum>>>;
};


export type QuerySearchStockAnalyticsInventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockAnalyticsInventoryUniqueArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockAnalyticsMonthArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsMonthFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockAnalyticsMonthUniqueArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsMonthFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockAnalyticsTermArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsTermFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockAnalyticsTermUniqueArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsTermFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockByWarehouseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockByWarehouseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockListByDivisionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByDivisionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockListByProductArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByProductFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStockListByWarehouseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByWarehouseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchTermsAndConditionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTermsAndConditionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TermsAndConditionsSortEnum>>>;
};


export type QuerySearchTradeHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TradeHistorySortEnum>>>;
};


export type QuerySearchTradeHistoryByMonthArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryByMonthFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchTradeHistoryForDialogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryForDialogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchTradeHistoryStockArgs = {
  filter?: InputMaybe<SearchTradeHistoryStockFilter>;
};


export type QuerySearchTrustInventoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustInventoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<TrustInventorySortEnum>>>;
};


export type QuerySearchTrustSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustSalesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>>>;
};


export type QuerySearchUnitHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUnitHistoryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchUnitHistoryTrustArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUnitHistoryTrustFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<UserSortEnum>>>;
};


export type QuerySearchVendorArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<VendorSortEnum>>>;
};


export type QuerySearchVendorFromCodeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorFromCodeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<VendorSortEnum>>>;
};


export type QuerySearchVendorPaymentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorPaymentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<VendorSortEnum>>>;
};


export type QuerySearchVendorPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>>>;
};


export type QuerySearchVendorPurchaseMonthlyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorPurchaseMonthlyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchVendorWithCarryOverArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorWithCarryOverFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchWarehouseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseSortEnum>>>;
};


export type QuerySearchWarehouseMoveArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseMoveFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseMoveSortEnum>>>;
};


export type QuerySearchWarehouseMoveDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseMoveDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchWithdrawalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>>>;
};


export type QuerySearchWithdrawalMonthlyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithDrawalsMonthlyFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchWithdrawalPaymentDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithdrawalPaymentDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>>>;
};


export type QuerySearchWithdrawalVendorPurchaseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithdrawalVendorPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>>>;
};


export type QuerySendOrderArgs = {
  id: Scalars['ID'];
};


export type QuerySendOrderDetailArgs = {
  id: Scalars['ID'];
};


export type QuerySendOrderLotArgs = {
  id: Scalars['ID'];
};


export type QuerySendOrderViewArgs = {
  id: Scalars['ID'];
};


export type QueryShipmentArgs = {
  id: Scalars['ID'];
};


export type QueryShipmentDetailArgs = {
  id: Scalars['ID'];
};


export type QueryShipmentTaxDetailArgs = {
  id: Scalars['ID'];
};


export type QueryStockAdjustArgs = {
  id: Scalars['ID'];
};


export type QueryStockAdjustDetailArgs = {
  id: Scalars['ID'];
};


export type QueryStockAlertArgs = {
  filter?: InputMaybe<StockAlertFilter>;
};


export type QueryStockDisposalArgs = {
  id: Scalars['ID'];
};


export type QueryStockDisposalDetailArgs = {
  id: Scalars['ID'];
};


export type QuerySystemSettingArgs = {
  id: Scalars['ID'];
};


export type QueryTaxDivisionArgs = {
  id: Scalars['ID'];
};


export type QueryTermsAndConditionsArgs = {
  id: Scalars['ID'];
};


export type QueryTotalDemandDetailArgs = {
  id: Scalars['ID'];
};


export type QueryTotalDemandTaxDetailArgs = {
  id: Scalars['ID'];
};


export type QueryTradeHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryTrustInventoryArgs = {
  id: Scalars['ID'];
};


export type QueryTrustInventoryDetailArgs = {
  id: Scalars['ID'];
};


export type QueryTrustStockArgs = {
  id: Scalars['ID'];
};


export type QueryUpdateDispTrustinventoryArgs = {
  filter?: InputMaybe<SearchUpdateDispTrustInventoryFilter>;
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryVendorArgs = {
  id: Scalars['ID'];
};


export type QueryVendorClosingArgs = {
  id: Scalars['ID'];
};


export type QueryWarehouseArgs = {
  id: Scalars['ID'];
};


export type QueryWarehouseMoveArgs = {
  id: Scalars['ID'];
};


export type QueryWarehouseMoveDetailArgs = {
  id: Scalars['ID'];
};


export type QueryWithdrawalArgs = {
  id: Scalars['ID'];
};


export type QueryWithdrawalDetailArgs = {
  id: Scalars['ID'];
};

export type ReceivableBalance = Node & {
  __typename?: 'ReceivableBalance';
  beforeReceivableBalance?: Maybe<Scalars['Int']>;
  businessAmebaFlg?: Maybe<Scalars['String']>;
  carryOverBalance?: Maybe<Scalars['Int']>;
  cash?: Maybe<Scalars['Int']>;
  collectCycleCode?: Maybe<Scalars['String']>;
  collectDate?: Maybe<Scalars['Int']>;
  collectDays?: Maybe<Scalars['Int']>;
  collectPrice?: Maybe<Scalars['Int']>;
  commission?: Maybe<Scalars['Int']>;
  customerGroup?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerRank?: Maybe<Scalars['String']>;
  demandClosingGroupCode?: Maybe<Scalars['String']>;
  demandCode?: Maybe<Scalars['String']>;
  divisionBundle?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  draft?: Maybe<Scalars['Int']>;
  exciseTaxPer8?: Maybe<Scalars['Float']>;
  exciseTaxPer10?: Maybe<Scalars['Float']>;
  excludingTaxSales?: Maybe<Scalars['Int']>;
  expirationDate?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  monthBalance?: Maybe<Scalars['Int']>;
  otherPayment?: Maybe<Scalars['Int']>;
  receivablePrice?: Maybe<Scalars['Int']>;
  salesTradeDivision?: Maybe<Scalars['String']>;
  transfer?: Maybe<Scalars['Int']>;
  userCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type ReceivableBalanceConnection = {
  __typename?: 'ReceivableBalanceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReceivableBalanceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReceivableBalance` and its cursor. */
export type ReceivableBalanceEdge = {
  __typename?: 'ReceivableBalanceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReceivableBalance>;
};

export type ReceiveOrderDetail = Node & {
  __typename?: 'ReceiveOrderDetail';
  Warehouse?: Maybe<Warehouse>;
  approvalStatus: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveredQuantity?: Maybe<Scalars['Float']>;
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  estimateDetailId?: Maybe<Scalars['Int']>;
  frontNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: Maybe<Scalars['Float']>;
  receiveOrderDetailStatus: Scalars['String'];
  receiveOrderHeader?: Maybe<ReceiveOrderHeader>;
  receiveOrderId: Scalars['ID'];
  receiveOrderPrice?: Maybe<Scalars['Float']>;
  receiveOrderQuantity?: Maybe<Scalars['Float']>;
  receiveOrderUnit?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  taxDivision?: Maybe<TaxDivision>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type ReceiveOrderDetailConnection = {
  __typename?: 'ReceiveOrderDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReceiveOrderDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReceiveOrderDetail` and its cursor. */
export type ReceiveOrderDetailEdge = {
  __typename?: 'ReceiveOrderDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReceiveOrderDetail>;
};

export type ReceiveOrderDetailFilter = {
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum ReceiveOrderDetailSortEnum {
  ApprovalStatusAsc = 'APPROVAL_STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL_STATUS_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveredQuantityAsc = 'DELIVERED_QUANTITY_ASC',
  DeliveredQuantityDesc = 'DELIVERED_QUANTITY_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  EstimateDetailIdAsc = 'ESTIMATE_DETAIL_ID_ASC',
  EstimateDetailIdDesc = 'ESTIMATE_DETAIL_ID_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ReceiveDetailTradeTypeAsc = 'RECEIVE_DETAIL_TRADE_TYPE_ASC',
  ReceiveDetailTradeTypeDesc = 'RECEIVE_DETAIL_TRADE_TYPE_DESC',
  ReceiveOrderDecisionQuantityAsc = 'RECEIVE_ORDER_DECISION_QUANTITY_ASC',
  ReceiveOrderDecisionQuantityDesc = 'RECEIVE_ORDER_DECISION_QUANTITY_DESC',
  ReceiveOrderDetailStatusAsc = 'RECEIVE_ORDER_DETAIL_STATUS_ASC',
  ReceiveOrderDetailStatusDesc = 'RECEIVE_ORDER_DETAIL_STATUS_DESC',
  ReceiveOrderIdAsc = 'RECEIVE_ORDER_ID_ASC',
  ReceiveOrderIdDesc = 'RECEIVE_ORDER_ID_DESC',
  ReceiveOrderPriceAsc = 'RECEIVE_ORDER_PRICE_ASC',
  ReceiveOrderPriceDesc = 'RECEIVE_ORDER_PRICE_DESC',
  ReceiveOrderQuantityAsc = 'RECEIVE_ORDER_QUANTITY_ASC',
  ReceiveOrderQuantityDesc = 'RECEIVE_ORDER_QUANTITY_DESC',
  ReceiveOrderUnitAsc = 'RECEIVE_ORDER_UNIT_ASC',
  ReceiveOrderUnitDesc = 'RECEIVE_ORDER_UNIT_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type ReceiveOrderHeader = Node & {
  __typename?: 'ReceiveOrderHeader';
  completedDetailCount: Scalars['Int'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  customerGroup: Scalars['String'];
  customerWarehouseCode?: Maybe<Scalars['String']>;
  deliver?: Maybe<Deliver>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryStatus: Scalars['String'];
  demandCode: Scalars['String'];
  detailCount: Scalars['Int'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  estimateId?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  orderPath: Scalars['String'];
  ordererEmail1?: Maybe<Scalars['String']>;
  ordererEmail2?: Maybe<Scalars['String']>;
  ordererEmail3?: Maybe<Scalars['String']>;
  ordererName?: Maybe<Scalars['String']>;
  ordererRemark?: Maybe<Scalars['String']>;
  ordererTel?: Maybe<Scalars['String']>;
  provisionalCustomerName?: Maybe<Scalars['String']>;
  receiveOrderDate: Scalars['String'];
  receiveOrderDetails?: Maybe<ReceiveOrderDetailConnection>;
  receiveOrderId: Scalars['ID'];
  receiveOrderMemo?: Maybe<Scalars['String']>;
  receiveOrderRemarks?: Maybe<Scalars['String']>;
  receiveOrderStatus: Scalars['String'];
  receiveOrderTotalPrice?: Maybe<Scalars['Float']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: Maybe<Scalars['String']>;
  sales?: Maybe<Sales>;
  salesDate?: Maybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUser?: Maybe<User>;
  salesUserCode?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  shipment?: Maybe<Shipment>;
  tax8Per?: Maybe<Scalars['Float']>;
  tax10Per?: Maybe<Scalars['Float']>;
  taxExcludeTotal?: Maybe<Scalars['Float']>;
  taxExcluded8Per?: Maybe<Scalars['Float']>;
  taxExcluded10Per?: Maybe<Scalars['Float']>;
  undeliveredDetailCount: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};


export type ReceiveOrderHeaderReceiveOrderDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ReceiveOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ReceiveOrderHeaderConnection = {
  __typename?: 'ReceiveOrderHeaderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReceiveOrderHeaderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReceiveOrderHeader` and its cursor. */
export type ReceiveOrderHeaderEdge = {
  __typename?: 'ReceiveOrderHeaderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReceiveOrderHeader>;
};

/** An enumeration. */
export enum ReceiveOrderHeaderSortEnum {
  CompletedDetailCountAsc = 'COMPLETED_DETAIL_COUNT_ASC',
  CompletedDetailCountDesc = 'COMPLETED_DETAIL_COUNT_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerGroupAsc = 'CUSTOMER_GROUP_ASC',
  CustomerGroupDesc = 'CUSTOMER_GROUP_DESC',
  CustomerWarehouseCodeAsc = 'CUSTOMER_WAREHOUSE_CODE_ASC',
  CustomerWarehouseCodeDesc = 'CUSTOMER_WAREHOUSE_CODE_DESC',
  DeliveryDateAsc = 'DELIVERY_DATE_ASC',
  DeliveryDateDesc = 'DELIVERY_DATE_DESC',
  DeliveryDestinationCodeAsc = 'DELIVERY_DESTINATION_CODE_ASC',
  DeliveryDestinationCodeDesc = 'DELIVERY_DESTINATION_CODE_DESC',
  DeliveryDestinationNameAsc = 'DELIVERY_DESTINATION_NAME_ASC',
  DeliveryDestinationNameDesc = 'DELIVERY_DESTINATION_NAME_DESC',
  DeliveryStatusAsc = 'DELIVERY_STATUS_ASC',
  DeliveryStatusDesc = 'DELIVERY_STATUS_DESC',
  DemandCodeAsc = 'DEMAND_CODE_ASC',
  DemandCodeDesc = 'DEMAND_CODE_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  EstimateIdAsc = 'ESTIMATE_ID_ASC',
  EstimateIdDesc = 'ESTIMATE_ID_DESC',
  OrdererEmail1Asc = 'ORDERER_EMAIL1_ASC',
  OrdererEmail1Desc = 'ORDERER_EMAIL1_DESC',
  OrdererEmail2Asc = 'ORDERER_EMAIL2_ASC',
  OrdererEmail2Desc = 'ORDERER_EMAIL2_DESC',
  OrdererEmail3Asc = 'ORDERER_EMAIL3_ASC',
  OrdererEmail3Desc = 'ORDERER_EMAIL3_DESC',
  OrdererNameAsc = 'ORDERER_NAME_ASC',
  OrdererNameDesc = 'ORDERER_NAME_DESC',
  OrdererRemarkAsc = 'ORDERER_REMARK_ASC',
  OrdererRemarkDesc = 'ORDERER_REMARK_DESC',
  OrdererTelAsc = 'ORDERER_TEL_ASC',
  OrdererTelDesc = 'ORDERER_TEL_DESC',
  OrderPathAsc = 'ORDER_PATH_ASC',
  OrderPathDesc = 'ORDER_PATH_DESC',
  ProvisionalCustomerNameAsc = 'PROVISIONAL_CUSTOMER_NAME_ASC',
  ProvisionalCustomerNameDesc = 'PROVISIONAL_CUSTOMER_NAME_DESC',
  ReceiveOrderDateAsc = 'RECEIVE_ORDER_DATE_ASC',
  ReceiveOrderDateDesc = 'RECEIVE_ORDER_DATE_DESC',
  ReceiveOrderIdAsc = 'RECEIVE_ORDER_ID_ASC',
  ReceiveOrderIdDesc = 'RECEIVE_ORDER_ID_DESC',
  ReceiveOrderMemoAsc = 'RECEIVE_ORDER_MEMO_ASC',
  ReceiveOrderMemoDesc = 'RECEIVE_ORDER_MEMO_DESC',
  ReceiveOrderRemarksAsc = 'RECEIVE_ORDER_REMARKS_ASC',
  ReceiveOrderRemarksDesc = 'RECEIVE_ORDER_REMARKS_DESC',
  ReceiveOrderStatusAsc = 'RECEIVE_ORDER_STATUS_ASC',
  ReceiveOrderStatusDesc = 'RECEIVE_ORDER_STATUS_DESC',
  ReceiveOrderTotalPriceAsc = 'RECEIVE_ORDER_TOTAL_PRICE_ASC',
  ReceiveOrderTotalPriceDesc = 'RECEIVE_ORDER_TOTAL_PRICE_DESC',
  ReceiveOrderTypeAsc = 'RECEIVE_ORDER_TYPE_ASC',
  ReceiveOrderTypeDesc = 'RECEIVE_ORDER_TYPE_DESC',
  ReturnDivisionAsc = 'RETURN_DIVISION_ASC',
  ReturnDivisionDesc = 'RETURN_DIVISION_DESC',
  SalesDateAsc = 'SALES_DATE_ASC',
  SalesDateDesc = 'SALES_DATE_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  SalesUserCodeAsc = 'SALES_USER_CODE_ASC',
  SalesUserCodeDesc = 'SALES_USER_CODE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  Tax_8PerAsc = 'TAX_8_PER_ASC',
  Tax_8PerDesc = 'TAX_8_PER_DESC',
  Tax_10PerAsc = 'TAX_10_PER_ASC',
  Tax_10PerDesc = 'TAX_10_PER_DESC',
  TaxExcluded_8PerAsc = 'TAX_EXCLUDED_8_PER_ASC',
  TaxExcluded_8PerDesc = 'TAX_EXCLUDED_8_PER_DESC',
  TaxExcluded_10PerAsc = 'TAX_EXCLUDED_10_PER_ASC',
  TaxExcluded_10PerDesc = 'TAX_EXCLUDED_10_PER_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  UndeliveredDetailCountAsc = 'UNDELIVERED_DETAIL_COUNT_ASC',
  UndeliveredDetailCountDesc = 'UNDELIVERED_DETAIL_COUNT_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ReceiveOrderPrintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['Int'];
  reportLayoutCode: Scalars['String'];
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type ReceiveOrderPrintPayload = {
  __typename?: 'ReceiveOrderPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

export type ReceiveOrderView = Node & {
  __typename?: 'ReceiveOrderView';
  completedDetailCount?: Maybe<Scalars['Int']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerCode: Scalars['String'];
  customerGroup: Scalars['String'];
  customerName: Scalars['String'];
  customerWarehouseCode?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  detailCount?: Maybe<Scalars['Int']>;
  detailSearchKeyword?: Maybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  estimateId?: Maybe<Scalars['Int']>;
  headerSearchKeyword?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  receiveOrderDate: Scalars['String'];
  receiveOrderDetails?: Maybe<ReceiveOrderDetailConnection>;
  receiveOrderId: Scalars['ID'];
  receiveOrderMemo?: Maybe<Scalars['String']>;
  receiveOrderRemarks?: Maybe<Scalars['String']>;
  receiveOrderStatus: Scalars['String'];
  receiveOrderTotalPrice?: Maybe<Scalars['Int']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: Maybe<Scalars['String']>;
  sales?: Maybe<Sales>;
  salesDate?: Maybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUser?: Maybe<User>;
  salesUserCode?: Maybe<Scalars['String']>;
  tax8Per?: Maybe<Scalars['Int']>;
  tax10Per?: Maybe<Scalars['Int']>;
  taxExcludeTotal?: Maybe<Scalars['Int']>;
  taxExcluded8Per?: Maybe<Scalars['Int']>;
  taxExcluded10Per?: Maybe<Scalars['Int']>;
  undeliveredDetailCount?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type ReceiveOrderViewReceiveOrderDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ReceiveOrderViewConnection = {
  __typename?: 'ReceiveOrderViewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReceiveOrderViewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReceiveOrderView` and its cursor. */
export type ReceiveOrderViewEdge = {
  __typename?: 'ReceiveOrderViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReceiveOrderView>;
};

/** An enumeration. */
export enum ReceiveOrderViewSortEnum {
  CompletedDetailCountAsc = 'COMPLETED_DETAIL_COUNT_ASC',
  CompletedDetailCountDesc = 'COMPLETED_DETAIL_COUNT_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  CustomerGroupAsc = 'CUSTOMER_GROUP_ASC',
  CustomerGroupDesc = 'CUSTOMER_GROUP_DESC',
  CustomerNameAsc = 'CUSTOMER_NAME_ASC',
  CustomerNameDesc = 'CUSTOMER_NAME_DESC',
  CustomerWarehouseCodeAsc = 'CUSTOMER_WAREHOUSE_CODE_ASC',
  CustomerWarehouseCodeDesc = 'CUSTOMER_WAREHOUSE_CODE_DESC',
  DeliveryDateAsc = 'DELIVERY_DATE_ASC',
  DeliveryDateDesc = 'DELIVERY_DATE_DESC',
  DeliveryDestinationCodeAsc = 'DELIVERY_DESTINATION_CODE_ASC',
  DeliveryDestinationCodeDesc = 'DELIVERY_DESTINATION_CODE_DESC',
  DeliveryDestinationNameAsc = 'DELIVERY_DESTINATION_NAME_ASC',
  DeliveryDestinationNameDesc = 'DELIVERY_DESTINATION_NAME_DESC',
  DeliveryStatusAsc = 'DELIVERY_STATUS_ASC',
  DeliveryStatusDesc = 'DELIVERY_STATUS_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  DetailSearchKeywordAsc = 'DETAIL_SEARCH_KEYWORD_ASC',
  DetailSearchKeywordDesc = 'DETAIL_SEARCH_KEYWORD_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  EstimateIdAsc = 'ESTIMATE_ID_ASC',
  EstimateIdDesc = 'ESTIMATE_ID_DESC',
  HeaderSearchKeywordAsc = 'HEADER_SEARCH_KEYWORD_ASC',
  HeaderSearchKeywordDesc = 'HEADER_SEARCH_KEYWORD_DESC',
  ReceiveOrderDateAsc = 'RECEIVE_ORDER_DATE_ASC',
  ReceiveOrderDateDesc = 'RECEIVE_ORDER_DATE_DESC',
  ReceiveOrderIdAsc = 'RECEIVE_ORDER_ID_ASC',
  ReceiveOrderIdDesc = 'RECEIVE_ORDER_ID_DESC',
  ReceiveOrderMemoAsc = 'RECEIVE_ORDER_MEMO_ASC',
  ReceiveOrderMemoDesc = 'RECEIVE_ORDER_MEMO_DESC',
  ReceiveOrderRemarksAsc = 'RECEIVE_ORDER_REMARKS_ASC',
  ReceiveOrderRemarksDesc = 'RECEIVE_ORDER_REMARKS_DESC',
  ReceiveOrderStatusAsc = 'RECEIVE_ORDER_STATUS_ASC',
  ReceiveOrderStatusDesc = 'RECEIVE_ORDER_STATUS_DESC',
  ReceiveOrderTotalPriceAsc = 'RECEIVE_ORDER_TOTAL_PRICE_ASC',
  ReceiveOrderTotalPriceDesc = 'RECEIVE_ORDER_TOTAL_PRICE_DESC',
  ReceiveOrderTypeAsc = 'RECEIVE_ORDER_TYPE_ASC',
  ReceiveOrderTypeDesc = 'RECEIVE_ORDER_TYPE_DESC',
  ReturnDivisionAsc = 'RETURN_DIVISION_ASC',
  ReturnDivisionDesc = 'RETURN_DIVISION_DESC',
  SalesDateAsc = 'SALES_DATE_ASC',
  SalesDateDesc = 'SALES_DATE_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  SalesUserCodeAsc = 'SALES_USER_CODE_ASC',
  SalesUserCodeDesc = 'SALES_USER_CODE_DESC',
  Tax_8PerAsc = 'TAX_8_PER_ASC',
  Tax_8PerDesc = 'TAX_8_PER_DESC',
  Tax_10PerAsc = 'TAX_10_PER_ASC',
  Tax_10PerDesc = 'TAX_10_PER_DESC',
  TaxExcluded_8PerAsc = 'TAX_EXCLUDED_8_PER_ASC',
  TaxExcluded_8PerDesc = 'TAX_EXCLUDED_8_PER_DESC',
  TaxExcluded_10PerAsc = 'TAX_EXCLUDED_10_PER_ASC',
  TaxExcluded_10PerDesc = 'TAX_EXCLUDED_10_PER_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  UndeliveredDetailCountAsc = 'UNDELIVERED_DETAIL_COUNT_ASC',
  UndeliveredDetailCountDesc = 'UNDELIVERED_DETAIL_COUNT_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type RemainFkorderInformationAttachment = {
  attachmentId: Scalars['Int'];
  filename: Scalars['String'];
};

export type ReportLayout = Node & {
  __typename?: 'ReportLayout';
  activeReportFlg: Scalars['String'];
  corpId: Scalars['Int'];
  corporation?: Maybe<Corporation>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  offsetFlg: Scalars['String'];
  offsetX: Scalars['Int'];
  offsetY: Scalars['Int'];
  reportLayoutCode: Scalars['String'];
  reportLayoutDivision: Scalars['String'];
  reportLayoutName: Scalars['String'];
  reportLayoutTypeCode: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ReportLayoutConnection = {
  __typename?: 'ReportLayoutConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReportLayoutEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ReportLayout` and its cursor. */
export type ReportLayoutEdge = {
  __typename?: 'ReportLayoutEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ReportLayout>;
};

/** An enumeration. */
export enum ReportLayoutSortEnum {
  ActiveReportFlgAsc = 'ACTIVE_REPORT_FLG_ASC',
  ActiveReportFlgDesc = 'ACTIVE_REPORT_FLG_DESC',
  CorpIdAsc = 'CORP_ID_ASC',
  CorpIdDesc = 'CORP_ID_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  OffsetFlgAsc = 'OFFSET_FLG_ASC',
  OffsetFlgDesc = 'OFFSET_FLG_DESC',
  OffsetXAsc = 'OFFSET_X_ASC',
  OffsetXDesc = 'OFFSET_X_DESC',
  OffsetYAsc = 'OFFSET_Y_ASC',
  OffsetYDesc = 'OFFSET_Y_DESC',
  ReportLayoutCodeAsc = 'REPORT_LAYOUT_CODE_ASC',
  ReportLayoutCodeDesc = 'REPORT_LAYOUT_CODE_DESC',
  ReportLayoutDivisionAsc = 'REPORT_LAYOUT_DIVISION_ASC',
  ReportLayoutDivisionDesc = 'REPORT_LAYOUT_DIVISION_DESC',
  ReportLayoutNameAsc = 'REPORT_LAYOUT_NAME_ASC',
  ReportLayoutNameDesc = 'REPORT_LAYOUT_NAME_DESC',
  ReportLayoutTypeCodeAsc = 'REPORT_LAYOUT_TYPE_CODE_ASC',
  ReportLayoutTypeCodeDesc = 'REPORT_LAYOUT_TYPE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ResultData = {
  __typename?: 'ResultData';
  importFlg?: Maybe<Scalars['Boolean']>;
  memo?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  purchaseDate?: Maybe<Scalars['String']>;
  shopCode?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type SaleVoucherPrintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  deliveryOrderId: Scalars['Int'];
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  reportLayoutCode: Scalars['String'];
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type SaleVoucherPrintPayload = {
  __typename?: 'SaleVoucherPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

export type Sales = Node & {
  __typename?: 'Sales';
  allShipmentTaxDetails?: Maybe<ShipmentTaxDetailConnection>;
  closingStatusCode: Scalars['String'];
  closingTiming?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  deliver?: Maybe<Deliver>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryOrderId?: Maybe<Scalars['Int']>;
  demand?: Maybe<Demand>;
  demandCode: Scalars['String'];
  demandCustomer?: Maybe<Customer>;
  demandId?: Maybe<Scalars['Int']>;
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  exciseTax?: Maybe<Scalars['Float']>;
  exciseTaxClearing?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  receiveOrder?: Maybe<ReceiveOrderHeader>;
  receiveOrderId?: Maybe<Scalars['Int']>;
  salesDate: Scalars['String'];
  salesDetails?: Maybe<SalesDetailConnection>;
  salesId: Scalars['ID'];
  salesRemark?: Maybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUser?: Maybe<User>;
  salesUserCode?: Maybe<Scalars['String']>;
  salesVoucherType: Scalars['String'];
  searchKeyword?: Maybe<Scalars['String']>;
  shipment?: Maybe<Shipment>;
  shipmentTaxDetails?: Maybe<ShipmentTaxDetailConnection>;
  trustInventory?: Maybe<TrustInventory>;
  trustSalesDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type SalesAllShipmentTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SalesSalesDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SalesDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type SalesShipmentTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SalesAnalyticsComparisonTable = Node & {
  __typename?: 'SalesAnalyticsComparisonTable';
  aggregateResults?: Maybe<Scalars['JSONString']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  userCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SalesAnalyticsComparisonTableConnection = {
  __typename?: 'SalesAnalyticsComparisonTableConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsComparisonTableEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsComparisonTable` and its cursor. */
export type SalesAnalyticsComparisonTableEdge = {
  __typename?: 'SalesAnalyticsComparisonTableEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsComparisonTable>;
};

export type SalesAnalyticsCustomer = Node & {
  __typename?: 'SalesAnalyticsCustomer';
  compositionRatio?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  janCode?: Maybe<Scalars['String']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType?: Maybe<Scalars['String']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
};

export type SalesAnalyticsCustomerConnection = {
  __typename?: 'SalesAnalyticsCustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsCustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsCustomer` and its cursor. */
export type SalesAnalyticsCustomerEdge = {
  __typename?: 'SalesAnalyticsCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsCustomer>;
};

export type SalesAnalyticsDeliver = Node & {
  __typename?: 'SalesAnalyticsDeliver';
  compositionRatio?: Maybe<Scalars['Float']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  janCode?: Maybe<Scalars['String']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
};

export type SalesAnalyticsDeliverConnection = {
  __typename?: 'SalesAnalyticsDeliverConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsDeliverEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsDeliver` and its cursor. */
export type SalesAnalyticsDeliverEdge = {
  __typename?: 'SalesAnalyticsDeliverEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsDeliver>;
};

export type SalesAnalyticsDivision = Node & {
  __typename?: 'SalesAnalyticsDivision';
  compositionRatio?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
};

export type SalesAnalyticsDivisionConnection = {
  __typename?: 'SalesAnalyticsDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsDivision` and its cursor. */
export type SalesAnalyticsDivisionEdge = {
  __typename?: 'SalesAnalyticsDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsDivision>;
};

export type SalesAnalyticsDivisionProduct = Node & {
  __typename?: 'SalesAnalyticsDivisionProduct';
  compositionRatio?: Maybe<Scalars['Float']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  janCode?: Maybe<Scalars['String']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
};

export type SalesAnalyticsDivisionProductConnection = {
  __typename?: 'SalesAnalyticsDivisionProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsDivisionProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsDivisionProduct` and its cursor. */
export type SalesAnalyticsDivisionProductEdge = {
  __typename?: 'SalesAnalyticsDivisionProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsDivisionProduct>;
};

export type SalesAnalyticsProduct = Node & {
  __typename?: 'SalesAnalyticsProduct';
  compositionRatio?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  janCode?: Maybe<Scalars['String']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
};

export type SalesAnalyticsProductConnection = {
  __typename?: 'SalesAnalyticsProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsProduct` and its cursor. */
export type SalesAnalyticsProductEdge = {
  __typename?: 'SalesAnalyticsProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsProduct>;
};

export type SalesAnalyticsSalesUser = Node & {
  __typename?: 'SalesAnalyticsSalesUser';
  compositionRatio?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSubTotal?: Maybe<Scalars['Boolean']>;
  netSalesAmount?: Maybe<Scalars['Int']>;
  netSalesQuantity?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
  userCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SalesAnalyticsSalesUserConnection = {
  __typename?: 'SalesAnalyticsSalesUserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesAnalyticsSalesUserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesAnalyticsSalesUser` and its cursor. */
export type SalesAnalyticsSalesUserEdge = {
  __typename?: 'SalesAnalyticsSalesUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesAnalyticsSalesUser>;
};

export type SalesChangingListCustomer = Node & {
  __typename?: 'SalesChangingListCustomer';
  achievementRate1?: Maybe<Scalars['Float']>;
  achievementRate2?: Maybe<Scalars['Float']>;
  achievementRate3?: Maybe<Scalars['Float']>;
  achievementRate4?: Maybe<Scalars['Float']>;
  achievementRate5?: Maybe<Scalars['Float']>;
  achievementRate6?: Maybe<Scalars['Float']>;
  achievementRate7?: Maybe<Scalars['Float']>;
  achievementRate8?: Maybe<Scalars['Float']>;
  achievementRate9?: Maybe<Scalars['Float']>;
  achievementRate10?: Maybe<Scalars['Float']>;
  achievementRate11?: Maybe<Scalars['Float']>;
  achievementRate12?: Maybe<Scalars['Float']>;
  achievementRateTotals?: Maybe<Scalars['Float']>;
  budgetMonth1?: Maybe<Scalars['Float']>;
  budgetMonth2?: Maybe<Scalars['Float']>;
  budgetMonth3?: Maybe<Scalars['Float']>;
  budgetMonth4?: Maybe<Scalars['Float']>;
  budgetMonth5?: Maybe<Scalars['Float']>;
  budgetMonth6?: Maybe<Scalars['Float']>;
  budgetMonth7?: Maybe<Scalars['Float']>;
  budgetMonth8?: Maybe<Scalars['Float']>;
  budgetMonth9?: Maybe<Scalars['Float']>;
  budgetMonth10?: Maybe<Scalars['Float']>;
  budgetMonth11?: Maybe<Scalars['Float']>;
  budgetMonth12?: Maybe<Scalars['Float']>;
  budgetTotals?: Maybe<Scalars['Float']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  differenceMonth1?: Maybe<Scalars['Float']>;
  differenceMonth2?: Maybe<Scalars['Float']>;
  differenceMonth3?: Maybe<Scalars['Float']>;
  differenceMonth4?: Maybe<Scalars['Float']>;
  differenceMonth5?: Maybe<Scalars['Float']>;
  differenceMonth6?: Maybe<Scalars['Float']>;
  differenceMonth7?: Maybe<Scalars['Float']>;
  differenceMonth8?: Maybe<Scalars['Float']>;
  differenceMonth9?: Maybe<Scalars['Float']>;
  differenceMonth10?: Maybe<Scalars['Float']>;
  differenceMonth11?: Maybe<Scalars['Float']>;
  differenceMonth12?: Maybe<Scalars['Float']>;
  differenceTotals?: Maybe<Scalars['Float']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  salesMonth1?: Maybe<Scalars['Float']>;
  salesMonth2?: Maybe<Scalars['Float']>;
  salesMonth3?: Maybe<Scalars['Float']>;
  salesMonth4?: Maybe<Scalars['Float']>;
  salesMonth5?: Maybe<Scalars['Float']>;
  salesMonth6?: Maybe<Scalars['Float']>;
  salesMonth7?: Maybe<Scalars['Float']>;
  salesMonth8?: Maybe<Scalars['Float']>;
  salesMonth9?: Maybe<Scalars['Float']>;
  salesMonth10?: Maybe<Scalars['Float']>;
  salesMonth11?: Maybe<Scalars['Float']>;
  salesMonth12?: Maybe<Scalars['Float']>;
  salesQuantityMonth1?: Maybe<Scalars['Int']>;
  salesQuantityMonth2?: Maybe<Scalars['Int']>;
  salesQuantityMonth3?: Maybe<Scalars['Int']>;
  salesQuantityMonth4?: Maybe<Scalars['Int']>;
  salesQuantityMonth5?: Maybe<Scalars['Int']>;
  salesQuantityMonth6?: Maybe<Scalars['Int']>;
  salesQuantityMonth7?: Maybe<Scalars['Int']>;
  salesQuantityMonth8?: Maybe<Scalars['Int']>;
  salesQuantityMonth9?: Maybe<Scalars['Int']>;
  salesQuantityMonth10?: Maybe<Scalars['Int']>;
  salesQuantityMonth11?: Maybe<Scalars['Int']>;
  salesQuantityMonth12?: Maybe<Scalars['Int']>;
  salesQuantityTotals?: Maybe<Scalars['Int']>;
  salesTotals?: Maybe<Scalars['Float']>;
  salesUserCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SalesChangingListCustomerConnection = {
  __typename?: 'SalesChangingListCustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesChangingListCustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesChangingListCustomer` and its cursor. */
export type SalesChangingListCustomerEdge = {
  __typename?: 'SalesChangingListCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesChangingListCustomer>;
};

export type SalesChangingListProduct = Node & {
  __typename?: 'SalesChangingListProduct';
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  productGroup1?: Maybe<Scalars['String']>;
  productGroup2?: Maybe<Scalars['String']>;
  productGroup3?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  salesMonth1?: Maybe<Scalars['Float']>;
  salesMonth2?: Maybe<Scalars['Float']>;
  salesMonth3?: Maybe<Scalars['Float']>;
  salesMonth4?: Maybe<Scalars['Float']>;
  salesMonth5?: Maybe<Scalars['Float']>;
  salesMonth6?: Maybe<Scalars['Float']>;
  salesMonth7?: Maybe<Scalars['Float']>;
  salesMonth8?: Maybe<Scalars['Float']>;
  salesMonth9?: Maybe<Scalars['Float']>;
  salesMonth10?: Maybe<Scalars['Float']>;
  salesMonth11?: Maybe<Scalars['Float']>;
  salesMonth12?: Maybe<Scalars['Float']>;
  salesQuantityMonth1?: Maybe<Scalars['Int']>;
  salesQuantityMonth2?: Maybe<Scalars['Int']>;
  salesQuantityMonth3?: Maybe<Scalars['Int']>;
  salesQuantityMonth4?: Maybe<Scalars['Int']>;
  salesQuantityMonth5?: Maybe<Scalars['Int']>;
  salesQuantityMonth6?: Maybe<Scalars['Int']>;
  salesQuantityMonth7?: Maybe<Scalars['Int']>;
  salesQuantityMonth8?: Maybe<Scalars['Int']>;
  salesQuantityMonth9?: Maybe<Scalars['Int']>;
  salesQuantityMonth10?: Maybe<Scalars['Int']>;
  salesQuantityMonth11?: Maybe<Scalars['Int']>;
  salesQuantityMonth12?: Maybe<Scalars['Int']>;
  salesQuantityTotals?: Maybe<Scalars['Int']>;
  salesTotals?: Maybe<Scalars['Float']>;
};

export type SalesChangingListProductConnection = {
  __typename?: 'SalesChangingListProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesChangingListProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesChangingListProduct` and its cursor. */
export type SalesChangingListProductEdge = {
  __typename?: 'SalesChangingListProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesChangingListProduct>;
};

export type SalesConnection = {
  __typename?: 'SalesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SalesDailyCustomer = Node & {
  __typename?: 'SalesDailyCustomer';
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  discountTotals?: Maybe<Scalars['Int']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  netSales?: Maybe<Scalars['Int']>;
  othersTotals?: Maybe<Scalars['Int']>;
  returnTotals?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
  salesTotals?: Maybe<Scalars['Int']>;
  salesUserCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SalesDailyCustomerConnection = {
  __typename?: 'SalesDailyCustomerConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesDailyCustomerEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesDailyCustomer` and its cursor. */
export type SalesDailyCustomerEdge = {
  __typename?: 'SalesDailyCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesDailyCustomer>;
};

export type SalesDailyDivision = Node & {
  __typename?: 'SalesDailyDivision';
  discountTotals?: Maybe<Scalars['Int']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  netSales?: Maybe<Scalars['Int']>;
  othersTotals?: Maybe<Scalars['Int']>;
  returnTotals?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
  salesTotals?: Maybe<Scalars['Int']>;
};

export type SalesDailyDivisionConnection = {
  __typename?: 'SalesDailyDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesDailyDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesDailyDivision` and its cursor. */
export type SalesDailyDivisionEdge = {
  __typename?: 'SalesDailyDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesDailyDivision>;
};

export type SalesDailyProduct = Node & {
  __typename?: 'SalesDailyProduct';
  discountTotals?: Maybe<Scalars['Int']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  netSales?: Maybe<Scalars['Int']>;
  othersTotals?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  returnTotals?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
  salesTotals?: Maybe<Scalars['Int']>;
};

export type SalesDailyProductConnection = {
  __typename?: 'SalesDailyProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesDailyProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesDailyProduct` and its cursor. */
export type SalesDailyProductEdge = {
  __typename?: 'SalesDailyProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesDailyProduct>;
};

export type SalesDailySalesUser = Node & {
  __typename?: 'SalesDailySalesUser';
  discountTotals?: Maybe<Scalars['Int']>;
  grossProfit?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  netSales?: Maybe<Scalars['Int']>;
  othersTotals?: Maybe<Scalars['Int']>;
  returnTotals?: Maybe<Scalars['Int']>;
  roundGrossProfitrate?: Maybe<Scalars['Float']>;
  salesTotals?: Maybe<Scalars['Int']>;
  salesUserCode?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SalesDailySalesUserConnection = {
  __typename?: 'SalesDailySalesUserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesDailySalesUserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SalesDailySalesUser` and its cursor. */
export type SalesDailySalesUserEdge = {
  __typename?: 'SalesDailySalesUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesDailySalesUser>;
};

export type SalesDetail = Node & {
  __typename?: 'SalesDetail';
  clearingPrice?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryOrderDetailNumbering?: Maybe<Scalars['Int']>;
  deliveryOrderId?: Maybe<Scalars['Int']>;
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType?: Maybe<Scalars['String']>;
  receiveOrderQuantity?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  sales?: Maybe<Sales>;
  salesId: Scalars['ID'];
  salesUnitPrice?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  shipmentDetail?: Maybe<ShipmentDetail>;
  taxDivision?: Maybe<TaxDivision>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  uniqueCode?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type SalesDetailConnection = {
  __typename?: 'SalesDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SalesDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SalesDetail` and its cursor. */
export type SalesDetailEdge = {
  __typename?: 'SalesDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SalesDetail>;
};

export type SalesDetailFilter = {
  detailMainFlg?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum SalesDetailSortEnum {
  ClearingPriceAsc = 'CLEARING_PRICE_ASC',
  ClearingPriceDesc = 'CLEARING_PRICE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveryOrderDetailNumberingAsc = 'DELIVERY_ORDER_DETAIL_NUMBERING_ASC',
  DeliveryOrderDetailNumberingDesc = 'DELIVERY_ORDER_DETAIL_NUMBERING_DESC',
  DeliveryOrderIdAsc = 'DELIVERY_ORDER_ID_ASC',
  DeliveryOrderIdDesc = 'DELIVERY_ORDER_ID_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ReceiveDetailTradeTypeAsc = 'RECEIVE_DETAIL_TRADE_TYPE_ASC',
  ReceiveDetailTradeTypeDesc = 'RECEIVE_DETAIL_TRADE_TYPE_DESC',
  ReceiveOrderQuantityAsc = 'RECEIVE_ORDER_QUANTITY_ASC',
  ReceiveOrderQuantityDesc = 'RECEIVE_ORDER_QUANTITY_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesIdAsc = 'SALES_ID_ASC',
  SalesIdDesc = 'SALES_ID_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  SellingPriceAsc = 'SELLING_PRICE_ASC',
  SellingPriceDesc = 'SELLING_PRICE_DESC',
  SellingUnitPriceAsc = 'SELLING_UNIT_PRICE_ASC',
  SellingUnitPriceDesc = 'SELLING_UNIT_PRICE_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalQuantityAsc = 'TOTAL_QUANTITY_ASC',
  TotalQuantityDesc = 'TOTAL_QUANTITY_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type SalesDetailWTax = Node & {
  __typename?: 'SalesDetailWTax';
  details?: Maybe<Array<Maybe<SalesDetailWTaxDetail>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  summary?: Maybe<SalesDetailWTaxSummary>;
};

export type SalesDetailWTaxDetail = {
  __typename?: 'SalesDetailWTaxDetail';
  closingStatusCode?: Maybe<Scalars['String']>;
  createUserCode?: Maybe<Scalars['String']>;
  createUserName?: Maybe<Scalars['String']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryOrderDetailStatus?: Maybe<Scalars['String']>;
  deliveryOrderMemo?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  estimateId?: Maybe<Scalars['String']>;
  grossProfit?: Maybe<Scalars['Float']>;
  janCode?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType?: Maybe<Scalars['String']>;
  receiveOrderId?: Maybe<Scalars['String']>;
  receiveOrderMemo?: Maybe<Scalars['String']>;
  receiveOrderType?: Maybe<Scalars['String']>;
  salesDate?: Maybe<Scalars['String']>;
  salesId?: Maybe<Scalars['String']>;
  salesRemark?: Maybe<Scalars['String']>;
  salesTaxType?: Maybe<Scalars['String']>;
  salesTradeDivision?: Maybe<Scalars['String']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  salesUserCode?: Maybe<Scalars['String']>;
  salesUserName?: Maybe<Scalars['String']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  shipmentId?: Maybe<Scalars['String']>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  trustInventoryId?: Maybe<Scalars['String']>;
  trustSalesDivision?: Maybe<Scalars['String']>;
  uniqueCode?: Maybe<Scalars['String']>;
};

export type SalesDetailWTaxFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dispTaxTotal?: InputMaybe<Scalars['Boolean']>;
  dispTotal?: InputMaybe<Scalars['Boolean']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesDateFrom: Scalars['String'];
  salesDateTo: Scalars['String'];
  salesIdFrom?: InputMaybe<Scalars['Int']>;
  salesIdTo?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SalesDetailWTaxSummary = {
  __typename?: 'SalesDetailWTaxSummary';
  count?: Maybe<Scalars['Int']>;
  excludeTax?: Maybe<Scalars['Int']>;
  grossProfit?: Maybe<Scalars['Int']>;
  grossProfitRate?: Maybe<Scalars['Float']>;
  notApplicable?: Maybe<Scalars['Int']>;
  salesUnitPrice?: Maybe<Scalars['Int']>;
  targetEight?: Maybe<Scalars['Int']>;
  targetTen?: Maybe<Scalars['Int']>;
  taxEight?: Maybe<Scalars['Int']>;
  taxFree?: Maybe<Scalars['Int']>;
  taxTen?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Sales` and its cursor. */
export type SalesEdge = {
  __typename?: 'SalesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Sales>;
};

/** An enumeration. */
export enum SalesSortEnum {
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  ClosingTimingAsc = 'CLOSING_TIMING_ASC',
  ClosingTimingDesc = 'CLOSING_TIMING_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DeliveryDestinationCodeAsc = 'DELIVERY_DESTINATION_CODE_ASC',
  DeliveryDestinationCodeDesc = 'DELIVERY_DESTINATION_CODE_DESC',
  DeliveryDestinationNameAsc = 'DELIVERY_DESTINATION_NAME_ASC',
  DeliveryDestinationNameDesc = 'DELIVERY_DESTINATION_NAME_DESC',
  DeliveryOrderIdAsc = 'DELIVERY_ORDER_ID_ASC',
  DeliveryOrderIdDesc = 'DELIVERY_ORDER_ID_DESC',
  DemandCodeAsc = 'DEMAND_CODE_ASC',
  DemandCodeDesc = 'DEMAND_CODE_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  ExciseTaxAsc = 'EXCISE_TAX_ASC',
  ExciseTaxClearingAsc = 'EXCISE_TAX_CLEARING_ASC',
  ExciseTaxClearingDesc = 'EXCISE_TAX_CLEARING_DESC',
  ExciseTaxDesc = 'EXCISE_TAX_DESC',
  ReceiveOrderIdAsc = 'RECEIVE_ORDER_ID_ASC',
  ReceiveOrderIdDesc = 'RECEIVE_ORDER_ID_DESC',
  SalesDateAsc = 'SALES_DATE_ASC',
  SalesDateDesc = 'SALES_DATE_DESC',
  SalesIdAsc = 'SALES_ID_ASC',
  SalesIdDesc = 'SALES_ID_DESC',
  SalesRemarkAsc = 'SALES_REMARK_ASC',
  SalesRemarkDesc = 'SALES_REMARK_DESC',
  SalesTaxTypeAsc = 'SALES_TAX_TYPE_ASC',
  SalesTaxTypeDesc = 'SALES_TAX_TYPE_DESC',
  SalesTradeDivisionAsc = 'SALES_TRADE_DIVISION_ASC',
  SalesTradeDivisionDesc = 'SALES_TRADE_DIVISION_DESC',
  SalesUserCodeAsc = 'SALES_USER_CODE_ASC',
  SalesUserCodeDesc = 'SALES_USER_CODE_DESC',
  SalesVoucherTypeAsc = 'SALES_VOUCHER_TYPE_ASC',
  SalesVoucherTypeDesc = 'SALES_VOUCHER_TYPE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TrustSalesDivisionAsc = 'TRUST_SALES_DIVISION_ASC',
  TrustSalesDivisionDesc = 'TRUST_SALES_DIVISION_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type SeachDeliverFilter = {
  customerCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerName?: InputMaybe<Scalars['String']>;
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  deliveryDestinationName?: InputMaybe<Scalars['String']>;
};

export type SearchAddressFilter = {
  city?: InputMaybe<Scalars['String']>;
  prefecturesCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type SearchArrivalFilter = {
  arrivalDateFrom?: InputMaybe<Scalars['Date']>;
  arrivalDateTo?: InputMaybe<Scalars['Date']>;
  arrivalIdFrom?: InputMaybe<Scalars['Int']>;
  arrivalIdTo?: InputMaybe<Scalars['Int']>;
  companyStoreDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  orderIdFrom?: InputMaybe<Scalars['Int']>;
  orderIdTo?: InputMaybe<Scalars['Int']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseVoucherType?: InputMaybe<Scalars['String']>;
  purchaseVoucherTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purposeGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchBeforeDemandClosingListFilter = {
  billSendDivisions: Array<InputMaybe<Scalars['String']>>;
  closingDate: Scalars['Date'];
  customerGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchClosedPaymentFilter = {
  closingDate: Scalars['Date'];
  purposeGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeStopFlgs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorClosingGroup?: InputMaybe<Scalars['String']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withdrawalStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchCollectionPlanFilter = {
  collectionDateFrom: Scalars['Date'];
  collectionDateTo: Scalars['Date'];
};

export type SearchCollectionStatusFilter = {
  collectionDateFrom: Scalars['Date'];
  collectionDateTo: Scalars['Date'];
  remainedZeroFlg?: InputMaybe<Scalars['String']>;
  salesUserCode?: InputMaybe<Scalars['String']>;
};

export type SearchComponentFilter = {
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  finishedProductCode?: InputMaybe<Scalars['String']>;
  productPartsCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchCreateDispTrustInventoryFilter = {
  customerCode: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryTo: Scalars['Date'];
  salesDate: Scalars['Date'];
};

export type SearchCustomerDemandFilter = {
  billSendDivisions: Array<InputMaybe<Scalars['String']>>;
  closingDate?: InputMaybe<Scalars['Date']>;
  customerGroups: Array<InputMaybe<Scalars['String']>>;
  demandClosingGroupCode: Scalars['String'];
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchCustomerFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demand?: InputMaybe<Scalars['Boolean']>;
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  forReport?: InputMaybe<Scalars['Boolean']>;
  salesTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tradeStopFlgs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchCustomerFromCodeFilter = {
  customerCode?: InputMaybe<Scalars['String']>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchCustomerPriceFilter = {
  applicableDate?: InputMaybe<Scalars['Date']>;
  appliedStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCode?: InputMaybe<Scalars['String']>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startDate?: InputMaybe<Scalars['String']>;
  uniqueCode?: InputMaybe<Scalars['String']>;
};

export type SearchCustomerSalesFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCode?: InputMaybe<Scalars['String']>;
  demandCode: Scalars['String'];
  salesRemarkFlg?: InputMaybe<Scalars['String']>;
  salesTradeDivision?: InputMaybe<Scalars['String']>;
  totalingDateFrom: Scalars['Date'];
  totalingDateTo: Scalars['Date'];
  totalingMethod: Scalars['String'];
};

export type SearchCustomerSalesMontylyFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCode?: InputMaybe<Scalars['String']>;
  demandCode: Scalars['String'];
  salesTradeDivision?: InputMaybe<Scalars['String']>;
  totalingDateFrom: Scalars['Date'];
  totalingDateTo: Scalars['Date'];
  totalingMethod: Scalars['String'];
};

export type SearchCustomerUserFilter = {
  customerCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerName?: InputMaybe<Scalars['String']>;
  customerUserName?: InputMaybe<Scalars['String']>;
  deliveryDestinationCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['String']>;
  termsIdFrom?: InputMaybe<Scalars['String']>;
  termsIdTo?: InputMaybe<Scalars['String']>;
};

export type SearchCustomerWithCarryOverFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandCode: Scalars['String'];
  salesTradeDivision?: InputMaybe<Scalars['String']>;
  totalingDateFrom: Scalars['Date'];
};

export type SearchDemandClosingFilter = {
  billSendDivisions: Array<InputMaybe<Scalars['String']>>;
  closingDate: Scalars['Date'];
  createUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerGroups: Array<InputMaybe<Scalars['String']>>;
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchDemandCustomerSalesFilter = {
  demandCode: Scalars['String'];
  totalingDateFrom: Scalars['Date'];
  totalingDateTo: Scalars['Date'];
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchDemandHistoryFilter = {
  closingDateFrom?: InputMaybe<Scalars['Date']>;
  closingDateTo?: InputMaybe<Scalars['Date']>;
  demandCode?: InputMaybe<Scalars['String']>;
};

export type SearchDemandNotClearingFilter = {
  demandCode: Scalars['String'];
  depositId?: InputMaybe<Scalars['Int']>;
};

export type SearchDemandReportFilter = {
  demandId?: InputMaybe<Scalars['Int']>;
};

export type SearchDepositCustomerSalesFilter = {
  demandCode: Scalars['String'];
  totalingDateFrom: Scalars['Date'];
  totalingDateTo: Scalars['Date'];
};

export type SearchDepositDemandDetailFilter = {
  demandId?: InputMaybe<Scalars['Int']>;
  depositDate?: InputMaybe<Scalars['Date']>;
};

export type SearchDepositDivisionFilter = {
  depositDivisionName?: InputMaybe<Scalars['String']>;
  depositGroupCode?: InputMaybe<Scalars['String']>;
};

export type SearchDepositDivisionKeywordFilter = {
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchDepositFilter = {
  billSendDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  depositDateFrom?: InputMaybe<Scalars['Date']>;
  depositDateTo?: InputMaybe<Scalars['Date']>;
  depositDetailStatus?: InputMaybe<Scalars['String']>;
  depositPriceFrom?: InputMaybe<Scalars['Decimal']>;
  depositPriceTo?: InputMaybe<Scalars['Decimal']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchDivisionFilter = {
  divisionCode?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divistionType?: InputMaybe<Scalars['String']>;
  divistionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchDivisionFinancialDateFilter = {
  divisionCode?: InputMaybe<Scalars['String']>;
  targetDate?: InputMaybe<Scalars['Date']>;
};

export type SearchEstimateFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  estimateDateFrom?: InputMaybe<Scalars['Date']>;
  estimateDateTo?: InputMaybe<Scalars['Date']>;
  estimateIdFrom?: InputMaybe<Scalars['Int']>;
  estimateIdTo?: InputMaybe<Scalars['Int']>;
  searchKeywords?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchEstimateViewFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  estimateDateFrom?: InputMaybe<Scalars['Date']>;
  estimateDateTo?: InputMaybe<Scalars['Date']>;
  estimateIdFrom?: InputMaybe<Scalars['Int']>;
  estimateIdTo?: InputMaybe<Scalars['Int']>;
  searchKeywords?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchFinancialDateDetail = Node & {
  __typename?: 'SearchFinancialDateDetail';
  financialStage: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  maxFinancialEndDate: Scalars['Date'];
  minFinancialStartDate: Scalars['Date'];
};

export type SearchFinancialDateDetailConnection = {
  __typename?: 'SearchFinancialDateDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchFinancialDateDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchFinancialDateDetail` and its cursor. */
export type SearchFinancialDateDetailEdge = {
  __typename?: 'SearchFinancialDateDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchFinancialDateDetail>;
};

export type SearchFinancialDateDetailFilter = {
  financialStage?: InputMaybe<Scalars['Int']>;
};

export type SearchFkorderInformationFilter = {
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  informationType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  postedAt?: InputMaybe<Scalars['Date']>;
  postedAtEnd?: InputMaybe<Scalars['Date']>;
  postedAtStart?: InputMaybe<Scalars['Date']>;
  publicationFrom?: InputMaybe<Scalars['Date']>;
  publicationFromEnd?: InputMaybe<Scalars['Date']>;
  publicationFromStart?: InputMaybe<Scalars['Date']>;
  publicationStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publicationTo?: InputMaybe<Scalars['Date']>;
  publicationToEnd?: InputMaybe<Scalars['Date']>;
  publicationToStart?: InputMaybe<Scalars['Date']>;
};

export type SearchInternalTransaction = Node & {
  __typename?: 'SearchInternalTransaction';
  adjustId?: Maybe<Scalars['String']>;
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  deliveryOrderId?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  estimateId?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inputAttributeName?: Maybe<Scalars['String']>;
  inputDivisionCode?: Maybe<Scalars['String']>;
  inputDivisionName?: Maybe<Scalars['String']>;
  inputJanCode?: Maybe<Scalars['String']>;
  inputPrice?: Maybe<Scalars['Float']>;
  inputSalesUnitPrice?: Maybe<Scalars['Float']>;
  outputAttributeName?: Maybe<Scalars['String']>;
  outputDivisionCode?: Maybe<Scalars['String']>;
  outputDivisionName?: Maybe<Scalars['String']>;
  outputJanCode?: Maybe<Scalars['String']>;
  outputPrice?: Maybe<Scalars['Float']>;
  outputSalesUnitPrice?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  receiveOrderId?: Maybe<Scalars['String']>;
  tradeDate?: Maybe<Scalars['String']>;
  tradeHistoryType?: Maybe<Scalars['String']>;
  tradeId?: Maybe<Scalars['String']>;
  warehouseMoveId?: Maybe<Scalars['String']>;
};

export type SearchInternalTransactionConnection = {
  __typename?: 'SearchInternalTransactionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchInternalTransactionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchInternalTransaction` and its cursor. */
export type SearchInternalTransactionEdge = {
  __typename?: 'SearchInternalTransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchInternalTransaction>;
};

export type SearchInternalTransactionFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inputDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  outputDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tradeDateFrom?: InputMaybe<Scalars['Date']>;
  tradeDateTo?: InputMaybe<Scalars['Date']>;
  tradeHistoryTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchInventoryDetailFilter = {
  divisionCode: Scalars['String'];
  inventoryId: Scalars['Int'];
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type SearchInventoryDetailUniqueFilter = {
  inventoryId: Scalars['Int'];
  productCode: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type SearchInventoryDivisionFilter = {
  divisionCode: Scalars['String'];
  inventoryId: Scalars['Int'];
};

export type SearchInventoryFilter = {
  inventoryBaseFrom?: InputMaybe<Scalars['Date']>;
  inventoryBaseTo?: InputMaybe<Scalars['Date']>;
  inventoryName?: InputMaybe<Scalars['String']>;
};

export type SearchOrderName = Node & {
  __typename?: 'SearchOrderName';
  /** The ID of the object. */
  id: Scalars['ID'];
  userName?: Maybe<Scalars['String']>;
};

export type SearchOrderNameFilter = {
  userId: Scalars['String'];
};

export type SearchPayableBalanceListFilter = {
  demandDateStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  outOfRangePayment?: InputMaybe<Scalars['String']>;
  payDateFrom: Scalars['Date'];
  payDateTo: Scalars['Date'];
  payableBalanceStatus?: InputMaybe<Scalars['String']>;
  purposeGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeStopFlgs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorClosingGroup?: InputMaybe<Scalars['String']>;
  vendorTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchPaymentDivisionFilter = {
  paymentDivisionName?: InputMaybe<Scalars['String']>;
  paymentGroupCode?: InputMaybe<Scalars['String']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchPaymentHistoryFilter = {
  closingDateFrom?: InputMaybe<Scalars['Date']>;
  closingDateTo?: InputMaybe<Scalars['Date']>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type SearchPaymentVendorPurchaseFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalingDateFrom?: InputMaybe<Scalars['Date']>;
  totalingDateTo?: InputMaybe<Scalars['Date']>;
  vendorCode: Scalars['String'];
};

export type SearchProductExactMatch = {
  janCode?: InputMaybe<Scalars['String']>;
  uniqueCode?: InputMaybe<Scalars['String']>;
};

export type SearchProductFilter = {
  branchNumber?: InputMaybe<Scalars['Int']>;
  componentDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fcCode?: InputMaybe<Scalars['String']>;
  janCode?: InputMaybe<Scalars['String']>;
  janCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCode?: InputMaybe<Scalars['String']>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vendorCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductFromUniqueCodeFilter = {
  uniqueCode?: InputMaybe<Scalars['String']>;
};

export type SearchProductGroupFilter = {
  divisionCode?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupCode?: InputMaybe<Scalars['String']>;
  productGroupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGrouptypeCode?: InputMaybe<Scalars['String']>;
  publicationOption?: InputMaybe<Scalars['String']>;
  publicationScope?: InputMaybe<Scalars['String']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchProductGroupFromCodeFilter = {
  productGroupCode: Scalars['String'];
  productGroupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductHistoryFilter = {
  uniqueCode: Scalars['String'];
};

export type SearchProductInPurchaseKoreFilter = {
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDivision: Scalars['String'];
  productGroup1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroup2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroup3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCodesSelect?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductListViewFilter = {
  appliedStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  componentDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fcCode?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber?: InputMaybe<Scalars['String']>;
  janCode?: InputMaybe<Scalars['String']>;
  janCodeOrProductCode?: InputMaybe<Scalars['String']>;
  periodPrice?: InputMaybe<Scalars['Date']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  vendorCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductNoPriceViewFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  janCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductPriceFilter = {
  uniqueCode?: InputMaybe<Scalars['String']>;
  uniqueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductPriceFromTargetDateFilter = {
  targetDate: Scalars['String'];
  uniqueCode: Scalars['String'];
};

export type SearchProductStockByDivisionFilter = {
  divisionCode: Scalars['String'];
  productCodes: Array<InputMaybe<Scalars['String']>>;
  targetDateTo: Scalars['Date'];
};

export type SearchProductStockByWarehouseExFilter = {
  productCodes: Array<InputMaybe<Scalars['String']>>;
  targetDateTo?: InputMaybe<Scalars['Date']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type SearchProductStockByWarehouseFilter = {
  janCodes: Array<InputMaybe<Scalars['String']>>;
  targetDateTo?: InputMaybe<Scalars['Date']>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type SearchProductStockForAdjustFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseCode: Scalars['String'];
};

export type SearchProductViewFilter = {
  componentDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fcCode?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber?: InputMaybe<Scalars['String']>;
  janCode?: InputMaybe<Scalars['String']>;
  janCodeOrProductCode?: InputMaybe<Scalars['String']>;
  maxPurchaseOrderQty?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  vendorCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductViewWithCustomerFilter = {
  customerCode: Scalars['String'];
  janCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  targetDate: Scalars['Date'];
};

export type SearchProductViewWithOutsourcerFilter = {
  customerCode: Scalars['String'];
  janCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  targetDate: Scalars['Date'];
};

export type SearchProductViewWithProductCodesFilter = {
  productCodes: Array<InputMaybe<Scalars['String']>>;
  targetDate: Scalars['Date'];
};

export type SearchProductViewWithVendorFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  targetDate: Scalars['Date'];
  vendorCode: Scalars['String'];
};

export type SearchProductViewsWithCustomerFilter = {
  customerCode: Scalars['String'];
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetDate: Scalars['Date'];
};

export type SearchProductViewsWithOutsourcerFilter = {
  customerCode: Scalars['String'];
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetDate: Scalars['Date'];
};

export type SearchProductViewsWithVendorFilter = {
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetDate: Scalars['Date'];
  vendorCode: Scalars['String'];
};

export type SearchProductWithJanFilter = {
  janCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductionFilter = {
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  finishedProductCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  finishedProductGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  finishedProductGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  finishedProductGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productionDetailStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productionOrderDateFrom?: InputMaybe<Scalars['Date']>;
  productionOrderDateTo?: InputMaybe<Scalars['Date']>;
  productionOrderIdFrom?: InputMaybe<Scalars['Int']>;
  productionOrderIdTo?: InputMaybe<Scalars['Int']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchProductsByProductCodesFilter = {
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchProductsListViewFromPriceCardFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  periodPrice?: InputMaybe<Scalars['Date']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchPurchaseAnalyticsFilter = {
  criteriaStatus?: InputMaybe<Scalars['String']>;
  displayStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
};

export type SearchPurchaseDailyFilter = {
  criteriaStatus?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDailyStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchPurchaseFilter = {
  companyStoreDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  invoiceDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
  purchaseIdFrom?: InputMaybe<Scalars['Int']>;
  purchaseIdTo?: InputMaybe<Scalars['Int']>;
  purchaseVoucherType?: InputMaybe<Scalars['String']>;
  purchaseVoucherTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purposeGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchPurchasePaymentDetailFilter = {
  paymentId?: InputMaybe<Scalars['Int']>;
  purchaseDate?: InputMaybe<Scalars['Date']>;
};

export type SearchPurchaseUnitHistory = Node & {
  __typename?: 'SearchPurchaseUnitHistory';
  /** The ID of the object. */
  id: Scalars['ID'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  slipDate?: Maybe<Scalars['Date']>;
  slipNumber?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type SearchPurchaseUnitHistoryConnection = {
  __typename?: 'SearchPurchaseUnitHistoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchPurchaseUnitHistoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchPurchaseUnitHistory` and its cursor. */
export type SearchPurchaseUnitHistoryEdge = {
  __typename?: 'SearchPurchaseUnitHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchPurchaseUnitHistory>;
};

export type SearchPurchaseUnitHistoryFilter = {
  mode: Scalars['String'];
  productCode: Scalars['String'];
};

export type SearchReceivableBalanceListFilter = {
  billSendDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerStatus: Scalars['String'];
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandDateFrom: Scalars['Date'];
  demandDateStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandDateTo: Scalars['Date'];
  receivableBalanceStatus?: InputMaybe<Scalars['String']>;
  salesTradeDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchReceiveOrdeViewFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryDateFrom?: InputMaybe<Scalars['Date']>;
  deliveryDateTo?: InputMaybe<Scalars['Date']>;
  deliveryDestinationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  estimateIdFrom?: InputMaybe<Scalars['Int']>;
  estimateIdTo?: InputMaybe<Scalars['Int']>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderDateFrom?: InputMaybe<Scalars['Date']>;
  receiveOrderDateTo?: InputMaybe<Scalars['Date']>;
  receiveOrderIdFrom?: InputMaybe<Scalars['Int']>;
  receiveOrderIdTo?: InputMaybe<Scalars['Int']>;
  receiveOrderStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderType?: InputMaybe<Scalars['String']>;
  returnDivision?: InputMaybe<Scalars['String']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchReceiveOrderDetail = Node & {
  __typename?: 'SearchReceiveOrderDetail';
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryDestinationCode?: Maybe<Scalars['String']>;
  deliveryDestinationName?: Maybe<Scalars['String']>;
  detailFlg: Scalars['Boolean'];
  detailMemo?: Maybe<Scalars['String']>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  estimateId?: Maybe<Scalars['String']>;
  firstRowByOrder?: Maybe<Scalars['Boolean']>;
  grossProfit?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  idForLink?: Maybe<Scalars['String']>;
  janCode?: Maybe<Scalars['String']>;
  lastRowByOrder?: Maybe<Scalars['Boolean']>;
  priceRoundType?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveDetailTradeType?: Maybe<Scalars['String']>;
  receiveOrderDate?: Maybe<Scalars['String']>;
  receiveOrderDetailStatus?: Maybe<Scalars['String']>;
  receiveOrderId?: Maybe<Scalars['String']>;
  receiveOrderPrice?: Maybe<Scalars['Float']>;
  receiveOrderQuantity?: Maybe<Scalars['Float']>;
  receiveOrderRemarks?: Maybe<Scalars['String']>;
  receiveOrderUnit?: Maybe<Scalars['Float']>;
  remainQuantity?: Maybe<Scalars['Float']>;
  salesTaxType?: Maybe<Scalars['String']>;
  salesTradeDivision?: Maybe<Scalars['String']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  salesUserCode?: Maybe<Scalars['String']>;
  taxRoundType?: Maybe<Scalars['String']>;
  taxationDivision?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type SearchReceiveOrderDetailConnection = {
  __typename?: 'SearchReceiveOrderDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchReceiveOrderDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchReceiveOrderDetail` and its cursor. */
export type SearchReceiveOrderDetailEdge = {
  __typename?: 'SearchReceiveOrderDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchReceiveOrderDetail>;
};

export type SearchReceiveOrderDetailFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gridType: Scalars['String'];
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderIdFrom?: InputMaybe<Scalars['Int']>;
  receiveOrderIdTo?: InputMaybe<Scalars['Int']>;
  termFrom: Scalars['Date'];
  termTo: Scalars['Date'];
  totallingType: Scalars['String'];
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visibleSubtotal: Scalars['Boolean'];
};

export type SearchReceiveOrderHeaderFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryDateFrom?: InputMaybe<Scalars['Date']>;
  deliveryDateTo?: InputMaybe<Scalars['Date']>;
  deliveryDestinationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryOrderIdFrom?: InputMaybe<Scalars['Int']>;
  deliveryOrderIdTo?: InputMaybe<Scalars['Int']>;
  deliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  estimateIdFrom?: InputMaybe<Scalars['Int']>;
  estimateIdTo?: InputMaybe<Scalars['Int']>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderDateFrom?: InputMaybe<Scalars['Date']>;
  receiveOrderDateTo?: InputMaybe<Scalars['Date']>;
  receiveOrderDetailStatus?: InputMaybe<Scalars['String']>;
  receiveOrderIdFrom?: InputMaybe<Scalars['Int']>;
  receiveOrderIdTo?: InputMaybe<Scalars['Int']>;
  receiveOrderStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderType?: InputMaybe<Scalars['String']>;
  returnDivision?: InputMaybe<Scalars['String']>;
  salesIdFrom?: InputMaybe<Scalars['Int']>;
  salesIdTo?: InputMaybe<Scalars['Int']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchReceiveOrderRemainFilter = {
  productCode?: InputMaybe<Scalars['String']>;
  receiveOrderId?: InputMaybe<Scalars['Int']>;
};

export type SearchReceiveOrderSalesUnitPriceUpdateFilter = {
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderDateFrom?: InputMaybe<Scalars['Date']>;
  receiveOrderDateTo?: InputMaybe<Scalars['Date']>;
  userCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchReceiveRemainByProduct = Node & {
  __typename?: 'SearchReceiveRemainByProduct';
  deliveryDate: Scalars['Date'];
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity: Scalars['Float'];
  receiveOrderId: Scalars['Int'];
  warehouseCode: Scalars['String'];
  warehouseName: Scalars['String'];
};

export type SearchReceiveRemainByProductConnection = {
  __typename?: 'SearchReceiveRemainByProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchReceiveRemainByProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchReceiveRemainByProduct` and its cursor. */
export type SearchReceiveRemainByProductEdge = {
  __typename?: 'SearchReceiveRemainByProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchReceiveRemainByProduct>;
};

export type SearchReceiveRemainByProductFilter = {
  productCode: Scalars['String'];
};

export type SearchReportLayoutFilter = {
  reportLayoutDivision?: InputMaybe<Scalars['String']>;
  reportLayoutDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reportLayoutTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsComparisonTableFilter = {
  aggregateTarget?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsCustomerFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsDeliverFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsDivisionFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsDivisionProductFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsProductFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesAnalyticsSalesUserFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displaySubtotal?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesChangingListCustomerFilter = {
  aggregateTarget: Scalars['String'];
  aggregateYear: Scalars['Int'];
  budgetStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayUnit?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesChangingListProductFilter = {
  aggregateTarget: Scalars['String'];
  aggregateYear: Scalars['Int'];
  displayUnit?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesDailyCustomerFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesDailyDivisionFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesDailyProductFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesDailySalesUserFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesDemandDetailFilter = {
  demandId?: InputMaybe<Scalars['Int']>;
  salesDate?: InputMaybe<Scalars['Date']>;
};

export type SearchSalesFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detailMainFlg?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeNullDeliveryDestination?: InputMaybe<Scalars['Boolean']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesIdFrom?: InputMaybe<Scalars['Int']>;
  salesIdTo?: InputMaybe<Scalars['Int']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSalesFromDeliveryOrderId2Filter = {
  deliveryOrderId: Scalars['Int'];
};

export type SearchSalesFromDeliveryOrderIdFilter = {
  deliveryOrderId?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type SearchSendOrderDetailFilter = {
  deliveryDateFrom?: InputMaybe<Scalars['Date']>;
  deliveryDateTo?: InputMaybe<Scalars['Date']>;
  detailMainFlg?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  orderDateFrom?: InputMaybe<Scalars['Date']>;
  orderDateTo?: InputMaybe<Scalars['Date']>;
  orderDetailStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderIdFrom?: InputMaybe<Scalars['Int']>;
  orderIdTo?: InputMaybe<Scalars['Int']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDetailStatus?: InputMaybe<Scalars['String']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSendOrderFilter = {
  clothDeliveryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryDateFrom?: InputMaybe<Scalars['Date']>;
  deliveryDateTo?: InputMaybe<Scalars['Date']>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  janCode?: InputMaybe<Scalars['String']>;
  orderDateFrom?: InputMaybe<Scalars['Date']>;
  orderDateTo?: InputMaybe<Scalars['Date']>;
  orderDetailStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderIdFrom?: InputMaybe<Scalars['Int']>;
  orderIdTo?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Scalars['String']>;
  poCodeFrom?: InputMaybe<Scalars['String']>;
  poCodeTo?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
  purchaseDetailStatus?: InputMaybe<Scalars['String']>;
  purposeGroup?: InputMaybe<Scalars['String']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSendOrderLotFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  lotGroupName?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  searchKeyword?: InputMaybe<Scalars['String']>;
};

export type SearchSendOrderPurchaseUnitPrice = Node & {
  __typename?: 'SearchSendOrderPurchaseUnitPrice';
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderQuantity?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productPurchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  productPurchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type SearchSendOrderPurchaseUnitPriceConnection = {
  __typename?: 'SearchSendOrderPurchaseUnitPriceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchSendOrderPurchaseUnitPriceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SearchSendOrderPurchaseUnitPrice` and its cursor. */
export type SearchSendOrderPurchaseUnitPriceEdge = {
  __typename?: 'SearchSendOrderPurchaseUnitPriceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchSendOrderPurchaseUnitPrice>;
};

export type SearchSendOrderPurchaseUnitPriceUpdateFilter = {
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDateFrom?: InputMaybe<Scalars['Date']>;
  orderDateTo?: InputMaybe<Scalars['Date']>;
};

export type SearchSendOrderRemainFilter = {
  orderId?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
};

export type SearchSendOrderViewFilter = {
  arrivalIdFrom?: InputMaybe<Scalars['Int']>;
  arrivalIdTo?: InputMaybe<Scalars['Int']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDateFrom?: InputMaybe<Scalars['Date']>;
  orderDateTo?: InputMaybe<Scalars['Date']>;
  orderDetailStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderIdFrom?: InputMaybe<Scalars['Int']>;
  orderIdTo?: InputMaybe<Scalars['Int']>;
  orderType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poCode?: InputMaybe<Scalars['String']>;
  purchaseDateFrom?: InputMaybe<Scalars['Date']>;
  purchaseDateTo?: InputMaybe<Scalars['Date']>;
  purchaseIdFrom?: InputMaybe<Scalars['Int']>;
  purchaseIdTo?: InputMaybe<Scalars['Int']>;
  searchKeywords?: InputMaybe<Scalars['String']>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSendOrderViewUnapprovedFilter = {
  approvalStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDateFrom?: InputMaybe<Scalars['Date']>;
  orderDateTo?: InputMaybe<Scalars['Date']>;
  orderIdFrom?: InputMaybe<Scalars['Int']>;
  orderIdTo?: InputMaybe<Scalars['Int']>;
  poCode?: InputMaybe<Scalars['String']>;
  requestUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeywords?: InputMaybe<Scalars['String']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchSendRemainByProduct = Node & {
  __typename?: 'SearchSendRemainByProduct';
  deliveryDate?: Maybe<Scalars['Date']>;
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  quantity: Scalars['Float'];
  warehouseCode: Scalars['String'];
  warehouseName: Scalars['String'];
};

export type SearchSendRemainByProductConnection = {
  __typename?: 'SearchSendRemainByProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchSendRemainByProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchSendRemainByProduct` and its cursor. */
export type SearchSendRemainByProductEdge = {
  __typename?: 'SearchSendRemainByProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchSendRemainByProduct>;
};

export type SearchSendRemainByProductFilter = {
  isByProductCode: Scalars['Boolean'];
  janCode?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
};

export type SearchShipmentFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryOrderDateFrom?: InputMaybe<Scalars['Date']>;
  deliveryOrderDateTo?: InputMaybe<Scalars['Date']>;
  deliveryOrderIdFrom?: InputMaybe<Scalars['Int']>;
  deliveryOrderIdTo?: InputMaybe<Scalars['Int']>;
  detailMainFlg?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderIdFrom?: InputMaybe<Scalars['Int']>;
  receiveOrderIdTo?: InputMaybe<Scalars['Int']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchShopsTrustInventoryDetail = {
  __typename?: 'SearchShopsTrustInventoryDetail';
  customerCode: Scalars['String'];
  customerName: Scalars['String'];
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryMonth: Scalars['Date'];
  inventoryStatus?: Maybe<Scalars['String']>;
  inventoryStatusLabel?: Maybe<Scalars['String']>;
  inventoryTo: Scalars['Date'];
  remark?: Maybe<Scalars['String']>;
  salesUserCode: Scalars['String'];
  salesUserName: Scalars['String'];
  trustInventoryId: Scalars['Int'];
};

export type SearchShopsTrustInventoryFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inventoryFrom?: InputMaybe<Scalars['Date']>;
  inventoryTo?: InputMaybe<Scalars['Date']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trustInventoryStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchShopsTrustInventoryOperators = {
  __typename?: 'SearchShopsTrustInventoryOperators';
  operationAt?: Maybe<Scalars['DateTime']>;
  operatorBelong?: Maybe<Scalars['String']>;
  operatorCode?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  operatorType: Scalars['String'];
  trustInventoryId: Scalars['Int'];
};

export type SearchShopsTrustInventoryOperatorsFilter = {
  trustInventoryId: Scalars['Int'];
};

export type SearchStockAdjustFilter = {
  adjustDateFrom?: InputMaybe<Scalars['Date']>;
  adjustDateTo?: InputMaybe<Scalars['Date']>;
  adjustIdFrom?: InputMaybe<Scalars['Int']>;
  adjustIdTo?: InputMaybe<Scalars['Int']>;
  adjustMemo?: InputMaybe<Scalars['String']>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchStockAnalyticsInventoryFilter = {
  dio?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayAllZero: Scalars['String'];
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeOutsourcer: Scalars['String'];
  inventoryId: Scalars['String'];
  manufacturer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchStockAnalyticsMonthFilter = {
  dio?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayAllZero: Scalars['String'];
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeOutsourcer: Scalars['String'];
  manufacturer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderType: Scalars['String'];
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  termFrom: Scalars['Int'];
  termTo: Scalars['Int'];
  times: Scalars['Int'];
  visibleSubtotal: Scalars['Boolean'];
};

export type SearchStockAnalyticsTermFilter = {
  dio?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayAllZero: Scalars['String'];
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeOutsourcer: Scalars['String'];
  manufacturer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  termFrom: Scalars['Date'];
  termTo: Scalars['Date'];
};

export type SearchStockByWarehouse = Node & {
  __typename?: 'SearchStockByWarehouse';
  divisionCode: Scalars['String'];
  divisionName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity: Scalars['Float'];
  warehouseCode: Scalars['String'];
  warehouseName: Scalars['String'];
};

export type SearchStockByWarehouseConnection = {
  __typename?: 'SearchStockByWarehouseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchStockByWarehouseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchStockByWarehouse` and its cursor. */
export type SearchStockByWarehouseEdge = {
  __typename?: 'SearchStockByWarehouseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchStockByWarehouse>;
};

export type SearchStockByWarehouseFilter = {
  productCode: Scalars['String'];
};

export type SearchStockListByDivisionFilter = {
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockBaseDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Scalars['JSONString']>;
};

export type SearchStockListByProductFilter = {
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  displayLessDivisionBaseFlg?: InputMaybe<Scalars['String']>;
  displayLessSendBaseFlg?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockBaseDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Scalars['JSONString']>;
};

export type SearchStockListByWarehouseFilter = {
  discontinueFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupIds3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stockBaseDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  warehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchTermsAndConditionsFilter = {
  enactmentDate?: InputMaybe<Scalars['String']>;
  termsId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchTradeHistoryByMonthFilter = {
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetWarehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeDateFrom?: InputMaybe<Scalars['Date']>;
  tradeDateTo?: InputMaybe<Scalars['Date']>;
  tradeHistoryTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchTradeHistoryFilter = {
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetWarehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tradeDateFrom?: InputMaybe<Scalars['String']>;
  tradeDateTo?: InputMaybe<Scalars['String']>;
  tradeHistoryTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchTradeHistoryForDialog = Node & {
  __typename?: 'SearchTradeHistoryForDialog';
  customerName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity: Scalars['Float'];
  tradeDate: Scalars['Date'];
};

export type SearchTradeHistoryForDialogConnection = {
  __typename?: 'SearchTradeHistoryForDialogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchTradeHistoryForDialogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchTradeHistoryForDialog` and its cursor. */
export type SearchTradeHistoryForDialogEdge = {
  __typename?: 'SearchTradeHistoryForDialogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchTradeHistoryForDialog>;
};

export type SearchTradeHistoryForDialogFilter = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isByProductCode: Scalars['Boolean'];
  productCode: Scalars['String'];
  targetType: Scalars['String'];
};

export type SearchTradeHistoryStockFilter = {
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  targetData?: InputMaybe<Scalars['Date']>;
  warehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchTrustInventoryFilter = {
  customerCode?: InputMaybe<Scalars['String']>;
  inventoryFrom?: InputMaybe<Scalars['Date']>;
  inventoryTo?: InputMaybe<Scalars['Date']>;
  salesMonth?: InputMaybe<Scalars['Date']>;
  trustInventoryRemark?: InputMaybe<Scalars['String']>;
};

export type SearchTrustSalesFilter = {
  customerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  salesDateFrom?: InputMaybe<Scalars['Date']>;
  salesDateTo?: InputMaybe<Scalars['Date']>;
  salesIdFrom?: InputMaybe<Scalars['Int']>;
  salesIdTo?: InputMaybe<Scalars['Int']>;
  salesUserCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  trustSalesDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchUnitHistory = Node & {
  __typename?: 'SearchUnitHistory';
  customerName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Float']>;
  slipDate?: Maybe<Scalars['Date']>;
  slipNumber?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type SearchUnitHistoryConnection = {
  __typename?: 'SearchUnitHistoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchUnitHistoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchUnitHistory` and its cursor. */
export type SearchUnitHistoryEdge = {
  __typename?: 'SearchUnitHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchUnitHistory>;
};

export type SearchUnitHistoryFilter = {
  classification: Scalars['String'];
  customerCode?: InputMaybe<Scalars['String']>;
  productCode: Scalars['String'];
};

export type SearchUnitHistoryTrust = Node & {
  __typename?: 'SearchUnitHistoryTrust';
  customerName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Float']>;
  salesDate?: Maybe<Scalars['Date']>;
  salesNumber?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Float']>;
};

export type SearchUnitHistoryTrustConnection = {
  __typename?: 'SearchUnitHistoryTrustConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchUnitHistoryTrustEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchUnitHistoryTrust` and its cursor. */
export type SearchUnitHistoryTrustEdge = {
  __typename?: 'SearchUnitHistoryTrustEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchUnitHistoryTrust>;
};

export type SearchUnitHistoryTrustFilter = {
  customerCode?: InputMaybe<Scalars['String']>;
  isInventory: Scalars['Boolean'];
  janCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
};

export type SearchUpdateDispTrustInventoryFilter = {
  trustInventoryId: Scalars['String'];
};

export type SearchUserFilter = {
  companyStoreDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isCustomerSalesUser?: InputMaybe<Scalars['Boolean']>;
  userKeyword?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type SearchVendorFilter = {
  purposeGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tradeStopFlg?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorTradeDivision?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchVendorFromCodeFilter = {
  vendorCode: Scalars['String'];
};

export type SearchVendorPaymentFilter = {
  closingDate?: InputMaybe<Scalars['Date']>;
  tradeStopFlgs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorClosingGroup: Scalars['String'];
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchVendorPurchaseFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  purchaseRemarkFlg?: InputMaybe<Scalars['String']>;
  totalingDateFrom?: InputMaybe<Scalars['Date']>;
  totalingDateTo?: InputMaybe<Scalars['Date']>;
  totalingMethod?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorTradeDivision?: InputMaybe<Scalars['String']>;
};

export type SearchVendorPurchaseMonthlyFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalingDateFrom: Scalars['Date'];
  totalingDateTo: Scalars['Date'];
  totalingMethod: Scalars['String'];
  vendorCode: Scalars['String'];
  vendorTradeDivision?: InputMaybe<Scalars['String']>;
};

export type SearchVendorWithCarryOverFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalingDateFrom: Scalars['Date'];
  vendorCode: Scalars['String'];
  vendorTradeDivision?: InputMaybe<Scalars['String']>;
};

export type SearchWarehouseFilter = {
  customerCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseCode?: InputMaybe<Scalars['String']>;
  warehouseCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseName?: InputMaybe<Scalars['String']>;
  warehouseType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchWarehouseMoveDetail = Node & {
  __typename?: 'SearchWarehouseMoveDetail';
  adjustId?: Maybe<Scalars['String']>;
  deliveryOrderId?: Maybe<Scalars['String']>;
  destinationAttributeName?: Maybe<Scalars['String']>;
  destinationDivisionCode?: Maybe<Scalars['String']>;
  destinationDivisionName?: Maybe<Scalars['String']>;
  destinationJanCode?: Maybe<Scalars['String']>;
  destinationPrice?: Maybe<Scalars['Float']>;
  destinationSalesUnitPrice?: Maybe<Scalars['Float']>;
  destinationWarehouseCode?: Maybe<Scalars['String']>;
  destinationWarehouseName?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  moveDate?: Maybe<Scalars['String']>;
  moveQuantity?: Maybe<Scalars['Int']>;
  receiveOrderId?: Maybe<Scalars['String']>;
  sourceAttributeName?: Maybe<Scalars['String']>;
  sourceDivisionCode?: Maybe<Scalars['String']>;
  sourceDivisionName?: Maybe<Scalars['String']>;
  sourceJanCode?: Maybe<Scalars['String']>;
  sourcePrice?: Maybe<Scalars['Float']>;
  sourceSalesUnitPrice?: Maybe<Scalars['Float']>;
  sourceWarehouseCode?: Maybe<Scalars['String']>;
  sourceWarehouseName?: Maybe<Scalars['String']>;
  tradeHistoryType?: Maybe<Scalars['String']>;
  tradeTargetId?: Maybe<Scalars['String']>;
  warehouseMoveId?: Maybe<Scalars['String']>;
};

export type SearchWarehouseMoveDetailConnection = {
  __typename?: 'SearchWarehouseMoveDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchWarehouseMoveDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SearchWarehouseMoveDetail` and its cursor. */
export type SearchWarehouseMoveDetailEdge = {
  __typename?: 'SearchWarehouseMoveDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SearchWarehouseMoveDetail>;
};

export type SearchWarehouseMoveDetailFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  moveDateFrom?: InputMaybe<Scalars['Date']>;
  moveDateTo?: InputMaybe<Scalars['Date']>;
  moveWarehouseDestinationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseDestinations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseSourceDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseSources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  tradeHistoryTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchWarehouseMoveFilter = {
  janCode?: InputMaybe<Scalars['String']>;
  moveDateFrom?: InputMaybe<Scalars['Date']>;
  moveDateTo?: InputMaybe<Scalars['Date']>;
  moveWarehouseDestinationDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseDestinationTrusts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseDestinations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseSourceDivisions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseSourceTrusts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveWarehouseSources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId2?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productGroupId3?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  warehouseMoveIdFrom?: InputMaybe<Scalars['Int']>;
  warehouseMoveIdTo?: InputMaybe<Scalars['Int']>;
  warehouseMoveStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchWithDrawalsMonthlyFilter = {
  payDate: Scalars['Date'];
  vendorCode: Scalars['String'];
};

export type SearchWithdrawalFilter = {
  payDateFrom?: InputMaybe<Scalars['Date']>;
  payDateTo?: InputMaybe<Scalars['Date']>;
  payPriceFrom?: InputMaybe<Scalars['Decimal']>;
  payPriceTo?: InputMaybe<Scalars['Decimal']>;
  vendorClosingGroup?: InputMaybe<Scalars['String']>;
  vendorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SearchWithdrawalPaymentDetailFilter = {
  payDate?: InputMaybe<Scalars['Date']>;
  paymentId?: InputMaybe<Scalars['Int']>;
};

export type SearchWithdrawalVendorPurchaseFilter = {
  closingStatusCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  totalingDateFrom?: InputMaybe<Scalars['Date']>;
  totalingDateTo?: InputMaybe<Scalars['Date']>;
  vendorCode: Scalars['String'];
};

export type SendBackTrustInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  reasonForSendBack: Scalars['String'];
  trustInventoryId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type SendBackTrustInventoryPayload = {
  __typename?: 'SendBackTrustInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type SendOrder = Node & {
  __typename?: 'SendOrder';
  approvalDate?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  approvalUserCode?: Maybe<Scalars['String']>;
  approvalUserName?: Maybe<Scalars['String']>;
  arrival?: Maybe<Arrival>;
  completedDetailCount: Scalars['Int'];
  createDate: Scalars['DateTime'];
  createUser?: Maybe<User>;
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryStatus: Scalars['String'];
  detailCount: Scalars['Int'];
  division?: Maybe<Division>;
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  orderDate: Scalars['String'];
  orderId: Scalars['ID'];
  orderMemo?: Maybe<Scalars['String']>;
  orderRemarks?: Maybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: Maybe<Scalars['String']>;
  purchase?: Maybe<Purchase>;
  remandMemo?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['String']>;
  requestType: Scalars['String'];
  requestUserCode?: Maybe<Scalars['String']>;
  requestUserName?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrderDetails?: Maybe<SendOrderDetailConnection>;
  shippingCode?: Maybe<Scalars['String']>;
  shippingName?: Maybe<Scalars['String']>;
  shippingTypeCode: Scalars['String'];
  taxExcludeTotal?: Maybe<Scalars['Float']>;
  undeliveredDetailCount: Scalars['Int'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode: Scalars['String'];
  vendorTaxType: Scalars['String'];
  vendorTradeDivision: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type SendOrderSendOrderDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SendOrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SendOrderConnection = {
  __typename?: 'SendOrderConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SendOrderEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SendOrderDetail = Node & {
  __typename?: 'SendOrderDetail';
  Warehouse?: Maybe<Warehouse>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  groupNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  orderDetailStatus: Scalars['String'];
  orderId: Scalars['ID'];
  orderQuantity?: Maybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  purchasePriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  receivedQuantity?: Maybe<Scalars['Float']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type SendOrderDetailConnection = {
  __typename?: 'SendOrderDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SendOrderDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SendOrderDetail` and its cursor. */
export type SendOrderDetailEdge = {
  __typename?: 'SendOrderDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SendOrderDetail>;
};

export type SendOrderDetailFilter = {
  clothGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  detailMainFlg?: InputMaybe<Scalars['String']>;
  itemDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDetailStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum SendOrderDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  GroupNumberingAsc = 'GROUP_NUMBERING_ASC',
  GroupNumberingDesc = 'GROUP_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OrderDetailStatusAsc = 'ORDER_DETAIL_STATUS_ASC',
  OrderDetailStatusDesc = 'ORDER_DETAIL_STATUS_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  OrderQuantityAsc = 'ORDER_QUANTITY_ASC',
  OrderQuantityDesc = 'ORDER_QUANTITY_DESC',
  OrderTradeTypeCodeAsc = 'ORDER_TRADE_TYPE_CODE_ASC',
  OrderTradeTypeCodeDesc = 'ORDER_TRADE_TYPE_CODE_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  PurchasePriceAsc = 'PURCHASE_PRICE_ASC',
  PurchasePriceDesc = 'PURCHASE_PRICE_DESC',
  PurchasePriceDollarAsc = 'PURCHASE_PRICE_DOLLAR_ASC',
  PurchasePriceDollarDesc = 'PURCHASE_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  ReceivedQuantityAsc = 'RECEIVED_QUANTITY_ASC',
  ReceivedQuantityDesc = 'RECEIVED_QUANTITY_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalQuantityAsc = 'TOTAL_QUANTITY_ASC',
  TotalQuantityDesc = 'TOTAL_QUANTITY_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

/** A Relay edge containing a `SendOrder` and its cursor. */
export type SendOrderEdge = {
  __typename?: 'SendOrderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SendOrder>;
};

export type SendOrderLot = Node & {
  __typename?: 'SendOrderLot';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  lotGroupCode: Scalars['ID'];
  lotGroupName: Scalars['String'];
  minimumLot: Scalars['Int'];
  productVariants?: Maybe<ProductVariantConnection>;
  purchaseOrderLeadTime?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type SendOrderLotProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SendOrderLotConnection = {
  __typename?: 'SendOrderLotConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SendOrderLotEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SendOrderLot` and its cursor. */
export type SendOrderLotEdge = {
  __typename?: 'SendOrderLotEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SendOrderLot>;
};

/** An enumeration. */
export enum SendOrderLotSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  LotGroupCodeAsc = 'LOT_GROUP_CODE_ASC',
  LotGroupCodeDesc = 'LOT_GROUP_CODE_DESC',
  LotGroupNameAsc = 'LOT_GROUP_NAME_ASC',
  LotGroupNameDesc = 'LOT_GROUP_NAME_DESC',
  MinimumLotAsc = 'MINIMUM_LOT_ASC',
  MinimumLotDesc = 'MINIMUM_LOT_DESC',
  PurchaseOrderLeadTimeAsc = 'PURCHASE_ORDER_LEAD_TIME_ASC',
  PurchaseOrderLeadTimeDesc = 'PURCHASE_ORDER_LEAD_TIME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type SendOrderPrintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  reportLayoutCode: Scalars['String'];
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type SendOrderPrintPayload = {
  __typename?: 'SendOrderPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum SendOrderSortEnum {
  ApprovalDateAsc = 'APPROVAL_DATE_ASC',
  ApprovalDateDesc = 'APPROVAL_DATE_DESC',
  ApprovalStatusAsc = 'APPROVAL_STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL_STATUS_DESC',
  ApprovalUserCodeAsc = 'APPROVAL_USER_CODE_ASC',
  ApprovalUserCodeDesc = 'APPROVAL_USER_CODE_DESC',
  ApprovalUserNameAsc = 'APPROVAL_USER_NAME_ASC',
  ApprovalUserNameDesc = 'APPROVAL_USER_NAME_DESC',
  CompletedDetailCountAsc = 'COMPLETED_DETAIL_COUNT_ASC',
  CompletedDetailCountDesc = 'COMPLETED_DETAIL_COUNT_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveryDateAsc = 'DELIVERY_DATE_ASC',
  DeliveryDateDesc = 'DELIVERY_DATE_DESC',
  DeliveryStatusAsc = 'DELIVERY_STATUS_ASC',
  DeliveryStatusDesc = 'DELIVERY_STATUS_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  OrderDateAsc = 'ORDER_DATE_ASC',
  OrderDateDesc = 'ORDER_DATE_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  OrderMemoAsc = 'ORDER_MEMO_ASC',
  OrderMemoDesc = 'ORDER_MEMO_DESC',
  OrderRemarksAsc = 'ORDER_REMARKS_ASC',
  OrderRemarksDesc = 'ORDER_REMARKS_DESC',
  OrderTypeAsc = 'ORDER_TYPE_ASC',
  OrderTypeDesc = 'ORDER_TYPE_DESC',
  PoCodeAsc = 'PO_CODE_ASC',
  PoCodeDesc = 'PO_CODE_DESC',
  RemandMemoAsc = 'REMAND_MEMO_ASC',
  RemandMemoDesc = 'REMAND_MEMO_DESC',
  RequestDateAsc = 'REQUEST_DATE_ASC',
  RequestDateDesc = 'REQUEST_DATE_DESC',
  RequestTypeAsc = 'REQUEST_TYPE_ASC',
  RequestTypeDesc = 'REQUEST_TYPE_DESC',
  RequestUserCodeAsc = 'REQUEST_USER_CODE_ASC',
  RequestUserCodeDesc = 'REQUEST_USER_CODE_DESC',
  RequestUserNameAsc = 'REQUEST_USER_NAME_ASC',
  RequestUserNameDesc = 'REQUEST_USER_NAME_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  ShippingCodeAsc = 'SHIPPING_CODE_ASC',
  ShippingCodeDesc = 'SHIPPING_CODE_DESC',
  ShippingNameAsc = 'SHIPPING_NAME_ASC',
  ShippingNameDesc = 'SHIPPING_NAME_DESC',
  ShippingTypeCodeAsc = 'SHIPPING_TYPE_CODE_ASC',
  ShippingTypeCodeDesc = 'SHIPPING_TYPE_CODE_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  UndeliveredDetailCountAsc = 'UNDELIVERED_DETAIL_COUNT_ASC',
  UndeliveredDetailCountDesc = 'UNDELIVERED_DETAIL_COUNT_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VendorTaxTypeAsc = 'VENDOR_TAX_TYPE_ASC',
  VendorTaxTypeDesc = 'VENDOR_TAX_TYPE_DESC',
  VendorTradeDivisionAsc = 'VENDOR_TRADE_DIVISION_ASC',
  VendorTradeDivisionDesc = 'VENDOR_TRADE_DIVISION_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type SendOrderView = Node & {
  __typename?: 'SendOrderView';
  approvalDate?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  approvalUserCode?: Maybe<Scalars['String']>;
  approvalUserName?: Maybe<Scalars['String']>;
  arrival?: Maybe<Arrival>;
  completedDetailCount?: Maybe<Scalars['Int']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryStatus?: Maybe<Scalars['String']>;
  detailCount?: Maybe<Scalars['Int']>;
  divisionCode: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  orderDate: Scalars['String'];
  orderId: Scalars['ID'];
  orderMemo?: Maybe<Scalars['String']>;
  orderRemarks?: Maybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['String']>;
  requestType: Scalars['String'];
  requestUserCode?: Maybe<Scalars['String']>;
  requestUserName?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  sendOrderDetails?: Maybe<ClothProgressConnection>;
  shippingCode?: Maybe<Scalars['String']>;
  shippingName?: Maybe<Scalars['String']>;
  shippingTypeCode: Scalars['String'];
  taxExcludeTotal?: Maybe<Scalars['Int']>;
  undeliveredDetailCount?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendor?: Maybe<Vendor>;
  vendorCode: Scalars['String'];
  vendorName: Scalars['String'];
  vendorTaxType: Scalars['String'];
  vendorTradeDivision: Scalars['String'];
  vendorUnitpriceType?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};


export type SendOrderViewSendOrderDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SendOrderViewConnection = {
  __typename?: 'SendOrderViewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SendOrderViewEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SendOrderView` and its cursor. */
export type SendOrderViewEdge = {
  __typename?: 'SendOrderViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SendOrderView>;
};

/** An enumeration. */
export enum SendOrderViewSortEnum {
  ApprovalDateAsc = 'APPROVAL_DATE_ASC',
  ApprovalDateDesc = 'APPROVAL_DATE_DESC',
  ApprovalStatusAsc = 'APPROVAL_STATUS_ASC',
  ApprovalStatusDesc = 'APPROVAL_STATUS_DESC',
  ApprovalUserCodeAsc = 'APPROVAL_USER_CODE_ASC',
  ApprovalUserCodeDesc = 'APPROVAL_USER_CODE_DESC',
  ApprovalUserNameAsc = 'APPROVAL_USER_NAME_ASC',
  ApprovalUserNameDesc = 'APPROVAL_USER_NAME_DESC',
  CompletedDetailCountAsc = 'COMPLETED_DETAIL_COUNT_ASC',
  CompletedDetailCountDesc = 'COMPLETED_DETAIL_COUNT_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveryDateAsc = 'DELIVERY_DATE_ASC',
  DeliveryDateDesc = 'DELIVERY_DATE_DESC',
  DeliveryStatusAsc = 'DELIVERY_STATUS_ASC',
  DeliveryStatusDesc = 'DELIVERY_STATUS_DESC',
  DetailCountAsc = 'DETAIL_COUNT_ASC',
  DetailCountDesc = 'DETAIL_COUNT_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  OrderDateAsc = 'ORDER_DATE_ASC',
  OrderDateDesc = 'ORDER_DATE_DESC',
  OrderIdAsc = 'ORDER_ID_ASC',
  OrderIdDesc = 'ORDER_ID_DESC',
  OrderMemoAsc = 'ORDER_MEMO_ASC',
  OrderMemoDesc = 'ORDER_MEMO_DESC',
  OrderRemarksAsc = 'ORDER_REMARKS_ASC',
  OrderRemarksDesc = 'ORDER_REMARKS_DESC',
  OrderTypeAsc = 'ORDER_TYPE_ASC',
  OrderTypeDesc = 'ORDER_TYPE_DESC',
  PoCodeAsc = 'PO_CODE_ASC',
  PoCodeDesc = 'PO_CODE_DESC',
  RequestDateAsc = 'REQUEST_DATE_ASC',
  RequestDateDesc = 'REQUEST_DATE_DESC',
  RequestTypeAsc = 'REQUEST_TYPE_ASC',
  RequestTypeDesc = 'REQUEST_TYPE_DESC',
  RequestUserCodeAsc = 'REQUEST_USER_CODE_ASC',
  RequestUserCodeDesc = 'REQUEST_USER_CODE_DESC',
  RequestUserNameAsc = 'REQUEST_USER_NAME_ASC',
  RequestUserNameDesc = 'REQUEST_USER_NAME_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  ShippingCodeAsc = 'SHIPPING_CODE_ASC',
  ShippingCodeDesc = 'SHIPPING_CODE_DESC',
  ShippingNameAsc = 'SHIPPING_NAME_ASC',
  ShippingNameDesc = 'SHIPPING_NAME_DESC',
  ShippingTypeCodeAsc = 'SHIPPING_TYPE_CODE_ASC',
  ShippingTypeCodeDesc = 'SHIPPING_TYPE_CODE_DESC',
  TaxExcludeTotalAsc = 'TAX_EXCLUDE_TOTAL_ASC',
  TaxExcludeTotalDesc = 'TAX_EXCLUDE_TOTAL_DESC',
  UndeliveredDetailCountAsc = 'UNDELIVERED_DETAIL_COUNT_ASC',
  UndeliveredDetailCountDesc = 'UNDELIVERED_DETAIL_COUNT_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VendorNameAsc = 'VENDOR_NAME_ASC',
  VendorNameDesc = 'VENDOR_NAME_DESC',
  VendorTaxTypeAsc = 'VENDOR_TAX_TYPE_ASC',
  VendorTaxTypeDesc = 'VENDOR_TAX_TYPE_DESC',
  VendorTradeDivisionAsc = 'VENDOR_TRADE_DIVISION_ASC',
  VendorTradeDivisionDesc = 'VENDOR_TRADE_DIVISION_DESC',
  VendorUnitpriceTypeAsc = 'VENDOR_UNITPRICE_TYPE_ASC',
  VendorUnitpriceTypeDesc = 'VENDOR_UNITPRICE_TYPE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Shipment = Node & {
  __typename?: 'Shipment';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerWarehouseCode?: Maybe<Scalars['String']>;
  deliveryOrderDate: Scalars['String'];
  deliveryOrderId: Scalars['ID'];
  deliveryOrderMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  receiveOrder?: Maybe<ReceiveOrderHeader>;
  receiveOrderId: Scalars['Int'];
  sales?: Maybe<Sales>;
  salesRemark?: Maybe<Scalars['String']>;
  shipmentDetails?: Maybe<ShipmentDetailConnection>;
  shipmentTaxDetails?: Maybe<ShipmentTaxDetailConnection>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type ShipmentShipmentDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShipmentDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ShipmentShipmentTaxDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ShipmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum ShipmentCustomSortEnum {
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DeliveryDestinationCodeAsc = 'DELIVERY_DESTINATION_CODE_ASC',
  DeliveryDestinationCodeDesc = 'DELIVERY_DESTINATION_CODE_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC'
}

export type ShipmentDetail = Node & {
  __typename?: 'ShipmentDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryDetailTradeType: Scalars['String'];
  deliveryOrderDetailStatus: Scalars['String'];
  deliveryOrderId: Scalars['ID'];
  deliveryOrderQuantity?: Maybe<Scalars['Float']>;
  detailMainFlg?: Maybe<Scalars['String']>;
  detailMemo?: Maybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  outWarehouseFlg?: Maybe<Scalars['String']>;
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiveOrderDetailNumbering?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  shipment?: Maybe<Shipment>;
  taxDivision?: Maybe<TaxDivision>;
  taxationDivision?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  totalTaxExcluded?: Maybe<Scalars['Float']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode?: Maybe<Scalars['String']>;
};

export type ShipmentDetailConnection = {
  __typename?: 'ShipmentDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ShipmentDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ShipmentDetail` and its cursor. */
export type ShipmentDetailEdge = {
  __typename?: 'ShipmentDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ShipmentDetail>;
};

export type ShipmentDetailFilter = {
  detailMainFlg?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId1s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId2s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productGroupId3s?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum ShipmentDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DeliveryDetailTradeTypeAsc = 'DELIVERY_DETAIL_TRADE_TYPE_ASC',
  DeliveryDetailTradeTypeDesc = 'DELIVERY_DETAIL_TRADE_TYPE_DESC',
  DeliveryOrderDetailStatusAsc = 'DELIVERY_ORDER_DETAIL_STATUS_ASC',
  DeliveryOrderDetailStatusDesc = 'DELIVERY_ORDER_DETAIL_STATUS_DESC',
  DeliveryOrderIdAsc = 'DELIVERY_ORDER_ID_ASC',
  DeliveryOrderIdDesc = 'DELIVERY_ORDER_ID_DESC',
  DeliveryOrderQuantityAsc = 'DELIVERY_ORDER_QUANTITY_ASC',
  DeliveryOrderQuantityDesc = 'DELIVERY_ORDER_QUANTITY_DESC',
  DetailMainFlgAsc = 'DETAIL_MAIN_FLG_ASC',
  DetailMainFlgDesc = 'DETAIL_MAIN_FLG_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  FrontNumberingAsc = 'FRONT_NUMBERING_ASC',
  FrontNumberingDesc = 'FRONT_NUMBERING_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  OutWarehouseFlgAsc = 'OUT_WAREHOUSE_FLG_ASC',
  OutWarehouseFlgDesc = 'OUT_WAREHOUSE_FLG_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  ProductNameAsc = 'PRODUCT_NAME_ASC',
  ProductNameDesc = 'PRODUCT_NAME_DESC',
  ReceiveOrderDetailNumberingAsc = 'RECEIVE_ORDER_DETAIL_NUMBERING_ASC',
  ReceiveOrderDetailNumberingDesc = 'RECEIVE_ORDER_DETAIL_NUMBERING_DESC',
  RetailPriceAsc = 'RETAIL_PRICE_ASC',
  RetailPriceDesc = 'RETAIL_PRICE_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  SellingPriceAsc = 'SELLING_PRICE_ASC',
  SellingPriceDesc = 'SELLING_PRICE_DESC',
  SellingUnitPriceAsc = 'SELLING_UNIT_PRICE_ASC',
  SellingUnitPriceDesc = 'SELLING_UNIT_PRICE_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TotalQuantityAsc = 'TOTAL_QUANTITY_ASC',
  TotalQuantityDesc = 'TOTAL_QUANTITY_DESC',
  TotalTaxExcludedAsc = 'TOTAL_TAX_EXCLUDED_ASC',
  TotalTaxExcludedDesc = 'TOTAL_TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

/** A Relay edge containing a `Shipment` and its cursor. */
export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Shipment>;
};

/** An enumeration. */
export enum ShipmentSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerWarehouseCodeAsc = 'CUSTOMER_WAREHOUSE_CODE_ASC',
  CustomerWarehouseCodeDesc = 'CUSTOMER_WAREHOUSE_CODE_DESC',
  DeliveryOrderDateAsc = 'DELIVERY_ORDER_DATE_ASC',
  DeliveryOrderDateDesc = 'DELIVERY_ORDER_DATE_DESC',
  DeliveryOrderIdAsc = 'DELIVERY_ORDER_ID_ASC',
  DeliveryOrderIdDesc = 'DELIVERY_ORDER_ID_DESC',
  DeliveryOrderMemoAsc = 'DELIVERY_ORDER_MEMO_ASC',
  DeliveryOrderMemoDesc = 'DELIVERY_ORDER_MEMO_DESC',
  ReceiveOrderIdAsc = 'RECEIVE_ORDER_ID_ASC',
  ReceiveOrderIdDesc = 'RECEIVE_ORDER_ID_DESC',
  SalesRemarkAsc = 'SALES_REMARK_ASC',
  SalesRemarkDesc = 'SALES_REMARK_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type ShipmentTaxDetail = Node & {
  __typename?: 'ShipmentTaxDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  deliveryOrderId?: Maybe<Scalars['Int']>;
  exciseTax?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  salesId?: Maybe<Scalars['Int']>;
  taxDivision?: Maybe<TaxDivision>;
  taxExcluded?: Maybe<Scalars['Float']>;
  taxIncluded?: Maybe<Scalars['Float']>;
  taxRoundType: Scalars['String'];
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type ShipmentTaxDetailConnection = {
  __typename?: 'ShipmentTaxDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ShipmentTaxDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ShipmentTaxDetail` and its cursor. */
export type ShipmentTaxDetailEdge = {
  __typename?: 'ShipmentTaxDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ShipmentTaxDetail>;
};

export type Stock = Node & {
  __typename?: 'Stock';
  allQuantity?: Maybe<Scalars['Int']>;
  externalQuantity?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  mainQuantity?: Maybe<Scalars['Int']>;
};

export type StockAdjust = Node & {
  __typename?: 'StockAdjust';
  adjustDate: Scalars['String'];
  adjustId: Scalars['ID'];
  adjustMemo?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  stockAdjustDetails?: Maybe<StockAdjustDetailConnection>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouse?: Maybe<Warehouse>;
  warehouseCode: Scalars['String'];
};


export type StockAdjustStockAdjustDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type StockAdjustConnection = {
  __typename?: 'StockAdjustConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockAdjustEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StockAdjustDetail = Node & {
  __typename?: 'StockAdjustDetail';
  adjustId: Scalars['ID'];
  adjustQuantity: Scalars['Float'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  damageQuantity: Scalars['Float'];
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode: Scalars['String'];
  numbering: Scalars['ID'];
  productCode: Scalars['String'];
  productVariant?: Maybe<ProductVariant>;
  stockAdjust?: Maybe<StockAdjust>;
  stockQuantity: Scalars['Float'];
  unitCost: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type StockAdjustDetailConnection = {
  __typename?: 'StockAdjustDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockAdjustDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StockAdjustDetail` and its cursor. */
export type StockAdjustDetailEdge = {
  __typename?: 'StockAdjustDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockAdjustDetail>;
};

/** An enumeration. */
export enum StockAdjustDetailSortEnum {
  AdjustIdAsc = 'ADJUST_ID_ASC',
  AdjustIdDesc = 'ADJUST_ID_DESC',
  AdjustQuantityAsc = 'ADJUST_QUANTITY_ASC',
  AdjustQuantityDesc = 'ADJUST_QUANTITY_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DamageQuantityAsc = 'DAMAGE_QUANTITY_ASC',
  DamageQuantityDesc = 'DAMAGE_QUANTITY_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  StockQuantityAsc = 'STOCK_QUANTITY_ASC',
  StockQuantityDesc = 'STOCK_QUANTITY_DESC',
  UnitCostAsc = 'UNIT_COST_ASC',
  UnitCostDesc = 'UNIT_COST_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `StockAdjust` and its cursor. */
export type StockAdjustEdge = {
  __typename?: 'StockAdjustEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockAdjust>;
};

/** An enumeration. */
export enum StockAdjustSortEnum {
  AdjustDateAsc = 'ADJUST_DATE_ASC',
  AdjustDateDesc = 'ADJUST_DATE_DESC',
  AdjustIdAsc = 'ADJUST_ID_ASC',
  AdjustIdDesc = 'ADJUST_ID_DESC',
  AdjustMemoAsc = 'ADJUST_MEMO_ASC',
  AdjustMemoDesc = 'ADJUST_MEMO_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type StockAlert = Node & {
  __typename?: 'StockAlert';
  division?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  purchaseOrder?: Maybe<Scalars['Float']>;
};

export type StockAlertFilter = {
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StockAnalytics = Node & {
  __typename?: 'StockAnalytics';
  adjustInput: Scalars['Float'];
  adjustOutput: Scalars['Float'];
  averageStockPrice: Scalars['Float'];
  buyOutput: Scalars['Float'];
  buyReturn: Scalars['Float'];
  dio: Scalars['Float'];
  dioRank: Scalars['String'];
  directOutput: Scalars['Float'];
  directReturn: Scalars['Float'];
  disposal: Scalars['Float'];
  divisionInput: Scalars['Float'];
  divisionOutput: Scalars['Float'];
  domOverFlg: Scalars['String'];
  endExternalQuantity: Scalars['Float'];
  endMainQuantity: Scalars['Float'];
  endOutsourceQuantity: Scalars['Float'];
  endStockQuantity: Scalars['Float'];
  externalQuantity: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inTotal: Scalars['Float'];
  janCode: Scalars['String'];
  lotGroupCode: Scalars['String'];
  lotGroupName: Scalars['String'];
  mainQuantity: Scalars['Float'];
  manufacturer: Scalars['String'];
  minimumLot?: Maybe<Scalars['Float']>;
  nowStockCycle: Scalars['Float'];
  orderRemainQuantity: Scalars['Float'];
  outTotal: Scalars['Float'];
  outsourceQuantity: Scalars['Float'];
  productCode: Scalars['String'];
  productGroupName1: Scalars['String'];
  productGroupName2: Scalars['String'];
  productGroupName3: Scalars['String'];
  productName: Scalars['String'];
  productionInput: Scalars['Float'];
  productionOutput: Scalars['Float'];
  purchase: Scalars['Float'];
  purchaseOrderLeadTime?: Maybe<Scalars['Float']>;
  purchaseReturn: Scalars['Float'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityPerDay: Scalars['Float'];
  salesUnitPrice?: Maybe<Scalars['Float']>;
  startExternalQuantity: Scalars['Float'];
  startMainQuantity: Scalars['Float'];
  startOutsourceQuantity: Scalars['Float'];
  startStockQuantity: Scalars['Float'];
  term: Scalars['Int'];
  totalSalesUnitPrice: Scalars['Float'];
  trustInput: Scalars['Float'];
  trustOutput: Scalars['Float'];
  trustReturn: Scalars['Float'];
  trustSales: Scalars['Float'];
  withinCompanyInput: Scalars['Float'];
  withinCompanyOutput: Scalars['Float'];
};

export type StockAnalyticsConnection = {
  __typename?: 'StockAnalyticsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockAnalyticsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StockAnalytics` and its cursor. */
export type StockAnalyticsEdge = {
  __typename?: 'StockAnalyticsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockAnalytics>;
};

export type StockAnalyticsMonth = Node & {
  __typename?: 'StockAnalyticsMonth';
  adjustInput: Scalars['Float'];
  adjustOutput: Scalars['Float'];
  averageStockPrice: Scalars['Float'];
  buyOutput: Scalars['Float'];
  buyReturn: Scalars['Float'];
  dio: Scalars['Float'];
  dioRank: Scalars['String'];
  directOutput: Scalars['Float'];
  directReturn: Scalars['Float'];
  disposal: Scalars['Float'];
  divisionInput: Scalars['Float'];
  divisionOutput: Scalars['Float'];
  domOverFlg: Scalars['String'];
  endExternalQuantity: Scalars['Float'];
  endMainQuantity: Scalars['Float'];
  endOutsourceQuantity: Scalars['Float'];
  endStockQuantity: Scalars['Float'];
  externalQuantity: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inTotal: Scalars['Float'];
  isDetail?: Maybe<Scalars['Boolean']>;
  isThisTerm: Scalars['Boolean'];
  janCode: Scalars['String'];
  lotGroupCode: Scalars['String'];
  lotGroupName: Scalars['String'];
  mainQuantity: Scalars['Float'];
  manufacturer: Scalars['String'];
  minimumLot?: Maybe<Scalars['Float']>;
  nowStockCycle: Scalars['Float'];
  orderRemainQuantity: Scalars['Float'];
  outTotal: Scalars['Float'];
  outsourceQuantity: Scalars['Float'];
  productCode: Scalars['String'];
  productGroupName1: Scalars['String'];
  productGroupName2: Scalars['String'];
  productGroupName3: Scalars['String'];
  productName: Scalars['String'];
  productionInput: Scalars['Float'];
  productionOutput: Scalars['Float'];
  purchase: Scalars['Float'];
  purchaseOrderLeadTime?: Maybe<Scalars['Float']>;
  purchaseReturn: Scalars['Float'];
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantityPerDay: Scalars['Float'];
  salesUnitPrice?: Maybe<Scalars['Float']>;
  startExternalQuantity: Scalars['Float'];
  startMainQuantity: Scalars['Float'];
  startOutsourceQuantity: Scalars['Float'];
  startStockQuantity: Scalars['Float'];
  termAvrgPerDay: Scalars['Float'];
  termAvrgStockCycle: Scalars['Float'];
  termMonthRange: Scalars['Int'];
  termPrice: Scalars['Float'];
  trustInput: Scalars['Float'];
  trustOutput: Scalars['Float'];
  trustReturn: Scalars['Float'];
  trustSales: Scalars['Float'];
  withinCompanyInput: Scalars['Float'];
  withinCompanyOutput: Scalars['Float'];
  yearMonth: Scalars['String'];
};

export type StockAnalyticsMonthConnection = {
  __typename?: 'StockAnalyticsMonthConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockAnalyticsMonthEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StockAnalyticsMonth` and its cursor. */
export type StockAnalyticsMonthEdge = {
  __typename?: 'StockAnalyticsMonthEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockAnalyticsMonth>;
};

export type StockByDivision = Node & {
  __typename?: 'StockByDivision';
  allQuantity?: Maybe<Scalars['Int']>;
  division?: Maybe<Division>;
  divisionCode?: Maybe<Scalars['String']>;
  externalQuantity?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  mainQuantity?: Maybe<Scalars['Int']>;
  outsourceQuantity?: Maybe<Scalars['Int']>;
};

export type StockByWarehouse = Node & {
  __typename?: 'StockByWarehouse';
  /** The ID of the object. */
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  warehouseCode?: Maybe<Scalars['String']>;
};

export type StockDisposal = Node & {
  __typename?: 'StockDisposal';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  disposalDate: Scalars['String'];
  disposalId: Scalars['ID'];
  disposalMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  stockDisposalDetails?: Maybe<StockDisposalDetailConnection>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};


export type StockDisposalStockDisposalDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type StockDisposalConnection = {
  __typename?: 'StockDisposalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockDisposalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StockDisposalDetail = Node & {
  __typename?: 'StockDisposalDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  damageQuantity: Scalars['Float'];
  detailMemo?: Maybe<Scalars['String']>;
  disposalId: Scalars['ID'];
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  productCode: Scalars['String'];
  stockDisposal?: Maybe<StockDisposal>;
  stockQuantity: Scalars['Float'];
  unitCost: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type StockDisposalDetailConnection = {
  __typename?: 'StockDisposalDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockDisposalDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StockDisposalDetail` and its cursor. */
export type StockDisposalDetailEdge = {
  __typename?: 'StockDisposalDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockDisposalDetail>;
};

/** An enumeration. */
export enum StockDisposalDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DamageQuantityAsc = 'DAMAGE_QUANTITY_ASC',
  DamageQuantityDesc = 'DAMAGE_QUANTITY_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  DisposalIdAsc = 'DISPOSAL_ID_ASC',
  DisposalIdDesc = 'DISPOSAL_ID_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  StockQuantityAsc = 'STOCK_QUANTITY_ASC',
  StockQuantityDesc = 'STOCK_QUANTITY_DESC',
  UnitCostAsc = 'UNIT_COST_ASC',
  UnitCostDesc = 'UNIT_COST_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `StockDisposal` and its cursor. */
export type StockDisposalEdge = {
  __typename?: 'StockDisposalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockDisposal>;
};

/** An enumeration. */
export enum StockDisposalSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DisposalDateAsc = 'DISPOSAL_DATE_ASC',
  DisposalDateDesc = 'DISPOSAL_DATE_DESC',
  DisposalIdAsc = 'DISPOSAL_ID_ASC',
  DisposalIdDesc = 'DISPOSAL_ID_DESC',
  DisposalMemoAsc = 'DISPOSAL_MEMO_ASC',
  DisposalMemoDesc = 'DISPOSAL_MEMO_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type StockListByDivision = Node & {
  __typename?: 'StockListByDivision';
  allQuantity?: Maybe<Scalars['Float']>;
  allStockPrice?: Maybe<Scalars['Float']>;
  discontinueFlg?: Maybe<Array<Maybe<Scalars['String']>>>;
  divisionName?: Maybe<Scalars['String']>;
  domOverFlg?: Maybe<Scalars['String']>;
  externalQuantity?: Maybe<Scalars['Float']>;
  externalStockPrice?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  mainQuantity?: Maybe<Scalars['Float']>;
  mainStockPrice?: Maybe<Scalars['Float']>;
  manufacturer?: Maybe<Scalars['String']>;
  outsourceQuantity?: Maybe<Scalars['Float']>;
  outsourceStockPrice?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productGroupName1?: Maybe<Scalars['String']>;
  productGroupName2?: Maybe<Scalars['String']>;
  productGroupName3?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  retailPrice?: Maybe<Scalars['Float']>;
  tags?: Maybe<Scalars['JSONString']>;
};

export type StockListByDivisionConnection = {
  __typename?: 'StockListByDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockListByDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StockListByDivision` and its cursor. */
export type StockListByDivisionEdge = {
  __typename?: 'StockListByDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockListByDivision>;
};

export type StockListByProduct = Node & {
  __typename?: 'StockListByProduct';
  allQuantity?: Maybe<Scalars['Float']>;
  allStockPrice?: Maybe<Scalars['Float']>;
  discontinueFlg?: Maybe<Array<Maybe<Scalars['String']>>>;
  divisionBaseQuantity?: Maybe<Scalars['Float']>;
  domOverFlg?: Maybe<Scalars['String']>;
  externalQuantity?: Maybe<Scalars['Float']>;
  externalStockPrice?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  mainQuantity?: Maybe<Scalars['Float']>;
  mainStockPrice?: Maybe<Scalars['Float']>;
  manufacturer?: Maybe<Scalars['String']>;
  outsourceQuantity?: Maybe<Scalars['Float']>;
  outsourceStockPrice?: Maybe<Scalars['Float']>;
  productCode?: Maybe<Scalars['String']>;
  productGroupName1?: Maybe<Scalars['String']>;
  productGroupName2?: Maybe<Scalars['String']>;
  productGroupName3?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receivePossibleQuantity?: Maybe<Scalars['Float']>;
  receiveRemainQuantity?: Maybe<Scalars['Float']>;
  retailPrice?: Maybe<Scalars['Float']>;
  sendBaseQuantity?: Maybe<Scalars['Float']>;
  sendRemainQuantity?: Maybe<Scalars['Float']>;
  tags?: Maybe<Scalars['JSONString']>;
};

export type StockListByProductConnection = {
  __typename?: 'StockListByProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockListByProductEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StockListByProduct` and its cursor. */
export type StockListByProductEdge = {
  __typename?: 'StockListByProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockListByProduct>;
};

export type StockListByWarehouse = Node & {
  __typename?: 'StockListByWarehouse';
  discontinueFlg?: Maybe<Array<Maybe<Scalars['String']>>>;
  divisionName?: Maybe<Scalars['String']>;
  domOverFlg?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productGroupName1?: Maybe<Scalars['String']>;
  productGroupName2?: Maybe<Scalars['String']>;
  productGroupName3?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  retailPrice?: Maybe<Scalars['Float']>;
  tags?: Maybe<Scalars['JSONString']>;
  warehouseName?: Maybe<Scalars['String']>;
  warehouseQuantity?: Maybe<Scalars['Float']>;
  warehouseStockPrice?: Maybe<Scalars['Float']>;
  warehouseType?: Maybe<Scalars['String']>;
};

export type StockListByWarehouseConnection = {
  __typename?: 'StockListByWarehouseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StockListByWarehouseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StockListByWarehouse` and its cursor. */
export type StockListByWarehouseEdge = {
  __typename?: 'StockListByWarehouseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StockListByWarehouse>;
};

export type StockWarehouseMove = Node & {
  __typename?: 'StockWarehouseMove';
  /** The ID of the object. */
  id: Scalars['ID'];
  possibleQuantity?: Maybe<Scalars['Int']>;
  stockQuantity?: Maybe<Scalars['Int']>;
};

export type SyncFkorderPublicationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
};

export type SyncFkorderPublicationPayload = {
  __typename?: 'SyncFkorderPublicationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  divisionCode: Scalars['String'];
};

export type SyncFkorderPublicationPreAndPublicInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
};

export type SyncFkorderPublicationPreAndPublicPayload = {
  __typename?: 'SyncFkorderPublicationPreAndPublicPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  divisionCode: Scalars['String'];
};

export type SystemSetting = Node & {
  __typename?: 'SystemSetting';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  financialEndDate: Scalars['String'];
  financialStage: Scalars['Int'];
  financialStartDate: Scalars['String'];
  financialYear: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  systemCode: Scalars['String'];
  systemSuspensionFlg: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  year: Scalars['Int'];
};

export type SystemSettingConnection = {
  __typename?: 'SystemSettingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SystemSettingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SystemSetting` and its cursor. */
export type SystemSettingEdge = {
  __typename?: 'SystemSettingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SystemSetting>;
};

/** An enumeration. */
export enum SystemSettingSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  FinancialEndDateAsc = 'FINANCIAL_END_DATE_ASC',
  FinancialEndDateDesc = 'FINANCIAL_END_DATE_DESC',
  FinancialStageAsc = 'FINANCIAL_STAGE_ASC',
  FinancialStageDesc = 'FINANCIAL_STAGE_DESC',
  FinancialStartDateAsc = 'FINANCIAL_START_DATE_ASC',
  FinancialStartDateDesc = 'FINANCIAL_START_DATE_DESC',
  FinancialYearAsc = 'FINANCIAL_YEAR_ASC',
  FinancialYearDesc = 'FINANCIAL_YEAR_DESC',
  SystemCodeAsc = 'SYSTEM_CODE_ASC',
  SystemCodeDesc = 'SYSTEM_CODE_DESC',
  SystemSuspensionFlgAsc = 'SYSTEM_SUSPENSION_FLG_ASC',
  SystemSuspensionFlgDesc = 'SYSTEM_SUSPENSION_FLG_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type TaxDivision = Node & {
  __typename?: 'TaxDivision';
  applicableDate: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  taxRatio: Scalars['Float'];
  taxationDivision: Scalars['String'];
  taxationDivisionName: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  useSuspension: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type TaxDivisionConnection = {
  __typename?: 'TaxDivisionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaxDivisionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TaxDivision` and its cursor. */
export type TaxDivisionEdge = {
  __typename?: 'TaxDivisionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TaxDivision>;
};

/** An enumeration. */
export enum TaxDivisionSortEnum {
  ApplicableDateAsc = 'APPLICABLE_DATE_ASC',
  ApplicableDateDesc = 'APPLICABLE_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TaxationDivisionNameAsc = 'TAXATION_DIVISION_NAME_ASC',
  TaxationDivisionNameDesc = 'TAXATION_DIVISION_NAME_DESC',
  TaxRatioAsc = 'TAX_RATIO_ASC',
  TaxRatioDesc = 'TAX_RATIO_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UseSuspensionAsc = 'USE_SUSPENSION_ASC',
  UseSuspensionDesc = 'USE_SUSPENSION_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type TermsAndConditions = Node & {
  __typename?: 'TermsAndConditions';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerUser?: Maybe<CustomerUserConnection>;
  enactmentDate: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  privacyPolicy: Scalars['String'];
  startDate: Scalars['DateTime'];
  termsContents: Scalars['String'];
  termsId: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};


export type TermsAndConditionsCustomerUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TermsAndConditionsConnection = {
  __typename?: 'TermsAndConditionsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TermsAndConditionsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TermsAndConditions` and its cursor. */
export type TermsAndConditionsEdge = {
  __typename?: 'TermsAndConditionsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TermsAndConditions>;
};

/** An enumeration. */
export enum TermsAndConditionsSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  EnactmentDateAsc = 'ENACTMENT_DATE_ASC',
  EnactmentDateDesc = 'ENACTMENT_DATE_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  PrivacyPolicyAsc = 'PRIVACY_POLICY_ASC',
  PrivacyPolicyDesc = 'PRIVACY_POLICY_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TermsContentsAsc = 'TERMS_CONTENTS_ASC',
  TermsContentsDesc = 'TERMS_CONTENTS_DESC',
  TermsIdAsc = 'TERMS_ID_ASC',
  TermsIdDesc = 'TERMS_ID_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type TotalDemandDetail = Node & {
  __typename?: 'TotalDemandDetail';
  adjustAddFlg: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode: Scalars['String'];
  demand?: Maybe<Demand>;
  demandId: Scalars['ID'];
  excludingTaxTotalDemandPrice?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  includedTaxTotalDemandPrice?: Maybe<Scalars['Float']>;
  sales?: Maybe<Sales>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type TotalDemandDetailConnection = {
  __typename?: 'TotalDemandDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TotalDemandDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TotalDemandDetail` and its cursor. */
export type TotalDemandDetailEdge = {
  __typename?: 'TotalDemandDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TotalDemandDetail>;
};

/** An enumeration. */
export enum TotalDemandDetailSortEnum {
  AdjustAddFlgAsc = 'ADJUST_ADD_FLG_ASC',
  AdjustAddFlgDesc = 'ADJUST_ADD_FLG_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  ExcludingTaxTotalDemandPriceAsc = 'EXCLUDING_TAX_TOTAL_DEMAND_PRICE_ASC',
  ExcludingTaxTotalDemandPriceDesc = 'EXCLUDING_TAX_TOTAL_DEMAND_PRICE_DESC',
  IncludedTaxTotalDemandPriceAsc = 'INCLUDED_TAX_TOTAL_DEMAND_PRICE_ASC',
  IncludedTaxTotalDemandPriceDesc = 'INCLUDED_TAX_TOTAL_DEMAND_PRICE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type TotalDemandTaxDetail = Node & {
  __typename?: 'TotalDemandTaxDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerCode: Scalars['String'];
  demand?: Maybe<Demand>;
  demandId: Scalars['ID'];
  exciseTax?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  taxExcluded?: Maybe<Scalars['Float']>;
  taxationDivision: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type TotalDemandTaxDetailConnection = {
  __typename?: 'TotalDemandTaxDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TotalDemandTaxDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TotalDemandTaxDetail` and its cursor. */
export type TotalDemandTaxDetailEdge = {
  __typename?: 'TotalDemandTaxDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TotalDemandTaxDetail>;
};

/** An enumeration. */
export enum TotalDemandTaxDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DemandIdAsc = 'DEMAND_ID_ASC',
  DemandIdDesc = 'DEMAND_ID_DESC',
  ExciseTaxAsc = 'EXCISE_TAX_ASC',
  ExciseTaxDesc = 'EXCISE_TAX_DESC',
  TaxationDivisionAsc = 'TAXATION_DIVISION_ASC',
  TaxationDivisionDesc = 'TAXATION_DIVISION_DESC',
  TaxExcludedAsc = 'TAX_EXCLUDED_ASC',
  TaxExcludedDesc = 'TAX_EXCLUDED_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type TradeHistory = Node & {
  __typename?: 'TradeHistory';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  product?: Maybe<ProductListView>;
  productCode?: Maybe<Scalars['String']>;
  purchaseUnitPriceDollar?: Maybe<Scalars['Float']>;
  purchaseUnitPriceYen?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  salesUnitPrice?: Maybe<Scalars['Float']>;
  targetCode: Scalars['String'];
  targetType: Scalars['String'];
  targetWarehouse?: Maybe<Warehouse>;
  targetWarehouseCode: Scalars['String'];
  tradeCode?: Maybe<Scalars['String']>;
  tradeCustomer?: Maybe<Customer>;
  tradeDate: Scalars['String'];
  tradeDivision?: Maybe<Division>;
  tradeHistoryId: Scalars['ID'];
  tradeHistoryTradeDivision?: Maybe<Scalars['String']>;
  tradeHistoryType: Scalars['String'];
  tradeTargetId?: Maybe<Scalars['String']>;
  tradeType?: Maybe<Scalars['String']>;
  tradeVendor?: Maybe<Vendor>;
  tradeWarehouseCode?: Maybe<Scalars['String']>;
  transferProductCode?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type TradeHistoryByMonth = Node & {
  __typename?: 'TradeHistoryByMonth';
  averageUnitPrice?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inputQuantity?: Maybe<Scalars['Int']>;
  inventory?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['String']>;
  moveQuantity?: Maybe<Scalars['Int']>;
  outputQuantity?: Maybe<Scalars['Int']>;
  period?: Maybe<Scalars['String']>;
};

export type TradeHistoryByMonthConnection = {
  __typename?: 'TradeHistoryByMonthConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TradeHistoryByMonthEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TradeHistoryByMonth` and its cursor. */
export type TradeHistoryByMonthEdge = {
  __typename?: 'TradeHistoryByMonthEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TradeHistoryByMonth>;
};

export type TradeHistoryConnection = {
  __typename?: 'TradeHistoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TradeHistoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TradeHistory` and its cursor. */
export type TradeHistoryEdge = {
  __typename?: 'TradeHistoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TradeHistory>;
};

/** An enumeration. */
export enum TradeHistorySortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  PurchaseUnitPriceDollarAsc = 'PURCHASE_UNIT_PRICE_DOLLAR_ASC',
  PurchaseUnitPriceDollarDesc = 'PURCHASE_UNIT_PRICE_DOLLAR_DESC',
  PurchaseUnitPriceYenAsc = 'PURCHASE_UNIT_PRICE_YEN_ASC',
  PurchaseUnitPriceYenDesc = 'PURCHASE_UNIT_PRICE_YEN_DESC',
  QuantityAsc = 'QUANTITY_ASC',
  QuantityDesc = 'QUANTITY_DESC',
  SalesUnitPriceAsc = 'SALES_UNIT_PRICE_ASC',
  SalesUnitPriceDesc = 'SALES_UNIT_PRICE_DESC',
  TargetCodeAsc = 'TARGET_CODE_ASC',
  TargetCodeDesc = 'TARGET_CODE_DESC',
  TargetTypeAsc = 'TARGET_TYPE_ASC',
  TargetTypeDesc = 'TARGET_TYPE_DESC',
  TargetWarehouseCodeAsc = 'TARGET_WAREHOUSE_CODE_ASC',
  TargetWarehouseCodeDesc = 'TARGET_WAREHOUSE_CODE_DESC',
  TradeCodeAsc = 'TRADE_CODE_ASC',
  TradeCodeDesc = 'TRADE_CODE_DESC',
  TradeDateAsc = 'TRADE_DATE_ASC',
  TradeDateDesc = 'TRADE_DATE_DESC',
  TradeHistoryIdAsc = 'TRADE_HISTORY_ID_ASC',
  TradeHistoryIdDesc = 'TRADE_HISTORY_ID_DESC',
  TradeHistoryTradeDivisionAsc = 'TRADE_HISTORY_TRADE_DIVISION_ASC',
  TradeHistoryTradeDivisionDesc = 'TRADE_HISTORY_TRADE_DIVISION_DESC',
  TradeHistoryTypeAsc = 'TRADE_HISTORY_TYPE_ASC',
  TradeHistoryTypeDesc = 'TRADE_HISTORY_TYPE_DESC',
  TradeTargetIdAsc = 'TRADE_TARGET_ID_ASC',
  TradeTargetIdDesc = 'TRADE_TARGET_ID_DESC',
  TradeTypeAsc = 'TRADE_TYPE_ASC',
  TradeTypeDesc = 'TRADE_TYPE_DESC',
  TradeWarehouseCodeAsc = 'TRADE_WAREHOUSE_CODE_ASC',
  TradeWarehouseCodeDesc = 'TRADE_WAREHOUSE_CODE_DESC',
  TransferProductCodeAsc = 'TRANSFER_PRODUCT_CODE_ASC',
  TransferProductCodeDesc = 'TRANSFER_PRODUCT_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type TradeHistoryStock = Node & {
  __typename?: 'TradeHistoryStock';
  /** The ID of the object. */
  id: Scalars['ID'];
  stock?: Maybe<Scalars['Float']>;
};

export type Tray = Node & {
  __typename?: 'Tray';
  /** The ID of the object. */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  trayId?: Maybe<Scalars['String']>;
};

export type TrustInventory = Node & {
  __typename?: 'TrustInventory';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryControlUnit: Scalars['String'];
  inventoryFrom?: Maybe<Scalars['String']>;
  inventoryTo?: Maybe<Scalars['String']>;
  reasonForSendBack?: Maybe<Scalars['String']>;
  salesDate?: Maybe<Scalars['String']>;
  salesId?: Maybe<Scalars['Int']>;
  sendBackFlg: Scalars['String'];
  trustInventoryDate: Scalars['String'];
  trustInventoryDetails?: Maybe<TrustInventoryDetailConnection>;
  trustInventoryId: Scalars['ID'];
  trustInventoryPath: Scalars['String'];
  trustInventoryRemark?: Maybe<Scalars['String']>;
  trustInventoryStatus: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  userCode?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};


export type TrustInventoryTrustInventoryDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TrustInventoryConnection = {
  __typename?: 'TrustInventoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TrustInventoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TrustInventoryDetail = Node & {
  __typename?: 'TrustInventoryDetail';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  currentStock: Scalars['Float'];
  damageQuantity: Scalars['Float'];
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  numbering: Scalars['ID'];
  physicalInventory: Scalars['Float'];
  productCode?: Maybe<Scalars['String']>;
  salesQuantity: Scalars['Float'];
  sellingUnitPrice?: Maybe<Scalars['Float']>;
  trustInventory?: Maybe<TrustInventory>;
  trustInventoryId: Scalars['ID'];
  uniqueCode?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type TrustInventoryDetailConnection = {
  __typename?: 'TrustInventoryDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TrustInventoryDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TrustInventoryDetail` and its cursor. */
export type TrustInventoryDetailEdge = {
  __typename?: 'TrustInventoryDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TrustInventoryDetail>;
};

/** An enumeration. */
export enum TrustInventoryDetailSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CurrentStockAsc = 'CURRENT_STOCK_ASC',
  CurrentStockDesc = 'CURRENT_STOCK_DESC',
  DamageQuantityAsc = 'DAMAGE_QUANTITY_ASC',
  DamageQuantityDesc = 'DAMAGE_QUANTITY_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  PhysicalInventoryAsc = 'PHYSICAL_INVENTORY_ASC',
  PhysicalInventoryDesc = 'PHYSICAL_INVENTORY_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  SalesQuantityAsc = 'SALES_QUANTITY_ASC',
  SalesQuantityDesc = 'SALES_QUANTITY_DESC',
  SellingUnitPriceAsc = 'SELLING_UNIT_PRICE_ASC',
  SellingUnitPriceDesc = 'SELLING_UNIT_PRICE_DESC',
  TrustInventoryIdAsc = 'TRUST_INVENTORY_ID_ASC',
  TrustInventoryIdDesc = 'TRUST_INVENTORY_ID_DESC',
  UniqueCodeAsc = 'UNIQUE_CODE_ASC',
  UniqueCodeDesc = 'UNIQUE_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `TrustInventory` and its cursor. */
export type TrustInventoryEdge = {
  __typename?: 'TrustInventoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TrustInventory>;
};

/** An enumeration. */
export enum TrustInventorySortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  InventoryControlUnitAsc = 'INVENTORY_CONTROL_UNIT_ASC',
  InventoryControlUnitDesc = 'INVENTORY_CONTROL_UNIT_DESC',
  InventoryFromAsc = 'INVENTORY_FROM_ASC',
  InventoryFromDesc = 'INVENTORY_FROM_DESC',
  InventoryToAsc = 'INVENTORY_TO_ASC',
  InventoryToDesc = 'INVENTORY_TO_DESC',
  ReasonForSendBackAsc = 'REASON_FOR_SEND_BACK_ASC',
  ReasonForSendBackDesc = 'REASON_FOR_SEND_BACK_DESC',
  SalesDateAsc = 'SALES_DATE_ASC',
  SalesDateDesc = 'SALES_DATE_DESC',
  SalesIdAsc = 'SALES_ID_ASC',
  SalesIdDesc = 'SALES_ID_DESC',
  SendBackFlgAsc = 'SEND_BACK_FLG_ASC',
  SendBackFlgDesc = 'SEND_BACK_FLG_DESC',
  TrustInventoryDateAsc = 'TRUST_INVENTORY_DATE_ASC',
  TrustInventoryDateDesc = 'TRUST_INVENTORY_DATE_DESC',
  TrustInventoryIdAsc = 'TRUST_INVENTORY_ID_ASC',
  TrustInventoryIdDesc = 'TRUST_INVENTORY_ID_DESC',
  TrustInventoryPathAsc = 'TRUST_INVENTORY_PATH_ASC',
  TrustInventoryPathDesc = 'TRUST_INVENTORY_PATH_DESC',
  TrustInventoryRemarkAsc = 'TRUST_INVENTORY_REMARK_ASC',
  TrustInventoryRemarkDesc = 'TRUST_INVENTORY_REMARK_DESC',
  TrustInventoryStatusAsc = 'TRUST_INVENTORY_STATUS_ASC',
  TrustInventoryStatusDesc = 'TRUST_INVENTORY_STATUS_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type TrustSaleVoucherPrintInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  copies?: InputMaybe<Scalars['Int']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  outputCode: Scalars['Int'];
  printerId?: InputMaybe<Scalars['String']>;
  reportLayoutCode: Scalars['String'];
  salesId: Scalars['Int'];
  trayNo?: InputMaybe<Scalars['String']>;
  withInkan?: InputMaybe<Scalars['Boolean']>;
};

export type TrustSaleVoucherPrintPayload = {
  __typename?: 'TrustSaleVoucherPrintPayload';
  artifactId?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pages?: Maybe<Scalars['Int']>;
};

export type TrustStock = Node & {
  __typename?: 'TrustStock';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode: Scalars['String'];
  lastInputDate?: Maybe<Scalars['DateTime']>;
  lastOutputDate?: Maybe<Scalars['DateTime']>;
  stockQuantity: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type TrustStockConnection = {
  __typename?: 'TrustStockConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TrustStockEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TrustStock` and its cursor. */
export type TrustStockEdge = {
  __typename?: 'TrustStockEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TrustStock>;
};

/** An enumeration. */
export enum TrustStockSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  LastInputDateAsc = 'LAST_INPUT_DATE_ASC',
  LastInputDateDesc = 'LAST_INPUT_DATE_DESC',
  LastOutputDateAsc = 'LAST_OUTPUT_DATE_ASC',
  LastOutputDateDesc = 'LAST_OUTPUT_DATE_DESC',
  StockQuantityAsc = 'STOCK_QUANTITY_ASC',
  StockQuantityDesc = 'STOCK_QUANTITY_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC'
}

export type UpdateAdjudstDetailList = {
  adjustQuantity: Scalars['Decimal'];
  damageQuantity: Scalars['Decimal'];
  detailMemo?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  numbering: Scalars['Int'];
  productCode: Scalars['String'];
  stockQuantity: Scalars['Decimal'];
  updateType: UpdateType;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateArrivalDetail = {
  arrivalDetailStatus?: InputMaybe<Scalars['String']>;
  arrivalQuantity?: InputMaybe<Scalars['Float']>;
  arrivalTradeTypeCode: Scalars['String'];
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  purchasePrice?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  sendOrderDetailGroupNumbering?: InputMaybe<Scalars['Int']>;
  sendOrderDetailNumbering?: InputMaybe<Scalars['Int']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateArrivalInput = {
  arrivalDate: Scalars['String'];
  arrivalDetails?: InputMaybe<Array<InputMaybe<UpdateArrivalDetail>>>;
  arrivalId: Scalars['Int'];
  arrivalMemo?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingTiming?: InputMaybe<Scalars['String']>;
  orderId: Scalars['Int'];
  poCode?: InputMaybe<Scalars['String']>;
  purchaseRemark?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorTaxType: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateArrivalPayload = {
  __typename?: 'UpdateArrivalPayload';
  arrival?: Maybe<Arrival>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateComponentDetail = {
  finishedProductCode?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  productPartsCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateComponentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  componentDetail: Array<InputMaybe<UpdateComponentDetail>>;
  finishedProductCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateComponentPayload = {
  __typename?: 'UpdateComponentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  component?: Maybe<Component>;
};

export type UpdateCustomerInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressLabelFlg?: InputMaybe<Scalars['String']>;
  billSendDivision?: InputMaybe<Scalars['String']>;
  billSite?: InputMaybe<Scalars['Int']>;
  businessAmebaFlg?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectCycleCode?: InputMaybe<Scalars['String']>;
  collectDate?: InputMaybe<Scalars['Int']>;
  collectDays?: InputMaybe<Scalars['Int']>;
  collectMethodCode?: InputMaybe<Scalars['String']>;
  creditLimitPrice?: InputMaybe<Scalars['Decimal']>;
  customerArea?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  customerFuri: Scalars['String'];
  customerGroup?: InputMaybe<Scalars['String']>;
  customerMemo?: InputMaybe<Scalars['String']>;
  customerName: Scalars['String'];
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerRank?: InputMaybe<Scalars['String']>;
  customerUnitpriceType: Scalars['String'];
  customerUser?: InputMaybe<Scalars['String']>;
  delFlg?: InputMaybe<Scalars['String']>;
  demandClosingGroupCode?: InputMaybe<Scalars['String']>;
  demandCode?: InputMaybe<Scalars['String']>;
  designAmebaFlg?: InputMaybe<Scalars['String']>;
  divisionBundle?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  inventoryControlUnit: Scalars['String'];
  outsourcerCode?: InputMaybe<Scalars['String']>;
  prescribeDemandReport?: InputMaybe<Scalars['String']>;
  prescribeSalesReport?: InputMaybe<Scalars['String']>;
  priceRoundType: Scalars['String'];
  ratio: Scalars['Float'];
  reportOutputUnit: Scalars['String'];
  salesTaxType: Scalars['String'];
  salesTradeDivision: Scalars['String'];
  salesUserEmail1?: InputMaybe<Scalars['String']>;
  salesUserEmail2?: InputMaybe<Scalars['String']>;
  salesUserEmail3?: InputMaybe<Scalars['String']>;
  salesUserName1?: InputMaybe<Scalars['String']>;
  salesUserName2?: InputMaybe<Scalars['String']>;
  salesUserName3?: InputMaybe<Scalars['String']>;
  taxRoundType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeStopFlg?: InputMaybe<Scalars['String']>;
  transferShareCost?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
  userDivisionCode?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerPayload = {
  __typename?: 'UpdateCustomerPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
};

export type UpdateCustomerUserBelong = {
  customerCode?: InputMaybe<Scalars['String']>;
  customerGroup?: InputMaybe<Scalars['String']>;
  customerUserId?: InputMaybe<Scalars['Int']>;
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerUserBelong?: InputMaybe<Array<InputMaybe<UpdateCustomerUserBelong>>>;
  customerUserId?: InputMaybe<Scalars['Int']>;
  customerUserName: Scalars['String'];
  email: Scalars['String'];
  initialConfirmationDate?: InputMaybe<Scalars['Date']>;
  password?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  termsOfUseVersion?: InputMaybe<Scalars['Int']>;
  updateConfirmationDate?: InputMaybe<Scalars['Date']>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerUserPayload = {
  __typename?: 'UpdateCustomerUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  customerUser?: Maybe<CustomerUser>;
};

export type UpdateDeliverInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerUser?: InputMaybe<Scalars['String']>;
  delFlg?: InputMaybe<Scalars['String']>;
  deliveryDestinationCode: Scalars['String'];
  deliveryDestinationName: Scalars['String'];
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  tel?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateDeliverPayload = {
  __typename?: 'UpdateDeliverPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deliver?: Maybe<Deliver>;
};

export type UpdateDepositDemand = {
  demandId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type UpdateDepositDetail = {
  billDate?: InputMaybe<Scalars['Date']>;
  depositDivisionCode: Scalars['String'];
  depositDivisionDetail?: InputMaybe<Scalars['String']>;
  depositPrice: Scalars['Decimal'];
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering: Scalars['Int'];
  updateType: UpdateType;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateDepositInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demandIds: Array<InputMaybe<UpdateDepositDemand>>;
  depositDate: Scalars['Date'];
  depositDetails?: InputMaybe<Array<InputMaybe<UpdateDepositDetail>>>;
  depositId: Scalars['Int'];
  depositRemark?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateDepositPayload = {
  __typename?: 'UpdateDepositPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  deposit?: Maybe<Deposit>;
};

export type UpdateDispTrustInventory = Node & {
  __typename?: 'UpdateDispTrustInventory';
  customerCode?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  details?: Maybe<DetailsConnection>;
  divisionCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inventoryControlUnit?: Maybe<Scalars['String']>;
  inventoryFrom?: Maybe<Scalars['Date']>;
  inventoryTo?: Maybe<Scalars['Date']>;
  priceRoundType?: Maybe<Scalars['String']>;
  reasonForSendBack?: Maybe<Scalars['String']>;
  salesDate?: Maybe<Scalars['Date']>;
  salesId?: Maybe<Scalars['Int']>;
  salesTaxType?: Maybe<Scalars['String']>;
  sendBackFlg?: Maybe<Scalars['String']>;
  taxRoundType?: Maybe<Scalars['String']>;
  trustInventoryDate?: Maybe<Scalars['Date']>;
  trustInventoryId?: Maybe<Scalars['Int']>;
  trustInventoryPath?: Maybe<Scalars['String']>;
  trustInventoryRemark?: Maybe<Scalars['String']>;
  trustInventoryStatus?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  versionUuid?: Maybe<Scalars['String']>;
  warehouseCode?: Maybe<Scalars['String']>;
};


export type UpdateDispTrustInventoryDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UpdateDivisionFinancialDate = {
  financialStage: Scalars['String'];
  targetGrossMarginRate: Scalars['Decimal'];
};

export type UpdateDivisionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  divisionFinancialDetail?: InputMaybe<Array<InputMaybe<UpdateDivisionFinancialDate>>>;
  divisionName?: InputMaybe<Scalars['String']>;
  divistionType?: InputMaybe<Scalars['String']>;
  recordHighSales?: InputMaybe<Scalars['Decimal']>;
  versionUuid: Scalars['String'];
  windowName?: InputMaybe<Scalars['String']>;
};

export type UpdateDivisionPayload = {
  __typename?: 'UpdateDivisionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  division?: Maybe<Division>;
};

export type UpdateEstimateDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  divisionName?: InputMaybe<Scalars['String']>;
  estimateId?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  janCode?: InputMaybe<Scalars['String']>;
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  receiveDetailTradeType: Scalars['String'];
  receiveOrderPossibleStock?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  salesUnitPrice?: InputMaybe<Scalars['Float']>;
  sellingPrice?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  stockQuantity?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateEstimateInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  customerUser?: InputMaybe<Scalars['String']>;
  deliverPeriod?: InputMaybe<Scalars['String']>;
  deliverPlace?: InputMaybe<Scalars['String']>;
  estimateDate: Scalars['String'];
  estimateDetails?: InputMaybe<Array<InputMaybe<UpdateEstimateDetail>>>;
  estimateId: Scalars['String'];
  estimateRemark?: InputMaybe<Scalars['String']>;
  estimateTitle?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeMethod?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateEstimatePayload = {
  __typename?: 'UpdateEstimatePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  estimate?: Maybe<Estimate>;
};

export type UpdateFkorderInformationAttachment = {
  filename: Scalars['String'];
  s3Key: Scalars['String'];
};

export type UpdateFkorderInformationInput = {
  attachments?: InputMaybe<Array<InputMaybe<UpdateFkorderInformationAttachment>>>;
  attachmentsRemain?: InputMaybe<Array<InputMaybe<RemainFkorderInformationAttachment>>>;
  body: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  informationId: Scalars['String'];
  informationType: Scalars['String'];
  postedAt: Scalars['Date'];
  publicationFrom: Scalars['Date'];
  publicationTo: Scalars['Date'];
  title: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateFkorderInformationPayload = {
  __typename?: 'UpdateFkorderInformationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fkorderInformation?: Maybe<FkorderInformation>;
};

export type UpdateInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  inventoryFinishFlg?: InputMaybe<Scalars['String']>;
  inventoryId: Scalars['Int'];
  inventoryName?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateInventoryPayload = {
  __typename?: 'UpdateInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  inventory?: Maybe<Inventory>;
};

export type UpdateOutsourcerSalesDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName?: InputMaybe<Scalars['String']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  updateType?: InputMaybe<UpdateType>;
};

export type UpdateOutsourcerSalesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  salesDate: Scalars['String'];
  salesDetails?: InputMaybe<Array<InputMaybe<UpdateOutsourcerSalesDetail>>>;
  salesId: Scalars['String'];
  salesRemark?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateOutsourcerSalesPayload = {
  __typename?: 'UpdateOutsourcerSalesPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sales?: Maybe<Sales>;
};

export type UpdateProductGroupDetail = {
  divisionCode?: InputMaybe<Scalars['String']>;
  productGroupCode?: InputMaybe<Scalars['String']>;
  productGroupId?: InputMaybe<Scalars['Int']>;
  productGroupName?: InputMaybe<Scalars['String']>;
  productGrouptypeCode?: InputMaybe<Scalars['String']>;
  publicationOption?: InputMaybe<Scalars['String']>;
  publicationScope?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateProductGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  productGroupDetails?: InputMaybe<Array<InputMaybe<UpdateProductGroupDetail>>>;
};

export type UpdateProductGroupPayload = {
  __typename?: 'UpdateProductGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateProductInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clothGroup?: InputMaybe<Scalars['String']>;
  componentDivision?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  designUserCode?: InputMaybe<Scalars['String']>;
  domOverFlg?: InputMaybe<Scalars['String']>;
  inventoryControlFlg?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  manufacturer?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxPurchaseOrderQty?: InputMaybe<Scalars['Int']>;
  notIncludedSku?: InputMaybe<Scalars['String']>;
  planningUserCode?: InputMaybe<Scalars['String']>;
  priceUpdateFlg?: InputMaybe<Scalars['Boolean']>;
  productFuri?: InputMaybe<Scalars['String']>;
  productGroupId1?: InputMaybe<Scalars['Int']>;
  productGroupId2?: InputMaybe<Scalars['Int']>;
  productGroupId3?: InputMaybe<Scalars['Int']>;
  productName: Scalars['String'];
  productPrice?: InputMaybe<Array<InputMaybe<UpdateProductPrice>>>;
  productVariants?: InputMaybe<Array<InputMaybe<UpdateProductVariant>>>;
  purchaseOrderLeadTime?: InputMaybe<Scalars['Int']>;
  quantityDecimalDigits?: InputMaybe<Scalars['Int']>;
  receiveOrderLot?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['JSONString']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  uniqueCode: Scalars['String'];
  unitCode?: InputMaybe<Scalars['String']>;
  unitDollarDecimalDigits?: InputMaybe<Scalars['Int']>;
  unitYenDecimalDigits?: InputMaybe<Scalars['Int']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
};

export type UpdateProductPrice = {
  endDate?: InputMaybe<Scalars['String']>;
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Decimal']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Decimal']>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  salesUnitPrice?: InputMaybe<Scalars['Decimal']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type UpdateProductVariant = {
  attr1?: InputMaybe<Scalars['String']>;
  attr2?: InputMaybe<Scalars['String']>;
  attrNo?: InputMaybe<Scalars['Int']>;
  baseStockQuantity?: InputMaybe<Scalars['Int']>;
  discontinueFlg?: InputMaybe<Scalars['String']>;
  divisionCode: Scalars['String'];
  divisionStandardStock?: InputMaybe<Scalars['Int']>;
  endOfSalesDate?: InputMaybe<Scalars['String']>;
  fcCode1?: InputMaybe<Scalars['String']>;
  fcCode2?: InputMaybe<Scalars['String']>;
  fcCode3?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber1?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber2?: InputMaybe<Scalars['String']>;
  fcCodeBranchNumber3?: InputMaybe<Scalars['String']>;
  firstArrivalDate?: InputMaybe<Scalars['String']>;
  innerCartonSize?: InputMaybe<Scalars['String']>;
  innerCartonUnit?: InputMaybe<Scalars['Int']>;
  innerCartonWeight?: InputMaybe<Scalars['String']>;
  lotGroupCode?: InputMaybe<Scalars['Int']>;
  minimumLot?: InputMaybe<Scalars['Int']>;
  outerCartonDept?: InputMaybe<Scalars['Decimal']>;
  outerCartonHeight?: InputMaybe<Scalars['Decimal']>;
  outerCartonUnit?: InputMaybe<Scalars['Int']>;
  outerCartonWeight?: InputMaybe<Scalars['String']>;
  outerCartonWidth?: InputMaybe<Scalars['Decimal']>;
  productAttrMemo?: InputMaybe<Scalars['String']>;
  productBodySize?: InputMaybe<Scalars['String']>;
  productBodyWeight?: InputMaybe<Scalars['String']>;
  productImage1?: InputMaybe<Scalars['String']>;
  productImage2?: InputMaybe<Scalars['String']>;
  productImage3?: InputMaybe<Scalars['String']>;
  productImage4?: InputMaybe<Scalars['String']>;
  productImage5?: InputMaybe<Scalars['String']>;
  productImage6?: InputMaybe<Scalars['String']>;
  productPackageSize?: InputMaybe<Scalars['String']>;
  productPackageWeight?: InputMaybe<Scalars['String']>;
  publicationOption?: InputMaybe<Scalars['String']>;
  purchaseOrderStandardStock?: InputMaybe<Scalars['Int']>;
};

export type UpdateProductionDetailList = {
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering: Scalars['Int'];
  partsQuantity?: InputMaybe<Scalars['Decimal']>;
  productPartsCode: Scalars['String'];
  quantity?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateProductionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  finishedQuantity?: InputMaybe<Scalars['Decimal']>;
  productionDetailList?: InputMaybe<Array<InputMaybe<UpdateProductionDetailList>>>;
  productionMemo?: InputMaybe<Scalars['String']>;
  productionOrderDate?: InputMaybe<Scalars['Date']>;
  productionOrderId: Scalars['Int'];
  versionUuid: Scalars['String'];
};

export type UpdateProductionPayload = {
  __typename?: 'UpdateProductionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  production?: Maybe<Production>;
};

export type UpdateReceiveOrderCorrectionInput = {
  buttonMode: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDate: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  receiveDetails?: InputMaybe<Array<InputMaybe<UpdateReceiveOrderDetailCorrection>>>;
  receiveOrderDate: Scalars['String'];
  receiveOrderId: Scalars['String'];
  receiveOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderRemarks?: InputMaybe<Scalars['String']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: InputMaybe<Scalars['String']>;
  salesDate?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesUserCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReceiveOrderCorrectionPayload = {
  __typename?: 'UpdateReceiveOrderCorrectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type UpdateReceiveOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderPrice?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderUnit?: InputMaybe<Scalars['Float']>;
  rejectFlg?: InputMaybe<Scalars['String']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateReceiveOrderDetailCorrection = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderPrice?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderUnit?: InputMaybe<Scalars['Float']>;
  rejectFlg?: InputMaybe<Scalars['String']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateReceiveOrderDetailSalesUnitPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  receiveOrderDateFrom?: InputMaybe<Scalars['Date']>;
  receiveOrderDateTo?: InputMaybe<Scalars['Date']>;
  userCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateReceiveOrderDetailSalesUnitPricePayload = {
  __typename?: 'UpdateReceiveOrderDetailSalesUnitPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrderDetail?: Maybe<Array<Maybe<ReceiveOrderDetail>>>;
};

export type UpdateReceiveOrderInput = {
  buttonMode: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDate: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  receiveDetails?: InputMaybe<Array<InputMaybe<UpdateReceiveOrderDetail>>>;
  receiveOrderDate: Scalars['String'];
  receiveOrderId: Scalars['String'];
  receiveOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderRemarks?: InputMaybe<Scalars['String']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: InputMaybe<Scalars['String']>;
  salesDate?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesUserCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReceiveOrderPayload = {
  __typename?: 'UpdateReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type UpdateReceiveOrderStatusCancelInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReceiveOrderStatusCancelPayload = {
  __typename?: 'UpdateReceiveOrderStatusCancelPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type UpdateReceiveOrderStatusConfirmedInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReceiveOrderStatusConfirmedPayload = {
  __typename?: 'UpdateReceiveOrderStatusConfirmedPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type UpdateReturnReceiveOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveDetailTradeType: Scalars['String'];
  receiveOrderDecisionQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderPrice?: InputMaybe<Scalars['Float']>;
  receiveOrderQuantity?: InputMaybe<Scalars['Float']>;
  receiveOrderUnit?: InputMaybe<Scalars['Float']>;
  rejectFlg?: InputMaybe<Scalars['String']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateReturnReceiveOrderInput = {
  buttonMode: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDate: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  provisionalCustomerName?: InputMaybe<Scalars['String']>;
  receiveDetails?: InputMaybe<Array<InputMaybe<UpdateReturnReceiveOrderDetail>>>;
  receiveOrderDate: Scalars['String'];
  receiveOrderId: Scalars['String'];
  receiveOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderRemarks?: InputMaybe<Scalars['String']>;
  receiveOrderType: Scalars['String'];
  returnDivision?: InputMaybe<Scalars['String']>;
  salesDate?: InputMaybe<Scalars['String']>;
  salesTaxType: Scalars['String'];
  salesUserCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReturnReceiveOrderPayload = {
  __typename?: 'UpdateReturnReceiveOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  receiveOrder?: Maybe<ReceiveOrderHeader>;
};

export type UpdateReturnSendOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  orderQuantity?: InputMaybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateReturnSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  orderDate: Scalars['String'];
  orderId: Scalars['String'];
  orderMemo?: InputMaybe<Scalars['String']>;
  orderRemarks?: InputMaybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: InputMaybe<Scalars['String']>;
  sendOrderDetails?: InputMaybe<Array<InputMaybe<UpdateReturnSendOrderDetail>>>;
  shippingCode: Scalars['String'];
  shippingTypeCode: Scalars['String'];
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateReturnSendOrderPayload = {
  __typename?: 'UpdateReturnSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type UpdateSendOrderApprovalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateSendOrderApprovalPayload = {
  __typename?: 'UpdateSendOrderApprovalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type UpdateSendOrderBulkApprovalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  sendOrderList?: InputMaybe<Array<InputMaybe<ApprovalSendOrder>>>;
};

export type UpdateSendOrderBulkApprovalPayload = {
  __typename?: 'UpdateSendOrderBulkApprovalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type UpdateSendOrderDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  orderQuantity?: InputMaybe<Scalars['Float']>;
  orderTradeTypeCode: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  purchaseUnitPriceDollar?: InputMaybe<Scalars['Float']>;
  purchaseUnitPriceYen?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateSendOrderDetailPurchaseUnitPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderDateFrom: Scalars['Date'];
  orderDateTo: Scalars['Date'];
};

export type UpdateSendOrderDetailPurchaseUnitPricePayload = {
  __typename?: 'UpdateSendOrderDetailPurchaseUnitPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrderDetail?: Maybe<Array<Maybe<SendOrderDetail>>>;
};

export type UpdateSendOrderInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  orderDate: Scalars['String'];
  orderId: Scalars['String'];
  orderMemo?: InputMaybe<Scalars['String']>;
  orderRemarks?: InputMaybe<Scalars['String']>;
  orderType: Scalars['String'];
  poCode?: InputMaybe<Scalars['String']>;
  sendOrderDetails?: InputMaybe<Array<InputMaybe<UpdateSendOrderDetail>>>;
  shippingCode: Scalars['String'];
  shippingTypeCode: Scalars['String'];
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateSendOrderLotInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  lotGroupCode?: InputMaybe<Scalars['String']>;
  lotGroupName?: InputMaybe<Scalars['String']>;
  minimumLot?: InputMaybe<Scalars['String']>;
  purchaseOrderLeadTime?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateSendOrderLotPayload = {
  __typename?: 'UpdateSendOrderLotPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrderLot?: Maybe<SendOrderLot>;
};

export type UpdateSendOrderPayload = {
  __typename?: 'UpdateSendOrderPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type UpdateSendOrderRemandInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  remandMemo?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateSendOrderRemandPayload = {
  __typename?: 'UpdateSendOrderRemandPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  sendOrder?: Maybe<SendOrder>;
};

export type UpdateShipmentDetail = {
  deliveryDetailTradeType: Scalars['String'];
  deliveryOrderQuantity?: InputMaybe<Scalars['Float']>;
  detailMemo?: InputMaybe<Scalars['String']>;
  frontNumbering: Scalars['Int'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode?: InputMaybe<Scalars['String']>;
  productName: Scalars['String'];
  receiveOrderDetailNumbering?: InputMaybe<Scalars['Int']>;
  retailPrice?: InputMaybe<Scalars['Float']>;
  sellingUnitPrice?: InputMaybe<Scalars['Float']>;
  taxationDivision?: InputMaybe<Scalars['String']>;
  updateType?: InputMaybe<UpdateType>;
  warehouseCode?: InputMaybe<Scalars['String']>;
};

export type UpdateShipmentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  closingTiming?: InputMaybe<Scalars['String']>;
  collectExpectedDate?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  deliveryDestinationCode?: InputMaybe<Scalars['String']>;
  deliveryOrderDate: Scalars['String'];
  deliveryOrderId: Scalars['String'];
  deliveryOrderMemo?: InputMaybe<Scalars['String']>;
  receiveOrderId: Scalars['String'];
  salesRemark?: InputMaybe<Scalars['String']>;
  shipmentDetails?: InputMaybe<Array<InputMaybe<UpdateShipmentDetail>>>;
  userCode?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  shipment?: Maybe<Shipment>;
};

export type UpdateStockAdjustInput = {
  adjustDate: Scalars['Date'];
  adjustDetailList?: InputMaybe<Array<InputMaybe<UpdateAdjudstDetailList>>>;
  adjustId: Scalars['String'];
  adjustMemo?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
};

export type UpdateStockAdjustPayload = {
  __typename?: 'UpdateStockAdjustPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  stockAdjust?: Maybe<StockAdjust>;
};

export type UpdateTrustInventoryDetail = {
  damageQuantity: Scalars['Float'];
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering?: InputMaybe<Scalars['Int']>;
  physicalInventory: Scalars['Float'];
  productCode: Scalars['String'];
  sellingUnitPrice: Scalars['Float'];
  updateType?: InputMaybe<UpdateType>;
};

export type UpdateTrustInventoryDetailJanUnit = {
  damageQuantity: Scalars['Float'];
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering?: InputMaybe<Scalars['Int']>;
  physicalInventory: Scalars['Float'];
  sellingUnitPrice: Scalars['Float'];
  uniqueCode: Scalars['String'];
  updateType?: InputMaybe<UpdateType>;
};

export type UpdateTrustInventoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryTo: Scalars['Date'];
  salesDate: Scalars['Date'];
  salesMonth: Scalars['String'];
  trustInventoryDetail?: InputMaybe<Array<InputMaybe<UpdateTrustInventoryDetail>>>;
  trustInventoryId: Scalars['String'];
  trustInventoryRemark?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateTrustInventoryJanUnitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode: Scalars['String'];
  inventoryFrom: Scalars['Date'];
  inventoryTo: Scalars['Date'];
  salesDate: Scalars['Date'];
  salesMonth: Scalars['String'];
  trustInventoryDetail?: InputMaybe<Array<InputMaybe<UpdateTrustInventoryDetailJanUnit>>>;
  trustInventoryId: Scalars['String'];
  trustInventoryRemark?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
};

export type UpdateTrustInventoryJanUnitPayload = {
  __typename?: 'UpdateTrustInventoryJanUnitPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export type UpdateTrustInventoryPayload = {
  __typename?: 'UpdateTrustInventoryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  trustInventory?: Maybe<TrustInventory>;
};

export enum UpdateType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  None = 'NONE',
  Update = 'UPDATE'
}

export type UpdateUserInput = {
  approvalPrivilege?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  priorityWarehouseCode?: InputMaybe<Scalars['String']>;
  subDivision1?: InputMaybe<Scalars['String']>;
  subDivision2?: InputMaybe<Scalars['String']>;
  subDivision3?: InputMaybe<Scalars['String']>;
  subDivision4?: InputMaybe<Scalars['String']>;
  superUser?: InputMaybe<Scalars['String']>;
  systemAdminFlg?: InputMaybe<Scalars['String']>;
  trustInventoryApprovalPrivilege?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
  userName: Scalars['String'];
  userType: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UpdateVendorInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  bankAccountCode?: InputMaybe<Scalars['String']>;
  bankAccountFuri?: InputMaybe<Scalars['String']>;
  bankAccountName?: InputMaybe<Scalars['String']>;
  bankAccountRelation?: InputMaybe<Scalars['String']>;
  bankAccountType?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  bankFuri?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  billSendDivision?: InputMaybe<Scalars['String']>;
  branchOfficeCode?: InputMaybe<Scalars['String']>;
  branchOfficeFuri?: InputMaybe<Scalars['String']>;
  branchOfficeName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  customerPositionName?: InputMaybe<Scalars['String']>;
  customerPostName?: InputMaybe<Scalars['String']>;
  customerUser?: InputMaybe<Scalars['String']>;
  ediInfo?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  factoryCode?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  honorificCode?: InputMaybe<Scalars['String']>;
  invoiceDivision?: InputMaybe<Scalars['String']>;
  invoiceRegistrationCode?: InputMaybe<Scalars['String']>;
  paymentCycle?: InputMaybe<Scalars['String']>;
  paymentDate?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  priceRoundType: Scalars['String'];
  productGroup?: InputMaybe<Scalars['String']>;
  purposeGroup: Scalars['String'];
  reportOutputUnit: Scalars['String'];
  taxRoundType: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  tradeStopFlg?: InputMaybe<Scalars['String']>;
  transferCondition?: InputMaybe<Scalars['String']>;
  transferCustomCode1?: InputMaybe<Scalars['String']>;
  transferCustomCode2?: InputMaybe<Scalars['String']>;
  transferMethodCode?: InputMaybe<Scalars['String']>;
  transferShareCost?: InputMaybe<Scalars['String']>;
  vendorClosingGroup?: InputMaybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorFuri: Scalars['String'];
  vendorMemo?: InputMaybe<Scalars['String']>;
  vendorName: Scalars['String'];
  vendorTaxType: Scalars['String'];
  vendorTradeDivision: Scalars['String'];
  vendorUnitpriceType?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorPayload = {
  __typename?: 'UpdateVendorPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
};

export type UpdateWarehouseInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerCode?: InputMaybe<Scalars['String']>;
  divisionCode?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  isCountTarget: Scalars['String'];
  tel?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
  warehouseMemo?: InputMaybe<Scalars['String']>;
  warehouseName: Scalars['String'];
  warehouseType: Scalars['String'];
  warehouseUser?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateWarehouseMoveApproveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseMoveId: Scalars['Int'];
};

export type UpdateWarehouseMoveApprovePayload = {
  __typename?: 'UpdateWarehouseMoveApprovePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouseMove?: Maybe<WarehouseMove>;
};

export type UpdateWarehouseMoveDetailList = {
  detailMemo?: InputMaybe<Scalars['String']>;
  janCode: Scalars['String'];
  moveQuantity: Scalars['Decimal'];
  numbering?: InputMaybe<Scalars['Int']>;
  productCode: Scalars['String'];
  transferProductCode?: InputMaybe<Scalars['String']>;
  updateType: UpdateType;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateWarehouseMoveInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  moveDate: Scalars['Date'];
  moveWarehouseDestination: Scalars['String'];
  moveWarehouseSource: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseMoveDetailList?: InputMaybe<Array<InputMaybe<UpdateWarehouseMoveDetailList>>>;
  warehouseMoveId: Scalars['Int'];
  warehouseMoveMemo?: InputMaybe<Scalars['String']>;
  warehouseMoveMethod: Scalars['String'];
};

export type UpdateWarehouseMovePayload = {
  __typename?: 'UpdateWarehouseMovePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouseMove?: Maybe<WarehouseMove>;
};

export type UpdateWarehouseMoveRejectInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  warehouseMoveId: Scalars['Int'];
};

export type UpdateWarehouseMoveRejectPayload = {
  __typename?: 'UpdateWarehouseMoveRejectPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouseMove?: Maybe<WarehouseMove>;
};

export type UpdateWarehousePayload = {
  __typename?: 'UpdateWarehousePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  warehouse?: Maybe<Warehouse>;
};

export type UpdateWithdrawalDetail = {
  detailMemo?: InputMaybe<Scalars['String']>;
  numbering?: InputMaybe<Scalars['Int']>;
  payDivisionCode?: InputMaybe<Scalars['String']>;
  payDivisionDetail?: InputMaybe<Scalars['String']>;
  payPrice?: InputMaybe<Scalars['Decimal']>;
  updateType?: InputMaybe<UpdateType>;
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateWithdrawalInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  payDate?: InputMaybe<Scalars['Date']>;
  payId: Scalars['String'];
  payRemark?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  withdrawalDetails?: InputMaybe<Array<InputMaybe<UpdateWithdrawalDetail>>>;
};

export type UpdateWithdrawalPayload = {
  __typename?: 'UpdateWithdrawalPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  withdrawal?: Maybe<Withdrawal>;
};

export type UpsertDemandTaxAdjust = {
  demandId: Scalars['Int'];
  demandTaxAdjustDetails?: InputMaybe<Array<InputMaybe<UpsertDemandTaxAdjustDetail>>>;
  versionUuid: Scalars['String'];
};

export type UpsertDemandTaxAdjustDetail = {
  adjust?: InputMaybe<Scalars['Decimal']>;
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpsertDemandTaxAdjustListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  demandTaxAdjustList?: InputMaybe<Array<InputMaybe<UpsertDemandTaxAdjust>>>;
};

export type UpsertDemandTaxAdjustListPayload = {
  __typename?: 'UpsertDemandTaxAdjustListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  demandTaxAdjustDetail?: Maybe<DemandTaxAdjustDetail>;
};

export type UpsertPaymentTaxAdjust = {
  paymentId: Scalars['Int'];
  paymentTaxAdjustDetails?: InputMaybe<Array<InputMaybe<UpsertPaymentTaxAdjustDetail>>>;
  versionUuid: Scalars['String'];
};

export type UpsertPaymentTaxAdjustDetail = {
  adjust?: InputMaybe<Scalars['Decimal']>;
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpsertPaymentTaxAdjustDetailEx = {
  adjust?: InputMaybe<Scalars['Decimal']>;
  taxationDivision: Scalars['String'];
  versionUuid?: InputMaybe<Scalars['String']>;
};

export type UpsertPaymentTaxAdjustListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentTaxAdjustList?: InputMaybe<Array<InputMaybe<UpsertPaymentTaxAdjust>>>;
};

export type UpsertPaymentTaxAdjustListPayload = {
  __typename?: 'UpsertPaymentTaxAdjustListPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  paymentTaxAdjustDetail?: Maybe<PaymentTaxAdjustDetail>;
};

export type User = Node & {
  __typename?: 'User';
  approvalPrivilege?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  delFlg: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode?: Maybe<Scalars['String']>;
  divisionCodes?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  priorityWarehouseCode?: Maybe<Scalars['String']>;
  subDivision1?: Maybe<Scalars['String']>;
  subDivision2?: Maybe<Scalars['String']>;
  subDivision3?: Maybe<Scalars['String']>;
  subDivision4?: Maybe<Scalars['String']>;
  superUser?: Maybe<Scalars['String']>;
  systemAdminFlg?: Maybe<Scalars['String']>;
  trustInventoryApprovalPrivilege: Scalars['String'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  userCode: Scalars['String'];
  userName: Scalars['String'];
  userType: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `User` and its cursor. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<User>;
};

/** An enumeration. */
export enum UserSortEnum {
  ApprovalPrivilegeAsc = 'APPROVAL_PRIVILEGE_ASC',
  ApprovalPrivilegeDesc = 'APPROVAL_PRIVILEGE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PriorityWarehouseCodeAsc = 'PRIORITY_WAREHOUSE_CODE_ASC',
  PriorityWarehouseCodeDesc = 'PRIORITY_WAREHOUSE_CODE_DESC',
  SubDivision1Asc = 'SUB_DIVISION1_ASC',
  SubDivision1Desc = 'SUB_DIVISION1_DESC',
  SubDivision2Asc = 'SUB_DIVISION2_ASC',
  SubDivision2Desc = 'SUB_DIVISION2_DESC',
  SubDivision3Asc = 'SUB_DIVISION3_ASC',
  SubDivision3Desc = 'SUB_DIVISION3_DESC',
  SubDivision4Asc = 'SUB_DIVISION4_ASC',
  SubDivision4Desc = 'SUB_DIVISION4_DESC',
  SuperUserAsc = 'SUPER_USER_ASC',
  SuperUserDesc = 'SUPER_USER_DESC',
  SystemAdminFlgAsc = 'SYSTEM_ADMIN_FLG_ASC',
  SystemAdminFlgDesc = 'SYSTEM_ADMIN_FLG_DESC',
  TrustInventoryApprovalPrivilegeAsc = 'TRUST_INVENTORY_APPROVAL_PRIVILEGE_ASC',
  TrustInventoryApprovalPrivilegeDesc = 'TRUST_INVENTORY_APPROVAL_PRIVILEGE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  UserNameAsc = 'USER_NAME_ASC',
  UserNameDesc = 'USER_NAME_DESC',
  UserTypeAsc = 'USER_TYPE_ASC',
  UserTypeDesc = 'USER_TYPE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type Vendor = Node & {
  __typename?: 'Vendor';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  balanceData?: Maybe<Scalars['Float']>;
  bankAccountCode?: Maybe<Scalars['String']>;
  bankAccountFuri?: Maybe<Scalars['String']>;
  bankAccountName?: Maybe<Scalars['String']>;
  bankAccountRelation?: Maybe<Scalars['String']>;
  bankAccountType?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bankFuri?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  billSendDivision?: Maybe<Scalars['String']>;
  branchOfficeCode?: Maybe<Scalars['String']>;
  branchOfficeFuri?: Maybe<Scalars['String']>;
  branchOfficeName?: Maybe<Scalars['String']>;
  closingDate?: Maybe<Scalars['Date']>;
  countryCode?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customerPositionName?: Maybe<Scalars['String']>;
  customerPostName?: Maybe<Scalars['String']>;
  customerUser?: Maybe<Scalars['String']>;
  delFlg: Scalars['String'];
  ediInfo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  factoryCode?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  honorificCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  invoiceDivision?: Maybe<Scalars['String']>;
  invoiceRegistrationCode?: Maybe<Scalars['String']>;
  paymentCycle?: Maybe<Scalars['String']>;
  paymentDate?: Maybe<Scalars['Int']>;
  paymentDivision?: Maybe<PaymentDivision>;
  paymentMethod?: Maybe<Scalars['String']>;
  priceRoundType?: Maybe<Scalars['String']>;
  productGroup?: Maybe<Scalars['String']>;
  purposeGroup?: Maybe<Scalars['String']>;
  reportOutputUnit?: Maybe<Scalars['String']>;
  searchKeyword?: Maybe<Scalars['String']>;
  taxRoundType?: Maybe<Scalars['String']>;
  tel?: Maybe<Scalars['String']>;
  tradeStopFlg?: Maybe<Scalars['String']>;
  transferCondition?: Maybe<Scalars['String']>;
  transferCustomCode1?: Maybe<Scalars['String']>;
  transferCustomCode2?: Maybe<Scalars['String']>;
  transferMethodCode?: Maybe<Scalars['String']>;
  transferShareCost?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendorClosingGroup?: Maybe<Scalars['String']>;
  vendorCode: Scalars['String'];
  vendorFuri: Scalars['String'];
  vendorMemo?: Maybe<Scalars['String']>;
  vendorName: Scalars['String'];
  vendorTaxType?: Maybe<Scalars['String']>;
  vendorTradeDivision?: Maybe<Scalars['String']>;
  vendorUnitpriceType?: Maybe<Scalars['String']>;
  versionUuid: Scalars['String'];
  zipCode?: Maybe<Scalars['String']>;
};

export type VendorClosing = Node & {
  __typename?: 'VendorClosing';
  closingDate: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
};

export type VendorClosingConnection = {
  __typename?: 'VendorClosingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorClosingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `VendorClosing` and its cursor. */
export type VendorClosingEdge = {
  __typename?: 'VendorClosingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<VendorClosing>;
};

/** An enumeration. */
export enum VendorClosingSortEnum {
  ClosingDateAsc = 'CLOSING_DATE_ASC',
  ClosingDateDesc = 'CLOSING_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type VendorConnection = {
  __typename?: 'VendorConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Vendor` and its cursor. */
export type VendorEdge = {
  __typename?: 'VendorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Vendor>;
};

export type VendorPurchaseMonthly = Node & {
  __typename?: 'VendorPurchaseMonthly';
  /** The ID of the object. */
  id: Scalars['ID'];
  totalingMonthly?: Maybe<Scalars['String']>;
  totalingPeriod?: Maybe<Scalars['String']>;
  totalingPurchasePrice?: Maybe<Scalars['Int']>;
  totalingPurchasePriceDollar?: Maybe<Scalars['Int']>;
  totalingWithdrawalPrice?: Maybe<Scalars['Int']>;
  vendorCode?: Maybe<Scalars['String']>;
};

export type VendorPurchaseMonthlyConnection = {
  __typename?: 'VendorPurchaseMonthlyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorPurchaseMonthlyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VendorPurchaseMonthly` and its cursor. */
export type VendorPurchaseMonthlyEdge = {
  __typename?: 'VendorPurchaseMonthlyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<VendorPurchaseMonthly>;
};

/** An enumeration. */
export enum VendorSortEnum {
  Address1Asc = 'ADDRESS1_ASC',
  Address1Desc = 'ADDRESS1_DESC',
  Address2Asc = 'ADDRESS2_ASC',
  Address2Desc = 'ADDRESS2_DESC',
  BankAccountCodeAsc = 'BANK_ACCOUNT_CODE_ASC',
  BankAccountCodeDesc = 'BANK_ACCOUNT_CODE_DESC',
  BankAccountFuriAsc = 'BANK_ACCOUNT_FURI_ASC',
  BankAccountFuriDesc = 'BANK_ACCOUNT_FURI_DESC',
  BankAccountNameAsc = 'BANK_ACCOUNT_NAME_ASC',
  BankAccountNameDesc = 'BANK_ACCOUNT_NAME_DESC',
  BankAccountRelationAsc = 'BANK_ACCOUNT_RELATION_ASC',
  BankAccountRelationDesc = 'BANK_ACCOUNT_RELATION_DESC',
  BankAccountTypeAsc = 'BANK_ACCOUNT_TYPE_ASC',
  BankAccountTypeDesc = 'BANK_ACCOUNT_TYPE_DESC',
  BankCodeAsc = 'BANK_CODE_ASC',
  BankCodeDesc = 'BANK_CODE_DESC',
  BankFuriAsc = 'BANK_FURI_ASC',
  BankFuriDesc = 'BANK_FURI_DESC',
  BankNameAsc = 'BANK_NAME_ASC',
  BankNameDesc = 'BANK_NAME_DESC',
  BillSendDivisionAsc = 'BILL_SEND_DIVISION_ASC',
  BillSendDivisionDesc = 'BILL_SEND_DIVISION_DESC',
  BranchOfficeCodeAsc = 'BRANCH_OFFICE_CODE_ASC',
  BranchOfficeCodeDesc = 'BRANCH_OFFICE_CODE_DESC',
  BranchOfficeFuriAsc = 'BRANCH_OFFICE_FURI_ASC',
  BranchOfficeFuriDesc = 'BRANCH_OFFICE_FURI_DESC',
  BranchOfficeNameAsc = 'BRANCH_OFFICE_NAME_ASC',
  BranchOfficeNameDesc = 'BRANCH_OFFICE_NAME_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerPositionNameAsc = 'CUSTOMER_POSITION_NAME_ASC',
  CustomerPositionNameDesc = 'CUSTOMER_POSITION_NAME_DESC',
  CustomerPostNameAsc = 'CUSTOMER_POST_NAME_ASC',
  CustomerPostNameDesc = 'CUSTOMER_POST_NAME_DESC',
  CustomerUserAsc = 'CUSTOMER_USER_ASC',
  CustomerUserDesc = 'CUSTOMER_USER_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  EdiInfoAsc = 'EDI_INFO_ASC',
  EdiInfoDesc = 'EDI_INFO_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FactoryCodeAsc = 'FACTORY_CODE_ASC',
  FactoryCodeDesc = 'FACTORY_CODE_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  HonorificCodeAsc = 'HONORIFIC_CODE_ASC',
  HonorificCodeDesc = 'HONORIFIC_CODE_DESC',
  InvoiceDivisionAsc = 'INVOICE_DIVISION_ASC',
  InvoiceDivisionDesc = 'INVOICE_DIVISION_DESC',
  InvoiceRegistrationCodeAsc = 'INVOICE_REGISTRATION_CODE_ASC',
  InvoiceRegistrationCodeDesc = 'INVOICE_REGISTRATION_CODE_DESC',
  PaymentCycleAsc = 'PAYMENT_CYCLE_ASC',
  PaymentCycleDesc = 'PAYMENT_CYCLE_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC',
  PaymentMethodAsc = 'PAYMENT_METHOD_ASC',
  PaymentMethodDesc = 'PAYMENT_METHOD_DESC',
  PriceRoundTypeAsc = 'PRICE_ROUND_TYPE_ASC',
  PriceRoundTypeDesc = 'PRICE_ROUND_TYPE_DESC',
  ProductGroupAsc = 'PRODUCT_GROUP_ASC',
  ProductGroupDesc = 'PRODUCT_GROUP_DESC',
  PurposeGroupAsc = 'PURPOSE_GROUP_ASC',
  PurposeGroupDesc = 'PURPOSE_GROUP_DESC',
  ReportOutputUnitAsc = 'REPORT_OUTPUT_UNIT_ASC',
  ReportOutputUnitDesc = 'REPORT_OUTPUT_UNIT_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  TaxRoundTypeAsc = 'TAX_ROUND_TYPE_ASC',
  TaxRoundTypeDesc = 'TAX_ROUND_TYPE_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  TradeStopFlgAsc = 'TRADE_STOP_FLG_ASC',
  TradeStopFlgDesc = 'TRADE_STOP_FLG_DESC',
  TransferConditionAsc = 'TRANSFER_CONDITION_ASC',
  TransferConditionDesc = 'TRANSFER_CONDITION_DESC',
  TransferCustomCode1Asc = 'TRANSFER_CUSTOM_CODE1_ASC',
  TransferCustomCode1Desc = 'TRANSFER_CUSTOM_CODE1_DESC',
  TransferCustomCode2Asc = 'TRANSFER_CUSTOM_CODE2_ASC',
  TransferCustomCode2Desc = 'TRANSFER_CUSTOM_CODE2_DESC',
  TransferMethodCodeAsc = 'TRANSFER_METHOD_CODE_ASC',
  TransferMethodCodeDesc = 'TRANSFER_METHOD_CODE_DESC',
  TransferShareCostAsc = 'TRANSFER_SHARE_COST_ASC',
  TransferShareCostDesc = 'TRANSFER_SHARE_COST_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VendorClosingGroupAsc = 'VENDOR_CLOSING_GROUP_ASC',
  VendorClosingGroupDesc = 'VENDOR_CLOSING_GROUP_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VendorFuriAsc = 'VENDOR_FURI_ASC',
  VendorFuriDesc = 'VENDOR_FURI_DESC',
  VendorMemoAsc = 'VENDOR_MEMO_ASC',
  VendorMemoDesc = 'VENDOR_MEMO_DESC',
  VendorNameAsc = 'VENDOR_NAME_ASC',
  VendorNameDesc = 'VENDOR_NAME_DESC',
  VendorTaxTypeAsc = 'VENDOR_TAX_TYPE_ASC',
  VendorTaxTypeDesc = 'VENDOR_TAX_TYPE_DESC',
  VendorTradeDivisionAsc = 'VENDOR_TRADE_DIVISION_ASC',
  VendorTradeDivisionDesc = 'VENDOR_TRADE_DIVISION_DESC',
  VendorUnitpriceTypeAsc = 'VENDOR_UNITPRICE_TYPE_ASC',
  VendorUnitpriceTypeDesc = 'VENDOR_UNITPRICE_TYPE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export type VendorWithCarryOver = Node & {
  __typename?: 'VendorWithCarryOver';
  /** The ID of the object. */
  id: Scalars['ID'];
  targetCarryOver?: Maybe<Scalars['Float']>;
  vendorTaxType?: Maybe<Scalars['String']>;
};

export type VendorWithCarryOverConnection = {
  __typename?: 'VendorWithCarryOverConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VendorWithCarryOverEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VendorWithCarryOver` and its cursor. */
export type VendorWithCarryOverEdge = {
  __typename?: 'VendorWithCarryOverEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<VendorWithCarryOver>;
};

export type Warehouse = Node & {
  __typename?: 'Warehouse';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  customer?: Maybe<Customer>;
  customerCode?: Maybe<Scalars['String']>;
  delFlg: Scalars['String'];
  division?: Maybe<Division>;
  divisionCode?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isCountTarget: Scalars['String'];
  tel?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseCode: Scalars['String'];
  warehouseMemo?: Maybe<Scalars['String']>;
  warehouseName: Scalars['String'];
  warehouseType: Scalars['String'];
  warehouseUser?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type WarehouseConnection = {
  __typename?: 'WarehouseConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WarehouseEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Warehouse` and its cursor. */
export type WarehouseEdge = {
  __typename?: 'WarehouseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Warehouse>;
};

export type WarehouseMove = Node & {
  __typename?: 'WarehouseMove';
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  moveDate: Scalars['String'];
  moveDestination?: Maybe<Warehouse>;
  moveSource?: Maybe<Warehouse>;
  moveWarehouseDestination: Scalars['String'];
  moveWarehouseSource: Scalars['String'];
  searchKeyword?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseMoveDetail?: Maybe<WarehouseMoveDetailConnection>;
  warehouseMoveId: Scalars['ID'];
  warehouseMoveMemo?: Maybe<Scalars['String']>;
  warehouseMoveMethod: Scalars['String'];
  warehouseMoveStatus: Scalars['String'];
};


export type WarehouseMoveWarehouseMoveDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type WarehouseMoveConnection = {
  __typename?: 'WarehouseMoveConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WarehouseMoveEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WarehouseMoveDetail = Node & {
  __typename?: 'WarehouseMoveDetail';
  approvedMoveQuantity?: Maybe<Scalars['Float']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  janCode?: Maybe<Scalars['String']>;
  moveQuantity: Scalars['Float'];
  numbering: Scalars['ID'];
  product?: Maybe<ProductNoPriceView>;
  productCode?: Maybe<Scalars['String']>;
  stockWarehouseMove?: Maybe<StockWarehouseMove>;
  transferProduct?: Maybe<ProductNoPriceView>;
  transferProductCode?: Maybe<Scalars['String']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  warehouseMove?: Maybe<WarehouseMove>;
  warehouseMoveId: Scalars['ID'];
};

export type WarehouseMoveDetailConnection = {
  __typename?: 'WarehouseMoveDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WarehouseMoveDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `WarehouseMoveDetail` and its cursor. */
export type WarehouseMoveDetailEdge = {
  __typename?: 'WarehouseMoveDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<WarehouseMoveDetail>;
};

/** An enumeration. */
export enum WarehouseMoveDetailSortEnum {
  ApprovedMoveQuantityAsc = 'APPROVED_MOVE_QUANTITY_ASC',
  ApprovedMoveQuantityDesc = 'APPROVED_MOVE_QUANTITY_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  JanCodeAsc = 'JAN_CODE_ASC',
  JanCodeDesc = 'JAN_CODE_DESC',
  MoveQuantityAsc = 'MOVE_QUANTITY_ASC',
  MoveQuantityDesc = 'MOVE_QUANTITY_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  ProductCodeAsc = 'PRODUCT_CODE_ASC',
  ProductCodeDesc = 'PRODUCT_CODE_DESC',
  TransferProductCodeAsc = 'TRANSFER_PRODUCT_CODE_ASC',
  TransferProductCodeDesc = 'TRANSFER_PRODUCT_CODE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseMoveIdAsc = 'WAREHOUSE_MOVE_ID_ASC',
  WarehouseMoveIdDesc = 'WAREHOUSE_MOVE_ID_DESC'
}

/** A Relay edge containing a `WarehouseMove` and its cursor. */
export type WarehouseMoveEdge = {
  __typename?: 'WarehouseMoveEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<WarehouseMove>;
};

/** An enumeration. */
export enum WarehouseMoveSortEnum {
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  MoveDateAsc = 'MOVE_DATE_ASC',
  MoveDateDesc = 'MOVE_DATE_DESC',
  MoveWarehouseDestinationAsc = 'MOVE_WAREHOUSE_DESTINATION_ASC',
  MoveWarehouseDestinationDesc = 'MOVE_WAREHOUSE_DESTINATION_DESC',
  MoveWarehouseSourceAsc = 'MOVE_WAREHOUSE_SOURCE_ASC',
  MoveWarehouseSourceDesc = 'MOVE_WAREHOUSE_SOURCE_DESC',
  SearchKeywordAsc = 'SEARCH_KEYWORD_ASC',
  SearchKeywordDesc = 'SEARCH_KEYWORD_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseMoveIdAsc = 'WAREHOUSE_MOVE_ID_ASC',
  WarehouseMoveIdDesc = 'WAREHOUSE_MOVE_ID_DESC',
  WarehouseMoveMemoAsc = 'WAREHOUSE_MOVE_MEMO_ASC',
  WarehouseMoveMemoDesc = 'WAREHOUSE_MOVE_MEMO_DESC',
  WarehouseMoveMethodAsc = 'WAREHOUSE_MOVE_METHOD_ASC',
  WarehouseMoveMethodDesc = 'WAREHOUSE_MOVE_METHOD_DESC',
  WarehouseMoveStatusAsc = 'WAREHOUSE_MOVE_STATUS_ASC',
  WarehouseMoveStatusDesc = 'WAREHOUSE_MOVE_STATUS_DESC'
}

/** An enumeration. */
export enum WarehouseSortEnum {
  Address1Asc = 'ADDRESS1_ASC',
  Address1Desc = 'ADDRESS1_DESC',
  Address2Asc = 'ADDRESS2_ASC',
  Address2Desc = 'ADDRESS2_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  CustomerCodeAsc = 'CUSTOMER_CODE_ASC',
  CustomerCodeDesc = 'CUSTOMER_CODE_DESC',
  DelFlgAsc = 'DEL_FLG_ASC',
  DelFlgDesc = 'DEL_FLG_DESC',
  DivisionCodeAsc = 'DIVISION_CODE_ASC',
  DivisionCodeDesc = 'DIVISION_CODE_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  IsCountTargetAsc = 'IS_COUNT_TARGET_ASC',
  IsCountTargetDesc = 'IS_COUNT_TARGET_DESC',
  TelAsc = 'TEL_ASC',
  TelDesc = 'TEL_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC',
  WarehouseCodeAsc = 'WAREHOUSE_CODE_ASC',
  WarehouseCodeDesc = 'WAREHOUSE_CODE_DESC',
  WarehouseMemoAsc = 'WAREHOUSE_MEMO_ASC',
  WarehouseMemoDesc = 'WAREHOUSE_MEMO_DESC',
  WarehouseNameAsc = 'WAREHOUSE_NAME_ASC',
  WarehouseNameDesc = 'WAREHOUSE_NAME_DESC',
  WarehouseTypeAsc = 'WAREHOUSE_TYPE_ASC',
  WarehouseTypeDesc = 'WAREHOUSE_TYPE_DESC',
  WarehouseUserAsc = 'WAREHOUSE_USER_ASC',
  WarehouseUserDesc = 'WAREHOUSE_USER_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC'
}

export type WipResultData = {
  __typename?: 'WipResultData';
  divisionCode?: Maybe<Scalars['String']>;
  divisionName?: Maybe<Scalars['String']>;
  eightTax?: Maybe<Scalars['Float']>;
  eightTaxExcluded?: Maybe<Scalars['Float']>;
  importFlg?: Maybe<Scalars['Boolean']>;
  purchaseDate?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  taxExcluded?: Maybe<Scalars['Float']>;
  taxIncluded?: Maybe<Scalars['Float']>;
  tenTax?: Maybe<Scalars['Float']>;
  tenTaxExcluded?: Maybe<Scalars['Float']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorName?: Maybe<Scalars['String']>;
};

export type WithDrawalsMonthly = Node & {
  __typename?: 'WithDrawalsMonthly';
  fromDate?: Maybe<Scalars['Date']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  toDate?: Maybe<Scalars['Date']>;
  totalingWithdrawalPrice?: Maybe<Scalars['Decimal']>;
  vendorCode?: Maybe<Scalars['String']>;
};

export type WithDrawalsMonthlyConnection = {
  __typename?: 'WithDrawalsMonthlyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WithDrawalsMonthlyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `WithDrawalsMonthly` and its cursor. */
export type WithDrawalsMonthlyEdge = {
  __typename?: 'WithDrawalsMonthlyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<WithDrawalsMonthly>;
};

export type Withdrawal = Node & {
  __typename?: 'Withdrawal';
  automaticallyGeneratedFlg: Scalars['String'];
  closingStatusCode: Scalars['String'];
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  payDate: Scalars['String'];
  payId: Scalars['ID'];
  payPriceTotal: Scalars['Float'];
  payRemark?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']>;
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  user?: Maybe<User>;
  userCode?: Maybe<Scalars['String']>;
  vendor?: Maybe<Vendor>;
  vendorCode: Scalars['String'];
  versionUuid: Scalars['String'];
  withdrawalDetail?: Maybe<WithdrawalDetailConnection>;
  withdrawalDetails?: Maybe<WithdrawalDetailConnection>;
};


export type WithdrawalWithdrawalDetailArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type WithdrawalWithdrawalDetailsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<WithdrawalDetailFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type WithdrawalConnection = {
  __typename?: 'WithdrawalConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WithdrawalEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WithdrawalDetail = Node & {
  __typename?: 'WithdrawalDetail';
  billDate?: Maybe<Scalars['String']>;
  createDate: Scalars['DateTime'];
  createUserCode: Scalars['String'];
  createUserName: Scalars['String'];
  detailMemo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  numbering: Scalars['ID'];
  payDivisionCode: Scalars['String'];
  payDivisionDetail?: Maybe<Scalars['String']>;
  payId: Scalars['ID'];
  payPrice: Scalars['Float'];
  updateDate: Scalars['DateTime'];
  updateUserCode: Scalars['String'];
  updateUserName: Scalars['String'];
  versionUuid: Scalars['String'];
  withdrawal?: Maybe<Withdrawal>;
};

export type WithdrawalDetailConnection = {
  __typename?: 'WithdrawalDetailConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<WithdrawalDetailEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `WithdrawalDetail` and its cursor. */
export type WithdrawalDetailEdge = {
  __typename?: 'WithdrawalDetailEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<WithdrawalDetail>;
};

export type WithdrawalDetailFilter = {
  payDivisionCode?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum WithdrawalDetailSortEnum {
  BillDateAsc = 'BILL_DATE_ASC',
  BillDateDesc = 'BILL_DATE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  DetailMemoAsc = 'DETAIL_MEMO_ASC',
  DetailMemoDesc = 'DETAIL_MEMO_DESC',
  NumberingAsc = 'NUMBERING_ASC',
  NumberingDesc = 'NUMBERING_DESC',
  PayDivisionCodeAsc = 'PAY_DIVISION_CODE_ASC',
  PayDivisionCodeDesc = 'PAY_DIVISION_CODE_DESC',
  PayDivisionDetailAsc = 'PAY_DIVISION_DETAIL_ASC',
  PayDivisionDetailDesc = 'PAY_DIVISION_DETAIL_DESC',
  PayIdAsc = 'PAY_ID_ASC',
  PayIdDesc = 'PAY_ID_DESC',
  PayPriceAsc = 'PAY_PRICE_ASC',
  PayPriceDesc = 'PAY_PRICE_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

/** A Relay edge containing a `Withdrawal` and its cursor. */
export type WithdrawalEdge = {
  __typename?: 'WithdrawalEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<Withdrawal>;
};

/** An enumeration. */
export enum WithdrawalSortEnum {
  AutomaticallyGeneratedFlgAsc = 'AUTOMATICALLY_GENERATED_FLG_ASC',
  AutomaticallyGeneratedFlgDesc = 'AUTOMATICALLY_GENERATED_FLG_DESC',
  ClosingStatusCodeAsc = 'CLOSING_STATUS_CODE_ASC',
  ClosingStatusCodeDesc = 'CLOSING_STATUS_CODE_DESC',
  CreateDateAsc = 'CREATE_DATE_ASC',
  CreateDateDesc = 'CREATE_DATE_DESC',
  CreateUserCodeAsc = 'CREATE_USER_CODE_ASC',
  CreateUserCodeDesc = 'CREATE_USER_CODE_DESC',
  CreateUserNameAsc = 'CREATE_USER_NAME_ASC',
  CreateUserNameDesc = 'CREATE_USER_NAME_DESC',
  PaymentIdAsc = 'PAYMENT_ID_ASC',
  PaymentIdDesc = 'PAYMENT_ID_DESC',
  PayDateAsc = 'PAY_DATE_ASC',
  PayDateDesc = 'PAY_DATE_DESC',
  PayIdAsc = 'PAY_ID_ASC',
  PayIdDesc = 'PAY_ID_DESC',
  PayPriceTotalAsc = 'PAY_PRICE_TOTAL_ASC',
  PayPriceTotalDesc = 'PAY_PRICE_TOTAL_DESC',
  PayRemarkAsc = 'PAY_REMARK_ASC',
  PayRemarkDesc = 'PAY_REMARK_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
  UpdateUserCodeAsc = 'UPDATE_USER_CODE_ASC',
  UpdateUserCodeDesc = 'UPDATE_USER_CODE_DESC',
  UpdateUserNameAsc = 'UPDATE_USER_NAME_ASC',
  UpdateUserNameDesc = 'UPDATE_USER_NAME_DESC',
  UserCodeAsc = 'USER_CODE_ASC',
  UserCodeDesc = 'USER_CODE_DESC',
  VendorCodeAsc = 'VENDOR_CODE_ASC',
  VendorCodeDesc = 'VENDOR_CODE_DESC',
  VersionUuidAsc = 'VERSION_UUID_ASC',
  VersionUuidDesc = 'VERSION_UUID_DESC'
}

export type SearchSendOrderArrivalFieldsFragment = { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, id: string, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailNumbering?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSendOrderFieldsFragment = { __typename?: 'SendOrder', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, searchKeyword?: string | null | undefined, id: string, arrival?: { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, id: string, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailNumbering?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchSendOrderDetailFieldsFragment = { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, totalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', productName: string, attr1?: string | null | undefined, attr2?: string | null | undefined, clothGroup?: string | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined };

export type SearchSendOrderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderFilter>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderSortEnum>> | InputMaybe<SendOrderSortEnum>>;
  detailFilter?: InputMaybe<SendOrderDetailFilter>;
}>;


export type SearchSendOrderQuery = { __typename?: 'Query', searchSendOrder?: { __typename?: 'SendOrderConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SendOrderEdge', cursor: string, node?: { __typename?: 'SendOrder', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, searchKeyword?: string | null | undefined, id: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, totalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', productName: string, attr1?: string | null | undefined, attr2?: string | null | undefined, clothGroup?: string | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined, arrival?: { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, id: string, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailNumbering?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ActiveReportDemandPrintMutationVariables = Exact<{
  demandId: Scalars['Int'];
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  carryOverPriceFlg?: InputMaybe<Scalars['String']>;
  detailStatus?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportDemandPrintMutation = { __typename?: 'Mutation', activeReportDemandPrint?: { __typename?: 'ActiveReportDemandPrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportSaleVoucherPrintMutationVariables = Exact<{
  deliveryOrderId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  offsetX?: InputMaybe<Scalars['String']>;
  offsetY?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportSaleVoucherPrintMutation = { __typename?: 'Mutation', activeReportSaleVoucherPrint?: { __typename?: 'ActiveReportShipmentPrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportReceiveOrderPrintMutationVariables = Exact<{
  receiveOrderId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  offsetX?: InputMaybe<Scalars['String']>;
  offsetY?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportReceiveOrderPrintMutation = { __typename?: 'Mutation', activeReportReceiveOrderPrint?: { __typename?: 'ActiveReportReceiveOrderPrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportEstimatePrintMutationVariables = Exact<{
  estimateId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportEstimatePrintMutation = { __typename?: 'Mutation', activeReportEstimatePrint?: { __typename?: 'ActiveReportEstimatePrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportSendOrderPrintMutationVariables = Exact<{
  orderId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportSendOrderPrintMutation = { __typename?: 'Mutation', activeReportSendOrderPrint?: { __typename?: 'ActiveReportSendOrderPrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportOutsourcerSalesPrintMutationVariables = Exact<{
  salesId: Scalars['Int'];
  withInkan?: InputMaybe<Scalars['Boolean']>;
  reportLayoutCode?: InputMaybe<Scalars['String']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
}>;


export type ActiveReportOutsourcerSalesPrintMutation = { __typename?: 'Mutation', activeReportOutsourcerSalesPrint?: { __typename?: 'ActiveReportOutsourcerSalesPrint', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportBulkDemandPrintMutationVariables = Exact<{
  demandIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  fcCodeFlg?: InputMaybe<Scalars['String']>;
  detailStatus: Scalars['String'];
  carryOverPriceFlg: Scalars['String'];
  excludeZeroDemandFlg: Scalars['String'];
}>;


export type ActiveReportBulkDemandPrintMutation = { __typename?: 'Mutation', activeReportBulkDemandPrint?: { __typename?: 'ActiveReportBulkDemandPrint', presignedUrl?: string | null | undefined } | null | undefined };

export type ActiveReportCreatePriceCardMutationVariables = Exact<{
  productCodes: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  titles?: InputMaybe<Scalars['String']>;
  targetDate: Scalars['Date'];
  reportLayoutCode: Scalars['String'];
  priceMode: Scalars['String'];
  copiesDetail: Array<CreatePriceCard> | CreatePriceCard;
}>;


export type ActiveReportCreatePriceCardMutation = { __typename?: 'Mutation', activeReportCreatePriceCard?: { __typename?: 'ActiveReportCreatePriceCard', pdfBase64?: string | null | undefined } | null | undefined };

export type ActiveReportCreatePriceCardForTshirtsMutationVariables = Exact<{
  janCodes: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  targetDate: Scalars['Date'];
  copiesDetail: Array<CreatePriceCardForTshirts> | CreatePriceCardForTshirts;
}>;


export type ActiveReportCreatePriceCardForTshirtsMutation = { __typename?: 'Mutation', activeReportCreatePriceCardForTshirts?: { __typename?: 'ActiveReportCreatePriceCardForTshirts', pdfBase64?: string | null | undefined } | null | undefined };

export type AddressFieldsFragment = { __typename?: 'Address', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, zipCode1: string, zipCode2: string, prefecturesCode: string, prefectures: string, city1: string, city2: string };

export type SearchAddressQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchAddressFilter>;
  sort?: InputMaybe<Array<InputMaybe<AddressSortEnum>> | InputMaybe<AddressSortEnum>>;
}>;


export type SearchAddressQuery = { __typename?: 'Query', searchAddress?: { __typename?: 'AddressConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'AddressEdge', cursor: string, node?: { __typename?: 'Address', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, zipCode1: string, zipCode2: string, prefecturesCode: string, prefectures: string, city1: string, city2: string } | null | undefined } | null | undefined> } | null | undefined };

export type ArrivalFieldsFragment = { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, id: string, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ArrivalSendOrderDetailFieldsFragment = { __typename?: 'SendOrderDetail', numbering: string, orderQuantity?: number | null | undefined, receivedQuantity?: number | null | undefined };

export type ArrivalTaxDetailFieldsFragment = { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, id: string };

export type ArrivalDetailFieldsFragment = { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined };

export type SearchArrivalQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchArrivalFilter>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalSortEnum>> | InputMaybe<ArrivalSortEnum>>;
}>;


export type SearchArrivalQuery = { __typename?: 'Query', searchArrival?: { __typename?: 'ArrivalConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ArrivalEdge', cursor: string, node?: { __typename?: 'Arrival', id: string, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, updateUserName: string, updateDate: any, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalQuantity?: number | null | undefined, purchasePrice?: number | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ArrivalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArrivalQuery = { __typename?: 'Query', arrival?: { __typename?: 'Arrival', id: string, versionUuid: string, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseRemark?: string | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', id: string, arrivalId: string, numbering: string, frontNumbering: number, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, purchase?: { __typename?: 'Purchase', poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, closingStatusCode: string } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderType: string, poCode?: string | null | undefined, orderMemo?: string | null | undefined, versionUuid: string, divisionCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', numbering: string, orderQuantity?: number | null | undefined, receivedQuantity?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorTaxType?: string | null | undefined, vendorTradeDivision?: string | null | undefined, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined, balanceData?: number | null | undefined, purposeGroup?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ArrivalMutationFieldsFragment = { __typename?: 'Arrival', id: string, arrivalId: string, arrivalDate: string, sendOrder?: { __typename?: 'SendOrder', vendorCode: string } | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateArrivalMutationVariables = Exact<{
  input: CreateArrivalInput;
}>;


export type CreateArrivalMutation = { __typename?: 'Mutation', createArrival?: { __typename?: 'CreateArrivalPayload', arrival?: { __typename?: 'Arrival', id: string, arrivalId: string, arrivalDate: string, sendOrder?: { __typename?: 'SendOrder', vendorCode: string } | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateArrivalMutationVariables = Exact<{
  input: UpdateArrivalInput;
}>;


export type UpdateArrivalMutation = { __typename?: 'Mutation', updateArrival?: { __typename?: 'UpdateArrivalPayload', arrival?: { __typename?: 'Arrival', id: string, arrivalId: string, arrivalDate: string, sendOrder?: { __typename?: 'SendOrder', vendorCode: string } | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteArrivalMutationVariables = Exact<{
  input: DeleteArrivalInput;
}>;


export type DeleteArrivalMutation = { __typename?: 'Mutation', deleteArrival?: { __typename?: 'DeleteArrivalPayload', arrival?: { __typename?: 'Arrival', id: string, arrivalId: string, arrivalDate: string, sendOrder?: { __typename?: 'SendOrder', vendorCode: string } | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalId: string, numbering: string, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, product?: { __typename?: 'ProductNoPriceView', allRemainReceiveQuantity?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type SearchArrivalDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchArrivalFilter>;
  sort?: InputMaybe<Array<InputMaybe<ArrivalSortEnum>> | InputMaybe<ArrivalSortEnum>>;
  detailFilter?: InputMaybe<ArrivalDetailFilter>;
}>;


export type SearchArrivalDetailQuery = { __typename?: 'Query', searchArrival?: { __typename?: 'ArrivalConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ArrivalEdge', cursor: string, node?: { __typename?: 'Arrival', arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined, purchaseVoucherType: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseRemark?: string | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', id: string, arrivalId: string, numbering: string, frontNumbering: number, arrivalTradeTypeCode: string, arrivalDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, arrivalQuantity?: number | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, sendOrderDetailGroupNumbering?: number | null | undefined, sendOrderDetailNumbering?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, purchase?: { __typename?: 'Purchase', poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, closingStatusCode: string, taxExcludedTotal?: number | null | undefined, purchaseId: string, divisionCode: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderType: string, poCode?: string | null | undefined, orderMemo?: string | null | undefined, versionUuid: string, divisionCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', numbering: string, orderQuantity?: number | null | undefined, receivedQuantity?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorTaxType?: string | null | undefined, vendorTradeDivision?: string | null | undefined, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined, balanceData?: number | null | undefined, purposeGroup?: string | null | undefined } | null | undefined, purchase?: { __typename?: 'Purchase', purchaseId: string } | null | undefined } | null | undefined, arrivalTaxDetail?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, taxationDivision: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type BeforeDemandClosingFieldsFragment = { __typename?: 'BeforeDemandClosing', demandCode?: string | null | undefined, customerName?: string | null | undefined, customerFuri?: string | null | undefined, closingDate?: any | null | undefined, collectExpectedDate?: any | null | undefined, beforeDemandRemain?: number | null | undefined, depositPriceTotalInAccountMonth?: number | null | undefined, excludedTaxTotalDemandPrice?: number | null | undefined, exciseTaxTotal?: number | null | undefined, carryOverPrice?: number | null | undefined, includedTaxTotalDemandPrice?: number | null | undefined, exciseTaxPer10?: number | null | undefined, taxExcludedPer10?: number | null | undefined, exciseTaxPer8?: number | null | undefined, taxExcludedPer8?: number | null | undefined, currentDemandExpectRemain?: number | null | undefined };

export type SearchBeforeDemandClosingQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchBeforeDemandClosingListFilter>;
}>;


export type SearchBeforeDemandClosingQuery = { __typename?: 'Query', searchBeforeDemandClosing?: { __typename?: 'BeforeDemandClosingConnection', totalCount?: number | null | undefined, edges: Array<{ __typename?: 'BeforeDemandClosingEdge', node?: { __typename?: 'BeforeDemandClosing', demandCode?: string | null | undefined, customerName?: string | null | undefined, customerFuri?: string | null | undefined, closingDate?: any | null | undefined, collectExpectedDate?: any | null | undefined, beforeDemandRemain?: number | null | undefined, depositPriceTotalInAccountMonth?: number | null | undefined, excludedTaxTotalDemandPrice?: number | null | undefined, exciseTaxTotal?: number | null | undefined, carryOverPrice?: number | null | undefined, includedTaxTotalDemandPrice?: number | null | undefined, exciseTaxPer10?: number | null | undefined, taxExcludedPer10?: number | null | undefined, exciseTaxPer8?: number | null | undefined, taxExcludedPer8?: number | null | undefined, currentDemandExpectRemain?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetTaxDivisionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxDivisionQuery = { __typename?: 'Query', getTaxDivision?: { __typename?: 'TaxDivisionConnection', edges: Array<{ __typename?: 'TaxDivisionEdge', node?: { __typename?: 'TaxDivision', taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined> } | null | undefined };

export type GetDepositDivisionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepositDivisionQuery = { __typename?: 'Query', searchDepositDivision?: { __typename?: 'DepositDivisionConnection', edges: Array<{ __typename?: 'DepositDivisionEdge', node?: { __typename?: 'DepositDivision', depositDivisionCode: string, depositDivisionName: string, depositGroupCode: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetPaymentDivisionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentDivisionQuery = { __typename?: 'Query', searchPaymentDivision?: { __typename?: 'PaymentDivisionConnection', edges: Array<{ __typename?: 'PaymentDivisionEdge', node?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string, paymentGroupCode: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetDivisionQueryVariables = Exact<{
  filter?: InputMaybe<SearchDivisionFilter>;
}>;


export type GetDivisionQuery = { __typename?: 'Query', searchDivision?: { __typename?: 'DivisionConnection', edges: Array<{ __typename?: 'DivisionEdge', node?: { __typename?: 'Division', divisionCode: string, divisionName: string, divistionType: string, customerCode?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetFinancialDateQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<FinancialDateSortEnum>> | InputMaybe<FinancialDateSortEnum>>;
}>;


export type GetFinancialDateQuery = { __typename?: 'Query', getFinancialDate?: { __typename?: 'FinancialDateConnection', edges: Array<{ __typename?: 'FinancialDateEdge', node?: { __typename?: 'FinancialDate', financialStage: string, financialYear: string, financialMonth: string, financialStartDate: string, financialEndDate: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', userCode: string, userName: string, userType: string } | null | undefined };

export type GetReportLayoutQueryVariables = Exact<{
  filter?: InputMaybe<SearchReportLayoutFilter>;
}>;


export type GetReportLayoutQuery = { __typename?: 'Query', searchReportLayout?: { __typename?: 'ReportLayoutConnection', edges: Array<{ __typename?: 'ReportLayoutEdge', node?: { __typename?: 'ReportLayout', reportLayoutName: string, reportLayoutCode: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorQuery = { __typename?: 'Query', searchVendor?: { __typename?: 'VendorConnection', edges: Array<{ __typename?: 'VendorEdge', node?: { __typename?: 'Vendor', vendorCode: string, vendorName: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetProductGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductGroupQuery = { __typename?: 'Query', searchProductGroup?: { __typename?: 'ProductGroupConnection', edges: Array<{ __typename?: 'ProductGroupEdge', node?: { __typename?: 'ProductGroup', productGroupId: string, productGroupName: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetInventoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInventoryQuery = { __typename?: 'Query', searchInventory?: { __typename?: 'InventoryConnection', edges: Array<{ __typename?: 'InventoryEdge', node?: { __typename?: 'Inventory', inventoryId: string, inventoryName: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerQuery = { __typename?: 'Query', searchCustomer?: { __typename?: 'CustomerConnection', edges: Array<{ __typename?: 'CustomerEdge', node?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchClothProgressQueryVariables = Exact<{
  filter?: InputMaybe<ClothProgressFilter>;
}>;


export type SearchClothProgressQuery = { __typename?: 'Query', searchClothProgress?: { __typename?: 'ClothProgressConnection', edges: Array<{ __typename?: 'ClothProgressEdge', node?: { __typename?: 'ClothProgress', orderId: string, totalQuantity?: number | null | undefined, receivedQuantity?: number | null | undefined, janCode?: string | null | undefined, createUserName: string, sendOrder?: { __typename?: 'SendOrder', orderDate: string, deliveryDate?: string | null | undefined, orderMemo?: string | null | undefined, orderRemarks?: string | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', productName: string, attr1?: string | null | undefined, attr2?: string | null | undefined, clothGroup?: string | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined } | null | undefined, clothProgressArraival?: Array<{ __typename?: 'ClothProgressArraival', arrivalDate?: any | null | undefined, arrivalQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchCollectionPlanQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCollectionPlanFilter>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>> | InputMaybe<DemandSortEnum>>;
}>;


export type SearchCollectionPlanQuery = { __typename?: 'Query', searchCollectionPlan?: { __typename?: 'DemandConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', cursor: string, node?: { __typename?: 'Demand', demandCode: string, collectExpectedDate: string, demandDate: string, demandId: string, includedTaxTotalDemandPrice: number, customer?: { __typename?: 'Customer', customerName: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchCollectionStatusQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCollectionStatusFilter>;
}>;


export type SearchCollectionStatusQuery = { __typename?: 'Query', searchCollectionStatus?: { __typename?: 'CollectionStatusConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CollectionStatusEdge', cursor: string, node?: { __typename?: 'CollectionStatus', userName?: string | null | undefined, demandCode?: string | null | undefined, demandName?: string | null | undefined, collectedNeedThisMonth?: number | null | undefined, collectedThisMonth?: number | null | undefined, collectedRate?: number | null | undefined, remainedLastMonth?: number | null | undefined, remainedThisMonth?: number | null | undefined, remainedThisMonthEnd?: number | null | undefined, collectExpectedLastMonth?: number | null | undefined, collectExpectedThisMonth?: number | null | undefined, collectExpectedNextMonth?: number | null | undefined, collectExpectedAfterNextMonth?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ComponentDetailFieldsFragment = { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ComponentFieldsFragment = { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined };

export type ComponentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ComponentQuery = { __typename?: 'Query', component?: { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateComponentMutationVariables = Exact<{
  input: CreateComponentInput;
}>;


export type CreateComponentMutation = { __typename?: 'Mutation', createComponent?: { __typename?: 'CreateComponentPayload', component?: { __typename?: 'Component', id: string, finishedProductCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateComponentMutationVariables = Exact<{
  input: UpdateComponentInput;
}>;


export type UpdateComponentMutation = { __typename?: 'Mutation', updateComponent?: { __typename?: 'UpdateComponentPayload', component?: { __typename?: 'Component', id: string, finishedProductCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteComponentMutationVariables = Exact<{
  input: DeleteComponentInput;
}>;


export type DeleteComponentMutation = { __typename?: 'Mutation', deleteComponent?: { __typename?: 'DeleteComponentPayload', component?: { __typename?: 'Component', finishedProductCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchComponentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchComponentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ComponentSortEnum>> | InputMaybe<ComponentSortEnum>>;
}>;


export type SearchComponentQuery = { __typename?: 'Query', searchComponent?: { __typename?: 'ComponentConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentEdge', cursor: string, node?: { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CustomerFieldsFragment = { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, balanceData?: number | null | undefined, delFlg: string };

export type CustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, balanceData?: number | null | undefined, delFlg: string, demand?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, depositDivision?: { __typename?: 'DepositDivision', depositDivisionCode: string, depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string } | null | undefined } | null | undefined };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'CreateCustomerPayload', customer?: { __typename?: 'Customer', customerCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'UpdateCustomerPayload', customer?: { __typename?: 'Customer', customerCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteCustomerMutationVariables = Exact<{
  input: DeleteCustomerInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer?: { __typename?: 'DeleteCustomerPayload', customer?: { __typename?: 'Customer', customerCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchCustomerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerFilter>;
  customFilter?: InputMaybe<SearchCustomerFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSortEnum>> | InputMaybe<CustomerSortEnum>>;
}>;


export type SearchCustomerQuery = { __typename?: 'Query', searchCustomer?: { __typename?: 'CustomerConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, balanceData?: number | null | undefined, delFlg: string, user?: { __typename?: 'User', userName: string } | null | undefined, demand?: { __typename?: 'Customer', customerName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, salesReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string } | null | undefined, demandReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateCustomerBudgetMutationVariables = Exact<{
  input: CreateCustomerBudgetInput;
}>;


export type CreateCustomerBudgetMutation = { __typename?: 'Mutation', createCustomerBudget?: { __typename?: 'CreateCustomerBudgetPayload', customerBudget?: { __typename?: 'CustomerBudget', id: string } | null | undefined } | null | undefined };

export type ImportCustomerBudgetMutationVariables = Exact<{
  input: ImportCustomerBudgetListInput;
}>;


export type ImportCustomerBudgetMutation = { __typename?: 'Mutation', importCustomerBudget?: { __typename?: 'ImportCustomerBudgetListPayload', customerBudget?: Array<{ __typename?: 'CustomerBudget', financialStage: number, financialMonth: number, customerCode: string, budgetPrice: number } | null | undefined> | null | undefined } | null | undefined };

export type CustomerBudgetsCustomFieldsFragment = { __typename?: 'CustomerBudgetsCustom', customerCode?: string | null | undefined, customerName?: string | null | undefined, userCode?: string | null | undefined, userName?: string | null | undefined, customerArea?: string | null | undefined, rowType?: string | null | undefined, jan?: number | null | undefined, feb?: number | null | undefined, mar?: number | null | undefined, apr?: number | null | undefined, may?: number | null | undefined, jun?: number | null | undefined, jul?: number | null | undefined, aug?: number | null | undefined, sep?: number | null | undefined, oct?: number | null | undefined, nov?: number | null | undefined, dec?: number | null | undefined, versionUuid?: { __typename?: 'CustomerBudgetsVersionUuid', jan?: string | null | undefined, feb?: string | null | undefined, mar?: string | null | undefined, apr?: string | null | undefined, may?: string | null | undefined, jun?: string | null | undefined, jul?: string | null | undefined, aug?: string | null | undefined, sep?: string | null | undefined, oct?: string | null | undefined, nov?: string | null | undefined, dec?: string | null | undefined } | null | undefined };

export type SearchCustomerBudgetQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CustomerBudgetsCustomFilter>;
}>;


export type SearchCustomerBudgetQuery = { __typename?: 'Query', searchCustomerBudget?: { __typename?: 'CustomerBudgetsCustomConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerBudgetsCustomEdge', cursor: string, node?: { __typename?: 'CustomerBudgetsCustom', customerCode?: string | null | undefined, customerName?: string | null | undefined, userCode?: string | null | undefined, userName?: string | null | undefined, customerArea?: string | null | undefined, rowType?: string | null | undefined, jan?: number | null | undefined, feb?: number | null | undefined, mar?: number | null | undefined, apr?: number | null | undefined, may?: number | null | undefined, jun?: number | null | undefined, jul?: number | null | undefined, aug?: number | null | undefined, sep?: number | null | undefined, oct?: number | null | undefined, nov?: number | null | undefined, dec?: number | null | undefined, versionUuid?: { __typename?: 'CustomerBudgetsVersionUuid', jan?: string | null | undefined, feb?: string | null | undefined, mar?: string | null | undefined, apr?: string | null | undefined, may?: string | null | undefined, jun?: string | null | undefined, jul?: string | null | undefined, aug?: string | null | undefined, sep?: string | null | undefined, oct?: string | null | undefined, nov?: string | null | undefined, dec?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CustomerPriceFieldsFragment = { __typename?: 'CustomerPrice', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, customerCode: string, uniqueCode: string, startDate: string, endDate: string, sellingUnitPrice: number, id: string, customer?: { __typename?: 'Customer', customerName: string, salesTaxType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, priceRoundType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, product?: { __typename?: 'Product', janCode: string, productName: string, unitYenDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined } | null | undefined, productPrice?: { __typename?: 'ProductPrice', uniqueCode: string, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate: string, endDate: string } | null | undefined };

export type CustomerPriceFieldsListFragment = { __typename?: 'CustomerPriceNode', id: string, versionUuid?: string | null | undefined, uniqueCode?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, priceRoundType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, currentDate?: string | null | undefined, taxationDivision?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, activeStatus?: string | null | undefined, retailPriceExcl?: number | null | undefined, sellingPriceExcl?: number | null | undefined, sellingUnitPrice?: number | null | undefined, retailPriceIncl?: number | null | undefined, sellingPriceIncl?: number | null | undefined, sellingUnitPriceIncl?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, salesTaxType?: string | null | undefined };

export type SearchCustomerPriceListQueryVariables = Exact<{
  filter?: InputMaybe<SearchCustomerPriceFilter>;
}>;


export type SearchCustomerPriceListQuery = { __typename?: 'Query', searchCustomerPriceList?: { __typename?: 'CustomerPriceListResult', totalCount?: number | null | undefined, list?: Array<{ __typename?: 'CustomerPriceNode', id: string, versionUuid?: string | null | undefined, uniqueCode?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, priceRoundType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, currentDate?: string | null | undefined, taxationDivision?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, activeStatus?: string | null | undefined, retailPriceExcl?: number | null | undefined, sellingPriceExcl?: number | null | undefined, sellingUnitPrice?: number | null | undefined, retailPriceIncl?: number | null | undefined, sellingPriceIncl?: number | null | undefined, sellingUnitPriceIncl?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, salesTaxType?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchCustomerPriceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerPriceFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerPriceSortEnum>> | InputMaybe<CustomerPriceSortEnum>>;
}>;


export type SearchCustomerPriceQuery = { __typename?: 'Query', searchCustomerPrice?: { __typename?: 'CustomerPriceConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerPriceEdge', cursor: string, node?: { __typename?: 'CustomerPrice', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, customerCode: string, uniqueCode: string, startDate: string, endDate: string, sellingUnitPrice: number, id: string, customer?: { __typename?: 'Customer', customerName: string, salesTaxType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, priceRoundType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, product?: { __typename?: 'Product', janCode: string, productName: string, unitYenDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined } | null | undefined, productPrice?: { __typename?: 'ProductPrice', uniqueCode: string, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate: string, endDate: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateCustomerPriceMutationVariables = Exact<{
  input: CreateCustomerPriceInput;
}>;


export type CreateCustomerPriceMutation = { __typename?: 'Mutation', createCustomerPrice?: { __typename?: 'CreateCustomerPricePayload', customerPrice?: { __typename?: 'CustomerPrice', id: string, versionUuid: string } | null | undefined } | null | undefined };

export type CustomerFieldsForCustomerPriceFragment = { __typename?: 'Customer', customerCode: string, customerName: string, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined };

export type SearchCustomerForCustomerPriceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchCustomerForCustomerPriceQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', customerCode: string, customerName: string, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined };

export type CreateCustomerPriceWithImportMutationVariables = Exact<{
  input: CreateCustomerPriceWithImportInput;
}>;


export type CreateCustomerPriceWithImportMutation = { __typename?: 'Mutation', createCustomerPriceWithImport?: { __typename?: 'CreateCustomerPriceWithImportPayload', resultDatas?: Array<{ __typename?: 'CreateCustomerResultData', importFlg?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateCustomerPriceWithBulkImportMutationVariables = Exact<{
  input: CreateCustomerPriceWithBulkImportInput;
}>;


export type CreateCustomerPriceWithBulkImportMutation = { __typename?: 'Mutation', createCustomerPriceWithBulkImport?: { __typename?: 'CreateCustomerPriceWithBulkImportPayload', allResult?: boolean | null | undefined, clientMutationId?: string | null | undefined, resultDatas?: Array<{ __typename?: 'CreateCustomerResultData', importFlg?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateCustomerPriceWithBulkImportResultFragment = { __typename?: 'CreateCustomerPriceWithBulkImportPayload', allResult?: boolean | null | undefined, clientMutationId?: string | null | undefined, resultDatas?: Array<{ __typename?: 'CreateCustomerResultData', importFlg?: boolean | null | undefined } | null | undefined> | null | undefined };

export type CustomerProductGroupPublicationFieldsFragment = { __typename?: 'CustomerProductGroupPublicationNode', id: string, customerCode: string, customerName?: string | null | undefined, userDivisionName?: string | null | undefined, productGroupId: string, productGroupCode: string, productGroupName?: string | null | undefined, productGrouptypeCode?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, visibilityStatus?: string | null | undefined };

export type ProductGroupBasicInfoFieldsFragment = { __typename?: 'ProductGroup', productGroupId: string, productGroupCode: string, productGroupName: string, productGrouptypeCode: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined };

export type SearchCustomerProductGroupPublicationsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerProductGroupPublicationFilter>;
}>;


export type SearchCustomerProductGroupPublicationsQuery = { __typename?: 'Query', searchCustomerProductGroupPublications?: Array<{ __typename?: 'CustomerProductGroupPublicationNode', id: string, customerCode: string, customerName?: string | null | undefined, userDivisionName?: string | null | undefined, productGroupId: string, productGroupCode: string, productGroupName?: string | null | undefined, productGrouptypeCode?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, visibilityStatus?: string | null | undefined } | null | undefined> | null | undefined };

export type GetProductGroupBasicInfoByProductGroupCodesQueryVariables = Exact<{
  filter: SearchProductGroupFilter;
}>;


export type GetProductGroupBasicInfoByProductGroupCodesQuery = { __typename?: 'Query', searchProductGroupByCode?: Array<{ __typename?: 'ProductGroup', productGroupId: string, productGroupCode: string, productGroupName: string, productGrouptypeCode: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined> | null | undefined };

export type CreateCustomerProductGroupPublicationMutationVariables = Exact<{
  input: CreateCustomerProductGroupPublicationInput;
}>;


export type CreateCustomerProductGroupPublicationMutation = { __typename?: 'Mutation', createCustomerProductGroupPublication?: { __typename?: 'CreateCustomerProductGroupPublicationPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type CreateCustomerProductGroupPublicationWithImportMutationVariables = Exact<{
  input: CreateCustomerProductGroupPublicationWithImportInput;
}>;


export type CreateCustomerProductGroupPublicationWithImportMutation = { __typename?: 'Mutation', createCustomerProductGroupPublicationWithImport?: { __typename?: 'CreateCustomerProductGroupPublicationWithImportPayload', importResults?: Array<{ __typename?: 'CustomerProductGroupPublicationWithImportResultData', importFlg?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CustomerProductPublicationFieldsFragment = { __typename?: 'CustomerProductPublicationNode', id: string, customerCode: string, customerName?: string | null | undefined, userDivisionName?: string | null | undefined, janCode?: string | null | undefined, productCode: string, productName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, visibilityStatus?: string | null | undefined };

export type ProductBasicInfoFieldsFragment = { __typename?: 'ProductNoPriceView', janCode: string, productCode: string, productName: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined };

export type CustomerBasicInfoFieldsFragment = { __typename?: 'Customer', customerCode: string, customerName: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined };

export type SearchCustomerProductPublicationsQueryVariables = Exact<{
  filter?: InputMaybe<CustomerProductPublicationFilter>;
}>;


export type SearchCustomerProductPublicationsQuery = { __typename?: 'Query', searchCustomerProductPublications?: Array<{ __typename?: 'CustomerProductPublicationNode', id: string, customerCode: string, customerName?: string | null | undefined, userDivisionName?: string | null | undefined, janCode?: string | null | undefined, productCode: string, productName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, visibilityStatus?: string | null | undefined } | null | undefined> | null | undefined };

export type GetProductBasicInfoByProductCodesQueryVariables = Exact<{
  filter: SearchProductNoPriceViewFilter;
}>;


export type GetProductBasicInfoByProductCodesQuery = { __typename?: 'Query', searchProductNoPriceView?: Array<{ __typename?: 'ProductNoPriceView', janCode: string, productCode: string, productName: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined> | null | undefined };

export type GetCustomerBasicInfoByCustomerCodesQueryVariables = Exact<{
  filter: SearchCustomerFromCodeFilter;
}>;


export type GetCustomerBasicInfoByCustomerCodesQuery = { __typename?: 'Query', customersByCode?: Array<{ __typename?: 'Customer', customerCode: string, customerName: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined> | null | undefined };

export type CreateCustomerProductPublicationMutationVariables = Exact<{
  input: CreateCustomerProductPublicationInput;
}>;


export type CreateCustomerProductPublicationMutation = { __typename?: 'Mutation', createCustomerProductPublication?: { __typename?: 'CreateCustomerProductPublicationPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type CreateCustomerProductPublicationWithImportMutationVariables = Exact<{
  input: CreateCustomerProductPublicationWithImportInput;
}>;


export type CreateCustomerProductPublicationWithImportMutation = { __typename?: 'Mutation', createCustomerProductPublicationWithImport?: { __typename?: 'CreateCustomerProductPublicationWithImportPayload', importResults?: Array<{ __typename?: 'CustomerProductPublicationWithImportResultData', importFlg?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CustomerUserFieldsFragment = { __typename?: 'CustomerUser', id: string, customerUserId: string, email: string, customerUserName: string, tel?: string | null | undefined, termsOfUseVersion?: number | null | undefined, initialConfirmationDate?: any | null | undefined, updateConfirmationDate?: any | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, delFlg: string, customerUserBelong?: { __typename?: 'CustomerUserBelongConnection', edges: Array<{ __typename?: 'CustomerUserBelongEdge', node?: { __typename?: 'CustomerUserBelong', customerUserBelongId: string, customerUserId: number, customerCode: string, customerGroup: string, deliveryDestinationCode?: string | null | undefined, deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, deliveryDestinationName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, termsAndConditions?: { __typename?: 'TermsAndConditions', termsId: string, enactmentDate: any } | null | undefined };

export type CustomerUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerUserQuery = { __typename?: 'Query', customerUser?: { __typename?: 'CustomerUser', id: string, customerUserId: string, email: string, customerUserName: string, tel?: string | null | undefined, termsOfUseVersion?: number | null | undefined, initialConfirmationDate?: any | null | undefined, updateConfirmationDate?: any | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, delFlg: string, customerUserBelong?: { __typename?: 'CustomerUserBelongConnection', edges: Array<{ __typename?: 'CustomerUserBelongEdge', node?: { __typename?: 'CustomerUserBelong', customerUserBelongId: string, customerUserId: number, customerCode: string, customerGroup: string, deliveryDestinationCode?: string | null | undefined, deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, deliveryDestinationName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, termsAndConditions?: { __typename?: 'TermsAndConditions', termsId: string, enactmentDate: any } | null | undefined } | null | undefined };

export type SearchCustomerUserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerUserFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerUserSortEnum>> | InputMaybe<CustomerUserSortEnum>>;
}>;


export type SearchCustomerUserQuery = { __typename?: 'Query', searchCustomerUser?: { __typename?: 'CustomerUserConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerUserEdge', cursor: string, node?: { __typename?: 'CustomerUser', id: string, customerUserId: string, email: string, customerUserName: string, tel?: string | null | undefined, termsOfUseVersion?: number | null | undefined, initialConfirmationDate?: any | null | undefined, updateConfirmationDate?: any | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, delFlg: string, customerUserBelong?: { __typename?: 'CustomerUserBelongConnection', edges: Array<{ __typename?: 'CustomerUserBelongEdge', node?: { __typename?: 'CustomerUserBelong', customerUserBelongId: string, customerUserId: number, customerCode: string, customerGroup: string, deliveryDestinationCode?: string | null | undefined, deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, deliveryDestinationName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, termsAndConditions?: { __typename?: 'TermsAndConditions', termsId: string, enactmentDate: any } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateCustomerUserMutationVariables = Exact<{
  input: CreateCustomerUserInput;
}>;


export type CreateCustomerUserMutation = { __typename?: 'Mutation', createCustomerUser?: { __typename?: 'CreateCustomerUserPayload', customerUser?: { __typename?: 'CustomerUser', customerUserId: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateCustomerUserMutationVariables = Exact<{
  input: UpdateCustomerUserInput;
}>;


export type UpdateCustomerUserMutation = { __typename?: 'Mutation', updateCustomerUser?: { __typename?: 'UpdateCustomerUserPayload', customerUser?: { __typename?: 'CustomerUser', customerUserId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteCustomerUserMutationVariables = Exact<{
  input: DeleteCustomerUserInput;
}>;


export type DeleteCustomerUserMutation = { __typename?: 'Mutation', deleteCustomerUser?: { __typename?: 'DeleteCustomerUserPayload', customerUser?: { __typename?: 'CustomerUser', customerUserId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeliverFieldsFragment = { __typename?: 'Deliver', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryDestinationCode: string, deliveryDestinationName: string, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, customerCode?: string | null | undefined, delFlg: string, id: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined };

export type DeliverQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeliverQuery = { __typename?: 'Query', deliver?: { __typename?: 'Deliver', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryDestinationCode: string, deliveryDestinationName: string, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, customerCode?: string | null | undefined, delFlg: string, id: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined };

export type CreateDeliverMutationVariables = Exact<{
  input: CreateDeliverInput;
}>;


export type CreateDeliverMutation = { __typename?: 'Mutation', createDeliver?: { __typename?: 'CreateDeliverPayload', deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateDeliverMutationVariables = Exact<{
  input: UpdateDeliverInput;
}>;


export type UpdateDeliverMutation = { __typename?: 'Mutation', updateDeliver?: { __typename?: 'UpdateDeliverPayload', deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteDeliverMutationVariables = Exact<{
  input: DeleteDeliverInput;
}>;


export type DeleteDeliverMutation = { __typename?: 'Mutation', deleteDeliver?: { __typename?: 'DeleteDeliverPayload', deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchDeliverQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SeachDeliverFilter>;
  sort?: InputMaybe<Array<InputMaybe<DeliverSortEnum>> | InputMaybe<DeliverSortEnum>>;
}>;


export type SearchDeliverQuery = { __typename?: 'Query', searchDeliver?: { __typename?: 'DeliverConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DeliverEdge', cursor: string, node?: { __typename?: 'Deliver', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryDestinationCode: string, deliveryDestinationName: string, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, customerCode?: string | null | undefined, delFlg: string, id: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type DemandFieldsFragment = { __typename?: 'Demand', versionUuid: string, createUserCode: string, createDate: any, createUserName: string, updateUserCode: string, updateUserName: string, updateDate: any, demandId: string, closingDate: string, demandDate: string, collectExpectedDate: string, demandCode: string, salesTaxType?: string | null | undefined, beforeDemandRemain: number, depositPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalDemandPrice: number, includedTaxTotalDemandPrice: number, currentDemandExpectRemain: number, includedTaxDemandClearingPrice?: number | null | undefined, exciseTaxTotal: number, clearingState?: string | null | undefined, closingStatusCode: string, closingTriggerId?: number | null | undefined, totalDemandFlag?: string | null | undefined, demandTradeDivision?: string | null | undefined, id: string, demandTaxDetails?: { __typename?: 'DemandTaxDetailConnection', edges: Array<{ __typename?: 'DemandTaxDetailEdge', node?: { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, demandTaxAdjustDetails?: { __typename?: 'DemandTaxAdjustDetailConnection', edges: Array<{ __typename?: 'DemandTaxAdjustDetailEdge', node?: { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerName: string, customerFuri: string } | null | undefined };

export type DemandTaxDetailFieldsFragment = { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined };

export type DemandTaxAdjustDetailFieldsFragment = { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined };

export type DemandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DemandQuery = { __typename?: 'Query', demand?: { __typename?: 'Demand', versionUuid: string, createUserCode: string, createDate: any, createUserName: string, updateUserCode: string, updateUserName: string, updateDate: any, demandId: string, closingDate: string, demandDate: string, collectExpectedDate: string, demandCode: string, salesTaxType?: string | null | undefined, beforeDemandRemain: number, depositPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalDemandPrice: number, includedTaxTotalDemandPrice: number, currentDemandExpectRemain: number, includedTaxDemandClearingPrice?: number | null | undefined, exciseTaxTotal: number, clearingState?: string | null | undefined, closingStatusCode: string, closingTriggerId?: number | null | undefined, totalDemandFlag?: string | null | undefined, demandTradeDivision?: string | null | undefined, id: string, demandTaxDetails?: { __typename?: 'DemandTaxDetailConnection', edges: Array<{ __typename?: 'DemandTaxDetailEdge', node?: { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, demandTaxAdjustDetails?: { __typename?: 'DemandTaxAdjustDetailConnection', edges: Array<{ __typename?: 'DemandTaxAdjustDetailEdge', node?: { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerName: string, customerFuri: string } | null | undefined } | null | undefined };

export type SearchCustomerDemandQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerDemandFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerSortEnum>> | InputMaybe<CustomerSortEnum>>;
}>;


export type SearchCustomerDemandQuery = { __typename?: 'Query', searchCustomerDemand?: { __typename?: 'CustomerConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerEdge', cursor: string, node?: { __typename?: 'Customer', id: string, demandCode?: string | null | undefined, customerName: string, customerFuri: string, closingDate?: any | null | undefined, latestDemandId?: number | null | undefined, createDate: any, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchDemandClosingQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandClosingFilter>;
}>;


export type SearchDemandClosingQuery = { __typename?: 'Query', searchDemandClosing?: { __typename?: 'DemandConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', cursor: string, node?: { __typename?: 'Demand', versionUuid: string, createUserCode: string, createDate: any, createUserName: string, updateUserCode: string, updateUserName: string, updateDate: any, demandId: string, closingDate: string, demandDate: string, collectExpectedDate: string, demandCode: string, salesTaxType?: string | null | undefined, beforeDemandRemain: number, depositPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalDemandPrice: number, includedTaxTotalDemandPrice: number, currentDemandExpectRemain: number, includedTaxDemandClearingPrice?: number | null | undefined, exciseTaxTotal: number, clearingState?: string | null | undefined, closingStatusCode: string, closingTriggerId?: number | null | undefined, totalDemandFlag?: string | null | undefined, demandTradeDivision?: string | null | undefined, id: string, demandTaxDetails?: { __typename?: 'DemandTaxDetailConnection', edges: Array<{ __typename?: 'DemandTaxDetailEdge', node?: { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, demandTaxAdjustDetails?: { __typename?: 'DemandTaxAdjustDetailConnection', edges: Array<{ __typename?: 'DemandTaxAdjustDetailEdge', node?: { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerName: string, customerFuri: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchDemandHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandHistoryFilter>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>> | InputMaybe<DemandSortEnum>>;
}>;


export type SearchDemandHistoryQuery = { __typename?: 'Query', searchDemandHistory?: { __typename?: 'DemandConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', cursor: string, node?: { __typename?: 'Demand', versionUuid: string, createUserCode: string, createDate: any, createUserName: string, updateUserCode: string, updateUserName: string, updateDate: any, demandId: string, closingDate: string, demandDate: string, collectExpectedDate: string, demandCode: string, salesTaxType?: string | null | undefined, beforeDemandRemain: number, depositPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalDemandPrice: number, includedTaxTotalDemandPrice: number, currentDemandExpectRemain: number, includedTaxDemandClearingPrice?: number | null | undefined, exciseTaxTotal: number, clearingState?: string | null | undefined, closingStatusCode: string, closingTriggerId?: number | null | undefined, totalDemandFlag?: string | null | undefined, demandTradeDivision?: string | null | undefined, id: string, demandTaxDetails?: { __typename?: 'DemandTaxDetailConnection', edges: Array<{ __typename?: 'DemandTaxDetailEdge', node?: { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, demandTaxAdjustDetails?: { __typename?: 'DemandTaxAdjustDetailConnection', edges: Array<{ __typename?: 'DemandTaxAdjustDetailEdge', node?: { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerName: string, customerFuri: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchDemandHistoryDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchSalesDemandDetailFilter>;
  filter2?: InputMaybe<SearchDepositDemandDetailFilter>;
  sort1?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
  sort2?: InputMaybe<Array<InputMaybe<DepositSortEnum>> | InputMaybe<DepositSortEnum>>;
}>;


export type SearchDemandHistoryDetailQuery = { __typename?: 'Query', searchSalesDemandDetail?: { __typename?: 'SalesConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, salesDate: string, customerCode: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesRemark?: string | null | undefined, deliveryOrderId?: number | null | undefined, exciseTax?: number | null | undefined, exciseTaxClearing?: number | null | undefined, closingStatusCode: string, demandId?: number | null | undefined, divisionCode: string, trustSalesDivision: string, receiveOrderId?: number | null | undefined, salesVoucherType: string, searchKeyword?: string | null | undefined, id: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, numbering: string, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderDetailNumbering?: number | null | undefined, clearingPrice?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, updateDate: any, versionUuid: string, balanceData?: number | null | undefined, delFlg: string } | null | undefined, demand?: { __typename?: 'Demand', id: string, clearingState?: string | null | undefined, salesTaxType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string } | null | undefined, salesUser?: { __typename?: 'User', id: string, userCode: string, userName: string, userType: string } | null | undefined, shipment?: { __typename?: 'Shipment', deliveryOrderId: string, receiveOrderId: number } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchDepositDemandDetail?: { __typename?: 'DepositConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DepositEdge', cursor: string, node?: { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDemandMutationVariables = Exact<{
  input: CreateDemandInput;
}>;


export type CreateDemandMutation = { __typename?: 'Mutation', createDemand?: { __typename?: 'CreateDemandPayload', demand?: { __typename?: 'Demand', demandId: string, demandCode: string } | null | undefined } | null | undefined };

export type DeleteDemandListMutationVariables = Exact<{
  input: DeleteDemandListInput;
}>;


export type DeleteDemandListMutation = { __typename?: 'Mutation', deleteDemandList?: { __typename?: 'DeleteDemandListPayload', result?: boolean | null | undefined } | null | undefined };

export type UpsertDemandTaxAdjustListMutationVariables = Exact<{
  input: UpsertDemandTaxAdjustListInput;
}>;


export type UpsertDemandTaxAdjustListMutation = { __typename?: 'Mutation', upsertDemandTaxAdjustList?: { __typename?: 'UpsertDemandTaxAdjustListPayload', demandTaxAdjustDetail?: { __typename?: 'DemandTaxAdjustDetail', demandId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteDemandTaxAdjustListMutationVariables = Exact<{
  input: DeleteDemandTaxAdjustListInput;
}>;


export type DeleteDemandTaxAdjustListMutation = { __typename?: 'Mutation', deleteDemandTaxAdjustList?: { __typename?: 'DeleteDemandTaxAdjustListPayload', demandTaxAdjustDetail?: { __typename?: 'DemandTaxAdjustDetail', demandId: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchDemandReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandReportFilter>;
  sort?: InputMaybe<Array<InputMaybe<DemandSortEnum>> | InputMaybe<DemandSortEnum>>;
}>;


export type SearchDemandReportQuery = { __typename?: 'Query', searchDemandReport?: { __typename?: 'DemandConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', node?: { __typename?: 'Demand', demandId: string, customer?: { __typename?: 'Customer', userDivisionCode: string, demandReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type DepositFieldsFragment = { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined };

export type DepositDetailFieldsFragment = { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string };

export type DepositClearingDetailFieldsFragment = { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string };

export type CreateBulkDepositResultFragment = { __typename?: 'CreateBulkDepositPayload', allResult?: boolean | null | undefined, count?: number | null | undefined, resultList?: Array<boolean | null | undefined> | null | undefined };

export type DepositQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DepositQuery = { __typename?: 'Query', deposit?: { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined };

export type SearchDepositQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositFilter>;
  sort?: InputMaybe<Array<InputMaybe<DepositSortEnum>> | InputMaybe<DepositSortEnum>>;
}>;


export type SearchDepositQuery = { __typename?: 'Query', searchDeposit?: { __typename?: 'DepositConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DepositEdge', cursor: string, node?: { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDepositMutationVariables = Exact<{
  input: CreateDepositInput;
}>;


export type CreateDepositMutation = { __typename?: 'Mutation', createDeposit?: { __typename?: 'CreateDepositPayload', deposit?: { __typename?: 'Deposit', depositId: string } | null | undefined } | null | undefined };

export type CreateBulkDepositMutationVariables = Exact<{
  input: CreateBulkDepositInput;
}>;


export type CreateBulkDepositMutation = { __typename?: 'Mutation', createBulkDeposit?: { __typename?: 'CreateBulkDepositPayload', allResult?: boolean | null | undefined, count?: number | null | undefined, resultList?: Array<boolean | null | undefined> | null | undefined } | null | undefined };

export type UpdateDepositMutationVariables = Exact<{
  input: UpdateDepositInput;
}>;


export type UpdateDepositMutation = { __typename?: 'Mutation', updateDeposit?: { __typename?: 'UpdateDepositPayload', deposit?: { __typename?: 'Deposit', depositId: string } | null | undefined } | null | undefined };

export type DeleteDepositMutationVariables = Exact<{
  input: DeleteDepositInput;
}>;


export type DeleteDepositMutation = { __typename?: 'Mutation', deleteDeposit?: { __typename?: 'DeleteDepositPayload', deposit?: { __typename?: 'Deposit', depositId: string } | null | undefined } | null | undefined };

export type SearchDemandNotClearingQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDemandNotClearingFilter>;
}>;


export type SearchDemandNotClearingQuery = { __typename?: 'Query', searchDemandNotClearing?: { __typename?: 'DemandConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', cursor: string, node?: { __typename?: 'Demand', versionUuid: string, demandId: string, demandDate: string, closingDate: string, collectExpectedDate: string, includedTaxTotalDemandPrice: number, includedTaxDemandClearingPrice?: number | null | undefined, demandTradeDivision?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchDepositListsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositFilter>;
  sort?: InputMaybe<Array<InputMaybe<DepositSortEnum>> | InputMaybe<DepositSortEnum>>;
}>;


export type SearchDepositListsQuery = { __typename?: 'Query', searchDeposit?: { __typename?: 'DepositConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DepositEdge', cursor: string, node?: { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type DepositDivisionFieldsFragment = { __typename?: 'DepositDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositDivisionCode: string, depositDivisionName: string, depositGroupCode: string, delFlg: string, id: string };

export type SearchDepositDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDepositDivisionFilter>;
  sort?: InputMaybe<Array<InputMaybe<DepositDivisionSortEnum>> | InputMaybe<DepositDivisionSortEnum>>;
}>;


export type SearchDepositDivisionQuery = { __typename?: 'Query', searchDepositDivision?: { __typename?: 'DepositDivisionConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DepositDivisionEdge', cursor: string, node?: { __typename?: 'DepositDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositDivisionCode: string, depositDivisionName: string, depositGroupCode: string, delFlg: string, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDirectPurchaseMutationVariables = Exact<{
  input: CreateDirectPurchaseInput;
}>;


export type CreateDirectPurchaseMutation = { __typename?: 'Mutation', createDirectPurchase?: { __typename?: 'CreateDirectPurchasePayload', resultDatas?: Array<{ __typename?: 'ResultData', importFlg?: boolean | null | undefined, purchaseDate?: string | null | undefined, shopCode?: string | null | undefined, shopName?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, price?: number | null | undefined, memo?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteDirectPurchaseMutationVariables = Exact<{
  input: DeleteDirectPurchaseInput;
}>;


export type DeleteDirectPurchaseMutation = { __typename?: 'Mutation', deleteDirectPurchase?: { __typename?: 'DeleteDirectPurchasePayload', purchase?: { __typename?: 'Purchase', purchaseId: string, id: string } | null | undefined } | null | undefined };

export type DirectlyPurchaseFieldsFragment = { __typename?: 'DirectlyPurchase', purchaseId: string, purchaseDate: string, closingStatusCode: string, divisionCode: string, divisionName: string, vendorCode: string, vendorName: string, taxExcludedTotal?: number | null | undefined, tenTaxExcluded?: number | null | undefined, tenTax?: number | null | undefined, eightTaxExcluded?: number | null | undefined, eightTax?: number | null | undefined, exportTaxFree?: number | null | undefined, taxIncludedTotal?: number | null | undefined, detailMemo?: string | null | undefined, versionUuid: string };

export type SearchDirectlyPurchaseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DirectlyPurchaseFilter>;
}>;


export type SearchDirectlyPurchaseQuery = { __typename?: 'Query', searchDirectlyPurchase?: { __typename?: 'DirectlyPurchaseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DirectlyPurchaseEdge', cursor: string, node?: { __typename?: 'DirectlyPurchase', purchaseId: string, purchaseDate: string, closingStatusCode: string, divisionCode: string, divisionName: string, vendorCode: string, vendorName: string, taxExcludedTotal?: number | null | undefined, tenTaxExcluded?: number | null | undefined, tenTax?: number | null | undefined, eightTaxExcluded?: number | null | undefined, eightTax?: number | null | undefined, exportTaxFree?: number | null | undefined, taxIncludedTotal?: number | null | undefined, detailMemo?: string | null | undefined, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDirectWipMutationVariables = Exact<{
  input: CreateDirectWipInput;
}>;


export type CreateDirectWipMutation = { __typename?: 'Mutation', createDirectWip?: { __typename?: 'CreateDirectWipPayload', resultDatas?: Array<{ __typename?: 'WipResultData', importFlg?: boolean | null | undefined, purchaseDate?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, taxExcluded?: number | null | undefined, tenTaxExcluded?: number | null | undefined, tenTax?: number | null | undefined, eightTaxExcluded?: number | null | undefined, eightTax?: number | null | undefined, taxIncluded?: number | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type DeleteDirectWipMutationVariables = Exact<{
  input: DeleteDirectWipInput;
}>;


export type DeleteDirectWipMutation = { __typename?: 'Mutation', deleteDirectWip?: { __typename?: 'DeleteDirectWipPayload', purchase?: { __typename?: 'Purchase', purchaseId: string, id: string } | null | undefined } | null | undefined };

export type DivisionFieldsFragment = { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string };

export type DivisionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DivisionQuery = { __typename?: 'Query', division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string } | null | undefined };

export type CreateDivisionMutationVariables = Exact<{
  input: CreateDivisionInput;
}>;


export type CreateDivisionMutation = { __typename?: 'Mutation', createDivision?: { __typename?: 'CreateDivisionPayload', division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateDivisionMutationVariables = Exact<{
  input: UpdateDivisionInput;
}>;


export type UpdateDivisionMutation = { __typename?: 'Mutation', updateDivision?: { __typename?: 'UpdateDivisionPayload', division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteDivisionMutationVariables = Exact<{
  input: DeleteDivisionInput;
}>;


export type DeleteDivisionMutation = { __typename?: 'Mutation', deleteDivision?: { __typename?: 'DeleteDivisionPayload', division?: { __typename?: 'Division', divisionCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchDivisionFilter>;
  sort?: InputMaybe<Array<InputMaybe<DivisionSortEnum>> | InputMaybe<DivisionSortEnum>>;
}>;


export type SearchDivisionQuery = { __typename?: 'Query', searchDivision?: { __typename?: 'DivisionConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DivisionEdge', cursor: string, node?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined };

export type ExchangeFieldsFragment = { __typename?: 'Exchange', id: string, divisionCode: string, numbering: string, startDate: string, endDate: string, exchangeRate: number, createDate: any, updateDate: any, versionUuid: string };

export type DivisionWithExchangeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DivisionWithExchangeQuery = { __typename?: 'Query', division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string, exchanges?: { __typename?: 'ExchangeConnection', edges: Array<{ __typename?: 'ExchangeEdge', node?: { __typename?: 'Exchange', id: string, divisionCode: string, numbering: string, startDate: string, endDate: string, exchangeRate: number, createDate: any, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchDivisionWithExchangeQueryVariables = Exact<{
  filter?: InputMaybe<SearchDivisionFilter>;
}>;


export type SearchDivisionWithExchangeQuery = { __typename?: 'Query', searchDivision?: { __typename?: 'DivisionConnection', edges: Array<{ __typename?: 'DivisionEdge', node?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string, exchanges?: { __typename?: 'ExchangeConnection', edges: Array<{ __typename?: 'ExchangeEdge', node?: { __typename?: 'Exchange', id: string, divisionCode: string, numbering: string, startDate: string, endDate: string, exchangeRate: number, createDate: any, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type DivisionFinancialDateFieldsFragment = { __typename?: 'DivisionFinancialDate', divisionCode: string, financialStage: string, targetGrossMarginRate?: number | null | undefined };

export type SearchDivisionWithDivisionFinancialDateQueryVariables = Exact<{
  filter?: InputMaybe<SearchDivisionFinancialDateFilter>;
}>;


export type SearchDivisionWithDivisionFinancialDateQuery = { __typename?: 'Query', searchDivisionFinancialDate?: { __typename?: 'DivisionFinancialDateConnection', edges: Array<{ __typename?: 'DivisionFinancialDateEdge', node?: { __typename?: 'DivisionFinancialDate', divisionCode: string, financialStage: string, targetGrossMarginRate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type DivisionDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DivisionDetailQuery = { __typename?: 'Query', division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string, windowName: string, recordHighSales?: number | null | undefined, recordHighSalesUpdateUserName?: string | null | undefined, recordHighSalesUpdateDate?: string | null | undefined, delFlg: string, createDate: any, updateUserName: string, updateDate: any, versionUuid: string, exchanges?: { __typename?: 'ExchangeConnection', edges: Array<{ __typename?: 'ExchangeEdge', node?: { __typename?: 'Exchange', id: string, divisionCode: string, numbering: string, startDate: string, endDate: string, exchangeRate: number, createDate: any, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined, divisionFinancialDate?: { __typename?: 'DivisionFinancialDateConnection', edges: Array<{ __typename?: 'DivisionFinancialDateEdge', node?: { __typename?: 'DivisionFinancialDate', divisionCode: string, financialStage: string, targetGrossMarginRate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type DivisionGradeFieldsFragment = { __typename?: 'DivisionGrades', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, totalSku?: number | null | undefined, skuOwn?: number | null | undefined, skuOthers?: number | null | undefined, totalSkuLatest?: number | null | undefined, skuLatestOwn?: number | null | undefined, skuLatestOthers?: number | null | undefined, totalSkuNew?: number | null | undefined, skuNewOwn?: number | null | undefined, skuNewOthers?: number | null | undefined, totalSkuLatestRate?: number | null | undefined, skuLatestOwnSalesRate?: number | null | undefined, totalSkuNewRate?: number | null | undefined, skuNewOwnRate?: number | null | undefined, totalSkuLatestSalesRate?: number | null | undefined, totalSkuLatestOwnRate?: number | null | undefined, totalSkuNewOwnSalesRate?: number | null | undefined, totalSkuNewSalesRate?: number | null | undefined, totalSalesCostAmountCurrent?: number | null | undefined, totalSalesCostAmount1year?: number | null | undefined, totalSalesCostAmount2year?: number | null | undefined, totalSalesAmountCurrent?: number | null | undefined, totalSalesAmount1year?: number | null | undefined, totalSalesAmount2year?: number | null | undefined, grossProfitRateCurrent?: number | null | undefined, grossProfitRate1year?: number | null | undefined, grossProfitRate2year?: number | null | undefined, costRateCurrent?: number | null | undefined, costRate1year?: number | null | undefined, costRate2year?: number | null | undefined, targetGrossMarginRate?: number | null | undefined, recordHighSales?: number | null | undefined, dioCurrent?: number | null | undefined, dio1year?: number | null | undefined, dio2year?: number | null | undefined, discontinuedProductAmountCurrent?: number | null | undefined, discontinuedProductAmount1year?: number | null | undefined, discontinuedProductAmount2year?: number | null | undefined, skuLatestOwnSales?: number | null | undefined, totalSkuNewSales?: number | null | undefined, skuNewOwnSales?: number | null | undefined, totalSkuSales?: number | null | undefined, stockCurrent?: number | null | undefined, stock1year?: number | null | undefined, stock2year?: number | null | undefined, costBetweenLastyearAndToday?: number | null | undefined, skuOwnSales?: number | null | undefined, skuLatestSales?: number | null | undefined, totalSkuLatestSales?: number | null | undefined, totalSkuLatestOwnSales?: number | null | undefined, totalSkuOwnSales?: number | null | undefined };

export type DivisionTermsFieldsFragment = { __typename?: 'DivisionTerms', current?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, currentTerm?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, previousTerm?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, twoTermsAgo?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined };

export type FetchDivisionGradesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDivisionGradesQuery = { __typename?: 'Query', divisionGrades?: Array<{ __typename?: 'DivisionGrades', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, totalSku?: number | null | undefined, skuOwn?: number | null | undefined, skuOthers?: number | null | undefined, totalSkuLatest?: number | null | undefined, skuLatestOwn?: number | null | undefined, skuLatestOthers?: number | null | undefined, totalSkuNew?: number | null | undefined, skuNewOwn?: number | null | undefined, skuNewOthers?: number | null | undefined, totalSkuLatestRate?: number | null | undefined, skuLatestOwnSalesRate?: number | null | undefined, totalSkuNewRate?: number | null | undefined, skuNewOwnRate?: number | null | undefined, totalSkuLatestSalesRate?: number | null | undefined, totalSkuLatestOwnRate?: number | null | undefined, totalSkuNewOwnSalesRate?: number | null | undefined, totalSkuNewSalesRate?: number | null | undefined, totalSalesCostAmountCurrent?: number | null | undefined, totalSalesCostAmount1year?: number | null | undefined, totalSalesCostAmount2year?: number | null | undefined, totalSalesAmountCurrent?: number | null | undefined, totalSalesAmount1year?: number | null | undefined, totalSalesAmount2year?: number | null | undefined, grossProfitRateCurrent?: number | null | undefined, grossProfitRate1year?: number | null | undefined, grossProfitRate2year?: number | null | undefined, costRateCurrent?: number | null | undefined, costRate1year?: number | null | undefined, costRate2year?: number | null | undefined, targetGrossMarginRate?: number | null | undefined, recordHighSales?: number | null | undefined, dioCurrent?: number | null | undefined, dio1year?: number | null | undefined, dio2year?: number | null | undefined, discontinuedProductAmountCurrent?: number | null | undefined, discontinuedProductAmount1year?: number | null | undefined, discontinuedProductAmount2year?: number | null | undefined, skuLatestOwnSales?: number | null | undefined, totalSkuNewSales?: number | null | undefined, skuNewOwnSales?: number | null | undefined, totalSkuSales?: number | null | undefined, stockCurrent?: number | null | undefined, stock1year?: number | null | undefined, stock2year?: number | null | undefined, costBetweenLastyearAndToday?: number | null | undefined, skuOwnSales?: number | null | undefined, skuLatestSales?: number | null | undefined, totalSkuLatestSales?: number | null | undefined, totalSkuLatestOwnSales?: number | null | undefined, totalSkuOwnSales?: number | null | undefined } | null | undefined> | null | undefined, divisionTerms?: { __typename?: 'DivisionTerms', current?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, currentTerm?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, previousTerm?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined, twoTermsAgo?: { __typename?: 'DivisionTermsFromTo', termFrom?: any | null | undefined, termTo?: any | null | undefined } | null | undefined } | null | undefined };

export type EstimateFieldsFragment = { __typename?: 'Estimate', id: string, estimateId: string, estimateDate: string, customerCode: string, provisionalCustomerName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, salesTradeDivision: string, salesTaxType: string, estimateTitle?: string | null | undefined, estimateRemark?: string | null | undefined, userCode: string, deliverPeriod?: string | null | undefined, deliverPlace?: string | null | undefined, tradeMethod?: string | null | undefined, expirationDate?: string | null | undefined, taxExcludeTotal?: number | null | undefined, estimatePriceTotal?: number | null | undefined, detailCount: number, createDate: any, createUserCode: string, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, userDivisionCode: string, userCode?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type EstimateDetailFieldsFragment = { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined };

export type EstimateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EstimateQuery = { __typename?: 'Query', estimate?: { __typename?: 'Estimate', id: string, estimateId: string, estimateDate: string, customerCode: string, provisionalCustomerName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, salesTradeDivision: string, salesTaxType: string, estimateTitle?: string | null | undefined, estimateRemark?: string | null | undefined, userCode: string, deliverPeriod?: string | null | undefined, deliverPlace?: string | null | undefined, tradeMethod?: string | null | undefined, expirationDate?: string | null | undefined, taxExcludeTotal?: number | null | undefined, estimatePriceTotal?: number | null | undefined, detailCount: number, createDate: any, createUserCode: string, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, userDivisionCode: string, userCode?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchEstimateQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchEstimateFilter>;
  sort?: InputMaybe<Array<InputMaybe<EstimateSortEnum>> | InputMaybe<EstimateSortEnum>>;
}>;


export type SearchEstimateQuery = { __typename?: 'Query', searchEstimate?: { __typename?: 'EstimateConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'EstimateEdge', cursor: string, node?: { __typename?: 'Estimate', id: string, estimateId: string, estimateDate: string, customerCode: string, provisionalCustomerName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, salesTradeDivision: string, salesTaxType: string, estimateTitle?: string | null | undefined, estimateRemark?: string | null | undefined, userCode: string, deliverPeriod?: string | null | undefined, deliverPlace?: string | null | undefined, tradeMethod?: string | null | undefined, expirationDate?: string | null | undefined, taxExcludeTotal?: number | null | undefined, estimatePriceTotal?: number | null | undefined, detailCount: number, createDate: any, createUserCode: string, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, userDivisionCode: string, userCode?: string | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type EstimateMutationFieldsFragment = { __typename?: 'Estimate', id: string, estimateId: string, customerCode: string, estimateDate: string, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateEstimateMutationVariables = Exact<{
  input: CreateEstimateInput;
}>;


export type CreateEstimateMutation = { __typename?: 'Mutation', createEstimate?: { __typename?: 'CreateEstimatePayload', estimate?: { __typename?: 'Estimate', id: string, estimateId: string, customerCode: string, estimateDate: string, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateEstimateMutationVariables = Exact<{
  input: UpdateEstimateInput;
}>;


export type UpdateEstimateMutation = { __typename?: 'Mutation', updateEstimate?: { __typename?: 'UpdateEstimatePayload', estimate?: { __typename?: 'Estimate', id: string, estimateId: string, customerCode: string, estimateDate: string, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteEstimateMutationVariables = Exact<{
  input: DeleteEstimateInput;
}>;


export type DeleteEstimateMutation = { __typename?: 'Mutation', deleteEstimate?: { __typename?: 'DeleteEstimatePayload', estimate?: { __typename?: 'Estimate', id: string, estimateId: string, customerCode: string, estimateDate: string, estimateDetails?: { __typename?: 'EstimateDetailConnection', edges: Array<{ __typename?: 'EstimateDetailEdge', node?: { __typename?: 'EstimateDetail', id: string, estimateId: string, numbering: string, receiveDetailTradeType: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type EstimateCustomerFieldsFragment = { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, balanceData?: number | null | undefined, user?: { __typename?: 'User', userName: string } | null | undefined };

export type EstimateCustomerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EstimateCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, balanceData?: number | null | undefined, user?: { __typename?: 'User', userName: string } | null | undefined } | null | undefined };

export type SearchEstimateDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchEstimateFilter>;
  sort?: InputMaybe<Array<InputMaybe<EstimateSortEnum>> | InputMaybe<EstimateSortEnum>>;
}>;


export type SearchEstimateDivisionQuery = { __typename?: 'Query', searchEstimate?: { __typename?: 'EstimateConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'EstimateEdge', cursor: string, node?: { __typename?: 'Estimate', customer?: { __typename?: 'Customer', userDivisionCode: string, salesReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchExchangeQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchExchangeQuery = { __typename?: 'Query', searchExchange?: { __typename?: 'ExchangeConnection', edges: Array<{ __typename?: 'ExchangeEdge', node?: { __typename?: 'Exchange', divisionCode: string, exchangeRate: number } | null | undefined } | null | undefined> } | null | undefined };

export type ExecuteDemandDecisionDeleteMutationVariables = Exact<{
  input: ExecuteDemandDecisionDeleteInput;
}>;


export type ExecuteDemandDecisionDeleteMutation = { __typename?: 'Mutation', executeDemandDecisionDelete?: { __typename?: 'ExecuteDemandDecisionDeletePayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string } | null | undefined } | null | undefined };

export type ExecuteDemandDecisionReceiveMutationVariables = Exact<{
  input: ExecuteDemandDecisionReceiveInput;
}>;


export type ExecuteDemandDecisionReceiveMutation = { __typename?: 'Mutation', executeDemandDecisionReceive?: { __typename?: 'ExecuteDemandDecisionReceivePayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string } | null | undefined } | null | undefined };

export type ExecutePaymentDecisionDeleteMutationVariables = Exact<{
  input: ExecutePaymentDecisionDeleteInput;
}>;


export type ExecutePaymentDecisionDeleteMutation = { __typename?: 'Mutation', executePaymentDecisionDelete?: { __typename?: 'ExecutePaymentDecisionDeletePayload', sendOrder?: { __typename?: 'SendOrder', orderId: string } | null | undefined } | null | undefined };

export type ExecutePaymentDecisionSendMutationVariables = Exact<{
  input: ExecutePaymentDecisionSendInput;
}>;


export type ExecutePaymentDecisionSendMutation = { __typename?: 'Mutation', executePaymentDecisionSend?: { __typename?: 'ExecutePaymentDecisionSendPayload', sendOrder?: { __typename?: 'SendOrder', orderId: string } | null | undefined } | null | undefined };

export type ExecuteReturnProcessSendMutationVariables = Exact<{
  input: ExecuteReturnProcessSendInput;
}>;


export type ExecuteReturnProcessSendMutation = { __typename?: 'Mutation', executeReturnProcessSend?: { __typename?: 'ExecuteReturnProcessSendPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type FinancialDateDetailFieldsFragment = { __typename?: 'SearchFinancialDateDetail', financialStage: number, minFinancialStartDate: any, maxFinancialEndDate: any };

export type SearchFinancialDateDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFinancialDateDetailQuery = { __typename?: 'Query', searchFinancialDateDetail?: { __typename?: 'SearchFinancialDateDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchFinancialDateDetailEdge', cursor: string, node?: { __typename?: 'SearchFinancialDateDetail', financialStage: number, minFinancialStartDate: any, maxFinancialEndDate: any } | null | undefined } | null | undefined> } | null | undefined };

export type CreateFkorderInformationAttachmentMutationVariables = Exact<{
  input: CreateFkorderInformationAttachmentInput;
}>;


export type CreateFkorderInformationAttachmentMutation = { __typename?: 'Mutation', createFkorderInformationAttachment?: { __typename?: 'CreateFkorderInformationAttachmentPayload', url: string, s3Key: string } | null | undefined };

export type FkorderPublicationQueryVariables = Exact<{ [key: string]: never; }>;


export type FkorderPublicationQuery = { __typename?: 'Query', fkorderPublication?: Array<{ __typename?: 'FkorderPublication', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, lastUpdated?: string | null | undefined, lastPublicated?: string | null | undefined, publicationStatus?: string | null | undefined } | null | undefined> | null | undefined };

export type SyncFkorderPublicationMutationVariables = Exact<{
  input: SyncFkorderPublicationInput;
}>;


export type SyncFkorderPublicationMutation = { __typename?: 'Mutation', syncFkorderPublication?: { __typename?: 'SyncFkorderPublicationPayload', divisionCode: string } | null | undefined };

export type SyncFkorderPublicationPreAndPublicMutationVariables = Exact<{
  input: SyncFkorderPublicationPreAndPublicInput;
}>;


export type SyncFkorderPublicationPreAndPublicMutation = { __typename?: 'Mutation', syncFkorderPublicationPreAndPublic?: { __typename?: 'SyncFkorderPublicationPreAndPublicPayload', divisionCode: string } | null | undefined };

export type ImportSendOrderRequestMutationVariables = Exact<{
  input: ImportSendOrderRequestInput;
}>;


export type ImportSendOrderRequestMutation = { __typename?: 'Mutation', importSendOrderRequest?: { __typename?: 'ImportSendOrderRequestPayload', sendOrder?: Array<{ __typename?: 'SendOrder', orderId: string } | null | undefined> | null | undefined } | null | undefined };

export type InformationFieldsFragment = { __typename?: 'FkorderInformation', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, informationId: string, divisionCode: string, informationType: string, title: string, postedAt: string, publicationFrom: string, publicationTo: string, body: string, deliveryStatus: string, versionUuid: string, fkorderInformationAttachments?: { __typename?: 'FkorderInformationAttachmentConnection', edges: Array<{ __typename?: 'FkorderInformationAttachmentEdge', node?: { __typename?: 'FkorderInformationAttachment', attachmentId: string, filename: string, path: string, presignedUrl?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type FkorderInformationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FkorderInformationQuery = { __typename?: 'Query', fkorderInformation?: { __typename?: 'FkorderInformation', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, informationId: string, divisionCode: string, informationType: string, title: string, postedAt: string, publicationFrom: string, publicationTo: string, body: string, deliveryStatus: string, versionUuid: string, fkorderInformationAttachments?: { __typename?: 'FkorderInformationAttachmentConnection', edges: Array<{ __typename?: 'FkorderInformationAttachmentEdge', node?: { __typename?: 'FkorderInformationAttachment', attachmentId: string, filename: string, path: string, presignedUrl?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchFkorderInformationQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchFkorderInformationFilter>;
  sort?: InputMaybe<Array<InputMaybe<FkorderInformationSortEnum>> | InputMaybe<FkorderInformationSortEnum>>;
}>;


export type SearchFkorderInformationQuery = { __typename?: 'Query', searchFkorderInformation?: { __typename?: 'FkorderInformationConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'FkorderInformationEdge', cursor: string, node?: { __typename?: 'FkorderInformation', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, informationId: string, divisionCode: string, informationType: string, title: string, postedAt: string, publicationFrom: string, publicationTo: string, body: string, deliveryStatus: string, versionUuid: string, fkorderInformationAttachments?: { __typename?: 'FkorderInformationAttachmentConnection', edges: Array<{ __typename?: 'FkorderInformationAttachmentEdge', node?: { __typename?: 'FkorderInformationAttachment', attachmentId: string, filename: string, path: string, presignedUrl?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateFKorderInformationMutationVariables = Exact<{
  input: CreateFkorderInformationInput;
}>;


export type CreateFKorderInformationMutation = { __typename?: 'Mutation', createFkorderInformation?: { __typename?: 'CreateFkorderInformationPayload', fkorderInformation?: { __typename?: 'FkorderInformation', informationId: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateFKorderInformationMutationVariables = Exact<{
  input: UpdateFkorderInformationInput;
}>;


export type UpdateFKorderInformationMutation = { __typename?: 'Mutation', updateFkorderInformation?: { __typename?: 'UpdateFkorderInformationPayload', fkorderInformation?: { __typename?: 'FkorderInformation', informationId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteFkorderInformationMutationVariables = Exact<{
  input: DeleteFkorderInformationInput;
}>;


export type DeleteFkorderInformationMutation = { __typename?: 'Mutation', deleteFkorderInformation?: { __typename?: 'DeleteFkorderInformationPayload', fkorderInformation?: { __typename?: 'FkorderInformation', informationId: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchInternalTransactionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInternalTransactionFilter>;
}>;


export type SearchInternalTransactionQuery = { __typename?: 'Query', searchInternalTransaction?: { __typename?: 'SearchInternalTransactionConnection', edges: Array<{ __typename?: 'SearchInternalTransactionEdge', node?: { __typename?: 'SearchInternalTransaction', tradeDate?: string | null | undefined, tradeHistoryType?: string | null | undefined, tradeId?: string | null | undefined, inputDivisionCode?: string | null | undefined, inputDivisionName?: string | null | undefined, outputDivisionCode?: string | null | undefined, outputDivisionName?: string | null | undefined, inputJanCode?: string | null | undefined, inputAttributeName?: string | null | undefined, quantity?: number | null | undefined, inputSalesUnitPrice?: number | null | undefined, inputPrice?: number | null | undefined, outputJanCode?: string | null | undefined, outputAttributeName?: string | null | undefined, outputSalesUnitPrice?: number | null | undefined, outputPrice?: number | null | undefined, detailMemo?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, estimateId?: string | null | undefined, receiveOrderId?: string | null | undefined, deliveryOrderId?: string | null | undefined, warehouseMoveId?: string | null | undefined, adjustId?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type InventoryFieldsFragment = { __typename?: 'Inventory', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, inventoryBaseFrom: string, inventoryBaseTo: string, inventoryName: string, inventoryFinishFlg: string, id: string, inventoryDivision?: { __typename?: 'InventoryDivisionConnection', edges: Array<{ __typename?: 'InventoryDivisionEdge', node?: { __typename?: 'InventoryDivision', updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, divisionCode: string, inventoryDivisionStatus: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type InventoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InventoryQuery = { __typename?: 'Query', inventory?: { __typename?: 'Inventory', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, inventoryBaseFrom: string, inventoryBaseTo: string, inventoryName: string, inventoryFinishFlg: string, id: string, inventoryDivision?: { __typename?: 'InventoryDivisionConnection', edges: Array<{ __typename?: 'InventoryDivisionEdge', node?: { __typename?: 'InventoryDivision', updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, divisionCode: string, inventoryDivisionStatus: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchInventoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryFilter>;
  sort?: InputMaybe<Array<InputMaybe<InventorySortEnum>> | InputMaybe<InventorySortEnum>>;
}>;


export type SearchInventoryQuery = { __typename?: 'Query', searchInventory?: { __typename?: 'InventoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'InventoryEdge', cursor: string, node?: { __typename?: 'Inventory', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, inventoryBaseFrom: string, inventoryBaseTo: string, inventoryName: string, inventoryFinishFlg: string, id: string, inventoryDivision?: { __typename?: 'InventoryDivisionConnection', edges: Array<{ __typename?: 'InventoryDivisionEdge', node?: { __typename?: 'InventoryDivision', updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, divisionCode: string, inventoryDivisionStatus: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateInventoryMutationVariables = Exact<{
  input: CreateInventoryInput;
}>;


export type CreateInventoryMutation = { __typename?: 'Mutation', createInventory?: { __typename?: 'CreateInventoryPayload', inventory?: { __typename?: 'Inventory', versionUuid: string, inventoryId: string } | null | undefined } | null | undefined };

export type UpdateInventoryMutationVariables = Exact<{
  input: UpdateInventoryInput;
}>;


export type UpdateInventoryMutation = { __typename?: 'Mutation', updateInventory?: { __typename?: 'UpdateInventoryPayload', inventory?: { __typename?: 'Inventory', versionUuid: string, inventoryId: string } | null | undefined } | null | undefined };

export type DeleteInventoryMutationVariables = Exact<{
  input: DeleteInventoryInput;
}>;


export type DeleteInventoryMutation = { __typename?: 'Mutation', deleteInventory?: { __typename?: 'DeleteInventoryPayload', inventory?: { __typename?: 'Inventory', versionUuid: string, inventoryId: string } | null | undefined } | null | undefined };

export type FinalizeInventoryDivisionMutationVariables = Exact<{
  input: FinalizeInventoryDivisionInput;
}>;


export type FinalizeInventoryDivisionMutation = { __typename?: 'Mutation', finalizeInventoryDivision?: { __typename?: 'FinalizeInventoryDivisionPayload', inventoryId?: number | null | undefined } | null | undefined };

export type ImportInventoryDetailMutationVariables = Exact<{
  input: ImportInventoryDetailInput;
}>;


export type ImportInventoryDetailMutation = { __typename?: 'Mutation', importInventoryDetail?: { __typename?: 'ImportInventoryDetailPayload', inventoryId?: number | null | undefined } | null | undefined };

export type SearchInventoryDetailCustomQueryVariables = Exact<{
  filter?: InputMaybe<InventoryDetailCustomFilter>;
}>;


export type SearchInventoryDetailCustomQuery = { __typename?: 'Query', searchInventoryDetailCustom?: { __typename?: 'InventoryDetailCustom', result: string } | null | undefined };

export type InventoryDivisionFieldsFragment = { __typename?: 'InventoryDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, divisionCode: string, inventoryDivisionStatus: string, id: string, inventory?: { __typename?: 'Inventory', inventoryBaseFrom: string, inventoryBaseTo: string, inventoryName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined };

export type SearchInventoryDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInventoryDivisionFilter>;
  sort?: InputMaybe<Array<InputMaybe<InventoryDivisionSortEnum>> | InputMaybe<InventoryDivisionSortEnum>>;
}>;


export type SearchInventoryDivisionQuery = { __typename?: 'Query', searchInventoryDivision?: { __typename?: 'InventoryDivisionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'InventoryDivisionEdge', cursor: string, node?: { __typename?: 'InventoryDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, inventoryId: string, divisionCode: string, inventoryDivisionStatus: string, id: string, inventory?: { __typename?: 'Inventory', inventoryBaseFrom: string, inventoryBaseTo: string, inventoryName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchLotGroupProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<LotGroupProductFilter>;
}>;


export type SearchLotGroupProductQuery = { __typename?: 'Query', searchLotGroupProduct?: { __typename?: 'LotGroupProductConnection', edges: Array<{ __typename?: 'LotGroupProductEdge', node?: { __typename?: 'LotGroupProduct', lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, janCode: string, productCode: string, productName: string, attr1?: string | null | undefined, attr2?: string | null | undefined, attributeName: string } | null | undefined } | null | undefined> } | null | undefined };

export type AllSearchSendOrderLotQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type AllSearchSendOrderLotQuery = { __typename?: 'Query', searchSendOrderLot?: { __typename?: 'SendOrderLotConnection', totalCount?: number | null | undefined, edges: Array<{ __typename?: 'SendOrderLotEdge', cursor: string, node?: { __typename?: 'SendOrderLot', lotGroupCode: string, lotGroupName: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetNotificationQueryVariables = Exact<{
  userCode: Scalars['String'];
}>;


export type GetNotificationQuery = { __typename?: 'Query', getNotification?: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'Notification', no?: string | null | undefined, type?: string | null | undefined, subject?: string | null | undefined, message?: string | null | undefined, createDate?: any | null | undefined, updateDate?: any | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchOrderNameQueryVariables = Exact<{
  filter?: InputMaybe<SearchOrderNameFilter>;
}>;


export type SearchOrderNameQuery = { __typename?: 'Query', searchOrderName?: { __typename?: 'SearchOrderName', userName?: string | null | undefined } | null | undefined };

export type ReceiveRemainByProductFieldsFragment = { __typename?: 'SearchReceiveRemainByProduct', deliveryDate: any, divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number, receiveOrderId: number };

export type SearchReceiveRemainByProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveRemainByProductFilter>;
}>;


export type SearchReceiveRemainByProductQuery = { __typename?: 'Query', searchReceiveRemainByProduct?: { __typename?: 'SearchReceiveRemainByProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchReceiveRemainByProductEdge', cursor: string, node?: { __typename?: 'SearchReceiveRemainByProduct', deliveryDate: any, divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number, receiveOrderId: number } | null | undefined } | null | undefined> } | null | undefined };

export type SendRemainByProductFieldsFragment = { __typename?: 'SearchSendRemainByProduct', deliveryDate?: any | null | undefined, divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number, orderId: number };

export type SearchSendRemainByProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendRemainByProductFilter>;
}>;


export type SearchSendRemainByProductQuery = { __typename?: 'Query', searchSendRemainByProduct?: { __typename?: 'SearchSendRemainByProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchSendRemainByProductEdge', cursor: string, node?: { __typename?: 'SearchSendRemainByProduct', deliveryDate?: any | null | undefined, divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number, orderId: number } | null | undefined } | null | undefined> } | null | undefined };

export type SalesFieldsForOutsourcerSalesFragment = { __typename?: 'Sales', id: string, versionUuid: string, createUserCode: string, createUserName: string, salesId: string, salesDate: string, customerCode: string, salesRemark?: string | null | undefined, salesTaxType: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SalesDetailFieldsForOutsourcerSalesFragment = { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined };

export type OutsourcerSalesFromIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OutsourcerSalesFromIdQuery = { __typename?: 'Query', sales?: { __typename?: 'Sales', id: string, versionUuid: string, createUserCode: string, createUserName: string, salesId: string, salesDate: string, customerCode: string, salesRemark?: string | null | undefined, salesTaxType: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type OutsourcerSalesMutationFieldsFragment = { __typename?: 'Sales', id: string, salesId: string, customerCode: string, salesDate: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateOutsourcerSalesMutationVariables = Exact<{
  input: CreateOutsourcerSalesInput;
}>;


export type CreateOutsourcerSalesMutation = { __typename?: 'Mutation', createOutsourcerSales?: { __typename?: 'CreateOutsourcerSalesPayload', sales?: { __typename?: 'Sales', id: string, salesId: string, customerCode: string, salesDate: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateOutsourcerSalesMutationVariables = Exact<{
  input: UpdateOutsourcerSalesInput;
}>;


export type UpdateOutsourcerSalesMutation = { __typename?: 'Mutation', updateOutsourcerSales?: { __typename?: 'UpdateOutsourcerSalesPayload', sales?: { __typename?: 'Sales', id: string, salesId: string, customerCode: string, salesDate: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteOutsourcerSalesMutationVariables = Exact<{
  input: DeleteOutsourcerSalesInput;
}>;


export type DeleteOutsourcerSalesMutation = { __typename?: 'Mutation', deleteOutsourcerSales?: { __typename?: 'DeleteOutsourcerSalesPayload', sales?: { __typename?: 'Sales', id: string, salesId: string, customerCode: string, salesDate: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', id: string, salesId: string, versionUuid: string, numbering: string, frontNumbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type CustomerFieldsForOutsourcerSalesFragment = { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTaxType?: string | null | undefined, ratio?: number | null | undefined, customerUser?: string | null | undefined, userDivisionCode: string, inventoryControlUnit: string };

export type SearchCustomerForOutsourcerSalesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchCustomerForOutsourcerSalesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTaxType?: string | null | undefined, ratio?: number | null | undefined, customerUser?: string | null | undefined, userDivisionCode: string, inventoryControlUnit: string } | null | undefined };

export type PartialQueryDataFieldsFragment = { __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any };

export type GetPartialQueryByProductQueryVariables = Exact<{
  filter?: InputMaybe<PartialQueryByProductFilter>;
}>;


export type GetPartialQueryByProductQuery = { __typename?: 'Query', partialQueryByProduct?: { __typename?: 'PartialQueryByProduct', existsTrade: boolean, terms: Array<any | null | undefined>, initialStock: any, initialOrder: any, initialRemain: any, currentInitialRemain: any, results: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined>, current: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> } | null | undefined };

export type GetPartialQueryByLotGroupQueryVariables = Exact<{
  filter?: InputMaybe<PartialQueryByLotGroupFilter>;
}>;


export type GetPartialQueryByLotGroupQuery = { __typename?: 'Query', partialQueryByLotGroup?: { __typename?: 'PartialQueryByLotGroup', existsTrade: boolean, terms: Array<any | null | undefined>, productCodes: Array<string | null | undefined>, initialStock: Array<any | null | undefined>, initialOrder: Array<any | null | undefined>, initialRemain: Array<any | null | undefined>, currentInitialRemain: Array<any | null | undefined>, products: Array<{ __typename?: 'PartialQueryByLotGroupProduct', productCode: string, productName: string } | null | undefined>, results?: { __typename?: 'PartialQueryByLotGroupResult', arrivalP3?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, arrivalP2?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, arrivalP1?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentP3?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentP2?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentP1?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, disposeP3?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, disposeP2?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, disposeP1?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentdisposeP3?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentdisposeP2?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentdisposeP1?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined } | null | undefined, current?: { __typename?: 'PartialQueryByLotGroupCurrent', shipmentBefore?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, shipmentFix?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, stock?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, sendorderSum?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, arrivalSum?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, sendorder?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, sendorderRemain?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined, consumption?: Array<{ __typename?: 'PartialQueryData', type: string, label: string, productCode: string, TM1: any, TM2: any, TM3: any, TM4: any, TM5: any, TM6: any, TM7: any, TM8: any, TM9: any, TM10: any, TM11: any, TM12: any } | null | undefined> | null | undefined } | null | undefined } | null | undefined };

export type SearchPayableBalanceListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPayableBalanceListFilter>;
}>;


export type SearchPayableBalanceListQuery = { __typename?: 'Query', searchPayableBalanceList?: { __typename?: 'PayableBalanceConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PayableBalanceEdge', cursor: string, node?: { __typename?: 'PayableBalance', vendorCode?: string | null | undefined, vendorName?: string | null | undefined, vendorFuri?: string | null | undefined, beforePayableBalance?: number | null | undefined, payablePrice?: number | null | undefined, expirationDate?: number | null | undefined, purchasePrice?: number | null | undefined, exciseTax10par?: number | null | undefined, exciseTax8par?: number | null | undefined, monthBalance?: number | null | undefined, cash?: number | null | undefined, transfer?: number | null | undefined, draft?: number | null | undefined, otherPayment?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type PaymentFieldsFragment = { __typename?: 'Payment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentId: string, closingDate: string, paymentExpectedDate: string, paymentDate: string, vendorCode: string, vendorTaxType: string, beforePaymentRemain: number, payPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalPaymentPrice: number, includedTaxTotalPaymentPrice: number, includedTaxTotalPaymentPriceWithAdjust: number, includedTaxPaymentClearingPrice: number, exciseTaxTotal: number, currentPaymentExpectRemain: number, currentPaymentPrice?: number | null | undefined, differencePrice?: number | null | undefined, offsetPrice?: number | null | undefined, depositPrice?: number | null | undefined, transferFee?: number | null | undefined, currentTransferPrice?: number | null | undefined, paymentMemo?: string | null | undefined, withdrawalState: string, closingStatusCode: string, currentTotalPurchasePrice?: number | null | undefined, currentTotalImportPrice?: number | null | undefined, currentTotalProgressPrice?: number | null | undefined, automaticPayId?: number | null | undefined, id: string, paymentTaxDetails?: { __typename?: 'PaymentTaxDetailConnection', edges: Array<{ __typename?: 'PaymentTaxDetailEdge', node?: { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, paymentTaxAdjustDetails?: { __typename?: 'PaymentTaxAdjustDetailConnection', edges: Array<{ __typename?: 'PaymentTaxAdjustDetailEdge', node?: { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined, automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined };

export type PaymentTaxDetailFieldsFragment = { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined };

export type PaymentTaxAdjustDetailFieldsFragment = { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined };

export type SearchVendorPaymentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorPaymentFilter>;
  sort?: InputMaybe<Array<InputMaybe<VendorSortEnum>> | InputMaybe<VendorSortEnum>>;
}>;


export type SearchVendorPaymentQuery = { __typename?: 'Query', searchVendorPayment?: { __typename?: 'VendorConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'VendorEdge', cursor: string, node?: { __typename?: 'Vendor', id: string, vendorCode: string, vendorName: string, vendorFuri: string, closingDate?: any | null | undefined, createDate: any, updateDate: any, versionUuid: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchClosedPaymentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchClosedPaymentFilter>;
}>;


export type SearchClosedPaymentQuery = { __typename?: 'Query', searchClosedPayment?: { __typename?: 'PaymentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node?: { __typename?: 'Payment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentId: string, closingDate: string, paymentExpectedDate: string, paymentDate: string, vendorCode: string, vendorTaxType: string, beforePaymentRemain: number, payPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalPaymentPrice: number, includedTaxTotalPaymentPrice: number, includedTaxTotalPaymentPriceWithAdjust: number, includedTaxPaymentClearingPrice: number, exciseTaxTotal: number, currentPaymentExpectRemain: number, currentPaymentPrice?: number | null | undefined, differencePrice?: number | null | undefined, offsetPrice?: number | null | undefined, depositPrice?: number | null | undefined, transferFee?: number | null | undefined, currentTransferPrice?: number | null | undefined, paymentMemo?: string | null | undefined, withdrawalState: string, closingStatusCode: string, currentTotalPurchasePrice?: number | null | undefined, currentTotalImportPrice?: number | null | undefined, currentTotalProgressPrice?: number | null | undefined, automaticPayId?: number | null | undefined, id: string, paymentTaxDetails?: { __typename?: 'PaymentTaxDetailConnection', edges: Array<{ __typename?: 'PaymentTaxDetailEdge', node?: { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, paymentTaxAdjustDetails?: { __typename?: 'PaymentTaxAdjustDetailConnection', edges: Array<{ __typename?: 'PaymentTaxAdjustDetailEdge', node?: { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined, automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type PaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentId: string, closingDate: string, paymentExpectedDate: string, paymentDate: string, vendorCode: string, vendorTaxType: string, beforePaymentRemain: number, payPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalPaymentPrice: number, includedTaxTotalPaymentPrice: number, includedTaxTotalPaymentPriceWithAdjust: number, includedTaxPaymentClearingPrice: number, exciseTaxTotal: number, currentPaymentExpectRemain: number, currentPaymentPrice?: number | null | undefined, differencePrice?: number | null | undefined, offsetPrice?: number | null | undefined, depositPrice?: number | null | undefined, transferFee?: number | null | undefined, currentTransferPrice?: number | null | undefined, paymentMemo?: string | null | undefined, withdrawalState: string, closingStatusCode: string, currentTotalPurchasePrice?: number | null | undefined, currentTotalImportPrice?: number | null | undefined, currentTotalProgressPrice?: number | null | undefined, automaticPayId?: number | null | undefined, id: string, paymentTaxDetails?: { __typename?: 'PaymentTaxDetailConnection', edges: Array<{ __typename?: 'PaymentTaxDetailEdge', node?: { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, paymentTaxAdjustDetails?: { __typename?: 'PaymentTaxAdjustDetailConnection', edges: Array<{ __typename?: 'PaymentTaxAdjustDetailEdge', node?: { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined, automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined } | null | undefined };

export type SearchPaymentHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPaymentHistoryFilter>;
  sort?: InputMaybe<Array<InputMaybe<PaymentSortEnum>> | InputMaybe<PaymentSortEnum>>;
}>;


export type SearchPaymentHistoryQuery = { __typename?: 'Query', searchPaymentHistory?: { __typename?: 'PaymentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node?: { __typename?: 'Payment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentId: string, closingDate: string, paymentExpectedDate: string, paymentDate: string, vendorCode: string, vendorTaxType: string, beforePaymentRemain: number, payPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalPaymentPrice: number, includedTaxTotalPaymentPrice: number, includedTaxTotalPaymentPriceWithAdjust: number, includedTaxPaymentClearingPrice: number, exciseTaxTotal: number, currentPaymentExpectRemain: number, currentPaymentPrice?: number | null | undefined, differencePrice?: number | null | undefined, offsetPrice?: number | null | undefined, depositPrice?: number | null | undefined, transferFee?: number | null | undefined, currentTransferPrice?: number | null | undefined, paymentMemo?: string | null | undefined, withdrawalState: string, closingStatusCode: string, currentTotalPurchasePrice?: number | null | undefined, currentTotalImportPrice?: number | null | undefined, currentTotalProgressPrice?: number | null | undefined, automaticPayId?: number | null | undefined, id: string, paymentTaxDetails?: { __typename?: 'PaymentTaxDetailConnection', edges: Array<{ __typename?: 'PaymentTaxDetailEdge', node?: { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, paymentTaxAdjustDetails?: { __typename?: 'PaymentTaxAdjustDetailConnection', edges: Array<{ __typename?: 'PaymentTaxAdjustDetailEdge', node?: { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined, automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchPaymentHistoryDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchPurchasePaymentDetailFilter>;
  filter2?: InputMaybe<SearchWithdrawalPaymentDetailFilter>;
  sort1?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>> | InputMaybe<PurchaseSortEnum>>;
  sort2?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>> | InputMaybe<WithdrawalSortEnum>>;
}>;


export type SearchPaymentHistoryDetailQuery = { __typename?: 'Query', searchPurchasePaymentDetail?: { __typename?: 'PurchaseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, purchaseDate: string, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, arrivalId?: number | null | undefined, taxExcludedTotal?: number | null | undefined, taxIncludedTotal?: number | null | undefined, totalDollar?: number | null | undefined, closingStatusCode: string, paymentId?: number | null | undefined, purchaseVoucherType: string, orderId?: number | null | undefined, id: string, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, numbering: string, purchaseTradeTypeCode: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, arrivalDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, payment?: { __typename?: 'Payment', id: string, withdrawalState: string, vendorTaxType: string } | null | undefined, arrival?: { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined } | null | undefined, arrivalTaxDetails?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, arrivalTaxDetailsPurchase?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchWithdrawalPaymentDetail?: { __typename?: 'WithdrawalConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WithdrawalEdge', cursor: string, node?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'CreatePaymentPayload', payment?: { __typename?: 'Payment', paymentId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeletePaymentMutationVariables = Exact<{
  input: DeletePaymentInput;
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment?: { __typename?: 'DeletePaymentPayload', payment?: { __typename?: 'Payment', paymentId: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpsertPaymentTaxAdjustListMutationVariables = Exact<{
  input: UpsertPaymentTaxAdjustListInput;
}>;


export type UpsertPaymentTaxAdjustListMutation = { __typename?: 'Mutation', upsertPaymentTaxAdjustList?: { __typename?: 'UpsertPaymentTaxAdjustListPayload', paymentTaxAdjustDetail?: { __typename?: 'PaymentTaxAdjustDetail', paymentId: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeletePaymentTaxAdjustListMutationVariables = Exact<{
  input: DeletePaymentTaxAdjustListInput;
}>;


export type DeletePaymentTaxAdjustListMutation = { __typename?: 'Mutation', deletePaymentTaxAdjustList?: { __typename?: 'DeletePaymentTaxAdjustListPayload', paymentTaxAdjustDetail?: { __typename?: 'PaymentTaxAdjustDetail', paymentId: string, versionUuid: string } | null | undefined } | null | undefined };

export type PaymentDivisionFieldsFragment = { __typename?: 'PaymentDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentDivisionCode: string, paymentDivisionName: string, paymentGroupCode: string, delFlg: string, id: string };

export type SearchPaymentDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPaymentDivisionFilter>;
  sort?: InputMaybe<Array<InputMaybe<PaymentDivisionSortEnum>> | InputMaybe<PaymentDivisionSortEnum>>;
}>;


export type SearchPaymentDivisionQuery = { __typename?: 'Query', searchPaymentDivision?: { __typename?: 'PaymentDivisionConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PaymentDivisionEdge', cursor: string, node?: { __typename?: 'PaymentDivision', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentDivisionCode: string, paymentDivisionName: string, paymentGroupCode: string, delFlg: string, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type GetPlannigDesignUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannigDesignUserQuery = { __typename?: 'Query', allPlanningUser?: { __typename?: 'PlanningUserConnection', edges: Array<{ __typename?: 'PlanningUserEdge', node?: { __typename?: 'PlanningUser', planningUserCode: string, planningUserName: string, delFlg: string } | null | undefined } | null | undefined> } | null | undefined, allDesignUser?: { __typename?: 'DesignUserConnection', edges: Array<{ __typename?: 'DesignUserEdge', node?: { __typename?: 'DesignUser', designUserCode: string, designUserName: string, delFlg: string } | null | undefined } | null | undefined> } | null | undefined };

export type EstimatePrintMutationVariables = Exact<{
  input: EstimatePrintInput;
}>;


export type EstimatePrintMutation = { __typename?: 'Mutation', estimatePrint?: { __typename?: 'EstimatePrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type SearchReportLayoutQueryVariables = Exact<{
  reportLayoutDivision: Scalars['String'];
  reportLayoutTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SearchReportLayoutQuery = { __typename?: 'Query', searchReportLayout?: { __typename?: 'ReportLayoutConnection', edges: Array<{ __typename?: 'ReportLayoutEdge', node?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string, offsetFlg: string, offsetX: number, offsetY: number } | null | undefined } | null | undefined> } | null | undefined };

export type DemandPrintMutationVariables = Exact<{
  input: DemandPrintInput;
}>;


export type DemandPrintMutation = { __typename?: 'Mutation', demandPrint?: { __typename?: 'DemandPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type BulkDemandPrintMutationVariables = Exact<{
  input: BulkDemandPrintInput;
}>;


export type BulkDemandPrintMutation = { __typename?: 'Mutation', bulkDemandPrint?: { __typename?: 'BulkDemandPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined, base64?: string | null | undefined } | null | undefined };

export type ReceiveOrderPrintMutationVariables = Exact<{
  input: ReceiveOrderPrintInput;
}>;


export type ReceiveOrderPrintMutation = { __typename?: 'Mutation', receiveOrderPrint?: { __typename?: 'ReceiveOrderPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type SaleVoucherPrintMutationVariables = Exact<{
  input: SaleVoucherPrintInput;
}>;


export type SaleVoucherPrintMutation = { __typename?: 'Mutation', saleVoucherPrint?: { __typename?: 'SaleVoucherPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type SendOrderPrintMutationVariables = Exact<{
  input: SendOrderPrintInput;
}>;


export type SendOrderPrintMutation = { __typename?: 'Mutation', sendOrderPrint?: { __typename?: 'SendOrderPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type TrustSalesPrintMutationVariables = Exact<{
  input: TrustSaleVoucherPrintInput;
}>;


export type TrustSalesPrintMutation = { __typename?: 'Mutation', trustSalesPrint?: { __typename?: 'TrustSaleVoucherPrintPayload', location?: string | null | undefined, artifactId?: string | null | undefined, pages?: number | null | undefined } | null | undefined };

export type GetSvfAccessTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSvfAccessTokenQuery = { __typename?: 'Query', svfAccessToken?: string | null | undefined };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', versionUuid: string, uniqueCode: string, janCode: string, productName: string, productFuri?: string | null | undefined, unitCode?: string | null | undefined, receiveOrderLot?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined, purchaseOrderLeadTime?: number | null | undefined, vendorCode?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, componentDivision?: string | null | undefined, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, clothGroup?: string | null | undefined, material?: string | null | undefined, inventoryControlFlg?: string | null | undefined, notIncludedSku: string, planningUserCode?: string | null | undefined, designUserCode?: string | null | undefined, tags?: any | null | undefined, delFlg: string, updateDate: any, productVariants?: { __typename?: 'ProductVariantConnection', edges: Array<{ __typename?: 'ProductVariantEdge', node?: { __typename?: 'ProductVariant', productCode: string, uniqueCode: string, divisionCode: string, attrNo: number, branchNumber: number, attributeName?: string | null | undefined, divisionStandardStock?: number | null | undefined, purchaseOrderStandardStock?: number | null | undefined, baseStockQuantity?: number | null | undefined, lotGroupCode?: number | null | undefined, minimumLot?: number | null | undefined, firstArrivalDate?: string | null | undefined, fcCode1?: string | null | undefined, fcCode2?: string | null | undefined, fcCode3?: string | null | undefined, fcCodeBranchNumber1?: string | null | undefined, fcCodeBranchNumber2?: string | null | undefined, fcCodeBranchNumber3?: string | null | undefined, productAttrMemo?: string | null | undefined, productBodySize?: string | null | undefined, productBodyWeight?: string | null | undefined, productPackageSize?: string | null | undefined, productPackageWeight?: string | null | undefined, innerCartonSize?: string | null | undefined, innerCartonWeight?: string | null | undefined, innerCartonUnit?: number | null | undefined, outerCartonWidth?: number | null | undefined, outerCartonHeight?: number | null | undefined, outerCartonDept?: number | null | undefined, outerCartonWeight?: string | null | undefined, outerCartonUnit?: number | null | undefined, attr1?: string | null | undefined, attr2?: string | null | undefined, discontinueFlg: string, delFlg: string, publicationOption?: string | null | undefined, productImage1?: string | null | undefined, productImage2?: string | null | undefined, productImage3?: string | null | undefined, productImage4?: string | null | undefined, productImage5?: string | null | undefined, productImage6?: string | null | undefined, endOfSalesDate?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupId: string, productGroupCode: string, productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupId: string, productGroupCode: string, productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupId: string, productGroupCode: string, productGroupName: string } | null | undefined, productPrice?: { __typename?: 'ProductPriceConnection', edges: Array<{ __typename?: 'ProductPriceEdge', node?: { __typename?: 'ProductPrice', uniqueCode: string, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate: string, endDate: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProductPayload', product?: { __typename?: 'Product', uniqueCode: string, janCode: string } | null | undefined } | null | undefined };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'UpdateProductPayload', product?: { __typename?: 'Product', uniqueCode: string } | null | undefined } | null | undefined };

export type DeleteProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: { __typename?: 'DeleteProductPayload', product?: { __typename?: 'Product', uniqueCode: string } | null | undefined } | null | undefined };

export type SearchProductPriceQueryVariables = Exact<{
  filter?: InputMaybe<SearchProductPriceFilter>;
}>;


export type SearchProductPriceQuery = { __typename?: 'Query', searchProductPrice?: { __typename?: 'ProductPriceConnection', edges: Array<{ __typename?: 'ProductPriceEdge', node?: { __typename?: 'ProductPrice', uniqueCode: string, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate: string, endDate: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchProductPriceFromTargetDateQueryVariables = Exact<{
  filter?: InputMaybe<SearchProductPriceFromTargetDateFilter>;
}>;


export type SearchProductPriceFromTargetDateQuery = { __typename?: 'Query', searchProductPriceFromTargetDate?: { __typename?: 'ProductPriceConnection', edges: Array<{ __typename?: 'ProductPriceEdge', node?: { __typename?: 'ProductPrice', uniqueCode: string, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate: string, endDate: string } | null | undefined } | null | undefined> } | null | undefined };

export type ProductGroupFieldsFragment = { __typename?: 'ProductGroup', productGroupId: string, divisionCode: string, productGrouptypeCode: string, productGroupCode: string, productGroupName: string, versionUuid: string, id: string, publicationOption?: string | null | undefined, publicationScope?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined };

export type ProductGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductGroupQuery = { __typename?: 'Query', productGroup?: { __typename?: 'ProductGroup', productGroupId: string, divisionCode: string, productGrouptypeCode: string, productGroupCode: string, productGroupName: string, versionUuid: string, id: string, publicationOption?: string | null | undefined, publicationScope?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined };

export type UpdateProductGroupMutationVariables = Exact<{
  input: UpdateProductGroupInput;
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup?: { __typename?: 'UpdateProductGroupPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type SearchProductGroupQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductGroupFilter>;
  sort?: InputMaybe<Array<InputMaybe<ProductGroupSortEnum>> | InputMaybe<ProductGroupSortEnum>>;
}>;


export type SearchProductGroupQuery = { __typename?: 'Query', searchProductGroup?: { __typename?: 'ProductGroupConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductGroupEdge', cursor: string, node?: { __typename?: 'ProductGroup', productGroupId: string, divisionCode: string, productGrouptypeCode: string, productGroupCode: string, productGroupName: string, versionUuid: string, id: string, publicationOption?: string | null | undefined, publicationScope?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductHistoryFieldsFragment = { __typename?: 'ProductHistory', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productBaseHistoryId: string, uniqueCode: string, janCode?: string | null | undefined, productName?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, vendorCode?: string | null | undefined, id: string, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined };

export type SearchProductUpdateHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchProductHistoryFilter>;
  filter2?: InputMaybe<SearchProductFromUniqueCodeFilter>;
  sort1?: InputMaybe<Array<InputMaybe<ProductHistorySortEnum>> | InputMaybe<ProductHistorySortEnum>>;
  sort2?: InputMaybe<Array<InputMaybe<ProductSortEnum>> | InputMaybe<ProductSortEnum>>;
}>;


export type SearchProductUpdateHistoryQuery = { __typename?: 'Query', searchProductHistory?: { __typename?: 'ProductHistoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductHistoryEdge', cursor: string, node?: { __typename?: 'ProductHistory', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productBaseHistoryId: string, uniqueCode: string, janCode?: string | null | undefined, productName?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, vendorCode?: string | null | undefined, id: string, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchProductFromUniqueCode?: { __typename?: 'ProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductEdge', cursor: string, node?: { __typename?: 'Product', uniqueCode: string, janCode: string, productName: string } | null | undefined } | null | undefined> } | null | undefined };

export type ProductListViewFieldsFragment = { __typename?: 'ProductListView', id: string, uniqueCode: string, janCode: string, productName: string, productFuri?: string | null | undefined, unitCode?: string | null | undefined, receiveOrderLot?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined, purchaseOrderLeadTime?: number | null | undefined, vendorCode?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, componentDivision?: string | null | undefined, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, clothGroup?: string | null | undefined, material?: string | null | undefined, inventoryControlFlg?: string | null | undefined, notIncludedSku: string, discontinueFlg?: string | null | undefined, planningUserCode?: string | null | undefined, designUserCode?: string | null | undefined, tags?: any | null | undefined, productImage1?: string | null | undefined, productImage2?: string | null | undefined, productImage3?: string | null | undefined, productImage4?: string | null | undefined, productImage5?: string | null | undefined, productImage6?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, productCode: string, divisionCode: string, attrNo: number, branchNumber: number, attributeName?: string | null | undefined, divisionStandardStock?: number | null | undefined, purchaseOrderStandardStock?: number | null | undefined, baseStockQuantity?: number | null | undefined, lotGroupCode?: number | null | undefined, minimumLot?: number | null | undefined, firstArrivalDate?: string | null | undefined, fcCode1?: string | null | undefined, fcCode2?: string | null | undefined, fcCode3?: string | null | undefined, fcCodeBranchNumber1?: string | null | undefined, fcCodeBranchNumber2?: string | null | undefined, fcCodeBranchNumber3?: string | null | undefined, productAttrMemo?: string | null | undefined, productBodySize?: string | null | undefined, productBodyWeight?: string | null | undefined, productPackageSize?: string | null | undefined, productPackageWeight?: string | null | undefined, innerCartonSize?: string | null | undefined, innerCartonWeight?: string | null | undefined, innerCartonUnit?: number | null | undefined, outerCartonWidth?: number | null | undefined, outerCartonHeight?: number | null | undefined, outerCartonDept?: number | null | undefined, outerCartonWeight?: string | null | undefined, outerCartonUnit?: number | null | undefined, attr1?: string | null | undefined, attr2?: string | null | undefined, publicationOption?: string | null | undefined, endOfSalesDate?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string, publicationOption?: string | null | undefined } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, sendOrderLot?: { __typename?: 'SendOrderLot', lotGroupName: string } | null | undefined };

export type SearchProductListViewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductListViewFilter>;
  sort?: InputMaybe<Array<InputMaybe<ProductListViewSortEnum>> | InputMaybe<ProductListViewSortEnum>>;
}>;


export type SearchProductListViewQuery = { __typename?: 'Query', searchProductListView?: { __typename?: 'ProductListViewConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductListViewEdge', cursor: string, node?: { __typename?: 'ProductListView', id: string, uniqueCode: string, janCode: string, productName: string, productFuri?: string | null | undefined, unitCode?: string | null | undefined, receiveOrderLot?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined, purchaseOrderLeadTime?: number | null | undefined, vendorCode?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, componentDivision?: string | null | undefined, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, clothGroup?: string | null | undefined, material?: string | null | undefined, inventoryControlFlg?: string | null | undefined, notIncludedSku: string, discontinueFlg?: string | null | undefined, planningUserCode?: string | null | undefined, designUserCode?: string | null | undefined, tags?: any | null | undefined, productImage1?: string | null | undefined, productImage2?: string | null | undefined, productImage3?: string | null | undefined, productImage4?: string | null | undefined, productImage5?: string | null | undefined, productImage6?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, productCode: string, divisionCode: string, attrNo: number, branchNumber: number, attributeName?: string | null | undefined, divisionStandardStock?: number | null | undefined, purchaseOrderStandardStock?: number | null | undefined, baseStockQuantity?: number | null | undefined, lotGroupCode?: number | null | undefined, minimumLot?: number | null | undefined, firstArrivalDate?: string | null | undefined, fcCode1?: string | null | undefined, fcCode2?: string | null | undefined, fcCode3?: string | null | undefined, fcCodeBranchNumber1?: string | null | undefined, fcCodeBranchNumber2?: string | null | undefined, fcCodeBranchNumber3?: string | null | undefined, productAttrMemo?: string | null | undefined, productBodySize?: string | null | undefined, productBodyWeight?: string | null | undefined, productPackageSize?: string | null | undefined, productPackageWeight?: string | null | undefined, innerCartonSize?: string | null | undefined, innerCartonWeight?: string | null | undefined, innerCartonUnit?: number | null | undefined, outerCartonWidth?: number | null | undefined, outerCartonHeight?: number | null | undefined, outerCartonDept?: number | null | undefined, outerCartonWeight?: string | null | undefined, outerCartonUnit?: number | null | undefined, attr1?: string | null | undefined, attr2?: string | null | undefined, publicationOption?: string | null | undefined, endOfSalesDate?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string, publicationOption?: string | null | undefined } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, sendOrderLot?: { __typename?: 'SendOrderLot', lotGroupName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductViewFieldsFragment = { __typename?: 'ProductView', id: string, uniqueCode: string, janCode: string, productName: string, productFuri?: string | null | undefined, unitCode?: string | null | undefined, receiveOrderLot?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined, purchaseOrderLeadTime?: number | null | undefined, vendorCode?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, componentDivision?: string | null | undefined, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, clothGroup?: string | null | undefined, material?: string | null | undefined, inventoryControlFlg?: string | null | undefined, notIncludedSku: string, discontinueFlg?: string | null | undefined, planningUserCode?: string | null | undefined, designUserCode?: string | null | undefined, tags?: any | null | undefined, productImage1?: string | null | undefined, productImage2?: string | null | undefined, productImage3?: string | null | undefined, productImage4?: string | null | undefined, productImage5?: string | null | undefined, productImage6?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, productCode: string, divisionCode: string, attrNo: number, branchNumber: number, attributeName?: string | null | undefined, divisionStandardStock?: number | null | undefined, purchaseOrderStandardStock?: number | null | undefined, lotGroupCode?: number | null | undefined, minimumLot?: number | null | undefined, firstArrivalDate?: string | null | undefined, fcCode1?: string | null | undefined, fcCode2?: string | null | undefined, fcCode3?: string | null | undefined, fcCodeBranchNumber1?: string | null | undefined, fcCodeBranchNumber2?: string | null | undefined, fcCodeBranchNumber3?: string | null | undefined, productAttrMemo?: string | null | undefined, productBodySize?: string | null | undefined, productBodyWeight?: string | null | undefined, productPackageSize?: string | null | undefined, productPackageWeight?: string | null | undefined, innerCartonSize?: string | null | undefined, innerCartonWeight?: string | null | undefined, innerCartonUnit?: number | null | undefined, outerCartonWidth?: number | null | undefined, outerCartonHeight?: number | null | undefined, outerCartonDept?: number | null | undefined, outerCartonWeight?: string | null | undefined, outerCartonUnit?: number | null | undefined, attr1?: string | null | undefined, attr2?: string | null | undefined, publicationOption?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, sendOrderLot?: { __typename?: 'SendOrderLot', lotGroupName: string } | null | undefined };

export type SearchProductViewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductViewFilter>;
  sort?: InputMaybe<Array<InputMaybe<ProductViewSortEnum>> | InputMaybe<ProductViewSortEnum>>;
}>;


export type SearchProductViewQuery = { __typename?: 'Query', searchProductView?: { __typename?: 'ProductViewConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductViewEdge', cursor: string, node?: { __typename?: 'ProductView', id: string, uniqueCode: string, janCode: string, productName: string, productFuri?: string | null | undefined, unitCode?: string | null | undefined, receiveOrderLot?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined, purchaseOrderLeadTime?: number | null | undefined, vendorCode?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, componentDivision?: string | null | undefined, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, clothGroup?: string | null | undefined, material?: string | null | undefined, inventoryControlFlg?: string | null | undefined, notIncludedSku: string, discontinueFlg?: string | null | undefined, planningUserCode?: string | null | undefined, designUserCode?: string | null | undefined, tags?: any | null | undefined, productImage1?: string | null | undefined, productImage2?: string | null | undefined, productImage3?: string | null | undefined, productImage4?: string | null | undefined, productImage5?: string | null | undefined, productImage6?: string | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, retailPrice?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, productCode: string, divisionCode: string, attrNo: number, branchNumber: number, attributeName?: string | null | undefined, divisionStandardStock?: number | null | undefined, purchaseOrderStandardStock?: number | null | undefined, lotGroupCode?: number | null | undefined, minimumLot?: number | null | undefined, firstArrivalDate?: string | null | undefined, fcCode1?: string | null | undefined, fcCode2?: string | null | undefined, fcCode3?: string | null | undefined, fcCodeBranchNumber1?: string | null | undefined, fcCodeBranchNumber2?: string | null | undefined, fcCodeBranchNumber3?: string | null | undefined, productAttrMemo?: string | null | undefined, productBodySize?: string | null | undefined, productBodyWeight?: string | null | undefined, productPackageSize?: string | null | undefined, productPackageWeight?: string | null | undefined, innerCartonSize?: string | null | undefined, innerCartonWeight?: string | null | undefined, innerCartonUnit?: number | null | undefined, outerCartonWidth?: number | null | undefined, outerCartonHeight?: number | null | undefined, outerCartonDept?: number | null | undefined, outerCartonWeight?: string | null | undefined, outerCartonUnit?: number | null | undefined, attr1?: string | null | undefined, attr2?: string | null | undefined, publicationOption?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupCode: string, productGroupName: string } | null | undefined, sendOrderLot?: { __typename?: 'SendOrderLot', lotGroupName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductViewFromIdFieldsFragment = { __typename?: 'ProductView', janCode: string, productCode: string, productName: string, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined, warehouse?: { __typename?: 'Warehouse', customerCode?: string | null | undefined, warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined, outsourceQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined> | null | undefined };

export type ProductViewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductViewQuery = { __typename?: 'Query', productView?: { __typename?: 'ProductView', janCode: string, productCode: string, productName: string, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, taxationDivision?: string | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined, warehouse?: { __typename?: 'Warehouse', customerCode?: string | null | undefined, warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined, outsourceQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ProductImportMutationVariables = Exact<{
  input: ProductImportInput;
}>;


export type ProductImportMutation = { __typename?: 'Mutation', productImport?: { __typename?: 'ProductImportPayload', product?: { __typename?: 'Product', uniqueCode: string, janCode: string } | null | undefined } | null | undefined };

export type ProductionFieldsFragment = { __typename?: 'Production', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, productionOrderDate: string, finishedProductCode: string, finishedQuantity: number, divisionCode: string, warehouseCode: string, receiveUnitPrice?: number | null | undefined, receivePrice?: number | null | undefined, productionMemo?: string | null | undefined, searchKeyword?: string | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined } | null | undefined, component?: { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductionDetailFieldsFragment = { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchProductionFieldsFragment = { __typename?: 'Production', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, productionOrderDate: string, finishedProductCode: string, finishedQuantity: number, divisionCode: string, warehouseCode: string, receiveUnitPrice?: number | null | undefined, receivePrice?: number | null | undefined, productionMemo?: string | null | undefined, searchKeyword?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', janCode: string, productName: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined };

export type ProductionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductionQuery = { __typename?: 'Query', production?: { __typename?: 'Production', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, productionOrderDate: string, finishedProductCode: string, finishedQuantity: number, divisionCode: string, warehouseCode: string, receiveUnitPrice?: number | null | undefined, receivePrice?: number | null | undefined, productionMemo?: string | null | undefined, searchKeyword?: string | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined } | null | undefined, component?: { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchProductionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductionFilter>;
  sort?: InputMaybe<Array<InputMaybe<ProductionSortEnum>> | InputMaybe<ProductionSortEnum>>;
}>;


export type SearchProductionQuery = { __typename?: 'Query', searchProduction?: { __typename?: 'ProductionConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductionEdge', cursor: string, node?: { __typename?: 'Production', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, productionOrderDate: string, finishedProductCode: string, finishedQuantity: number, divisionCode: string, warehouseCode: string, receiveUnitPrice?: number | null | undefined, receivePrice?: number | null | undefined, productionMemo?: string | null | undefined, searchKeyword?: string | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined } | null | undefined, component?: { __typename?: 'Component', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, versionUuid: string, componentDetail?: { __typename?: 'ComponentDetailConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ComponentDetailEdge', cursor: string, node?: { __typename?: 'ComponentDetail', id: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, finishedProductCode: string, productPartsCode: string, frontNumbering: number, quantity: number, versionUuid: string, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined, stockByDivisions?: Array<{ __typename?: 'StockByDivision', divisionCode?: string | null | undefined, mainQuantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductView', searchKeyword?: string | null | undefined, divisionCode: string, productName: string, janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchProductionDetailListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductionFilter>;
  sort?: InputMaybe<Array<InputMaybe<ProductionSortEnum>> | InputMaybe<ProductionSortEnum>>;
  detailFilter?: InputMaybe<ProductionDetailFilter>;
}>;


export type SearchProductionDetailListQuery = { __typename?: 'Query', searchProduction?: { __typename?: 'ProductionConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ProductionEdge', cursor: string, node?: { __typename?: 'Production', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, productionOrderDate: string, finishedProductCode: string, finishedQuantity: number, divisionCode: string, warehouseCode: string, receiveUnitPrice?: number | null | undefined, receivePrice?: number | null | undefined, productionMemo?: string | null | undefined, searchKeyword?: string | null | undefined, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, productView?: { __typename?: 'ProductNoPriceView', janCode: string, productName: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductionMutationFieldsFragment = { __typename?: 'Production', id: string, productionOrderId: string, productionOrderDate: string, warehouseCode: string, finishedProductCode: string, finishedQuantity: number, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateProductionMutationVariables = Exact<{
  input: CreateProductionInput;
}>;


export type CreateProductionMutation = { __typename?: 'Mutation', createProduction?: { __typename?: 'CreateProductionPayload', production?: { __typename?: 'Production', id: string, productionOrderId: string, productionOrderDate: string, warehouseCode: string, finishedProductCode: string, finishedQuantity: number, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateProductionMutationVariables = Exact<{
  input: UpdateProductionInput;
}>;


export type UpdateProductionMutation = { __typename?: 'Mutation', updateProduction?: { __typename?: 'UpdateProductionPayload', production?: { __typename?: 'Production', id: string, productionOrderId: string, productionOrderDate: string, warehouseCode: string, finishedProductCode: string, finishedQuantity: number, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteProductionMutationVariables = Exact<{
  input: DeleteProductionInput;
}>;


export type DeleteProductionMutation = { __typename?: 'Mutation', deleteProduction?: { __typename?: 'DeleteProductionPayload', production?: { __typename?: 'Production', id: string, productionOrderId: string, productionOrderDate: string, warehouseCode: string, finishedProductCode: string, finishedQuantity: number, productionDetails?: { __typename?: 'ProductionDetailConnection', edges: Array<{ __typename?: 'ProductionDetailEdge', node?: { __typename?: 'ProductionDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, productionOrderId: string, numbering: string, productPartsCode: string, quantity: number, partsQuantity: number, defrayalUnitPrice?: number | null | undefined, defrayalPrice?: number | null | undefined, detailMemo?: string | null | undefined, productView?: { __typename?: 'ProductNoPriceView', productName: string, janCode: string, productGroupId1?: number | null | undefined, productGroupId2?: number | null | undefined, productGroupId3?: number | null | undefined, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type ProductionComponentDetailFieldsFragment = { __typename?: 'ComponentDetail', id: string, productPartsCode: string, quantity: number, productView?: { __typename?: 'ProductView', janCode: string, productName: string, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ProductionComponentFieldsFragment = { __typename?: 'Component', finishedProductCode: string, productView?: { __typename?: 'ProductView', division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined, componentDetail?: { __typename?: 'ComponentDetailConnection', edges: Array<{ __typename?: 'ComponentDetailEdge', node?: { __typename?: 'ComponentDetail', id: string, productPartsCode: string, quantity: number, productView?: { __typename?: 'ProductView', janCode: string, productName: string, attributeName?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ProductionProductViewFieldsFragment = { __typename?: 'ProductView', janCode: string, productCode: string, attributeName?: string | null | undefined, salesUnitPrice?: number | null | undefined, discontinueFlg?: string | null | undefined, stockByWarehouses?: Array<{ __typename?: 'StockByWarehouse', warehouseCode?: string | null | undefined, quantity?: number | null | undefined } | null | undefined> | null | undefined };

export type SearchComponentWithPriceQueryVariables = Exact<{
  filter?: InputMaybe<ComponentWithPriceFilter>;
}>;


export type SearchComponentWithPriceQuery = { __typename?: 'Query', searchComponentWithPrice?: { __typename?: 'ComponentWithPrice', finishedProductCode?: string | null | undefined, purchaseUnitPriceYen?: any | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, componentDetail?: Array<{ __typename?: 'ComponentDetailWithPrice', productPartsCode?: string | null | undefined, quantity?: any | null | undefined, janCode?: string | null | undefined, attributeName?: string | null | undefined, salesUnitPrice?: any | null | undefined, stockQuantity?: any | null | undefined, purchaseUnitPriceYen?: any | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PurchaseFieldsFragment = { __typename?: 'Purchase', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, purchaseDate: string, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, arrivalId?: number | null | undefined, taxExcludedTotal?: number | null | undefined, taxIncludedTotal?: number | null | undefined, totalDollar?: number | null | undefined, closingStatusCode: string, paymentId?: number | null | undefined, purchaseVoucherType: string, orderId?: number | null | undefined, id: string, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, numbering: string, purchaseTradeTypeCode: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, arrivalDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, payment?: { __typename?: 'Payment', id: string, withdrawalState: string, vendorTaxType: string } | null | undefined, arrival?: { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined } | null | undefined, arrivalTaxDetails?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, arrivalTaxDetailsPurchase?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type PurchaseDetailFieldsFragment = { __typename?: 'PurchaseDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, numbering: string, purchaseTradeTypeCode: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, arrivalDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string };

export type VendorPurchaseMonthlyFieldsFragment = { __typename?: 'VendorPurchaseMonthly', vendorCode?: string | null | undefined, totalingMonthly?: string | null | undefined, totalingPeriod?: string | null | undefined, totalingPurchasePrice?: number | null | undefined, totalingPurchasePriceDollar?: number | null | undefined, totalingWithdrawalPrice?: number | null | undefined };

export type SearchVendorLedgerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchVendorPurchaseFilter>;
  filter2?: InputMaybe<SearchWithdrawalVendorPurchaseFilter>;
  filter3?: InputMaybe<SearchVendorWithCarryOverFilter>;
  filter4?: InputMaybe<SearchPaymentVendorPurchaseFilter>;
  sort1?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>> | InputMaybe<PurchaseSortEnum>>;
  sort2?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>> | InputMaybe<WithdrawalSortEnum>>;
  sort4?: InputMaybe<Array<InputMaybe<PaymentSortEnum>> | InputMaybe<PaymentSortEnum>>;
}>;


export type SearchVendorLedgerQuery = { __typename?: 'Query', searchVendorPurchase?: { __typename?: 'PurchaseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseEdge', cursor: string, node?: { __typename?: 'Purchase', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, purchaseDate: string, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, arrivalId?: number | null | undefined, taxExcludedTotal?: number | null | undefined, taxIncludedTotal?: number | null | undefined, totalDollar?: number | null | undefined, closingStatusCode: string, paymentId?: number | null | undefined, purchaseVoucherType: string, orderId?: number | null | undefined, id: string, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, purchaseId: string, numbering: string, purchaseTradeTypeCode: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, arrivalDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, payment?: { __typename?: 'Payment', id: string, withdrawalState: string, vendorTaxType: string } | null | undefined, arrival?: { __typename?: 'Arrival', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId: string, arrivalDate: string, arrivalMemo?: string | null | undefined, orderId?: number | null | undefined } | null | undefined, arrivalTaxDetails?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, arrivalTaxDetailsPurchase?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, arrivalId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchWithdrawalVendorPurchase?: { __typename?: 'WithdrawalConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WithdrawalEdge', cursor: string, node?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchVendorWithCarryOver?: { __typename?: 'VendorWithCarryOverConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'VendorWithCarryOverEdge', cursor: string, node?: { __typename?: 'VendorWithCarryOver', vendorTaxType?: string | null | undefined, targetCarryOver?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchPaymentVendorPurchase?: { __typename?: 'PaymentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node?: { __typename?: 'Payment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, paymentId: string, closingDate: string, paymentExpectedDate: string, paymentDate: string, vendorCode: string, vendorTaxType: string, beforePaymentRemain: number, payPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalPaymentPrice: number, includedTaxTotalPaymentPrice: number, includedTaxPaymentClearingPrice: number, exciseTaxTotal: number, currentPaymentExpectRemain: number, currentPaymentPrice?: number | null | undefined, differencePrice?: number | null | undefined, offsetPrice?: number | null | undefined, transferFee?: number | null | undefined, currentTransferPrice?: number | null | undefined, paymentMemo?: string | null | undefined, withdrawalState: string, closingStatusCode: string, currentTotalPurchasePrice?: number | null | undefined, currentTotalImportPrice?: number | null | undefined, currentTotalProgressPrice?: number | null | undefined, automaticPayId?: number | null | undefined, id: string, paymentTaxDetails?: { __typename?: 'PaymentTaxDetailConnection', edges: Array<{ __typename?: 'PaymentTaxDetailEdge', node?: { __typename?: 'PaymentTaxDetail', versionUuid: string, paymentId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, paymentTaxAdjustDetails?: { __typename?: 'PaymentTaxAdjustDetailConnection', edges: Array<{ __typename?: 'PaymentTaxAdjustDetailEdge', node?: { __typename?: 'PaymentTaxAdjustDetail', versionUuid: string, paymentId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, updateDate: any, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionName: string } | null | undefined } | null | undefined, automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchVendorPurchaseMonthlyQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchVendorPurchaseMonthlyFilter>;
  filter2?: InputMaybe<SearchVendorWithCarryOverFilter>;
}>;


export type SearchVendorPurchaseMonthlyQuery = { __typename?: 'Query', searchVendorPurchaseMonthly?: { __typename?: 'VendorPurchaseMonthlyConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'VendorPurchaseMonthlyEdge', cursor: string, node?: { __typename?: 'VendorPurchaseMonthly', vendorCode?: string | null | undefined, totalingMonthly?: string | null | undefined, totalingPeriod?: string | null | undefined, totalingPurchasePrice?: number | null | undefined, totalingPurchasePriceDollar?: number | null | undefined, totalingWithdrawalPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchVendorWithCarryOver?: { __typename?: 'VendorWithCarryOverConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'VendorWithCarryOverEdge', cursor: string, node?: { __typename?: 'VendorWithCarryOver', vendorTaxType?: string | null | undefined, targetCarryOver?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchPurchaseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseFilter>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>> | InputMaybe<PurchaseSortEnum>>;
}>;


export type SearchPurchaseQuery = { __typename?: 'Query', searchPurchase?: { __typename?: 'PurchaseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', purchaseId: string, purchaseDate: string, closingStatusCode: string, purchaseRemark?: string | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string } | null | undefined, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', purchasePrice?: number | null | undefined, taxationDivision?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type PurchaseDetailListPurchaseDetailFieldsFragment = { __typename?: 'PurchaseDetail', purchaseTradeTypeCode: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined };

export type PurchaseDetailListArrivalDetailFieldsFragment = { __typename?: 'ArrivalDetail', arrivalDetailStatus?: string | null | undefined, arrivalTradeTypeCode: string, productCode?: string | null | undefined };

export type PurchaseDetailListArrivalTaxDetailFieldsFragment = { __typename?: 'ArrivalTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined };

export type PurchaseDetailListPurchaseFieldsFragment = { __typename?: 'Purchase', purchaseId: string, purchaseDate: string, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, taxExcludedTotal?: number | null | undefined, taxIncludedTotal?: number | null | undefined, purchaseVoucherType: string, orderId?: number | null | undefined, arrivalId?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorTaxType?: string | null | undefined, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined } | null | undefined, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', purchaseTradeTypeCode: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, arrival?: { __typename?: 'Arrival', arrivalId: string, orderId?: number | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalDetailStatus?: string | null | undefined, arrivalTradeTypeCode: string, productCode?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined, arrivalTaxDetails?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, arrivalTaxDetailsPurchase?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type PurchaseDetailListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseFilter>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSortEnum>> | InputMaybe<PurchaseSortEnum>>;
  detailFilter?: InputMaybe<PurchaseDetailFilter>;
}>;


export type PurchaseDetailListQuery = { __typename?: 'Query', searchPurchase?: { __typename?: 'PurchaseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseEdge', node?: { __typename?: 'Purchase', purchaseId: string, purchaseDate: string, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, poCode?: string | null | undefined, purchaseRemark?: string | null | undefined, closingTiming?: string | null | undefined, taxExcludedTotal?: number | null | undefined, taxIncludedTotal?: number | null | undefined, purchaseVoucherType: string, orderId?: number | null | undefined, arrivalId?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorTaxType?: string | null | undefined, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined } | null | undefined, purchaseDetails?: { __typename?: 'PurchaseDetailConnection', edges: Array<{ __typename?: 'PurchaseDetailEdge', node?: { __typename?: 'PurchaseDetail', purchaseTradeTypeCode: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, purchaseQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, arrival?: { __typename?: 'Arrival', arrivalId: string, orderId?: number | null | undefined, arrivalDetails?: { __typename?: 'ArrivalDetailConnection', edges: Array<{ __typename?: 'ArrivalDetailEdge', node?: { __typename?: 'ArrivalDetail', arrivalDetailStatus?: string | null | undefined, arrivalTradeTypeCode: string, productCode?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined, arrivalTaxDetails?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, arrivalTaxDetailsPurchase?: { __typename?: 'ArrivalTaxDetailConnection', edges: Array<{ __typename?: 'ArrivalTaxDetailEdge', node?: { __typename?: 'ArrivalTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ExportProductFromPurchaseKoreQueryVariables = Exact<{
  filter?: InputMaybe<SearchProductInPurchaseKoreFilter>;
}>;


export type ExportProductFromPurchaseKoreQuery = { __typename?: 'Query', exportProductFromPurchaseKore?: { __typename?: 'PurchaseKoreConnection', totalCount?: number | null | undefined, exchangeRate?: number | null | undefined, pageInfo?: { __typename?: 'PurchaseKorePageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage?: boolean | null | undefined, hasPreviousPage?: boolean | null | undefined } | null | undefined, edges?: Array<{ __typename?: 'PurchaseKoreEdge', cursor?: string | null | undefined, node?: { __typename?: 'PurchaseKore', productCode?: string | null | undefined, attributeName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, firstArrivalDate?: string | null | undefined, totalSalesDate?: number | null | undefined, totalStock?: number | null | undefined, remainingOrderQuantity?: number | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, retailPrice?: number | null | undefined, costRatio?: number | null | undefined, planningUserName?: string | null | undefined, designUserName?: string | null | undefined, minimumLot?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, latestOrderDate?: string | null | undefined, latestArrivalDate?: string | null | undefined, latestOrderToArrivalLeadTime?: number | null | undefined, latestArrivalQuantity?: number | null | undefined, latestDailyAverageShipmentQuantity?: number | null | undefined, latestTotalShipmentCustomers?: number | null | undefined, latestTotalShipmentQuantity?: number | null | undefined, latestDio?: number | null | undefined, previousOrderDate?: string | null | undefined, previousArrivalDate?: string | null | undefined, previousOrderToArrivalLeadTime?: number | null | undefined, previousArrivalQuantity?: number | null | undefined, previousDailyAverageShipmentQuantity?: number | null | undefined, previousTotalShipmentCustomers?: number | null | undefined, previousTotalShipmentQuantity?: number | null | undefined, previousDio?: number | null | undefined, beforePreviousOrderDate?: string | null | undefined, beforePreviousArrivalDate?: string | null | undefined, beforePreviousOrderToArrivalLeadTime?: number | null | undefined, beforePreviousArrivalQuantity?: number | null | undefined, beforePreviousDailyAverageShipmentQuantity?: number | null | undefined, beforePreviousTotalShipmentCustomers?: number | null | undefined, beforePreviousTotalShipmentQuantity?: number | null | undefined, beforePreviousDio?: number | null | undefined, thirdPreviousOrderDate?: string | null | undefined, thirdPreviousArrivalDate?: string | null | undefined, thirdPreviousOrderToArrivalLeadTime?: number | null | undefined, thirdPreviousArrivalQuantity?: number | null | undefined, thirdPreviousDailyAverageShipmentQuantity?: number | null | undefined, thirdPreviousTotalShipmentCustomers?: number | null | undefined, thirdPreviousTotalShipmentQuantity?: number | null | undefined, thirdPreviousDio?: number | null | undefined, daysFromLatestArrivalToNow?: number | null | undefined, daysFromPreviousArrivalToLatestArrival?: number | null | undefined, daysFromBeforePreviousArrivalToPreviousArrival?: number | null | undefined, daysFromThirdPreviousArrivalToBeforePreviousArrival?: number | null | undefined, mCurrentMonth?: number | null | undefined, m1MonthsAgo?: number | null | undefined, m2MonthsAgo?: number | null | undefined, m3MonthsAgo?: number | null | undefined, m4MonthsAgo?: number | null | undefined, m5MonthsAgo?: number | null | undefined, m6MonthsAgo?: number | null | undefined, m7MonthsAgo?: number | null | undefined, m8MonthsAgo?: number | null | undefined, m9MonthsAgo?: number | null | undefined, m10MonthsAgo?: number | null | undefined, m11MonthsAgo?: number | null | undefined, m12MonthsAgo?: number | null | undefined, m13MonthsAgo?: number | null | undefined, m14MonthsAgo?: number | null | undefined, m15MonthsAgo?: number | null | undefined, m16MonthsAgo?: number | null | undefined, m17MonthsAgo?: number | null | undefined, m18MonthsAgo?: number | null | undefined, m19MonthsAgo?: number | null | undefined, m20MonthsAgo?: number | null | undefined, m21MonthsAgo?: number | null | undefined, m22MonthsAgo?: number | null | undefined, m23MonthsAgo?: number | null | undefined, m24MonthsAgo?: number | null | undefined, m25MonthsAgo?: number | null | undefined, m26MonthsAgo?: number | null | undefined, m27MonthsAgo?: number | null | undefined, m28MonthsAgo?: number | null | undefined, m29MonthsAgo?: number | null | undefined, m30MonthsAgo?: number | null | undefined, m31MonthsAgo?: number | null | undefined, m32MonthsAgo?: number | null | undefined, m33MonthsAgo?: number | null | undefined, m34MonthsAgo?: number | null | undefined, m35MonthsAgo?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SearchProductFromPurchaseKoreQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchProductInPurchaseKoreFilter>;
}>;


export type SearchProductFromPurchaseKoreQuery = { __typename?: 'Query', searchProductFromPurchaseKore?: { __typename?: 'PurchaseKoreConnection', totalCount?: number | null | undefined, exchangeRate?: number | null | undefined, pageInfo?: { __typename?: 'PurchaseKorePageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage?: boolean | null | undefined, hasPreviousPage?: boolean | null | undefined } | null | undefined, edges?: Array<{ __typename?: 'PurchaseKoreEdge', cursor?: string | null | undefined, node?: { __typename?: 'PurchaseKore', productCode?: string | null | undefined, attributeName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, firstArrivalDate?: string | null | undefined, totalSalesDate?: number | null | undefined, totalStock?: number | null | undefined, remainingOrderQuantity?: number | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, retailPrice?: number | null | undefined, costRatio?: number | null | undefined, planningUserName?: string | null | undefined, designUserName?: string | null | undefined, minimumLot?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, latestOrderDate?: string | null | undefined, latestArrivalDate?: string | null | undefined, latestOrderToArrivalLeadTime?: number | null | undefined, latestArrivalQuantity?: number | null | undefined, latestDailyAverageShipmentQuantity?: number | null | undefined, latestTotalShipmentCustomers?: number | null | undefined, latestTotalShipmentQuantity?: number | null | undefined, latestDio?: number | null | undefined, previousOrderDate?: string | null | undefined, previousArrivalDate?: string | null | undefined, previousOrderToArrivalLeadTime?: number | null | undefined, previousArrivalQuantity?: number | null | undefined, previousDailyAverageShipmentQuantity?: number | null | undefined, previousTotalShipmentCustomers?: number | null | undefined, previousTotalShipmentQuantity?: number | null | undefined, previousDio?: number | null | undefined, beforePreviousOrderDate?: string | null | undefined, beforePreviousArrivalDate?: string | null | undefined, beforePreviousOrderToArrivalLeadTime?: number | null | undefined, beforePreviousArrivalQuantity?: number | null | undefined, beforePreviousDailyAverageShipmentQuantity?: number | null | undefined, beforePreviousTotalShipmentCustomers?: number | null | undefined, beforePreviousTotalShipmentQuantity?: number | null | undefined, beforePreviousDio?: number | null | undefined, thirdPreviousOrderDate?: string | null | undefined, thirdPreviousArrivalDate?: string | null | undefined, thirdPreviousOrderToArrivalLeadTime?: number | null | undefined, thirdPreviousArrivalQuantity?: number | null | undefined, thirdPreviousDailyAverageShipmentQuantity?: number | null | undefined, thirdPreviousTotalShipmentCustomers?: number | null | undefined, thirdPreviousTotalShipmentQuantity?: number | null | undefined, thirdPreviousDio?: number | null | undefined, daysFromLatestArrivalToNow?: number | null | undefined, daysFromPreviousArrivalToLatestArrival?: number | null | undefined, daysFromBeforePreviousArrivalToPreviousArrival?: number | null | undefined, daysFromThirdPreviousArrivalToBeforePreviousArrival?: number | null | undefined, mCurrentMonth?: number | null | undefined, m1MonthsAgo?: number | null | undefined, m2MonthsAgo?: number | null | undefined, m3MonthsAgo?: number | null | undefined, m4MonthsAgo?: number | null | undefined, m5MonthsAgo?: number | null | undefined, m6MonthsAgo?: number | null | undefined, m7MonthsAgo?: number | null | undefined, m8MonthsAgo?: number | null | undefined, m9MonthsAgo?: number | null | undefined, m10MonthsAgo?: number | null | undefined, m11MonthsAgo?: number | null | undefined, m12MonthsAgo?: number | null | undefined, m13MonthsAgo?: number | null | undefined, m14MonthsAgo?: number | null | undefined, m15MonthsAgo?: number | null | undefined, m16MonthsAgo?: number | null | undefined, m17MonthsAgo?: number | null | undefined, m18MonthsAgo?: number | null | undefined, m19MonthsAgo?: number | null | undefined, m20MonthsAgo?: number | null | undefined, m21MonthsAgo?: number | null | undefined, m22MonthsAgo?: number | null | undefined, m23MonthsAgo?: number | null | undefined, m24MonthsAgo?: number | null | undefined, m25MonthsAgo?: number | null | undefined, m26MonthsAgo?: number | null | undefined, m27MonthsAgo?: number | null | undefined, m28MonthsAgo?: number | null | undefined, m29MonthsAgo?: number | null | undefined, m30MonthsAgo?: number | null | undefined, m31MonthsAgo?: number | null | undefined, m32MonthsAgo?: number | null | undefined, m33MonthsAgo?: number | null | undefined, m34MonthsAgo?: number | null | undefined, m35MonthsAgo?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type PurchaseKoreFieldsFragment = { __typename?: 'PurchaseKore', productCode?: string | null | undefined, attributeName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, firstArrivalDate?: string | null | undefined, totalSalesDate?: number | null | undefined, totalStock?: number | null | undefined, remainingOrderQuantity?: number | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, domOverFlg?: string | null | undefined, countryCode?: string | null | undefined, manufacturer?: string | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, retailPrice?: number | null | undefined, costRatio?: number | null | undefined, planningUserName?: string | null | undefined, designUserName?: string | null | undefined, minimumLot?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, latestOrderDate?: string | null | undefined, latestArrivalDate?: string | null | undefined, latestOrderToArrivalLeadTime?: number | null | undefined, latestArrivalQuantity?: number | null | undefined, latestDailyAverageShipmentQuantity?: number | null | undefined, latestTotalShipmentCustomers?: number | null | undefined, latestTotalShipmentQuantity?: number | null | undefined, latestDio?: number | null | undefined, previousOrderDate?: string | null | undefined, previousArrivalDate?: string | null | undefined, previousOrderToArrivalLeadTime?: number | null | undefined, previousArrivalQuantity?: number | null | undefined, previousDailyAverageShipmentQuantity?: number | null | undefined, previousTotalShipmentCustomers?: number | null | undefined, previousTotalShipmentQuantity?: number | null | undefined, previousDio?: number | null | undefined, beforePreviousOrderDate?: string | null | undefined, beforePreviousArrivalDate?: string | null | undefined, beforePreviousOrderToArrivalLeadTime?: number | null | undefined, beforePreviousArrivalQuantity?: number | null | undefined, beforePreviousDailyAverageShipmentQuantity?: number | null | undefined, beforePreviousTotalShipmentCustomers?: number | null | undefined, beforePreviousTotalShipmentQuantity?: number | null | undefined, beforePreviousDio?: number | null | undefined, thirdPreviousOrderDate?: string | null | undefined, thirdPreviousArrivalDate?: string | null | undefined, thirdPreviousOrderToArrivalLeadTime?: number | null | undefined, thirdPreviousArrivalQuantity?: number | null | undefined, thirdPreviousDailyAverageShipmentQuantity?: number | null | undefined, thirdPreviousTotalShipmentCustomers?: number | null | undefined, thirdPreviousTotalShipmentQuantity?: number | null | undefined, thirdPreviousDio?: number | null | undefined, daysFromLatestArrivalToNow?: number | null | undefined, daysFromPreviousArrivalToLatestArrival?: number | null | undefined, daysFromBeforePreviousArrivalToPreviousArrival?: number | null | undefined, daysFromThirdPreviousArrivalToBeforePreviousArrival?: number | null | undefined, mCurrentMonth?: number | null | undefined, m1MonthsAgo?: number | null | undefined, m2MonthsAgo?: number | null | undefined, m3MonthsAgo?: number | null | undefined, m4MonthsAgo?: number | null | undefined, m5MonthsAgo?: number | null | undefined, m6MonthsAgo?: number | null | undefined, m7MonthsAgo?: number | null | undefined, m8MonthsAgo?: number | null | undefined, m9MonthsAgo?: number | null | undefined, m10MonthsAgo?: number | null | undefined, m11MonthsAgo?: number | null | undefined, m12MonthsAgo?: number | null | undefined, m13MonthsAgo?: number | null | undefined, m14MonthsAgo?: number | null | undefined, m15MonthsAgo?: number | null | undefined, m16MonthsAgo?: number | null | undefined, m17MonthsAgo?: number | null | undefined, m18MonthsAgo?: number | null | undefined, m19MonthsAgo?: number | null | undefined, m20MonthsAgo?: number | null | undefined, m21MonthsAgo?: number | null | undefined, m22MonthsAgo?: number | null | undefined, m23MonthsAgo?: number | null | undefined, m24MonthsAgo?: number | null | undefined, m25MonthsAgo?: number | null | undefined, m26MonthsAgo?: number | null | undefined, m27MonthsAgo?: number | null | undefined, m28MonthsAgo?: number | null | undefined, m29MonthsAgo?: number | null | undefined, m30MonthsAgo?: number | null | undefined, m31MonthsAgo?: number | null | undefined, m32MonthsAgo?: number | null | undefined, m33MonthsAgo?: number | null | undefined, m34MonthsAgo?: number | null | undefined, m35MonthsAgo?: number | null | undefined };

export type SearchPurchaseUnitHistoryFieldsFragment = { __typename?: 'SearchPurchaseUnitHistory', slipDate?: any | null | undefined, slipNumber?: string | null | undefined, vendorName?: string | null | undefined, quantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined };

export type SearchPurchaseUnitHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseUnitHistoryFilter>;
}>;


export type SearchPurchaseUnitHistoryQuery = { __typename?: 'Query', searchPurchaseUnitHistory?: { __typename?: 'SearchPurchaseUnitHistoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchPurchaseUnitHistoryEdge', node?: { __typename?: 'SearchPurchaseUnitHistory', slipDate?: any | null | undefined, slipNumber?: string | null | undefined, vendorName?: string | null | undefined, quantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchPurchaseAnalyticsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseAnalyticsFilter>;
}>;


export type SearchPurchaseAnalyticsListQuery = { __typename?: 'Query', searchPurchaseAnalyticsList?: { __typename?: 'PurchaseAnalyticsConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseAnalyticsEdge', cursor: string, node?: { __typename?: 'PurchaseAnalytics', vendorCode?: string | null | undefined, vendorName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, totalPurchasePrice?: number | null | undefined, totalPurchaseQuantity?: number | null | undefined, returnPrice?: number | null | undefined, returnQuantity?: number | null | undefined, discountPrice?: number | null | undefined, otherPrice?: number | null | undefined, netPurchasePrice?: number | null | undefined, netPurchaseQuantity?: number | null | undefined, configurationRate?: number | null | undefined, totalPurchasePriceDollar?: number | null | undefined, returnPriceDollar?: number | null | undefined, discountPriceDollar?: number | null | undefined, otherPriceDollar?: number | null | undefined, netPurchasePriceDollar?: number | null | undefined, configurationRateDollar?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchPurchaseDailyListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchPurchaseDailyFilter>;
}>;


export type SearchPurchaseDailyListQuery = { __typename?: 'Query', searchPurchaseDailyList?: { __typename?: 'PurchaseDailyConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PurchaseDailyEdge', cursor: string, node?: { __typename?: 'PurchaseDaily', vendorCode?: string | null | undefined, vendorName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, totalPurchasePrice?: number | null | undefined, returnPrice?: number | null | undefined, returnRate?: number | null | undefined, discountPrice?: number | null | undefined, discountRate?: number | null | undefined, otherPrice?: number | null | undefined, netPurchasePrice?: number | null | undefined, totalPurchasePriceDollar?: number | null | undefined, returnPriceDollar?: number | null | undefined, returnRateDollar?: number | null | undefined, discountPriceDollar?: number | null | undefined, discountRateDollar?: number | null | undefined, otherPriceDollar?: number | null | undefined, netPurchasePriceDollar?: number | null | undefined, totalPurchaseQuantity?: number | null | undefined, returnQuantity?: number | null | undefined, netPurchaseQuantity?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchReceivableBalanceListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceivableBalanceListFilter>;
}>;


export type SearchReceivableBalanceListQuery = { __typename?: 'Query', searchReceivableBalanceList?: { __typename?: 'ReceivableBalanceConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceivableBalanceEdge', cursor: string, node?: { __typename?: 'ReceivableBalance', businessAmebaFlg?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, userCode?: string | null | undefined, userName?: string | null | undefined, demandCode?: string | null | undefined, customerName?: string | null | undefined, beforeReceivableBalance?: number | null | undefined, collectPrice?: number | null | undefined, expirationDate?: number | null | undefined, carryOverBalance?: number | null | undefined, excludingTaxSales?: number | null | undefined, exciseTaxPer10?: number | null | undefined, exciseTaxPer8?: number | null | undefined, receivablePrice?: number | null | undefined, monthBalance?: number | null | undefined, cash?: number | null | undefined, transfer?: number | null | undefined, commission?: number | null | undefined, draft?: number | null | undefined, otherPayment?: number | null | undefined, divisionBundle?: string | null | undefined, demandClosingGroupCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, collectDays?: number | null | undefined, customerRank?: string | null | undefined, salesTradeDivision?: string | null | undefined, customerGroup?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ReceiveOrderSalesUnitPriceFieldsFragment = { __typename?: 'ReceiveOrderDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, receiveOrderId: string, numbering: string, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, productCode?: string | null | undefined, receiveOrderHeader?: { __typename?: 'ReceiveOrderHeader', versionUuid: string, receiveOrderDate: string, customerCode: string, customer?: { __typename?: 'Customer', versionUuid: string, customerCode: string, customerName: string, userCode?: string | null | undefined, user?: { __typename?: 'User', versionUuid: string, userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', versionUuid: string, janCode: string, productName: string } | null | undefined };

export type SearchReceiveOrderSalesUnitPriceUpdateQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderSalesUnitPriceUpdateFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderDetailSortEnum>> | InputMaybe<ReceiveOrderDetailSortEnum>>;
}>;


export type SearchReceiveOrderSalesUnitPriceUpdateQuery = { __typename?: 'Query', searchReceiveOrderSalesUnitPriceUpdate?: { __typename?: 'ReceiveOrderDetailConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', cursor: string, node?: { __typename?: 'ReceiveOrderDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, receiveOrderId: string, numbering: string, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, productCode?: string | null | undefined, receiveOrderHeader?: { __typename?: 'ReceiveOrderHeader', versionUuid: string, receiveOrderDate: string, customerCode: string, customer?: { __typename?: 'Customer', versionUuid: string, customerCode: string, customerName: string, userCode?: string | null | undefined, user?: { __typename?: 'User', versionUuid: string, userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', versionUuid: string, janCode: string, productName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type UpdateReceiveOrderSalesUnitPriceMutationVariables = Exact<{
  input: UpdateReceiveOrderDetailSalesUnitPriceInput;
}>;


export type UpdateReceiveOrderSalesUnitPriceMutation = { __typename?: 'Mutation', updateReceiveOrderSalesUnitPrice?: { __typename?: 'UpdateReceiveOrderDetailSalesUnitPricePayload', receiveOrderDetail?: Array<{ __typename?: 'ReceiveOrderDetail', receiveOrderId: string, numbering: string, versionUuid: string, id: string } | null | undefined> | null | undefined } | null | undefined };

export type ReceiveOrderHeaderFieldsFragment = { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, salesDate?: string | null | undefined, receiveOrderStatus: string, receiveOrderType: string, returnDivision?: string | null | undefined, receiveOrderMemo?: string | null | undefined, customerCode: string, provisionalCustomerName?: string | null | undefined, orderPath: string, ordererName?: string | null | undefined, ordererEmail1?: string | null | undefined, ordererEmail2?: string | null | undefined, ordererEmail3?: string | null | undefined, ordererTel?: string | null | undefined, ordererRemark?: string | null | undefined, userId?: string | null | undefined, customerGroup: string, salesTradeDivision: string, salesTaxType: string, customerWarehouseCode?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, divisionCode: string, salesUserCode?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, estimateId?: number | null | undefined, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryStatus: string, completedDetailCount: number, undeliveredDetailCount: number, detailCount: number, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, sales?: { __typename?: 'Sales', demand?: { __typename?: 'Demand', clearingState?: string | null | undefined, demandId: string } | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ReceiveOrderDetailFieldsFragment = { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined };

export type ReceiveOrderHeaderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReceiveOrderHeaderQuery = { __typename?: 'Query', receiveOrderHeader?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, salesDate?: string | null | undefined, receiveOrderStatus: string, receiveOrderType: string, returnDivision?: string | null | undefined, receiveOrderMemo?: string | null | undefined, customerCode: string, provisionalCustomerName?: string | null | undefined, orderPath: string, ordererName?: string | null | undefined, ordererEmail1?: string | null | undefined, ordererEmail2?: string | null | undefined, ordererEmail3?: string | null | undefined, ordererTel?: string | null | undefined, ordererRemark?: string | null | undefined, userId?: string | null | undefined, customerGroup: string, salesTradeDivision: string, salesTaxType: string, customerWarehouseCode?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, divisionCode: string, salesUserCode?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, estimateId?: number | null | undefined, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryStatus: string, completedDetailCount: number, undeliveredDetailCount: number, detailCount: number, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, sales?: { __typename?: 'Sales', demand?: { __typename?: 'Demand', clearingState?: string | null | undefined, demandId: string } | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type ReceiveOrderMutationFieldsFragment = { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateReceiveOrderMutationVariables = Exact<{
  input: CreateReceiveOrderInput;
}>;


export type CreateReceiveOrderMutation = { __typename?: 'Mutation', createReceiveOrder?: { __typename?: 'CreateReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type CreateReturnReceiveOrderMutationVariables = Exact<{
  input: CreateReturnReceiveOrderInput;
}>;


export type CreateReturnReceiveOrderMutation = { __typename?: 'Mutation', createReturnReceiveOrder?: { __typename?: 'CreateReturnReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateReceiveOrderMutationVariables = Exact<{
  input: UpdateReceiveOrderInput;
}>;


export type UpdateReceiveOrderMutation = { __typename?: 'Mutation', updateReceiveOrder?: { __typename?: 'UpdateReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateReturnReceiveOrderMutationVariables = Exact<{
  input: UpdateReturnReceiveOrderInput;
}>;


export type UpdateReturnReceiveOrderMutation = { __typename?: 'Mutation', updateReturnReceiveOrder?: { __typename?: 'UpdateReturnReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteReceiveOrderMutationVariables = Exact<{
  input: DeleteReceiveOrderInput;
}>;


export type DeleteReceiveOrderMutation = { __typename?: 'Mutation', deleteReceiveOrder?: { __typename?: 'DeleteReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteReturnReceiveOrderMutationVariables = Exact<{
  input: DeleteReturnReceiveOrderInput;
}>;


export type DeleteReturnReceiveOrderMutation = { __typename?: 'Mutation', deleteReturnReceiveOrder?: { __typename?: 'DeleteReturnReceiveOrderPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type ExecuteReturnProcessReceiveMutationVariables = Exact<{
  input: ExecuteReturnProcessReceiveInput;
}>;


export type ExecuteReturnProcessReceiveMutation = { __typename?: 'Mutation', executeReturnProcessReceive?: { __typename?: 'ExecuteReturnProcessReceivePayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type ExecuteDeleteReturnProcessReceiveMutationVariables = Exact<{
  input: ExecuteDeleteReturnProcessReceiveInput;
}>;


export type ExecuteDeleteReturnProcessReceiveMutation = { __typename?: 'Mutation', executeDeleteReturnProcessReceive?: { __typename?: 'ExecuteDeleteReturnProcessReceivePayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, customerCode: string, receiveOrderDate: string, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, frontNumbering: number, numbering: string, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, receiveOrderId: string, estimateDetailId?: number | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, divisionCode?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type CustomerFieldsForReceiveFragment = { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, userCode?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, customerUser?: string | null | undefined, ratio?: number | null | undefined, balanceData?: number | null | undefined, creditLimitPrice?: number | null | undefined, userDivisionCode: string, user?: { __typename?: 'User', userName: string } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined };

export type SearchCustomerForReceiveQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchCustomerForReceiveQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, userCode?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, customerUser?: string | null | undefined, ratio?: number | null | undefined, balanceData?: number | null | undefined, creditLimitPrice?: number | null | undefined, userDivisionCode: string, user?: { __typename?: 'User', userName: string } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined } | null | undefined };

export type SearchReceiveOrderFieldsFragment = { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, customerCode: string, provisionalCustomerName?: string | null | undefined, divisionCode: string, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, returnDivision?: string | null | undefined, salesTaxType: string, receiveOrderStatus: string, deliveryStatus: string, detailCount: number, completedDetailCount: number, undeliveredDetailCount: number, receiveOrderMemo?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, orderPath: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined };

export type SearchReceiveOrderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>> | InputMaybe<ReceiveOrderHeaderSortEnum>>;
}>;


export type SearchReceiveOrderQuery = { __typename?: 'Query', searchReceiveOrder?: { __typename?: 'ReceiveOrderHeaderConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceiveOrderHeaderEdge', cursor: string, node?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, customerCode: string, provisionalCustomerName?: string | null | undefined, divisionCode: string, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, returnDivision?: string | null | undefined, salesTaxType: string, receiveOrderStatus: string, deliveryStatus: string, detailCount: number, completedDetailCount: number, undeliveredDetailCount: number, receiveOrderMemo?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, orderPath: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchReceiveOrderForConfirmedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>> | InputMaybe<ReceiveOrderHeaderSortEnum>>;
}>;


export type SearchReceiveOrderForConfirmedQuery = { __typename?: 'Query', searchReceiveOrderForConfirmed?: { __typename?: 'ReceiveOrderHeaderConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceiveOrderHeaderEdge', cursor: string, node?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, customerCode: string, provisionalCustomerName?: string | null | undefined, divisionCode: string, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, returnDivision?: string | null | undefined, salesTaxType: string, receiveOrderStatus: string, deliveryStatus: string, detailCount: number, completedDetailCount: number, undeliveredDetailCount: number, receiveOrderMemo?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, orderPath: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchReceiveOrderForApprovalQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>> | InputMaybe<ReceiveOrderHeaderSortEnum>>;
}>;


export type SearchReceiveOrderForApprovalQuery = { __typename?: 'Query', searchReceiveOrderForApproval?: { __typename?: 'ReceiveOrderHeaderConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceiveOrderHeaderEdge', cursor: string, node?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, customerCode: string, provisionalCustomerName?: string | null | undefined, divisionCode: string, taxExcludeTotal?: number | null | undefined, taxExcluded10Per?: number | null | undefined, taxExcluded8Per?: number | null | undefined, tax10Per?: number | null | undefined, tax8Per?: number | null | undefined, receiveOrderTotalPrice?: number | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, returnDivision?: string | null | undefined, salesTaxType: string, receiveOrderStatus: string, deliveryStatus: string, detailCount: number, completedDetailCount: number, undeliveredDetailCount: number, receiveOrderMemo?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, orderPath: string, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchReciveOrderDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>> | InputMaybe<ReceiveOrderHeaderSortEnum>>;
}>;


export type SearchReciveOrderDivisionQuery = { __typename?: 'Query', searchReceiveOrder?: { __typename?: 'ReceiveOrderHeaderConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ReceiveOrderHeaderEdge', cursor: string, node?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string, divisionCode: string, customer?: { __typename?: 'Customer', userDivisionCode: string, salesReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string, offsetFlg: string, offsetX: number, offsetY: number } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WarehouseForReceiveOrderFieldsFragment = { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined };

export type SearchWarehouseForReceiveOrderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseFilter>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseSortEnum>> | InputMaybe<WarehouseSortEnum>>;
}>;


export type SearchWarehouseForReceiveOrderQuery = { __typename?: 'Query', searchWarehouse?: { __typename?: 'WarehouseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WarehouseEdge', cursor: string, node?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type UpdateReceiveOrderStatusConfirmedMutationVariables = Exact<{
  input: UpdateReceiveOrderStatusConfirmedInput;
}>;


export type UpdateReceiveOrderStatusConfirmedMutation = { __typename?: 'Mutation', updateReceiveOrderStatusConfirmed?: { __typename?: 'UpdateReceiveOrderStatusConfirmedPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string } | null | undefined } | null | undefined };

export type UpdateReceiveOrderStatusCancelMutationVariables = Exact<{
  input: UpdateReceiveOrderStatusCancelInput;
}>;


export type UpdateReceiveOrderStatusCancelMutation = { __typename?: 'Mutation', updateReceiveOrderStatusCancel?: { __typename?: 'UpdateReceiveOrderStatusCancelPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string } | null | undefined } | null | undefined };

export type UpdateReceiveOrderCorrectionMutationVariables = Exact<{
  input: UpdateReceiveOrderCorrectionInput;
}>;


export type UpdateReceiveOrderCorrectionMutation = { __typename?: 'Mutation', updateReceiveOrderCorrection?: { __typename?: 'UpdateReceiveOrderCorrectionPayload', receiveOrder?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string } | null | undefined } | null | undefined };

export type SearchReceivedOrderDetailQueryVariables = Exact<{
  filter?: InputMaybe<SearchReceiveOrderHeaderFilter>;
  sort?: InputMaybe<Array<InputMaybe<ReceiveOrderHeaderSortEnum>> | InputMaybe<ReceiveOrderHeaderSortEnum>>;
  detailFilter?: InputMaybe<ReceiveOrderDetailFilter>;
}>;


export type SearchReceivedOrderDetailQuery = { __typename?: 'Query', searchReceiveOrder?: { __typename?: 'ReceiveOrderHeaderConnection', edges: Array<{ __typename?: 'ReceiveOrderHeaderEdge', node?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string, receiveOrderDate: string, customerCode: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, divisionCode: string, salesUserCode?: string | null | undefined, salesTradeDivision: string, deliveryDate?: string | null | undefined, estimateId?: number | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', receiveDetailTradeType: string, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderDetailStatus: string, productCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchReceiveOrderDetailFieldsFragment = { __typename?: 'SearchReceiveOrderDetail', receiveOrderDate?: string | null | undefined, receiveOrderId?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, salesUserCode?: string | null | undefined, userName?: string | null | undefined, receiveDetailTradeType?: string | null | undefined, receiveOrderDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, remainQuantity?: number | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, grossProfit?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesTradeDivision?: string | null | undefined, estimateId?: string | null | undefined, deliveryDate?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, salesTaxType?: string | null | undefined, detailFlg: boolean, idForLink?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, firstRowByOrder?: boolean | null | undefined, lastRowByOrder?: boolean | null | undefined };

export type SearchReceiveOrderDetailQueryVariables = Exact<{
  filter?: InputMaybe<SearchReceiveOrderDetailFilter>;
}>;


export type SearchReceiveOrderDetailQuery = { __typename?: 'Query', searchReceiveOrderDetail?: { __typename?: 'SearchReceiveOrderDetailConnection', edges: Array<{ __typename?: 'SearchReceiveOrderDetailEdge', node?: { __typename?: 'SearchReceiveOrderDetail', receiveOrderDate?: string | null | undefined, receiveOrderId?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, salesUserCode?: string | null | undefined, userName?: string | null | undefined, receiveDetailTradeType?: string | null | undefined, receiveOrderDetailStatus?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, remainQuantity?: number | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, grossProfit?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesTradeDivision?: string | null | undefined, estimateId?: string | null | undefined, deliveryDate?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, salesTaxType?: string | null | undefined, detailFlg: boolean, idForLink?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, firstRowByOrder?: boolean | null | undefined, lastRowByOrder?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SalesFieldsFragment = { __typename?: 'Sales', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, salesDate: string, customerCode: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesRemark?: string | null | undefined, deliveryOrderId?: number | null | undefined, exciseTax?: number | null | undefined, exciseTaxClearing?: number | null | undefined, closingStatusCode: string, demandId?: number | null | undefined, divisionCode: string, trustSalesDivision: string, receiveOrderId?: number | null | undefined, salesVoucherType: string, searchKeyword?: string | null | undefined, id: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, numbering: string, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderDetailNumbering?: number | null | undefined, clearingPrice?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, updateDate: any, versionUuid: string, balanceData?: number | null | undefined, delFlg: string } | null | undefined, demand?: { __typename?: 'Demand', id: string, clearingState?: string | null | undefined, salesTaxType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string } | null | undefined, salesUser?: { __typename?: 'User', id: string, userCode: string, userName: string, userType: string } | null | undefined, shipment?: { __typename?: 'Shipment', deliveryOrderId: string, receiveOrderId: number } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined };

export type SalesDetailFieldsFragment = { __typename?: 'SalesDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, numbering: string, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderDetailNumbering?: number | null | undefined, clearingPrice?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined };

export type CustomerSalesMonthlyFieldsFragment = { __typename?: 'CustomerSalesMonthly', demandCode?: string | null | undefined, totalingMonthly?: string | null | undefined, totalingPeriod?: string | null | undefined, totalingSellingPrice?: number | null | undefined, totalingDepositPrice?: number | null | undefined };

export type CustomerFromCodeFieldsFragment = { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, updateDate: any, versionUuid: string };

export type LegderShipmentTaxDetailFieldsFragment = { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string };

export type SearchCustomerLedgerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchCustomerSalesFilter>;
  filter2?: InputMaybe<SearchDepositCustomerSalesFilter>;
  filter3?: InputMaybe<SearchCustomerWithCarryOverFilter>;
  filter4?: InputMaybe<SearchDemandCustomerSalesFilter>;
  sort1?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
  sort2?: InputMaybe<Array<InputMaybe<DepositSortEnum>> | InputMaybe<DepositSortEnum>>;
  sort4?: InputMaybe<Array<InputMaybe<DemandSortEnum>> | InputMaybe<DemandSortEnum>>;
}>;


export type SearchCustomerLedgerQuery = { __typename?: 'Query', searchCustomerSales?: { __typename?: 'SalesConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesEdge', cursor: string, node?: { __typename?: 'Sales', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, salesDate: string, customerCode: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesRemark?: string | null | undefined, deliveryOrderId?: number | null | undefined, exciseTax?: number | null | undefined, exciseTaxClearing?: number | null | undefined, closingStatusCode: string, demandId?: number | null | undefined, divisionCode: string, trustSalesDivision: string, receiveOrderId?: number | null | undefined, salesVoucherType: string, searchKeyword?: string | null | undefined, id: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, numbering: string, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderDetailNumbering?: number | null | undefined, clearingPrice?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, updateDate: any, versionUuid: string, balanceData?: number | null | undefined, delFlg: string } | null | undefined, demand?: { __typename?: 'Demand', id: string, clearingState?: string | null | undefined, salesTaxType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string } | null | undefined, salesUser?: { __typename?: 'User', id: string, userCode: string, userName: string, userType: string } | null | undefined, shipment?: { __typename?: 'Shipment', deliveryOrderId: string, receiveOrderId: number } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchDepositCustomerSales?: { __typename?: 'DepositConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DepositEdge', cursor: string, node?: { __typename?: 'Deposit', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, depositDate: string, depositRemark?: string | null | undefined, depositPriceTotal: number, clearingPrice?: number | null | undefined, closingStatusCode: string, depositTotalInMonth: number, demandTotalInMonth: number, demandId?: number | null | undefined, demandCode: string, userCode?: string | null | undefined, id: string, depositDetail?: { __typename?: 'DepositDetailConnection', edges: Array<{ __typename?: 'DepositDetailEdge', node?: { __typename?: 'DepositDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, numbering: string, depositDivisionCode: string, depositDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, depositPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, depositClearingDetail?: { __typename?: 'DepositClearingDetailConnection', edges: Array<{ __typename?: 'DepositClearingDetailEdge', node?: { __typename?: 'DepositClearingDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, depositId: string, demandId: string, clearingPrice?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerFuri: string, demandCode?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string, depositDivision?: { __typename?: 'DepositDivision', depositDivisionName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchCustomerWithCarryOver?: { __typename?: 'CustomerWithCarryOverConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerWithCarryOverEdge', cursor: string, node?: { __typename?: 'CustomerWithCarryOver', salesTaxType?: string | null | undefined, targetCarryOver?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchDemandCustomerSales?: { __typename?: 'DemandConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DemandEdge', cursor: string, node?: { __typename?: 'Demand', versionUuid: string, createUserCode: string, createDate: any, createUserName: string, updateUserCode: string, updateUserName: string, updateDate: any, demandId: string, closingDate: string, demandDate: string, collectExpectedDate: string, demandCode: string, salesTaxType?: string | null | undefined, beforeDemandRemain: number, depositPriceTotalInAccountMonth: number, carryOverPrice: number, excludingTaxTotalDemandPrice: number, includedTaxTotalDemandPrice: number, currentDemandExpectRemain: number, includedTaxDemandClearingPrice?: number | null | undefined, exciseTaxTotal: number, clearingState?: string | null | undefined, closingStatusCode: string, closingTriggerId?: number | null | undefined, totalDemandFlag?: string | null | undefined, demandTradeDivision?: string | null | undefined, demandTaxDetails?: { __typename?: 'DemandTaxDetailConnection', edges: Array<{ __typename?: 'DemandTaxDetailEdge', node?: { __typename?: 'DemandTaxDetail', versionUuid: string, demandId: string, taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, demandTaxAdjustDetails?: { __typename?: 'DemandTaxAdjustDetailConnection', edges: Array<{ __typename?: 'DemandTaxAdjustDetailEdge', node?: { __typename?: 'DemandTaxAdjustDetail', versionUuid: string, demandId: string, taxationDivision: string, beforeAdjustExciseTax?: number | null | undefined, afterAdjustExciseTax?: number | null | undefined, adjust?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', customerName: string, customerFuri: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchCustomerSalesMonthlyQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<SearchCustomerSalesMontylyFilter>;
  filter2?: InputMaybe<SearchCustomerWithCarryOverFilter>;
}>;


export type SearchCustomerSalesMonthlyQuery = { __typename?: 'Query', searchCustomerSalesMonthly?: { __typename?: 'CustomerSalesMonthlyConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerSalesMonthlyEdge', cursor: string, node?: { __typename?: 'CustomerSalesMonthly', demandCode?: string | null | undefined, totalingMonthly?: string | null | undefined, totalingPeriod?: string | null | undefined, totalingSellingPrice?: number | null | undefined, totalingDepositPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, searchCustomerWithCarryOver?: { __typename?: 'CustomerWithCarryOverConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerWithCarryOverEdge', cursor: string, node?: { __typename?: 'CustomerWithCarryOver', salesTaxType?: string | null | undefined, targetCarryOver?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesFromDeliveryOrderIdQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFromDeliveryOrderIdFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
}>;


export type SearchSalesFromDeliveryOrderIdQuery = { __typename?: 'Query', searchSalesFromDeliveryOrderId?: { __typename?: 'SalesConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesEdge', cursor: string, node?: { __typename?: 'Sales', salesId: string, demandId?: number | null | undefined, closingTiming?: string | null | undefined, closingStatusCode: string, demand?: { __typename?: 'Demand', collectExpectedDate: string, clearingState?: string | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchTrustSalesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustSalesFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
}>;


export type SearchTrustSalesQuery = { __typename?: 'Query', searchTrustSales?: { __typename?: 'SalesConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, salesDate: string, customerCode: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesRemark?: string | null | undefined, deliveryOrderId?: number | null | undefined, exciseTax?: number | null | undefined, exciseTaxClearing?: number | null | undefined, closingStatusCode: string, demandId?: number | null | undefined, divisionCode: string, trustSalesDivision: string, receiveOrderId?: number | null | undefined, salesVoucherType: string, searchKeyword?: string | null | undefined, id: string, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, salesId: string, numbering: string, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderDetailNumbering?: number | null | undefined, clearingPrice?: number | null | undefined, detailMainFlg?: string | null | undefined, totalQuantity?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, customer?: { __typename?: 'Customer', id: string, customerCode: string, customerName: string, customerFuri: string, customerGroup?: string | null | undefined, userDivisionCode: string, userCode?: string | null | undefined, divisionBundle?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, salesTradeDivision?: string | null | undefined, salesTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined, creditLimitPrice?: number | null | undefined, demandClosingGroupCode?: string | null | undefined, billSendDivision?: string | null | undefined, collectMethodCode?: string | null | undefined, collectCycleCode?: string | null | undefined, collectDate?: number | null | undefined, demandCode?: string | null | undefined, transferShareCost?: string | null | undefined, billSite?: number | null | undefined, outsourcerCode?: string | null | undefined, collectDays?: number | null | undefined, salesUserName1?: string | null | undefined, salesUserEmail1?: string | null | undefined, salesUserName2?: string | null | undefined, salesUserEmail2?: string | null | undefined, salesUserName3?: string | null | undefined, salesUserEmail3?: string | null | undefined, inventoryControlUnit: string, reportOutputUnit: string, designAmebaFlg: string, tradeStopFlg: string, businessAmebaFlg: string, customerRank?: string | null | undefined, prescribeSalesReport?: string | null | undefined, prescribeDemandReport?: string | null | undefined, addressLabelFlg: string, customerArea?: string | null | undefined, customerMemo?: string | null | undefined, createDate: any, updateDate: any, versionUuid: string, balanceData?: number | null | undefined, delFlg: string } | null | undefined, demand?: { __typename?: 'Demand', id: string, clearingState?: string | null | undefined, salesTaxType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', id: string, divisionCode: string, divisionName: string, divistionType: string } | null | undefined, salesUser?: { __typename?: 'User', id: string, userCode: string, userName: string, userType: string } | null | undefined, shipment?: { __typename?: 'Shipment', deliveryOrderId: string, receiveOrderId: number } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, taxIncluded?: number | null | undefined, id: string, taxDivision?: { __typename?: 'TaxDivision', id: string, taxationDivision: string, taxationDivisionName: string, taxRatio: number } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesPrintQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustSalesFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
}>;


export type SearchSalesPrintQuery = { __typename?: 'Query', searchTrustSales?: { __typename?: 'SalesConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', salesId: string, customer?: { __typename?: 'Customer', userDivisionCode: string, salesReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsCustomerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsCustomerFilter>;
}>;


export type SearchSalesAnalyticsCustomerQuery = { __typename?: 'Query', searchSalesAnalyticsCustomer?: { __typename?: 'SalesAnalyticsCustomerConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsCustomerEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsCustomer', customerCode?: string | null | undefined, customerName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined, isSubTotal?: boolean | null | undefined, receiveDetailTradeType?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsDeliverQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDeliverFilter>;
}>;


export type SearchSalesAnalyticsDeliverQuery = { __typename?: 'Query', searchSalesAnalyticsDeliver?: { __typename?: 'SalesAnalyticsDeliverConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsDeliverEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsDeliver', deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsProductFilter>;
}>;


export type SearchSalesAnalyticsProductQuery = { __typename?: 'Query', searchSalesAnalyticsProduct?: { __typename?: 'SalesAnalyticsProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsProductEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsProduct', janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined, isSubTotal?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsSalesUserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsSalesUserFilter>;
}>;


export type SearchSalesAnalyticsSalesUserQuery = { __typename?: 'Query', searchSalesAnalyticsSalesUser?: { __typename?: 'SalesAnalyticsSalesUserConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsSalesUserEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsSalesUser', userCode?: string | null | undefined, userName?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined, isSubTotal?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDivisionFilter>;
}>;


export type SearchSalesAnalyticsDivisionQuery = { __typename?: 'Query', searchSalesAnalyticsDivision?: { __typename?: 'SalesAnalyticsDivisionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsDivisionEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsDivision', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsDivisionProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsDivisionProductFilter>;
}>;


export type SearchSalesAnalyticsDivisionProductQuery = { __typename?: 'Query', searchSalesAnalyticsDivisionProduct?: { __typename?: 'SalesAnalyticsDivisionProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsDivisionProductEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsDivisionProduct', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, netSalesAmount?: number | null | undefined, compositionRatio?: number | null | undefined, netSalesQuantity?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesAnalyticsComparisontableQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesAnalyticsComparisonTableFilter>;
}>;


export type SearchSalesAnalyticsComparisontableQuery = { __typename?: 'Query', searchSalesAnalyticsComparisontable?: { __typename?: 'SalesAnalyticsComparisonTableConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesAnalyticsComparisonTableEdge', cursor: string, node?: { __typename?: 'SalesAnalyticsComparisonTable', userCode?: string | null | undefined, userName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, aggregateResults?: any | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesChangingListCustomerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesChangingListCustomerFilter>;
}>;


export type SearchSalesChangingListCustomerQuery = { __typename?: 'Query', searchSalesChangingListCustomer?: { __typename?: 'SalesChangingListCustomerConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesChangingListCustomerEdge', cursor: string, node?: { __typename?: 'SalesChangingListCustomer', customerCode?: string | null | undefined, customerName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, salesUserCode?: string | null | undefined, userName?: string | null | undefined, budgetMonth1?: number | null | undefined, budgetMonth2?: number | null | undefined, budgetMonth3?: number | null | undefined, budgetMonth4?: number | null | undefined, budgetMonth5?: number | null | undefined, budgetMonth6?: number | null | undefined, budgetMonth7?: number | null | undefined, budgetMonth8?: number | null | undefined, budgetMonth9?: number | null | undefined, budgetMonth10?: number | null | undefined, budgetMonth11?: number | null | undefined, budgetMonth12?: number | null | undefined, budgetTotals?: number | null | undefined, salesMonth1?: number | null | undefined, salesMonth2?: number | null | undefined, salesMonth3?: number | null | undefined, salesMonth4?: number | null | undefined, salesMonth5?: number | null | undefined, salesMonth6?: number | null | undefined, salesMonth7?: number | null | undefined, salesMonth8?: number | null | undefined, salesMonth9?: number | null | undefined, salesMonth10?: number | null | undefined, salesMonth11?: number | null | undefined, salesMonth12?: number | null | undefined, salesTotals?: number | null | undefined, differenceMonth1?: number | null | undefined, differenceMonth2?: number | null | undefined, differenceMonth3?: number | null | undefined, differenceMonth4?: number | null | undefined, differenceMonth5?: number | null | undefined, differenceMonth6?: number | null | undefined, differenceMonth7?: number | null | undefined, differenceMonth8?: number | null | undefined, differenceMonth9?: number | null | undefined, differenceMonth10?: number | null | undefined, differenceMonth11?: number | null | undefined, differenceMonth12?: number | null | undefined, differenceTotals?: number | null | undefined, achievementRate1?: number | null | undefined, achievementRate2?: number | null | undefined, achievementRate3?: number | null | undefined, achievementRate4?: number | null | undefined, achievementRate5?: number | null | undefined, achievementRate6?: number | null | undefined, achievementRate7?: number | null | undefined, achievementRate8?: number | null | undefined, achievementRate9?: number | null | undefined, achievementRate10?: number | null | undefined, achievementRate11?: number | null | undefined, achievementRate12?: number | null | undefined, achievementRateTotals?: number | null | undefined, salesQuantityMonth1?: number | null | undefined, salesQuantityMonth2?: number | null | undefined, salesQuantityMonth3?: number | null | undefined, salesQuantityMonth4?: number | null | undefined, salesQuantityMonth5?: number | null | undefined, salesQuantityMonth6?: number | null | undefined, salesQuantityMonth7?: number | null | undefined, salesQuantityMonth8?: number | null | undefined, salesQuantityMonth9?: number | null | undefined, salesQuantityMonth10?: number | null | undefined, salesQuantityMonth11?: number | null | undefined, salesQuantityMonth12?: number | null | undefined, salesQuantityTotals?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesChangingListProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesChangingListProductFilter>;
}>;


export type SearchSalesChangingListProductQuery = { __typename?: 'Query', searchSalesChangingListProduct?: { __typename?: 'SalesChangingListProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesChangingListProductEdge', cursor: string, node?: { __typename?: 'SalesChangingListProduct', janCode?: string | null | undefined, productName?: string | null | undefined, salesMonth1?: number | null | undefined, salesMonth2?: number | null | undefined, salesMonth3?: number | null | undefined, salesMonth4?: number | null | undefined, salesMonth5?: number | null | undefined, salesMonth6?: number | null | undefined, salesMonth7?: number | null | undefined, salesMonth8?: number | null | undefined, salesMonth9?: number | null | undefined, salesMonth10?: number | null | undefined, salesMonth11?: number | null | undefined, salesMonth12?: number | null | undefined, salesTotals?: number | null | undefined, salesQuantityMonth1?: number | null | undefined, salesQuantityMonth2?: number | null | undefined, salesQuantityMonth3?: number | null | undefined, salesQuantityMonth4?: number | null | undefined, salesQuantityMonth5?: number | null | undefined, salesQuantityMonth6?: number | null | undefined, salesQuantityMonth7?: number | null | undefined, salesQuantityMonth8?: number | null | undefined, salesQuantityMonth9?: number | null | undefined, salesQuantityMonth10?: number | null | undefined, salesQuantityMonth11?: number | null | undefined, salesQuantityMonth12?: number | null | undefined, salesQuantityTotals?: number | null | undefined, productGroup1?: string | null | undefined, productGroup2?: string | null | undefined, productGroup3?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesDailyCustomerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyCustomerFilter>;
}>;


export type SearchSalesDailyCustomerQuery = { __typename?: 'Query', searchSalesDailyCustomer?: { __typename?: 'SalesDailyCustomerConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesDailyCustomerEdge', cursor: string, node?: { __typename?: 'SalesDailyCustomer', customerCode?: string | null | undefined, customerName?: string | null | undefined, salesUserCode?: string | null | undefined, userName?: string | null | undefined, salesTotals?: number | null | undefined, returnTotals?: number | null | undefined, discountTotals?: number | null | undefined, othersTotals?: number | null | undefined, netSales?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesDailyProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyProductFilter>;
}>;


export type SearchSalesDailyProductQuery = { __typename?: 'Query', searchSalesDailyProduct?: { __typename?: 'SalesDailyProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesDailyProductEdge', cursor: string, node?: { __typename?: 'SalesDailyProduct', janCode?: string | null | undefined, productName?: string | null | undefined, salesTotals?: number | null | undefined, returnTotals?: number | null | undefined, discountTotals?: number | null | undefined, othersTotals?: number | null | undefined, netSales?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesDailySalesuserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailySalesUserFilter>;
}>;


export type SearchSalesDailySalesuserQuery = { __typename?: 'Query', searchSalesDailySalesuser?: { __typename?: 'SalesDailySalesUserConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesDailySalesUserEdge', cursor: string, node?: { __typename?: 'SalesDailySalesUser', salesUserCode?: string | null | undefined, userName?: string | null | undefined, salesTotals?: number | null | undefined, returnTotals?: number | null | undefined, discountTotals?: number | null | undefined, othersTotals?: number | null | undefined, netSales?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesDailyDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesDailyDivisionFilter>;
}>;


export type SearchSalesDailyDivisionQuery = { __typename?: 'Query', searchSalesDailyDivision?: { __typename?: 'SalesDailyDivisionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesDailyDivisionEdge', cursor: string, node?: { __typename?: 'SalesDailyDivision', divisionCode?: string | null | undefined, divisionName?: string | null | undefined, salesTotals?: number | null | undefined, returnTotals?: number | null | undefined, discountTotals?: number | null | undefined, othersTotals?: number | null | undefined, netSales?: number | null | undefined, grossProfit?: number | null | undefined, roundGrossProfitrate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SalesDetailListDetailFieldsFragment = { __typename?: 'SalesDetail', receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, totalTaxExcluded?: number | null | undefined, totalQuantity?: number | null | undefined, shipmentDetail?: { __typename?: 'ShipmentDetail', deliveryOrderDetailStatus: string } | null | undefined };

export type SalesDetailListShipmentTaxDetailFieldsFragment = { __typename?: 'ShipmentTaxDetail', taxationDivision: string, exciseTax?: number | null | undefined, taxExcluded?: number | null | undefined, taxIncluded?: number | null | undefined };

export type SalesDetailListHeaderFieldsFragment = { __typename?: 'Sales', createUserCode: string, createUserName: string, salesDate: string, salesId: string, customerCode: string, divisionCode: string, deliveryOrderId?: number | null | undefined, salesTradeDivision: string, closingTiming?: string | null | undefined, closingStatusCode: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesRemark?: string | null | undefined, salesUserCode?: string | null | undefined, salesVoucherType: string, receiveOrderId?: number | null | undefined, trustSalesDivision: string, customer?: { __typename?: 'Customer', customerName: string, taxRoundType?: string | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, shipment?: { __typename?: 'Shipment', salesRemark?: string | null | undefined, deliveryOrderMemo?: string | null | undefined } | null | undefined, receiveOrder?: { __typename?: 'ReceiveOrderHeader', estimateId?: number | null | undefined, receiveOrderRemarks?: string | null | undefined, receiveOrderType: string, receiveOrderMemo?: string | null | undefined } | null | undefined, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, totalTaxExcluded?: number | null | undefined, totalQuantity?: number | null | undefined, shipmentDetail?: { __typename?: 'ShipmentDetail', deliveryOrderDetailStatus: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, exciseTax?: number | null | undefined, taxExcluded?: number | null | undefined, taxIncluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined };

export type SearchSalesDetailQueryVariables = Exact<{
  filter?: InputMaybe<SearchSalesFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
  detailFilter?: InputMaybe<SalesDetailFilter>;
}>;


export type SearchSalesDetailQuery = { __typename?: 'Query', searchSales?: { __typename?: 'SalesConnection', edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', createUserCode: string, createUserName: string, salesDate: string, salesId: string, customerCode: string, divisionCode: string, deliveryOrderId?: number | null | undefined, salesTradeDivision: string, closingTiming?: string | null | undefined, closingStatusCode: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesRemark?: string | null | undefined, salesUserCode?: string | null | undefined, salesVoucherType: string, receiveOrderId?: number | null | undefined, trustSalesDivision: string, customer?: { __typename?: 'Customer', customerName: string, taxRoundType?: string | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, shipment?: { __typename?: 'Shipment', salesRemark?: string | null | undefined, deliveryOrderMemo?: string | null | undefined } | null | undefined, receiveOrder?: { __typename?: 'ReceiveOrderHeader', estimateId?: number | null | undefined, receiveOrderRemarks?: string | null | undefined, receiveOrderType: string, receiveOrderMemo?: string | null | undefined } | null | undefined, salesDetails?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, totalTaxExcluded?: number | null | undefined, totalQuantity?: number | null | undefined, shipmentDetail?: { __typename?: 'ShipmentDetail', deliveryOrderDetailStatus: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, exciseTax?: number | null | undefined, taxExcluded?: number | null | undefined, taxIncluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSalesDetailProductQueryVariables = Exact<{
  filter?: InputMaybe<SearchSalesFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesDetailSortEnum>> | InputMaybe<SalesDetailSortEnum>>;
}>;


export type SearchSalesDetailProductQuery = { __typename?: 'Query', searchSalesDetailProduct?: { __typename?: 'SalesDetailConnection', edges: Array<{ __typename?: 'SalesDetailEdge', node?: { __typename?: 'SalesDetail', janCode?: string | null | undefined, productName?: string | null | undefined, salesId: string, receiveDetailTradeType?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, deliveryOrderId?: number | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined, sales?: { __typename?: 'Sales', createUserCode: string, createUserName: string, salesDate: string, customerCode: string, divisionCode: string, salesTradeDivision: string, closingTiming?: string | null | undefined, closingStatusCode: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesRemark?: string | null | undefined, salesUserCode?: string | null | undefined, salesVoucherType: string, receiveOrderId?: number | null | undefined, trustSalesDivision: string, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, receiveOrder?: { __typename?: 'ReceiveOrderHeader', estimateId?: number | null | undefined, receiveOrderRemarks?: string | null | undefined, receiveOrderType: string, receiveOrderMemo?: string | null | undefined } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined, shipmentDetail?: { __typename?: 'ShipmentDetail', deliveryOrderDetailStatus: string, shipment?: { __typename?: 'Shipment', deliveryOrderMemo?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SalesDetailWTaxSummaryFieldsFragment = { __typename?: 'SalesDetailWTaxSummary', count?: number | null | undefined, salesUnitPrice?: number | null | undefined, grossProfit?: number | null | undefined, grossProfitRate?: number | null | undefined, excludeTax?: number | null | undefined, targetTen?: number | null | undefined, taxTen?: number | null | undefined, targetEight?: number | null | undefined, taxEight?: number | null | undefined, taxFree?: number | null | undefined, notApplicable?: number | null | undefined, total?: number | null | undefined };

export type SalesDetailWTaxDetailFieldsFragment = { __typename?: 'SalesDetailWTaxDetail', salesDate?: string | null | undefined, salesId?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, totalQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, grossProfit?: number | null | undefined, salesRemark?: string | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, salesTradeDivision?: string | null | undefined, closingStatusCode?: string | null | undefined, salesTaxType?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesUserName?: string | null | undefined, estimateId?: string | null | undefined, receiveOrderId?: string | null | undefined, receiveOrderType?: string | null | undefined, createUserCode?: string | null | undefined, createUserName?: string | null | undefined, deliveryOrderDetailStatus?: string | null | undefined, trustSalesDivision?: string | null | undefined, shipmentId?: string | null | undefined, trustInventoryId?: string | null | undefined, receiveOrderMemo?: string | null | undefined, deliveryOrderMemo?: string | null | undefined };

export type SearchSalesDetailWTaxQueryVariables = Exact<{
  filter?: InputMaybe<SalesDetailWTaxFilter>;
}>;


export type SearchSalesDetailWTaxQuery = { __typename?: 'Query', salesDetailWTax?: { __typename?: 'SalesDetailWTax', summary?: { __typename?: 'SalesDetailWTaxSummary', count?: number | null | undefined, salesUnitPrice?: number | null | undefined, grossProfit?: number | null | undefined, grossProfitRate?: number | null | undefined, excludeTax?: number | null | undefined, targetTen?: number | null | undefined, taxTen?: number | null | undefined, targetEight?: number | null | undefined, taxEight?: number | null | undefined, taxFree?: number | null | undefined, notApplicable?: number | null | undefined, total?: number | null | undefined } | null | undefined, details?: Array<{ __typename?: 'SalesDetailWTaxDetail', salesDate?: string | null | undefined, salesId?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, divisionCode?: string | null | undefined, divisionName?: string | null | undefined, receiveDetailTradeType?: string | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, totalQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, grossProfit?: number | null | undefined, salesRemark?: string | null | undefined, detailMemo?: string | null | undefined, taxationDivision?: string | null | undefined, salesTradeDivision?: string | null | undefined, closingStatusCode?: string | null | undefined, salesTaxType?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesUserCode?: string | null | undefined, salesUserName?: string | null | undefined, estimateId?: string | null | undefined, receiveOrderId?: string | null | undefined, receiveOrderType?: string | null | undefined, createUserCode?: string | null | undefined, createUserName?: string | null | undefined, deliveryOrderDetailStatus?: string | null | undefined, trustSalesDivision?: string | null | undefined, shipmentId?: string | null | undefined, trustInventoryId?: string | null | undefined, receiveOrderMemo?: string | null | undefined, deliveryOrderMemo?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type TaxDetailForTrustFieldsFragment = { __typename?: 'ShipmentTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined };

export type SalesForTrustFieldsFragment = { __typename?: 'Sales', salesId: string, trustSalesDivision: string, salesDate: string, salesRemark?: string | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined };

export type SearchSalesForTrustQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustSalesFilter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
}>;


export type SearchSalesForTrustQuery = { __typename?: 'Query', searchTrustSales?: { __typename?: 'SalesConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', salesId: string, trustSalesDivision: string, salesDate: string, salesRemark?: string | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined, division?: { __typename?: 'Division', divisionName: string } | null | undefined, salesUser?: { __typename?: 'User', userName: string } | null | undefined, allShipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SendOrderDetailFieldsFragment = { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined };

export type SendOrderFieldsFragment = { __typename?: 'SendOrder', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, shippingName?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, divisionCode: string, deliveryStatus: string, searchKeyword?: string | null | undefined, requestType: string, approvalStatus: string, remandMemo?: string | null | undefined, requestDate?: string | null | undefined, requestUserName?: string | null | undefined, id: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined, balanceData?: number | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, purposeGroup?: string | null | undefined } | null | undefined, purchase?: { __typename?: 'Purchase', payment?: { __typename?: 'Payment', withdrawalState: string } | null | undefined } | null | undefined };

export type SendOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendOrderQuery = { __typename?: 'Query', sendOrder?: { __typename?: 'SendOrder', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, shippingName?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, divisionCode: string, deliveryStatus: string, searchKeyword?: string | null | undefined, requestType: string, approvalStatus: string, remandMemo?: string | null | undefined, requestDate?: string | null | undefined, requestUserName?: string | null | undefined, id: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string, taxRoundType?: string | null | undefined, priceRoundType?: string | null | undefined, balanceData?: number | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, purposeGroup?: string | null | undefined } | null | undefined, purchase?: { __typename?: 'Purchase', payment?: { __typename?: 'Payment', withdrawalState: string } | null | undefined } | null | undefined } | null | undefined };

export type SendOrderMutationFieldsFragment = { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateSendOrderMutationVariables = Exact<{
  input: CreateSendOrderInput;
}>;


export type CreateSendOrderMutation = { __typename?: 'Mutation', createSendOrder?: { __typename?: 'CreateSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type CreateReturnSendOrderMutationVariables = Exact<{
  input: CreateReturnSendOrderInput;
}>;


export type CreateReturnSendOrderMutation = { __typename?: 'Mutation', createReturnSendOrder?: { __typename?: 'CreateReturnSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateSendOrderMutationVariables = Exact<{
  input: UpdateSendOrderInput;
}>;


export type UpdateSendOrderMutation = { __typename?: 'Mutation', updateSendOrder?: { __typename?: 'UpdateSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateReturnSendOrderMutationVariables = Exact<{
  input: UpdateReturnSendOrderInput;
}>;


export type UpdateReturnSendOrderMutation = { __typename?: 'Mutation', updateReturnSendOrder?: { __typename?: 'UpdateReturnSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateSendOrderBulkApprovalMutationVariables = Exact<{
  input: UpdateSendOrderBulkApprovalInput;
}>;


export type UpdateSendOrderBulkApprovalMutation = { __typename?: 'Mutation', updateSendOrderBulkApproval?: { __typename?: 'UpdateSendOrderBulkApprovalPayload', result?: boolean | null | undefined } | null | undefined };

export type DeleteSendOrderMutationVariables = Exact<{
  input: DeleteSendOrderInput;
}>;


export type DeleteSendOrderMutation = { __typename?: 'Mutation', deleteSendOrder?: { __typename?: 'DeleteSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteReturnSendOrderMutationVariables = Exact<{
  input: DeleteReturnSendOrderInput;
}>;


export type DeleteReturnSendOrderMutation = { __typename?: 'Mutation', deleteReturnSendOrder?: { __typename?: 'DeleteReturnSendOrderPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateSendOrderApprovalMutationVariables = Exact<{
  input: UpdateSendOrderApprovalInput;
}>;


export type UpdateSendOrderApprovalMutation = { __typename?: 'Mutation', updateSendOrderApproval?: { __typename?: 'UpdateSendOrderApprovalPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateSendOrderRemandMutationVariables = Exact<{
  input: UpdateSendOrderRemandInput;
}>;


export type UpdateSendOrderRemandMutation = { __typename?: 'Mutation', updateSendOrderRemand?: { __typename?: 'UpdateSendOrderRemandPayload', sendOrder?: { __typename?: 'SendOrder', id: string, orderId: string, orderDate: string, vendorCode: string, sendOrderDetails?: { __typename?: 'SendOrderDetailConnection', edges: Array<{ __typename?: 'SendOrderDetailEdge', node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, groupNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, maxPurchaseOrderQty?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, externalQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type VendorForSendOrderFieldsFragment = { __typename?: 'Vendor', vendorCode: string, vendorName: string, purposeGroup?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, balanceData?: number | null | undefined };

export type SearchVendorForSendOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchVendorForSendOrderQuery = { __typename?: 'Query', vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, purposeGroup?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, balanceData?: number | null | undefined } | null | undefined };

export type WarehouseForSendOrderFieldsFragment = { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined };

export type SearchWarehouseForSendOrderQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseFilter>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseSortEnum>> | InputMaybe<WarehouseSortEnum>>;
}>;


export type SearchWarehouseForSendOrderQuery = { __typename?: 'Query', searchWarehouse?: { __typename?: 'WarehouseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WarehouseEdge', cursor: string, node?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchSendOrderDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderDetailFilter>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderDetailSortEnum>> | InputMaybe<SendOrderDetailSortEnum>>;
}>;


export type SearchSendOrderDetailQuery = { __typename?: 'Query', searchSendOrderDetail?: { __typename?: 'SendOrderDetailConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SendOrderDetailEdge', cursor: string, node?: { __typename?: 'SendOrderDetail', id: string, orderId: string, numbering: string, frontNumbering: number, orderTradeTypeCode: string, orderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, orderQuantity?: number | null | undefined, totalQuantity?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, purchasePrice?: number | null | undefined, purchasePriceDollar?: number | null | undefined, detailMemo?: string | null | undefined, receivedQuantity?: number | null | undefined, taxationDivision?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', productName: string, attr1?: string | null | undefined, attr2?: string | null | undefined, clothGroup?: string | null | undefined, unitYenDecimalDigits?: number | null | undefined, unitDollarDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, productGroup1?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup2?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, productGroup3?: { __typename?: 'ProductGroup', productGroupName: string } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', divisionCode?: string | null | undefined } | null | undefined, sendOrder?: { __typename?: 'SendOrder', orderId: string, orderDate: string, deliveryDate?: string | null | undefined, orderType: string, orderMemo?: string | null | undefined, vendorCode: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingCode?: string | null | undefined, poCode?: string | null | undefined, orderRemarks?: string | null | undefined, vendor?: { __typename?: 'Vendor', vendorName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SendOrderLotFieldsFragment = { __typename?: 'SendOrderLot', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, delFlg: string, id: string };

export type SearchSendOrderLotQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderLotFilter>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderLotSortEnum>> | InputMaybe<SendOrderLotSortEnum>>;
}>;


export type SearchSendOrderLotQuery = { __typename?: 'Query', searchSendOrderLot?: { __typename?: 'SendOrderLotConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SendOrderLotEdge', cursor: string, node?: { __typename?: 'SendOrderLot', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, delFlg: string, id: string, productVariants?: { __typename?: 'ProductVariantConnection', edges: Array<{ __typename?: 'ProductVariantEdge', node?: { __typename?: 'ProductVariant', lotGroupCode?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateSendOrderLotMutationVariables = Exact<{
  input: CreateSendOrderLotInput;
}>;


export type CreateSendOrderLotMutation = { __typename?: 'Mutation', createSendOrderLot?: { __typename?: 'CreateSendOrderLotPayload', sendOrderLot?: { __typename?: 'SendOrderLot', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, delFlg: string, id: string } | null | undefined } | null | undefined };

export type UpdateSendOrderLotMutationVariables = Exact<{
  input: UpdateSendOrderLotInput;
}>;


export type UpdateSendOrderLotMutation = { __typename?: 'Mutation', updateSendOrderLot?: { __typename?: 'UpdateSendOrderLotPayload', sendOrderLot?: { __typename?: 'SendOrderLot', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, delFlg: string, id: string } | null | undefined } | null | undefined };

export type DeleteSendOrderLotMutationVariables = Exact<{
  input: DeleteSendOrderLotInput;
}>;


export type DeleteSendOrderLotMutation = { __typename?: 'Mutation', deleteSendOrderLot?: { __typename?: 'DeleteSendOrderLotPayload', sendOrderLot?: { __typename?: 'SendOrderLot', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, lotGroupCode: string, lotGroupName: string, minimumLot: number, purchaseOrderLeadTime?: number | null | undefined, delFlg: string, id: string } | null | undefined } | null | undefined };

export type UpdateSendOrderPurchaseUnitPriceMutationVariables = Exact<{
  input: UpdateSendOrderDetailPurchaseUnitPriceInput;
}>;


export type UpdateSendOrderPurchaseUnitPriceMutation = { __typename?: 'Mutation', updateSendOrderPurchaseUnitPrice?: { __typename?: 'UpdateSendOrderDetailPurchaseUnitPricePayload', sendOrderDetail?: Array<{ __typename?: 'SendOrderDetail', orderId: string, numbering: string, versionUuid: string, id: string } | null | undefined> | null | undefined } | null | undefined };

export type SearchSendOrderPurchaseUnitPriceUpdateQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderPurchaseUnitPriceUpdateFilter>;
}>;


export type SearchSendOrderPurchaseUnitPriceUpdateQuery = { __typename?: 'Query', searchSendOrderPurchaseUnitPriceUpdate?: { __typename?: 'SearchSendOrderPurchaseUnitPriceConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchSendOrderPurchaseUnitPriceEdge', cursor: string, node?: { __typename?: 'SearchSendOrderPurchaseUnitPrice', orderId?: string | null | undefined, orderDate?: string | null | undefined, vendorCode?: string | null | undefined, vendorName?: string | null | undefined, orderQuantity?: number | null | undefined, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, productPurchaseUnitPriceYen?: number | null | undefined, productPurchaseUnitPriceDollar?: number | null | undefined, rate?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SendOrderViewFieldsFragment = { __typename?: 'SendOrderView', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, vendorCode: string, divisionCode: string, orderType: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingName?: string | null | undefined, orderRemarks?: string | null | undefined, orderMemo?: string | null | undefined, vendorName: string, vendorUnitpriceType?: string | null | undefined, detailCount?: number | null | undefined, completedDetailCount?: number | null | undefined, undeliveredDetailCount?: number | null | undefined, deliveryStatus?: string | null | undefined, taxExcludeTotal?: number | null | undefined, id: string };

export type SearchSendOrderViewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderViewFilter>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderViewSortEnum>> | InputMaybe<SendOrderViewSortEnum>>;
}>;


export type SearchSendOrderViewQuery = { __typename?: 'Query', searchSendOrderView?: { __typename?: 'SendOrderViewConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SendOrderViewEdge', cursor: string, node?: { __typename?: 'SendOrderView', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, orderId: string, orderDate: string, vendorCode: string, divisionCode: string, orderType: string, vendorTradeDivision: string, vendorTaxType: string, shippingTypeCode: string, shippingName?: string | null | undefined, orderRemarks?: string | null | undefined, orderMemo?: string | null | undefined, vendorName: string, vendorUnitpriceType?: string | null | undefined, detailCount?: number | null | undefined, completedDetailCount?: number | null | undefined, undeliveredDetailCount?: number | null | undefined, deliveryStatus?: string | null | undefined, taxExcludeTotal?: number | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type SendOrderViewUnapprovedFieldsFragment = { __typename?: 'SendOrderView', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, requestUserCode?: string | null | undefined, requestUserName?: string | null | undefined, approvalStatus: string, orderDate: string, orderId: string, poCode?: string | null | undefined, vendorCode: string, vendorName: string, taxExcludeTotal?: number | null | undefined, detailCount?: number | null | undefined, vendorTaxType: string, vendorUnitpriceType?: string | null | undefined, shippingTypeCode: string, shippingName?: string | null | undefined, id: string };

export type SearchSendOrderViewUnapprovedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSendOrderViewUnapprovedFilter>;
  sort?: InputMaybe<Array<InputMaybe<SendOrderViewSortEnum>> | InputMaybe<SendOrderViewSortEnum>>;
}>;


export type SearchSendOrderViewUnapprovedQuery = { __typename?: 'Query', searchSendOrderViewUnapproved?: { __typename?: 'SendOrderViewConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SendOrderViewEdge', cursor: string, node?: { __typename?: 'SendOrderView', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, requestUserCode?: string | null | undefined, requestUserName?: string | null | undefined, approvalStatus: string, orderDate: string, orderId: string, poCode?: string | null | undefined, vendorCode: string, vendorName: string, taxExcludeTotal?: number | null | undefined, detailCount?: number | null | undefined, vendorTaxType: string, vendorUnitpriceType?: string | null | undefined, shippingTypeCode: string, shippingName?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type ShipmentFieldsFragment = { __typename?: 'Shipment', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId: string, receiveOrderId: number, id: string };

export type ShipmentTaxDetailFieldsFragment = { __typename?: 'ShipmentTaxDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId?: number | null | undefined, taxationDivision: string, taxRoundType: string, taxExcluded?: number | null | undefined, exciseTax?: number | null | undefined, id: string };

export type ReceiveForShipmentFieldsFragment = { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, estimateId?: number | null | undefined, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, returnDivision?: string | null | undefined, receiveOrderMemo?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, salesTaxType: string, receiveOrderRemarks?: string | null | undefined, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUser?: string | null | undefined, ratio?: number | null | undefined, balanceData?: number | null | undefined, creditLimitPrice?: number | null | undefined, userDivisionCode: string, customerUnitpriceType?: string | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined, demand?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, numbering: string, frontNumbering: number, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ReceiveForShipmentDetailFieldsFragment = { __typename?: 'ReceiveOrderDetail', id: string, numbering: string, frontNumbering: number, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined };

export type ShipmentSearchFieldsFragment = { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, deliveryOrderMemo?: string | null | undefined, customerWarehouseCode?: string | null | undefined, receiveOrderId: number, salesRemark?: string | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ShipmentDetailsSearchFieldsFragment = { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined };

export type SalesForShipmentFragment = { __typename?: 'Sales', salesId: string, demandId?: number | null | undefined, closingTiming?: string | null | undefined, closingStatusCode: string, demand?: { __typename?: 'Demand', collectExpectedDate: string, clearingState?: string | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined } | null | undefined, demandCustomer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, deliveryDestinationName: string } | null | undefined };

export type SearchShipmentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchShipmentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentSortEnum>> | InputMaybe<ShipmentSortEnum>>;
}>;


export type SearchShipmentQuery = { __typename?: 'Query', searchShipment?: { __typename?: 'ShipmentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ShipmentEdge', cursor: string, node?: { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, deliveryOrderMemo?: string | null | undefined, customerWarehouseCode?: string | null | undefined, receiveOrderId: number, updateUserName: string, updateDate: any, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', sellingPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type ShipmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ShipmentQuery = { __typename?: 'Query', shipment?: { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, deliveryOrderMemo?: string | null | undefined, customerWarehouseCode?: string | null | undefined, receiveOrderId: number, salesRemark?: string | null | undefined, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, versionUuid: string, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type ShipmentMutationFieldsFragment = { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, receiveOrder?: { __typename?: 'ReceiveOrderHeader', customerCode: string } | null | undefined, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentInput;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment?: { __typename?: 'CreateShipmentPayload', shipment?: { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, receiveOrder?: { __typename?: 'ReceiveOrderHeader', customerCode: string } | null | undefined, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateShipmentMutationVariables = Exact<{
  input: UpdateShipmentInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment?: { __typename?: 'UpdateShipmentPayload', shipment?: { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, receiveOrder?: { __typename?: 'ReceiveOrderHeader', customerCode: string } | null | undefined, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteShipmentMutationVariables = Exact<{
  input: DeleteShipmentInput;
}>;


export type DeleteShipmentMutation = { __typename?: 'Mutation', deleteShipment?: { __typename?: 'DeleteShipmentPayload', shipment?: { __typename?: 'Shipment', id: string, deliveryOrderId: string, deliveryOrderDate: string, receiveOrder?: { __typename?: 'ReceiveOrderHeader', customerCode: string } | null | undefined, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type ReceiveForShipmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReceiveForShipmentQuery = { __typename?: 'Query', receiveOrderHeader?: { __typename?: 'ReceiveOrderHeader', id: string, receiveOrderId: string, estimateId?: number | null | undefined, receiveOrderDate: string, deliveryDate?: string | null | undefined, receiveOrderType: string, returnDivision?: string | null | undefined, receiveOrderMemo?: string | null | undefined, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, salesTradeDivision: string, salesTaxType: string, receiveOrderRemarks?: string | null | undefined, versionUuid: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, customerGroup?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, customerUser?: string | null | undefined, ratio?: number | null | undefined, balanceData?: number | null | undefined, creditLimitPrice?: number | null | undefined, userDivisionCode: string, customerUnitpriceType?: string | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined, demand?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, salesUser?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, receiveOrderDetails?: { __typename?: 'ReceiveOrderDetailConnection', edges: Array<{ __typename?: 'ReceiveOrderDetailEdge', node?: { __typename?: 'ReceiveOrderDetail', id: string, numbering: string, frontNumbering: number, receiveDetailTradeType: string, receiveOrderDetailStatus: string, approvalStatus: string, productCode?: string | null | undefined, janCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, receiveOrderQuantity?: number | null | undefined, receiveOrderDecisionQuantity?: number | null | undefined, receiveOrderUnit?: number | null | undefined, receiveOrderPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, deliveredQuantity?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, product?: { __typename?: 'ProductNoPriceView', unitYenDecimalDigits?: number | null | undefined, quantityDecimalDigits?: number | null | undefined, allRemainReceiveQuantity?: number | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, stock?: { __typename?: 'Stock', allQuantity?: number | null | undefined } | null | undefined } | null | undefined, Warehouse?: { __typename?: 'Warehouse', warehouseCode: string, warehouseName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchSalesForShipmentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchSalesFromDeliveryOrderId2Filter>;
  sort?: InputMaybe<Array<InputMaybe<SalesSortEnum>> | InputMaybe<SalesSortEnum>>;
}>;


export type SearchSalesForShipmentQuery = { __typename?: 'Query', searchSalesFromDeliveryOrderId2?: { __typename?: 'SalesConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SalesEdge', node?: { __typename?: 'Sales', salesId: string, demandId?: number | null | undefined, closingTiming?: string | null | undefined, closingStatusCode: string, demand?: { __typename?: 'Demand', collectExpectedDate: string, clearingState?: string | null | undefined, customer?: { __typename?: 'Customer', customerName: string } | null | undefined } | null | undefined, demandCustomer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, deliver?: { __typename?: 'Deliver', deliveryDestinationCode: string, deliveryDestinationName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchShipmentReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchShipmentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentSortEnum>> | InputMaybe<ShipmentSortEnum>>;
}>;


export type SearchShipmentReportQuery = { __typename?: 'Query', searchShipment?: { __typename?: 'ShipmentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ShipmentEdge', cursor: string, node?: { __typename?: 'Shipment', deliveryOrderId: string, receiveOrder?: { __typename?: 'ReceiveOrderHeader', customer?: { __typename?: 'Customer', userDivisionCode: string, salesReport?: { __typename?: 'ReportLayout', reportLayoutCode: string, reportLayoutName: string, activeReportFlg: string, offsetFlg: string, offsetX: number, offsetY: number } | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchShipmentDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchShipmentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentSortEnum>> | InputMaybe<ShipmentSortEnum>>;
  detailFilter?: InputMaybe<ShipmentDetailFilter>;
  customSort?: InputMaybe<Array<InputMaybe<ShipmentCustomSortEnum>> | InputMaybe<ShipmentCustomSortEnum>>;
}>;


export type SearchShipmentDetailQuery = { __typename?: 'Query', searchShipment?: { __typename?: 'ShipmentConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'ShipmentEdge', cursor: string, node?: { __typename?: 'Shipment', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId: string, deliveryOrderDate: string, deliveryOrderMemo?: string | null | undefined, salesRemark?: string | null | undefined, receiveOrderId: number, shipmentDetails?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined, receiveOrder?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string, receiveOrderType: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, salesUserCode?: string | null | undefined, estimateId?: number | null | undefined, receiveOrderMemo?: string | null | undefined, receiveOrderDate: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, taxRoundType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, salesUser?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, exciseTax?: number | null | undefined, taxExcluded?: number | null | undefined, taxIncluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchShipmentDetailProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchShipmentFilter>;
  sort?: InputMaybe<Array<InputMaybe<ShipmentDetailSortEnum>> | InputMaybe<ShipmentDetailSortEnum>>;
}>;


export type SearchShipmentDetailProductQuery = { __typename?: 'Query', searchShipmentDetailProduct?: { __typename?: 'ShipmentDetailConnection', edges: Array<{ __typename?: 'ShipmentDetailEdge', node?: { __typename?: 'ShipmentDetail', id: string, deliveryOrderId: string, numbering: string, frontNumbering: number, deliveryDetailTradeType: string, deliveryOrderDetailStatus: string, janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, warehouseCode?: string | null | undefined, deliveryOrderQuantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, retailPrice?: number | null | undefined, sellingUnitPrice?: number | null | undefined, sellingPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, receiveOrderDetailNumbering?: number | null | undefined, detailMainFlg?: string | null | undefined, outWarehouseFlg?: string | null | undefined, totalQuantity?: number | null | undefined, totalTaxExcluded?: number | null | undefined, shipment?: { __typename?: 'Shipment', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, deliveryOrderId: string, deliveryOrderDate: string, deliveryOrderMemo?: string | null | undefined, salesRemark?: string | null | undefined, receiveOrderId: number, receiveOrder?: { __typename?: 'ReceiveOrderHeader', receiveOrderId: string, receiveOrderType: string, salesTradeDivision: string, salesTaxType: string, deliveryDestinationCode?: string | null | undefined, deliveryDestinationName?: string | null | undefined, receiveOrderRemarks?: string | null | undefined, salesUserCode?: string | null | undefined, estimateId?: number | null | undefined, receiveOrderMemo?: string | null | undefined, receiveOrderDate: string, customer?: { __typename?: 'Customer', customerCode: string, customerName: string, taxRoundType?: string | null | undefined } | null | undefined, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, salesUser?: { __typename?: 'User', userCode: string, userName: string } | null | undefined } | null | undefined, shipmentTaxDetails?: { __typename?: 'ShipmentTaxDetailConnection', edges: Array<{ __typename?: 'ShipmentTaxDetailEdge', node?: { __typename?: 'ShipmentTaxDetail', taxationDivision: string, exciseTax?: number | null | undefined, taxExcluded?: number | null | undefined, taxIncluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchShopsTrustInventoryQueryVariables = Exact<{
  filter?: InputMaybe<SearchShopsTrustInventoryFilter>;
}>;


export type SearchShopsTrustInventoryQuery = { __typename?: 'Query', searchShopsTrustInventory?: Array<{ __typename?: 'SearchShopsTrustInventoryDetail', trustInventoryId: number, inventoryMonth: any, inventoryFrom: any, inventoryTo: any, customerCode: string, customerName: string, divisionCode: string, divisionName: string, salesUserCode: string, salesUserName: string, inventoryStatus?: string | null | undefined, inventoryStatusLabel?: string | null | undefined, remark?: string | null | undefined } | null | undefined> | null | undefined };

export type SearchShopsTrustInventoryOperatorsQueryVariables = Exact<{
  filter?: InputMaybe<SearchShopsTrustInventoryOperatorsFilter>;
}>;


export type SearchShopsTrustInventoryOperatorsQuery = { __typename?: 'Query', searchShopsTrustInventoryOperators?: Array<{ __typename?: 'SearchShopsTrustInventoryOperators', trustInventoryId: number, operatorType: string, operatorCode?: string | null | undefined, operatorBelong?: string | null | undefined, operatorName?: string | null | undefined, operationAt?: any | null | undefined } | null | undefined> | null | undefined };

export type ApproveTrustInventoryMutationVariables = Exact<{
  input: ApproveTrustInventoryInput;
}>;


export type ApproveTrustInventoryMutation = { __typename?: 'Mutation', approveTrustInventory?: { __typename?: 'ApproveTrustInventoryPayload', trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined };

export type SendBackTrustInventoryMutationVariables = Exact<{
  input: SendBackTrustInventoryInput;
}>;


export type SendBackTrustInventoryMutation = { __typename?: 'Mutation', sendBackTrustInventory?: { __typename?: 'SendBackTrustInventoryPayload', trustInventory?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined };

export type StockAdjustFieldsFragment = { __typename?: 'StockAdjust', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, adjustDate: string, warehouseCode: string, adjustMemo?: string | null | undefined, id: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseName: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined };

export type StockAdjustDetailFieldsFragment = { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined };

export type SearchStockAdjustQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAdjustFilter>;
}>;


export type SearchStockAdjustQuery = { __typename?: 'Query', searchStockAdjust?: { __typename?: 'StockAdjustConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAdjustEdge', cursor: string, node?: { __typename?: 'StockAdjust', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, adjustDate: string, warehouseCode: string, adjustMemo?: string | null | undefined, id: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseName: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type StockAdjustQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StockAdjustQuery = { __typename?: 'Query', stockAdjust?: { __typename?: 'StockAdjust', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, adjustDate: string, warehouseCode: string, adjustMemo?: string | null | undefined, id: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined, warehouse?: { __typename?: 'Warehouse', warehouseName: string, division?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined } | null | undefined } | null | undefined };

export type StockAdjustMutationFieldsFragment = { __typename?: 'StockAdjust', adjustId: string, versionUuid: string, adjustDate: string, warehouseCode: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateStockAdjustMutationVariables = Exact<{
  input: CreateStockAdjustInput;
}>;


export type CreateStockAdjustMutation = { __typename?: 'Mutation', createStockAdjust?: { __typename?: 'CreateStockAdjustPayload', stockAdjust?: { __typename?: 'StockAdjust', adjustId: string, versionUuid: string, adjustDate: string, warehouseCode: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateStockAdjustMutationVariables = Exact<{
  input: UpdateStockAdjustInput;
}>;


export type UpdateStockAdjustMutation = { __typename?: 'Mutation', updateStockAdjust?: { __typename?: 'UpdateStockAdjustPayload', stockAdjust?: { __typename?: 'StockAdjust', adjustId: string, versionUuid: string, adjustDate: string, warehouseCode: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteStockAdjustMutationVariables = Exact<{
  input: DeleteStockAdjustInput;
}>;


export type DeleteStockAdjustMutation = { __typename?: 'Mutation', deleteStockAdjust?: { __typename?: 'DeleteStockAdjustPayload', stockAdjust?: { __typename?: 'StockAdjust', adjustId: string, versionUuid: string, adjustDate: string, warehouseCode: string, stockAdjustDetails?: { __typename?: 'StockAdjustDetailConnection', edges: Array<{ __typename?: 'StockAdjustDetailEdge', node?: { __typename?: 'StockAdjustDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, adjustId: string, numbering: string, janCode: string, productCode: string, stockQuantity: number, adjustQuantity: number, damageQuantity: number, unitCost: number, detailMemo?: string | null | undefined, id: string, productVariant?: { __typename?: 'ProductVariant', product?: { __typename?: 'Product', productName: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type StockAlertQueryVariables = Exact<{
  productDivisionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type StockAlertQuery = { __typename?: 'Query', stockAlert?: { __typename?: 'StockAlert', purchaseOrder?: number | null | undefined, division?: number | null | undefined } | null | undefined };

export type SearchStockListByProductQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByProductFilter>;
}>;


export type SearchStockListByProductQuery = { __typename?: 'Query', searchStockListByProduct?: { __typename?: 'StockListByProductConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockListByProductEdge', cursor: string, node?: { __typename?: 'StockListByProduct', janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, retailPrice?: number | null | undefined, domOverFlg?: string | null | undefined, manufacturer?: string | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, tags?: any | null | undefined, discontinueFlg?: Array<string | null | undefined> | null | undefined, allQuantity?: number | null | undefined, allStockPrice?: number | null | undefined, sendBaseQuantity?: number | null | undefined, divisionBaseQuantity?: number | null | undefined, mainQuantity?: number | null | undefined, mainStockPrice?: number | null | undefined, externalQuantity?: number | null | undefined, externalStockPrice?: number | null | undefined, outsourceQuantity?: number | null | undefined, outsourceStockPrice?: number | null | undefined, receivePossibleQuantity?: number | null | undefined, receiveRemainQuantity?: number | null | undefined, sendRemainQuantity?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchStockListByDivisionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByDivisionFilter>;
}>;


export type SearchStockListByDivisionQuery = { __typename?: 'Query', searchStockListByDivision?: { __typename?: 'StockListByDivisionConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockListByDivisionEdge', cursor: string, node?: { __typename?: 'StockListByDivision', janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, retailPrice?: number | null | undefined, domOverFlg?: string | null | undefined, manufacturer?: string | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, tags?: any | null | undefined, discontinueFlg?: Array<string | null | undefined> | null | undefined, divisionName?: string | null | undefined, allQuantity?: number | null | undefined, allStockPrice?: number | null | undefined, mainQuantity?: number | null | undefined, mainStockPrice?: number | null | undefined, externalQuantity?: number | null | undefined, externalStockPrice?: number | null | undefined, outsourceQuantity?: number | null | undefined, outsourceStockPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchStockListByWarehouseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockListByWarehouseFilter>;
}>;


export type SearchStockListByWarehouseQuery = { __typename?: 'Query', searchStockListByWarehouse?: { __typename?: 'StockListByWarehouseConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockListByWarehouseEdge', cursor: string, node?: { __typename?: 'StockListByWarehouse', janCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, retailPrice?: number | null | undefined, domOverFlg?: string | null | undefined, manufacturer?: string | null | undefined, productGroupName1?: string | null | undefined, productGroupName2?: string | null | undefined, productGroupName3?: string | null | undefined, tags?: any | null | undefined, discontinueFlg?: Array<string | null | undefined> | null | undefined, divisionName?: string | null | undefined, warehouseType?: string | null | undefined, warehouseName?: string | null | undefined, warehouseQuantity?: number | null | undefined, warehouseStockPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type StockAnalyticsInventoryFieldsFragment = { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string };

export type SearchStockAnalyticsInventoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsInventoryFilter>;
}>;


export type SearchStockAnalyticsInventoryQuery = { __typename?: 'Query', searchStockAnalyticsInventory?: { __typename?: 'StockAnalyticsConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsEdge', cursor: string, node?: { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchStockAnalyticsInventoryUniqueQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsInventoryFilter>;
}>;


export type SearchStockAnalyticsInventoryUniqueQuery = { __typename?: 'Query', searchStockAnalyticsInventoryUnique?: { __typename?: 'StockAnalyticsConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsEdge', cursor: string, node?: { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string } | null | undefined } | null | undefined> } | null | undefined };

export type InventoryDateForStockAnalyticsInventoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InventoryDateForStockAnalyticsInventoryQuery = { __typename?: 'Query', inventory?: { __typename?: 'Inventory', inventoryBaseFrom: string, inventoryBaseTo: string } | null | undefined };

export type StockAnalyticsMonthFieldsFragment = { __typename?: 'StockAnalyticsMonth', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, yearMonth: string, isThisTerm: boolean, termMonthRange: number, termPrice: number, averageStockPrice: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, quantityPerDay: number, nowStockCycle: number, termAvrgPerDay: number, termAvrgStockCycle: number, dio: number, dioRank: string, isDetail?: boolean | null | undefined };

export type SearchStockAnalyticsMonthQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsMonthFilter>;
}>;


export type SearchStockAnalyticsMonthQuery = { __typename?: 'Query', searchStockAnalyticsMonth?: { __typename?: 'StockAnalyticsMonthConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsMonthEdge', cursor: string, node?: { __typename?: 'StockAnalyticsMonth', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, yearMonth: string, isThisTerm: boolean, termMonthRange: number, termPrice: number, averageStockPrice: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, quantityPerDay: number, nowStockCycle: number, termAvrgPerDay: number, termAvrgStockCycle: number, dio: number, dioRank: string, isDetail?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchStockAnalyticsMonthUniqueQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsMonthFilter>;
}>;


export type SearchStockAnalyticsMonthUniqueQuery = { __typename?: 'Query', searchStockAnalyticsMonthUnique?: { __typename?: 'StockAnalyticsMonthConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsMonthEdge', cursor: string, node?: { __typename?: 'StockAnalyticsMonth', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, yearMonth: string, isThisTerm: boolean, termMonthRange: number, termPrice: number, averageStockPrice: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, quantityPerDay: number, nowStockCycle: number, termAvrgPerDay: number, termAvrgStockCycle: number, dio: number, dioRank: string, isDetail?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type StockAnalyticsFieldsFragment = { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string };

export type SearchStockAnalyticsTermQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsTermFilter>;
}>;


export type SearchStockAnalyticsTermQuery = { __typename?: 'Query', searchStockAnalyticsTerm?: { __typename?: 'StockAnalyticsConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsEdge', cursor: string, node?: { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string } | null | undefined } | null | undefined> } | null | undefined };

export type SearchStockAnalyticsTermUniqueQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockAnalyticsTermFilter>;
}>;


export type SearchStockAnalyticsTermUniqueQuery = { __typename?: 'Query', searchStockAnalyticsTermUnique?: { __typename?: 'StockAnalyticsConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'StockAnalyticsEdge', cursor: string, node?: { __typename?: 'StockAnalytics', janCode: string, productCode: string, productName: string, lotGroupCode: string, lotGroupName: string, domOverFlg: string, manufacturer: string, productGroupName1: string, productGroupName2: string, productGroupName3: string, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseOrderLeadTime?: number | null | undefined, minimumLot?: number | null | undefined, mainQuantity: number, externalQuantity: number, outsourceQuantity: number, orderRemainQuantity: number, startMainQuantity: number, startExternalQuantity: number, startOutsourceQuantity: number, startStockQuantity: number, endMainQuantity: number, endExternalQuantity: number, endOutsourceQuantity: number, endStockQuantity: number, inTotal: number, outTotal: number, purchase: number, trustInput: number, buyReturn: number, directReturn: number, trustReturn: number, divisionInput: number, productionInput: number, adjustInput: number, withinCompanyInput: number, buyOutput: number, trustSales: number, directOutput: number, trustOutput: number, purchaseReturn: number, divisionOutput: number, productionOutput: number, disposal: number, adjustOutput: number, withinCompanyOutput: number, term: number, quantityPerDay: number, nowStockCycle: number, averageStockPrice: number, totalSalesUnitPrice: number, dio: number, dioRank: string } | null | undefined } | null | undefined> } | null | undefined };

export type StockByWarehouseFieldsFragment = { __typename?: 'SearchStockByWarehouse', divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number };

export type SearchStockByWarehouseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchStockByWarehouseFilter>;
}>;


export type SearchStockByWarehouseQuery = { __typename?: 'Query', searchStockByWarehouse?: { __typename?: 'SearchStockByWarehouseConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchStockByWarehouseEdge', cursor: string, node?: { __typename?: 'SearchStockByWarehouse', divisionCode: string, divisionName: string, warehouseCode: string, warehouseName: string, quantity: number } | null | undefined } | null | undefined> } | null | undefined };

export type SearchTermsAndConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchTermsAndConditionsQuery = { __typename?: 'Query', searchTermsAndConditions?: { __typename?: 'TermsAndConditionsConnection', edges: Array<{ __typename?: 'TermsAndConditionsEdge', node?: { __typename?: 'TermsAndConditions', termsId: string, enactmentDate: any } | null | undefined } | null | undefined> } | null | undefined };

export type TradeHistoryDialogFieldsFragment = { __typename?: 'SearchTradeHistoryForDialog', tradeDate: any, customerName: string, quantity: number };

export type SearchTradeHistoryForDialogQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryForDialogFilter>;
}>;


export type SearchTradeHistoryForDialogQuery = { __typename?: 'Query', searchTradeHistoryForDialog?: { __typename?: 'SearchTradeHistoryForDialogConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchTradeHistoryForDialogEdge', cursor: string, node?: { __typename?: 'SearchTradeHistoryForDialog', tradeDate: any, customerName: string, quantity: number } | null | undefined } | null | undefined> } | null | undefined };

export type TradeHistoryFieldsFragment = { __typename?: 'TradeHistory', tradeHistoryId: string, tradeDate: string, tradeHistoryType: string, tradeTargetId?: string | null | undefined, tradeType?: string | null | undefined, tradeCode?: string | null | undefined, tradeHistoryTradeDivision?: string | null | undefined, tradeWarehouseCode?: string | null | undefined, targetType: string, targetCode: string, targetWarehouseCode: string, productCode?: string | null | undefined, quantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, targetWarehouse?: { __typename?: 'Warehouse', divisionCode?: string | null | undefined, warehouseName: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, tradeDivision?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, tradeCustomer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, tradeVendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string } | null | undefined };

export type SearchTradeHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryFilter>;
  sort?: InputMaybe<Array<InputMaybe<TradeHistorySortEnum>> | InputMaybe<TradeHistorySortEnum>>;
}>;


export type SearchTradeHistoryQuery = { __typename?: 'Query', searchTradeHistory?: { __typename?: 'TradeHistoryConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'TradeHistoryEdge', cursor: string, node?: { __typename?: 'TradeHistory', tradeHistoryId: string, tradeDate: string, tradeHistoryType: string, tradeTargetId?: string | null | undefined, tradeType?: string | null | undefined, tradeCode?: string | null | undefined, tradeHistoryTradeDivision?: string | null | undefined, tradeWarehouseCode?: string | null | undefined, targetType: string, targetCode: string, targetWarehouseCode: string, productCode?: string | null | undefined, quantity?: number | null | undefined, salesUnitPrice?: number | null | undefined, purchaseUnitPriceYen?: number | null | undefined, purchaseUnitPriceDollar?: number | null | undefined, targetWarehouse?: { __typename?: 'Warehouse', divisionCode?: string | null | undefined, warehouseName: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined } | null | undefined, tradeDivision?: { __typename?: 'Division', divisionCode: string, divisionName: string } | null | undefined, tradeCustomer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined, tradeVendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchTradeHistoryByMonthQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTradeHistoryByMonthFilter>;
}>;


export type SearchTradeHistoryByMonthQuery = { __typename?: 'Query', searchTradeHistoryByMonth?: { __typename?: 'TradeHistoryByMonthConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'TradeHistoryByMonthEdge', cursor: string, node?: { __typename?: 'TradeHistoryByMonth', month?: string | null | undefined, period?: string | null | undefined, averageUnitPrice?: number | null | undefined, inputQuantity?: number | null | undefined, outputQuantity?: number | null | undefined, moveQuantity?: number | null | undefined, inventory?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchTradeHistoryStockQueryVariables = Exact<{
  carryOverFilter?: InputMaybe<SearchTradeHistoryStockFilter>;
  currentStockFilter?: InputMaybe<SearchTradeHistoryStockFilter>;
}>;


export type SearchTradeHistoryStockQuery = { __typename?: 'Query', carryOver?: { __typename?: 'TradeHistoryStock', stock?: number | null | undefined } | null | undefined, currentStock?: { __typename?: 'TradeHistoryStock', stock?: number | null | undefined } | null | undefined };

export type SearchProductTradeHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<SearchProductViewFilter>;
}>;


export type SearchProductTradeHistoryQuery = { __typename?: 'Query', searchProductView?: { __typename?: 'ProductViewConnection', edges: Array<{ __typename?: 'ProductViewEdge', cursor: string, node?: { __typename?: 'ProductView', janCode: string, productCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDispTrustInventoryFieldsFragment = { __typename?: 'CreateDispTrustInventory', janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, physicalInventory?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined };

export type UpdateDispTrustInventoryFieldsFragment = { __typename?: 'UpdateDispTrustInventory', id: string, trustInventoryId?: number | null | undefined, warehouseCode?: string | null | undefined, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, trustInventoryDate?: any | null | undefined, userName?: string | null | undefined, inventoryControlUnit?: string | null | undefined, salesDate?: any | null | undefined, inventoryFrom?: any | null | undefined, inventoryTo?: any | null | undefined, trustInventoryRemark?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTaxType?: string | null | undefined, versionUuid?: string | null | undefined, salesId?: number | null | undefined, trustInventoryPath?: string | null | undefined, trustInventoryStatus?: string | null | undefined, sendBackFlg?: string | null | undefined, reasonForSendBack?: string | null | undefined, details?: { __typename?: 'DetailsConnection', edges: Array<{ __typename?: 'DetailsEdge', node?: { __typename?: 'Details', id: string, trustInventoryId?: string | null | undefined, numbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, physicalInventory?: number | null | undefined, damageQuantity?: number | null | undefined, salesQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type UpdateDispTrustInventoryDetailFieldsFragment = { __typename?: 'Details', id: string, trustInventoryId?: string | null | undefined, numbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, physicalInventory?: number | null | undefined, damageQuantity?: number | null | undefined, salesQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined };

export type TrustInventoryDetailFieldsFragment = { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined };

export type CreateDispTrustinventoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCreateDispTrustInventoryFilter>;
}>;


export type CreateDispTrustinventoryQuery = { __typename?: 'Query', createDispTrustinventory?: { __typename?: 'CreateDispTrustInventoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CreateDispTrustInventoryEdge', node?: { __typename?: 'CreateDispTrustInventory', janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, physicalInventory?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateDispTrustinventoryUniqueCodeQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCreateDispTrustInventoryFilter>;
}>;


export type CreateDispTrustinventoryUniqueCodeQuery = { __typename?: 'Query', createDispTrustinventoryUniqueCode?: { __typename?: 'CreateDispTrustInventoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CreateDispTrustInventoryEdge', node?: { __typename?: 'CreateDispTrustInventory', janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, physicalInventory?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type UpdateDispTrustinventoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateDispTrustinventoryQuery = { __typename?: 'Query', updateDispTrustinventory?: { __typename?: 'UpdateDispTrustInventory', id: string, trustInventoryId?: number | null | undefined, warehouseCode?: string | null | undefined, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, customerName?: string | null | undefined, trustInventoryDate?: any | null | undefined, userName?: string | null | undefined, inventoryControlUnit?: string | null | undefined, salesDate?: any | null | undefined, inventoryFrom?: any | null | undefined, inventoryTo?: any | null | undefined, trustInventoryRemark?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, salesTaxType?: string | null | undefined, versionUuid?: string | null | undefined, salesId?: number | null | undefined, trustInventoryPath?: string | null | undefined, trustInventoryStatus?: string | null | undefined, sendBackFlg?: string | null | undefined, reasonForSendBack?: string | null | undefined, details?: { __typename?: 'DetailsConnection', edges: Array<{ __typename?: 'DetailsEdge', node?: { __typename?: 'Details', id: string, trustInventoryId?: string | null | undefined, numbering?: number | null | undefined, janCode?: string | null | undefined, uniqueCode?: string | null | undefined, productCode?: string | null | undefined, productName?: string | null | undefined, beforeInventoryQuantity?: number | null | undefined, currentInputQuantity?: number | null | undefined, currentReturnQuantity?: number | null | undefined, currentStockQuantity?: number | null | undefined, physicalInventory?: number | null | undefined, damageQuantity?: number | null | undefined, salesQuantity?: number | null | undefined, sellingUnitPrice?: number | null | undefined, taxationDivision?: string | null | undefined, detailMemo?: string | null | undefined, salesUnitPrice?: number | null | undefined, unitYenDecimalDigits?: number | null | undefined, quantityDecimalDegits?: number | null | undefined, currentInputTotalTaxExcluded?: number | null | undefined, currentReturnTotalTaxExcluded?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type TrustInventoryMutationFieldsFragment = { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateTrustInventoryJanUnitMutationVariables = Exact<{
  input: CreateTrustInventoryJanUnitInput;
}>;


export type CreateTrustInventoryJanUnitMutation = { __typename?: 'Mutation', createTrustInventoryJanUnit?: { __typename?: 'CreateTrustInventoryJanUnitPayload', trustInventory?: { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type CreateTrustInventoryMutationVariables = Exact<{
  input: CreateTrustInventoryInput;
}>;


export type CreateTrustInventoryMutation = { __typename?: 'Mutation', createTrustInventory?: { __typename?: 'CreateTrustInventoryPayload', trustInventory?: { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateTrustInventoryJanUnitMutationVariables = Exact<{
  input: UpdateTrustInventoryJanUnitInput;
}>;


export type UpdateTrustInventoryJanUnitMutation = { __typename?: 'Mutation', updateTrustInventoryJanUnit?: { __typename?: 'UpdateTrustInventoryJanUnitPayload', trustInventory?: { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateTrustInventoryMutationVariables = Exact<{
  input: UpdateTrustInventoryInput;
}>;


export type UpdateTrustInventoryMutation = { __typename?: 'Mutation', updateTrustInventory?: { __typename?: 'UpdateTrustInventoryPayload', trustInventory?: { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteTrustInventoryMutationVariables = Exact<{
  input: DeleteTrustInventoryInput;
}>;


export type DeleteTrustInventoryMutation = { __typename?: 'Mutation', deleteTrustInventory?: { __typename?: 'DeleteTrustInventoryPayload', trustInventory?: { __typename?: 'TrustInventory', id: string, trustInventoryId: string, trustInventoryDate: string, warehouseCode: string, trustInventoryDetails?: { __typename?: 'TrustInventoryDetailConnection', edges: Array<{ __typename?: 'TrustInventoryDetailEdge', node?: { __typename?: 'TrustInventoryDetail', trustInventoryId: string, productCode?: string | null | undefined, currentStock: number, physicalInventory: number, damageQuantity: number, salesQuantity: number, sellingUnitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type SearchExistTrustInventoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchTrustInventoryFilter>;
}>;


export type SearchExistTrustInventoryQuery = { __typename?: 'Query', searchTrustInventory?: { __typename?: 'TrustInventoryConnection', edges: Array<{ __typename?: 'TrustInventoryEdge', node?: { __typename?: 'TrustInventory', trustInventoryId: string } | null | undefined } | null | undefined> } | null | undefined };

export type CustomerInfoTrustInventoryFieldsFragment = { __typename?: 'Customer', priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, inventoryControlUnit: string, salesTaxType?: string | null | undefined, customerUser?: string | null | undefined, customerCode: string, user?: { __typename?: 'User', userName: string } | null | undefined };

export type SearchCustomerInfoTrustInventoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchCustomerInfoTrustInventoryQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, inventoryControlUnit: string, salesTaxType?: string | null | undefined, customerUser?: string | null | undefined, customerCode: string, user?: { __typename?: 'User', userName: string } | null | undefined } | null | undefined };

export type SearchUnitHistoryFieldsFragment = { __typename?: 'SearchUnitHistory', slipDate?: any | null | undefined, slipNumber?: string | null | undefined, customerName?: string | null | undefined, quantity?: number | null | undefined, unitPrice?: number | null | undefined };

export type SearchUnitHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUnitHistoryFilter>;
}>;


export type SearchUnitHistoryQuery = { __typename?: 'Query', searchUnitHistory?: { __typename?: 'SearchUnitHistoryConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchUnitHistoryEdge', node?: { __typename?: 'SearchUnitHistory', slipDate?: any | null | undefined, slipNumber?: string | null | undefined, customerName?: string | null | undefined, quantity?: number | null | undefined, unitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CustomerPriceInUnitPriceFieldsFragment = { __typename?: 'CustomerPrice', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, customerCode: string, uniqueCode: string, sellingUnitPrice: number, id: string, customer?: { __typename?: 'Customer', customerName: string, salesTaxType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, product?: { __typename?: 'Product', janCode: string, productName: string, unitYenDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined } | null | undefined };

export type SearchCustomerPriceInUnitPriceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchCustomerPriceFilter>;
  sort?: InputMaybe<Array<InputMaybe<CustomerPriceSortEnum>> | InputMaybe<CustomerPriceSortEnum>>;
}>;


export type SearchCustomerPriceInUnitPriceQuery = { __typename?: 'Query', searchCustomerPrice?: { __typename?: 'CustomerPriceConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CustomerPriceEdge', cursor: string, node?: { __typename?: 'CustomerPrice', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, customerCode: string, uniqueCode: string, sellingUnitPrice: number, id: string, customer?: { __typename?: 'Customer', customerName: string, salesTaxType?: string | null | undefined, customerUnitpriceType?: string | null | undefined, ratio?: number | null | undefined } | null | undefined, product?: { __typename?: 'Product', janCode: string, productName: string, unitYenDecimalDigits?: number | null | undefined, taxationDivision?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchUnitHistoryTrustQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUnitHistoryTrustFilter>;
}>;


export type SearchUnitHistoryTrustQuery = { __typename?: 'Query', searchUnitHistoryTrust?: { __typename?: 'SearchUnitHistoryTrustConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'SearchUnitHistoryTrustEdge', node?: { __typename?: 'SearchUnitHistoryTrust', salesDate?: any | null | undefined, salesNumber?: string | null | undefined, customerName?: string | null | undefined, quantity?: number | null | undefined, unitPrice?: number | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type UserFieldsFragment = { __typename?: 'User', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, userCode: string, userName: string, userType: string, divisionCode?: string | null | undefined, subDivision1?: string | null | undefined, subDivision2?: string | null | undefined, subDivision3?: string | null | undefined, subDivision4?: string | null | undefined, email?: string | null | undefined, superUser?: string | null | undefined, approvalPrivilege?: string | null | undefined, systemAdminFlg?: string | null | undefined, priorityWarehouseCode?: string | null | undefined, trustInventoryApprovalPrivilege: string, delFlg: string, id: string };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, userCode: string, userName: string, userType: string, divisionCode?: string | null | undefined, subDivision1?: string | null | undefined, subDivision2?: string | null | undefined, subDivision3?: string | null | undefined, subDivision4?: string | null | undefined, email?: string | null | undefined, superUser?: string | null | undefined, approvalPrivilege?: string | null | undefined, systemAdminFlg?: string | null | undefined, priorityWarehouseCode?: string | null | undefined, trustInventoryApprovalPrivilege: string, delFlg: string, id: string } | null | undefined };

export type SearchUserQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchUserFilter>;
  sort?: InputMaybe<Array<InputMaybe<UserSortEnum>> | InputMaybe<UserSortEnum>>;
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser?: { __typename?: 'UserConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UserEdge', cursor: string, node?: { __typename?: 'User', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, userCode: string, userName: string, userType: string, divisionCode?: string | null | undefined, subDivision1?: string | null | undefined, subDivision2?: string | null | undefined, subDivision3?: string | null | undefined, subDivision4?: string | null | undefined, email?: string | null | undefined, superUser?: string | null | undefined, approvalPrivilege?: string | null | undefined, systemAdminFlg?: string | null | undefined, priorityWarehouseCode?: string | null | undefined, trustInventoryApprovalPrivilege: string, delFlg: string, id: string } | null | undefined } | null | undefined> } | null | undefined };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'User', userCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', userCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'DeleteUserPayload', user?: { __typename?: 'User', userCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type VendorFieldsFragment = { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined };

export type VendorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VendorQuery = { __typename?: 'Query', vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined };

export type CreateVendorMutationVariables = Exact<{
  input: CreateVendorInput;
}>;


export type CreateVendorMutation = { __typename?: 'Mutation', createVendor?: { __typename?: 'CreateVendorPayload', vendor?: { __typename?: 'Vendor', vendorCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type UpdateVendorMutationVariables = Exact<{
  input: UpdateVendorInput;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor?: { __typename?: 'UpdateVendorPayload', vendor?: { __typename?: 'Vendor', vendorCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type DeleteVendorMutationVariables = Exact<{
  input: DeleteVendorInput;
}>;


export type DeleteVendorMutation = { __typename?: 'Mutation', deleteVendor?: { __typename?: 'DeleteVendorPayload', vendor?: { __typename?: 'Vendor', vendorCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchVendorQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchVendorFilter>;
  sort?: InputMaybe<Array<InputMaybe<VendorSortEnum>> | InputMaybe<VendorSortEnum>>;
}>;


export type SearchVendorQuery = { __typename?: 'Query', searchVendor?: { __typename?: 'VendorConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'VendorEdge', cursor: string, node?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, factoryCode?: string | null | undefined, purposeGroup?: string | null | undefined, countryCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, customerPostName?: string | null | undefined, customerPositionName?: string | null | undefined, customerUser?: string | null | undefined, honorificCode?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, email?: string | null | undefined, vendorClosingGroup?: string | null | undefined, billSendDivision?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, transferCondition?: string | null | undefined, invoiceDivision?: string | null | undefined, invoiceRegistrationCode?: string | null | undefined, ediInfo?: string | null | undefined, vendorTradeDivision?: string | null | undefined, vendorTaxType?: string | null | undefined, priceRoundType?: string | null | undefined, taxRoundType?: string | null | undefined, vendorUnitpriceType?: string | null | undefined, productGroup?: string | null | undefined, reportOutputUnit?: string | null | undefined, tradeStopFlg?: string | null | undefined, vendorMemo?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, bankFuri?: string | null | undefined, branchOfficeCode?: string | null | undefined, branchOfficeName?: string | null | undefined, branchOfficeFuri?: string | null | undefined, bankAccountRelation?: string | null | undefined, bankAccountType?: string | null | undefined, bankAccountCode?: string | null | undefined, bankAccountName?: string | null | undefined, bankAccountFuri?: string | null | undefined, transferCustomCode1?: string | null | undefined, transferCustomCode2?: string | null | undefined, transferMethodCode?: string | null | undefined, delFlg: string, balanceData?: number | null | undefined, createDate: any, createUserName: string, updateDate: any, updateUserName: string, versionUuid: string, id: string, paymentDivision?: { __typename?: 'PaymentDivision', paymentDivisionCode: string, paymentDivisionName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WarehouseFieldsFragment = { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined };

export type WarehouseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WarehouseQuery = { __typename?: 'Query', warehouse?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined };

export type CreateWarehouseMutationVariables = Exact<{
  input: CreateWarehouseInput;
}>;


export type CreateWarehouseMutation = { __typename?: 'Mutation', createWarehouse?: { __typename?: 'CreateWarehousePayload', warehouse?: { __typename?: 'Warehouse', versionUuid: string, warehouseCode: string } | null | undefined } | null | undefined };

export type UpdateWarehouseMutationVariables = Exact<{
  input: UpdateWarehouseInput;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', updateWarehouse?: { __typename?: 'UpdateWarehousePayload', warehouse?: { __typename?: 'Warehouse', versionUuid: string, warehouseCode: string } | null | undefined } | null | undefined };

export type DeleteWarehouseMutationVariables = Exact<{
  input: DeleteWarehouseInput;
}>;


export type DeleteWarehouseMutation = { __typename?: 'Mutation', deleteWarehouse?: { __typename?: 'DeleteWarehousePayload', warehouse?: { __typename?: 'Warehouse', warehouseCode: string, versionUuid: string } | null | undefined } | null | undefined };

export type SearchWarehouseQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseFilter>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseSortEnum>> | InputMaybe<WarehouseSortEnum>>;
}>;


export type SearchWarehouseQuery = { __typename?: 'Query', searchWarehouse?: { __typename?: 'WarehouseConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WarehouseEdge', cursor: string, node?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WarehouseMoveFieldsFragment = { __typename?: 'WarehouseMove', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveStatus: string, warehouseMoveMethod: string, warehouseMoveMemo?: string | null | undefined, searchKeyword?: string | null | undefined, moveSource?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, moveDestination?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WarehouseMoveDetailFieldsFragment = { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined };

export type WarehouseMoveQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WarehouseMoveQuery = { __typename?: 'Query', warehouseMove?: { __typename?: 'WarehouseMove', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveStatus: string, warehouseMoveMethod: string, warehouseMoveMemo?: string | null | undefined, searchKeyword?: string | null | undefined, moveSource?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, moveDestination?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined };

export type SearchWarehouseMoveQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseMoveFilter>;
  sort?: InputMaybe<Array<InputMaybe<WarehouseMoveSortEnum>> | InputMaybe<WarehouseMoveSortEnum>>;
}>;


export type SearchWarehouseMoveQuery = { __typename?: 'Query', searchWarehouseMove?: { __typename?: 'WarehouseMoveConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WarehouseMoveEdge', cursor: string, node?: { __typename?: 'WarehouseMove', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveStatus: string, warehouseMoveMethod: string, warehouseMoveMemo?: string | null | undefined, searchKeyword?: string | null | undefined, moveSource?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, moveDestination?: { __typename?: 'Warehouse', createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseCode: string, warehouseName: string, warehouseType: string, divisionCode?: string | null | undefined, customerCode?: string | null | undefined, zipCode?: string | null | undefined, address1?: string | null | undefined, address2?: string | null | undefined, warehouseUser?: string | null | undefined, tel?: string | null | undefined, fax?: string | null | undefined, warehouseMemo?: string | null | undefined, delFlg: string, isCountTarget: string, id: string, versionUuid: string, division?: { __typename?: 'Division', divisionName: string } | null | undefined, customer?: { __typename?: 'Customer', customerCode: string, customerName: string } | null | undefined } | null | undefined, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WarehouseMoveMutationFieldsFragment = { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateWarehouseMoveMutationVariables = Exact<{
  input: CreateWarehouseMoveInput;
}>;


export type CreateWarehouseMoveMutation = { __typename?: 'Mutation', createWarehouseMove?: { __typename?: 'CreateWarehouseMovePayload', warehouseMove?: { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateWarehouseMoveMutationVariables = Exact<{
  input: UpdateWarehouseMoveInput;
}>;


export type UpdateWarehouseMoveMutation = { __typename?: 'Mutation', updateWarehouseMove?: { __typename?: 'UpdateWarehouseMovePayload', warehouseMove?: { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateWarehouseMoveApproveMutationVariables = Exact<{
  input: UpdateWarehouseMoveApproveInput;
}>;


export type UpdateWarehouseMoveApproveMutation = { __typename?: 'Mutation', updateWarehouseMoveApprove?: { __typename?: 'UpdateWarehouseMoveApprovePayload', warehouseMove?: { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type UpdateWarehouseMoveRejectMutationVariables = Exact<{
  input: UpdateWarehouseMoveRejectInput;
}>;


export type UpdateWarehouseMoveRejectMutation = { __typename?: 'Mutation', updateWarehouseMoveReject?: { __typename?: 'UpdateWarehouseMoveRejectPayload', warehouseMove?: { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type DeleteWarehouseMoveMutationVariables = Exact<{
  input: DeleteWarehouseMoveInput;
}>;


export type DeleteWarehouseMoveMutation = { __typename?: 'Mutation', deleteWarehouseMove?: { __typename?: 'DeleteWarehouseMovePayload', warehouseMove?: { __typename?: 'WarehouseMove', warehouseMoveId: string, versionUuid: string, moveDate: string, moveWarehouseSource: string, moveWarehouseDestination: string, warehouseMoveDetail?: { __typename?: 'WarehouseMoveDetailConnection', edges: Array<{ __typename?: 'WarehouseMoveDetailEdge', node?: { __typename?: 'WarehouseMoveDetail', id: string, versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, warehouseMoveId: string, numbering: string, janCode?: string | null | undefined, productCode?: string | null | undefined, transferProductCode?: string | null | undefined, moveQuantity: number, approvedMoveQuantity?: number | null | undefined, detailMemo?: string | null | undefined, stockWarehouseMove?: { __typename?: 'StockWarehouseMove', stockQuantity?: number | null | undefined, possibleQuantity?: number | null | undefined } | null | undefined, product?: { __typename?: 'ProductNoPriceView', attributeName?: string | null | undefined } | null | undefined, transferProduct?: { __typename?: 'ProductNoPriceView', janCode: string, attributeName?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type SearchWarehouseMoveDetailQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWarehouseMoveDetailFilter>;
}>;


export type SearchWarehouseMoveDetailQuery = { __typename?: 'Query', searchWarehouseMoveDetail?: { __typename?: 'SearchWarehouseMoveDetailConnection', edges: Array<{ __typename?: 'SearchWarehouseMoveDetailEdge', node?: { __typename?: 'SearchWarehouseMoveDetail', moveDate?: string | null | undefined, tradeHistoryType?: string | null | undefined, tradeTargetId?: string | null | undefined, sourceDivisionCode?: string | null | undefined, sourceDivisionName?: string | null | undefined, sourceWarehouseCode?: string | null | undefined, sourceWarehouseName?: string | null | undefined, destinationDivisionCode?: string | null | undefined, destinationDivisionName?: string | null | undefined, destinationWarehouseCode?: string | null | undefined, destinationWarehouseName?: string | null | undefined, destinationJanCode?: string | null | undefined, destinationAttributeName?: string | null | undefined, moveQuantity?: number | null | undefined, destinationSalesUnitPrice?: number | null | undefined, destinationPrice?: number | null | undefined, sourceJanCode?: string | null | undefined, sourceAttributeName?: string | null | undefined, sourceSalesUnitPrice?: number | null | undefined, sourcePrice?: number | null | undefined, detailMemo?: string | null | undefined, receiveOrderId?: string | null | undefined, deliveryOrderId?: string | null | undefined, warehouseMoveId?: string | null | undefined, adjustId?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type WithdrawalFieldsFragment = { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined };

export type SearchWithdrawalFieldsFragment = { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, id: string, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined };

export type WithdrawalDetailFieldsFragment = { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string };

export type WithdrawalMonthlyFieldsFragment = { __typename?: 'WithDrawalsMonthly', vendorCode?: string | null | undefined, fromDate?: any | null | undefined, toDate?: any | null | undefined, totalingWithdrawalPrice?: any | null | undefined };

export type WithdrawalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WithdrawalQuery = { __typename?: 'Query', withdrawal?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, automaticallyGeneratedFlg: string, id: string, withdrawalDetail?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined, user?: { __typename?: 'User', userCode: string, userName: string } | null | undefined, payment?: { __typename?: 'Payment', payPriceTotalInAccountMonth: number, currentPaymentExpectRemain: number, withdrawalState: string } | null | undefined } | null | undefined };

export type SearchWithdrawalQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithdrawalFilter>;
  sort?: InputMaybe<Array<InputMaybe<WithdrawalSortEnum>> | InputMaybe<WithdrawalSortEnum>>;
  detailFilter?: InputMaybe<WithdrawalDetailFilter>;
}>;


export type SearchWithdrawalQuery = { __typename?: 'Query', searchWithdrawal?: { __typename?: 'WithdrawalConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WithdrawalEdge', cursor: string, node?: { __typename?: 'Withdrawal', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, payDate: string, vendorCode: string, userCode?: string | null | undefined, payRemark?: string | null | undefined, payPriceTotal: number, closingStatusCode: string, paymentId?: number | null | undefined, id: string, withdrawalDetails?: { __typename?: 'WithdrawalDetailConnection', edges: Array<{ __typename?: 'WithdrawalDetailEdge', node?: { __typename?: 'WithdrawalDetail', versionUuid: string, createUserCode: string, createUserName: string, createDate: any, updateUserCode: string, updateUserName: string, updateDate: any, payId: string, numbering: string, payDivisionCode: string, payDivisionDetail?: string | null | undefined, billDate?: string | null | undefined, payPrice: number, detailMemo?: string | null | undefined, id: string } | null | undefined } | null | undefined> } | null | undefined, vendor?: { __typename?: 'Vendor', vendorCode: string, vendorName: string, vendorFuri: string, vendorClosingGroup?: string | null | undefined, paymentMethod?: string | null | undefined, paymentCycle?: string | null | undefined, paymentDate?: number | null | undefined, transferShareCost?: string | null | undefined, balanceData?: number | null | undefined, id: string } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type SearchWithdrawalMonthlyQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchWithDrawalsMonthlyFilter>;
}>;


export type SearchWithdrawalMonthlyQuery = { __typename?: 'Query', searchWithdrawalMonthly?: { __typename?: 'WithDrawalsMonthlyConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'WithDrawalsMonthlyEdge', cursor: string, node?: { __typename?: 'WithDrawalsMonthly', vendorCode?: string | null | undefined, fromDate?: any | null | undefined, toDate?: any | null | undefined, totalingWithdrawalPrice?: any | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type CreateWithdrawalMutationVariables = Exact<{
  input: CreateWithdrawalInput;
}>;


export type CreateWithdrawalMutation = { __typename?: 'Mutation', createWithdrawal?: { __typename?: 'CreateWithdrawalPayload', withdrawal?: { __typename?: 'Withdrawal', versionUuid: string, payId: string } | null | undefined } | null | undefined };

export type UpdateWithdrawalMutationVariables = Exact<{
  input: UpdateWithdrawalInput;
}>;


export type UpdateWithdrawalMutation = { __typename?: 'Mutation', updateWithdrawal?: { __typename?: 'UpdateWithdrawalPayload', withdrawal?: { __typename?: 'Withdrawal', versionUuid: string, payId: string } | null | undefined } | null | undefined };

export type DeleteWithdrawalMutationVariables = Exact<{
  input: DeleteWithdrawalInput;
}>;


export type DeleteWithdrawalMutation = { __typename?: 'Mutation', deleteWithdrawal?: { __typename?: 'DeleteWithdrawalPayload', withdrawal?: { __typename?: 'Withdrawal', versionUuid: string, payId: string } | null | undefined } | null | undefined };

export type CreateAutomaticWithdrawalMutationVariables = Exact<{
  input: CreateAutomaticWithdrawalsInput;
}>;


export type CreateAutomaticWithdrawalMutation = { __typename?: 'Mutation', createAutomaticWithdrawal?: { __typename?: 'CreateAutomaticWithdrawalsPayload', automaticWithdrawal?: { __typename?: 'Withdrawal', versionUuid: string, payId: string } | null | undefined } | null | undefined };

export type DeleteAutomaticWithdrawalMutationVariables = Exact<{
  input: DeleteAutomaticWithdrawalsInput;
}>;


export type DeleteAutomaticWithdrawalMutation = { __typename?: 'Mutation', deleteAutomaticWithdrawal?: { __typename?: 'DeleteAutomaticWithdrawalsPayload', payment?: { __typename?: 'Payment', versionUuid: string, paymentId: string } | null | undefined } | null | undefined };

export const SearchSendOrderArrivalFieldsFragmentDoc = `
    fragment SearchSendOrderArrivalFields on Arrival {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  arrivalId
  arrivalDate
  arrivalMemo
  orderId
  arrivalDetails {
    edges {
      node {
        arrivalId
        numbering
        arrivalTradeTypeCode
        arrivalDetailStatus
        janCode
        productCode
        productName
        warehouseCode
        arrivalQuantity
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        purchasePrice
        detailMemo
        taxationDivision
        sendOrderDetailNumbering
      }
    }
  }
  id
}
    `;
export const SearchSendOrderFieldsFragmentDoc = `
    fragment SearchSendOrderFields on SendOrder {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  orderId
  orderDate
  deliveryDate
  orderType
  orderMemo
  vendorCode
  vendorTradeDivision
  vendorTaxType
  shippingTypeCode
  shippingCode
  poCode
  orderRemarks
  searchKeyword
  arrival {
    ...SearchSendOrderArrivalFields
  }
  id
}
    ${SearchSendOrderArrivalFieldsFragmentDoc}`;
export const SearchSendOrderDetailFieldsFragmentDoc = `
    fragment SearchSendOrderDetailFields on SendOrderDetail {
  id
  orderId
  numbering
  frontNumbering
  orderTradeTypeCode
  orderDetailStatus
  janCode
  productCode
  productName
  warehouseCode
  orderQuantity
  totalQuantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  purchasePrice
  purchasePriceDollar
  detailMemo
  receivedQuantity
  taxationDivision
  product {
    productName
    attr1
    attr2
    clothGroup
    productGroup1 {
      productGroupName
    }
    productGroup2 {
      productGroupName
    }
    productGroup3 {
      productGroupName
    }
    division {
      divisionCode
      divisionName
    }
    unitYenDecimalDigits
    unitDollarDecimalDigits
    quantityDecimalDigits
  }
  Warehouse {
    divisionCode
  }
  sendOrder {
    orderId
    orderDate
    deliveryDate
    orderType
    orderMemo
    vendorCode
    vendorTradeDivision
    vendorTaxType
    shippingTypeCode
    shippingCode
    poCode
    orderRemarks
    vendor {
      vendorName
    }
  }
}
    `;
export const AddressFieldsFragmentDoc = `
    fragment AddressFields on Address {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  zipCode1
  zipCode2
  prefecturesCode
  prefectures
  city1
  city2
}
    `;
export const ArrivalFieldsFragmentDoc = `
    fragment ArrivalFields on Arrival {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  arrivalId
  arrivalDate
  arrivalMemo
  orderId
  arrivalDetails {
    edges {
      node {
        arrivalId
        numbering
        arrivalTradeTypeCode
        arrivalDetailStatus
        janCode
        productCode
        productName
        warehouseCode
        arrivalQuantity
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        purchasePrice
        detailMemo
        taxationDivision
        sendOrderDetailGroupNumbering
        sendOrderDetailNumbering
        product {
          allRemainReceiveQuantity
        }
      }
    }
  }
  id
}
    `;
export const ArrivalSendOrderDetailFieldsFragmentDoc = `
    fragment ArrivalSendOrderDetailFields on SendOrderDetail {
  numbering
  orderQuantity
  receivedQuantity
}
    `;
export const ArrivalTaxDetailFieldsFragmentDoc = `
    fragment ArrivalTaxDetailFields on ArrivalTaxDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  arrivalId
  taxationDivision
  taxRoundType
  taxExcluded
  exciseTax
  id
}
    `;
export const ArrivalDetailFieldsFragmentDoc = `
    fragment ArrivalDetailFields on ArrivalDetail {
  arrivalId
  numbering
  arrivalTradeTypeCode
  arrivalDetailStatus
  janCode
  productCode
  productName
  warehouseCode
  arrivalQuantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  purchasePrice
  detailMemo
  taxationDivision
  sendOrderDetailGroupNumbering
  sendOrderDetailNumbering
  product {
    allRemainReceiveQuantity
  }
}
    `;
export const ArrivalMutationFieldsFragmentDoc = `
    fragment ArrivalMutationFields on Arrival {
  id
  arrivalId
  arrivalDate
  sendOrder {
    vendorCode
  }
  arrivalDetails {
    edges {
      node {
        ...ArrivalDetailFields
      }
    }
  }
}
    ${ArrivalDetailFieldsFragmentDoc}`;
export const BeforeDemandClosingFieldsFragmentDoc = `
    fragment BeforeDemandClosingFields on BeforeDemandClosing {
  demandCode
  customerName
  customerFuri
  closingDate
  collectExpectedDate
  beforeDemandRemain
  depositPriceTotalInAccountMonth
  excludedTaxTotalDemandPrice
  exciseTaxTotal
  carryOverPrice
  includedTaxTotalDemandPrice
  exciseTaxPer10
  taxExcludedPer10
  exciseTaxPer8
  taxExcludedPer8
  currentDemandExpectRemain
}
    `;
export const CustomerFieldsFragmentDoc = `
    fragment CustomerFields on Customer {
  id
  customerCode
  customerName
  customerFuri
  customerGroup
  userDivisionCode
  userCode
  divisionBundle
  zipCode
  address1
  address2
  customerPostName
  customerPositionName
  customerUser
  honorificCode
  tel
  fax
  email
  salesTradeDivision
  salesTaxType
  priceRoundType
  taxRoundType
  customerUnitpriceType
  ratio
  creditLimitPrice
  demandClosingGroupCode
  billSendDivision
  collectMethodCode
  collectCycleCode
  collectDate
  demandCode
  transferShareCost
  billSite
  outsourcerCode
  collectDays
  salesUserName1
  salesUserEmail1
  salesUserName2
  salesUserEmail2
  salesUserName3
  salesUserEmail3
  inventoryControlUnit
  reportOutputUnit
  designAmebaFlg
  tradeStopFlg
  businessAmebaFlg
  customerRank
  prescribeSalesReport
  prescribeDemandReport
  addressLabelFlg
  customerArea
  customerMemo
  createDate
  createUserName
  updateDate
  updateUserName
  versionUuid
  balanceData
  delFlg
}
    `;
export const CustomerBudgetsCustomFieldsFragmentDoc = `
    fragment CustomerBudgetsCustomFields on CustomerBudgetsCustom {
  customerCode
  customerName
  userCode
  userName
  customerArea
  rowType
  jan
  feb
  mar
  apr
  may
  jun
  jul
  aug
  sep
  oct
  nov
  dec
  versionUuid {
    jan
    feb
    mar
    apr
    may
    jun
    jul
    aug
    sep
    oct
    nov
    dec
  }
}
    `;
export const CustomerPriceFieldsFragmentDoc = `
    fragment CustomerPriceFields on CustomerPrice {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  customerCode
  uniqueCode
  startDate
  endDate
  sellingUnitPrice
  customer {
    customerName
    salesTaxType
    customerUnitpriceType
    priceRoundType
    ratio
  }
  product {
    janCode
    productName
    unitYenDecimalDigits
    taxationDivision
  }
  productPrice {
    uniqueCode
    retailPrice
    salesUnitPrice
    purchaseUnitPriceYen
    purchaseUnitPriceDollar
    startDate
    endDate
  }
  id
}
    `;
export const CustomerPriceFieldsListFragmentDoc = `
    fragment CustomerPriceFieldsList on CustomerPriceNode {
  id
  versionUuid
  uniqueCode
  customerCode
  customerName
  priceRoundType
  janCode
  productName
  currentDate
  taxationDivision
  startDate
  endDate
  activeStatus
  retailPriceExcl
  sellingPriceExcl
  sellingUnitPrice
  retailPriceIncl
  sellingPriceIncl
  sellingUnitPriceIncl
  unitYenDecimalDigits
  customerUnitpriceType
  ratio
  salesTaxType
}
    `;
export const CustomerFieldsForCustomerPriceFragmentDoc = `
    fragment CustomerFieldsForCustomerPrice on Customer {
  customerCode
  customerName
  salesTaxType
  priceRoundType
  taxRoundType
  customerUnitpriceType
  ratio
}
    `;
export const CreateCustomerPriceWithBulkImportResultFragmentDoc = `
    fragment CreateCustomerPriceWithBulkImportResult on CreateCustomerPriceWithBulkImportPayload {
  allResult
  clientMutationId
  resultDatas {
    importFlg
  }
}
    `;
export const CustomerProductGroupPublicationFieldsFragmentDoc = `
    fragment CustomerProductGroupPublicationFields on CustomerProductGroupPublicationNode {
  id
  customerCode
  customerName
  userDivisionName
  productGroupId
  productGroupCode
  productGroupName
  productGrouptypeCode
  divisionCode
  divisionName
  visibilityStatus
}
    `;
export const ProductGroupBasicInfoFieldsFragmentDoc = `
    fragment ProductGroupBasicInfoFields on ProductGroup {
  productGroupId
  productGroupCode
  productGroupName
  productGrouptypeCode
  division {
    divisionCode
    divisionName
  }
}
    `;
export const CustomerProductPublicationFieldsFragmentDoc = `
    fragment CustomerProductPublicationFields on CustomerProductPublicationNode {
  id
  customerCode
  customerName
  userDivisionName
  janCode
  productCode
  productName
  divisionCode
  divisionName
  visibilityStatus
}
    `;
export const ProductBasicInfoFieldsFragmentDoc = `
    fragment ProductBasicInfoFields on ProductNoPriceView {
  janCode
  productCode
  productName
  division {
    divisionCode
    divisionName
  }
}
    `;
export const CustomerBasicInfoFieldsFragmentDoc = `
    fragment CustomerBasicInfoFields on Customer {
  customerCode
  customerName
  division {
    divisionName
  }
}
    `;
export const CustomerUserFieldsFragmentDoc = `
    fragment CustomerUserFields on CustomerUser {
  id
  customerUserId
  email
  customerUserName
  tel
  termsOfUseVersion
  initialConfirmationDate
  updateConfirmationDate
  createDate
  createUserName
  updateDate
  updateUserName
  versionUuid
  delFlg
  customerUserBelong {
    edges {
      node {
        customerUserBelongId
        customerUserId
        customerCode
        customerGroup
        deliveryDestinationCode
        deliver {
          deliveryDestinationCode
          deliveryDestinationName
        }
        customer {
          customerCode
          customerName
        }
      }
    }
  }
  termsAndConditions {
    termsId
    enactmentDate
  }
}
    `;
export const DeliverFieldsFragmentDoc = `
    fragment DeliverFields on Deliver {
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  deliveryDestinationCode
  deliveryDestinationName
  zipCode
  address1
  address2
  customerPostName
  customerPositionName
  customerUser
  honorificCode
  tel
  fax
  customerCode
  delFlg
  id
  versionUuid
  customer {
    customerCode
    customerName
  }
}
    `;
export const DemandTaxDetailFieldsFragmentDoc = `
    fragment DemandTaxDetailFields on DemandTaxDetail {
  versionUuid
  demandId
  taxationDivision
  taxExcluded
  exciseTax
}
    `;
export const DemandTaxAdjustDetailFieldsFragmentDoc = `
    fragment DemandTaxAdjustDetailFields on DemandTaxAdjustDetail {
  versionUuid
  demandId
  taxationDivision
  beforeAdjustExciseTax
  afterAdjustExciseTax
  adjust
}
    `;
export const DemandFieldsFragmentDoc = `
    fragment DemandFields on Demand {
  versionUuid
  createUserCode
  createDate
  createUserName
  updateUserCode
  updateUserName
  updateDate
  demandId
  closingDate
  demandDate
  collectExpectedDate
  demandCode
  salesTaxType
  beforeDemandRemain
  depositPriceTotalInAccountMonth
  carryOverPrice
  excludingTaxTotalDemandPrice
  includedTaxTotalDemandPrice
  currentDemandExpectRemain
  includedTaxDemandClearingPrice
  exciseTaxTotal
  clearingState
  closingStatusCode
  closingTriggerId
  totalDemandFlag
  demandTradeDivision
  demandTaxDetails {
    edges {
      node {
        ...DemandTaxDetailFields
      }
    }
  }
  demandTaxAdjustDetails {
    edges {
      node {
        ...DemandTaxAdjustDetailFields
      }
    }
  }
  customer {
    customerName
    customerFuri
  }
  id
}
    ${DemandTaxDetailFieldsFragmentDoc}
${DemandTaxAdjustDetailFieldsFragmentDoc}`;
export const DepositDetailFieldsFragmentDoc = `
    fragment DepositDetailFields on DepositDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  depositId
  numbering
  depositDivisionCode
  depositDivisionDetail
  billDate
  depositPrice
  detailMemo
  id
}
    `;
export const DepositClearingDetailFieldsFragmentDoc = `
    fragment DepositClearingDetailFields on DepositClearingDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  depositId
  demandId
  clearingPrice
  id
}
    `;
export const DepositFieldsFragmentDoc = `
    fragment DepositFields on Deposit {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  depositId
  depositDate
  depositRemark
  depositPriceTotal
  clearingPrice
  closingStatusCode
  depositTotalInMonth
  demandTotalInMonth
  depositDetail {
    edges {
      node {
        ...DepositDetailFields
      }
    }
  }
  depositClearingDetail {
    edges {
      node {
        ...DepositClearingDetailFields
      }
    }
  }
  demandId
  demandCode
  customer {
    customerCode
    customerName
    customerFuri
    demandCode
    collectMethodCode
    collectCycleCode
    collectDate
    demandClosingGroupCode
    transferShareCost
    depositDivision {
      depositDivisionName
    }
    division {
      divisionName
    }
    balanceData
    id
  }
  userCode
  user {
    userCode
    userName
  }
  id
}
    ${DepositDetailFieldsFragmentDoc}
${DepositClearingDetailFieldsFragmentDoc}`;
export const CreateBulkDepositResultFragmentDoc = `
    fragment CreateBulkDepositResult on CreateBulkDepositPayload {
  allResult
  count
  resultList
}
    `;
export const DepositDivisionFieldsFragmentDoc = `
    fragment DepositDivisionFields on DepositDivision {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  depositDivisionCode
  depositDivisionName
  depositGroupCode
  delFlg
  id
}
    `;
export const DirectlyPurchaseFieldsFragmentDoc = `
    fragment DirectlyPurchaseFields on DirectlyPurchase {
  purchaseId
  purchaseDate
  closingStatusCode
  divisionCode
  divisionName
  vendorCode
  vendorName
  taxExcludedTotal
  tenTaxExcluded
  tenTax
  eightTaxExcluded
  eightTax
  exportTaxFree
  taxIncludedTotal
  detailMemo
  versionUuid
}
    `;
export const DivisionFieldsFragmentDoc = `
    fragment DivisionFields on Division {
  id
  divisionCode
  divisionName
  divistionType
  windowName
  recordHighSales
  recordHighSalesUpdateUserName
  recordHighSalesUpdateDate
  delFlg
  createDate
  updateUserName
  updateDate
  versionUuid
}
    `;
export const ExchangeFieldsFragmentDoc = `
    fragment ExchangeFields on Exchange {
  id
  divisionCode
  numbering
  startDate
  endDate
  exchangeRate
  createDate
  updateDate
  versionUuid
}
    `;
export const DivisionFinancialDateFieldsFragmentDoc = `
    fragment DivisionFinancialDateFields on DivisionFinancialDate {
  divisionCode
  financialStage
  targetGrossMarginRate
}
    `;
export const DivisionGradeFieldsFragmentDoc = `
    fragment DivisionGradeFields on DivisionGrades {
  divisionCode
  divisionName
  totalSku
  skuOwn
  skuOthers
  totalSkuLatest
  skuLatestOwn
  skuLatestOthers
  totalSkuNew
  skuNewOwn
  skuNewOthers
  totalSkuLatestRate
  skuLatestOwnSalesRate
  totalSkuNewRate
  skuNewOwnRate
  totalSkuLatestSalesRate
  totalSkuLatestOwnRate
  totalSkuNewOwnSalesRate
  totalSkuNewSalesRate
  totalSalesCostAmountCurrent
  totalSalesCostAmount1year
  totalSalesCostAmount2year
  totalSalesAmountCurrent
  totalSalesAmount1year
  totalSalesAmount2year
  grossProfitRateCurrent
  grossProfitRate1year
  grossProfitRate2year
  costRateCurrent
  costRate1year
  costRate2year
  targetGrossMarginRate
  recordHighSales
  dioCurrent
  dio1year
  dio2year
  discontinuedProductAmountCurrent
  discontinuedProductAmount1year
  discontinuedProductAmount2year
  skuLatestOwnSales
  totalSkuNewSales
  skuNewOwnSales
  totalSkuSales
  stockCurrent
  stock1year
  stock2year
  costBetweenLastyearAndToday
  skuOwnSales
  skuLatestSales
  totalSkuLatestSales
  totalSkuLatestOwnSales
  totalSkuOwnSales
}
    `;
export const DivisionTermsFieldsFragmentDoc = `
    fragment DivisionTermsFields on DivisionTerms {
  current {
    termFrom
    termTo
  }
  currentTerm {
    termFrom
    termTo
  }
  previousTerm {
    termFrom
    termTo
  }
  twoTermsAgo {
    termFrom
    termTo
  }
}
    `;
export const EstimateDetailFieldsFragmentDoc = `
    fragment EstimateDetailFields on EstimateDetail {
  id
  estimateId
  numbering
  receiveDetailTradeType
  janCode
  productCode
  productName
  product {
    unitYenDecimalDigits
    quantityDecimalDigits
    stock {
      allQuantity
    }
    division {
      divisionCode
      divisionName
    }
    allRemainReceiveQuantity
  }
  receiveOrderQuantity
  salesUnitPrice
  sellingUnitPrice
  sellingPrice
  retailPrice
  taxationDivision
  detailMemo
  versionUuid
}
    `;
export const EstimateFieldsFragmentDoc = `
    fragment EstimateFields on Estimate {
  id
  estimateId
  estimateDate
  customerCode
  customer {
    customerCode
    customerName
    userDivisionCode
    userCode
  }
  provisionalCustomerName
  customerUser
  honorificCode
  tel
  fax
  salesTradeDivision
  salesTaxType
  estimateTitle
  estimateRemark
  user {
    userCode
    userName
  }
  userCode
  deliverPeriod
  deliverPlace
  tradeMethod
  expirationDate
  taxExcludeTotal
  estimatePriceTotal
  detailCount
  estimateDetails {
    edges {
      node {
        ...EstimateDetailFields
      }
    }
  }
  createDate
  createUserCode
  createUserName
  updateDate
  updateUserName
  versionUuid
}
    ${EstimateDetailFieldsFragmentDoc}`;
export const EstimateMutationFieldsFragmentDoc = `
    fragment EstimateMutationFields on Estimate {
  id
  estimateId
  customerCode
  estimateDate
  estimateDetails {
    edges {
      node {
        ...EstimateDetailFields
      }
    }
  }
}
    ${EstimateDetailFieldsFragmentDoc}`;
export const EstimateCustomerFieldsFragmentDoc = `
    fragment EstimateCustomerFields on Customer {
  id
  customerCode
  customerName
  customerGroup
  userDivisionCode
  userCode
  customerUser
  honorificCode
  tel
  fax
  salesTradeDivision
  salesTaxType
  priceRoundType
  taxRoundType
  customerUnitpriceType
  ratio
  creditLimitPrice
  salesUserName1
  salesUserEmail1
  balanceData
  user {
    userName
  }
}
    `;
export const FinancialDateDetailFieldsFragmentDoc = `
    fragment FinancialDateDetailFields on SearchFinancialDateDetail {
  financialStage
  minFinancialStartDate
  maxFinancialEndDate
}
    `;
export const InformationFieldsFragmentDoc = `
    fragment InformationFields on FkorderInformation {
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  informationId
  divisionCode
  informationType
  title
  postedAt
  publicationFrom
  publicationTo
  body
  deliveryStatus
  versionUuid
  fkorderInformationAttachments {
    edges {
      node {
        attachmentId
        filename
        path
        presignedUrl
      }
    }
  }
}
    `;
export const InventoryFieldsFragmentDoc = `
    fragment InventoryFields on Inventory {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  inventoryId
  inventoryBaseFrom
  inventoryBaseTo
  inventoryName
  inventoryFinishFlg
  inventoryDivision {
    edges {
      node {
        updateUserCode
        updateUserName
        updateDate
        inventoryId
        divisionCode
        inventoryDivisionStatus
        division {
          divisionName
        }
      }
    }
  }
  id
}
    `;
export const InventoryDivisionFieldsFragmentDoc = `
    fragment InventoryDivisionFields on InventoryDivision {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  inventoryId
  divisionCode
  inventoryDivisionStatus
  inventory {
    inventoryBaseFrom
    inventoryBaseTo
    inventoryName
  }
  division {
    divisionName
  }
  id
}
    `;
export const ReceiveRemainByProductFieldsFragmentDoc = `
    fragment ReceiveRemainByProductFields on SearchReceiveRemainByProduct {
  deliveryDate
  divisionCode
  divisionName
  warehouseCode
  warehouseName
  quantity
  receiveOrderId
}
    `;
export const SendRemainByProductFieldsFragmentDoc = `
    fragment SendRemainByProductFields on SearchSendRemainByProduct {
  deliveryDate
  divisionCode
  divisionName
  warehouseCode
  warehouseName
  quantity
  orderId
}
    `;
export const SalesDetailFieldsForOutsourcerSalesFragmentDoc = `
    fragment SalesDetailFieldsForOutsourcerSales on SalesDetail {
  id
  salesId
  versionUuid
  numbering
  frontNumbering
  janCode
  uniqueCode
  productCode
  productName
  receiveOrderQuantity
  sellingUnitPrice
  sellingPrice
  salesUnitPrice
  taxationDivision
  detailMemo
  product {
    quantityDecimalDigits
    unitYenDecimalDigits
  }
}
    `;
export const SalesFieldsForOutsourcerSalesFragmentDoc = `
    fragment SalesFieldsForOutsourcerSales on Sales {
  id
  versionUuid
  createUserCode
  createUserName
  salesId
  salesDate
  customerCode
  salesRemark
  salesTaxType
  customer {
    customerCode
    customerName
    priceRoundType
    taxRoundType
    customerUnitpriceType
    ratio
  }
  salesDetails {
    edges {
      node {
        ...SalesDetailFieldsForOutsourcerSales
      }
    }
  }
}
    ${SalesDetailFieldsForOutsourcerSalesFragmentDoc}`;
export const OutsourcerSalesMutationFieldsFragmentDoc = `
    fragment OutsourcerSalesMutationFields on Sales {
  id
  salesId
  customerCode
  salesDate
  salesDetails {
    edges {
      node {
        ...SalesDetailFieldsForOutsourcerSales
      }
    }
  }
}
    ${SalesDetailFieldsForOutsourcerSalesFragmentDoc}`;
export const CustomerFieldsForOutsourcerSalesFragmentDoc = `
    fragment CustomerFieldsForOutsourcerSales on Customer {
  customerCode
  customerName
  customerGroup
  priceRoundType
  taxRoundType
  salesTaxType
  ratio
  customerUser
  userDivisionCode
  inventoryControlUnit
}
    `;
export const PartialQueryDataFieldsFragmentDoc = `
    fragment PartialQueryDataFields on PartialQueryData {
  type
  label
  productCode
  TM1
  TM2
  TM3
  TM4
  TM5
  TM6
  TM7
  TM8
  TM9
  TM10
  TM11
  TM12
}
    `;
export const PaymentTaxDetailFieldsFragmentDoc = `
    fragment PaymentTaxDetailFields on PaymentTaxDetail {
  versionUuid
  paymentId
  taxationDivision
  taxExcluded
  exciseTax
}
    `;
export const PaymentTaxAdjustDetailFieldsFragmentDoc = `
    fragment PaymentTaxAdjustDetailFields on PaymentTaxAdjustDetail {
  versionUuid
  paymentId
  taxationDivision
  beforeAdjustExciseTax
  afterAdjustExciseTax
  adjust
}
    `;
export const VendorFieldsFragmentDoc = `
    fragment VendorFields on Vendor {
  vendorCode
  vendorName
  vendorFuri
  factoryCode
  purposeGroup
  countryCode
  zipCode
  address1
  address2
  customerPostName
  customerPositionName
  customerUser
  honorificCode
  tel
  fax
  email
  vendorClosingGroup
  billSendDivision
  paymentMethod
  paymentCycle
  paymentDate
  transferShareCost
  transferCondition
  invoiceDivision
  invoiceRegistrationCode
  ediInfo
  vendorTradeDivision
  vendorTaxType
  priceRoundType
  taxRoundType
  vendorUnitpriceType
  productGroup
  reportOutputUnit
  tradeStopFlg
  vendorMemo
  bankCode
  bankName
  bankFuri
  branchOfficeCode
  branchOfficeName
  branchOfficeFuri
  bankAccountRelation
  bankAccountType
  bankAccountCode
  bankAccountName
  bankAccountFuri
  transferCustomCode1
  transferCustomCode2
  transferMethodCode
  delFlg
  balanceData
  createDate
  createUserName
  updateDate
  updateUserName
  versionUuid
  id
  paymentDivision {
    paymentDivisionCode
    paymentDivisionName
  }
}
    `;
export const WithdrawalDetailFieldsFragmentDoc = `
    fragment WithdrawalDetailFields on WithdrawalDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  payId
  numbering
  payDivisionCode
  payDivisionDetail
  billDate
  payPrice
  detailMemo
  id
}
    `;
export const WithdrawalFieldsFragmentDoc = `
    fragment WithdrawalFields on Withdrawal {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  payId
  payDate
  vendorCode
  userCode
  payRemark
  payPriceTotal
  closingStatusCode
  paymentId
  automaticallyGeneratedFlg
  withdrawalDetail {
    edges {
      node {
        ...WithdrawalDetailFields
      }
    }
  }
  vendor {
    vendorCode
    vendorName
    vendorFuri
    vendorClosingGroup
    paymentMethod
    paymentCycle
    paymentDate
    transferShareCost
    balanceData
    id
  }
  user {
    userCode
    userName
  }
  payment {
    payPriceTotalInAccountMonth
    currentPaymentExpectRemain
    withdrawalState
  }
  id
}
    ${WithdrawalDetailFieldsFragmentDoc}`;
export const PaymentFieldsFragmentDoc = `
    fragment PaymentFields on Payment {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  paymentId
  closingDate
  paymentExpectedDate
  paymentDate
  vendorCode
  vendorTaxType
  beforePaymentRemain
  payPriceTotalInAccountMonth
  carryOverPrice
  excludingTaxTotalPaymentPrice
  includedTaxTotalPaymentPrice
  includedTaxTotalPaymentPriceWithAdjust
  includedTaxPaymentClearingPrice
  exciseTaxTotal
  currentPaymentExpectRemain
  currentPaymentPrice
  differencePrice
  offsetPrice
  depositPrice
  transferFee
  currentTransferPrice
  paymentMemo
  withdrawalState
  closingStatusCode
  currentTotalPurchasePrice
  currentTotalImportPrice
  currentTotalProgressPrice
  automaticPayId
  paymentTaxDetails {
    edges {
      node {
        ...PaymentTaxDetailFields
      }
    }
  }
  paymentTaxAdjustDetails {
    edges {
      node {
        ...PaymentTaxAdjustDetailFields
      }
    }
  }
  vendor {
    ...VendorFields
  }
  automaticWithdrawal {
    ...WithdrawalFields
  }
  id
}
    ${PaymentTaxDetailFieldsFragmentDoc}
${PaymentTaxAdjustDetailFieldsFragmentDoc}
${VendorFieldsFragmentDoc}
${WithdrawalFieldsFragmentDoc}`;
export const PaymentDivisionFieldsFragmentDoc = `
    fragment PaymentDivisionFields on PaymentDivision {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  paymentDivisionCode
  paymentDivisionName
  paymentGroupCode
  delFlg
  id
}
    `;
export const ProductGroupFieldsFragmentDoc = `
    fragment ProductGroupFields on ProductGroup {
  productGroupId
  divisionCode
  division {
    divisionCode
    divisionName
  }
  productGrouptypeCode
  productGroupCode
  productGroupName
  versionUuid
  id
  publicationOption
  publicationScope
}
    `;
export const ProductHistoryFieldsFragmentDoc = `
    fragment ProductHistoryFields on ProductHistory {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  productBaseHistoryId
  uniqueCode
  janCode
  productName
  retailPrice
  salesUnitPrice
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  vendorCode
  vendor {
    vendorName
  }
  id
}
    `;
export const ProductListViewFieldsFragmentDoc = `
    fragment ProductListViewFields on ProductListView {
  id
  uniqueCode
  janCode
  productName
  productFuri
  unitCode
  receiveOrderLot
  maxPurchaseOrderQty
  quantityDecimalDigits
  unitYenDecimalDigits
  unitDollarDecimalDigits
  taxationDivision
  purchaseOrderLeadTime
  vendorCode
  domOverFlg
  countryCode
  manufacturer
  componentDivision
  productGroupId1
  productGroupId2
  productGroupId3
  clothGroup
  material
  inventoryControlFlg
  notIncludedSku
  discontinueFlg
  planningUserCode
  designUserCode
  tags
  productImage1
  productImage2
  productImage3
  productImage4
  productImage5
  productImage6
  retailPrice
  salesUnitPrice
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  startDate
  endDate
  productCode
  divisionCode
  attrNo
  branchNumber
  attributeName
  divisionStandardStock
  purchaseOrderStandardStock
  baseStockQuantity
  lotGroupCode
  minimumLot
  firstArrivalDate
  fcCode1
  fcCode2
  fcCode3
  fcCodeBranchNumber1
  fcCodeBranchNumber2
  fcCodeBranchNumber3
  productAttrMemo
  productBodySize
  productBodyWeight
  productPackageSize
  productPackageWeight
  innerCartonSize
  innerCartonWeight
  innerCartonUnit
  outerCartonWidth
  outerCartonHeight
  outerCartonDept
  outerCartonWeight
  outerCartonUnit
  attr1
  attr2
  publicationOption
  endOfSalesDate
  division {
    divisionCode
    divisionName
  }
  vendor {
    vendorName
  }
  productGroup1 {
    productGroupCode
    productGroupName
    publicationOption
  }
  productGroup2 {
    productGroupCode
    productGroupName
  }
  productGroup3 {
    productGroupCode
    productGroupName
  }
  sendOrderLot {
    lotGroupName
  }
}
    `;
export const ProductViewFieldsFragmentDoc = `
    fragment ProductViewFields on ProductView {
  id
  uniqueCode
  janCode
  productName
  productFuri
  unitCode
  receiveOrderLot
  quantityDecimalDigits
  unitYenDecimalDigits
  unitDollarDecimalDigits
  taxationDivision
  purchaseOrderLeadTime
  vendorCode
  domOverFlg
  countryCode
  manufacturer
  componentDivision
  productGroupId1
  productGroupId2
  productGroupId3
  clothGroup
  material
  inventoryControlFlg
  notIncludedSku
  discontinueFlg
  planningUserCode
  designUserCode
  tags
  productImage1
  productImage2
  productImage3
  productImage4
  productImage5
  productImage6
  startDate
  endDate
  retailPrice
  salesUnitPrice
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  productCode
  divisionCode
  attrNo
  branchNumber
  attributeName
  divisionStandardStock
  purchaseOrderStandardStock
  lotGroupCode
  minimumLot
  firstArrivalDate
  fcCode1
  fcCode2
  fcCode3
  fcCodeBranchNumber1
  fcCodeBranchNumber2
  fcCodeBranchNumber3
  productAttrMemo
  productBodySize
  productBodyWeight
  productPackageSize
  productPackageWeight
  innerCartonSize
  innerCartonWeight
  innerCartonUnit
  outerCartonWidth
  outerCartonHeight
  outerCartonDept
  outerCartonWeight
  outerCartonUnit
  attr1
  attr2
  publicationOption
  division {
    divisionCode
    divisionName
  }
  vendor {
    vendorName
  }
  productGroup1 {
    productGroupCode
    productGroupName
  }
  productGroup2 {
    productGroupCode
    productGroupName
  }
  productGroup3 {
    productGroupCode
    productGroupName
  }
  sendOrderLot {
    lotGroupName
  }
}
    `;
export const ProductViewFromIdFieldsFragmentDoc = `
    fragment ProductViewFromIdFields on ProductView {
  janCode
  productCode
  productName
  salesUnitPrice
  retailPrice
  taxationDivision
  unitYenDecimalDigits
  quantityDecimalDigits
  unitDollarDecimalDigits
  division {
    divisionCode
    divisionName
  }
  stock {
    allQuantity
  }
  stockByWarehouses {
    warehouseCode
    quantity
    warehouse {
      customerCode
      warehouseCode
      warehouseName
      divisionCode
    }
  }
  stockByDivisions {
    divisionCode
    allQuantity
    mainQuantity
    externalQuantity
    outsourceQuantity
    division {
      divisionCode
      divisionName
    }
  }
}
    `;
export const ComponentDetailFieldsFragmentDoc = `
    fragment ComponentDetailFields on ComponentDetail {
  id
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  finishedProductCode
  productPartsCode
  frontNumbering
  quantity
  versionUuid
  productView {
    searchKeyword
    divisionCode
    productName
    janCode
    attributeName
    stockByDivisions {
      divisionCode
      mainQuantity
    }
  }
}
    `;
export const ComponentFieldsFragmentDoc = `
    fragment ComponentFields on Component {
  id
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  finishedProductCode
  versionUuid
  componentDetail {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ComponentDetailFields
      }
    }
  }
  productView {
    searchKeyword
    divisionCode
    productName
    janCode
    attributeName
  }
}
    ${ComponentDetailFieldsFragmentDoc}`;
export const ProductionDetailFieldsFragmentDoc = `
    fragment ProductionDetailFields on ProductionDetail {
  id
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  productionOrderId
  numbering
  productPartsCode
  quantity
  partsQuantity
  defrayalUnitPrice
  defrayalPrice
  detailMemo
  productView {
    productName
    janCode
    productName
    productGroupId1
    productGroupId2
    productGroupId3
    attributeName
    stockByWarehouses {
      warehouseCode
      quantity
    }
  }
}
    `;
export const ProductionFieldsFragmentDoc = `
    fragment ProductionFields on Production {
  id
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  productionOrderId
  productionOrderDate
  finishedProductCode
  finishedQuantity
  divisionCode
  warehouseCode
  receiveUnitPrice
  receivePrice
  productionMemo
  searchKeyword
  warehouse {
    warehouseCode
    warehouseName
  }
  productView {
    productName
    janCode
    productName
    productGroupId1
    productGroupId2
    productGroupId3
    attributeName
  }
  component {
    ...ComponentFields
  }
  division {
    divisionName
  }
  productionDetails {
    edges {
      node {
        ...ProductionDetailFields
      }
    }
  }
}
    ${ComponentFieldsFragmentDoc}
${ProductionDetailFieldsFragmentDoc}`;
export const SearchProductionFieldsFragmentDoc = `
    fragment SearchProductionFields on Production {
  id
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  productionOrderId
  productionOrderDate
  finishedProductCode
  finishedQuantity
  divisionCode
  warehouseCode
  receiveUnitPrice
  receivePrice
  productionMemo
  searchKeyword
  productView {
    janCode
    productName
    productGroupId1
    productGroupId2
    productGroupId3
    attributeName
  }
  warehouse {
    warehouseCode
    warehouseName
  }
}
    `;
export const ProductionMutationFieldsFragmentDoc = `
    fragment ProductionMutationFields on Production {
  id
  productionOrderId
  productionOrderDate
  warehouseCode
  finishedProductCode
  finishedQuantity
  productionDetails {
    edges {
      node {
        ...ProductionDetailFields
      }
    }
  }
}
    ${ProductionDetailFieldsFragmentDoc}`;
export const ProductionComponentDetailFieldsFragmentDoc = `
    fragment ProductionComponentDetailFields on ComponentDetail {
  id
  productPartsCode
  quantity
  productView {
    janCode
    productName
    attributeName
    stockByWarehouses {
      warehouseCode
      quantity
    }
  }
}
    `;
export const ProductionComponentFieldsFragmentDoc = `
    fragment ProductionComponentFields on Component {
  finishedProductCode
  productView {
    division {
      divisionCode
      divisionName
    }
  }
  componentDetail {
    edges {
      node {
        ...ProductionComponentDetailFields
      }
    }
  }
}
    ${ProductionComponentDetailFieldsFragmentDoc}`;
export const ProductionProductViewFieldsFragmentDoc = `
    fragment ProductionProductViewFields on ProductView {
  janCode
  productCode
  attributeName
  salesUnitPrice
  stockByWarehouses {
    warehouseCode
    quantity
  }
  discontinueFlg
}
    `;
export const PurchaseDetailFieldsFragmentDoc = `
    fragment PurchaseDetailFields on PurchaseDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  purchaseId
  numbering
  purchaseTradeTypeCode
  janCode
  productCode
  productName
  warehouseCode
  purchaseQuantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  purchasePrice
  purchasePriceDollar
  detailMemo
  taxationDivision
  arrivalDetailNumbering
  detailMainFlg
  totalQuantity
  id
}
    `;
export const PurchaseFieldsFragmentDoc = `
    fragment PurchaseFields on Purchase {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  purchaseId
  purchaseDate
  vendorCode
  vendorTradeDivision
  vendorTaxType
  poCode
  purchaseRemark
  closingTiming
  arrivalId
  taxExcludedTotal
  taxIncludedTotal
  totalDollar
  closingStatusCode
  paymentId
  purchaseVoucherType
  orderId
  purchaseDetails {
    edges {
      node {
        ...PurchaseDetailFields
      }
    }
  }
  payment {
    id
    withdrawalState
    vendorTaxType
  }
  arrival {
    versionUuid
    createUserCode
    createUserName
    createDate
    updateUserCode
    updateUserName
    updateDate
    arrivalId
    arrivalDate
    arrivalMemo
    orderId
  }
  arrivalTaxDetails {
    edges {
      node {
        versionUuid
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        arrivalId
        taxationDivision
        taxRoundType
        taxExcluded
        exciseTax
        taxIncluded
        id
      }
    }
  }
  arrivalTaxDetailsPurchase {
    edges {
      node {
        versionUuid
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        arrivalId
        taxationDivision
        taxRoundType
        taxExcluded
        exciseTax
        taxIncluded
        id
      }
    }
  }
  id
}
    ${PurchaseDetailFieldsFragmentDoc}`;
export const VendorPurchaseMonthlyFieldsFragmentDoc = `
    fragment VendorPurchaseMonthlyFields on VendorPurchaseMonthly {
  vendorCode
  totalingMonthly
  totalingPeriod
  totalingPurchasePrice
  totalingPurchasePriceDollar
  totalingWithdrawalPrice
}
    `;
export const PurchaseDetailListPurchaseDetailFieldsFragmentDoc = `
    fragment PurchaseDetailListPurchaseDetailFields on PurchaseDetail {
  purchaseTradeTypeCode
  productCode
  janCode
  productName
  warehouseCode
  purchaseQuantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  purchasePrice
  purchasePriceDollar
  taxationDivision
  detailMemo
  totalQuantity
  totalTaxExcluded
}
    `;
export const PurchaseDetailListArrivalDetailFieldsFragmentDoc = `
    fragment PurchaseDetailListArrivalDetailFields on ArrivalDetail {
  arrivalDetailStatus
  arrivalTradeTypeCode
  productCode
}
    `;
export const PurchaseDetailListArrivalTaxDetailFieldsFragmentDoc = `
    fragment PurchaseDetailListArrivalTaxDetailFields on ArrivalTaxDetail {
  taxationDivision
  taxExcluded
  exciseTax
}
    `;
export const PurchaseDetailListPurchaseFieldsFragmentDoc = `
    fragment PurchaseDetailListPurchaseFields on Purchase {
  purchaseId
  purchaseDate
  vendorCode
  vendorTradeDivision
  vendorTaxType
  poCode
  purchaseRemark
  closingTiming
  taxExcludedTotal
  taxIncludedTotal
  purchaseVoucherType
  orderId
  arrivalId
  division {
    divisionCode
    divisionName
  }
  vendor {
    vendorCode
    vendorName
    vendorTaxType
    taxRoundType
    priceRoundType
  }
  purchaseDetails(filter: $detailFilter) {
    edges {
      node {
        ...PurchaseDetailListPurchaseDetailFields
      }
    }
  }
  arrival {
    arrivalId
    orderId
    arrivalDetails {
      edges {
        node {
          ...PurchaseDetailListArrivalDetailFields
        }
      }
    }
  }
  arrivalTaxDetails {
    edges {
      node {
        ...PurchaseDetailListArrivalTaxDetailFields
      }
    }
  }
  arrivalTaxDetailsPurchase {
    edges {
      node {
        ...PurchaseDetailListArrivalTaxDetailFields
      }
    }
  }
}
    ${PurchaseDetailListPurchaseDetailFieldsFragmentDoc}
${PurchaseDetailListArrivalDetailFieldsFragmentDoc}
${PurchaseDetailListArrivalTaxDetailFieldsFragmentDoc}`;
export const PurchaseKoreFieldsFragmentDoc = `
    fragment PurchaseKoreFields on PurchaseKore {
  productCode
  attributeName
  janCode
  productName
  vendorCode
  vendorName
  firstArrivalDate
  totalSalesDate
  totalStock
  remainingOrderQuantity
  productGroupName1
  productGroupName2
  productGroupName3
  domOverFlg
  countryCode
  manufacturer
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  retailPrice
  costRatio
  planningUserName
  designUserName
  minimumLot
  purchaseOrderLeadTime
  latestOrderDate
  latestArrivalDate
  latestOrderToArrivalLeadTime
  latestArrivalQuantity
  latestDailyAverageShipmentQuantity
  latestTotalShipmentCustomers
  latestTotalShipmentQuantity
  latestDio
  previousOrderDate
  previousArrivalDate
  previousOrderToArrivalLeadTime
  previousArrivalQuantity
  previousDailyAverageShipmentQuantity
  previousTotalShipmentCustomers
  previousTotalShipmentQuantity
  previousDio
  beforePreviousOrderDate
  beforePreviousArrivalDate
  beforePreviousOrderToArrivalLeadTime
  beforePreviousArrivalQuantity
  beforePreviousDailyAverageShipmentQuantity
  beforePreviousTotalShipmentCustomers
  beforePreviousTotalShipmentQuantity
  beforePreviousDio
  thirdPreviousOrderDate
  thirdPreviousArrivalDate
  thirdPreviousOrderToArrivalLeadTime
  thirdPreviousArrivalQuantity
  thirdPreviousDailyAverageShipmentQuantity
  thirdPreviousTotalShipmentCustomers
  thirdPreviousTotalShipmentQuantity
  thirdPreviousDio
  daysFromLatestArrivalToNow
  daysFromPreviousArrivalToLatestArrival
  daysFromBeforePreviousArrivalToPreviousArrival
  daysFromThirdPreviousArrivalToBeforePreviousArrival
  mCurrentMonth
  m1MonthsAgo
  m2MonthsAgo
  m3MonthsAgo
  m4MonthsAgo
  m5MonthsAgo
  m6MonthsAgo
  m7MonthsAgo
  m8MonthsAgo
  m9MonthsAgo
  m10MonthsAgo
  m11MonthsAgo
  m12MonthsAgo
  m13MonthsAgo
  m14MonthsAgo
  m15MonthsAgo
  m16MonthsAgo
  m17MonthsAgo
  m18MonthsAgo
  m19MonthsAgo
  m20MonthsAgo
  m21MonthsAgo
  m22MonthsAgo
  m23MonthsAgo
  m24MonthsAgo
  m25MonthsAgo
  m26MonthsAgo
  m27MonthsAgo
  m28MonthsAgo
  m29MonthsAgo
  m30MonthsAgo
  m31MonthsAgo
  m32MonthsAgo
  m33MonthsAgo
  m34MonthsAgo
  m35MonthsAgo
}
    `;
export const SearchPurchaseUnitHistoryFieldsFragmentDoc = `
    fragment SearchPurchaseUnitHistoryFields on SearchPurchaseUnitHistory {
  slipDate
  slipNumber
  vendorName
  quantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
}
    `;
export const ReceiveOrderSalesUnitPriceFieldsFragmentDoc = `
    fragment ReceiveOrderSalesUnitPriceFields on ReceiveOrderDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  receiveOrderId
  numbering
  receiveOrderQuantity
  salesUnitPrice
  receiveOrderHeader {
    versionUuid
    receiveOrderDate
    customerCode
    customer {
      versionUuid
      customerCode
      customerName
      userCode
      user {
        versionUuid
        userCode
        userName
      }
    }
  }
  productCode
  product {
    versionUuid
    janCode
    productName
  }
}
    `;
export const ReceiveOrderDetailFieldsFragmentDoc = `
    fragment ReceiveOrderDetailFields on ReceiveOrderDetail {
  id
  frontNumbering
  numbering
  receiveDetailTradeType
  receiveOrderDetailStatus
  approvalStatus
  productCode
  janCode
  productName
  product {
    division {
      divisionCode
      divisionName
    }
    stock {
      allQuantity
    }
    unitYenDecimalDigits
    quantityDecimalDigits
    allRemainReceiveQuantity
  }
  Warehouse {
    warehouseCode
    warehouseName
    divisionCode
  }
  warehouseCode
  receiveOrderQuantity
  receiveOrderDecisionQuantity
  receiveOrderUnit
  receiveOrderPrice
  taxationDivision
  detailMemo
  salesUnitPrice
  retailPrice
  deliveredQuantity
  detailMainFlg
  outWarehouseFlg
  receiveOrderId
  warehouseCode
  estimateDetailId
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  versionUuid
}
    `;
export const ReceiveOrderHeaderFieldsFragmentDoc = `
    fragment ReceiveOrderHeaderFields on ReceiveOrderHeader {
  id
  receiveOrderId
  receiveOrderDate
  deliveryDate
  salesDate
  receiveOrderStatus
  receiveOrderType
  returnDivision
  receiveOrderMemo
  customerCode
  provisionalCustomerName
  orderPath
  ordererName
  ordererEmail1
  ordererEmail2
  ordererEmail3
  ordererTel
  ordererRemark
  userId
  customerGroup
  salesTradeDivision
  salesTaxType
  customerWarehouseCode
  deliveryDestinationCode
  deliveryDestinationName
  divisionCode
  salesUserCode
  receiveOrderRemarks
  estimateId
  taxExcludeTotal
  taxExcluded10Per
  taxExcluded8Per
  tax10Per
  tax8Per
  receiveOrderTotalPrice
  deliveryStatus
  completedDetailCount
  undeliveredDetailCount
  detailCount
  orderPath
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  versionUuid
  sales {
    demand {
      clearingState
      demandId
    }
  }
  salesUser {
    userName
  }
  customer {
    customerName
  }
  receiveOrderDetails {
    edges {
      node {
        ...ReceiveOrderDetailFields
      }
    }
  }
}
    ${ReceiveOrderDetailFieldsFragmentDoc}`;
export const ReceiveOrderMutationFieldsFragmentDoc = `
    fragment ReceiveOrderMutationFields on ReceiveOrderHeader {
  id
  receiveOrderId
  customerCode
  receiveOrderDate
  receiveOrderDetails {
    edges {
      node {
        ...ReceiveOrderDetailFields
      }
    }
  }
}
    ${ReceiveOrderDetailFieldsFragmentDoc}`;
export const CustomerFieldsForReceiveFragmentDoc = `
    fragment CustomerFieldsForReceive on Customer {
  customerCode
  customerName
  customerGroup
  userCode
  user {
    userName
  }
  priceRoundType
  taxRoundType
  salesTradeDivision
  salesTaxType
  customerUser
  ratio
  balanceData
  creditLimitPrice
  userDivisionCode
  warehouse {
    warehouseCode
    warehouseName
  }
}
    `;
export const SearchReceiveOrderFieldsFragmentDoc = `
    fragment SearchReceiveOrderFields on ReceiveOrderHeader {
  id
  receiveOrderId
  receiveOrderDate
  deliveryDate
  receiveOrderType
  customerCode
  provisionalCustomerName
  customer {
    customerCode
    customerName
  }
  divisionCode
  salesUser {
    userName
  }
  taxExcludeTotal
  taxExcluded10Per
  taxExcluded8Per
  tax10Per
  tax8Per
  receiveOrderTotalPrice
  deliveryDestinationName
  salesTradeDivision
  returnDivision
  salesTaxType
  receiveOrderStatus
  deliveryStatus
  detailCount
  completedDetailCount
  undeliveredDetailCount
  receiveOrderMemo
  receiveOrderRemarks
  orderPath
  versionUuid
}
    `;
export const WarehouseForReceiveOrderFieldsFragmentDoc = `
    fragment WarehouseForReceiveOrderFields on Warehouse {
  warehouseCode
  warehouseName
  warehouseType
  divisionCode
  id
  versionUuid
  division {
    divisionCode
    divisionName
  }
}
    `;
export const SearchReceiveOrderDetailFieldsFragmentDoc = `
    fragment SearchReceiveOrderDetailFields on SearchReceiveOrderDetail {
  receiveOrderDate
  receiveOrderId
  customerCode
  customerName
  deliveryDestinationCode
  deliveryDestinationName
  divisionCode
  divisionName
  salesUserCode
  userName
  receiveDetailTradeType
  receiveOrderDetailStatus
  janCode
  productName
  remainQuantity
  receiveOrderQuantity
  salesUnitPrice
  receiveOrderUnit
  receiveOrderPrice
  grossProfit
  taxationDivision
  detailMemo
  salesTradeDivision
  estimateId
  deliveryDate
  receiveOrderRemarks
  salesTaxType
  detailFlg
  idForLink
  priceRoundType
  taxRoundType
  firstRowByOrder
  lastRowByOrder
}
    `;
export const SalesDetailFieldsFragmentDoc = `
    fragment SalesDetailFields on SalesDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  salesId
  numbering
  receiveDetailTradeType
  janCode
  productName
  warehouseCode
  receiveOrderQuantity
  salesUnitPrice
  retailPrice
  sellingUnitPrice
  sellingPrice
  taxationDivision
  detailMemo
  deliveryOrderDetailNumbering
  clearingPrice
  detailMainFlg
  totalQuantity
  taxDivision {
    id
    taxationDivision
    taxationDivisionName
    taxRatio
  }
  id
}
    `;
export const LegderShipmentTaxDetailFieldsFragmentDoc = `
    fragment LegderShipmentTaxDetailFields on ShipmentTaxDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  deliveryOrderId
  taxationDivision
  taxRoundType
  taxExcluded
  exciseTax
  taxIncluded
  id
}
    `;
export const SalesFieldsFragmentDoc = `
    fragment SalesFields on Sales {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  salesId
  salesDate
  customerCode
  salesTradeDivision
  salesTaxType
  deliveryDestinationCode
  deliveryDestinationName
  salesUserCode
  salesRemark
  deliveryOrderId
  exciseTax
  exciseTaxClearing
  closingStatusCode
  demandId
  divisionCode
  trustSalesDivision
  receiveOrderId
  salesVoucherType
  searchKeyword
  salesDetails {
    edges {
      node {
        ...SalesDetailFields
      }
    }
  }
  customer {
    id
    customerCode
    customerName
    customerFuri
    customerGroup
    userDivisionCode
    userCode
    divisionBundle
    zipCode
    address1
    address2
    customerPostName
    customerPositionName
    customerUser
    honorificCode
    tel
    fax
    email
    salesTradeDivision
    salesTaxType
    priceRoundType
    taxRoundType
    customerUnitpriceType
    ratio
    creditLimitPrice
    demandClosingGroupCode
    billSendDivision
    collectMethodCode
    collectCycleCode
    collectDate
    demandCode
    transferShareCost
    billSite
    outsourcerCode
    collectDays
    salesUserName1
    salesUserEmail1
    salesUserName2
    salesUserEmail2
    salesUserName3
    salesUserEmail3
    inventoryControlUnit
    reportOutputUnit
    designAmebaFlg
    tradeStopFlg
    businessAmebaFlg
    customerRank
    prescribeSalesReport
    prescribeDemandReport
    addressLabelFlg
    customerArea
    customerMemo
    createDate
    updateDate
    versionUuid
    balanceData
    delFlg
  }
  demand {
    id
    clearingState
    salesTaxType
  }
  division {
    id
    divisionCode
    divisionName
    divistionType
  }
  salesUser {
    id
    userCode
    userName
    userType
  }
  shipment {
    deliveryOrderId
    receiveOrderId
  }
  shipmentTaxDetails {
    edges {
      node {
        ...LegderShipmentTaxDetailFields
        taxDivision {
          id
          taxationDivision
          taxationDivisionName
          taxRatio
        }
      }
    }
  }
  allShipmentTaxDetails {
    edges {
      node {
        ...LegderShipmentTaxDetailFields
        taxDivision {
          id
          taxationDivision
          taxationDivisionName
          taxRatio
        }
      }
    }
  }
  trustInventory {
    trustInventoryId
  }
  id
}
    ${SalesDetailFieldsFragmentDoc}
${LegderShipmentTaxDetailFieldsFragmentDoc}`;
export const CustomerSalesMonthlyFieldsFragmentDoc = `
    fragment CustomerSalesMonthlyFields on CustomerSalesMonthly {
  demandCode
  totalingMonthly
  totalingPeriod
  totalingSellingPrice
  totalingDepositPrice
}
    `;
export const CustomerFromCodeFieldsFragmentDoc = `
    fragment CustomerFromCodeFields on Customer {
  id
  customerCode
  customerName
  customerFuri
  customerGroup
  userDivisionCode
  userCode
  divisionBundle
  zipCode
  address1
  address2
  customerPostName
  customerPositionName
  customerUser
  honorificCode
  tel
  fax
  email
  salesTradeDivision
  salesTaxType
  priceRoundType
  taxRoundType
  customerUnitpriceType
  ratio
  creditLimitPrice
  demandClosingGroupCode
  billSendDivision
  collectMethodCode
  collectCycleCode
  collectDate
  demandCode
  transferShareCost
  billSite
  outsourcerCode
  collectDays
  salesUserName1
  salesUserEmail1
  salesUserName2
  salesUserEmail2
  salesUserName3
  salesUserEmail3
  inventoryControlUnit
  reportOutputUnit
  designAmebaFlg
  tradeStopFlg
  businessAmebaFlg
  customerRank
  prescribeSalesReport
  prescribeDemandReport
  addressLabelFlg
  customerArea
  customerMemo
  createDate
  updateDate
  versionUuid
}
    `;
export const SalesDetailListDetailFieldsFragmentDoc = `
    fragment SalesDetailListDetailFields on SalesDetail {
  shipmentDetail {
    deliveryOrderDetailStatus
  }
  receiveDetailTradeType
  janCode
  productName
  receiveOrderQuantity
  salesUnitPrice
  sellingUnitPrice
  sellingPrice
  detailMemo
  taxationDivision
  totalTaxExcluded
  totalQuantity
}
    `;
export const SalesDetailListShipmentTaxDetailFieldsFragmentDoc = `
    fragment SalesDetailListShipmentTaxDetailFields on ShipmentTaxDetail {
  taxationDivision
  exciseTax
  taxExcluded
  taxIncluded
}
    `;
export const SalesDetailListHeaderFieldsFragmentDoc = `
    fragment SalesDetailListHeaderFields on Sales {
  createUserCode
  createUserName
  salesDate
  salesId
  customerCode
  customer {
    customerName
    taxRoundType
  }
  divisionCode
  deliveryOrderId
  salesTradeDivision
  closingTiming
  closingStatusCode
  salesTaxType
  deliveryDestinationCode
  deliveryDestinationName
  salesRemark
  salesUserCode
  salesUser {
    userName
  }
  salesVoucherType
  shipment {
    salesRemark
    deliveryOrderMemo
  }
  receiveOrderId
  receiveOrder {
    estimateId
    receiveOrderRemarks
    receiveOrderType
    receiveOrderMemo
  }
  salesDetails(filter: $detailFilter) {
    edges {
      node {
        ...SalesDetailListDetailFields
      }
    }
  }
  allShipmentTaxDetails {
    edges {
      node {
        ...SalesDetailListShipmentTaxDetailFields
      }
    }
  }
  trustSalesDivision
  trustInventory {
    trustInventoryId
  }
}
    ${SalesDetailListDetailFieldsFragmentDoc}
${SalesDetailListShipmentTaxDetailFieldsFragmentDoc}`;
export const SalesDetailWTaxSummaryFieldsFragmentDoc = `
    fragment SalesDetailWTaxSummaryFields on SalesDetailWTaxSummary {
  count
  salesUnitPrice
  grossProfit
  grossProfitRate
  excludeTax
  targetTen
  taxTen
  targetEight
  taxEight
  taxFree
  notApplicable
  total
}
    `;
export const SalesDetailWTaxDetailFieldsFragmentDoc = `
    fragment SalesDetailWTaxDetailFields on SalesDetailWTaxDetail {
  salesDate
  salesId
  customerCode
  customerName
  divisionCode
  divisionName
  receiveDetailTradeType
  janCode
  uniqueCode
  productCode
  productName
  totalQuantity
  salesUnitPrice
  sellingUnitPrice
  sellingPrice
  grossProfit
  salesRemark
  detailMemo
  taxationDivision
  salesTradeDivision
  closingStatusCode
  salesTaxType
  deliveryDestinationCode
  deliveryDestinationName
  salesUserCode
  salesUserName
  estimateId
  receiveOrderId
  receiveOrderType
  createUserCode
  createUserName
  deliveryOrderDetailStatus
  trustSalesDivision
  shipmentId
  trustInventoryId
  receiveOrderMemo
  deliveryOrderMemo
}
    `;
export const TaxDetailForTrustFieldsFragmentDoc = `
    fragment TaxDetailForTrustFields on ShipmentTaxDetail {
  taxationDivision
  taxExcluded
  exciseTax
}
    `;
export const SalesForTrustFieldsFragmentDoc = `
    fragment SalesForTrustFields on Sales {
  salesId
  trustSalesDivision
  salesDate
  customer {
    customerName
  }
  division {
    divisionName
  }
  salesUser {
    userName
  }
  salesRemark
  allShipmentTaxDetails {
    edges {
      node {
        ...TaxDetailForTrustFields
      }
    }
  }
  trustInventory {
    trustInventoryId
  }
}
    ${TaxDetailForTrustFieldsFragmentDoc}`;
export const SendOrderDetailFieldsFragmentDoc = `
    fragment SendOrderDetailFields on SendOrderDetail {
  id
  orderId
  numbering
  frontNumbering
  groupNumbering
  orderTradeTypeCode
  orderDetailStatus
  janCode
  productCode
  productName
  warehouseCode
  orderQuantity
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  purchasePrice
  purchasePriceDollar
  detailMemo
  receivedQuantity
  taxationDivision
  product {
    division {
      divisionCode
      divisionName
    }
    stock {
      allQuantity
      mainQuantity
      externalQuantity
    }
    unitYenDecimalDigits
    unitDollarDecimalDigits
    quantityDecimalDigits
    allRemainReceiveQuantity
    maxPurchaseOrderQty
  }
  Warehouse {
    warehouseName
    warehouseType
    divisionCode
  }
  sendOrder {
    orderId
    orderDate
    deliveryDate
    orderType
    orderMemo
    vendorCode
    vendorTradeDivision
    vendorTaxType
    shippingTypeCode
    shippingCode
    poCode
    orderRemarks
    vendor {
      vendorName
    }
  }
}
    `;
export const SendOrderFieldsFragmentDoc = `
    fragment SendOrderFields on SendOrder {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  orderId
  orderDate
  deliveryDate
  orderType
  orderMemo
  vendorCode
  vendorTradeDivision
  vendorTaxType
  shippingTypeCode
  shippingCode
  shippingName
  poCode
  orderRemarks
  divisionCode
  deliveryStatus
  searchKeyword
  requestType
  approvalStatus
  remandMemo
  requestDate
  requestUserName
  sendOrderDetails {
    edges {
      node {
        ...SendOrderDetailFields
      }
    }
  }
  vendor {
    vendorName
    taxRoundType
    priceRoundType
    balanceData
    vendorTradeDivision
    vendorTaxType
    purposeGroup
  }
  purchase {
    payment {
      withdrawalState
    }
  }
  id
}
    ${SendOrderDetailFieldsFragmentDoc}`;
export const SendOrderMutationFieldsFragmentDoc = `
    fragment SendOrderMutationFields on SendOrder {
  id
  orderId
  orderDate
  vendorCode
  sendOrderDetails {
    edges {
      node {
        ...SendOrderDetailFields
      }
    }
  }
}
    ${SendOrderDetailFieldsFragmentDoc}`;
export const VendorForSendOrderFieldsFragmentDoc = `
    fragment VendorForSendOrderFields on Vendor {
  vendorCode
  vendorName
  purposeGroup
  vendorTradeDivision
  vendorTaxType
  priceRoundType
  taxRoundType
  vendorUnitpriceType
  balanceData
}
    `;
export const WarehouseForSendOrderFieldsFragmentDoc = `
    fragment WarehouseForSendOrderFields on Warehouse {
  warehouseCode
  warehouseName
  warehouseType
  divisionCode
  id
  versionUuid
  division {
    divisionCode
    divisionName
  }
}
    `;
export const SendOrderLotFieldsFragmentDoc = `
    fragment SendOrderLotFields on SendOrderLot {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  lotGroupCode
  lotGroupName
  minimumLot
  purchaseOrderLeadTime
  delFlg
  id
}
    `;
export const SendOrderViewFieldsFragmentDoc = `
    fragment SendOrderViewFields on SendOrderView {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  orderId
  orderDate
  vendorCode
  divisionCode
  orderType
  vendorTradeDivision
  vendorTaxType
  shippingTypeCode
  shippingName
  orderRemarks
  orderMemo
  vendorName
  vendorUnitpriceType
  detailCount
  completedDetailCount
  undeliveredDetailCount
  deliveryStatus
  taxExcludeTotal
  id
}
    `;
export const SendOrderViewUnapprovedFieldsFragmentDoc = `
    fragment SendOrderViewUnapprovedFields on SendOrderView {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  requestUserCode
  requestUserName
  approvalStatus
  orderDate
  orderId
  poCode
  vendorCode
  vendorName
  taxExcludeTotal
  detailCount
  vendorTaxType
  vendorUnitpriceType
  shippingTypeCode
  shippingName
  id
}
    `;
export const ShipmentFieldsFragmentDoc = `
    fragment ShipmentFields on Shipment {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  deliveryOrderId
  receiveOrderId
  id
}
    `;
export const ShipmentTaxDetailFieldsFragmentDoc = `
    fragment ShipmentTaxDetailFields on ShipmentTaxDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  deliveryOrderId
  taxationDivision
  taxRoundType
  taxExcluded
  exciseTax
  id
}
    `;
export const ReceiveForShipmentDetailFieldsFragmentDoc = `
    fragment ReceiveForShipmentDetailFields on ReceiveOrderDetail {
  id
  numbering
  frontNumbering
  receiveDetailTradeType
  receiveOrderDetailStatus
  approvalStatus
  productCode
  janCode
  productName
  product {
    division {
      divisionCode
      divisionName
    }
    stock {
      allQuantity
    }
    unitYenDecimalDigits
    quantityDecimalDigits
    allRemainReceiveQuantity
  }
  Warehouse {
    warehouseCode
    warehouseName
  }
  warehouseCode
  receiveOrderQuantity
  receiveOrderDecisionQuantity
  receiveOrderUnit
  receiveOrderPrice
  taxationDivision
  detailMemo
  salesUnitPrice
  retailPrice
  deliveredQuantity
  detailMainFlg
  outWarehouseFlg
}
    `;
export const ReceiveForShipmentFieldsFragmentDoc = `
    fragment ReceiveForShipmentFields on ReceiveOrderHeader {
  id
  receiveOrderId
  estimateId
  receiveOrderDate
  deliveryDate
  receiveOrderType
  returnDivision
  receiveOrderMemo
  deliveryDestinationCode
  deliveryDestinationName
  customer {
    customerCode
    customerName
    customerGroup
    priceRoundType
    taxRoundType
    customerUser
    ratio
    balanceData
    creditLimitPrice
    userDivisionCode
    warehouse {
      warehouseCode
      warehouseName
    }
    demand {
      customerCode
      customerName
    }
    customerUnitpriceType
  }
  salesTradeDivision
  salesTaxType
  salesUser {
    userCode
    userName
  }
  receiveOrderRemarks
  receiveOrderDetails {
    edges {
      node {
        ...ReceiveForShipmentDetailFields
      }
    }
  }
  versionUuid
}
    ${ReceiveForShipmentDetailFieldsFragmentDoc}`;
export const ShipmentDetailsSearchFieldsFragmentDoc = `
    fragment ShipmentDetailsSearchFields on ShipmentDetail {
  id
  deliveryOrderId
  numbering
  frontNumbering
  deliveryDetailTradeType
  deliveryOrderDetailStatus
  janCode
  productCode
  productName
  warehouseCode
  deliveryOrderQuantity
  salesUnitPrice
  retailPrice
  sellingUnitPrice
  sellingPrice
  taxationDivision
  detailMemo
  receiveOrderDetailNumbering
  detailMainFlg
  outWarehouseFlg
}
    `;
export const ShipmentSearchFieldsFragmentDoc = `
    fragment ShipmentSearchFields on Shipment {
  id
  deliveryOrderId
  deliveryOrderDate
  deliveryOrderMemo
  customerWarehouseCode
  receiveOrderId
  salesRemark
  shipmentDetails {
    edges {
      node {
        ...ShipmentDetailsSearchFields
      }
    }
  }
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  versionUuid
}
    ${ShipmentDetailsSearchFieldsFragmentDoc}`;
export const SalesForShipmentFragmentDoc = `
    fragment SalesForShipment on Sales {
  salesId
  demandId
  closingTiming
  closingStatusCode
  demand {
    collectExpectedDate
    customer {
      customerName
    }
    clearingState
  }
  demandCustomer {
    customerCode
    customerName
  }
  deliver {
    deliveryDestinationCode
    deliveryDestinationName
  }
}
    `;
export const ShipmentMutationFieldsFragmentDoc = `
    fragment ShipmentMutationFields on Shipment {
  id
  deliveryOrderId
  receiveOrder {
    customerCode
  }
  deliveryOrderDate
  shipmentDetails {
    edges {
      node {
        ...ShipmentDetailsSearchFields
      }
    }
  }
}
    ${ShipmentDetailsSearchFieldsFragmentDoc}`;
export const StockAdjustDetailFieldsFragmentDoc = `
    fragment StockAdjustDetailFields on StockAdjustDetail {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  adjustId
  numbering
  janCode
  productCode
  stockQuantity
  adjustQuantity
  damageQuantity
  unitCost
  detailMemo
  productVariant {
    product {
      productName
    }
  }
  id
}
    `;
export const StockAdjustFieldsFragmentDoc = `
    fragment StockAdjustFields on StockAdjust {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  adjustId
  adjustDate
  warehouseCode
  adjustMemo
  stockAdjustDetails {
    edges {
      node {
        ...StockAdjustDetailFields
      }
    }
  }
  warehouse {
    warehouseName
    division {
      divisionCode
      divisionName
    }
  }
  id
}
    ${StockAdjustDetailFieldsFragmentDoc}`;
export const StockAdjustMutationFieldsFragmentDoc = `
    fragment StockAdjustMutationFields on StockAdjust {
  adjustId
  versionUuid
  adjustDate
  warehouseCode
  stockAdjustDetails {
    edges {
      node {
        ...StockAdjustDetailFields
      }
    }
  }
}
    ${StockAdjustDetailFieldsFragmentDoc}`;
export const StockAnalyticsInventoryFieldsFragmentDoc = `
    fragment StockAnalyticsInventoryFields on StockAnalytics {
  janCode
  productCode
  productName
  lotGroupCode
  lotGroupName
  domOverFlg
  manufacturer
  productGroupName1
  productGroupName2
  productGroupName3
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  salesUnitPrice
  purchaseOrderLeadTime
  minimumLot
  mainQuantity
  externalQuantity
  outsourceQuantity
  orderRemainQuantity
  startMainQuantity
  startExternalQuantity
  startOutsourceQuantity
  startStockQuantity
  endMainQuantity
  endExternalQuantity
  endOutsourceQuantity
  endStockQuantity
  inTotal
  outTotal
  purchase
  trustInput
  buyReturn
  directReturn
  trustReturn
  divisionInput
  productionInput
  adjustInput
  withinCompanyInput
  buyOutput
  trustSales
  directOutput
  trustOutput
  purchaseReturn
  divisionOutput
  productionOutput
  disposal
  adjustOutput
  withinCompanyOutput
  term
  quantityPerDay
  nowStockCycle
  averageStockPrice
  totalSalesUnitPrice
  dio
  dioRank
}
    `;
export const StockAnalyticsMonthFieldsFragmentDoc = `
    fragment StockAnalyticsMonthFields on StockAnalyticsMonth {
  janCode
  productCode
  productName
  lotGroupCode
  lotGroupName
  domOverFlg
  manufacturer
  productGroupName1
  productGroupName2
  productGroupName3
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  salesUnitPrice
  purchaseOrderLeadTime
  minimumLot
  mainQuantity
  externalQuantity
  outsourceQuantity
  orderRemainQuantity
  yearMonth
  isThisTerm
  termMonthRange
  termPrice
  averageStockPrice
  startMainQuantity
  startExternalQuantity
  startOutsourceQuantity
  startStockQuantity
  endMainQuantity
  endExternalQuantity
  endOutsourceQuantity
  endStockQuantity
  inTotal
  outTotal
  purchase
  trustInput
  buyReturn
  directReturn
  trustReturn
  divisionInput
  productionInput
  adjustInput
  withinCompanyInput
  buyOutput
  trustSales
  directOutput
  trustOutput
  purchaseReturn
  divisionOutput
  productionOutput
  disposal
  adjustOutput
  withinCompanyOutput
  quantityPerDay
  nowStockCycle
  termAvrgPerDay
  termAvrgStockCycle
  dio
  dioRank
  isDetail
}
    `;
export const StockAnalyticsFieldsFragmentDoc = `
    fragment StockAnalyticsFields on StockAnalytics {
  janCode
  productCode
  productName
  lotGroupCode
  lotGroupName
  domOverFlg
  manufacturer
  productGroupName1
  productGroupName2
  productGroupName3
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  salesUnitPrice
  purchaseOrderLeadTime
  minimumLot
  mainQuantity
  externalQuantity
  outsourceQuantity
  orderRemainQuantity
  startMainQuantity
  startExternalQuantity
  startOutsourceQuantity
  startStockQuantity
  endMainQuantity
  endExternalQuantity
  endOutsourceQuantity
  endStockQuantity
  inTotal
  outTotal
  purchase
  trustInput
  buyReturn
  directReturn
  trustReturn
  divisionInput
  productionInput
  adjustInput
  withinCompanyInput
  buyOutput
  trustSales
  directOutput
  trustOutput
  purchaseReturn
  divisionOutput
  productionOutput
  disposal
  adjustOutput
  withinCompanyOutput
  term
  quantityPerDay
  nowStockCycle
  averageStockPrice
  totalSalesUnitPrice
  dio
  dioRank
}
    `;
export const StockByWarehouseFieldsFragmentDoc = `
    fragment StockByWarehouseFields on SearchStockByWarehouse {
  divisionCode
  divisionName
  warehouseCode
  warehouseName
  quantity
}
    `;
export const TradeHistoryDialogFieldsFragmentDoc = `
    fragment TradeHistoryDialogFields on SearchTradeHistoryForDialog {
  tradeDate
  customerName
  quantity
}
    `;
export const TradeHistoryFieldsFragmentDoc = `
    fragment TradeHistoryFields on TradeHistory {
  tradeHistoryId
  tradeDate
  tradeHistoryType
  tradeTargetId
  tradeType
  tradeCode
  tradeHistoryTradeDivision
  tradeWarehouseCode
  targetType
  targetCode
  targetWarehouseCode
  productCode
  quantity
  salesUnitPrice
  purchaseUnitPriceYen
  purchaseUnitPriceDollar
  targetWarehouse {
    divisionCode
    warehouseName
    division {
      divisionName
    }
  }
  tradeDivision {
    divisionCode
    divisionName
  }
  tradeCustomer {
    customerCode
    customerName
  }
  tradeVendor {
    vendorCode
    vendorName
  }
}
    `;
export const CreateDispTrustInventoryFieldsFragmentDoc = `
    fragment CreateDispTrustInventoryFields on CreateDispTrustInventory {
  janCode
  uniqueCode
  productCode
  productName
  beforeInventoryQuantity
  currentInputQuantity
  currentReturnQuantity
  currentStockQuantity
  sellingUnitPrice
  taxationDivision
  salesUnitPrice
  unitYenDecimalDigits
  quantityDecimalDegits
  physicalInventory
  currentInputTotalTaxExcluded
  currentReturnTotalTaxExcluded
}
    `;
export const UpdateDispTrustInventoryDetailFieldsFragmentDoc = `
    fragment UpdateDispTrustInventoryDetailFields on Details {
  id
  trustInventoryId
  numbering
  janCode
  uniqueCode
  productCode
  productName
  beforeInventoryQuantity
  currentInputQuantity
  currentReturnQuantity
  currentStockQuantity
  physicalInventory
  damageQuantity
  salesQuantity
  sellingUnitPrice
  taxationDivision
  detailMemo
  salesUnitPrice
  unitYenDecimalDigits
  quantityDecimalDegits
  currentInputTotalTaxExcluded
  currentReturnTotalTaxExcluded
}
    `;
export const UpdateDispTrustInventoryFieldsFragmentDoc = `
    fragment UpdateDispTrustInventoryFields on UpdateDispTrustInventory {
  id
  trustInventoryId
  warehouseCode
  divisionCode
  customerCode
  customerName
  trustInventoryDate
  userName
  inventoryControlUnit
  salesDate
  inventoryFrom
  inventoryTo
  trustInventoryRemark
  priceRoundType
  taxRoundType
  salesTaxType
  versionUuid
  salesId
  trustInventoryPath
  trustInventoryStatus
  sendBackFlg
  reasonForSendBack
  details {
    edges {
      node {
        ...UpdateDispTrustInventoryDetailFields
      }
    }
  }
}
    ${UpdateDispTrustInventoryDetailFieldsFragmentDoc}`;
export const TrustInventoryDetailFieldsFragmentDoc = `
    fragment TrustInventoryDetailFields on TrustInventoryDetail {
  trustInventoryId
  productCode
  currentStock
  physicalInventory
  damageQuantity
  salesQuantity
  sellingUnitPrice
}
    `;
export const TrustInventoryMutationFieldsFragmentDoc = `
    fragment TrustInventoryMutationFields on TrustInventory {
  id
  trustInventoryId
  trustInventoryDate
  warehouseCode
  trustInventoryDetails {
    edges {
      node {
        ...TrustInventoryDetailFields
      }
    }
  }
}
    ${TrustInventoryDetailFieldsFragmentDoc}`;
export const CustomerInfoTrustInventoryFieldsFragmentDoc = `
    fragment CustomerInfoTrustInventoryFields on Customer {
  priceRoundType
  taxRoundType
  inventoryControlUnit
  salesTaxType
  customerUser
  customerCode
  user {
    userName
  }
}
    `;
export const SearchUnitHistoryFieldsFragmentDoc = `
    fragment SearchUnitHistoryFields on SearchUnitHistory {
  slipDate
  slipNumber
  customerName
  quantity
  unitPrice
}
    `;
export const CustomerPriceInUnitPriceFieldsFragmentDoc = `
    fragment CustomerPriceInUnitPriceFields on CustomerPrice {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  customerCode
  uniqueCode
  sellingUnitPrice
  customer {
    customerName
    salesTaxType
    customerUnitpriceType
    ratio
  }
  product {
    janCode
    productName
    unitYenDecimalDigits
    taxationDivision
  }
  id
}
    `;
export const UserFieldsFragmentDoc = `
    fragment UserFields on User {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  userCode
  userName
  userType
  divisionCode
  subDivision1
  subDivision2
  subDivision3
  subDivision4
  email
  superUser
  approvalPrivilege
  systemAdminFlg
  priorityWarehouseCode
  trustInventoryApprovalPrivilege
  delFlg
  id
}
    `;
export const WarehouseFieldsFragmentDoc = `
    fragment WarehouseFields on Warehouse {
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  warehouseCode
  warehouseName
  warehouseType
  divisionCode
  customerCode
  zipCode
  address1
  address2
  warehouseUser
  tel
  fax
  warehouseMemo
  delFlg
  isCountTarget
  id
  versionUuid
  division {
    divisionName
  }
  customer {
    customerCode
    customerName
  }
}
    `;
export const WarehouseMoveDetailFieldsFragmentDoc = `
    fragment WarehouseMoveDetailFields on WarehouseMoveDetail {
  id
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  warehouseMoveId
  numbering
  janCode
  productCode
  transferProductCode
  moveQuantity
  approvedMoveQuantity
  detailMemo
  stockWarehouseMove {
    stockQuantity
    possibleQuantity
  }
  product {
    attributeName
  }
  transferProduct {
    janCode
    attributeName
  }
}
    `;
export const WarehouseMoveFieldsFragmentDoc = `
    fragment WarehouseMoveFields on WarehouseMove {
  id
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  warehouseMoveId
  moveDate
  moveWarehouseSource
  moveWarehouseDestination
  warehouseMoveStatus
  warehouseMoveMethod
  warehouseMoveMemo
  searchKeyword
  moveSource {
    ...WarehouseFields
  }
  moveDestination {
    ...WarehouseFields
  }
  warehouseMoveDetail {
    edges {
      node {
        ...WarehouseMoveDetailFields
      }
    }
  }
}
    ${WarehouseFieldsFragmentDoc}
${WarehouseMoveDetailFieldsFragmentDoc}`;
export const WarehouseMoveMutationFieldsFragmentDoc = `
    fragment WarehouseMoveMutationFields on WarehouseMove {
  warehouseMoveId
  versionUuid
  moveDate
  moveWarehouseSource
  moveWarehouseDestination
  warehouseMoveDetail {
    edges {
      node {
        ...WarehouseMoveDetailFields
      }
    }
  }
}
    ${WarehouseMoveDetailFieldsFragmentDoc}`;
export const SearchWithdrawalFieldsFragmentDoc = `
    fragment SearchWithdrawalFields on Withdrawal {
  versionUuid
  createUserCode
  createUserName
  createDate
  updateUserCode
  updateUserName
  updateDate
  payId
  payDate
  vendorCode
  userCode
  payRemark
  payPriceTotal
  closingStatusCode
  paymentId
  vendor {
    vendorCode
    vendorName
    vendorFuri
    vendorClosingGroup
    paymentMethod
    paymentCycle
    paymentDate
    transferShareCost
    balanceData
    id
  }
  id
}
    `;
export const WithdrawalMonthlyFieldsFragmentDoc = `
    fragment WithdrawalMonthlyFields on WithDrawalsMonthly {
  vendorCode
  fromDate
  toDate
  totalingWithdrawalPrice
}
    `;
export const SearchSendOrderDocument = `
    query searchSendOrder($first: Int, $after: String, $filter: SearchSendOrderFilter, $sort: [SendOrderSortEnum], $detailFilter: SendOrderDetailFilter) {
  searchSendOrder(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchSendOrderFields
        sendOrderDetails(filter: $detailFilter) {
          edges {
            node {
              ...SearchSendOrderDetailFields
            }
          }
        }
        vendor {
          vendorName
        }
      }
    }
  }
}
    ${SearchSendOrderFieldsFragmentDoc}
${SearchSendOrderDetailFieldsFragmentDoc}`;
export const useSearchSendOrderQuery = <
      TData = SearchSendOrderQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderQueryVariables,
      options?: UseQueryOptions<SearchSendOrderQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderQuery, TError, TData>(
      variables === undefined ? ['searchSendOrder'] : ['searchSendOrder', variables],
      useFetchData<SearchSendOrderQuery, SearchSendOrderQueryVariables>(SearchSendOrderDocument).bind(null, variables),
      options
    );

useSearchSendOrderQuery.getKey = (variables?: SearchSendOrderQueryVariables) => variables === undefined ? ['searchSendOrder'] : ['searchSendOrder', variables];
;

export const useInfiniteSearchSendOrderQuery = <
      TData = SearchSendOrderQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderQuery, TError, TData>(
      variables === undefined ? ['searchSendOrder.infinite'] : ['searchSendOrder.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderQuery, SearchSendOrderQueryVariables>(SearchSendOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ActiveReportDemandPrintDocument = `
    mutation activeReportDemandPrint($demandId: Int!, $reportLayoutCode: String, $fcCodeFlg: String, $carryOverPriceFlg: String, $detailStatus: String) {
  activeReportDemandPrint(
    demandId: $demandId
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
    carryOverPriceFlg: $carryOverPriceFlg
    detailStatus: $detailStatus
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportDemandPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportDemandPrintMutation, TError, ActiveReportDemandPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportDemandPrintMutation, TError, ActiveReportDemandPrintMutationVariables, TContext>(
      'activeReportDemandPrint',
      useFetchData<ActiveReportDemandPrintMutation, ActiveReportDemandPrintMutationVariables>(ActiveReportDemandPrintDocument),
      options
    );
export const ActiveReportSaleVoucherPrintDocument = `
    mutation activeReportSaleVoucherPrint($deliveryOrderId: Int!, $withInkan: Boolean, $reportLayoutCode: String, $fcCodeFlg: String, $offsetX: String, $offsetY: String) {
  activeReportSaleVoucherPrint(
    deliveryOrderId: $deliveryOrderId
    withInkan: $withInkan
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
    offsetX: $offsetX
    offsetY: $offsetY
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportSaleVoucherPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportSaleVoucherPrintMutation, TError, ActiveReportSaleVoucherPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportSaleVoucherPrintMutation, TError, ActiveReportSaleVoucherPrintMutationVariables, TContext>(
      'activeReportSaleVoucherPrint',
      useFetchData<ActiveReportSaleVoucherPrintMutation, ActiveReportSaleVoucherPrintMutationVariables>(ActiveReportSaleVoucherPrintDocument),
      options
    );
export const ActiveReportReceiveOrderPrintDocument = `
    mutation activeReportReceiveOrderPrint($receiveOrderId: Int!, $withInkan: Boolean, $reportLayoutCode: String, $fcCodeFlg: String, $offsetX: String, $offsetY: String) {
  activeReportReceiveOrderPrint(
    receiveOrderId: $receiveOrderId
    withInkan: $withInkan
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
    offsetX: $offsetX
    offsetY: $offsetY
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportReceiveOrderPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportReceiveOrderPrintMutation, TError, ActiveReportReceiveOrderPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportReceiveOrderPrintMutation, TError, ActiveReportReceiveOrderPrintMutationVariables, TContext>(
      'activeReportReceiveOrderPrint',
      useFetchData<ActiveReportReceiveOrderPrintMutation, ActiveReportReceiveOrderPrintMutationVariables>(ActiveReportReceiveOrderPrintDocument),
      options
    );
export const ActiveReportEstimatePrintDocument = `
    mutation activeReportEstimatePrint($estimateId: Int!, $withInkan: Boolean, $reportLayoutCode: String, $fcCodeFlg: String) {
  activeReportEstimatePrint(
    estimateId: $estimateId
    withInkan: $withInkan
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportEstimatePrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportEstimatePrintMutation, TError, ActiveReportEstimatePrintMutationVariables, TContext>) =>
    useMutation<ActiveReportEstimatePrintMutation, TError, ActiveReportEstimatePrintMutationVariables, TContext>(
      'activeReportEstimatePrint',
      useFetchData<ActiveReportEstimatePrintMutation, ActiveReportEstimatePrintMutationVariables>(ActiveReportEstimatePrintDocument),
      options
    );
export const ActiveReportSendOrderPrintDocument = `
    mutation activeReportSendOrderPrint($orderId: Int!, $withInkan: Boolean, $reportLayoutCode: String, $fcCodeFlg: String) {
  activeReportSendOrderPrint(
    orderId: $orderId
    withInkan: $withInkan
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportSendOrderPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportSendOrderPrintMutation, TError, ActiveReportSendOrderPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportSendOrderPrintMutation, TError, ActiveReportSendOrderPrintMutationVariables, TContext>(
      'activeReportSendOrderPrint',
      useFetchData<ActiveReportSendOrderPrintMutation, ActiveReportSendOrderPrintMutationVariables>(ActiveReportSendOrderPrintDocument),
      options
    );
export const ActiveReportOutsourcerSalesPrintDocument = `
    mutation activeReportOutsourcerSalesPrint($salesId: Int!, $withInkan: Boolean, $reportLayoutCode: String, $fcCodeFlg: String) {
  activeReportOutsourcerSalesPrint(
    salesId: $salesId
    withInkan: $withInkan
    reportLayoutCode: $reportLayoutCode
    fcCodeFlg: $fcCodeFlg
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportOutsourcerSalesPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportOutsourcerSalesPrintMutation, TError, ActiveReportOutsourcerSalesPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportOutsourcerSalesPrintMutation, TError, ActiveReportOutsourcerSalesPrintMutationVariables, TContext>(
      'activeReportOutsourcerSalesPrint',
      useFetchData<ActiveReportOutsourcerSalesPrintMutation, ActiveReportOutsourcerSalesPrintMutationVariables>(ActiveReportOutsourcerSalesPrintDocument),
      options
    );
export const ActiveReportBulkDemandPrintDocument = `
    mutation activeReportBulkDemandPrint($demandIds: [Int!], $fcCodeFlg: String, $detailStatus: String!, $carryOverPriceFlg: String!, $excludeZeroDemandFlg: String!) {
  activeReportBulkDemandPrint(
    demandIds: $demandIds
    fcCodeFlg: $fcCodeFlg
    detailStatus: $detailStatus
    carryOverPriceFlg: $carryOverPriceFlg
    excludeZeroDemandFlg: $excludeZeroDemandFlg
  ) {
    presignedUrl
  }
}
    `;
export const useActiveReportBulkDemandPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportBulkDemandPrintMutation, TError, ActiveReportBulkDemandPrintMutationVariables, TContext>) =>
    useMutation<ActiveReportBulkDemandPrintMutation, TError, ActiveReportBulkDemandPrintMutationVariables, TContext>(
      'activeReportBulkDemandPrint',
      useFetchData<ActiveReportBulkDemandPrintMutation, ActiveReportBulkDemandPrintMutationVariables>(ActiveReportBulkDemandPrintDocument),
      options
    );
export const ActiveReportCreatePriceCardDocument = `
    mutation activeReportCreatePriceCard($productCodes: [String]!, $titles: String, $targetDate: Date!, $reportLayoutCode: String!, $priceMode: String!, $copiesDetail: [CreatePriceCard!]!) {
  activeReportCreatePriceCard(
    productCodes: $productCodes
    titles: $titles
    targetDate: $targetDate
    reportLayoutCode: $reportLayoutCode
    priceMode: $priceMode
    copiesDetail: $copiesDetail
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportCreatePriceCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportCreatePriceCardMutation, TError, ActiveReportCreatePriceCardMutationVariables, TContext>) =>
    useMutation<ActiveReportCreatePriceCardMutation, TError, ActiveReportCreatePriceCardMutationVariables, TContext>(
      'activeReportCreatePriceCard',
      useFetchData<ActiveReportCreatePriceCardMutation, ActiveReportCreatePriceCardMutationVariables>(ActiveReportCreatePriceCardDocument),
      options
    );
export const ActiveReportCreatePriceCardForTshirtsDocument = `
    mutation activeReportCreatePriceCardForTshirts($janCodes: [String]!, $targetDate: Date!, $copiesDetail: [CreatePriceCardForTshirts!]!) {
  activeReportCreatePriceCardForTshirts(
    janCodes: $janCodes
    targetDate: $targetDate
    copiesDetail: $copiesDetail
  ) {
    pdfBase64
  }
}
    `;
export const useActiveReportCreatePriceCardForTshirtsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActiveReportCreatePriceCardForTshirtsMutation, TError, ActiveReportCreatePriceCardForTshirtsMutationVariables, TContext>) =>
    useMutation<ActiveReportCreatePriceCardForTshirtsMutation, TError, ActiveReportCreatePriceCardForTshirtsMutationVariables, TContext>(
      'activeReportCreatePriceCardForTshirts',
      useFetchData<ActiveReportCreatePriceCardForTshirtsMutation, ActiveReportCreatePriceCardForTshirtsMutationVariables>(ActiveReportCreatePriceCardForTshirtsDocument),
      options
    );
export const SearchAddressDocument = `
    query searchAddress($first: Int, $after: String, $filter: SearchAddressFilter, $sort: [AddressSortEnum]) {
  searchAddress(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...AddressFields
      }
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export const useSearchAddressQuery = <
      TData = SearchAddressQuery,
      TError = unknown
    >(
      variables?: SearchAddressQueryVariables,
      options?: UseQueryOptions<SearchAddressQuery, TError, TData>
    ) =>
    useQuery<SearchAddressQuery, TError, TData>(
      variables === undefined ? ['searchAddress'] : ['searchAddress', variables],
      useFetchData<SearchAddressQuery, SearchAddressQueryVariables>(SearchAddressDocument).bind(null, variables),
      options
    );

useSearchAddressQuery.getKey = (variables?: SearchAddressQueryVariables) => variables === undefined ? ['searchAddress'] : ['searchAddress', variables];
;

export const useInfiniteSearchAddressQuery = <
      TData = SearchAddressQuery,
      TError = unknown
    >(
      variables?: SearchAddressQueryVariables,
      options?: UseInfiniteQueryOptions<SearchAddressQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchAddressQuery, TError, TData>(
      variables === undefined ? ['searchAddress.infinite'] : ['searchAddress.infinite', variables],
      (metaData) => useFetchData<SearchAddressQuery, SearchAddressQueryVariables>(SearchAddressDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchArrivalDocument = `
    query searchArrival($first: Int, $after: String, $filter: SearchArrivalFilter, $sort: [ArrivalSortEnum]) {
  searchArrival(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        arrivalId
        arrivalDate
        arrivalMemo
        orderId
        arrivalDetails {
          edges {
            node {
              arrivalQuantity
              purchasePrice
              sendOrderDetailGroupNumbering
              sendOrderDetailNumbering
            }
          }
        }
        updateUserName
        updateDate
      }
    }
  }
}
    `;
export const useSearchArrivalQuery = <
      TData = SearchArrivalQuery,
      TError = unknown
    >(
      variables?: SearchArrivalQueryVariables,
      options?: UseQueryOptions<SearchArrivalQuery, TError, TData>
    ) =>
    useQuery<SearchArrivalQuery, TError, TData>(
      variables === undefined ? ['searchArrival'] : ['searchArrival', variables],
      useFetchData<SearchArrivalQuery, SearchArrivalQueryVariables>(SearchArrivalDocument).bind(null, variables),
      options
    );

useSearchArrivalQuery.getKey = (variables?: SearchArrivalQueryVariables) => variables === undefined ? ['searchArrival'] : ['searchArrival', variables];
;

export const useInfiniteSearchArrivalQuery = <
      TData = SearchArrivalQuery,
      TError = unknown
    >(
      variables?: SearchArrivalQueryVariables,
      options?: UseInfiniteQueryOptions<SearchArrivalQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchArrivalQuery, TError, TData>(
      variables === undefined ? ['searchArrival.infinite'] : ['searchArrival.infinite', variables],
      (metaData) => useFetchData<SearchArrivalQuery, SearchArrivalQueryVariables>(SearchArrivalDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ArrivalDocument = `
    query arrival($id: ID!) {
  arrival(id: $id) {
    id
    versionUuid
    arrivalId
    arrivalDate
    arrivalMemo
    orderId
    createUserCode
    createUserName
    createDate
    updateUserCode
    updateUserName
    updateDate
    purchaseRemark
    arrivalDetails {
      edges {
        node {
          id
          arrivalId
          numbering
          frontNumbering
          arrivalTradeTypeCode
          arrivalDetailStatus
          janCode
          productCode
          productName
          warehouseCode
          arrivalQuantity
          purchaseUnitPriceYen
          purchaseUnitPriceDollar
          purchasePrice
          purchasePriceDollar
          detailMemo
          taxationDivision
          sendOrderDetailGroupNumbering
          sendOrderDetailNumbering
          createUserCode
          createUserName
          createDate
          updateUserCode
          updateUserName
          updateDate
          product {
            division {
              divisionCode
              divisionName
            }
            stock {
              allQuantity
              mainQuantity
              externalQuantity
            }
            unitYenDecimalDigits
            unitDollarDecimalDigits
            quantityDecimalDigits
            allRemainReceiveQuantity
          }
          warehouse {
            warehouseName
            warehouseType
            divisionCode
          }
          versionUuid
        }
      }
    }
    purchase {
      poCode
      purchaseRemark
      closingTiming
      closingStatusCode
    }
    sendOrder {
      orderId
      orderType
      poCode
      orderMemo
      versionUuid
      divisionCode
      sendOrderDetails {
        edges {
          node {
            ...ArrivalSendOrderDetailFields
          }
        }
      }
      vendor {
        vendorCode
        vendorName
        vendorTaxType
        vendorTradeDivision
        taxRoundType
        priceRoundType
        balanceData
        purposeGroup
      }
    }
  }
}
    ${ArrivalSendOrderDetailFieldsFragmentDoc}`;
export const useArrivalQuery = <
      TData = ArrivalQuery,
      TError = unknown
    >(
      variables: ArrivalQueryVariables,
      options?: UseQueryOptions<ArrivalQuery, TError, TData>
    ) =>
    useQuery<ArrivalQuery, TError, TData>(
      ['arrival', variables],
      useFetchData<ArrivalQuery, ArrivalQueryVariables>(ArrivalDocument).bind(null, variables),
      options
    );

useArrivalQuery.getKey = (variables: ArrivalQueryVariables) => ['arrival', variables];
;

export const useInfiniteArrivalQuery = <
      TData = ArrivalQuery,
      TError = unknown
    >(
      variables: ArrivalQueryVariables,
      options?: UseInfiniteQueryOptions<ArrivalQuery, TError, TData>
    ) =>
    useInfiniteQuery<ArrivalQuery, TError, TData>(
      ['arrival.infinite', variables],
      (metaData) => useFetchData<ArrivalQuery, ArrivalQueryVariables>(ArrivalDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateArrivalDocument = `
    mutation createArrival($input: CreateArrivalInput!) {
  createArrival(input: $input) {
    arrival {
      ...ArrivalMutationFields
    }
  }
}
    ${ArrivalMutationFieldsFragmentDoc}`;
export const useCreateArrivalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateArrivalMutation, TError, CreateArrivalMutationVariables, TContext>) =>
    useMutation<CreateArrivalMutation, TError, CreateArrivalMutationVariables, TContext>(
      'createArrival',
      useFetchData<CreateArrivalMutation, CreateArrivalMutationVariables>(CreateArrivalDocument),
      options
    );
export const UpdateArrivalDocument = `
    mutation updateArrival($input: UpdateArrivalInput!) {
  updateArrival(input: $input) {
    arrival {
      ...ArrivalMutationFields
    }
  }
}
    ${ArrivalMutationFieldsFragmentDoc}`;
export const useUpdateArrivalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateArrivalMutation, TError, UpdateArrivalMutationVariables, TContext>) =>
    useMutation<UpdateArrivalMutation, TError, UpdateArrivalMutationVariables, TContext>(
      'updateArrival',
      useFetchData<UpdateArrivalMutation, UpdateArrivalMutationVariables>(UpdateArrivalDocument),
      options
    );
export const DeleteArrivalDocument = `
    mutation deleteArrival($input: DeleteArrivalInput!) {
  deleteArrival(input: $input) {
    arrival {
      ...ArrivalMutationFields
    }
  }
}
    ${ArrivalMutationFieldsFragmentDoc}`;
export const useDeleteArrivalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteArrivalMutation, TError, DeleteArrivalMutationVariables, TContext>) =>
    useMutation<DeleteArrivalMutation, TError, DeleteArrivalMutationVariables, TContext>(
      'deleteArrival',
      useFetchData<DeleteArrivalMutation, DeleteArrivalMutationVariables>(DeleteArrivalDocument),
      options
    );
export const SearchArrivalDetailDocument = `
    query searchArrivalDetail($first: Int, $after: String, $filter: SearchArrivalFilter, $sort: [ArrivalSortEnum], $detailFilter: ArrivalDetailFilter) {
  searchArrival(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        arrivalId
        arrivalDate
        arrivalMemo
        orderId
        purchaseVoucherType
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        purchaseRemark
        arrivalDetails(filter: $detailFilter) {
          edges {
            node {
              id
              arrivalId
              numbering
              frontNumbering
              arrivalTradeTypeCode
              arrivalDetailStatus
              janCode
              productCode
              productName
              warehouseCode
              arrivalQuantity
              totalQuantity
              totalTaxExcluded
              purchaseUnitPriceYen
              purchaseUnitPriceDollar
              purchasePrice
              purchasePriceDollar
              detailMemo
              taxationDivision
              sendOrderDetailGroupNumbering
              sendOrderDetailNumbering
              createUserCode
              createUserName
              createDate
              updateUserCode
              updateUserName
              updateDate
              product {
                division {
                  divisionCode
                  divisionName
                }
                stock {
                  allQuantity
                  mainQuantity
                  externalQuantity
                }
                unitYenDecimalDigits
                unitDollarDecimalDigits
                quantityDecimalDigits
                allRemainReceiveQuantity
              }
              warehouse {
                warehouseName
                warehouseType
              }
              versionUuid
            }
          }
        }
        purchase {
          poCode
          purchaseRemark
          closingTiming
          closingStatusCode
          taxExcludedTotal
          purchaseId
          divisionCode
          division {
            divisionName
          }
        }
        sendOrder {
          orderId
          orderType
          poCode
          orderMemo
          versionUuid
          divisionCode
          sendOrderDetails {
            edges {
              node {
                ...ArrivalSendOrderDetailFields
              }
            }
          }
          vendor {
            vendorCode
            vendorName
            vendorTaxType
            vendorTradeDivision
            taxRoundType
            priceRoundType
            balanceData
            purposeGroup
          }
          purchase {
            purchaseId
          }
        }
        arrivalTaxDetail {
          edges {
            node {
              taxExcluded
              exciseTax
              taxIncluded
              taxationDivision
            }
          }
        }
      }
    }
  }
}
    ${ArrivalSendOrderDetailFieldsFragmentDoc}`;
export const useSearchArrivalDetailQuery = <
      TData = SearchArrivalDetailQuery,
      TError = unknown
    >(
      variables?: SearchArrivalDetailQueryVariables,
      options?: UseQueryOptions<SearchArrivalDetailQuery, TError, TData>
    ) =>
    useQuery<SearchArrivalDetailQuery, TError, TData>(
      variables === undefined ? ['searchArrivalDetail'] : ['searchArrivalDetail', variables],
      useFetchData<SearchArrivalDetailQuery, SearchArrivalDetailQueryVariables>(SearchArrivalDetailDocument).bind(null, variables),
      options
    );

useSearchArrivalDetailQuery.getKey = (variables?: SearchArrivalDetailQueryVariables) => variables === undefined ? ['searchArrivalDetail'] : ['searchArrivalDetail', variables];
;

export const useInfiniteSearchArrivalDetailQuery = <
      TData = SearchArrivalDetailQuery,
      TError = unknown
    >(
      variables?: SearchArrivalDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchArrivalDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchArrivalDetailQuery, TError, TData>(
      variables === undefined ? ['searchArrivalDetail.infinite'] : ['searchArrivalDetail.infinite', variables],
      (metaData) => useFetchData<SearchArrivalDetailQuery, SearchArrivalDetailQueryVariables>(SearchArrivalDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchBeforeDemandClosingDocument = `
    query searchBeforeDemandClosing($first: Int, $after: String, $filter: SearchBeforeDemandClosingListFilter) {
  searchBeforeDemandClosing(first: $first, after: $after, filter: $filter) {
    totalCount
    edges {
      node {
        ...BeforeDemandClosingFields
      }
    }
  }
}
    ${BeforeDemandClosingFieldsFragmentDoc}`;
export const useSearchBeforeDemandClosingQuery = <
      TData = SearchBeforeDemandClosingQuery,
      TError = unknown
    >(
      variables?: SearchBeforeDemandClosingQueryVariables,
      options?: UseQueryOptions<SearchBeforeDemandClosingQuery, TError, TData>
    ) =>
    useQuery<SearchBeforeDemandClosingQuery, TError, TData>(
      variables === undefined ? ['searchBeforeDemandClosing'] : ['searchBeforeDemandClosing', variables],
      useFetchData<SearchBeforeDemandClosingQuery, SearchBeforeDemandClosingQueryVariables>(SearchBeforeDemandClosingDocument).bind(null, variables),
      options
    );

useSearchBeforeDemandClosingQuery.getKey = (variables?: SearchBeforeDemandClosingQueryVariables) => variables === undefined ? ['searchBeforeDemandClosing'] : ['searchBeforeDemandClosing', variables];
;

export const useInfiniteSearchBeforeDemandClosingQuery = <
      TData = SearchBeforeDemandClosingQuery,
      TError = unknown
    >(
      variables?: SearchBeforeDemandClosingQueryVariables,
      options?: UseInfiniteQueryOptions<SearchBeforeDemandClosingQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchBeforeDemandClosingQuery, TError, TData>(
      variables === undefined ? ['searchBeforeDemandClosing.infinite'] : ['searchBeforeDemandClosing.infinite', variables],
      (metaData) => useFetchData<SearchBeforeDemandClosingQuery, SearchBeforeDemandClosingQueryVariables>(SearchBeforeDemandClosingDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetTaxDivisionDocument = `
    query getTaxDivision {
  getTaxDivision {
    edges {
      node {
        taxationDivision
        taxationDivisionName
        taxRatio
      }
    }
  }
}
    `;
export const useGetTaxDivisionQuery = <
      TData = GetTaxDivisionQuery,
      TError = unknown
    >(
      variables?: GetTaxDivisionQueryVariables,
      options?: UseQueryOptions<GetTaxDivisionQuery, TError, TData>
    ) =>
    useQuery<GetTaxDivisionQuery, TError, TData>(
      variables === undefined ? ['getTaxDivision'] : ['getTaxDivision', variables],
      useFetchData<GetTaxDivisionQuery, GetTaxDivisionQueryVariables>(GetTaxDivisionDocument).bind(null, variables),
      options
    );

useGetTaxDivisionQuery.getKey = (variables?: GetTaxDivisionQueryVariables) => variables === undefined ? ['getTaxDivision'] : ['getTaxDivision', variables];
;

export const useInfiniteGetTaxDivisionQuery = <
      TData = GetTaxDivisionQuery,
      TError = unknown
    >(
      variables?: GetTaxDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<GetTaxDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetTaxDivisionQuery, TError, TData>(
      variables === undefined ? ['getTaxDivision.infinite'] : ['getTaxDivision.infinite', variables],
      (metaData) => useFetchData<GetTaxDivisionQuery, GetTaxDivisionQueryVariables>(GetTaxDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetDepositDivisionDocument = `
    query getDepositDivision {
  searchDepositDivision {
    edges {
      node {
        depositDivisionCode
        depositDivisionName
        depositGroupCode
      }
    }
  }
}
    `;
export const useGetDepositDivisionQuery = <
      TData = GetDepositDivisionQuery,
      TError = unknown
    >(
      variables?: GetDepositDivisionQueryVariables,
      options?: UseQueryOptions<GetDepositDivisionQuery, TError, TData>
    ) =>
    useQuery<GetDepositDivisionQuery, TError, TData>(
      variables === undefined ? ['getDepositDivision'] : ['getDepositDivision', variables],
      useFetchData<GetDepositDivisionQuery, GetDepositDivisionQueryVariables>(GetDepositDivisionDocument).bind(null, variables),
      options
    );

useGetDepositDivisionQuery.getKey = (variables?: GetDepositDivisionQueryVariables) => variables === undefined ? ['getDepositDivision'] : ['getDepositDivision', variables];
;

export const useInfiniteGetDepositDivisionQuery = <
      TData = GetDepositDivisionQuery,
      TError = unknown
    >(
      variables?: GetDepositDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<GetDepositDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetDepositDivisionQuery, TError, TData>(
      variables === undefined ? ['getDepositDivision.infinite'] : ['getDepositDivision.infinite', variables],
      (metaData) => useFetchData<GetDepositDivisionQuery, GetDepositDivisionQueryVariables>(GetDepositDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetPaymentDivisionDocument = `
    query getPaymentDivision {
  searchPaymentDivision {
    edges {
      node {
        paymentDivisionCode
        paymentDivisionName
        paymentGroupCode
      }
    }
  }
}
    `;
export const useGetPaymentDivisionQuery = <
      TData = GetPaymentDivisionQuery,
      TError = unknown
    >(
      variables?: GetPaymentDivisionQueryVariables,
      options?: UseQueryOptions<GetPaymentDivisionQuery, TError, TData>
    ) =>
    useQuery<GetPaymentDivisionQuery, TError, TData>(
      variables === undefined ? ['getPaymentDivision'] : ['getPaymentDivision', variables],
      useFetchData<GetPaymentDivisionQuery, GetPaymentDivisionQueryVariables>(GetPaymentDivisionDocument).bind(null, variables),
      options
    );

useGetPaymentDivisionQuery.getKey = (variables?: GetPaymentDivisionQueryVariables) => variables === undefined ? ['getPaymentDivision'] : ['getPaymentDivision', variables];
;

export const useInfiniteGetPaymentDivisionQuery = <
      TData = GetPaymentDivisionQuery,
      TError = unknown
    >(
      variables?: GetPaymentDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<GetPaymentDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetPaymentDivisionQuery, TError, TData>(
      variables === undefined ? ['getPaymentDivision.infinite'] : ['getPaymentDivision.infinite', variables],
      (metaData) => useFetchData<GetPaymentDivisionQuery, GetPaymentDivisionQueryVariables>(GetPaymentDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetDivisionDocument = `
    query getDivision($filter: SearchDivisionFilter) {
  searchDivision(filter: $filter) {
    edges {
      node {
        divisionCode
        divisionName
        divistionType
        customerCode
      }
    }
  }
}
    `;
export const useGetDivisionQuery = <
      TData = GetDivisionQuery,
      TError = unknown
    >(
      variables?: GetDivisionQueryVariables,
      options?: UseQueryOptions<GetDivisionQuery, TError, TData>
    ) =>
    useQuery<GetDivisionQuery, TError, TData>(
      variables === undefined ? ['getDivision'] : ['getDivision', variables],
      useFetchData<GetDivisionQuery, GetDivisionQueryVariables>(GetDivisionDocument).bind(null, variables),
      options
    );

useGetDivisionQuery.getKey = (variables?: GetDivisionQueryVariables) => variables === undefined ? ['getDivision'] : ['getDivision', variables];
;

export const useInfiniteGetDivisionQuery = <
      TData = GetDivisionQuery,
      TError = unknown
    >(
      variables?: GetDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<GetDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetDivisionQuery, TError, TData>(
      variables === undefined ? ['getDivision.infinite'] : ['getDivision.infinite', variables],
      (metaData) => useFetchData<GetDivisionQuery, GetDivisionQueryVariables>(GetDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetFinancialDateDocument = `
    query getFinancialDate($sort: [FinancialDateSortEnum]) {
  getFinancialDate(sort: $sort) {
    edges {
      node {
        financialStage
        financialYear
        financialMonth
        financialStartDate
        financialEndDate
      }
    }
  }
}
    `;
export const useGetFinancialDateQuery = <
      TData = GetFinancialDateQuery,
      TError = unknown
    >(
      variables?: GetFinancialDateQueryVariables,
      options?: UseQueryOptions<GetFinancialDateQuery, TError, TData>
    ) =>
    useQuery<GetFinancialDateQuery, TError, TData>(
      variables === undefined ? ['getFinancialDate'] : ['getFinancialDate', variables],
      useFetchData<GetFinancialDateQuery, GetFinancialDateQueryVariables>(GetFinancialDateDocument).bind(null, variables),
      options
    );

useGetFinancialDateQuery.getKey = (variables?: GetFinancialDateQueryVariables) => variables === undefined ? ['getFinancialDate'] : ['getFinancialDate', variables];
;

export const useInfiniteGetFinancialDateQuery = <
      TData = GetFinancialDateQuery,
      TError = unknown
    >(
      variables?: GetFinancialDateQueryVariables,
      options?: UseInfiniteQueryOptions<GetFinancialDateQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetFinancialDateQuery, TError, TData>(
      variables === undefined ? ['getFinancialDate.infinite'] : ['getFinancialDate.infinite', variables],
      (metaData) => useFetchData<GetFinancialDateQuery, GetFinancialDateQueryVariables>(GetFinancialDateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetUserDocument = `
    query getUser($id: ID!) {
  user(id: $id) {
    userCode
    userName
    userType
  }
}
    `;
export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options?: UseQueryOptions<GetUserQuery, TError, TData>
    ) =>
    useQuery<GetUserQuery, TError, TData>(
      ['getUser', variables],
      useFetchData<GetUserQuery, GetUserQueryVariables>(GetUserDocument).bind(null, variables),
      options
    );

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['getUser', variables];
;

export const useInfiniteGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetUserQuery, TError, TData>(
      ['getUser.infinite', variables],
      (metaData) => useFetchData<GetUserQuery, GetUserQueryVariables>(GetUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetReportLayoutDocument = `
    query getReportLayout($filter: SearchReportLayoutFilter) {
  searchReportLayout(filter: $filter) {
    edges {
      node {
        reportLayoutName
        reportLayoutCode
      }
    }
  }
}
    `;
export const useGetReportLayoutQuery = <
      TData = GetReportLayoutQuery,
      TError = unknown
    >(
      variables?: GetReportLayoutQueryVariables,
      options?: UseQueryOptions<GetReportLayoutQuery, TError, TData>
    ) =>
    useQuery<GetReportLayoutQuery, TError, TData>(
      variables === undefined ? ['getReportLayout'] : ['getReportLayout', variables],
      useFetchData<GetReportLayoutQuery, GetReportLayoutQueryVariables>(GetReportLayoutDocument).bind(null, variables),
      options
    );

useGetReportLayoutQuery.getKey = (variables?: GetReportLayoutQueryVariables) => variables === undefined ? ['getReportLayout'] : ['getReportLayout', variables];
;

export const useInfiniteGetReportLayoutQuery = <
      TData = GetReportLayoutQuery,
      TError = unknown
    >(
      variables?: GetReportLayoutQueryVariables,
      options?: UseInfiniteQueryOptions<GetReportLayoutQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetReportLayoutQuery, TError, TData>(
      variables === undefined ? ['getReportLayout.infinite'] : ['getReportLayout.infinite', variables],
      (metaData) => useFetchData<GetReportLayoutQuery, GetReportLayoutQueryVariables>(GetReportLayoutDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetVendorDocument = `
    query getVendor {
  searchVendor {
    edges {
      node {
        vendorCode
        vendorName
      }
    }
  }
}
    `;
export const useGetVendorQuery = <
      TData = GetVendorQuery,
      TError = unknown
    >(
      variables?: GetVendorQueryVariables,
      options?: UseQueryOptions<GetVendorQuery, TError, TData>
    ) =>
    useQuery<GetVendorQuery, TError, TData>(
      variables === undefined ? ['getVendor'] : ['getVendor', variables],
      useFetchData<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument).bind(null, variables),
      options
    );

useGetVendorQuery.getKey = (variables?: GetVendorQueryVariables) => variables === undefined ? ['getVendor'] : ['getVendor', variables];
;

export const useInfiniteGetVendorQuery = <
      TData = GetVendorQuery,
      TError = unknown
    >(
      variables?: GetVendorQueryVariables,
      options?: UseInfiniteQueryOptions<GetVendorQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetVendorQuery, TError, TData>(
      variables === undefined ? ['getVendor.infinite'] : ['getVendor.infinite', variables],
      (metaData) => useFetchData<GetVendorQuery, GetVendorQueryVariables>(GetVendorDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetProductGroupDocument = `
    query getProductGroup {
  searchProductGroup {
    edges {
      node {
        productGroupId
        productGroupName
      }
    }
  }
}
    `;
export const useGetProductGroupQuery = <
      TData = GetProductGroupQuery,
      TError = unknown
    >(
      variables?: GetProductGroupQueryVariables,
      options?: UseQueryOptions<GetProductGroupQuery, TError, TData>
    ) =>
    useQuery<GetProductGroupQuery, TError, TData>(
      variables === undefined ? ['getProductGroup'] : ['getProductGroup', variables],
      useFetchData<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument).bind(null, variables),
      options
    );

useGetProductGroupQuery.getKey = (variables?: GetProductGroupQueryVariables) => variables === undefined ? ['getProductGroup'] : ['getProductGroup', variables];
;

export const useInfiniteGetProductGroupQuery = <
      TData = GetProductGroupQuery,
      TError = unknown
    >(
      variables?: GetProductGroupQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductGroupQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetProductGroupQuery, TError, TData>(
      variables === undefined ? ['getProductGroup.infinite'] : ['getProductGroup.infinite', variables],
      (metaData) => useFetchData<GetProductGroupQuery, GetProductGroupQueryVariables>(GetProductGroupDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetInventoryDocument = `
    query getInventory {
  searchInventory {
    edges {
      node {
        inventoryId
        inventoryName
      }
    }
  }
}
    `;
export const useGetInventoryQuery = <
      TData = GetInventoryQuery,
      TError = unknown
    >(
      variables?: GetInventoryQueryVariables,
      options?: UseQueryOptions<GetInventoryQuery, TError, TData>
    ) =>
    useQuery<GetInventoryQuery, TError, TData>(
      variables === undefined ? ['getInventory'] : ['getInventory', variables],
      useFetchData<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument).bind(null, variables),
      options
    );

useGetInventoryQuery.getKey = (variables?: GetInventoryQueryVariables) => variables === undefined ? ['getInventory'] : ['getInventory', variables];
;

export const useInfiniteGetInventoryQuery = <
      TData = GetInventoryQuery,
      TError = unknown
    >(
      variables?: GetInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<GetInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetInventoryQuery, TError, TData>(
      variables === undefined ? ['getInventory.infinite'] : ['getInventory.infinite', variables],
      (metaData) => useFetchData<GetInventoryQuery, GetInventoryQueryVariables>(GetInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetCustomerDocument = `
    query getCustomer {
  searchCustomer {
    edges {
      node {
        customerCode
        customerName
      }
    }
  }
}
    `;
export const useGetCustomerQuery = <
      TData = GetCustomerQuery,
      TError = unknown
    >(
      variables?: GetCustomerQueryVariables,
      options?: UseQueryOptions<GetCustomerQuery, TError, TData>
    ) =>
    useQuery<GetCustomerQuery, TError, TData>(
      variables === undefined ? ['getCustomer'] : ['getCustomer', variables],
      useFetchData<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument).bind(null, variables),
      options
    );

useGetCustomerQuery.getKey = (variables?: GetCustomerQueryVariables) => variables === undefined ? ['getCustomer'] : ['getCustomer', variables];
;

export const useInfiniteGetCustomerQuery = <
      TData = GetCustomerQuery,
      TError = unknown
    >(
      variables?: GetCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<GetCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCustomerQuery, TError, TData>(
      variables === undefined ? ['getCustomer.infinite'] : ['getCustomer.infinite', variables],
      (metaData) => useFetchData<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchClothProgressDocument = `
    query searchClothProgress($filter: ClothProgressFilter) {
  searchClothProgress(filter: $filter) {
    edges {
      node {
        orderId
        totalQuantity
        receivedQuantity
        janCode
        sendOrder {
          orderDate
          deliveryDate
          orderMemo
          orderRemarks
        }
        createUserName
        product {
          productName
          attr1
          attr2
          clothGroup
          division {
            divisionName
          }
          productGroup1 {
            productGroupName
          }
          productGroup2 {
            productGroupName
          }
          productGroup3 {
            productGroupName
          }
        }
        clothProgressArraival {
          arrivalDate
          arrivalQuantity
        }
      }
    }
  }
}
    `;
export const useSearchClothProgressQuery = <
      TData = SearchClothProgressQuery,
      TError = unknown
    >(
      variables?: SearchClothProgressQueryVariables,
      options?: UseQueryOptions<SearchClothProgressQuery, TError, TData>
    ) =>
    useQuery<SearchClothProgressQuery, TError, TData>(
      variables === undefined ? ['searchClothProgress'] : ['searchClothProgress', variables],
      useFetchData<SearchClothProgressQuery, SearchClothProgressQueryVariables>(SearchClothProgressDocument).bind(null, variables),
      options
    );

useSearchClothProgressQuery.getKey = (variables?: SearchClothProgressQueryVariables) => variables === undefined ? ['searchClothProgress'] : ['searchClothProgress', variables];
;

export const useInfiniteSearchClothProgressQuery = <
      TData = SearchClothProgressQuery,
      TError = unknown
    >(
      variables?: SearchClothProgressQueryVariables,
      options?: UseInfiniteQueryOptions<SearchClothProgressQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchClothProgressQuery, TError, TData>(
      variables === undefined ? ['searchClothProgress.infinite'] : ['searchClothProgress.infinite', variables],
      (metaData) => useFetchData<SearchClothProgressQuery, SearchClothProgressQueryVariables>(SearchClothProgressDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCollectionPlanDocument = `
    query searchCollectionPlan($first: Int, $after: String, $filter: SearchCollectionPlanFilter, $sort: [DemandSortEnum]) {
  searchCollectionPlan(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        demandCode
        customer {
          customerName
          depositDivision {
            depositDivisionName
          }
        }
        collectExpectedDate
        demandDate
        demandId
        includedTaxTotalDemandPrice
      }
    }
  }
}
    `;
export const useSearchCollectionPlanQuery = <
      TData = SearchCollectionPlanQuery,
      TError = unknown
    >(
      variables?: SearchCollectionPlanQueryVariables,
      options?: UseQueryOptions<SearchCollectionPlanQuery, TError, TData>
    ) =>
    useQuery<SearchCollectionPlanQuery, TError, TData>(
      variables === undefined ? ['searchCollectionPlan'] : ['searchCollectionPlan', variables],
      useFetchData<SearchCollectionPlanQuery, SearchCollectionPlanQueryVariables>(SearchCollectionPlanDocument).bind(null, variables),
      options
    );

useSearchCollectionPlanQuery.getKey = (variables?: SearchCollectionPlanQueryVariables) => variables === undefined ? ['searchCollectionPlan'] : ['searchCollectionPlan', variables];
;

export const useInfiniteSearchCollectionPlanQuery = <
      TData = SearchCollectionPlanQuery,
      TError = unknown
    >(
      variables?: SearchCollectionPlanQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCollectionPlanQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCollectionPlanQuery, TError, TData>(
      variables === undefined ? ['searchCollectionPlan.infinite'] : ['searchCollectionPlan.infinite', variables],
      (metaData) => useFetchData<SearchCollectionPlanQuery, SearchCollectionPlanQueryVariables>(SearchCollectionPlanDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCollectionStatusDocument = `
    query searchCollectionStatus($first: Int, $after: String, $filter: SearchCollectionStatusFilter) {
  searchCollectionStatus(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        userName
        demandCode
        demandName
        collectedNeedThisMonth
        collectedThisMonth
        collectedRate
        remainedLastMonth
        remainedThisMonth
        remainedThisMonthEnd
        collectExpectedLastMonth
        collectExpectedThisMonth
        collectExpectedNextMonth
        collectExpectedAfterNextMonth
      }
    }
  }
}
    `;
export const useSearchCollectionStatusQuery = <
      TData = SearchCollectionStatusQuery,
      TError = unknown
    >(
      variables?: SearchCollectionStatusQueryVariables,
      options?: UseQueryOptions<SearchCollectionStatusQuery, TError, TData>
    ) =>
    useQuery<SearchCollectionStatusQuery, TError, TData>(
      variables === undefined ? ['searchCollectionStatus'] : ['searchCollectionStatus', variables],
      useFetchData<SearchCollectionStatusQuery, SearchCollectionStatusQueryVariables>(SearchCollectionStatusDocument).bind(null, variables),
      options
    );

useSearchCollectionStatusQuery.getKey = (variables?: SearchCollectionStatusQueryVariables) => variables === undefined ? ['searchCollectionStatus'] : ['searchCollectionStatus', variables];
;

export const useInfiniteSearchCollectionStatusQuery = <
      TData = SearchCollectionStatusQuery,
      TError = unknown
    >(
      variables?: SearchCollectionStatusQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCollectionStatusQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCollectionStatusQuery, TError, TData>(
      variables === undefined ? ['searchCollectionStatus.infinite'] : ['searchCollectionStatus.infinite', variables],
      (metaData) => useFetchData<SearchCollectionStatusQuery, SearchCollectionStatusQueryVariables>(SearchCollectionStatusDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ComponentDocument = `
    query Component($id: ID!) {
  component(id: $id) {
    ...ComponentFields
  }
}
    ${ComponentFieldsFragmentDoc}`;
export const useComponentQuery = <
      TData = ComponentQuery,
      TError = unknown
    >(
      variables: ComponentQueryVariables,
      options?: UseQueryOptions<ComponentQuery, TError, TData>
    ) =>
    useQuery<ComponentQuery, TError, TData>(
      ['Component', variables],
      useFetchData<ComponentQuery, ComponentQueryVariables>(ComponentDocument).bind(null, variables),
      options
    );

useComponentQuery.getKey = (variables: ComponentQueryVariables) => ['Component', variables];
;

export const useInfiniteComponentQuery = <
      TData = ComponentQuery,
      TError = unknown
    >(
      variables: ComponentQueryVariables,
      options?: UseInfiniteQueryOptions<ComponentQuery, TError, TData>
    ) =>
    useInfiniteQuery<ComponentQuery, TError, TData>(
      ['Component.infinite', variables],
      (metaData) => useFetchData<ComponentQuery, ComponentQueryVariables>(ComponentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateComponentDocument = `
    mutation createComponent($input: CreateComponentInput!) {
  createComponent(input: $input) {
    component {
      id
      finishedProductCode
      versionUuid
    }
  }
}
    `;
export const useCreateComponentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateComponentMutation, TError, CreateComponentMutationVariables, TContext>) =>
    useMutation<CreateComponentMutation, TError, CreateComponentMutationVariables, TContext>(
      'createComponent',
      useFetchData<CreateComponentMutation, CreateComponentMutationVariables>(CreateComponentDocument),
      options
    );
export const UpdateComponentDocument = `
    mutation updateComponent($input: UpdateComponentInput!) {
  updateComponent(input: $input) {
    component {
      id
      finishedProductCode
      versionUuid
    }
  }
}
    `;
export const useUpdateComponentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateComponentMutation, TError, UpdateComponentMutationVariables, TContext>) =>
    useMutation<UpdateComponentMutation, TError, UpdateComponentMutationVariables, TContext>(
      'updateComponent',
      useFetchData<UpdateComponentMutation, UpdateComponentMutationVariables>(UpdateComponentDocument),
      options
    );
export const DeleteComponentDocument = `
    mutation deleteComponent($input: DeleteComponentInput!) {
  deleteComponent(input: $input) {
    component {
      finishedProductCode
      versionUuid
    }
  }
}
    `;
export const useDeleteComponentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteComponentMutation, TError, DeleteComponentMutationVariables, TContext>) =>
    useMutation<DeleteComponentMutation, TError, DeleteComponentMutationVariables, TContext>(
      'deleteComponent',
      useFetchData<DeleteComponentMutation, DeleteComponentMutationVariables>(DeleteComponentDocument),
      options
    );
export const SearchComponentDocument = `
    query searchComponent($first: Int, $after: String, $filter: SearchComponentFilter, $sort: [ComponentSortEnum]) {
  searchComponent(first: $first, after: $after, filter: $filter, sort: $sort) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ComponentFields
      }
    }
  }
}
    ${ComponentFieldsFragmentDoc}`;
export const useSearchComponentQuery = <
      TData = SearchComponentQuery,
      TError = unknown
    >(
      variables?: SearchComponentQueryVariables,
      options?: UseQueryOptions<SearchComponentQuery, TError, TData>
    ) =>
    useQuery<SearchComponentQuery, TError, TData>(
      variables === undefined ? ['searchComponent'] : ['searchComponent', variables],
      useFetchData<SearchComponentQuery, SearchComponentQueryVariables>(SearchComponentDocument).bind(null, variables),
      options
    );

useSearchComponentQuery.getKey = (variables?: SearchComponentQueryVariables) => variables === undefined ? ['searchComponent'] : ['searchComponent', variables];
;

export const useInfiniteSearchComponentQuery = <
      TData = SearchComponentQuery,
      TError = unknown
    >(
      variables?: SearchComponentQueryVariables,
      options?: UseInfiniteQueryOptions<SearchComponentQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchComponentQuery, TError, TData>(
      variables === undefined ? ['searchComponent.infinite'] : ['searchComponent.infinite', variables],
      (metaData) => useFetchData<SearchComponentQuery, SearchComponentQueryVariables>(SearchComponentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CustomerDocument = `
    query Customer($id: ID!) {
  customer(id: $id) {
    ...CustomerFields
    demand {
      customerCode
      customerName
    }
    user {
      userCode
      userName
    }
    depositDivision {
      depositDivisionCode
      depositDivisionName
    }
    division {
      divisionCode
      divisionName
    }
    warehouse {
      warehouseCode
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const useCustomerQuery = <
      TData = CustomerQuery,
      TError = unknown
    >(
      variables: CustomerQueryVariables,
      options?: UseQueryOptions<CustomerQuery, TError, TData>
    ) =>
    useQuery<CustomerQuery, TError, TData>(
      ['Customer', variables],
      useFetchData<CustomerQuery, CustomerQueryVariables>(CustomerDocument).bind(null, variables),
      options
    );

useCustomerQuery.getKey = (variables: CustomerQueryVariables) => ['Customer', variables];
;

export const useInfiniteCustomerQuery = <
      TData = CustomerQuery,
      TError = unknown
    >(
      variables: CustomerQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<CustomerQuery, TError, TData>(
      ['Customer.infinite', variables],
      (metaData) => useFetchData<CustomerQuery, CustomerQueryVariables>(CustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerDocument = `
    mutation createCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    customer {
      customerCode
      versionUuid
    }
  }
}
    `;
export const useCreateCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>) =>
    useMutation<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>(
      'createCustomer',
      useFetchData<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument),
      options
    );
export const UpdateCustomerDocument = `
    mutation updateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    customer {
      customerCode
      versionUuid
    }
  }
}
    `;
export const useUpdateCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>) =>
    useMutation<UpdateCustomerMutation, TError, UpdateCustomerMutationVariables, TContext>(
      'updateCustomer',
      useFetchData<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument),
      options
    );
export const DeleteCustomerDocument = `
    mutation deleteCustomer($input: DeleteCustomerInput!) {
  deleteCustomer(input: $input) {
    customer {
      customerCode
      versionUuid
    }
  }
}
    `;
export const useDeleteCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerMutation, TError, DeleteCustomerMutationVariables, TContext>) =>
    useMutation<DeleteCustomerMutation, TError, DeleteCustomerMutationVariables, TContext>(
      'deleteCustomer',
      useFetchData<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument),
      options
    );
export const SearchCustomerDocument = `
    query searchCustomer($first: Int, $after: String, $filter: SearchCustomerFilter, $customFilter: SearchCustomerFilter, $sort: [CustomerSortEnum]) {
  searchCustomer(
    first: $first
    after: $after
    filter: $filter
    customFilter: $customFilter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerFields
        user {
          userName
        }
        demand {
          customerName
        }
        division {
          divisionName
        }
        depositDivision {
          depositDivisionName
        }
        salesReport {
          reportLayoutCode
          reportLayoutName
        }
        demandReport {
          reportLayoutCode
          reportLayoutName
        }
      }
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;
export const useSearchCustomerQuery = <
      TData = SearchCustomerQuery,
      TError = unknown
    >(
      variables?: SearchCustomerQueryVariables,
      options?: UseQueryOptions<SearchCustomerQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerQuery, TError, TData>(
      variables === undefined ? ['searchCustomer'] : ['searchCustomer', variables],
      useFetchData<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument).bind(null, variables),
      options
    );

useSearchCustomerQuery.getKey = (variables?: SearchCustomerQueryVariables) => variables === undefined ? ['searchCustomer'] : ['searchCustomer', variables];
;

export const useInfiniteSearchCustomerQuery = <
      TData = SearchCustomerQuery,
      TError = unknown
    >(
      variables?: SearchCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerQuery, TError, TData>(
      variables === undefined ? ['searchCustomer.infinite'] : ['searchCustomer.infinite', variables],
      (metaData) => useFetchData<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerBudgetDocument = `
    mutation createCustomerBudget($input: CreateCustomerBudgetInput!) {
  createCustomerBudget(input: $input) {
    customerBudget {
      id
    }
  }
}
    `;
export const useCreateCustomerBudgetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerBudgetMutation, TError, CreateCustomerBudgetMutationVariables, TContext>) =>
    useMutation<CreateCustomerBudgetMutation, TError, CreateCustomerBudgetMutationVariables, TContext>(
      'createCustomerBudget',
      useFetchData<CreateCustomerBudgetMutation, CreateCustomerBudgetMutationVariables>(CreateCustomerBudgetDocument),
      options
    );
export const ImportCustomerBudgetDocument = `
    mutation importCustomerBudget($input: ImportCustomerBudgetListInput!) {
  importCustomerBudget(input: $input) {
    customerBudget {
      financialStage
      financialMonth
      customerCode
      budgetPrice
    }
  }
}
    `;
export const useImportCustomerBudgetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportCustomerBudgetMutation, TError, ImportCustomerBudgetMutationVariables, TContext>) =>
    useMutation<ImportCustomerBudgetMutation, TError, ImportCustomerBudgetMutationVariables, TContext>(
      'importCustomerBudget',
      useFetchData<ImportCustomerBudgetMutation, ImportCustomerBudgetMutationVariables>(ImportCustomerBudgetDocument),
      options
    );
export const SearchCustomerBudgetDocument = `
    query searchCustomerBudget($first: Int, $after: String, $filter: CustomerBudgetsCustomFilter) {
  searchCustomerBudget(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerBudgetsCustomFields
      }
    }
  }
}
    ${CustomerBudgetsCustomFieldsFragmentDoc}`;
export const useSearchCustomerBudgetQuery = <
      TData = SearchCustomerBudgetQuery,
      TError = unknown
    >(
      variables?: SearchCustomerBudgetQueryVariables,
      options?: UseQueryOptions<SearchCustomerBudgetQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerBudgetQuery, TError, TData>(
      variables === undefined ? ['searchCustomerBudget'] : ['searchCustomerBudget', variables],
      useFetchData<SearchCustomerBudgetQuery, SearchCustomerBudgetQueryVariables>(SearchCustomerBudgetDocument).bind(null, variables),
      options
    );

useSearchCustomerBudgetQuery.getKey = (variables?: SearchCustomerBudgetQueryVariables) => variables === undefined ? ['searchCustomerBudget'] : ['searchCustomerBudget', variables];
;

export const useInfiniteSearchCustomerBudgetQuery = <
      TData = SearchCustomerBudgetQuery,
      TError = unknown
    >(
      variables?: SearchCustomerBudgetQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerBudgetQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerBudgetQuery, TError, TData>(
      variables === undefined ? ['searchCustomerBudget.infinite'] : ['searchCustomerBudget.infinite', variables],
      (metaData) => useFetchData<SearchCustomerBudgetQuery, SearchCustomerBudgetQueryVariables>(SearchCustomerBudgetDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerPriceListDocument = `
    query searchCustomerPriceList($filter: SearchCustomerPriceFilter) {
  searchCustomerPriceList(filter: $filter) {
    totalCount
    list {
      ...CustomerPriceFieldsList
    }
  }
}
    ${CustomerPriceFieldsListFragmentDoc}`;
export const useSearchCustomerPriceListQuery = <
      TData = SearchCustomerPriceListQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceListQueryVariables,
      options?: UseQueryOptions<SearchCustomerPriceListQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerPriceListQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPriceList'] : ['searchCustomerPriceList', variables],
      useFetchData<SearchCustomerPriceListQuery, SearchCustomerPriceListQueryVariables>(SearchCustomerPriceListDocument).bind(null, variables),
      options
    );

useSearchCustomerPriceListQuery.getKey = (variables?: SearchCustomerPriceListQueryVariables) => variables === undefined ? ['searchCustomerPriceList'] : ['searchCustomerPriceList', variables];
;

export const useInfiniteSearchCustomerPriceListQuery = <
      TData = SearchCustomerPriceListQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerPriceListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerPriceListQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPriceList.infinite'] : ['searchCustomerPriceList.infinite', variables],
      (metaData) => useFetchData<SearchCustomerPriceListQuery, SearchCustomerPriceListQueryVariables>(SearchCustomerPriceListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerPriceDocument = `
    query searchCustomerPrice($first: Int, $after: String, $filter: SearchCustomerPriceFilter, $sort: [CustomerPriceSortEnum]) {
  searchCustomerPrice(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerPriceFields
      }
    }
  }
}
    ${CustomerPriceFieldsFragmentDoc}`;
export const useSearchCustomerPriceQuery = <
      TData = SearchCustomerPriceQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceQueryVariables,
      options?: UseQueryOptions<SearchCustomerPriceQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerPriceQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPrice'] : ['searchCustomerPrice', variables],
      useFetchData<SearchCustomerPriceQuery, SearchCustomerPriceQueryVariables>(SearchCustomerPriceDocument).bind(null, variables),
      options
    );

useSearchCustomerPriceQuery.getKey = (variables?: SearchCustomerPriceQueryVariables) => variables === undefined ? ['searchCustomerPrice'] : ['searchCustomerPrice', variables];
;

export const useInfiniteSearchCustomerPriceQuery = <
      TData = SearchCustomerPriceQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerPriceQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerPriceQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPrice.infinite'] : ['searchCustomerPrice.infinite', variables],
      (metaData) => useFetchData<SearchCustomerPriceQuery, SearchCustomerPriceQueryVariables>(SearchCustomerPriceDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerPriceDocument = `
    mutation createCustomerPrice($input: CreateCustomerPriceInput!) {
  createCustomerPrice(input: $input) {
    customerPrice {
      id
      versionUuid
    }
  }
}
    `;
export const useCreateCustomerPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerPriceMutation, TError, CreateCustomerPriceMutationVariables, TContext>) =>
    useMutation<CreateCustomerPriceMutation, TError, CreateCustomerPriceMutationVariables, TContext>(
      'createCustomerPrice',
      useFetchData<CreateCustomerPriceMutation, CreateCustomerPriceMutationVariables>(CreateCustomerPriceDocument),
      options
    );
export const SearchCustomerForCustomerPriceDocument = `
    query searchCustomerForCustomerPrice($id: ID!) {
  customer(id: $id) {
    ...CustomerFieldsForCustomerPrice
  }
}
    ${CustomerFieldsForCustomerPriceFragmentDoc}`;
export const useSearchCustomerForCustomerPriceQuery = <
      TData = SearchCustomerForCustomerPriceQuery,
      TError = unknown
    >(
      variables: SearchCustomerForCustomerPriceQueryVariables,
      options?: UseQueryOptions<SearchCustomerForCustomerPriceQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerForCustomerPriceQuery, TError, TData>(
      ['searchCustomerForCustomerPrice', variables],
      useFetchData<SearchCustomerForCustomerPriceQuery, SearchCustomerForCustomerPriceQueryVariables>(SearchCustomerForCustomerPriceDocument).bind(null, variables),
      options
    );

useSearchCustomerForCustomerPriceQuery.getKey = (variables: SearchCustomerForCustomerPriceQueryVariables) => ['searchCustomerForCustomerPrice', variables];
;

export const useInfiniteSearchCustomerForCustomerPriceQuery = <
      TData = SearchCustomerForCustomerPriceQuery,
      TError = unknown
    >(
      variables: SearchCustomerForCustomerPriceQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerForCustomerPriceQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerForCustomerPriceQuery, TError, TData>(
      ['searchCustomerForCustomerPrice.infinite', variables],
      (metaData) => useFetchData<SearchCustomerForCustomerPriceQuery, SearchCustomerForCustomerPriceQueryVariables>(SearchCustomerForCustomerPriceDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerPriceWithImportDocument = `
    mutation createCustomerPriceWithImport($input: CreateCustomerPriceWithImportInput!) {
  createCustomerPriceWithImport(input: $input) {
    resultDatas {
      importFlg
    }
  }
}
    `;
export const useCreateCustomerPriceWithImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerPriceWithImportMutation, TError, CreateCustomerPriceWithImportMutationVariables, TContext>) =>
    useMutation<CreateCustomerPriceWithImportMutation, TError, CreateCustomerPriceWithImportMutationVariables, TContext>(
      'createCustomerPriceWithImport',
      useFetchData<CreateCustomerPriceWithImportMutation, CreateCustomerPriceWithImportMutationVariables>(CreateCustomerPriceWithImportDocument),
      options
    );
export const CreateCustomerPriceWithBulkImportDocument = `
    mutation createCustomerPriceWithBulkImport($input: CreateCustomerPriceWithBulkImportInput!) {
  createCustomerPriceWithBulkImport(input: $input) {
    ...CreateCustomerPriceWithBulkImportResult
  }
}
    ${CreateCustomerPriceWithBulkImportResultFragmentDoc}`;
export const useCreateCustomerPriceWithBulkImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerPriceWithBulkImportMutation, TError, CreateCustomerPriceWithBulkImportMutationVariables, TContext>) =>
    useMutation<CreateCustomerPriceWithBulkImportMutation, TError, CreateCustomerPriceWithBulkImportMutationVariables, TContext>(
      'createCustomerPriceWithBulkImport',
      useFetchData<CreateCustomerPriceWithBulkImportMutation, CreateCustomerPriceWithBulkImportMutationVariables>(CreateCustomerPriceWithBulkImportDocument),
      options
    );
export const SearchCustomerProductGroupPublicationsDocument = `
    query SearchCustomerProductGroupPublications($filter: CustomerProductGroupPublicationFilter) {
  searchCustomerProductGroupPublications(filter: $filter) {
    ...CustomerProductGroupPublicationFields
  }
}
    ${CustomerProductGroupPublicationFieldsFragmentDoc}`;
export const useSearchCustomerProductGroupPublicationsQuery = <
      TData = SearchCustomerProductGroupPublicationsQuery,
      TError = unknown
    >(
      variables?: SearchCustomerProductGroupPublicationsQueryVariables,
      options?: UseQueryOptions<SearchCustomerProductGroupPublicationsQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerProductGroupPublicationsQuery, TError, TData>(
      variables === undefined ? ['SearchCustomerProductGroupPublications'] : ['SearchCustomerProductGroupPublications', variables],
      useFetchData<SearchCustomerProductGroupPublicationsQuery, SearchCustomerProductGroupPublicationsQueryVariables>(SearchCustomerProductGroupPublicationsDocument).bind(null, variables),
      options
    );

useSearchCustomerProductGroupPublicationsQuery.getKey = (variables?: SearchCustomerProductGroupPublicationsQueryVariables) => variables === undefined ? ['SearchCustomerProductGroupPublications'] : ['SearchCustomerProductGroupPublications', variables];
;

export const useInfiniteSearchCustomerProductGroupPublicationsQuery = <
      TData = SearchCustomerProductGroupPublicationsQuery,
      TError = unknown
    >(
      variables?: SearchCustomerProductGroupPublicationsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerProductGroupPublicationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerProductGroupPublicationsQuery, TError, TData>(
      variables === undefined ? ['SearchCustomerProductGroupPublications.infinite'] : ['SearchCustomerProductGroupPublications.infinite', variables],
      (metaData) => useFetchData<SearchCustomerProductGroupPublicationsQuery, SearchCustomerProductGroupPublicationsQueryVariables>(SearchCustomerProductGroupPublicationsDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetProductGroupBasicInfoByProductGroupCodesDocument = `
    query GetProductGroupBasicInfoByProductGroupCodes($filter: SearchProductGroupFilter!) {
  searchProductGroupByCode(filter: $filter) {
    ...ProductGroupBasicInfoFields
  }
}
    ${ProductGroupBasicInfoFieldsFragmentDoc}`;
export const useGetProductGroupBasicInfoByProductGroupCodesQuery = <
      TData = GetProductGroupBasicInfoByProductGroupCodesQuery,
      TError = unknown
    >(
      variables: GetProductGroupBasicInfoByProductGroupCodesQueryVariables,
      options?: UseQueryOptions<GetProductGroupBasicInfoByProductGroupCodesQuery, TError, TData>
    ) =>
    useQuery<GetProductGroupBasicInfoByProductGroupCodesQuery, TError, TData>(
      ['GetProductGroupBasicInfoByProductGroupCodes', variables],
      useFetchData<GetProductGroupBasicInfoByProductGroupCodesQuery, GetProductGroupBasicInfoByProductGroupCodesQueryVariables>(GetProductGroupBasicInfoByProductGroupCodesDocument).bind(null, variables),
      options
    );

useGetProductGroupBasicInfoByProductGroupCodesQuery.getKey = (variables: GetProductGroupBasicInfoByProductGroupCodesQueryVariables) => ['GetProductGroupBasicInfoByProductGroupCodes', variables];
;

export const useInfiniteGetProductGroupBasicInfoByProductGroupCodesQuery = <
      TData = GetProductGroupBasicInfoByProductGroupCodesQuery,
      TError = unknown
    >(
      variables: GetProductGroupBasicInfoByProductGroupCodesQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductGroupBasicInfoByProductGroupCodesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetProductGroupBasicInfoByProductGroupCodesQuery, TError, TData>(
      ['GetProductGroupBasicInfoByProductGroupCodes.infinite', variables],
      (metaData) => useFetchData<GetProductGroupBasicInfoByProductGroupCodesQuery, GetProductGroupBasicInfoByProductGroupCodesQueryVariables>(GetProductGroupBasicInfoByProductGroupCodesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerProductGroupPublicationDocument = `
    mutation CreateCustomerProductGroupPublication($input: CreateCustomerProductGroupPublicationInput!) {
  createCustomerProductGroupPublication(input: $input) {
    clientMutationId
  }
}
    `;
export const useCreateCustomerProductGroupPublicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerProductGroupPublicationMutation, TError, CreateCustomerProductGroupPublicationMutationVariables, TContext>) =>
    useMutation<CreateCustomerProductGroupPublicationMutation, TError, CreateCustomerProductGroupPublicationMutationVariables, TContext>(
      'CreateCustomerProductGroupPublication',
      useFetchData<CreateCustomerProductGroupPublicationMutation, CreateCustomerProductGroupPublicationMutationVariables>(CreateCustomerProductGroupPublicationDocument),
      options
    );
export const CreateCustomerProductGroupPublicationWithImportDocument = `
    mutation CreateCustomerProductGroupPublicationWithImport($input: CreateCustomerProductGroupPublicationWithImportInput!) {
  createCustomerProductGroupPublicationWithImport(input: $input) {
    importResults {
      importFlg
    }
  }
}
    `;
export const useCreateCustomerProductGroupPublicationWithImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerProductGroupPublicationWithImportMutation, TError, CreateCustomerProductGroupPublicationWithImportMutationVariables, TContext>) =>
    useMutation<CreateCustomerProductGroupPublicationWithImportMutation, TError, CreateCustomerProductGroupPublicationWithImportMutationVariables, TContext>(
      'CreateCustomerProductGroupPublicationWithImport',
      useFetchData<CreateCustomerProductGroupPublicationWithImportMutation, CreateCustomerProductGroupPublicationWithImportMutationVariables>(CreateCustomerProductGroupPublicationWithImportDocument),
      options
    );
export const SearchCustomerProductPublicationsDocument = `
    query SearchCustomerProductPublications($filter: CustomerProductPublicationFilter) {
  searchCustomerProductPublications(filter: $filter) {
    ...CustomerProductPublicationFields
  }
}
    ${CustomerProductPublicationFieldsFragmentDoc}`;
export const useSearchCustomerProductPublicationsQuery = <
      TData = SearchCustomerProductPublicationsQuery,
      TError = unknown
    >(
      variables?: SearchCustomerProductPublicationsQueryVariables,
      options?: UseQueryOptions<SearchCustomerProductPublicationsQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerProductPublicationsQuery, TError, TData>(
      variables === undefined ? ['SearchCustomerProductPublications'] : ['SearchCustomerProductPublications', variables],
      useFetchData<SearchCustomerProductPublicationsQuery, SearchCustomerProductPublicationsQueryVariables>(SearchCustomerProductPublicationsDocument).bind(null, variables),
      options
    );

useSearchCustomerProductPublicationsQuery.getKey = (variables?: SearchCustomerProductPublicationsQueryVariables) => variables === undefined ? ['SearchCustomerProductPublications'] : ['SearchCustomerProductPublications', variables];
;

export const useInfiniteSearchCustomerProductPublicationsQuery = <
      TData = SearchCustomerProductPublicationsQuery,
      TError = unknown
    >(
      variables?: SearchCustomerProductPublicationsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerProductPublicationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerProductPublicationsQuery, TError, TData>(
      variables === undefined ? ['SearchCustomerProductPublications.infinite'] : ['SearchCustomerProductPublications.infinite', variables],
      (metaData) => useFetchData<SearchCustomerProductPublicationsQuery, SearchCustomerProductPublicationsQueryVariables>(SearchCustomerProductPublicationsDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetProductBasicInfoByProductCodesDocument = `
    query GetProductBasicInfoByProductCodes($filter: SearchProductNoPriceViewFilter!) {
  searchProductNoPriceView(filter: $filter) {
    ...ProductBasicInfoFields
  }
}
    ${ProductBasicInfoFieldsFragmentDoc}`;
export const useGetProductBasicInfoByProductCodesQuery = <
      TData = GetProductBasicInfoByProductCodesQuery,
      TError = unknown
    >(
      variables: GetProductBasicInfoByProductCodesQueryVariables,
      options?: UseQueryOptions<GetProductBasicInfoByProductCodesQuery, TError, TData>
    ) =>
    useQuery<GetProductBasicInfoByProductCodesQuery, TError, TData>(
      ['GetProductBasicInfoByProductCodes', variables],
      useFetchData<GetProductBasicInfoByProductCodesQuery, GetProductBasicInfoByProductCodesQueryVariables>(GetProductBasicInfoByProductCodesDocument).bind(null, variables),
      options
    );

useGetProductBasicInfoByProductCodesQuery.getKey = (variables: GetProductBasicInfoByProductCodesQueryVariables) => ['GetProductBasicInfoByProductCodes', variables];
;

export const useInfiniteGetProductBasicInfoByProductCodesQuery = <
      TData = GetProductBasicInfoByProductCodesQuery,
      TError = unknown
    >(
      variables: GetProductBasicInfoByProductCodesQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductBasicInfoByProductCodesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetProductBasicInfoByProductCodesQuery, TError, TData>(
      ['GetProductBasicInfoByProductCodes.infinite', variables],
      (metaData) => useFetchData<GetProductBasicInfoByProductCodesQuery, GetProductBasicInfoByProductCodesQueryVariables>(GetProductBasicInfoByProductCodesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetCustomerBasicInfoByCustomerCodesDocument = `
    query GetCustomerBasicInfoByCustomerCodes($filter: SearchCustomerFromCodeFilter!) {
  customersByCode(filter: $filter) {
    ...CustomerBasicInfoFields
  }
}
    ${CustomerBasicInfoFieldsFragmentDoc}`;
export const useGetCustomerBasicInfoByCustomerCodesQuery = <
      TData = GetCustomerBasicInfoByCustomerCodesQuery,
      TError = unknown
    >(
      variables: GetCustomerBasicInfoByCustomerCodesQueryVariables,
      options?: UseQueryOptions<GetCustomerBasicInfoByCustomerCodesQuery, TError, TData>
    ) =>
    useQuery<GetCustomerBasicInfoByCustomerCodesQuery, TError, TData>(
      ['GetCustomerBasicInfoByCustomerCodes', variables],
      useFetchData<GetCustomerBasicInfoByCustomerCodesQuery, GetCustomerBasicInfoByCustomerCodesQueryVariables>(GetCustomerBasicInfoByCustomerCodesDocument).bind(null, variables),
      options
    );

useGetCustomerBasicInfoByCustomerCodesQuery.getKey = (variables: GetCustomerBasicInfoByCustomerCodesQueryVariables) => ['GetCustomerBasicInfoByCustomerCodes', variables];
;

export const useInfiniteGetCustomerBasicInfoByCustomerCodesQuery = <
      TData = GetCustomerBasicInfoByCustomerCodesQuery,
      TError = unknown
    >(
      variables: GetCustomerBasicInfoByCustomerCodesQueryVariables,
      options?: UseInfiniteQueryOptions<GetCustomerBasicInfoByCustomerCodesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCustomerBasicInfoByCustomerCodesQuery, TError, TData>(
      ['GetCustomerBasicInfoByCustomerCodes.infinite', variables],
      (metaData) => useFetchData<GetCustomerBasicInfoByCustomerCodesQuery, GetCustomerBasicInfoByCustomerCodesQueryVariables>(GetCustomerBasicInfoByCustomerCodesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerProductPublicationDocument = `
    mutation CreateCustomerProductPublication($input: CreateCustomerProductPublicationInput!) {
  createCustomerProductPublication(input: $input) {
    clientMutationId
  }
}
    `;
export const useCreateCustomerProductPublicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerProductPublicationMutation, TError, CreateCustomerProductPublicationMutationVariables, TContext>) =>
    useMutation<CreateCustomerProductPublicationMutation, TError, CreateCustomerProductPublicationMutationVariables, TContext>(
      'CreateCustomerProductPublication',
      useFetchData<CreateCustomerProductPublicationMutation, CreateCustomerProductPublicationMutationVariables>(CreateCustomerProductPublicationDocument),
      options
    );
export const CreateCustomerProductPublicationWithImportDocument = `
    mutation CreateCustomerProductPublicationWithImport($input: CreateCustomerProductPublicationWithImportInput!) {
  createCustomerProductPublicationWithImport(input: $input) {
    importResults {
      importFlg
    }
  }
}
    `;
export const useCreateCustomerProductPublicationWithImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerProductPublicationWithImportMutation, TError, CreateCustomerProductPublicationWithImportMutationVariables, TContext>) =>
    useMutation<CreateCustomerProductPublicationWithImportMutation, TError, CreateCustomerProductPublicationWithImportMutationVariables, TContext>(
      'CreateCustomerProductPublicationWithImport',
      useFetchData<CreateCustomerProductPublicationWithImportMutation, CreateCustomerProductPublicationWithImportMutationVariables>(CreateCustomerProductPublicationWithImportDocument),
      options
    );
export const CustomerUserDocument = `
    query CustomerUser($id: ID!) {
  customerUser(id: $id) {
    ...CustomerUserFields
  }
}
    ${CustomerUserFieldsFragmentDoc}`;
export const useCustomerUserQuery = <
      TData = CustomerUserQuery,
      TError = unknown
    >(
      variables: CustomerUserQueryVariables,
      options?: UseQueryOptions<CustomerUserQuery, TError, TData>
    ) =>
    useQuery<CustomerUserQuery, TError, TData>(
      ['CustomerUser', variables],
      useFetchData<CustomerUserQuery, CustomerUserQueryVariables>(CustomerUserDocument).bind(null, variables),
      options
    );

useCustomerUserQuery.getKey = (variables: CustomerUserQueryVariables) => ['CustomerUser', variables];
;

export const useInfiniteCustomerUserQuery = <
      TData = CustomerUserQuery,
      TError = unknown
    >(
      variables: CustomerUserQueryVariables,
      options?: UseInfiniteQueryOptions<CustomerUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<CustomerUserQuery, TError, TData>(
      ['CustomerUser.infinite', variables],
      (metaData) => useFetchData<CustomerUserQuery, CustomerUserQueryVariables>(CustomerUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerUserDocument = `
    query searchCustomerUser($first: Int, $after: String, $filter: SearchCustomerUserFilter, $sort: [CustomerUserSortEnum]) {
  searchCustomerUser(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerUserFields
      }
    }
  }
}
    ${CustomerUserFieldsFragmentDoc}`;
export const useSearchCustomerUserQuery = <
      TData = SearchCustomerUserQuery,
      TError = unknown
    >(
      variables?: SearchCustomerUserQueryVariables,
      options?: UseQueryOptions<SearchCustomerUserQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerUserQuery, TError, TData>(
      variables === undefined ? ['searchCustomerUser'] : ['searchCustomerUser', variables],
      useFetchData<SearchCustomerUserQuery, SearchCustomerUserQueryVariables>(SearchCustomerUserDocument).bind(null, variables),
      options
    );

useSearchCustomerUserQuery.getKey = (variables?: SearchCustomerUserQueryVariables) => variables === undefined ? ['searchCustomerUser'] : ['searchCustomerUser', variables];
;

export const useInfiniteSearchCustomerUserQuery = <
      TData = SearchCustomerUserQuery,
      TError = unknown
    >(
      variables?: SearchCustomerUserQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerUserQuery, TError, TData>(
      variables === undefined ? ['searchCustomerUser.infinite'] : ['searchCustomerUser.infinite', variables],
      (metaData) => useFetchData<SearchCustomerUserQuery, SearchCustomerUserQueryVariables>(SearchCustomerUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateCustomerUserDocument = `
    mutation createCustomerUser($input: CreateCustomerUserInput!) {
  createCustomerUser(input: $input) {
    customerUser {
      customerUserId
      versionUuid
    }
  }
}
    `;
export const useCreateCustomerUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerUserMutation, TError, CreateCustomerUserMutationVariables, TContext>) =>
    useMutation<CreateCustomerUserMutation, TError, CreateCustomerUserMutationVariables, TContext>(
      'createCustomerUser',
      useFetchData<CreateCustomerUserMutation, CreateCustomerUserMutationVariables>(CreateCustomerUserDocument),
      options
    );
export const UpdateCustomerUserDocument = `
    mutation updateCustomerUser($input: UpdateCustomerUserInput!) {
  updateCustomerUser(input: $input) {
    customerUser {
      customerUserId
      versionUuid
    }
  }
}
    `;
export const useUpdateCustomerUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerUserMutation, TError, UpdateCustomerUserMutationVariables, TContext>) =>
    useMutation<UpdateCustomerUserMutation, TError, UpdateCustomerUserMutationVariables, TContext>(
      'updateCustomerUser',
      useFetchData<UpdateCustomerUserMutation, UpdateCustomerUserMutationVariables>(UpdateCustomerUserDocument),
      options
    );
export const DeleteCustomerUserDocument = `
    mutation deleteCustomerUser($input: DeleteCustomerUserInput!) {
  deleteCustomerUser(input: $input) {
    customerUser {
      customerUserId
      versionUuid
    }
  }
}
    `;
export const useDeleteCustomerUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerUserMutation, TError, DeleteCustomerUserMutationVariables, TContext>) =>
    useMutation<DeleteCustomerUserMutation, TError, DeleteCustomerUserMutationVariables, TContext>(
      'deleteCustomerUser',
      useFetchData<DeleteCustomerUserMutation, DeleteCustomerUserMutationVariables>(DeleteCustomerUserDocument),
      options
    );
export const DeliverDocument = `
    query Deliver($id: ID!) {
  deliver(id: $id) {
    ...DeliverFields
  }
}
    ${DeliverFieldsFragmentDoc}`;
export const useDeliverQuery = <
      TData = DeliverQuery,
      TError = unknown
    >(
      variables: DeliverQueryVariables,
      options?: UseQueryOptions<DeliverQuery, TError, TData>
    ) =>
    useQuery<DeliverQuery, TError, TData>(
      ['Deliver', variables],
      useFetchData<DeliverQuery, DeliverQueryVariables>(DeliverDocument).bind(null, variables),
      options
    );

useDeliverQuery.getKey = (variables: DeliverQueryVariables) => ['Deliver', variables];
;

export const useInfiniteDeliverQuery = <
      TData = DeliverQuery,
      TError = unknown
    >(
      variables: DeliverQueryVariables,
      options?: UseInfiniteQueryOptions<DeliverQuery, TError, TData>
    ) =>
    useInfiniteQuery<DeliverQuery, TError, TData>(
      ['Deliver.infinite', variables],
      (metaData) => useFetchData<DeliverQuery, DeliverQueryVariables>(DeliverDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDeliverDocument = `
    mutation createDeliver($input: CreateDeliverInput!) {
  createDeliver(input: $input) {
    deliver {
      deliveryDestinationCode
      versionUuid
    }
  }
}
    `;
export const useCreateDeliverMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDeliverMutation, TError, CreateDeliverMutationVariables, TContext>) =>
    useMutation<CreateDeliverMutation, TError, CreateDeliverMutationVariables, TContext>(
      'createDeliver',
      useFetchData<CreateDeliverMutation, CreateDeliverMutationVariables>(CreateDeliverDocument),
      options
    );
export const UpdateDeliverDocument = `
    mutation updateDeliver($input: UpdateDeliverInput!) {
  updateDeliver(input: $input) {
    deliver {
      deliveryDestinationCode
      versionUuid
    }
  }
}
    `;
export const useUpdateDeliverMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDeliverMutation, TError, UpdateDeliverMutationVariables, TContext>) =>
    useMutation<UpdateDeliverMutation, TError, UpdateDeliverMutationVariables, TContext>(
      'updateDeliver',
      useFetchData<UpdateDeliverMutation, UpdateDeliverMutationVariables>(UpdateDeliverDocument),
      options
    );
export const DeleteDeliverDocument = `
    mutation deleteDeliver($input: DeleteDeliverInput!) {
  deleteDeliver(input: $input) {
    deliver {
      deliveryDestinationCode
      versionUuid
    }
  }
}
    `;
export const useDeleteDeliverMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDeliverMutation, TError, DeleteDeliverMutationVariables, TContext>) =>
    useMutation<DeleteDeliverMutation, TError, DeleteDeliverMutationVariables, TContext>(
      'deleteDeliver',
      useFetchData<DeleteDeliverMutation, DeleteDeliverMutationVariables>(DeleteDeliverDocument),
      options
    );
export const SearchDeliverDocument = `
    query searchDeliver($first: Int, $after: String, $filter: SeachDeliverFilter, $sort: [DeliverSortEnum]) {
  searchDeliver(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DeliverFields
      }
    }
  }
}
    ${DeliverFieldsFragmentDoc}`;
export const useSearchDeliverQuery = <
      TData = SearchDeliverQuery,
      TError = unknown
    >(
      variables?: SearchDeliverQueryVariables,
      options?: UseQueryOptions<SearchDeliverQuery, TError, TData>
    ) =>
    useQuery<SearchDeliverQuery, TError, TData>(
      variables === undefined ? ['searchDeliver'] : ['searchDeliver', variables],
      useFetchData<SearchDeliverQuery, SearchDeliverQueryVariables>(SearchDeliverDocument).bind(null, variables),
      options
    );

useSearchDeliverQuery.getKey = (variables?: SearchDeliverQueryVariables) => variables === undefined ? ['searchDeliver'] : ['searchDeliver', variables];
;

export const useInfiniteSearchDeliverQuery = <
      TData = SearchDeliverQuery,
      TError = unknown
    >(
      variables?: SearchDeliverQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDeliverQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDeliverQuery, TError, TData>(
      variables === undefined ? ['searchDeliver.infinite'] : ['searchDeliver.infinite', variables],
      (metaData) => useFetchData<SearchDeliverQuery, SearchDeliverQueryVariables>(SearchDeliverDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const DemandDocument = `
    query Demand($id: ID!) {
  demand(id: $id) {
    ...DemandFields
  }
}
    ${DemandFieldsFragmentDoc}`;
export const useDemandQuery = <
      TData = DemandQuery,
      TError = unknown
    >(
      variables: DemandQueryVariables,
      options?: UseQueryOptions<DemandQuery, TError, TData>
    ) =>
    useQuery<DemandQuery, TError, TData>(
      ['Demand', variables],
      useFetchData<DemandQuery, DemandQueryVariables>(DemandDocument).bind(null, variables),
      options
    );

useDemandQuery.getKey = (variables: DemandQueryVariables) => ['Demand', variables];
;

export const useInfiniteDemandQuery = <
      TData = DemandQuery,
      TError = unknown
    >(
      variables: DemandQueryVariables,
      options?: UseInfiniteQueryOptions<DemandQuery, TError, TData>
    ) =>
    useInfiniteQuery<DemandQuery, TError, TData>(
      ['Demand.infinite', variables],
      (metaData) => useFetchData<DemandQuery, DemandQueryVariables>(DemandDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerDemandDocument = `
    query searchCustomerDemand($first: Int, $after: String, $filter: SearchCustomerDemandFilter, $sort: [CustomerSortEnum]) {
  searchCustomerDemand(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        demandCode
        customerName
        customerFuri
        closingDate
        latestDemandId
        createDate
        updateDate
        versionUuid
      }
    }
  }
}
    `;
export const useSearchCustomerDemandQuery = <
      TData = SearchCustomerDemandQuery,
      TError = unknown
    >(
      variables?: SearchCustomerDemandQueryVariables,
      options?: UseQueryOptions<SearchCustomerDemandQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerDemandQuery, TError, TData>(
      variables === undefined ? ['searchCustomerDemand'] : ['searchCustomerDemand', variables],
      useFetchData<SearchCustomerDemandQuery, SearchCustomerDemandQueryVariables>(SearchCustomerDemandDocument).bind(null, variables),
      options
    );

useSearchCustomerDemandQuery.getKey = (variables?: SearchCustomerDemandQueryVariables) => variables === undefined ? ['searchCustomerDemand'] : ['searchCustomerDemand', variables];
;

export const useInfiniteSearchCustomerDemandQuery = <
      TData = SearchCustomerDemandQuery,
      TError = unknown
    >(
      variables?: SearchCustomerDemandQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerDemandQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerDemandQuery, TError, TData>(
      variables === undefined ? ['searchCustomerDemand.infinite'] : ['searchCustomerDemand.infinite', variables],
      (metaData) => useFetchData<SearchCustomerDemandQuery, SearchCustomerDemandQueryVariables>(SearchCustomerDemandDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDemandClosingDocument = `
    query searchDemandClosing($first: Int, $after: String, $filter: SearchDemandClosingFilter) {
  searchDemandClosing(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DemandFields
      }
    }
  }
}
    ${DemandFieldsFragmentDoc}`;
export const useSearchDemandClosingQuery = <
      TData = SearchDemandClosingQuery,
      TError = unknown
    >(
      variables?: SearchDemandClosingQueryVariables,
      options?: UseQueryOptions<SearchDemandClosingQuery, TError, TData>
    ) =>
    useQuery<SearchDemandClosingQuery, TError, TData>(
      variables === undefined ? ['searchDemandClosing'] : ['searchDemandClosing', variables],
      useFetchData<SearchDemandClosingQuery, SearchDemandClosingQueryVariables>(SearchDemandClosingDocument).bind(null, variables),
      options
    );

useSearchDemandClosingQuery.getKey = (variables?: SearchDemandClosingQueryVariables) => variables === undefined ? ['searchDemandClosing'] : ['searchDemandClosing', variables];
;

export const useInfiniteSearchDemandClosingQuery = <
      TData = SearchDemandClosingQuery,
      TError = unknown
    >(
      variables?: SearchDemandClosingQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDemandClosingQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDemandClosingQuery, TError, TData>(
      variables === undefined ? ['searchDemandClosing.infinite'] : ['searchDemandClosing.infinite', variables],
      (metaData) => useFetchData<SearchDemandClosingQuery, SearchDemandClosingQueryVariables>(SearchDemandClosingDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDemandHistoryDocument = `
    query searchDemandHistory($first: Int, $after: String, $filter: SearchDemandHistoryFilter, $sort: [DemandSortEnum]) {
  searchDemandHistory(first: $first, after: $after, filter: $filter, sort: $sort) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DemandFields
      }
    }
  }
}
    ${DemandFieldsFragmentDoc}`;
export const useSearchDemandHistoryQuery = <
      TData = SearchDemandHistoryQuery,
      TError = unknown
    >(
      variables?: SearchDemandHistoryQueryVariables,
      options?: UseQueryOptions<SearchDemandHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchDemandHistoryQuery, TError, TData>(
      variables === undefined ? ['searchDemandHistory'] : ['searchDemandHistory', variables],
      useFetchData<SearchDemandHistoryQuery, SearchDemandHistoryQueryVariables>(SearchDemandHistoryDocument).bind(null, variables),
      options
    );

useSearchDemandHistoryQuery.getKey = (variables?: SearchDemandHistoryQueryVariables) => variables === undefined ? ['searchDemandHistory'] : ['searchDemandHistory', variables];
;

export const useInfiniteSearchDemandHistoryQuery = <
      TData = SearchDemandHistoryQuery,
      TError = unknown
    >(
      variables?: SearchDemandHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDemandHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDemandHistoryQuery, TError, TData>(
      variables === undefined ? ['searchDemandHistory.infinite'] : ['searchDemandHistory.infinite', variables],
      (metaData) => useFetchData<SearchDemandHistoryQuery, SearchDemandHistoryQueryVariables>(SearchDemandHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDemandHistoryDetailDocument = `
    query searchDemandHistoryDetail($first: Int, $after: String, $filter1: SearchSalesDemandDetailFilter, $filter2: SearchDepositDemandDetailFilter, $sort1: [SalesSortEnum], $sort2: [DepositSortEnum]) {
  searchSalesDemandDetail(
    first: $first
    after: $after
    filter: $filter1
    sort: $sort1
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...SalesFields
      }
    }
  }
  searchDepositDemandDetail(
    first: $first
    after: $after
    filter: $filter2
    sort: $sort2
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DepositFields
      }
    }
  }
}
    ${SalesFieldsFragmentDoc}
${DepositFieldsFragmentDoc}`;
export const useSearchDemandHistoryDetailQuery = <
      TData = SearchDemandHistoryDetailQuery,
      TError = unknown
    >(
      variables?: SearchDemandHistoryDetailQueryVariables,
      options?: UseQueryOptions<SearchDemandHistoryDetailQuery, TError, TData>
    ) =>
    useQuery<SearchDemandHistoryDetailQuery, TError, TData>(
      variables === undefined ? ['searchDemandHistoryDetail'] : ['searchDemandHistoryDetail', variables],
      useFetchData<SearchDemandHistoryDetailQuery, SearchDemandHistoryDetailQueryVariables>(SearchDemandHistoryDetailDocument).bind(null, variables),
      options
    );

useSearchDemandHistoryDetailQuery.getKey = (variables?: SearchDemandHistoryDetailQueryVariables) => variables === undefined ? ['searchDemandHistoryDetail'] : ['searchDemandHistoryDetail', variables];
;

export const useInfiniteSearchDemandHistoryDetailQuery = <
      TData = SearchDemandHistoryDetailQuery,
      TError = unknown
    >(
      variables?: SearchDemandHistoryDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDemandHistoryDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDemandHistoryDetailQuery, TError, TData>(
      variables === undefined ? ['searchDemandHistoryDetail.infinite'] : ['searchDemandHistoryDetail.infinite', variables],
      (metaData) => useFetchData<SearchDemandHistoryDetailQuery, SearchDemandHistoryDetailQueryVariables>(SearchDemandHistoryDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDemandDocument = `
    mutation createDemand($input: CreateDemandInput!) {
  createDemand(input: $input) {
    demand {
      demandId
      demandCode
    }
  }
}
    `;
export const useCreateDemandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDemandMutation, TError, CreateDemandMutationVariables, TContext>) =>
    useMutation<CreateDemandMutation, TError, CreateDemandMutationVariables, TContext>(
      'createDemand',
      useFetchData<CreateDemandMutation, CreateDemandMutationVariables>(CreateDemandDocument),
      options
    );
export const DeleteDemandListDocument = `
    mutation deleteDemandList($input: DeleteDemandListInput!) {
  deleteDemandList(input: $input) {
    result
  }
}
    `;
export const useDeleteDemandListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDemandListMutation, TError, DeleteDemandListMutationVariables, TContext>) =>
    useMutation<DeleteDemandListMutation, TError, DeleteDemandListMutationVariables, TContext>(
      'deleteDemandList',
      useFetchData<DeleteDemandListMutation, DeleteDemandListMutationVariables>(DeleteDemandListDocument),
      options
    );
export const UpsertDemandTaxAdjustListDocument = `
    mutation upsertDemandTaxAdjustList($input: UpsertDemandTaxAdjustListInput!) {
  upsertDemandTaxAdjustList(input: $input) {
    demandTaxAdjustDetail {
      demandId
      versionUuid
    }
  }
}
    `;
export const useUpsertDemandTaxAdjustListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertDemandTaxAdjustListMutation, TError, UpsertDemandTaxAdjustListMutationVariables, TContext>) =>
    useMutation<UpsertDemandTaxAdjustListMutation, TError, UpsertDemandTaxAdjustListMutationVariables, TContext>(
      'upsertDemandTaxAdjustList',
      useFetchData<UpsertDemandTaxAdjustListMutation, UpsertDemandTaxAdjustListMutationVariables>(UpsertDemandTaxAdjustListDocument),
      options
    );
export const DeleteDemandTaxAdjustListDocument = `
    mutation deleteDemandTaxAdjustList($input: DeleteDemandTaxAdjustListInput!) {
  deleteDemandTaxAdjustList(input: $input) {
    demandTaxAdjustDetail {
      demandId
      versionUuid
    }
  }
}
    `;
export const useDeleteDemandTaxAdjustListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDemandTaxAdjustListMutation, TError, DeleteDemandTaxAdjustListMutationVariables, TContext>) =>
    useMutation<DeleteDemandTaxAdjustListMutation, TError, DeleteDemandTaxAdjustListMutationVariables, TContext>(
      'deleteDemandTaxAdjustList',
      useFetchData<DeleteDemandTaxAdjustListMutation, DeleteDemandTaxAdjustListMutationVariables>(DeleteDemandTaxAdjustListDocument),
      options
    );
export const SearchDemandReportDocument = `
    query searchDemandReport($first: Int, $after: String, $filter: SearchDemandReportFilter, $sort: [DemandSortEnum]) {
  searchDemandReport(first: $first, after: $after, filter: $filter, sort: $sort) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        demandId
        customer {
          userDivisionCode
          demandReport {
            reportLayoutCode
            reportLayoutName
            activeReportFlg
          }
        }
      }
    }
  }
}
    `;
export const useSearchDemandReportQuery = <
      TData = SearchDemandReportQuery,
      TError = unknown
    >(
      variables?: SearchDemandReportQueryVariables,
      options?: UseQueryOptions<SearchDemandReportQuery, TError, TData>
    ) =>
    useQuery<SearchDemandReportQuery, TError, TData>(
      variables === undefined ? ['searchDemandReport'] : ['searchDemandReport', variables],
      useFetchData<SearchDemandReportQuery, SearchDemandReportQueryVariables>(SearchDemandReportDocument).bind(null, variables),
      options
    );

useSearchDemandReportQuery.getKey = (variables?: SearchDemandReportQueryVariables) => variables === undefined ? ['searchDemandReport'] : ['searchDemandReport', variables];
;

export const useInfiniteSearchDemandReportQuery = <
      TData = SearchDemandReportQuery,
      TError = unknown
    >(
      variables?: SearchDemandReportQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDemandReportQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDemandReportQuery, TError, TData>(
      variables === undefined ? ['searchDemandReport.infinite'] : ['searchDemandReport.infinite', variables],
      (metaData) => useFetchData<SearchDemandReportQuery, SearchDemandReportQueryVariables>(SearchDemandReportDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const DepositDocument = `
    query Deposit($id: ID!) {
  deposit(id: $id) {
    ...DepositFields
  }
}
    ${DepositFieldsFragmentDoc}`;
export const useDepositQuery = <
      TData = DepositQuery,
      TError = unknown
    >(
      variables: DepositQueryVariables,
      options?: UseQueryOptions<DepositQuery, TError, TData>
    ) =>
    useQuery<DepositQuery, TError, TData>(
      ['Deposit', variables],
      useFetchData<DepositQuery, DepositQueryVariables>(DepositDocument).bind(null, variables),
      options
    );

useDepositQuery.getKey = (variables: DepositQueryVariables) => ['Deposit', variables];
;

export const useInfiniteDepositQuery = <
      TData = DepositQuery,
      TError = unknown
    >(
      variables: DepositQueryVariables,
      options?: UseInfiniteQueryOptions<DepositQuery, TError, TData>
    ) =>
    useInfiniteQuery<DepositQuery, TError, TData>(
      ['Deposit.infinite', variables],
      (metaData) => useFetchData<DepositQuery, DepositQueryVariables>(DepositDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDepositDocument = `
    query searchDeposit($first: Int, $after: String, $filter: SearchDepositFilter, $sort: [DepositSortEnum]) {
  searchDeposit(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DepositFields
      }
    }
  }
}
    ${DepositFieldsFragmentDoc}`;
export const useSearchDepositQuery = <
      TData = SearchDepositQuery,
      TError = unknown
    >(
      variables?: SearchDepositQueryVariables,
      options?: UseQueryOptions<SearchDepositQuery, TError, TData>
    ) =>
    useQuery<SearchDepositQuery, TError, TData>(
      variables === undefined ? ['searchDeposit'] : ['searchDeposit', variables],
      useFetchData<SearchDepositQuery, SearchDepositQueryVariables>(SearchDepositDocument).bind(null, variables),
      options
    );

useSearchDepositQuery.getKey = (variables?: SearchDepositQueryVariables) => variables === undefined ? ['searchDeposit'] : ['searchDeposit', variables];
;

export const useInfiniteSearchDepositQuery = <
      TData = SearchDepositQuery,
      TError = unknown
    >(
      variables?: SearchDepositQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDepositQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDepositQuery, TError, TData>(
      variables === undefined ? ['searchDeposit.infinite'] : ['searchDeposit.infinite', variables],
      (metaData) => useFetchData<SearchDepositQuery, SearchDepositQueryVariables>(SearchDepositDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDepositDocument = `
    mutation createDeposit($input: CreateDepositInput!) {
  createDeposit(input: $input) {
    deposit {
      depositId
    }
  }
}
    `;
export const useCreateDepositMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDepositMutation, TError, CreateDepositMutationVariables, TContext>) =>
    useMutation<CreateDepositMutation, TError, CreateDepositMutationVariables, TContext>(
      'createDeposit',
      useFetchData<CreateDepositMutation, CreateDepositMutationVariables>(CreateDepositDocument),
      options
    );
export const CreateBulkDepositDocument = `
    mutation createBulkDeposit($input: CreateBulkDepositInput!) {
  createBulkDeposit(input: $input) {
    ...CreateBulkDepositResult
  }
}
    ${CreateBulkDepositResultFragmentDoc}`;
export const useCreateBulkDepositMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBulkDepositMutation, TError, CreateBulkDepositMutationVariables, TContext>) =>
    useMutation<CreateBulkDepositMutation, TError, CreateBulkDepositMutationVariables, TContext>(
      'createBulkDeposit',
      useFetchData<CreateBulkDepositMutation, CreateBulkDepositMutationVariables>(CreateBulkDepositDocument),
      options
    );
export const UpdateDepositDocument = `
    mutation updateDeposit($input: UpdateDepositInput!) {
  updateDeposit(input: $input) {
    deposit {
      depositId
    }
  }
}
    `;
export const useUpdateDepositMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDepositMutation, TError, UpdateDepositMutationVariables, TContext>) =>
    useMutation<UpdateDepositMutation, TError, UpdateDepositMutationVariables, TContext>(
      'updateDeposit',
      useFetchData<UpdateDepositMutation, UpdateDepositMutationVariables>(UpdateDepositDocument),
      options
    );
export const DeleteDepositDocument = `
    mutation deleteDeposit($input: DeleteDepositInput!) {
  deleteDeposit(input: $input) {
    deposit {
      depositId
    }
  }
}
    `;
export const useDeleteDepositMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDepositMutation, TError, DeleteDepositMutationVariables, TContext>) =>
    useMutation<DeleteDepositMutation, TError, DeleteDepositMutationVariables, TContext>(
      'deleteDeposit',
      useFetchData<DeleteDepositMutation, DeleteDepositMutationVariables>(DeleteDepositDocument),
      options
    );
export const SearchDemandNotClearingDocument = `
    query searchDemandNotClearing($first: Int, $after: String, $filter: SearchDemandNotClearingFilter) {
  searchDemandNotClearing(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        versionUuid
        demandId
        demandDate
        closingDate
        collectExpectedDate
        includedTaxTotalDemandPrice
        includedTaxDemandClearingPrice
        demandTradeDivision
      }
    }
  }
}
    `;
export const useSearchDemandNotClearingQuery = <
      TData = SearchDemandNotClearingQuery,
      TError = unknown
    >(
      variables?: SearchDemandNotClearingQueryVariables,
      options?: UseQueryOptions<SearchDemandNotClearingQuery, TError, TData>
    ) =>
    useQuery<SearchDemandNotClearingQuery, TError, TData>(
      variables === undefined ? ['searchDemandNotClearing'] : ['searchDemandNotClearing', variables],
      useFetchData<SearchDemandNotClearingQuery, SearchDemandNotClearingQueryVariables>(SearchDemandNotClearingDocument).bind(null, variables),
      options
    );

useSearchDemandNotClearingQuery.getKey = (variables?: SearchDemandNotClearingQueryVariables) => variables === undefined ? ['searchDemandNotClearing'] : ['searchDemandNotClearing', variables];
;

export const useInfiniteSearchDemandNotClearingQuery = <
      TData = SearchDemandNotClearingQuery,
      TError = unknown
    >(
      variables?: SearchDemandNotClearingQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDemandNotClearingQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDemandNotClearingQuery, TError, TData>(
      variables === undefined ? ['searchDemandNotClearing.infinite'] : ['searchDemandNotClearing.infinite', variables],
      (metaData) => useFetchData<SearchDemandNotClearingQuery, SearchDemandNotClearingQueryVariables>(SearchDemandNotClearingDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDepositListsDocument = `
    query searchDepositLists($first: Int, $after: String, $filter: SearchDepositFilter, $sort: [DepositSortEnum]) {
  searchDeposit(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DepositFields
      }
    }
  }
}
    ${DepositFieldsFragmentDoc}`;
export const useSearchDepositListsQuery = <
      TData = SearchDepositListsQuery,
      TError = unknown
    >(
      variables?: SearchDepositListsQueryVariables,
      options?: UseQueryOptions<SearchDepositListsQuery, TError, TData>
    ) =>
    useQuery<SearchDepositListsQuery, TError, TData>(
      variables === undefined ? ['searchDepositLists'] : ['searchDepositLists', variables],
      useFetchData<SearchDepositListsQuery, SearchDepositListsQueryVariables>(SearchDepositListsDocument).bind(null, variables),
      options
    );

useSearchDepositListsQuery.getKey = (variables?: SearchDepositListsQueryVariables) => variables === undefined ? ['searchDepositLists'] : ['searchDepositLists', variables];
;

export const useInfiniteSearchDepositListsQuery = <
      TData = SearchDepositListsQuery,
      TError = unknown
    >(
      variables?: SearchDepositListsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDepositListsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDepositListsQuery, TError, TData>(
      variables === undefined ? ['searchDepositLists.infinite'] : ['searchDepositLists.infinite', variables],
      (metaData) => useFetchData<SearchDepositListsQuery, SearchDepositListsQueryVariables>(SearchDepositListsDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDepositDivisionDocument = `
    query searchDepositDivision($first: Int, $after: String, $filter: SearchDepositDivisionFilter, $sort: [DepositDivisionSortEnum]) {
  searchDepositDivision(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DepositDivisionFields
      }
    }
  }
}
    ${DepositDivisionFieldsFragmentDoc}`;
export const useSearchDepositDivisionQuery = <
      TData = SearchDepositDivisionQuery,
      TError = unknown
    >(
      variables?: SearchDepositDivisionQueryVariables,
      options?: UseQueryOptions<SearchDepositDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchDepositDivisionQuery, TError, TData>(
      variables === undefined ? ['searchDepositDivision'] : ['searchDepositDivision', variables],
      useFetchData<SearchDepositDivisionQuery, SearchDepositDivisionQueryVariables>(SearchDepositDivisionDocument).bind(null, variables),
      options
    );

useSearchDepositDivisionQuery.getKey = (variables?: SearchDepositDivisionQueryVariables) => variables === undefined ? ['searchDepositDivision'] : ['searchDepositDivision', variables];
;

export const useInfiniteSearchDepositDivisionQuery = <
      TData = SearchDepositDivisionQuery,
      TError = unknown
    >(
      variables?: SearchDepositDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDepositDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDepositDivisionQuery, TError, TData>(
      variables === undefined ? ['searchDepositDivision.infinite'] : ['searchDepositDivision.infinite', variables],
      (metaData) => useFetchData<SearchDepositDivisionQuery, SearchDepositDivisionQueryVariables>(SearchDepositDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDirectPurchaseDocument = `
    mutation createDirectPurchase($input: CreateDirectPurchaseInput!) {
  createDirectPurchase(input: $input) {
    resultDatas {
      importFlg
      purchaseDate
      shopCode
      shopName
      vendorCode
      vendorName
      price
      memo
    }
  }
}
    `;
export const useCreateDirectPurchaseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDirectPurchaseMutation, TError, CreateDirectPurchaseMutationVariables, TContext>) =>
    useMutation<CreateDirectPurchaseMutation, TError, CreateDirectPurchaseMutationVariables, TContext>(
      'createDirectPurchase',
      useFetchData<CreateDirectPurchaseMutation, CreateDirectPurchaseMutationVariables>(CreateDirectPurchaseDocument),
      options
    );
export const DeleteDirectPurchaseDocument = `
    mutation deleteDirectPurchase($input: DeleteDirectPurchaseInput!) {
  deleteDirectPurchase(input: $input) {
    purchase {
      purchaseId
      id
    }
  }
}
    `;
export const useDeleteDirectPurchaseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDirectPurchaseMutation, TError, DeleteDirectPurchaseMutationVariables, TContext>) =>
    useMutation<DeleteDirectPurchaseMutation, TError, DeleteDirectPurchaseMutationVariables, TContext>(
      'deleteDirectPurchase',
      useFetchData<DeleteDirectPurchaseMutation, DeleteDirectPurchaseMutationVariables>(DeleteDirectPurchaseDocument),
      options
    );
export const SearchDirectlyPurchaseDocument = `
    query searchDirectlyPurchase($first: Int, $after: String, $filter: DirectlyPurchaseFilter) {
  searchDirectlyPurchase(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      cursor
      node {
        ...DirectlyPurchaseFields
      }
    }
  }
}
    ${DirectlyPurchaseFieldsFragmentDoc}`;
export const useSearchDirectlyPurchaseQuery = <
      TData = SearchDirectlyPurchaseQuery,
      TError = unknown
    >(
      variables?: SearchDirectlyPurchaseQueryVariables,
      options?: UseQueryOptions<SearchDirectlyPurchaseQuery, TError, TData>
    ) =>
    useQuery<SearchDirectlyPurchaseQuery, TError, TData>(
      variables === undefined ? ['searchDirectlyPurchase'] : ['searchDirectlyPurchase', variables],
      useFetchData<SearchDirectlyPurchaseQuery, SearchDirectlyPurchaseQueryVariables>(SearchDirectlyPurchaseDocument).bind(null, variables),
      options
    );

useSearchDirectlyPurchaseQuery.getKey = (variables?: SearchDirectlyPurchaseQueryVariables) => variables === undefined ? ['searchDirectlyPurchase'] : ['searchDirectlyPurchase', variables];
;

export const useInfiniteSearchDirectlyPurchaseQuery = <
      TData = SearchDirectlyPurchaseQuery,
      TError = unknown
    >(
      variables?: SearchDirectlyPurchaseQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDirectlyPurchaseQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDirectlyPurchaseQuery, TError, TData>(
      variables === undefined ? ['searchDirectlyPurchase.infinite'] : ['searchDirectlyPurchase.infinite', variables],
      (metaData) => useFetchData<SearchDirectlyPurchaseQuery, SearchDirectlyPurchaseQueryVariables>(SearchDirectlyPurchaseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDirectWipDocument = `
    mutation createDirectWip($input: CreateDirectWipInput!) {
  createDirectWip(input: $input) {
    resultDatas {
      importFlg
      purchaseDate
      divisionCode
      divisionName
      vendorCode
      vendorName
      taxExcluded
      tenTaxExcluded
      tenTax
      eightTaxExcluded
      eightTax
      taxIncluded
      remark
    }
  }
}
    `;
export const useCreateDirectWipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDirectWipMutation, TError, CreateDirectWipMutationVariables, TContext>) =>
    useMutation<CreateDirectWipMutation, TError, CreateDirectWipMutationVariables, TContext>(
      'createDirectWip',
      useFetchData<CreateDirectWipMutation, CreateDirectWipMutationVariables>(CreateDirectWipDocument),
      options
    );
export const DeleteDirectWipDocument = `
    mutation deleteDirectWip($input: DeleteDirectWipInput!) {
  deleteDirectWip(input: $input) {
    purchase {
      purchaseId
      id
    }
  }
}
    `;
export const useDeleteDirectWipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDirectWipMutation, TError, DeleteDirectWipMutationVariables, TContext>) =>
    useMutation<DeleteDirectWipMutation, TError, DeleteDirectWipMutationVariables, TContext>(
      'deleteDirectWip',
      useFetchData<DeleteDirectWipMutation, DeleteDirectWipMutationVariables>(DeleteDirectWipDocument),
      options
    );
export const DivisionDocument = `
    query Division($id: ID!) {
  division(id: $id) {
    ...DivisionFields
  }
}
    ${DivisionFieldsFragmentDoc}`;
export const useDivisionQuery = <
      TData = DivisionQuery,
      TError = unknown
    >(
      variables: DivisionQueryVariables,
      options?: UseQueryOptions<DivisionQuery, TError, TData>
    ) =>
    useQuery<DivisionQuery, TError, TData>(
      ['Division', variables],
      useFetchData<DivisionQuery, DivisionQueryVariables>(DivisionDocument).bind(null, variables),
      options
    );

useDivisionQuery.getKey = (variables: DivisionQueryVariables) => ['Division', variables];
;

export const useInfiniteDivisionQuery = <
      TData = DivisionQuery,
      TError = unknown
    >(
      variables: DivisionQueryVariables,
      options?: UseInfiniteQueryOptions<DivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<DivisionQuery, TError, TData>(
      ['Division.infinite', variables],
      (metaData) => useFetchData<DivisionQuery, DivisionQueryVariables>(DivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDivisionDocument = `
    mutation createDivision($input: CreateDivisionInput!) {
  createDivision(input: $input) {
    division {
      ...DivisionFields
    }
  }
}
    ${DivisionFieldsFragmentDoc}`;
export const useCreateDivisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateDivisionMutation, TError, CreateDivisionMutationVariables, TContext>) =>
    useMutation<CreateDivisionMutation, TError, CreateDivisionMutationVariables, TContext>(
      'createDivision',
      useFetchData<CreateDivisionMutation, CreateDivisionMutationVariables>(CreateDivisionDocument),
      options
    );
export const UpdateDivisionDocument = `
    mutation updateDivision($input: UpdateDivisionInput!) {
  updateDivision(input: $input) {
    division {
      ...DivisionFields
    }
  }
}
    ${DivisionFieldsFragmentDoc}`;
export const useUpdateDivisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDivisionMutation, TError, UpdateDivisionMutationVariables, TContext>) =>
    useMutation<UpdateDivisionMutation, TError, UpdateDivisionMutationVariables, TContext>(
      'updateDivision',
      useFetchData<UpdateDivisionMutation, UpdateDivisionMutationVariables>(UpdateDivisionDocument),
      options
    );
export const DeleteDivisionDocument = `
    mutation deleteDivision($input: DeleteDivisionInput!) {
  deleteDivision(input: $input) {
    division {
      divisionCode
      versionUuid
    }
  }
}
    `;
export const useDeleteDivisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteDivisionMutation, TError, DeleteDivisionMutationVariables, TContext>) =>
    useMutation<DeleteDivisionMutation, TError, DeleteDivisionMutationVariables, TContext>(
      'deleteDivision',
      useFetchData<DeleteDivisionMutation, DeleteDivisionMutationVariables>(DeleteDivisionDocument),
      options
    );
export const SearchDivisionDocument = `
    query searchDivision($first: Int, $after: String, $filter: SearchDivisionFilter, $sort: [DivisionSortEnum]) {
  searchDivision(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...DivisionFields
      }
    }
  }
}
    ${DivisionFieldsFragmentDoc}`;
export const useSearchDivisionQuery = <
      TData = SearchDivisionQuery,
      TError = unknown
    >(
      variables?: SearchDivisionQueryVariables,
      options?: UseQueryOptions<SearchDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchDivisionQuery, TError, TData>(
      variables === undefined ? ['searchDivision'] : ['searchDivision', variables],
      useFetchData<SearchDivisionQuery, SearchDivisionQueryVariables>(SearchDivisionDocument).bind(null, variables),
      options
    );

useSearchDivisionQuery.getKey = (variables?: SearchDivisionQueryVariables) => variables === undefined ? ['searchDivision'] : ['searchDivision', variables];
;

export const useInfiniteSearchDivisionQuery = <
      TData = SearchDivisionQuery,
      TError = unknown
    >(
      variables?: SearchDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDivisionQuery, TError, TData>(
      variables === undefined ? ['searchDivision.infinite'] : ['searchDivision.infinite', variables],
      (metaData) => useFetchData<SearchDivisionQuery, SearchDivisionQueryVariables>(SearchDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const DivisionWithExchangeDocument = `
    query DivisionWithExchange($id: ID!) {
  division(id: $id) {
    ...DivisionFields
    exchanges {
      edges {
        node {
          ...ExchangeFields
        }
      }
    }
  }
}
    ${DivisionFieldsFragmentDoc}
${ExchangeFieldsFragmentDoc}`;
export const useDivisionWithExchangeQuery = <
      TData = DivisionWithExchangeQuery,
      TError = unknown
    >(
      variables: DivisionWithExchangeQueryVariables,
      options?: UseQueryOptions<DivisionWithExchangeQuery, TError, TData>
    ) =>
    useQuery<DivisionWithExchangeQuery, TError, TData>(
      ['DivisionWithExchange', variables],
      useFetchData<DivisionWithExchangeQuery, DivisionWithExchangeQueryVariables>(DivisionWithExchangeDocument).bind(null, variables),
      options
    );

useDivisionWithExchangeQuery.getKey = (variables: DivisionWithExchangeQueryVariables) => ['DivisionWithExchange', variables];
;

export const useInfiniteDivisionWithExchangeQuery = <
      TData = DivisionWithExchangeQuery,
      TError = unknown
    >(
      variables: DivisionWithExchangeQueryVariables,
      options?: UseInfiniteQueryOptions<DivisionWithExchangeQuery, TError, TData>
    ) =>
    useInfiniteQuery<DivisionWithExchangeQuery, TError, TData>(
      ['DivisionWithExchange.infinite', variables],
      (metaData) => useFetchData<DivisionWithExchangeQuery, DivisionWithExchangeQueryVariables>(DivisionWithExchangeDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDivisionWithExchangeDocument = `
    query SearchDivisionWithExchange($filter: SearchDivisionFilter) {
  searchDivision(filter: $filter) {
    edges {
      node {
        ...DivisionFields
        exchanges {
          edges {
            node {
              ...ExchangeFields
            }
          }
        }
      }
    }
  }
}
    ${DivisionFieldsFragmentDoc}
${ExchangeFieldsFragmentDoc}`;
export const useSearchDivisionWithExchangeQuery = <
      TData = SearchDivisionWithExchangeQuery,
      TError = unknown
    >(
      variables?: SearchDivisionWithExchangeQueryVariables,
      options?: UseQueryOptions<SearchDivisionWithExchangeQuery, TError, TData>
    ) =>
    useQuery<SearchDivisionWithExchangeQuery, TError, TData>(
      variables === undefined ? ['SearchDivisionWithExchange'] : ['SearchDivisionWithExchange', variables],
      useFetchData<SearchDivisionWithExchangeQuery, SearchDivisionWithExchangeQueryVariables>(SearchDivisionWithExchangeDocument).bind(null, variables),
      options
    );

useSearchDivisionWithExchangeQuery.getKey = (variables?: SearchDivisionWithExchangeQueryVariables) => variables === undefined ? ['SearchDivisionWithExchange'] : ['SearchDivisionWithExchange', variables];
;

export const useInfiniteSearchDivisionWithExchangeQuery = <
      TData = SearchDivisionWithExchangeQuery,
      TError = unknown
    >(
      variables?: SearchDivisionWithExchangeQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDivisionWithExchangeQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDivisionWithExchangeQuery, TError, TData>(
      variables === undefined ? ['SearchDivisionWithExchange.infinite'] : ['SearchDivisionWithExchange.infinite', variables],
      (metaData) => useFetchData<SearchDivisionWithExchangeQuery, SearchDivisionWithExchangeQueryVariables>(SearchDivisionWithExchangeDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchDivisionWithDivisionFinancialDateDocument = `
    query SearchDivisionWithDivisionFinancialDate($filter: SearchDivisionFinancialDateFilter) {
  searchDivisionFinancialDate(filter: $filter) {
    edges {
      node {
        ...DivisionFinancialDateFields
      }
    }
  }
}
    ${DivisionFinancialDateFieldsFragmentDoc}`;
export const useSearchDivisionWithDivisionFinancialDateQuery = <
      TData = SearchDivisionWithDivisionFinancialDateQuery,
      TError = unknown
    >(
      variables?: SearchDivisionWithDivisionFinancialDateQueryVariables,
      options?: UseQueryOptions<SearchDivisionWithDivisionFinancialDateQuery, TError, TData>
    ) =>
    useQuery<SearchDivisionWithDivisionFinancialDateQuery, TError, TData>(
      variables === undefined ? ['SearchDivisionWithDivisionFinancialDate'] : ['SearchDivisionWithDivisionFinancialDate', variables],
      useFetchData<SearchDivisionWithDivisionFinancialDateQuery, SearchDivisionWithDivisionFinancialDateQueryVariables>(SearchDivisionWithDivisionFinancialDateDocument).bind(null, variables),
      options
    );

useSearchDivisionWithDivisionFinancialDateQuery.getKey = (variables?: SearchDivisionWithDivisionFinancialDateQueryVariables) => variables === undefined ? ['SearchDivisionWithDivisionFinancialDate'] : ['SearchDivisionWithDivisionFinancialDate', variables];
;

export const useInfiniteSearchDivisionWithDivisionFinancialDateQuery = <
      TData = SearchDivisionWithDivisionFinancialDateQuery,
      TError = unknown
    >(
      variables?: SearchDivisionWithDivisionFinancialDateQueryVariables,
      options?: UseInfiniteQueryOptions<SearchDivisionWithDivisionFinancialDateQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchDivisionWithDivisionFinancialDateQuery, TError, TData>(
      variables === undefined ? ['SearchDivisionWithDivisionFinancialDate.infinite'] : ['SearchDivisionWithDivisionFinancialDate.infinite', variables],
      (metaData) => useFetchData<SearchDivisionWithDivisionFinancialDateQuery, SearchDivisionWithDivisionFinancialDateQueryVariables>(SearchDivisionWithDivisionFinancialDateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const DivisionDetailDocument = `
    query DivisionDetail($id: ID!) {
  division(id: $id) {
    ...DivisionFields
    exchanges {
      edges {
        node {
          ...ExchangeFields
        }
      }
    }
    divisionFinancialDate {
      edges {
        node {
          ...DivisionFinancialDateFields
        }
      }
    }
  }
}
    ${DivisionFieldsFragmentDoc}
${ExchangeFieldsFragmentDoc}
${DivisionFinancialDateFieldsFragmentDoc}`;
export const useDivisionDetailQuery = <
      TData = DivisionDetailQuery,
      TError = unknown
    >(
      variables: DivisionDetailQueryVariables,
      options?: UseQueryOptions<DivisionDetailQuery, TError, TData>
    ) =>
    useQuery<DivisionDetailQuery, TError, TData>(
      ['DivisionDetail', variables],
      useFetchData<DivisionDetailQuery, DivisionDetailQueryVariables>(DivisionDetailDocument).bind(null, variables),
      options
    );

useDivisionDetailQuery.getKey = (variables: DivisionDetailQueryVariables) => ['DivisionDetail', variables];
;

export const useInfiniteDivisionDetailQuery = <
      TData = DivisionDetailQuery,
      TError = unknown
    >(
      variables: DivisionDetailQueryVariables,
      options?: UseInfiniteQueryOptions<DivisionDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<DivisionDetailQuery, TError, TData>(
      ['DivisionDetail.infinite', variables],
      (metaData) => useFetchData<DivisionDetailQuery, DivisionDetailQueryVariables>(DivisionDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const FetchDivisionGradesDocument = `
    query fetchDivisionGrades {
  divisionGrades {
    ...DivisionGradeFields
  }
  divisionTerms {
    ...DivisionTermsFields
  }
}
    ${DivisionGradeFieldsFragmentDoc}
${DivisionTermsFieldsFragmentDoc}`;
export const useFetchDivisionGradesQuery = <
      TData = FetchDivisionGradesQuery,
      TError = unknown
    >(
      variables?: FetchDivisionGradesQueryVariables,
      options?: UseQueryOptions<FetchDivisionGradesQuery, TError, TData>
    ) =>
    useQuery<FetchDivisionGradesQuery, TError, TData>(
      variables === undefined ? ['fetchDivisionGrades'] : ['fetchDivisionGrades', variables],
      useFetchData<FetchDivisionGradesQuery, FetchDivisionGradesQueryVariables>(FetchDivisionGradesDocument).bind(null, variables),
      options
    );

useFetchDivisionGradesQuery.getKey = (variables?: FetchDivisionGradesQueryVariables) => variables === undefined ? ['fetchDivisionGrades'] : ['fetchDivisionGrades', variables];
;

export const useInfiniteFetchDivisionGradesQuery = <
      TData = FetchDivisionGradesQuery,
      TError = unknown
    >(
      variables?: FetchDivisionGradesQueryVariables,
      options?: UseInfiniteQueryOptions<FetchDivisionGradesQuery, TError, TData>
    ) =>
    useInfiniteQuery<FetchDivisionGradesQuery, TError, TData>(
      variables === undefined ? ['fetchDivisionGrades.infinite'] : ['fetchDivisionGrades.infinite', variables],
      (metaData) => useFetchData<FetchDivisionGradesQuery, FetchDivisionGradesQueryVariables>(FetchDivisionGradesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const EstimateDocument = `
    query Estimate($id: ID!) {
  estimate(id: $id) {
    ...EstimateFields
  }
}
    ${EstimateFieldsFragmentDoc}`;
export const useEstimateQuery = <
      TData = EstimateQuery,
      TError = unknown
    >(
      variables: EstimateQueryVariables,
      options?: UseQueryOptions<EstimateQuery, TError, TData>
    ) =>
    useQuery<EstimateQuery, TError, TData>(
      ['Estimate', variables],
      useFetchData<EstimateQuery, EstimateQueryVariables>(EstimateDocument).bind(null, variables),
      options
    );

useEstimateQuery.getKey = (variables: EstimateQueryVariables) => ['Estimate', variables];
;

export const useInfiniteEstimateQuery = <
      TData = EstimateQuery,
      TError = unknown
    >(
      variables: EstimateQueryVariables,
      options?: UseInfiniteQueryOptions<EstimateQuery, TError, TData>
    ) =>
    useInfiniteQuery<EstimateQuery, TError, TData>(
      ['Estimate.infinite', variables],
      (metaData) => useFetchData<EstimateQuery, EstimateQueryVariables>(EstimateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchEstimateDocument = `
    query searchEstimate($first: Int, $after: String, $filter: SearchEstimateFilter, $sort: [EstimateSortEnum]) {
  searchEstimate(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...EstimateFields
      }
    }
  }
}
    ${EstimateFieldsFragmentDoc}`;
export const useSearchEstimateQuery = <
      TData = SearchEstimateQuery,
      TError = unknown
    >(
      variables?: SearchEstimateQueryVariables,
      options?: UseQueryOptions<SearchEstimateQuery, TError, TData>
    ) =>
    useQuery<SearchEstimateQuery, TError, TData>(
      variables === undefined ? ['searchEstimate'] : ['searchEstimate', variables],
      useFetchData<SearchEstimateQuery, SearchEstimateQueryVariables>(SearchEstimateDocument).bind(null, variables),
      options
    );

useSearchEstimateQuery.getKey = (variables?: SearchEstimateQueryVariables) => variables === undefined ? ['searchEstimate'] : ['searchEstimate', variables];
;

export const useInfiniteSearchEstimateQuery = <
      TData = SearchEstimateQuery,
      TError = unknown
    >(
      variables?: SearchEstimateQueryVariables,
      options?: UseInfiniteQueryOptions<SearchEstimateQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchEstimateQuery, TError, TData>(
      variables === undefined ? ['searchEstimate.infinite'] : ['searchEstimate.infinite', variables],
      (metaData) => useFetchData<SearchEstimateQuery, SearchEstimateQueryVariables>(SearchEstimateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateEstimateDocument = `
    mutation createEstimate($input: CreateEstimateInput!) {
  createEstimate(input: $input) {
    estimate {
      ...EstimateMutationFields
    }
  }
}
    ${EstimateMutationFieldsFragmentDoc}`;
export const useCreateEstimateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEstimateMutation, TError, CreateEstimateMutationVariables, TContext>) =>
    useMutation<CreateEstimateMutation, TError, CreateEstimateMutationVariables, TContext>(
      'createEstimate',
      useFetchData<CreateEstimateMutation, CreateEstimateMutationVariables>(CreateEstimateDocument),
      options
    );
export const UpdateEstimateDocument = `
    mutation updateEstimate($input: UpdateEstimateInput!) {
  updateEstimate(input: $input) {
    estimate {
      ...EstimateMutationFields
    }
  }
}
    ${EstimateMutationFieldsFragmentDoc}`;
export const useUpdateEstimateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateEstimateMutation, TError, UpdateEstimateMutationVariables, TContext>) =>
    useMutation<UpdateEstimateMutation, TError, UpdateEstimateMutationVariables, TContext>(
      'updateEstimate',
      useFetchData<UpdateEstimateMutation, UpdateEstimateMutationVariables>(UpdateEstimateDocument),
      options
    );
export const DeleteEstimateDocument = `
    mutation deleteEstimate($input: DeleteEstimateInput!) {
  deleteEstimate(input: $input) {
    estimate {
      ...EstimateMutationFields
    }
  }
}
    ${EstimateMutationFieldsFragmentDoc}`;
export const useDeleteEstimateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteEstimateMutation, TError, DeleteEstimateMutationVariables, TContext>) =>
    useMutation<DeleteEstimateMutation, TError, DeleteEstimateMutationVariables, TContext>(
      'deleteEstimate',
      useFetchData<DeleteEstimateMutation, DeleteEstimateMutationVariables>(DeleteEstimateDocument),
      options
    );
export const EstimateCustomerDocument = `
    query estimateCustomer($id: ID!) {
  customer(id: $id) {
    ...EstimateCustomerFields
  }
}
    ${EstimateCustomerFieldsFragmentDoc}`;
export const useEstimateCustomerQuery = <
      TData = EstimateCustomerQuery,
      TError = unknown
    >(
      variables: EstimateCustomerQueryVariables,
      options?: UseQueryOptions<EstimateCustomerQuery, TError, TData>
    ) =>
    useQuery<EstimateCustomerQuery, TError, TData>(
      ['estimateCustomer', variables],
      useFetchData<EstimateCustomerQuery, EstimateCustomerQueryVariables>(EstimateCustomerDocument).bind(null, variables),
      options
    );

useEstimateCustomerQuery.getKey = (variables: EstimateCustomerQueryVariables) => ['estimateCustomer', variables];
;

export const useInfiniteEstimateCustomerQuery = <
      TData = EstimateCustomerQuery,
      TError = unknown
    >(
      variables: EstimateCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<EstimateCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<EstimateCustomerQuery, TError, TData>(
      ['estimateCustomer.infinite', variables],
      (metaData) => useFetchData<EstimateCustomerQuery, EstimateCustomerQueryVariables>(EstimateCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchEstimateDivisionDocument = `
    query searchEstimateDivision($first: Int, $after: String, $filter: SearchEstimateFilter, $sort: [EstimateSortEnum]) {
  searchEstimate(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        customer {
          userDivisionCode
          salesReport {
            reportLayoutCode
            reportLayoutName
            activeReportFlg
          }
        }
      }
    }
  }
}
    `;
export const useSearchEstimateDivisionQuery = <
      TData = SearchEstimateDivisionQuery,
      TError = unknown
    >(
      variables?: SearchEstimateDivisionQueryVariables,
      options?: UseQueryOptions<SearchEstimateDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchEstimateDivisionQuery, TError, TData>(
      variables === undefined ? ['searchEstimateDivision'] : ['searchEstimateDivision', variables],
      useFetchData<SearchEstimateDivisionQuery, SearchEstimateDivisionQueryVariables>(SearchEstimateDivisionDocument).bind(null, variables),
      options
    );

useSearchEstimateDivisionQuery.getKey = (variables?: SearchEstimateDivisionQueryVariables) => variables === undefined ? ['searchEstimateDivision'] : ['searchEstimateDivision', variables];
;

export const useInfiniteSearchEstimateDivisionQuery = <
      TData = SearchEstimateDivisionQuery,
      TError = unknown
    >(
      variables?: SearchEstimateDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchEstimateDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchEstimateDivisionQuery, TError, TData>(
      variables === undefined ? ['searchEstimateDivision.infinite'] : ['searchEstimateDivision.infinite', variables],
      (metaData) => useFetchData<SearchEstimateDivisionQuery, SearchEstimateDivisionQueryVariables>(SearchEstimateDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchExchangeDocument = `
    query searchExchange {
  searchExchange {
    edges {
      node {
        divisionCode
        exchangeRate
      }
    }
  }
}
    `;
export const useSearchExchangeQuery = <
      TData = SearchExchangeQuery,
      TError = unknown
    >(
      variables?: SearchExchangeQueryVariables,
      options?: UseQueryOptions<SearchExchangeQuery, TError, TData>
    ) =>
    useQuery<SearchExchangeQuery, TError, TData>(
      variables === undefined ? ['searchExchange'] : ['searchExchange', variables],
      useFetchData<SearchExchangeQuery, SearchExchangeQueryVariables>(SearchExchangeDocument).bind(null, variables),
      options
    );

useSearchExchangeQuery.getKey = (variables?: SearchExchangeQueryVariables) => variables === undefined ? ['searchExchange'] : ['searchExchange', variables];
;

export const useInfiniteSearchExchangeQuery = <
      TData = SearchExchangeQuery,
      TError = unknown
    >(
      variables?: SearchExchangeQueryVariables,
      options?: UseInfiniteQueryOptions<SearchExchangeQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchExchangeQuery, TError, TData>(
      variables === undefined ? ['searchExchange.infinite'] : ['searchExchange.infinite', variables],
      (metaData) => useFetchData<SearchExchangeQuery, SearchExchangeQueryVariables>(SearchExchangeDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ExecuteDemandDecisionDeleteDocument = `
    mutation executeDemandDecisionDelete($input: ExecuteDemandDecisionDeleteInput!) {
  executeDemandDecisionDelete(input: $input) {
    receiveOrder {
      receiveOrderId
    }
  }
}
    `;
export const useExecuteDemandDecisionDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteDemandDecisionDeleteMutation, TError, ExecuteDemandDecisionDeleteMutationVariables, TContext>) =>
    useMutation<ExecuteDemandDecisionDeleteMutation, TError, ExecuteDemandDecisionDeleteMutationVariables, TContext>(
      'executeDemandDecisionDelete',
      useFetchData<ExecuteDemandDecisionDeleteMutation, ExecuteDemandDecisionDeleteMutationVariables>(ExecuteDemandDecisionDeleteDocument),
      options
    );
export const ExecuteDemandDecisionReceiveDocument = `
    mutation executeDemandDecisionReceive($input: ExecuteDemandDecisionReceiveInput!) {
  executeDemandDecisionReceive(input: $input) {
    receiveOrder {
      receiveOrderId
    }
  }
}
    `;
export const useExecuteDemandDecisionReceiveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteDemandDecisionReceiveMutation, TError, ExecuteDemandDecisionReceiveMutationVariables, TContext>) =>
    useMutation<ExecuteDemandDecisionReceiveMutation, TError, ExecuteDemandDecisionReceiveMutationVariables, TContext>(
      'executeDemandDecisionReceive',
      useFetchData<ExecuteDemandDecisionReceiveMutation, ExecuteDemandDecisionReceiveMutationVariables>(ExecuteDemandDecisionReceiveDocument),
      options
    );
export const ExecutePaymentDecisionDeleteDocument = `
    mutation executePaymentDecisionDelete($input: ExecutePaymentDecisionDeleteInput!) {
  executePaymentDecisionDelete(input: $input) {
    sendOrder {
      orderId
    }
  }
}
    `;
export const useExecutePaymentDecisionDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecutePaymentDecisionDeleteMutation, TError, ExecutePaymentDecisionDeleteMutationVariables, TContext>) =>
    useMutation<ExecutePaymentDecisionDeleteMutation, TError, ExecutePaymentDecisionDeleteMutationVariables, TContext>(
      'executePaymentDecisionDelete',
      useFetchData<ExecutePaymentDecisionDeleteMutation, ExecutePaymentDecisionDeleteMutationVariables>(ExecutePaymentDecisionDeleteDocument),
      options
    );
export const ExecutePaymentDecisionSendDocument = `
    mutation executePaymentDecisionSend($input: ExecutePaymentDecisionSendInput!) {
  executePaymentDecisionSend(input: $input) {
    sendOrder {
      orderId
    }
  }
}
    `;
export const useExecutePaymentDecisionSendMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecutePaymentDecisionSendMutation, TError, ExecutePaymentDecisionSendMutationVariables, TContext>) =>
    useMutation<ExecutePaymentDecisionSendMutation, TError, ExecutePaymentDecisionSendMutationVariables, TContext>(
      'executePaymentDecisionSend',
      useFetchData<ExecutePaymentDecisionSendMutation, ExecutePaymentDecisionSendMutationVariables>(ExecutePaymentDecisionSendDocument),
      options
    );
export const ExecuteReturnProcessSendDocument = `
    mutation executeReturnProcessSend($input: ExecuteReturnProcessSendInput!) {
  executeReturnProcessSend(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useExecuteReturnProcessSendMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteReturnProcessSendMutation, TError, ExecuteReturnProcessSendMutationVariables, TContext>) =>
    useMutation<ExecuteReturnProcessSendMutation, TError, ExecuteReturnProcessSendMutationVariables, TContext>(
      'executeReturnProcessSend',
      useFetchData<ExecuteReturnProcessSendMutation, ExecuteReturnProcessSendMutationVariables>(ExecuteReturnProcessSendDocument),
      options
    );
export const SearchFinancialDateDetailDocument = `
    query searchFinancialDateDetail {
  searchFinancialDateDetail {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...FinancialDateDetailFields
      }
    }
  }
}
    ${FinancialDateDetailFieldsFragmentDoc}`;
export const useSearchFinancialDateDetailQuery = <
      TData = SearchFinancialDateDetailQuery,
      TError = unknown
    >(
      variables?: SearchFinancialDateDetailQueryVariables,
      options?: UseQueryOptions<SearchFinancialDateDetailQuery, TError, TData>
    ) =>
    useQuery<SearchFinancialDateDetailQuery, TError, TData>(
      variables === undefined ? ['searchFinancialDateDetail'] : ['searchFinancialDateDetail', variables],
      useFetchData<SearchFinancialDateDetailQuery, SearchFinancialDateDetailQueryVariables>(SearchFinancialDateDetailDocument).bind(null, variables),
      options
    );

useSearchFinancialDateDetailQuery.getKey = (variables?: SearchFinancialDateDetailQueryVariables) => variables === undefined ? ['searchFinancialDateDetail'] : ['searchFinancialDateDetail', variables];
;

export const useInfiniteSearchFinancialDateDetailQuery = <
      TData = SearchFinancialDateDetailQuery,
      TError = unknown
    >(
      variables?: SearchFinancialDateDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchFinancialDateDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchFinancialDateDetailQuery, TError, TData>(
      variables === undefined ? ['searchFinancialDateDetail.infinite'] : ['searchFinancialDateDetail.infinite', variables],
      (metaData) => useFetchData<SearchFinancialDateDetailQuery, SearchFinancialDateDetailQueryVariables>(SearchFinancialDateDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateFkorderInformationAttachmentDocument = `
    mutation CreateFkorderInformationAttachment($input: CreateFkorderInformationAttachmentInput!) {
  createFkorderInformationAttachment(input: $input) {
    url
    s3Key
  }
}
    `;
export const useCreateFkorderInformationAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFkorderInformationAttachmentMutation, TError, CreateFkorderInformationAttachmentMutationVariables, TContext>) =>
    useMutation<CreateFkorderInformationAttachmentMutation, TError, CreateFkorderInformationAttachmentMutationVariables, TContext>(
      'CreateFkorderInformationAttachment',
      useFetchData<CreateFkorderInformationAttachmentMutation, CreateFkorderInformationAttachmentMutationVariables>(CreateFkorderInformationAttachmentDocument),
      options
    );
export const FkorderPublicationDocument = `
    query fkorderPublication {
  fkorderPublication {
    divisionCode
    divisionName
    lastUpdated
    lastPublicated
    publicationStatus
  }
}
    `;
export const useFkorderPublicationQuery = <
      TData = FkorderPublicationQuery,
      TError = unknown
    >(
      variables?: FkorderPublicationQueryVariables,
      options?: UseQueryOptions<FkorderPublicationQuery, TError, TData>
    ) =>
    useQuery<FkorderPublicationQuery, TError, TData>(
      variables === undefined ? ['fkorderPublication'] : ['fkorderPublication', variables],
      useFetchData<FkorderPublicationQuery, FkorderPublicationQueryVariables>(FkorderPublicationDocument).bind(null, variables),
      options
    );

useFkorderPublicationQuery.getKey = (variables?: FkorderPublicationQueryVariables) => variables === undefined ? ['fkorderPublication'] : ['fkorderPublication', variables];
;

export const useInfiniteFkorderPublicationQuery = <
      TData = FkorderPublicationQuery,
      TError = unknown
    >(
      variables?: FkorderPublicationQueryVariables,
      options?: UseInfiniteQueryOptions<FkorderPublicationQuery, TError, TData>
    ) =>
    useInfiniteQuery<FkorderPublicationQuery, TError, TData>(
      variables === undefined ? ['fkorderPublication.infinite'] : ['fkorderPublication.infinite', variables],
      (metaData) => useFetchData<FkorderPublicationQuery, FkorderPublicationQueryVariables>(FkorderPublicationDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SyncFkorderPublicationDocument = `
    mutation syncFkorderPublication($input: SyncFkorderPublicationInput!) {
  syncFkorderPublication(input: $input) {
    divisionCode
  }
}
    `;
export const useSyncFkorderPublicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncFkorderPublicationMutation, TError, SyncFkorderPublicationMutationVariables, TContext>) =>
    useMutation<SyncFkorderPublicationMutation, TError, SyncFkorderPublicationMutationVariables, TContext>(
      'syncFkorderPublication',
      useFetchData<SyncFkorderPublicationMutation, SyncFkorderPublicationMutationVariables>(SyncFkorderPublicationDocument),
      options
    );
export const SyncFkorderPublicationPreAndPublicDocument = `
    mutation syncFkorderPublicationPreAndPublic($input: SyncFkorderPublicationPreAndPublicInput!) {
  syncFkorderPublicationPreAndPublic(input: $input) {
    divisionCode
  }
}
    `;
export const useSyncFkorderPublicationPreAndPublicMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncFkorderPublicationPreAndPublicMutation, TError, SyncFkorderPublicationPreAndPublicMutationVariables, TContext>) =>
    useMutation<SyncFkorderPublicationPreAndPublicMutation, TError, SyncFkorderPublicationPreAndPublicMutationVariables, TContext>(
      'syncFkorderPublicationPreAndPublic',
      useFetchData<SyncFkorderPublicationPreAndPublicMutation, SyncFkorderPublicationPreAndPublicMutationVariables>(SyncFkorderPublicationPreAndPublicDocument),
      options
    );
export const ImportSendOrderRequestDocument = `
    mutation importSendOrderRequest($input: ImportSendOrderRequestInput!) {
  importSendOrderRequest(input: $input) {
    sendOrder {
      orderId
    }
  }
}
    `;
export const useImportSendOrderRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportSendOrderRequestMutation, TError, ImportSendOrderRequestMutationVariables, TContext>) =>
    useMutation<ImportSendOrderRequestMutation, TError, ImportSendOrderRequestMutationVariables, TContext>(
      'importSendOrderRequest',
      useFetchData<ImportSendOrderRequestMutation, ImportSendOrderRequestMutationVariables>(ImportSendOrderRequestDocument),
      options
    );
export const FkorderInformationDocument = `
    query FkorderInformation($id: ID!) {
  fkorderInformation(id: $id) {
    ...InformationFields
  }
}
    ${InformationFieldsFragmentDoc}`;
export const useFkorderInformationQuery = <
      TData = FkorderInformationQuery,
      TError = unknown
    >(
      variables: FkorderInformationQueryVariables,
      options?: UseQueryOptions<FkorderInformationQuery, TError, TData>
    ) =>
    useQuery<FkorderInformationQuery, TError, TData>(
      ['FkorderInformation', variables],
      useFetchData<FkorderInformationQuery, FkorderInformationQueryVariables>(FkorderInformationDocument).bind(null, variables),
      options
    );

useFkorderInformationQuery.getKey = (variables: FkorderInformationQueryVariables) => ['FkorderInformation', variables];
;

export const useInfiniteFkorderInformationQuery = <
      TData = FkorderInformationQuery,
      TError = unknown
    >(
      variables: FkorderInformationQueryVariables,
      options?: UseInfiniteQueryOptions<FkorderInformationQuery, TError, TData>
    ) =>
    useInfiniteQuery<FkorderInformationQuery, TError, TData>(
      ['FkorderInformation.infinite', variables],
      (metaData) => useFetchData<FkorderInformationQuery, FkorderInformationQueryVariables>(FkorderInformationDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchFkorderInformationDocument = `
    query searchFkorderInformation($first: Int, $after: String, $filter: SearchFkorderInformationFilter, $sort: [FkorderInformationSortEnum]) {
  searchFkorderInformation(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...InformationFields
      }
    }
  }
}
    ${InformationFieldsFragmentDoc}`;
export const useSearchFkorderInformationQuery = <
      TData = SearchFkorderInformationQuery,
      TError = unknown
    >(
      variables?: SearchFkorderInformationQueryVariables,
      options?: UseQueryOptions<SearchFkorderInformationQuery, TError, TData>
    ) =>
    useQuery<SearchFkorderInformationQuery, TError, TData>(
      variables === undefined ? ['searchFkorderInformation'] : ['searchFkorderInformation', variables],
      useFetchData<SearchFkorderInformationQuery, SearchFkorderInformationQueryVariables>(SearchFkorderInformationDocument).bind(null, variables),
      options
    );

useSearchFkorderInformationQuery.getKey = (variables?: SearchFkorderInformationQueryVariables) => variables === undefined ? ['searchFkorderInformation'] : ['searchFkorderInformation', variables];
;

export const useInfiniteSearchFkorderInformationQuery = <
      TData = SearchFkorderInformationQuery,
      TError = unknown
    >(
      variables?: SearchFkorderInformationQueryVariables,
      options?: UseInfiniteQueryOptions<SearchFkorderInformationQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchFkorderInformationQuery, TError, TData>(
      variables === undefined ? ['searchFkorderInformation.infinite'] : ['searchFkorderInformation.infinite', variables],
      (metaData) => useFetchData<SearchFkorderInformationQuery, SearchFkorderInformationQueryVariables>(SearchFkorderInformationDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateFKorderInformationDocument = `
    mutation createFKorderInformation($input: CreateFkorderInformationInput!) {
  createFkorderInformation(input: $input) {
    fkorderInformation {
      informationId
      versionUuid
    }
  }
}
    `;
export const useCreateFKorderInformationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFKorderInformationMutation, TError, CreateFKorderInformationMutationVariables, TContext>) =>
    useMutation<CreateFKorderInformationMutation, TError, CreateFKorderInformationMutationVariables, TContext>(
      'createFKorderInformation',
      useFetchData<CreateFKorderInformationMutation, CreateFKorderInformationMutationVariables>(CreateFKorderInformationDocument),
      options
    );
export const UpdateFKorderInformationDocument = `
    mutation updateFKorderInformation($input: UpdateFkorderInformationInput!) {
  updateFkorderInformation(input: $input) {
    fkorderInformation {
      informationId
      versionUuid
    }
  }
}
    `;
export const useUpdateFKorderInformationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFKorderInformationMutation, TError, UpdateFKorderInformationMutationVariables, TContext>) =>
    useMutation<UpdateFKorderInformationMutation, TError, UpdateFKorderInformationMutationVariables, TContext>(
      'updateFKorderInformation',
      useFetchData<UpdateFKorderInformationMutation, UpdateFKorderInformationMutationVariables>(UpdateFKorderInformationDocument),
      options
    );
export const DeleteFkorderInformationDocument = `
    mutation deleteFkorderInformation($input: DeleteFkorderInformationInput!) {
  deleteFkorderInformation(input: $input) {
    fkorderInformation {
      informationId
      versionUuid
    }
  }
}
    `;
export const useDeleteFkorderInformationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFkorderInformationMutation, TError, DeleteFkorderInformationMutationVariables, TContext>) =>
    useMutation<DeleteFkorderInformationMutation, TError, DeleteFkorderInformationMutationVariables, TContext>(
      'deleteFkorderInformation',
      useFetchData<DeleteFkorderInformationMutation, DeleteFkorderInformationMutationVariables>(DeleteFkorderInformationDocument),
      options
    );
export const SearchInternalTransactionDocument = `
    query searchInternalTransaction($first: Int, $after: String, $filter: SearchInternalTransactionFilter) {
  searchInternalTransaction(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        tradeDate
        tradeHistoryType
        tradeId
        inputDivisionCode
        inputDivisionName
        outputDivisionCode
        outputDivisionName
        inputJanCode
        inputAttributeName
        quantity
        inputSalesUnitPrice
        inputPrice
        outputJanCode
        outputAttributeName
        outputSalesUnitPrice
        outputPrice
        detailMemo
        customerCode
        customerName
        deliveryDestinationCode
        deliveryDestinationName
        estimateId
        receiveOrderId
        deliveryOrderId
        warehouseMoveId
        adjustId
      }
    }
  }
}
    `;
export const useSearchInternalTransactionQuery = <
      TData = SearchInternalTransactionQuery,
      TError = unknown
    >(
      variables?: SearchInternalTransactionQueryVariables,
      options?: UseQueryOptions<SearchInternalTransactionQuery, TError, TData>
    ) =>
    useQuery<SearchInternalTransactionQuery, TError, TData>(
      variables === undefined ? ['searchInternalTransaction'] : ['searchInternalTransaction', variables],
      useFetchData<SearchInternalTransactionQuery, SearchInternalTransactionQueryVariables>(SearchInternalTransactionDocument).bind(null, variables),
      options
    );

useSearchInternalTransactionQuery.getKey = (variables?: SearchInternalTransactionQueryVariables) => variables === undefined ? ['searchInternalTransaction'] : ['searchInternalTransaction', variables];
;

export const useInfiniteSearchInternalTransactionQuery = <
      TData = SearchInternalTransactionQuery,
      TError = unknown
    >(
      variables?: SearchInternalTransactionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchInternalTransactionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchInternalTransactionQuery, TError, TData>(
      variables === undefined ? ['searchInternalTransaction.infinite'] : ['searchInternalTransaction.infinite', variables],
      (metaData) => useFetchData<SearchInternalTransactionQuery, SearchInternalTransactionQueryVariables>(SearchInternalTransactionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const InventoryDocument = `
    query Inventory($id: ID!) {
  inventory(id: $id) {
    ...InventoryFields
  }
}
    ${InventoryFieldsFragmentDoc}`;
export const useInventoryQuery = <
      TData = InventoryQuery,
      TError = unknown
    >(
      variables: InventoryQueryVariables,
      options?: UseQueryOptions<InventoryQuery, TError, TData>
    ) =>
    useQuery<InventoryQuery, TError, TData>(
      ['Inventory', variables],
      useFetchData<InventoryQuery, InventoryQueryVariables>(InventoryDocument).bind(null, variables),
      options
    );

useInventoryQuery.getKey = (variables: InventoryQueryVariables) => ['Inventory', variables];
;

export const useInfiniteInventoryQuery = <
      TData = InventoryQuery,
      TError = unknown
    >(
      variables: InventoryQueryVariables,
      options?: UseInfiniteQueryOptions<InventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<InventoryQuery, TError, TData>(
      ['Inventory.infinite', variables],
      (metaData) => useFetchData<InventoryQuery, InventoryQueryVariables>(InventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchInventoryDocument = `
    query searchInventory($first: Int, $after: String, $filter: SearchInventoryFilter, $sort: [InventorySortEnum]) {
  searchInventory(first: $first, after: $after, filter: $filter, sort: $sort) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...InventoryFields
      }
    }
  }
}
    ${InventoryFieldsFragmentDoc}`;
export const useSearchInventoryQuery = <
      TData = SearchInventoryQuery,
      TError = unknown
    >(
      variables?: SearchInventoryQueryVariables,
      options?: UseQueryOptions<SearchInventoryQuery, TError, TData>
    ) =>
    useQuery<SearchInventoryQuery, TError, TData>(
      variables === undefined ? ['searchInventory'] : ['searchInventory', variables],
      useFetchData<SearchInventoryQuery, SearchInventoryQueryVariables>(SearchInventoryDocument).bind(null, variables),
      options
    );

useSearchInventoryQuery.getKey = (variables?: SearchInventoryQueryVariables) => variables === undefined ? ['searchInventory'] : ['searchInventory', variables];
;

export const useInfiniteSearchInventoryQuery = <
      TData = SearchInventoryQuery,
      TError = unknown
    >(
      variables?: SearchInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchInventoryQuery, TError, TData>(
      variables === undefined ? ['searchInventory.infinite'] : ['searchInventory.infinite', variables],
      (metaData) => useFetchData<SearchInventoryQuery, SearchInventoryQueryVariables>(SearchInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateInventoryDocument = `
    mutation createInventory($input: CreateInventoryInput!) {
  createInventory(input: $input) {
    inventory {
      versionUuid
      inventoryId
    }
  }
}
    `;
export const useCreateInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateInventoryMutation, TError, CreateInventoryMutationVariables, TContext>) =>
    useMutation<CreateInventoryMutation, TError, CreateInventoryMutationVariables, TContext>(
      'createInventory',
      useFetchData<CreateInventoryMutation, CreateInventoryMutationVariables>(CreateInventoryDocument),
      options
    );
export const UpdateInventoryDocument = `
    mutation updateInventory($input: UpdateInventoryInput!) {
  updateInventory(input: $input) {
    inventory {
      versionUuid
      inventoryId
    }
  }
}
    `;
export const useUpdateInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInventoryMutation, TError, UpdateInventoryMutationVariables, TContext>) =>
    useMutation<UpdateInventoryMutation, TError, UpdateInventoryMutationVariables, TContext>(
      'updateInventory',
      useFetchData<UpdateInventoryMutation, UpdateInventoryMutationVariables>(UpdateInventoryDocument),
      options
    );
export const DeleteInventoryDocument = `
    mutation deleteInventory($input: DeleteInventoryInput!) {
  deleteInventory(input: $input) {
    inventory {
      versionUuid
      inventoryId
    }
  }
}
    `;
export const useDeleteInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteInventoryMutation, TError, DeleteInventoryMutationVariables, TContext>) =>
    useMutation<DeleteInventoryMutation, TError, DeleteInventoryMutationVariables, TContext>(
      'deleteInventory',
      useFetchData<DeleteInventoryMutation, DeleteInventoryMutationVariables>(DeleteInventoryDocument),
      options
    );
export const FinalizeInventoryDivisionDocument = `
    mutation finalizeInventoryDivision($input: FinalizeInventoryDivisionInput!) {
  finalizeInventoryDivision(input: $input) {
    inventoryId
  }
}
    `;
export const useFinalizeInventoryDivisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FinalizeInventoryDivisionMutation, TError, FinalizeInventoryDivisionMutationVariables, TContext>) =>
    useMutation<FinalizeInventoryDivisionMutation, TError, FinalizeInventoryDivisionMutationVariables, TContext>(
      'finalizeInventoryDivision',
      useFetchData<FinalizeInventoryDivisionMutation, FinalizeInventoryDivisionMutationVariables>(FinalizeInventoryDivisionDocument),
      options
    );
export const ImportInventoryDetailDocument = `
    mutation importInventoryDetail($input: ImportInventoryDetailInput!) {
  importInventoryDetail(input: $input) {
    inventoryId
  }
}
    `;
export const useImportInventoryDetailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportInventoryDetailMutation, TError, ImportInventoryDetailMutationVariables, TContext>) =>
    useMutation<ImportInventoryDetailMutation, TError, ImportInventoryDetailMutationVariables, TContext>(
      'importInventoryDetail',
      useFetchData<ImportInventoryDetailMutation, ImportInventoryDetailMutationVariables>(ImportInventoryDetailDocument),
      options
    );
export const SearchInventoryDetailCustomDocument = `
    query searchInventoryDetailCustom($filter: InventoryDetailCustomFilter) {
  searchInventoryDetailCustom(filter: $filter) {
    result
  }
}
    `;
export const useSearchInventoryDetailCustomQuery = <
      TData = SearchInventoryDetailCustomQuery,
      TError = unknown
    >(
      variables?: SearchInventoryDetailCustomQueryVariables,
      options?: UseQueryOptions<SearchInventoryDetailCustomQuery, TError, TData>
    ) =>
    useQuery<SearchInventoryDetailCustomQuery, TError, TData>(
      variables === undefined ? ['searchInventoryDetailCustom'] : ['searchInventoryDetailCustom', variables],
      useFetchData<SearchInventoryDetailCustomQuery, SearchInventoryDetailCustomQueryVariables>(SearchInventoryDetailCustomDocument).bind(null, variables),
      options
    );

useSearchInventoryDetailCustomQuery.getKey = (variables?: SearchInventoryDetailCustomQueryVariables) => variables === undefined ? ['searchInventoryDetailCustom'] : ['searchInventoryDetailCustom', variables];
;

export const useInfiniteSearchInventoryDetailCustomQuery = <
      TData = SearchInventoryDetailCustomQuery,
      TError = unknown
    >(
      variables?: SearchInventoryDetailCustomQueryVariables,
      options?: UseInfiniteQueryOptions<SearchInventoryDetailCustomQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchInventoryDetailCustomQuery, TError, TData>(
      variables === undefined ? ['searchInventoryDetailCustom.infinite'] : ['searchInventoryDetailCustom.infinite', variables],
      (metaData) => useFetchData<SearchInventoryDetailCustomQuery, SearchInventoryDetailCustomQueryVariables>(SearchInventoryDetailCustomDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchInventoryDivisionDocument = `
    query searchInventoryDivision($first: Int, $after: String, $filter: SearchInventoryDivisionFilter, $sort: [InventoryDivisionSortEnum]) {
  searchInventoryDivision(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...InventoryDivisionFields
      }
    }
  }
}
    ${InventoryDivisionFieldsFragmentDoc}`;
export const useSearchInventoryDivisionQuery = <
      TData = SearchInventoryDivisionQuery,
      TError = unknown
    >(
      variables?: SearchInventoryDivisionQueryVariables,
      options?: UseQueryOptions<SearchInventoryDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchInventoryDivisionQuery, TError, TData>(
      variables === undefined ? ['searchInventoryDivision'] : ['searchInventoryDivision', variables],
      useFetchData<SearchInventoryDivisionQuery, SearchInventoryDivisionQueryVariables>(SearchInventoryDivisionDocument).bind(null, variables),
      options
    );

useSearchInventoryDivisionQuery.getKey = (variables?: SearchInventoryDivisionQueryVariables) => variables === undefined ? ['searchInventoryDivision'] : ['searchInventoryDivision', variables];
;

export const useInfiniteSearchInventoryDivisionQuery = <
      TData = SearchInventoryDivisionQuery,
      TError = unknown
    >(
      variables?: SearchInventoryDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchInventoryDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchInventoryDivisionQuery, TError, TData>(
      variables === undefined ? ['searchInventoryDivision.infinite'] : ['searchInventoryDivision.infinite', variables],
      (metaData) => useFetchData<SearchInventoryDivisionQuery, SearchInventoryDivisionQueryVariables>(SearchInventoryDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchLotGroupProductDocument = `
    query searchLotGroupProduct($first: Int, $after: String, $filter: LotGroupProductFilter) {
  searchLotGroupProduct(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        lotGroupCode
        lotGroupName
        minimumLot
        purchaseOrderLeadTime
        janCode
        productCode
        productName
        attr1
        attr2
        attributeName
      }
    }
  }
}
    `;
export const useSearchLotGroupProductQuery = <
      TData = SearchLotGroupProductQuery,
      TError = unknown
    >(
      variables?: SearchLotGroupProductQueryVariables,
      options?: UseQueryOptions<SearchLotGroupProductQuery, TError, TData>
    ) =>
    useQuery<SearchLotGroupProductQuery, TError, TData>(
      variables === undefined ? ['searchLotGroupProduct'] : ['searchLotGroupProduct', variables],
      useFetchData<SearchLotGroupProductQuery, SearchLotGroupProductQueryVariables>(SearchLotGroupProductDocument).bind(null, variables),
      options
    );

useSearchLotGroupProductQuery.getKey = (variables?: SearchLotGroupProductQueryVariables) => variables === undefined ? ['searchLotGroupProduct'] : ['searchLotGroupProduct', variables];
;

export const useInfiniteSearchLotGroupProductQuery = <
      TData = SearchLotGroupProductQuery,
      TError = unknown
    >(
      variables?: SearchLotGroupProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchLotGroupProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchLotGroupProductQuery, TError, TData>(
      variables === undefined ? ['searchLotGroupProduct.infinite'] : ['searchLotGroupProduct.infinite', variables],
      (metaData) => useFetchData<SearchLotGroupProductQuery, SearchLotGroupProductQueryVariables>(SearchLotGroupProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const AllSearchSendOrderLotDocument = `
    query allSearchSendOrderLot($first: Int) {
  searchSendOrderLot(first: $first) {
    totalCount
    edges {
      cursor
      node {
        lotGroupCode
        lotGroupName
      }
    }
  }
}
    `;
export const useAllSearchSendOrderLotQuery = <
      TData = AllSearchSendOrderLotQuery,
      TError = unknown
    >(
      variables?: AllSearchSendOrderLotQueryVariables,
      options?: UseQueryOptions<AllSearchSendOrderLotQuery, TError, TData>
    ) =>
    useQuery<AllSearchSendOrderLotQuery, TError, TData>(
      variables === undefined ? ['allSearchSendOrderLot'] : ['allSearchSendOrderLot', variables],
      useFetchData<AllSearchSendOrderLotQuery, AllSearchSendOrderLotQueryVariables>(AllSearchSendOrderLotDocument).bind(null, variables),
      options
    );

useAllSearchSendOrderLotQuery.getKey = (variables?: AllSearchSendOrderLotQueryVariables) => variables === undefined ? ['allSearchSendOrderLot'] : ['allSearchSendOrderLot', variables];
;

export const useInfiniteAllSearchSendOrderLotQuery = <
      TData = AllSearchSendOrderLotQuery,
      TError = unknown
    >(
      variables?: AllSearchSendOrderLotQueryVariables,
      options?: UseInfiniteQueryOptions<AllSearchSendOrderLotQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllSearchSendOrderLotQuery, TError, TData>(
      variables === undefined ? ['allSearchSendOrderLot.infinite'] : ['allSearchSendOrderLot.infinite', variables],
      (metaData) => useFetchData<AllSearchSendOrderLotQuery, AllSearchSendOrderLotQueryVariables>(AllSearchSendOrderLotDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetNotificationDocument = `
    query getNotification($userCode: String!) {
  getNotification(userCode: $userCode) {
    edges {
      node {
        no
        type
        subject
        message
        createDate
        updateDate
      }
    }
  }
}
    `;
export const useGetNotificationQuery = <
      TData = GetNotificationQuery,
      TError = unknown
    >(
      variables: GetNotificationQueryVariables,
      options?: UseQueryOptions<GetNotificationQuery, TError, TData>
    ) =>
    useQuery<GetNotificationQuery, TError, TData>(
      ['getNotification', variables],
      useFetchData<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument).bind(null, variables),
      options
    );

useGetNotificationQuery.getKey = (variables: GetNotificationQueryVariables) => ['getNotification', variables];
;

export const useInfiniteGetNotificationQuery = <
      TData = GetNotificationQuery,
      TError = unknown
    >(
      variables: GetNotificationQueryVariables,
      options?: UseInfiniteQueryOptions<GetNotificationQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetNotificationQuery, TError, TData>(
      ['getNotification.infinite', variables],
      (metaData) => useFetchData<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchOrderNameDocument = `
    query searchOrderName($filter: SearchOrderNameFilter) {
  searchOrderName(filter: $filter) {
    userName
  }
}
    `;
export const useSearchOrderNameQuery = <
      TData = SearchOrderNameQuery,
      TError = unknown
    >(
      variables?: SearchOrderNameQueryVariables,
      options?: UseQueryOptions<SearchOrderNameQuery, TError, TData>
    ) =>
    useQuery<SearchOrderNameQuery, TError, TData>(
      variables === undefined ? ['searchOrderName'] : ['searchOrderName', variables],
      useFetchData<SearchOrderNameQuery, SearchOrderNameQueryVariables>(SearchOrderNameDocument).bind(null, variables),
      options
    );

useSearchOrderNameQuery.getKey = (variables?: SearchOrderNameQueryVariables) => variables === undefined ? ['searchOrderName'] : ['searchOrderName', variables];
;

export const useInfiniteSearchOrderNameQuery = <
      TData = SearchOrderNameQuery,
      TError = unknown
    >(
      variables?: SearchOrderNameQueryVariables,
      options?: UseInfiniteQueryOptions<SearchOrderNameQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchOrderNameQuery, TError, TData>(
      variables === undefined ? ['searchOrderName.infinite'] : ['searchOrderName.infinite', variables],
      (metaData) => useFetchData<SearchOrderNameQuery, SearchOrderNameQueryVariables>(SearchOrderNameDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveRemainByProductDocument = `
    query searchReceiveRemainByProduct($first: Int, $after: String, $filter: SearchReceiveRemainByProductFilter) {
  searchReceiveRemainByProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ReceiveRemainByProductFields
      }
    }
  }
}
    ${ReceiveRemainByProductFieldsFragmentDoc}`;
export const useSearchReceiveRemainByProductQuery = <
      TData = SearchReceiveRemainByProductQuery,
      TError = unknown
    >(
      variables?: SearchReceiveRemainByProductQueryVariables,
      options?: UseQueryOptions<SearchReceiveRemainByProductQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveRemainByProductQuery, TError, TData>(
      variables === undefined ? ['searchReceiveRemainByProduct'] : ['searchReceiveRemainByProduct', variables],
      useFetchData<SearchReceiveRemainByProductQuery, SearchReceiveRemainByProductQueryVariables>(SearchReceiveRemainByProductDocument).bind(null, variables),
      options
    );

useSearchReceiveRemainByProductQuery.getKey = (variables?: SearchReceiveRemainByProductQueryVariables) => variables === undefined ? ['searchReceiveRemainByProduct'] : ['searchReceiveRemainByProduct', variables];
;

export const useInfiniteSearchReceiveRemainByProductQuery = <
      TData = SearchReceiveRemainByProductQuery,
      TError = unknown
    >(
      variables?: SearchReceiveRemainByProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveRemainByProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveRemainByProductQuery, TError, TData>(
      variables === undefined ? ['searchReceiveRemainByProduct.infinite'] : ['searchReceiveRemainByProduct.infinite', variables],
      (metaData) => useFetchData<SearchReceiveRemainByProductQuery, SearchReceiveRemainByProductQueryVariables>(SearchReceiveRemainByProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSendRemainByProductDocument = `
    query searchSendRemainByProduct($first: Int, $after: String, $filter: SearchSendRemainByProductFilter) {
  searchSendRemainByProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SendRemainByProductFields
      }
    }
  }
}
    ${SendRemainByProductFieldsFragmentDoc}`;
export const useSearchSendRemainByProductQuery = <
      TData = SearchSendRemainByProductQuery,
      TError = unknown
    >(
      variables?: SearchSendRemainByProductQueryVariables,
      options?: UseQueryOptions<SearchSendRemainByProductQuery, TError, TData>
    ) =>
    useQuery<SearchSendRemainByProductQuery, TError, TData>(
      variables === undefined ? ['searchSendRemainByProduct'] : ['searchSendRemainByProduct', variables],
      useFetchData<SearchSendRemainByProductQuery, SearchSendRemainByProductQueryVariables>(SearchSendRemainByProductDocument).bind(null, variables),
      options
    );

useSearchSendRemainByProductQuery.getKey = (variables?: SearchSendRemainByProductQueryVariables) => variables === undefined ? ['searchSendRemainByProduct'] : ['searchSendRemainByProduct', variables];
;

export const useInfiniteSearchSendRemainByProductQuery = <
      TData = SearchSendRemainByProductQuery,
      TError = unknown
    >(
      variables?: SearchSendRemainByProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendRemainByProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendRemainByProductQuery, TError, TData>(
      variables === undefined ? ['searchSendRemainByProduct.infinite'] : ['searchSendRemainByProduct.infinite', variables],
      (metaData) => useFetchData<SearchSendRemainByProductQuery, SearchSendRemainByProductQueryVariables>(SearchSendRemainByProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const OutsourcerSalesFromIdDocument = `
    query outsourcerSalesFromId($id: ID!) {
  sales(id: $id) {
    ...SalesFieldsForOutsourcerSales
  }
}
    ${SalesFieldsForOutsourcerSalesFragmentDoc}`;
export const useOutsourcerSalesFromIdQuery = <
      TData = OutsourcerSalesFromIdQuery,
      TError = unknown
    >(
      variables: OutsourcerSalesFromIdQueryVariables,
      options?: UseQueryOptions<OutsourcerSalesFromIdQuery, TError, TData>
    ) =>
    useQuery<OutsourcerSalesFromIdQuery, TError, TData>(
      ['outsourcerSalesFromId', variables],
      useFetchData<OutsourcerSalesFromIdQuery, OutsourcerSalesFromIdQueryVariables>(OutsourcerSalesFromIdDocument).bind(null, variables),
      options
    );

useOutsourcerSalesFromIdQuery.getKey = (variables: OutsourcerSalesFromIdQueryVariables) => ['outsourcerSalesFromId', variables];
;

export const useInfiniteOutsourcerSalesFromIdQuery = <
      TData = OutsourcerSalesFromIdQuery,
      TError = unknown
    >(
      variables: OutsourcerSalesFromIdQueryVariables,
      options?: UseInfiniteQueryOptions<OutsourcerSalesFromIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<OutsourcerSalesFromIdQuery, TError, TData>(
      ['outsourcerSalesFromId.infinite', variables],
      (metaData) => useFetchData<OutsourcerSalesFromIdQuery, OutsourcerSalesFromIdQueryVariables>(OutsourcerSalesFromIdDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateOutsourcerSalesDocument = `
    mutation createOutsourcerSales($input: CreateOutsourcerSalesInput!) {
  createOutsourcerSales(input: $input) {
    sales {
      ...OutsourcerSalesMutationFields
    }
  }
}
    ${OutsourcerSalesMutationFieldsFragmentDoc}`;
export const useCreateOutsourcerSalesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOutsourcerSalesMutation, TError, CreateOutsourcerSalesMutationVariables, TContext>) =>
    useMutation<CreateOutsourcerSalesMutation, TError, CreateOutsourcerSalesMutationVariables, TContext>(
      'createOutsourcerSales',
      useFetchData<CreateOutsourcerSalesMutation, CreateOutsourcerSalesMutationVariables>(CreateOutsourcerSalesDocument),
      options
    );
export const UpdateOutsourcerSalesDocument = `
    mutation updateOutsourcerSales($input: UpdateOutsourcerSalesInput!) {
  updateOutsourcerSales(input: $input) {
    sales {
      ...OutsourcerSalesMutationFields
    }
  }
}
    ${OutsourcerSalesMutationFieldsFragmentDoc}`;
export const useUpdateOutsourcerSalesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOutsourcerSalesMutation, TError, UpdateOutsourcerSalesMutationVariables, TContext>) =>
    useMutation<UpdateOutsourcerSalesMutation, TError, UpdateOutsourcerSalesMutationVariables, TContext>(
      'updateOutsourcerSales',
      useFetchData<UpdateOutsourcerSalesMutation, UpdateOutsourcerSalesMutationVariables>(UpdateOutsourcerSalesDocument),
      options
    );
export const DeleteOutsourcerSalesDocument = `
    mutation deleteOutsourcerSales($input: DeleteOutsourcerSalesInput!) {
  deleteOutsourcerSales(input: $input) {
    sales {
      ...OutsourcerSalesMutationFields
    }
  }
}
    ${OutsourcerSalesMutationFieldsFragmentDoc}`;
export const useDeleteOutsourcerSalesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteOutsourcerSalesMutation, TError, DeleteOutsourcerSalesMutationVariables, TContext>) =>
    useMutation<DeleteOutsourcerSalesMutation, TError, DeleteOutsourcerSalesMutationVariables, TContext>(
      'deleteOutsourcerSales',
      useFetchData<DeleteOutsourcerSalesMutation, DeleteOutsourcerSalesMutationVariables>(DeleteOutsourcerSalesDocument),
      options
    );
export const SearchCustomerForOutsourcerSalesDocument = `
    query searchCustomerForOutsourcerSales($id: ID!) {
  customer(id: $id) {
    ...CustomerFieldsForOutsourcerSales
  }
}
    ${CustomerFieldsForOutsourcerSalesFragmentDoc}`;
export const useSearchCustomerForOutsourcerSalesQuery = <
      TData = SearchCustomerForOutsourcerSalesQuery,
      TError = unknown
    >(
      variables: SearchCustomerForOutsourcerSalesQueryVariables,
      options?: UseQueryOptions<SearchCustomerForOutsourcerSalesQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerForOutsourcerSalesQuery, TError, TData>(
      ['searchCustomerForOutsourcerSales', variables],
      useFetchData<SearchCustomerForOutsourcerSalesQuery, SearchCustomerForOutsourcerSalesQueryVariables>(SearchCustomerForOutsourcerSalesDocument).bind(null, variables),
      options
    );

useSearchCustomerForOutsourcerSalesQuery.getKey = (variables: SearchCustomerForOutsourcerSalesQueryVariables) => ['searchCustomerForOutsourcerSales', variables];
;

export const useInfiniteSearchCustomerForOutsourcerSalesQuery = <
      TData = SearchCustomerForOutsourcerSalesQuery,
      TError = unknown
    >(
      variables: SearchCustomerForOutsourcerSalesQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerForOutsourcerSalesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerForOutsourcerSalesQuery, TError, TData>(
      ['searchCustomerForOutsourcerSales.infinite', variables],
      (metaData) => useFetchData<SearchCustomerForOutsourcerSalesQuery, SearchCustomerForOutsourcerSalesQueryVariables>(SearchCustomerForOutsourcerSalesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetPartialQueryByProductDocument = `
    query getPartialQueryByProduct($filter: PartialQueryByProductFilter) {
  partialQueryByProduct(filter: $filter) {
    existsTrade
    terms
    initialStock
    initialOrder
    initialRemain
    currentInitialRemain
    results {
      ...PartialQueryDataFields
    }
    current {
      ...PartialQueryDataFields
    }
  }
}
    ${PartialQueryDataFieldsFragmentDoc}`;
export const useGetPartialQueryByProductQuery = <
      TData = GetPartialQueryByProductQuery,
      TError = unknown
    >(
      variables?: GetPartialQueryByProductQueryVariables,
      options?: UseQueryOptions<GetPartialQueryByProductQuery, TError, TData>
    ) =>
    useQuery<GetPartialQueryByProductQuery, TError, TData>(
      variables === undefined ? ['getPartialQueryByProduct'] : ['getPartialQueryByProduct', variables],
      useFetchData<GetPartialQueryByProductQuery, GetPartialQueryByProductQueryVariables>(GetPartialQueryByProductDocument).bind(null, variables),
      options
    );

useGetPartialQueryByProductQuery.getKey = (variables?: GetPartialQueryByProductQueryVariables) => variables === undefined ? ['getPartialQueryByProduct'] : ['getPartialQueryByProduct', variables];
;

export const useInfiniteGetPartialQueryByProductQuery = <
      TData = GetPartialQueryByProductQuery,
      TError = unknown
    >(
      variables?: GetPartialQueryByProductQueryVariables,
      options?: UseInfiniteQueryOptions<GetPartialQueryByProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetPartialQueryByProductQuery, TError, TData>(
      variables === undefined ? ['getPartialQueryByProduct.infinite'] : ['getPartialQueryByProduct.infinite', variables],
      (metaData) => useFetchData<GetPartialQueryByProductQuery, GetPartialQueryByProductQueryVariables>(GetPartialQueryByProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetPartialQueryByLotGroupDocument = `
    query getPartialQueryByLotGroup($filter: PartialQueryByLotGroupFilter) {
  partialQueryByLotGroup(filter: $filter) {
    existsTrade
    terms
    productCodes
    products {
      productCode
      productName
    }
    initialStock
    initialOrder
    initialRemain
    currentInitialRemain
    results {
      arrivalP3 {
        ...PartialQueryDataFields
      }
      arrivalP2 {
        ...PartialQueryDataFields
      }
      arrivalP1 {
        ...PartialQueryDataFields
      }
      shipmentP3 {
        ...PartialQueryDataFields
      }
      shipmentP2 {
        ...PartialQueryDataFields
      }
      shipmentP1 {
        ...PartialQueryDataFields
      }
      disposeP3 {
        ...PartialQueryDataFields
      }
      disposeP2 {
        ...PartialQueryDataFields
      }
      disposeP1 {
        ...PartialQueryDataFields
      }
      shipmentdisposeP3 {
        ...PartialQueryDataFields
      }
      shipmentdisposeP2 {
        ...PartialQueryDataFields
      }
      shipmentdisposeP1 {
        ...PartialQueryDataFields
      }
    }
    current {
      shipmentBefore {
        ...PartialQueryDataFields
      }
      shipmentFix {
        ...PartialQueryDataFields
      }
      stock {
        ...PartialQueryDataFields
      }
      sendorderSum {
        ...PartialQueryDataFields
      }
      arrivalSum {
        ...PartialQueryDataFields
      }
      sendorder {
        ...PartialQueryDataFields
      }
      sendorderRemain {
        ...PartialQueryDataFields
      }
      consumption {
        ...PartialQueryDataFields
      }
    }
  }
}
    ${PartialQueryDataFieldsFragmentDoc}`;
export const useGetPartialQueryByLotGroupQuery = <
      TData = GetPartialQueryByLotGroupQuery,
      TError = unknown
    >(
      variables?: GetPartialQueryByLotGroupQueryVariables,
      options?: UseQueryOptions<GetPartialQueryByLotGroupQuery, TError, TData>
    ) =>
    useQuery<GetPartialQueryByLotGroupQuery, TError, TData>(
      variables === undefined ? ['getPartialQueryByLotGroup'] : ['getPartialQueryByLotGroup', variables],
      useFetchData<GetPartialQueryByLotGroupQuery, GetPartialQueryByLotGroupQueryVariables>(GetPartialQueryByLotGroupDocument).bind(null, variables),
      options
    );

useGetPartialQueryByLotGroupQuery.getKey = (variables?: GetPartialQueryByLotGroupQueryVariables) => variables === undefined ? ['getPartialQueryByLotGroup'] : ['getPartialQueryByLotGroup', variables];
;

export const useInfiniteGetPartialQueryByLotGroupQuery = <
      TData = GetPartialQueryByLotGroupQuery,
      TError = unknown
    >(
      variables?: GetPartialQueryByLotGroupQueryVariables,
      options?: UseInfiniteQueryOptions<GetPartialQueryByLotGroupQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetPartialQueryByLotGroupQuery, TError, TData>(
      variables === undefined ? ['getPartialQueryByLotGroup.infinite'] : ['getPartialQueryByLotGroup.infinite', variables],
      (metaData) => useFetchData<GetPartialQueryByLotGroupQuery, GetPartialQueryByLotGroupQueryVariables>(GetPartialQueryByLotGroupDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPayableBalanceListDocument = `
    query searchPayableBalanceList($first: Int, $after: String, $filter: SearchPayableBalanceListFilter) {
  searchPayableBalanceList(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        vendorCode
        vendorName
        vendorFuri
        beforePayableBalance
        payablePrice
        expirationDate
        purchasePrice
        exciseTax10par
        exciseTax8par
        monthBalance
        cash
        transfer
        draft
        otherPayment
      }
    }
  }
}
    `;
export const useSearchPayableBalanceListQuery = <
      TData = SearchPayableBalanceListQuery,
      TError = unknown
    >(
      variables?: SearchPayableBalanceListQueryVariables,
      options?: UseQueryOptions<SearchPayableBalanceListQuery, TError, TData>
    ) =>
    useQuery<SearchPayableBalanceListQuery, TError, TData>(
      variables === undefined ? ['searchPayableBalanceList'] : ['searchPayableBalanceList', variables],
      useFetchData<SearchPayableBalanceListQuery, SearchPayableBalanceListQueryVariables>(SearchPayableBalanceListDocument).bind(null, variables),
      options
    );

useSearchPayableBalanceListQuery.getKey = (variables?: SearchPayableBalanceListQueryVariables) => variables === undefined ? ['searchPayableBalanceList'] : ['searchPayableBalanceList', variables];
;

export const useInfiniteSearchPayableBalanceListQuery = <
      TData = SearchPayableBalanceListQuery,
      TError = unknown
    >(
      variables?: SearchPayableBalanceListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPayableBalanceListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPayableBalanceListQuery, TError, TData>(
      variables === undefined ? ['searchPayableBalanceList.infinite'] : ['searchPayableBalanceList.infinite', variables],
      (metaData) => useFetchData<SearchPayableBalanceListQuery, SearchPayableBalanceListQueryVariables>(SearchPayableBalanceListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchVendorPaymentDocument = `
    query searchVendorPayment($first: Int, $after: String, $filter: SearchVendorPaymentFilter, $sort: [VendorSortEnum]) {
  searchVendorPayment(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        vendorCode
        vendorName
        vendorFuri
        closingDate
        createDate
        updateDate
        versionUuid
      }
    }
  }
}
    `;
export const useSearchVendorPaymentQuery = <
      TData = SearchVendorPaymentQuery,
      TError = unknown
    >(
      variables?: SearchVendorPaymentQueryVariables,
      options?: UseQueryOptions<SearchVendorPaymentQuery, TError, TData>
    ) =>
    useQuery<SearchVendorPaymentQuery, TError, TData>(
      variables === undefined ? ['searchVendorPayment'] : ['searchVendorPayment', variables],
      useFetchData<SearchVendorPaymentQuery, SearchVendorPaymentQueryVariables>(SearchVendorPaymentDocument).bind(null, variables),
      options
    );

useSearchVendorPaymentQuery.getKey = (variables?: SearchVendorPaymentQueryVariables) => variables === undefined ? ['searchVendorPayment'] : ['searchVendorPayment', variables];
;

export const useInfiniteSearchVendorPaymentQuery = <
      TData = SearchVendorPaymentQuery,
      TError = unknown
    >(
      variables?: SearchVendorPaymentQueryVariables,
      options?: UseInfiniteQueryOptions<SearchVendorPaymentQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchVendorPaymentQuery, TError, TData>(
      variables === undefined ? ['searchVendorPayment.infinite'] : ['searchVendorPayment.infinite', variables],
      (metaData) => useFetchData<SearchVendorPaymentQuery, SearchVendorPaymentQueryVariables>(SearchVendorPaymentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchClosedPaymentDocument = `
    query searchClosedPayment($first: Int, $after: String, $filter: SearchClosedPaymentFilter) {
  searchClosedPayment(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PaymentFields
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;
export const useSearchClosedPaymentQuery = <
      TData = SearchClosedPaymentQuery,
      TError = unknown
    >(
      variables?: SearchClosedPaymentQueryVariables,
      options?: UseQueryOptions<SearchClosedPaymentQuery, TError, TData>
    ) =>
    useQuery<SearchClosedPaymentQuery, TError, TData>(
      variables === undefined ? ['searchClosedPayment'] : ['searchClosedPayment', variables],
      useFetchData<SearchClosedPaymentQuery, SearchClosedPaymentQueryVariables>(SearchClosedPaymentDocument).bind(null, variables),
      options
    );

useSearchClosedPaymentQuery.getKey = (variables?: SearchClosedPaymentQueryVariables) => variables === undefined ? ['searchClosedPayment'] : ['searchClosedPayment', variables];
;

export const useInfiniteSearchClosedPaymentQuery = <
      TData = SearchClosedPaymentQuery,
      TError = unknown
    >(
      variables?: SearchClosedPaymentQueryVariables,
      options?: UseInfiniteQueryOptions<SearchClosedPaymentQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchClosedPaymentQuery, TError, TData>(
      variables === undefined ? ['searchClosedPayment.infinite'] : ['searchClosedPayment.infinite', variables],
      (metaData) => useFetchData<SearchClosedPaymentQuery, SearchClosedPaymentQueryVariables>(SearchClosedPaymentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const PaymentDocument = `
    query Payment($id: ID!) {
  payment(id: $id) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;
export const usePaymentQuery = <
      TData = PaymentQuery,
      TError = unknown
    >(
      variables: PaymentQueryVariables,
      options?: UseQueryOptions<PaymentQuery, TError, TData>
    ) =>
    useQuery<PaymentQuery, TError, TData>(
      ['Payment', variables],
      useFetchData<PaymentQuery, PaymentQueryVariables>(PaymentDocument).bind(null, variables),
      options
    );

usePaymentQuery.getKey = (variables: PaymentQueryVariables) => ['Payment', variables];
;

export const useInfinitePaymentQuery = <
      TData = PaymentQuery,
      TError = unknown
    >(
      variables: PaymentQueryVariables,
      options?: UseInfiniteQueryOptions<PaymentQuery, TError, TData>
    ) =>
    useInfiniteQuery<PaymentQuery, TError, TData>(
      ['Payment.infinite', variables],
      (metaData) => useFetchData<PaymentQuery, PaymentQueryVariables>(PaymentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPaymentHistoryDocument = `
    query searchPaymentHistory($first: Int, $after: String, $filter: SearchPaymentHistoryFilter, $sort: [PaymentSortEnum]) {
  searchPaymentHistory(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PaymentFields
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;
export const useSearchPaymentHistoryQuery = <
      TData = SearchPaymentHistoryQuery,
      TError = unknown
    >(
      variables?: SearchPaymentHistoryQueryVariables,
      options?: UseQueryOptions<SearchPaymentHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchPaymentHistoryQuery, TError, TData>(
      variables === undefined ? ['searchPaymentHistory'] : ['searchPaymentHistory', variables],
      useFetchData<SearchPaymentHistoryQuery, SearchPaymentHistoryQueryVariables>(SearchPaymentHistoryDocument).bind(null, variables),
      options
    );

useSearchPaymentHistoryQuery.getKey = (variables?: SearchPaymentHistoryQueryVariables) => variables === undefined ? ['searchPaymentHistory'] : ['searchPaymentHistory', variables];
;

export const useInfiniteSearchPaymentHistoryQuery = <
      TData = SearchPaymentHistoryQuery,
      TError = unknown
    >(
      variables?: SearchPaymentHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPaymentHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPaymentHistoryQuery, TError, TData>(
      variables === undefined ? ['searchPaymentHistory.infinite'] : ['searchPaymentHistory.infinite', variables],
      (metaData) => useFetchData<SearchPaymentHistoryQuery, SearchPaymentHistoryQueryVariables>(SearchPaymentHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPaymentHistoryDetailDocument = `
    query searchPaymentHistoryDetail($first: Int, $after: String, $filter1: SearchPurchasePaymentDetailFilter, $filter2: SearchWithdrawalPaymentDetailFilter, $sort1: [PurchaseSortEnum], $sort2: [WithdrawalSortEnum]) {
  searchPurchasePaymentDetail(
    first: $first
    after: $after
    filter: $filter1
    sort: $sort1
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...PurchaseFields
      }
    }
  }
  searchWithdrawalPaymentDetail(
    first: $first
    after: $after
    filter: $filter2
    sort: $sort2
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WithdrawalFields
      }
    }
  }
}
    ${PurchaseFieldsFragmentDoc}
${WithdrawalFieldsFragmentDoc}`;
export const useSearchPaymentHistoryDetailQuery = <
      TData = SearchPaymentHistoryDetailQuery,
      TError = unknown
    >(
      variables?: SearchPaymentHistoryDetailQueryVariables,
      options?: UseQueryOptions<SearchPaymentHistoryDetailQuery, TError, TData>
    ) =>
    useQuery<SearchPaymentHistoryDetailQuery, TError, TData>(
      variables === undefined ? ['searchPaymentHistoryDetail'] : ['searchPaymentHistoryDetail', variables],
      useFetchData<SearchPaymentHistoryDetailQuery, SearchPaymentHistoryDetailQueryVariables>(SearchPaymentHistoryDetailDocument).bind(null, variables),
      options
    );

useSearchPaymentHistoryDetailQuery.getKey = (variables?: SearchPaymentHistoryDetailQueryVariables) => variables === undefined ? ['searchPaymentHistoryDetail'] : ['searchPaymentHistoryDetail', variables];
;

export const useInfiniteSearchPaymentHistoryDetailQuery = <
      TData = SearchPaymentHistoryDetailQuery,
      TError = unknown
    >(
      variables?: SearchPaymentHistoryDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPaymentHistoryDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPaymentHistoryDetailQuery, TError, TData>(
      variables === undefined ? ['searchPaymentHistoryDetail.infinite'] : ['searchPaymentHistoryDetail.infinite', variables],
      (metaData) => useFetchData<SearchPaymentHistoryDetailQuery, SearchPaymentHistoryDetailQueryVariables>(SearchPaymentHistoryDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreatePaymentDocument = `
    mutation createPayment($input: CreatePaymentInput!) {
  createPayment(input: $input) {
    payment {
      paymentId
      versionUuid
    }
  }
}
    `;
export const useCreatePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>) =>
    useMutation<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>(
      'createPayment',
      useFetchData<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument),
      options
    );
export const DeletePaymentDocument = `
    mutation deletePayment($input: DeletePaymentInput!) {
  deletePayment(input: $input) {
    payment {
      paymentId
      versionUuid
    }
  }
}
    `;
export const useDeletePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePaymentMutation, TError, DeletePaymentMutationVariables, TContext>) =>
    useMutation<DeletePaymentMutation, TError, DeletePaymentMutationVariables, TContext>(
      'deletePayment',
      useFetchData<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument),
      options
    );
export const UpsertPaymentTaxAdjustListDocument = `
    mutation upsertPaymentTaxAdjustList($input: UpsertPaymentTaxAdjustListInput!) {
  upsertPaymentTaxAdjustList(input: $input) {
    paymentTaxAdjustDetail {
      paymentId
      versionUuid
    }
  }
}
    `;
export const useUpsertPaymentTaxAdjustListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertPaymentTaxAdjustListMutation, TError, UpsertPaymentTaxAdjustListMutationVariables, TContext>) =>
    useMutation<UpsertPaymentTaxAdjustListMutation, TError, UpsertPaymentTaxAdjustListMutationVariables, TContext>(
      'upsertPaymentTaxAdjustList',
      useFetchData<UpsertPaymentTaxAdjustListMutation, UpsertPaymentTaxAdjustListMutationVariables>(UpsertPaymentTaxAdjustListDocument),
      options
    );
export const DeletePaymentTaxAdjustListDocument = `
    mutation deletePaymentTaxAdjustList($input: DeletePaymentTaxAdjustListInput!) {
  deletePaymentTaxAdjustList(input: $input) {
    paymentTaxAdjustDetail {
      paymentId
      versionUuid
    }
  }
}
    `;
export const useDeletePaymentTaxAdjustListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePaymentTaxAdjustListMutation, TError, DeletePaymentTaxAdjustListMutationVariables, TContext>) =>
    useMutation<DeletePaymentTaxAdjustListMutation, TError, DeletePaymentTaxAdjustListMutationVariables, TContext>(
      'deletePaymentTaxAdjustList',
      useFetchData<DeletePaymentTaxAdjustListMutation, DeletePaymentTaxAdjustListMutationVariables>(DeletePaymentTaxAdjustListDocument),
      options
    );
export const SearchPaymentDivisionDocument = `
    query searchPaymentDivision($first: Int, $after: String, $filter: SearchPaymentDivisionFilter, $sort: [PaymentDivisionSortEnum]) {
  searchPaymentDivision(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PaymentDivisionFields
      }
    }
  }
}
    ${PaymentDivisionFieldsFragmentDoc}`;
export const useSearchPaymentDivisionQuery = <
      TData = SearchPaymentDivisionQuery,
      TError = unknown
    >(
      variables?: SearchPaymentDivisionQueryVariables,
      options?: UseQueryOptions<SearchPaymentDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchPaymentDivisionQuery, TError, TData>(
      variables === undefined ? ['searchPaymentDivision'] : ['searchPaymentDivision', variables],
      useFetchData<SearchPaymentDivisionQuery, SearchPaymentDivisionQueryVariables>(SearchPaymentDivisionDocument).bind(null, variables),
      options
    );

useSearchPaymentDivisionQuery.getKey = (variables?: SearchPaymentDivisionQueryVariables) => variables === undefined ? ['searchPaymentDivision'] : ['searchPaymentDivision', variables];
;

export const useInfiniteSearchPaymentDivisionQuery = <
      TData = SearchPaymentDivisionQuery,
      TError = unknown
    >(
      variables?: SearchPaymentDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPaymentDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPaymentDivisionQuery, TError, TData>(
      variables === undefined ? ['searchPaymentDivision.infinite'] : ['searchPaymentDivision.infinite', variables],
      (metaData) => useFetchData<SearchPaymentDivisionQuery, SearchPaymentDivisionQueryVariables>(SearchPaymentDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const GetPlannigDesignUserDocument = `
    query getPlannigDesignUser {
  allPlanningUser {
    edges {
      node {
        planningUserCode
        planningUserName
        delFlg
      }
    }
  }
  allDesignUser {
    edges {
      node {
        designUserCode
        designUserName
        delFlg
      }
    }
  }
}
    `;
export const useGetPlannigDesignUserQuery = <
      TData = GetPlannigDesignUserQuery,
      TError = unknown
    >(
      variables?: GetPlannigDesignUserQueryVariables,
      options?: UseQueryOptions<GetPlannigDesignUserQuery, TError, TData>
    ) =>
    useQuery<GetPlannigDesignUserQuery, TError, TData>(
      variables === undefined ? ['getPlannigDesignUser'] : ['getPlannigDesignUser', variables],
      useFetchData<GetPlannigDesignUserQuery, GetPlannigDesignUserQueryVariables>(GetPlannigDesignUserDocument).bind(null, variables),
      options
    );

useGetPlannigDesignUserQuery.getKey = (variables?: GetPlannigDesignUserQueryVariables) => variables === undefined ? ['getPlannigDesignUser'] : ['getPlannigDesignUser', variables];
;

export const useInfiniteGetPlannigDesignUserQuery = <
      TData = GetPlannigDesignUserQuery,
      TError = unknown
    >(
      variables?: GetPlannigDesignUserQueryVariables,
      options?: UseInfiniteQueryOptions<GetPlannigDesignUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetPlannigDesignUserQuery, TError, TData>(
      variables === undefined ? ['getPlannigDesignUser.infinite'] : ['getPlannigDesignUser.infinite', variables],
      (metaData) => useFetchData<GetPlannigDesignUserQuery, GetPlannigDesignUserQueryVariables>(GetPlannigDesignUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const EstimatePrintDocument = `
    mutation estimatePrint($input: EstimatePrintInput!) {
  estimatePrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useEstimatePrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EstimatePrintMutation, TError, EstimatePrintMutationVariables, TContext>) =>
    useMutation<EstimatePrintMutation, TError, EstimatePrintMutationVariables, TContext>(
      'estimatePrint',
      useFetchData<EstimatePrintMutation, EstimatePrintMutationVariables>(EstimatePrintDocument),
      options
    );
export const SearchReportLayoutDocument = `
    query searchReportLayout($reportLayoutDivision: String!, $reportLayoutTypeCodes: [String]) {
  searchReportLayout(
    filter: {reportLayoutDivision: $reportLayoutDivision, reportLayoutTypeCodes: $reportLayoutTypeCodes}
  ) {
    edges {
      node {
        reportLayoutCode
        reportLayoutName
        activeReportFlg
        offsetFlg
        offsetX
        offsetY
      }
    }
  }
}
    `;
export const useSearchReportLayoutQuery = <
      TData = SearchReportLayoutQuery,
      TError = unknown
    >(
      variables: SearchReportLayoutQueryVariables,
      options?: UseQueryOptions<SearchReportLayoutQuery, TError, TData>
    ) =>
    useQuery<SearchReportLayoutQuery, TError, TData>(
      ['searchReportLayout', variables],
      useFetchData<SearchReportLayoutQuery, SearchReportLayoutQueryVariables>(SearchReportLayoutDocument).bind(null, variables),
      options
    );

useSearchReportLayoutQuery.getKey = (variables: SearchReportLayoutQueryVariables) => ['searchReportLayout', variables];
;

export const useInfiniteSearchReportLayoutQuery = <
      TData = SearchReportLayoutQuery,
      TError = unknown
    >(
      variables: SearchReportLayoutQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReportLayoutQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReportLayoutQuery, TError, TData>(
      ['searchReportLayout.infinite', variables],
      (metaData) => useFetchData<SearchReportLayoutQuery, SearchReportLayoutQueryVariables>(SearchReportLayoutDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const DemandPrintDocument = `
    mutation demandPrint($input: DemandPrintInput!) {
  demandPrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useDemandPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DemandPrintMutation, TError, DemandPrintMutationVariables, TContext>) =>
    useMutation<DemandPrintMutation, TError, DemandPrintMutationVariables, TContext>(
      'demandPrint',
      useFetchData<DemandPrintMutation, DemandPrintMutationVariables>(DemandPrintDocument),
      options
    );
export const BulkDemandPrintDocument = `
    mutation bulkDemandPrint($input: BulkDemandPrintInput!) {
  bulkDemandPrint(input: $input) {
    location
    artifactId
    pages
    base64
  }
}
    `;
export const useBulkDemandPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkDemandPrintMutation, TError, BulkDemandPrintMutationVariables, TContext>) =>
    useMutation<BulkDemandPrintMutation, TError, BulkDemandPrintMutationVariables, TContext>(
      'bulkDemandPrint',
      useFetchData<BulkDemandPrintMutation, BulkDemandPrintMutationVariables>(BulkDemandPrintDocument),
      options
    );
export const ReceiveOrderPrintDocument = `
    mutation receiveOrderPrint($input: ReceiveOrderPrintInput!) {
  receiveOrderPrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useReceiveOrderPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReceiveOrderPrintMutation, TError, ReceiveOrderPrintMutationVariables, TContext>) =>
    useMutation<ReceiveOrderPrintMutation, TError, ReceiveOrderPrintMutationVariables, TContext>(
      'receiveOrderPrint',
      useFetchData<ReceiveOrderPrintMutation, ReceiveOrderPrintMutationVariables>(ReceiveOrderPrintDocument),
      options
    );
export const SaleVoucherPrintDocument = `
    mutation saleVoucherPrint($input: SaleVoucherPrintInput!) {
  saleVoucherPrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useSaleVoucherPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaleVoucherPrintMutation, TError, SaleVoucherPrintMutationVariables, TContext>) =>
    useMutation<SaleVoucherPrintMutation, TError, SaleVoucherPrintMutationVariables, TContext>(
      'saleVoucherPrint',
      useFetchData<SaleVoucherPrintMutation, SaleVoucherPrintMutationVariables>(SaleVoucherPrintDocument),
      options
    );
export const SendOrderPrintDocument = `
    mutation sendOrderPrint($input: SendOrderPrintInput!) {
  sendOrderPrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useSendOrderPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendOrderPrintMutation, TError, SendOrderPrintMutationVariables, TContext>) =>
    useMutation<SendOrderPrintMutation, TError, SendOrderPrintMutationVariables, TContext>(
      'sendOrderPrint',
      useFetchData<SendOrderPrintMutation, SendOrderPrintMutationVariables>(SendOrderPrintDocument),
      options
    );
export const TrustSalesPrintDocument = `
    mutation trustSalesPrint($input: TrustSaleVoucherPrintInput!) {
  trustSalesPrint(input: $input) {
    location
    artifactId
    pages
  }
}
    `;
export const useTrustSalesPrintMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrustSalesPrintMutation, TError, TrustSalesPrintMutationVariables, TContext>) =>
    useMutation<TrustSalesPrintMutation, TError, TrustSalesPrintMutationVariables, TContext>(
      'trustSalesPrint',
      useFetchData<TrustSalesPrintMutation, TrustSalesPrintMutationVariables>(TrustSalesPrintDocument),
      options
    );
export const GetSvfAccessTokenDocument = `
    query getSvfAccessToken {
  svfAccessToken
}
    `;
export const useGetSvfAccessTokenQuery = <
      TData = GetSvfAccessTokenQuery,
      TError = unknown
    >(
      variables?: GetSvfAccessTokenQueryVariables,
      options?: UseQueryOptions<GetSvfAccessTokenQuery, TError, TData>
    ) =>
    useQuery<GetSvfAccessTokenQuery, TError, TData>(
      variables === undefined ? ['getSvfAccessToken'] : ['getSvfAccessToken', variables],
      useFetchData<GetSvfAccessTokenQuery, GetSvfAccessTokenQueryVariables>(GetSvfAccessTokenDocument).bind(null, variables),
      options
    );

useGetSvfAccessTokenQuery.getKey = (variables?: GetSvfAccessTokenQueryVariables) => variables === undefined ? ['getSvfAccessToken'] : ['getSvfAccessToken', variables];
;

export const useInfiniteGetSvfAccessTokenQuery = <
      TData = GetSvfAccessTokenQuery,
      TError = unknown
    >(
      variables?: GetSvfAccessTokenQueryVariables,
      options?: UseInfiniteQueryOptions<GetSvfAccessTokenQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetSvfAccessTokenQuery, TError, TData>(
      variables === undefined ? ['getSvfAccessToken.infinite'] : ['getSvfAccessToken.infinite', variables],
      (metaData) => useFetchData<GetSvfAccessTokenQuery, GetSvfAccessTokenQueryVariables>(GetSvfAccessTokenDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ProductDocument = `
    query product($id: ID!) {
  product(id: $id) {
    versionUuid
    uniqueCode
    janCode
    productName
    productFuri
    unitCode
    receiveOrderLot
    maxPurchaseOrderQty
    quantityDecimalDigits
    unitYenDecimalDigits
    unitDollarDecimalDigits
    taxationDivision
    purchaseOrderLeadTime
    vendorCode
    domOverFlg
    countryCode
    manufacturer
    componentDivision
    productGroupId1
    productGroupId2
    productGroupId3
    clothGroup
    material
    inventoryControlFlg
    notIncludedSku
    planningUserCode
    designUserCode
    tags
    delFlg
    updateDate
    productVariants {
      edges {
        node {
          productCode
          uniqueCode
          divisionCode
          attrNo
          branchNumber
          attributeName
          divisionStandardStock
          purchaseOrderStandardStock
          baseStockQuantity
          lotGroupCode
          minimumLot
          firstArrivalDate
          fcCode1
          fcCode2
          fcCode3
          fcCodeBranchNumber1
          fcCodeBranchNumber2
          fcCodeBranchNumber3
          productAttrMemo
          productBodySize
          productBodyWeight
          productPackageSize
          productPackageWeight
          innerCartonSize
          innerCartonWeight
          innerCartonUnit
          outerCartonWidth
          outerCartonHeight
          outerCartonDept
          outerCartonWeight
          outerCartonUnit
          attr1
          attr2
          discontinueFlg
          delFlg
          division {
            divisionCode
            divisionName
          }
          publicationOption
          productImage1
          productImage2
          productImage3
          productImage4
          productImage5
          productImage6
          endOfSalesDate
        }
      }
    }
    vendor {
      vendorCode
      vendorName
    }
    productGroup1 {
      productGroupId
      productGroupCode
      productGroupName
    }
    productGroup2 {
      productGroupId
      productGroupCode
      productGroupName
    }
    productGroup3 {
      productGroupId
      productGroupCode
      productGroupName
    }
    productPrice {
      edges {
        node {
          uniqueCode
          retailPrice
          salesUnitPrice
          purchaseUnitPriceYen
          purchaseUnitPriceDollar
          startDate
          endDate
        }
      }
    }
  }
}
    `;
export const useProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options?: UseQueryOptions<ProductQuery, TError, TData>
    ) =>
    useQuery<ProductQuery, TError, TData>(
      ['product', variables],
      useFetchData<ProductQuery, ProductQueryVariables>(ProductDocument).bind(null, variables),
      options
    );

useProductQuery.getKey = (variables: ProductQueryVariables) => ['product', variables];
;

export const useInfiniteProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options?: UseInfiniteQueryOptions<ProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProductQuery, TError, TData>(
      ['product.infinite', variables],
      (metaData) => useFetchData<ProductQuery, ProductQueryVariables>(ProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateProductDocument = `
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    product {
      uniqueCode
      janCode
    }
  }
}
    `;
export const useCreateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductMutation, TError, CreateProductMutationVariables, TContext>) =>
    useMutation<CreateProductMutation, TError, CreateProductMutationVariables, TContext>(
      'createProduct',
      useFetchData<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument),
      options
    );
export const UpdateProductDocument = `
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      uniqueCode
    }
  }
}
    `;
export const useUpdateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>) =>
    useMutation<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>(
      'updateProduct',
      useFetchData<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument),
      options
    );
export const DeleteProductDocument = `
    mutation deleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input) {
    product {
      uniqueCode
    }
  }
}
    `;
export const useDeleteProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProductMutation, TError, DeleteProductMutationVariables, TContext>) =>
    useMutation<DeleteProductMutation, TError, DeleteProductMutationVariables, TContext>(
      'deleteProduct',
      useFetchData<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument),
      options
    );
export const SearchProductPriceDocument = `
    query searchProductPrice($filter: SearchProductPriceFilter) {
  searchProductPrice(filter: $filter) {
    edges {
      node {
        uniqueCode
        retailPrice
        salesUnitPrice
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        startDate
        endDate
      }
    }
  }
}
    `;
export const useSearchProductPriceQuery = <
      TData = SearchProductPriceQuery,
      TError = unknown
    >(
      variables?: SearchProductPriceQueryVariables,
      options?: UseQueryOptions<SearchProductPriceQuery, TError, TData>
    ) =>
    useQuery<SearchProductPriceQuery, TError, TData>(
      variables === undefined ? ['searchProductPrice'] : ['searchProductPrice', variables],
      useFetchData<SearchProductPriceQuery, SearchProductPriceQueryVariables>(SearchProductPriceDocument).bind(null, variables),
      options
    );

useSearchProductPriceQuery.getKey = (variables?: SearchProductPriceQueryVariables) => variables === undefined ? ['searchProductPrice'] : ['searchProductPrice', variables];
;

export const useInfiniteSearchProductPriceQuery = <
      TData = SearchProductPriceQuery,
      TError = unknown
    >(
      variables?: SearchProductPriceQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductPriceQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductPriceQuery, TError, TData>(
      variables === undefined ? ['searchProductPrice.infinite'] : ['searchProductPrice.infinite', variables],
      (metaData) => useFetchData<SearchProductPriceQuery, SearchProductPriceQueryVariables>(SearchProductPriceDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductPriceFromTargetDateDocument = `
    query searchProductPriceFromTargetDate($filter: SearchProductPriceFromTargetDateFilter) {
  searchProductPriceFromTargetDate(filter: $filter) {
    edges {
      node {
        uniqueCode
        retailPrice
        salesUnitPrice
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        startDate
        endDate
      }
    }
  }
}
    `;
export const useSearchProductPriceFromTargetDateQuery = <
      TData = SearchProductPriceFromTargetDateQuery,
      TError = unknown
    >(
      variables?: SearchProductPriceFromTargetDateQueryVariables,
      options?: UseQueryOptions<SearchProductPriceFromTargetDateQuery, TError, TData>
    ) =>
    useQuery<SearchProductPriceFromTargetDateQuery, TError, TData>(
      variables === undefined ? ['searchProductPriceFromTargetDate'] : ['searchProductPriceFromTargetDate', variables],
      useFetchData<SearchProductPriceFromTargetDateQuery, SearchProductPriceFromTargetDateQueryVariables>(SearchProductPriceFromTargetDateDocument).bind(null, variables),
      options
    );

useSearchProductPriceFromTargetDateQuery.getKey = (variables?: SearchProductPriceFromTargetDateQueryVariables) => variables === undefined ? ['searchProductPriceFromTargetDate'] : ['searchProductPriceFromTargetDate', variables];
;

export const useInfiniteSearchProductPriceFromTargetDateQuery = <
      TData = SearchProductPriceFromTargetDateQuery,
      TError = unknown
    >(
      variables?: SearchProductPriceFromTargetDateQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductPriceFromTargetDateQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductPriceFromTargetDateQuery, TError, TData>(
      variables === undefined ? ['searchProductPriceFromTargetDate.infinite'] : ['searchProductPriceFromTargetDate.infinite', variables],
      (metaData) => useFetchData<SearchProductPriceFromTargetDateQuery, SearchProductPriceFromTargetDateQueryVariables>(SearchProductPriceFromTargetDateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ProductGroupDocument = `
    query ProductGroup($id: ID!) {
  productGroup(id: $id) {
    ...ProductGroupFields
  }
}
    ${ProductGroupFieldsFragmentDoc}`;
export const useProductGroupQuery = <
      TData = ProductGroupQuery,
      TError = unknown
    >(
      variables: ProductGroupQueryVariables,
      options?: UseQueryOptions<ProductGroupQuery, TError, TData>
    ) =>
    useQuery<ProductGroupQuery, TError, TData>(
      ['ProductGroup', variables],
      useFetchData<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument).bind(null, variables),
      options
    );

useProductGroupQuery.getKey = (variables: ProductGroupQueryVariables) => ['ProductGroup', variables];
;

export const useInfiniteProductGroupQuery = <
      TData = ProductGroupQuery,
      TError = unknown
    >(
      variables: ProductGroupQueryVariables,
      options?: UseInfiniteQueryOptions<ProductGroupQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProductGroupQuery, TError, TData>(
      ['ProductGroup.infinite', variables],
      (metaData) => useFetchData<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const UpdateProductGroupDocument = `
    mutation updateProductGroup($input: UpdateProductGroupInput!) {
  updateProductGroup(input: $input) {
    clientMutationId
  }
}
    `;
export const useUpdateProductGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductGroupMutation, TError, UpdateProductGroupMutationVariables, TContext>) =>
    useMutation<UpdateProductGroupMutation, TError, UpdateProductGroupMutationVariables, TContext>(
      'updateProductGroup',
      useFetchData<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument),
      options
    );
export const SearchProductGroupDocument = `
    query searchProductGroup($first: Int, $after: String, $filter: SearchProductGroupFilter, $sort: [ProductGroupSortEnum]) {
  searchProductGroup(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ProductGroupFields
      }
    }
  }
}
    ${ProductGroupFieldsFragmentDoc}`;
export const useSearchProductGroupQuery = <
      TData = SearchProductGroupQuery,
      TError = unknown
    >(
      variables?: SearchProductGroupQueryVariables,
      options?: UseQueryOptions<SearchProductGroupQuery, TError, TData>
    ) =>
    useQuery<SearchProductGroupQuery, TError, TData>(
      variables === undefined ? ['searchProductGroup'] : ['searchProductGroup', variables],
      useFetchData<SearchProductGroupQuery, SearchProductGroupQueryVariables>(SearchProductGroupDocument).bind(null, variables),
      options
    );

useSearchProductGroupQuery.getKey = (variables?: SearchProductGroupQueryVariables) => variables === undefined ? ['searchProductGroup'] : ['searchProductGroup', variables];
;

export const useInfiniteSearchProductGroupQuery = <
      TData = SearchProductGroupQuery,
      TError = unknown
    >(
      variables?: SearchProductGroupQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductGroupQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductGroupQuery, TError, TData>(
      variables === undefined ? ['searchProductGroup.infinite'] : ['searchProductGroup.infinite', variables],
      (metaData) => useFetchData<SearchProductGroupQuery, SearchProductGroupQueryVariables>(SearchProductGroupDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductUpdateHistoryDocument = `
    query searchProductUpdateHistory($first: Int, $after: String, $filter1: SearchProductHistoryFilter, $filter2: SearchProductFromUniqueCodeFilter, $sort1: [ProductHistorySortEnum], $sort2: [ProductSortEnum]) {
  searchProductHistory(
    first: $first
    after: $after
    filter: $filter1
    sort: $sort1
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ProductHistoryFields
      }
    }
  }
  searchProductFromUniqueCode(
    first: $first
    after: $after
    filter: $filter2
    sort: $sort2
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        uniqueCode
        janCode
        productName
      }
    }
  }
}
    ${ProductHistoryFieldsFragmentDoc}`;
export const useSearchProductUpdateHistoryQuery = <
      TData = SearchProductUpdateHistoryQuery,
      TError = unknown
    >(
      variables?: SearchProductUpdateHistoryQueryVariables,
      options?: UseQueryOptions<SearchProductUpdateHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchProductUpdateHistoryQuery, TError, TData>(
      variables === undefined ? ['searchProductUpdateHistory'] : ['searchProductUpdateHistory', variables],
      useFetchData<SearchProductUpdateHistoryQuery, SearchProductUpdateHistoryQueryVariables>(SearchProductUpdateHistoryDocument).bind(null, variables),
      options
    );

useSearchProductUpdateHistoryQuery.getKey = (variables?: SearchProductUpdateHistoryQueryVariables) => variables === undefined ? ['searchProductUpdateHistory'] : ['searchProductUpdateHistory', variables];
;

export const useInfiniteSearchProductUpdateHistoryQuery = <
      TData = SearchProductUpdateHistoryQuery,
      TError = unknown
    >(
      variables?: SearchProductUpdateHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductUpdateHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductUpdateHistoryQuery, TError, TData>(
      variables === undefined ? ['searchProductUpdateHistory.infinite'] : ['searchProductUpdateHistory.infinite', variables],
      (metaData) => useFetchData<SearchProductUpdateHistoryQuery, SearchProductUpdateHistoryQueryVariables>(SearchProductUpdateHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductListViewDocument = `
    query searchProductListView($first: Int, $after: String, $filter: SearchProductListViewFilter, $sort: [ProductListViewSortEnum]) {
  searchProductListView(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ProductListViewFields
      }
    }
  }
}
    ${ProductListViewFieldsFragmentDoc}`;
export const useSearchProductListViewQuery = <
      TData = SearchProductListViewQuery,
      TError = unknown
    >(
      variables?: SearchProductListViewQueryVariables,
      options?: UseQueryOptions<SearchProductListViewQuery, TError, TData>
    ) =>
    useQuery<SearchProductListViewQuery, TError, TData>(
      variables === undefined ? ['searchProductListView'] : ['searchProductListView', variables],
      useFetchData<SearchProductListViewQuery, SearchProductListViewQueryVariables>(SearchProductListViewDocument).bind(null, variables),
      options
    );

useSearchProductListViewQuery.getKey = (variables?: SearchProductListViewQueryVariables) => variables === undefined ? ['searchProductListView'] : ['searchProductListView', variables];
;

export const useInfiniteSearchProductListViewQuery = <
      TData = SearchProductListViewQuery,
      TError = unknown
    >(
      variables?: SearchProductListViewQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductListViewQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductListViewQuery, TError, TData>(
      variables === undefined ? ['searchProductListView.infinite'] : ['searchProductListView.infinite', variables],
      (metaData) => useFetchData<SearchProductListViewQuery, SearchProductListViewQueryVariables>(SearchProductListViewDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductViewDocument = `
    query searchProductView($first: Int, $after: String, $filter: SearchProductViewFilter, $sort: [ProductViewSortEnum]) {
  searchProductView(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ProductViewFields
      }
    }
  }
}
    ${ProductViewFieldsFragmentDoc}`;
export const useSearchProductViewQuery = <
      TData = SearchProductViewQuery,
      TError = unknown
    >(
      variables?: SearchProductViewQueryVariables,
      options?: UseQueryOptions<SearchProductViewQuery, TError, TData>
    ) =>
    useQuery<SearchProductViewQuery, TError, TData>(
      variables === undefined ? ['searchProductView'] : ['searchProductView', variables],
      useFetchData<SearchProductViewQuery, SearchProductViewQueryVariables>(SearchProductViewDocument).bind(null, variables),
      options
    );

useSearchProductViewQuery.getKey = (variables?: SearchProductViewQueryVariables) => variables === undefined ? ['searchProductView'] : ['searchProductView', variables];
;

export const useInfiniteSearchProductViewQuery = <
      TData = SearchProductViewQuery,
      TError = unknown
    >(
      variables?: SearchProductViewQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductViewQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductViewQuery, TError, TData>(
      variables === undefined ? ['searchProductView.infinite'] : ['searchProductView.infinite', variables],
      (metaData) => useFetchData<SearchProductViewQuery, SearchProductViewQueryVariables>(SearchProductViewDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ProductViewDocument = `
    query productView($id: ID!) {
  productView(id: $id) {
    ...ProductViewFromIdFields
  }
}
    ${ProductViewFromIdFieldsFragmentDoc}`;
export const useProductViewQuery = <
      TData = ProductViewQuery,
      TError = unknown
    >(
      variables: ProductViewQueryVariables,
      options?: UseQueryOptions<ProductViewQuery, TError, TData>
    ) =>
    useQuery<ProductViewQuery, TError, TData>(
      ['productView', variables],
      useFetchData<ProductViewQuery, ProductViewQueryVariables>(ProductViewDocument).bind(null, variables),
      options
    );

useProductViewQuery.getKey = (variables: ProductViewQueryVariables) => ['productView', variables];
;

export const useInfiniteProductViewQuery = <
      TData = ProductViewQuery,
      TError = unknown
    >(
      variables: ProductViewQueryVariables,
      options?: UseInfiniteQueryOptions<ProductViewQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProductViewQuery, TError, TData>(
      ['productView.infinite', variables],
      (metaData) => useFetchData<ProductViewQuery, ProductViewQueryVariables>(ProductViewDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ProductImportDocument = `
    mutation productImport($input: ProductImportInput!) {
  productImport(input: $input) {
    product {
      uniqueCode
      janCode
    }
  }
}
    `;
export const useProductImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ProductImportMutation, TError, ProductImportMutationVariables, TContext>) =>
    useMutation<ProductImportMutation, TError, ProductImportMutationVariables, TContext>(
      'productImport',
      useFetchData<ProductImportMutation, ProductImportMutationVariables>(ProductImportDocument),
      options
    );
export const ProductionDocument = `
    query production($id: ID!) {
  production(id: $id) {
    ...ProductionFields
  }
}
    ${ProductionFieldsFragmentDoc}`;
export const useProductionQuery = <
      TData = ProductionQuery,
      TError = unknown
    >(
      variables: ProductionQueryVariables,
      options?: UseQueryOptions<ProductionQuery, TError, TData>
    ) =>
    useQuery<ProductionQuery, TError, TData>(
      ['production', variables],
      useFetchData<ProductionQuery, ProductionQueryVariables>(ProductionDocument).bind(null, variables),
      options
    );

useProductionQuery.getKey = (variables: ProductionQueryVariables) => ['production', variables];
;

export const useInfiniteProductionQuery = <
      TData = ProductionQuery,
      TError = unknown
    >(
      variables: ProductionQueryVariables,
      options?: UseInfiniteQueryOptions<ProductionQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProductionQuery, TError, TData>(
      ['production.infinite', variables],
      (metaData) => useFetchData<ProductionQuery, ProductionQueryVariables>(ProductionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductionDocument = `
    query searchProduction($first: Int, $after: String, $filter: SearchProductionFilter, $sort: [ProductionSortEnum]) {
  searchProduction(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ProductionFields
      }
    }
  }
}
    ${ProductionFieldsFragmentDoc}`;
export const useSearchProductionQuery = <
      TData = SearchProductionQuery,
      TError = unknown
    >(
      variables?: SearchProductionQueryVariables,
      options?: UseQueryOptions<SearchProductionQuery, TError, TData>
    ) =>
    useQuery<SearchProductionQuery, TError, TData>(
      variables === undefined ? ['searchProduction'] : ['searchProduction', variables],
      useFetchData<SearchProductionQuery, SearchProductionQueryVariables>(SearchProductionDocument).bind(null, variables),
      options
    );

useSearchProductionQuery.getKey = (variables?: SearchProductionQueryVariables) => variables === undefined ? ['searchProduction'] : ['searchProduction', variables];
;

export const useInfiniteSearchProductionQuery = <
      TData = SearchProductionQuery,
      TError = unknown
    >(
      variables?: SearchProductionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductionQuery, TError, TData>(
      variables === undefined ? ['searchProduction.infinite'] : ['searchProduction.infinite', variables],
      (metaData) => useFetchData<SearchProductionQuery, SearchProductionQueryVariables>(SearchProductionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductionDetailListDocument = `
    query searchProductionDetailList($first: Int, $after: String, $filter: SearchProductionFilter, $sort: [ProductionSortEnum], $detailFilter: ProductionDetailFilter) {
  searchProduction(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchProductionFields
        productionDetails(filter: $detailFilter) {
          edges {
            node {
              ...ProductionDetailFields
            }
          }
        }
      }
    }
  }
}
    ${SearchProductionFieldsFragmentDoc}
${ProductionDetailFieldsFragmentDoc}`;
export const useSearchProductionDetailListQuery = <
      TData = SearchProductionDetailListQuery,
      TError = unknown
    >(
      variables?: SearchProductionDetailListQueryVariables,
      options?: UseQueryOptions<SearchProductionDetailListQuery, TError, TData>
    ) =>
    useQuery<SearchProductionDetailListQuery, TError, TData>(
      variables === undefined ? ['searchProductionDetailList'] : ['searchProductionDetailList', variables],
      useFetchData<SearchProductionDetailListQuery, SearchProductionDetailListQueryVariables>(SearchProductionDetailListDocument).bind(null, variables),
      options
    );

useSearchProductionDetailListQuery.getKey = (variables?: SearchProductionDetailListQueryVariables) => variables === undefined ? ['searchProductionDetailList'] : ['searchProductionDetailList', variables];
;

export const useInfiniteSearchProductionDetailListQuery = <
      TData = SearchProductionDetailListQuery,
      TError = unknown
    >(
      variables?: SearchProductionDetailListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductionDetailListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductionDetailListQuery, TError, TData>(
      variables === undefined ? ['searchProductionDetailList.infinite'] : ['searchProductionDetailList.infinite', variables],
      (metaData) => useFetchData<SearchProductionDetailListQuery, SearchProductionDetailListQueryVariables>(SearchProductionDetailListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateProductionDocument = `
    mutation createProduction($input: CreateProductionInput!) {
  createProduction(input: $input) {
    production {
      ...ProductionMutationFields
    }
  }
}
    ${ProductionMutationFieldsFragmentDoc}`;
export const useCreateProductionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductionMutation, TError, CreateProductionMutationVariables, TContext>) =>
    useMutation<CreateProductionMutation, TError, CreateProductionMutationVariables, TContext>(
      'createProduction',
      useFetchData<CreateProductionMutation, CreateProductionMutationVariables>(CreateProductionDocument),
      options
    );
export const UpdateProductionDocument = `
    mutation updateProduction($input: UpdateProductionInput!) {
  updateProduction(input: $input) {
    production {
      ...ProductionMutationFields
    }
  }
}
    ${ProductionMutationFieldsFragmentDoc}`;
export const useUpdateProductionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductionMutation, TError, UpdateProductionMutationVariables, TContext>) =>
    useMutation<UpdateProductionMutation, TError, UpdateProductionMutationVariables, TContext>(
      'updateProduction',
      useFetchData<UpdateProductionMutation, UpdateProductionMutationVariables>(UpdateProductionDocument),
      options
    );
export const DeleteProductionDocument = `
    mutation deleteProduction($input: DeleteProductionInput!) {
  deleteProduction(input: $input) {
    production {
      ...ProductionMutationFields
    }
  }
}
    ${ProductionMutationFieldsFragmentDoc}`;
export const useDeleteProductionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProductionMutation, TError, DeleteProductionMutationVariables, TContext>) =>
    useMutation<DeleteProductionMutation, TError, DeleteProductionMutationVariables, TContext>(
      'deleteProduction',
      useFetchData<DeleteProductionMutation, DeleteProductionMutationVariables>(DeleteProductionDocument),
      options
    );
export const SearchComponentWithPriceDocument = `
    query searchComponentWithPrice($filter: ComponentWithPriceFilter) {
  searchComponentWithPrice(filter: $filter) {
    finishedProductCode
    purchaseUnitPriceYen
    divisionCode
    divisionName
    componentDetail {
      productPartsCode
      quantity
      janCode
      attributeName
      salesUnitPrice
      stockQuantity
      purchaseUnitPriceYen
      divisionCode
      divisionName
    }
  }
}
    `;
export const useSearchComponentWithPriceQuery = <
      TData = SearchComponentWithPriceQuery,
      TError = unknown
    >(
      variables?: SearchComponentWithPriceQueryVariables,
      options?: UseQueryOptions<SearchComponentWithPriceQuery, TError, TData>
    ) =>
    useQuery<SearchComponentWithPriceQuery, TError, TData>(
      variables === undefined ? ['searchComponentWithPrice'] : ['searchComponentWithPrice', variables],
      useFetchData<SearchComponentWithPriceQuery, SearchComponentWithPriceQueryVariables>(SearchComponentWithPriceDocument).bind(null, variables),
      options
    );

useSearchComponentWithPriceQuery.getKey = (variables?: SearchComponentWithPriceQueryVariables) => variables === undefined ? ['searchComponentWithPrice'] : ['searchComponentWithPrice', variables];
;

export const useInfiniteSearchComponentWithPriceQuery = <
      TData = SearchComponentWithPriceQuery,
      TError = unknown
    >(
      variables?: SearchComponentWithPriceQueryVariables,
      options?: UseInfiniteQueryOptions<SearchComponentWithPriceQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchComponentWithPriceQuery, TError, TData>(
      variables === undefined ? ['searchComponentWithPrice.infinite'] : ['searchComponentWithPrice.infinite', variables],
      (metaData) => useFetchData<SearchComponentWithPriceQuery, SearchComponentWithPriceQueryVariables>(SearchComponentWithPriceDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchVendorLedgerDocument = `
    query searchVendorLedger($first: Int, $after: String, $filter1: SearchVendorPurchaseFilter, $filter2: SearchWithdrawalVendorPurchaseFilter, $filter3: SearchVendorWithCarryOverFilter, $filter4: SearchPaymentVendorPurchaseFilter, $sort1: [PurchaseSortEnum], $sort2: [WithdrawalSortEnum], $sort4: [PaymentSortEnum]) {
  searchVendorPurchase(
    first: $first
    after: $after
    filter: $filter1
    sort: $sort1
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PurchaseFields
      }
    }
  }
  searchWithdrawalVendorPurchase(
    first: $first
    after: $after
    filter: $filter2
    sort: $sort2
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        versionUuid
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        payId
        payDate
        vendorCode
        userCode
        payRemark
        payPriceTotal
        closingStatusCode
        paymentId
        automaticallyGeneratedFlg
        withdrawalDetail {
          edges {
            node {
              versionUuid
              createUserCode
              createUserName
              createDate
              updateUserCode
              updateUserName
              updateDate
              payId
              numbering
              payDivisionCode
              payDivisionDetail
              billDate
              payPrice
              detailMemo
              id
            }
          }
        }
        vendor {
          vendorCode
          vendorName
          vendorFuri
          vendorClosingGroup
          paymentMethod
          paymentCycle
          paymentDate
          transferShareCost
          balanceData
          id
        }
        user {
          userCode
          userName
        }
        payment {
          payPriceTotalInAccountMonth
          currentPaymentExpectRemain
        }
        id
      }
    }
  }
  searchVendorWithCarryOver(first: $first, after: $after, filter: $filter3) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        vendorTaxType
        targetCarryOver
      }
    }
  }
  searchPaymentVendorPurchase(
    first: $first
    after: $after
    filter: $filter4
    sort: $sort4
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        versionUuid
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        paymentId
        closingDate
        paymentExpectedDate
        paymentDate
        vendorCode
        vendorTaxType
        beforePaymentRemain
        payPriceTotalInAccountMonth
        carryOverPrice
        excludingTaxTotalPaymentPrice
        includedTaxTotalPaymentPrice
        includedTaxPaymentClearingPrice
        exciseTaxTotal
        currentPaymentExpectRemain
        currentPaymentPrice
        differencePrice
        offsetPrice
        transferFee
        currentTransferPrice
        paymentMemo
        withdrawalState
        closingStatusCode
        currentTotalPurchasePrice
        currentTotalImportPrice
        currentTotalProgressPrice
        automaticPayId
        paymentTaxDetails {
          edges {
            node {
              versionUuid
              paymentId
              taxationDivision
              taxExcluded
              exciseTax
            }
          }
        }
        paymentTaxAdjustDetails {
          edges {
            node {
              versionUuid
              paymentId
              taxationDivision
              beforeAdjustExciseTax
              afterAdjustExciseTax
              adjust
            }
          }
        }
        vendor {
          vendorCode
          vendorName
          vendorFuri
          factoryCode
          purposeGroup
          countryCode
          zipCode
          address1
          address2
          customerPostName
          customerPositionName
          customerUser
          honorificCode
          tel
          fax
          email
          vendorClosingGroup
          billSendDivision
          paymentMethod
          paymentCycle
          paymentDate
          transferShareCost
          transferCondition
          invoiceDivision
          invoiceRegistrationCode
          ediInfo
          vendorTradeDivision
          vendorTaxType
          priceRoundType
          taxRoundType
          vendorUnitpriceType
          productGroup
          reportOutputUnit
          tradeStopFlg
          vendorMemo
          bankCode
          bankName
          bankFuri
          branchOfficeCode
          branchOfficeName
          branchOfficeFuri
          bankAccountRelation
          bankAccountType
          bankAccountCode
          bankAccountName
          bankAccountFuri
          transferCustomCode1
          transferCustomCode2
          transferMethodCode
          delFlg
          balanceData
          createDate
          updateDate
          versionUuid
          id
          paymentDivision {
            paymentDivisionName
          }
        }
        automaticWithdrawal {
          versionUuid
          createUserCode
          createUserName
          createDate
          updateUserCode
          updateUserName
          updateDate
          payId
          payDate
          vendorCode
          userCode
          payRemark
          payPriceTotal
          closingStatusCode
          paymentId
          automaticallyGeneratedFlg
          withdrawalDetail {
            edges {
              node {
                versionUuid
                createUserCode
                createUserName
                createDate
                updateUserCode
                updateUserName
                updateDate
                payId
                numbering
                payDivisionCode
                payDivisionDetail
                billDate
                payPrice
                detailMemo
                id
              }
            }
          }
          vendor {
            vendorCode
            vendorName
            vendorFuri
            vendorClosingGroup
            paymentMethod
            paymentCycle
            paymentDate
            transferShareCost
            balanceData
            id
          }
          user {
            userCode
            userName
          }
          payment {
            payPriceTotalInAccountMonth
            currentPaymentExpectRemain
          }
          id
        }
        id
      }
    }
  }
}
    ${PurchaseFieldsFragmentDoc}`;
export const useSearchVendorLedgerQuery = <
      TData = SearchVendorLedgerQuery,
      TError = unknown
    >(
      variables?: SearchVendorLedgerQueryVariables,
      options?: UseQueryOptions<SearchVendorLedgerQuery, TError, TData>
    ) =>
    useQuery<SearchVendorLedgerQuery, TError, TData>(
      variables === undefined ? ['searchVendorLedger'] : ['searchVendorLedger', variables],
      useFetchData<SearchVendorLedgerQuery, SearchVendorLedgerQueryVariables>(SearchVendorLedgerDocument).bind(null, variables),
      options
    );

useSearchVendorLedgerQuery.getKey = (variables?: SearchVendorLedgerQueryVariables) => variables === undefined ? ['searchVendorLedger'] : ['searchVendorLedger', variables];
;

export const useInfiniteSearchVendorLedgerQuery = <
      TData = SearchVendorLedgerQuery,
      TError = unknown
    >(
      variables?: SearchVendorLedgerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchVendorLedgerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchVendorLedgerQuery, TError, TData>(
      variables === undefined ? ['searchVendorLedger.infinite'] : ['searchVendorLedger.infinite', variables],
      (metaData) => useFetchData<SearchVendorLedgerQuery, SearchVendorLedgerQueryVariables>(SearchVendorLedgerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchVendorPurchaseMonthlyDocument = `
    query searchVendorPurchaseMonthly($first: Int, $after: String, $filter1: SearchVendorPurchaseMonthlyFilter, $filter2: SearchVendorWithCarryOverFilter) {
  searchVendorPurchaseMonthly(first: $first, after: $after, filter: $filter1) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...VendorPurchaseMonthlyFields
      }
    }
  }
  searchVendorWithCarryOver(first: $first, after: $after, filter: $filter2) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        vendorTaxType
        targetCarryOver
      }
    }
  }
}
    ${VendorPurchaseMonthlyFieldsFragmentDoc}`;
export const useSearchVendorPurchaseMonthlyQuery = <
      TData = SearchVendorPurchaseMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchVendorPurchaseMonthlyQueryVariables,
      options?: UseQueryOptions<SearchVendorPurchaseMonthlyQuery, TError, TData>
    ) =>
    useQuery<SearchVendorPurchaseMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchVendorPurchaseMonthly'] : ['searchVendorPurchaseMonthly', variables],
      useFetchData<SearchVendorPurchaseMonthlyQuery, SearchVendorPurchaseMonthlyQueryVariables>(SearchVendorPurchaseMonthlyDocument).bind(null, variables),
      options
    );

useSearchVendorPurchaseMonthlyQuery.getKey = (variables?: SearchVendorPurchaseMonthlyQueryVariables) => variables === undefined ? ['searchVendorPurchaseMonthly'] : ['searchVendorPurchaseMonthly', variables];
;

export const useInfiniteSearchVendorPurchaseMonthlyQuery = <
      TData = SearchVendorPurchaseMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchVendorPurchaseMonthlyQueryVariables,
      options?: UseInfiniteQueryOptions<SearchVendorPurchaseMonthlyQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchVendorPurchaseMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchVendorPurchaseMonthly.infinite'] : ['searchVendorPurchaseMonthly.infinite', variables],
      (metaData) => useFetchData<SearchVendorPurchaseMonthlyQuery, SearchVendorPurchaseMonthlyQueryVariables>(SearchVendorPurchaseMonthlyDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPurchaseDocument = `
    query searchPurchase($first: Int, $after: String, $filter: SearchPurchaseFilter, $sort: [PurchaseSortEnum]) {
  searchPurchase(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        purchaseId
        purchaseDate
        closingStatusCode
        division {
          divisionCode
          divisionName
        }
        vendor {
          vendorCode
          vendorName
        }
        purchaseRemark
        purchaseDetails {
          edges {
            node {
              purchasePrice
              taxationDivision
            }
          }
        }
      }
    }
  }
}
    `;
export const useSearchPurchaseQuery = <
      TData = SearchPurchaseQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseQueryVariables,
      options?: UseQueryOptions<SearchPurchaseQuery, TError, TData>
    ) =>
    useQuery<SearchPurchaseQuery, TError, TData>(
      variables === undefined ? ['searchPurchase'] : ['searchPurchase', variables],
      useFetchData<SearchPurchaseQuery, SearchPurchaseQueryVariables>(SearchPurchaseDocument).bind(null, variables),
      options
    );

useSearchPurchaseQuery.getKey = (variables?: SearchPurchaseQueryVariables) => variables === undefined ? ['searchPurchase'] : ['searchPurchase', variables];
;

export const useInfiniteSearchPurchaseQuery = <
      TData = SearchPurchaseQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPurchaseQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPurchaseQuery, TError, TData>(
      variables === undefined ? ['searchPurchase.infinite'] : ['searchPurchase.infinite', variables],
      (metaData) => useFetchData<SearchPurchaseQuery, SearchPurchaseQueryVariables>(SearchPurchaseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const PurchaseDetailListDocument = `
    query purchaseDetailList($first: Int, $after: String, $filter: SearchPurchaseFilter, $sort: [PurchaseSortEnum], $detailFilter: PurchaseDetailFilter) {
  searchPurchase(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...PurchaseDetailListPurchaseFields
      }
    }
  }
}
    ${PurchaseDetailListPurchaseFieldsFragmentDoc}`;
export const usePurchaseDetailListQuery = <
      TData = PurchaseDetailListQuery,
      TError = unknown
    >(
      variables?: PurchaseDetailListQueryVariables,
      options?: UseQueryOptions<PurchaseDetailListQuery, TError, TData>
    ) =>
    useQuery<PurchaseDetailListQuery, TError, TData>(
      variables === undefined ? ['purchaseDetailList'] : ['purchaseDetailList', variables],
      useFetchData<PurchaseDetailListQuery, PurchaseDetailListQueryVariables>(PurchaseDetailListDocument).bind(null, variables),
      options
    );

usePurchaseDetailListQuery.getKey = (variables?: PurchaseDetailListQueryVariables) => variables === undefined ? ['purchaseDetailList'] : ['purchaseDetailList', variables];
;

export const useInfinitePurchaseDetailListQuery = <
      TData = PurchaseDetailListQuery,
      TError = unknown
    >(
      variables?: PurchaseDetailListQueryVariables,
      options?: UseInfiniteQueryOptions<PurchaseDetailListQuery, TError, TData>
    ) =>
    useInfiniteQuery<PurchaseDetailListQuery, TError, TData>(
      variables === undefined ? ['purchaseDetailList.infinite'] : ['purchaseDetailList.infinite', variables],
      (metaData) => useFetchData<PurchaseDetailListQuery, PurchaseDetailListQueryVariables>(PurchaseDetailListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ExportProductFromPurchaseKoreDocument = `
    query exportProductFromPurchaseKore($filter: SearchProductInPurchaseKoreFilter) {
  exportProductFromPurchaseKore(filter: $filter) {
    totalCount
    exchangeRate
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PurchaseKoreFields
      }
    }
  }
}
    ${PurchaseKoreFieldsFragmentDoc}`;
export const useExportProductFromPurchaseKoreQuery = <
      TData = ExportProductFromPurchaseKoreQuery,
      TError = unknown
    >(
      variables?: ExportProductFromPurchaseKoreQueryVariables,
      options?: UseQueryOptions<ExportProductFromPurchaseKoreQuery, TError, TData>
    ) =>
    useQuery<ExportProductFromPurchaseKoreQuery, TError, TData>(
      variables === undefined ? ['exportProductFromPurchaseKore'] : ['exportProductFromPurchaseKore', variables],
      useFetchData<ExportProductFromPurchaseKoreQuery, ExportProductFromPurchaseKoreQueryVariables>(ExportProductFromPurchaseKoreDocument).bind(null, variables),
      options
    );

useExportProductFromPurchaseKoreQuery.getKey = (variables?: ExportProductFromPurchaseKoreQueryVariables) => variables === undefined ? ['exportProductFromPurchaseKore'] : ['exportProductFromPurchaseKore', variables];
;

export const useInfiniteExportProductFromPurchaseKoreQuery = <
      TData = ExportProductFromPurchaseKoreQuery,
      TError = unknown
    >(
      variables?: ExportProductFromPurchaseKoreQueryVariables,
      options?: UseInfiniteQueryOptions<ExportProductFromPurchaseKoreQuery, TError, TData>
    ) =>
    useInfiniteQuery<ExportProductFromPurchaseKoreQuery, TError, TData>(
      variables === undefined ? ['exportProductFromPurchaseKore.infinite'] : ['exportProductFromPurchaseKore.infinite', variables],
      (metaData) => useFetchData<ExportProductFromPurchaseKoreQuery, ExportProductFromPurchaseKoreQueryVariables>(ExportProductFromPurchaseKoreDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductFromPurchaseKoreDocument = `
    query searchProductFromPurchaseKore($first: Int, $after: String, $filter: SearchProductInPurchaseKoreFilter) {
  searchProductFromPurchaseKore(first: $first, after: $after, filter: $filter) {
    totalCount
    exchangeRate
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...PurchaseKoreFields
      }
    }
  }
}
    ${PurchaseKoreFieldsFragmentDoc}`;
export const useSearchProductFromPurchaseKoreQuery = <
      TData = SearchProductFromPurchaseKoreQuery,
      TError = unknown
    >(
      variables?: SearchProductFromPurchaseKoreQueryVariables,
      options?: UseQueryOptions<SearchProductFromPurchaseKoreQuery, TError, TData>
    ) =>
    useQuery<SearchProductFromPurchaseKoreQuery, TError, TData>(
      variables === undefined ? ['searchProductFromPurchaseKore'] : ['searchProductFromPurchaseKore', variables],
      useFetchData<SearchProductFromPurchaseKoreQuery, SearchProductFromPurchaseKoreQueryVariables>(SearchProductFromPurchaseKoreDocument).bind(null, variables),
      options
    );

useSearchProductFromPurchaseKoreQuery.getKey = (variables?: SearchProductFromPurchaseKoreQueryVariables) => variables === undefined ? ['searchProductFromPurchaseKore'] : ['searchProductFromPurchaseKore', variables];
;

export const useInfiniteSearchProductFromPurchaseKoreQuery = <
      TData = SearchProductFromPurchaseKoreQuery,
      TError = unknown
    >(
      variables?: SearchProductFromPurchaseKoreQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductFromPurchaseKoreQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductFromPurchaseKoreQuery, TError, TData>(
      variables === undefined ? ['searchProductFromPurchaseKore.infinite'] : ['searchProductFromPurchaseKore.infinite', variables],
      (metaData) => useFetchData<SearchProductFromPurchaseKoreQuery, SearchProductFromPurchaseKoreQueryVariables>(SearchProductFromPurchaseKoreDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPurchaseUnitHistoryDocument = `
    query searchPurchaseUnitHistory($first: Int, $after: String, $filter: SearchPurchaseUnitHistoryFilter) {
  searchPurchaseUnitHistory(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...SearchPurchaseUnitHistoryFields
      }
    }
  }
}
    ${SearchPurchaseUnitHistoryFieldsFragmentDoc}`;
export const useSearchPurchaseUnitHistoryQuery = <
      TData = SearchPurchaseUnitHistoryQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseUnitHistoryQueryVariables,
      options?: UseQueryOptions<SearchPurchaseUnitHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchPurchaseUnitHistoryQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseUnitHistory'] : ['searchPurchaseUnitHistory', variables],
      useFetchData<SearchPurchaseUnitHistoryQuery, SearchPurchaseUnitHistoryQueryVariables>(SearchPurchaseUnitHistoryDocument).bind(null, variables),
      options
    );

useSearchPurchaseUnitHistoryQuery.getKey = (variables?: SearchPurchaseUnitHistoryQueryVariables) => variables === undefined ? ['searchPurchaseUnitHistory'] : ['searchPurchaseUnitHistory', variables];
;

export const useInfiniteSearchPurchaseUnitHistoryQuery = <
      TData = SearchPurchaseUnitHistoryQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseUnitHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPurchaseUnitHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPurchaseUnitHistoryQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseUnitHistory.infinite'] : ['searchPurchaseUnitHistory.infinite', variables],
      (metaData) => useFetchData<SearchPurchaseUnitHistoryQuery, SearchPurchaseUnitHistoryQueryVariables>(SearchPurchaseUnitHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPurchaseAnalyticsListDocument = `
    query searchPurchaseAnalyticsList($first: Int, $after: String, $filter: SearchPurchaseAnalyticsFilter) {
  searchPurchaseAnalyticsList(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        vendorCode
        vendorName
        janCode
        productName
        divisionCode
        divisionName
        totalPurchasePrice
        totalPurchaseQuantity
        returnPrice
        returnQuantity
        discountPrice
        otherPrice
        netPurchasePrice
        netPurchaseQuantity
        configurationRate
        totalPurchasePriceDollar
        returnPriceDollar
        discountPriceDollar
        otherPriceDollar
        netPurchasePriceDollar
        configurationRateDollar
      }
    }
  }
}
    `;
export const useSearchPurchaseAnalyticsListQuery = <
      TData = SearchPurchaseAnalyticsListQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseAnalyticsListQueryVariables,
      options?: UseQueryOptions<SearchPurchaseAnalyticsListQuery, TError, TData>
    ) =>
    useQuery<SearchPurchaseAnalyticsListQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseAnalyticsList'] : ['searchPurchaseAnalyticsList', variables],
      useFetchData<SearchPurchaseAnalyticsListQuery, SearchPurchaseAnalyticsListQueryVariables>(SearchPurchaseAnalyticsListDocument).bind(null, variables),
      options
    );

useSearchPurchaseAnalyticsListQuery.getKey = (variables?: SearchPurchaseAnalyticsListQueryVariables) => variables === undefined ? ['searchPurchaseAnalyticsList'] : ['searchPurchaseAnalyticsList', variables];
;

export const useInfiniteSearchPurchaseAnalyticsListQuery = <
      TData = SearchPurchaseAnalyticsListQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseAnalyticsListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPurchaseAnalyticsListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPurchaseAnalyticsListQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseAnalyticsList.infinite'] : ['searchPurchaseAnalyticsList.infinite', variables],
      (metaData) => useFetchData<SearchPurchaseAnalyticsListQuery, SearchPurchaseAnalyticsListQueryVariables>(SearchPurchaseAnalyticsListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchPurchaseDailyListDocument = `
    query searchPurchaseDailyList($first: Int, $after: String, $filter: SearchPurchaseDailyFilter) {
  searchPurchaseDailyList(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        vendorCode
        vendorName
        janCode
        productName
        divisionCode
        divisionName
        totalPurchasePrice
        returnPrice
        returnRate
        discountPrice
        discountRate
        otherPrice
        netPurchasePrice
        totalPurchasePriceDollar
        returnPriceDollar
        returnRateDollar
        discountPriceDollar
        discountRateDollar
        otherPriceDollar
        netPurchasePriceDollar
        totalPurchaseQuantity
        returnQuantity
        netPurchaseQuantity
      }
    }
  }
}
    `;
export const useSearchPurchaseDailyListQuery = <
      TData = SearchPurchaseDailyListQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseDailyListQueryVariables,
      options?: UseQueryOptions<SearchPurchaseDailyListQuery, TError, TData>
    ) =>
    useQuery<SearchPurchaseDailyListQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseDailyList'] : ['searchPurchaseDailyList', variables],
      useFetchData<SearchPurchaseDailyListQuery, SearchPurchaseDailyListQueryVariables>(SearchPurchaseDailyListDocument).bind(null, variables),
      options
    );

useSearchPurchaseDailyListQuery.getKey = (variables?: SearchPurchaseDailyListQueryVariables) => variables === undefined ? ['searchPurchaseDailyList'] : ['searchPurchaseDailyList', variables];
;

export const useInfiniteSearchPurchaseDailyListQuery = <
      TData = SearchPurchaseDailyListQuery,
      TError = unknown
    >(
      variables?: SearchPurchaseDailyListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchPurchaseDailyListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchPurchaseDailyListQuery, TError, TData>(
      variables === undefined ? ['searchPurchaseDailyList.infinite'] : ['searchPurchaseDailyList.infinite', variables],
      (metaData) => useFetchData<SearchPurchaseDailyListQuery, SearchPurchaseDailyListQueryVariables>(SearchPurchaseDailyListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceivableBalanceListDocument = `
    query searchReceivableBalanceList($first: Int, $after: String, $filter: SearchReceivableBalanceListFilter) {
  searchReceivableBalanceList(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        businessAmebaFlg
        divisionCode
        divisionName
        userCode
        userName
        demandCode
        customerName
        beforeReceivableBalance
        collectPrice
        expirationDate
        carryOverBalance
        excludingTaxSales
        exciseTaxPer10
        exciseTaxPer8
        receivablePrice
        monthBalance
        cash
        transfer
        commission
        draft
        otherPayment
        divisionBundle
        demandClosingGroupCode
        collectCycleCode
        collectDate
        collectDays
        customerRank
        salesTradeDivision
        customerGroup
      }
    }
  }
}
    `;
export const useSearchReceivableBalanceListQuery = <
      TData = SearchReceivableBalanceListQuery,
      TError = unknown
    >(
      variables?: SearchReceivableBalanceListQueryVariables,
      options?: UseQueryOptions<SearchReceivableBalanceListQuery, TError, TData>
    ) =>
    useQuery<SearchReceivableBalanceListQuery, TError, TData>(
      variables === undefined ? ['searchReceivableBalanceList'] : ['searchReceivableBalanceList', variables],
      useFetchData<SearchReceivableBalanceListQuery, SearchReceivableBalanceListQueryVariables>(SearchReceivableBalanceListDocument).bind(null, variables),
      options
    );

useSearchReceivableBalanceListQuery.getKey = (variables?: SearchReceivableBalanceListQueryVariables) => variables === undefined ? ['searchReceivableBalanceList'] : ['searchReceivableBalanceList', variables];
;

export const useInfiniteSearchReceivableBalanceListQuery = <
      TData = SearchReceivableBalanceListQuery,
      TError = unknown
    >(
      variables?: SearchReceivableBalanceListQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceivableBalanceListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceivableBalanceListQuery, TError, TData>(
      variables === undefined ? ['searchReceivableBalanceList.infinite'] : ['searchReceivableBalanceList.infinite', variables],
      (metaData) => useFetchData<SearchReceivableBalanceListQuery, SearchReceivableBalanceListQueryVariables>(SearchReceivableBalanceListDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveOrderSalesUnitPriceUpdateDocument = `
    query searchReceiveOrderSalesUnitPriceUpdate($first: Int, $after: String, $filter: SearchReceiveOrderSalesUnitPriceUpdateFilter, $sort: [ReceiveOrderDetailSortEnum]) {
  searchReceiveOrderSalesUnitPriceUpdate(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...ReceiveOrderSalesUnitPriceFields
      }
    }
  }
}
    ${ReceiveOrderSalesUnitPriceFieldsFragmentDoc}`;
export const useSearchReceiveOrderSalesUnitPriceUpdateQuery = <
      TData = SearchReceiveOrderSalesUnitPriceUpdateQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderSalesUnitPriceUpdateQueryVariables,
      options?: UseQueryOptions<SearchReceiveOrderSalesUnitPriceUpdateQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveOrderSalesUnitPriceUpdateQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderSalesUnitPriceUpdate'] : ['searchReceiveOrderSalesUnitPriceUpdate', variables],
      useFetchData<SearchReceiveOrderSalesUnitPriceUpdateQuery, SearchReceiveOrderSalesUnitPriceUpdateQueryVariables>(SearchReceiveOrderSalesUnitPriceUpdateDocument).bind(null, variables),
      options
    );

useSearchReceiveOrderSalesUnitPriceUpdateQuery.getKey = (variables?: SearchReceiveOrderSalesUnitPriceUpdateQueryVariables) => variables === undefined ? ['searchReceiveOrderSalesUnitPriceUpdate'] : ['searchReceiveOrderSalesUnitPriceUpdate', variables];
;

export const useInfiniteSearchReceiveOrderSalesUnitPriceUpdateQuery = <
      TData = SearchReceiveOrderSalesUnitPriceUpdateQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderSalesUnitPriceUpdateQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveOrderSalesUnitPriceUpdateQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveOrderSalesUnitPriceUpdateQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderSalesUnitPriceUpdate.infinite'] : ['searchReceiveOrderSalesUnitPriceUpdate.infinite', variables],
      (metaData) => useFetchData<SearchReceiveOrderSalesUnitPriceUpdateQuery, SearchReceiveOrderSalesUnitPriceUpdateQueryVariables>(SearchReceiveOrderSalesUnitPriceUpdateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const UpdateReceiveOrderSalesUnitPriceDocument = `
    mutation updateReceiveOrderSalesUnitPrice($input: UpdateReceiveOrderDetailSalesUnitPriceInput!) {
  updateReceiveOrderSalesUnitPrice(input: $input) {
    receiveOrderDetail {
      receiveOrderId
      numbering
      versionUuid
      id
    }
  }
}
    `;
export const useUpdateReceiveOrderSalesUnitPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReceiveOrderSalesUnitPriceMutation, TError, UpdateReceiveOrderSalesUnitPriceMutationVariables, TContext>) =>
    useMutation<UpdateReceiveOrderSalesUnitPriceMutation, TError, UpdateReceiveOrderSalesUnitPriceMutationVariables, TContext>(
      'updateReceiveOrderSalesUnitPrice',
      useFetchData<UpdateReceiveOrderSalesUnitPriceMutation, UpdateReceiveOrderSalesUnitPriceMutationVariables>(UpdateReceiveOrderSalesUnitPriceDocument),
      options
    );
export const ReceiveOrderHeaderDocument = `
    query receiveOrderHeader($id: ID!) {
  receiveOrderHeader(id: $id) {
    ...ReceiveOrderHeaderFields
  }
}
    ${ReceiveOrderHeaderFieldsFragmentDoc}`;
export const useReceiveOrderHeaderQuery = <
      TData = ReceiveOrderHeaderQuery,
      TError = unknown
    >(
      variables: ReceiveOrderHeaderQueryVariables,
      options?: UseQueryOptions<ReceiveOrderHeaderQuery, TError, TData>
    ) =>
    useQuery<ReceiveOrderHeaderQuery, TError, TData>(
      ['receiveOrderHeader', variables],
      useFetchData<ReceiveOrderHeaderQuery, ReceiveOrderHeaderQueryVariables>(ReceiveOrderHeaderDocument).bind(null, variables),
      options
    );

useReceiveOrderHeaderQuery.getKey = (variables: ReceiveOrderHeaderQueryVariables) => ['receiveOrderHeader', variables];
;

export const useInfiniteReceiveOrderHeaderQuery = <
      TData = ReceiveOrderHeaderQuery,
      TError = unknown
    >(
      variables: ReceiveOrderHeaderQueryVariables,
      options?: UseInfiniteQueryOptions<ReceiveOrderHeaderQuery, TError, TData>
    ) =>
    useInfiniteQuery<ReceiveOrderHeaderQuery, TError, TData>(
      ['receiveOrderHeader.infinite', variables],
      (metaData) => useFetchData<ReceiveOrderHeaderQuery, ReceiveOrderHeaderQueryVariables>(ReceiveOrderHeaderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateReceiveOrderDocument = `
    mutation createReceiveOrder($input: CreateReceiveOrderInput!) {
  createReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useCreateReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReceiveOrderMutation, TError, CreateReceiveOrderMutationVariables, TContext>) =>
    useMutation<CreateReceiveOrderMutation, TError, CreateReceiveOrderMutationVariables, TContext>(
      'createReceiveOrder',
      useFetchData<CreateReceiveOrderMutation, CreateReceiveOrderMutationVariables>(CreateReceiveOrderDocument),
      options
    );
export const CreateReturnReceiveOrderDocument = `
    mutation createReturnReceiveOrder($input: CreateReturnReceiveOrderInput!) {
  createReturnReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useCreateReturnReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReturnReceiveOrderMutation, TError, CreateReturnReceiveOrderMutationVariables, TContext>) =>
    useMutation<CreateReturnReceiveOrderMutation, TError, CreateReturnReceiveOrderMutationVariables, TContext>(
      'createReturnReceiveOrder',
      useFetchData<CreateReturnReceiveOrderMutation, CreateReturnReceiveOrderMutationVariables>(CreateReturnReceiveOrderDocument),
      options
    );
export const UpdateReceiveOrderDocument = `
    mutation updateReceiveOrder($input: UpdateReceiveOrderInput!) {
  updateReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useUpdateReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReceiveOrderMutation, TError, UpdateReceiveOrderMutationVariables, TContext>) =>
    useMutation<UpdateReceiveOrderMutation, TError, UpdateReceiveOrderMutationVariables, TContext>(
      'updateReceiveOrder',
      useFetchData<UpdateReceiveOrderMutation, UpdateReceiveOrderMutationVariables>(UpdateReceiveOrderDocument),
      options
    );
export const UpdateReturnReceiveOrderDocument = `
    mutation updateReturnReceiveOrder($input: UpdateReturnReceiveOrderInput!) {
  updateReturnReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useUpdateReturnReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReturnReceiveOrderMutation, TError, UpdateReturnReceiveOrderMutationVariables, TContext>) =>
    useMutation<UpdateReturnReceiveOrderMutation, TError, UpdateReturnReceiveOrderMutationVariables, TContext>(
      'updateReturnReceiveOrder',
      useFetchData<UpdateReturnReceiveOrderMutation, UpdateReturnReceiveOrderMutationVariables>(UpdateReturnReceiveOrderDocument),
      options
    );
export const DeleteReceiveOrderDocument = `
    mutation deleteReceiveOrder($input: DeleteReceiveOrderInput!) {
  deleteReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useDeleteReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReceiveOrderMutation, TError, DeleteReceiveOrderMutationVariables, TContext>) =>
    useMutation<DeleteReceiveOrderMutation, TError, DeleteReceiveOrderMutationVariables, TContext>(
      'deleteReceiveOrder',
      useFetchData<DeleteReceiveOrderMutation, DeleteReceiveOrderMutationVariables>(DeleteReceiveOrderDocument),
      options
    );
export const DeleteReturnReceiveOrderDocument = `
    mutation deleteReturnReceiveOrder($input: DeleteReturnReceiveOrderInput!) {
  deleteReturnReceiveOrder(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useDeleteReturnReceiveOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReturnReceiveOrderMutation, TError, DeleteReturnReceiveOrderMutationVariables, TContext>) =>
    useMutation<DeleteReturnReceiveOrderMutation, TError, DeleteReturnReceiveOrderMutationVariables, TContext>(
      'deleteReturnReceiveOrder',
      useFetchData<DeleteReturnReceiveOrderMutation, DeleteReturnReceiveOrderMutationVariables>(DeleteReturnReceiveOrderDocument),
      options
    );
export const ExecuteReturnProcessReceiveDocument = `
    mutation executeReturnProcessReceive($input: ExecuteReturnProcessReceiveInput!) {
  executeReturnProcessReceive(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useExecuteReturnProcessReceiveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteReturnProcessReceiveMutation, TError, ExecuteReturnProcessReceiveMutationVariables, TContext>) =>
    useMutation<ExecuteReturnProcessReceiveMutation, TError, ExecuteReturnProcessReceiveMutationVariables, TContext>(
      'executeReturnProcessReceive',
      useFetchData<ExecuteReturnProcessReceiveMutation, ExecuteReturnProcessReceiveMutationVariables>(ExecuteReturnProcessReceiveDocument),
      options
    );
export const ExecuteDeleteReturnProcessReceiveDocument = `
    mutation executeDeleteReturnProcessReceive($input: ExecuteDeleteReturnProcessReceiveInput!) {
  executeDeleteReturnProcessReceive(input: $input) {
    receiveOrder {
      ...ReceiveOrderMutationFields
    }
  }
}
    ${ReceiveOrderMutationFieldsFragmentDoc}`;
export const useExecuteDeleteReturnProcessReceiveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExecuteDeleteReturnProcessReceiveMutation, TError, ExecuteDeleteReturnProcessReceiveMutationVariables, TContext>) =>
    useMutation<ExecuteDeleteReturnProcessReceiveMutation, TError, ExecuteDeleteReturnProcessReceiveMutationVariables, TContext>(
      'executeDeleteReturnProcessReceive',
      useFetchData<ExecuteDeleteReturnProcessReceiveMutation, ExecuteDeleteReturnProcessReceiveMutationVariables>(ExecuteDeleteReturnProcessReceiveDocument),
      options
    );
export const SearchCustomerForReceiveDocument = `
    query searchCustomerForReceive($id: ID!) {
  customer(id: $id) {
    ...CustomerFieldsForReceive
  }
}
    ${CustomerFieldsForReceiveFragmentDoc}`;
export const useSearchCustomerForReceiveQuery = <
      TData = SearchCustomerForReceiveQuery,
      TError = unknown
    >(
      variables: SearchCustomerForReceiveQueryVariables,
      options?: UseQueryOptions<SearchCustomerForReceiveQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerForReceiveQuery, TError, TData>(
      ['searchCustomerForReceive', variables],
      useFetchData<SearchCustomerForReceiveQuery, SearchCustomerForReceiveQueryVariables>(SearchCustomerForReceiveDocument).bind(null, variables),
      options
    );

useSearchCustomerForReceiveQuery.getKey = (variables: SearchCustomerForReceiveQueryVariables) => ['searchCustomerForReceive', variables];
;

export const useInfiniteSearchCustomerForReceiveQuery = <
      TData = SearchCustomerForReceiveQuery,
      TError = unknown
    >(
      variables: SearchCustomerForReceiveQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerForReceiveQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerForReceiveQuery, TError, TData>(
      ['searchCustomerForReceive.infinite', variables],
      (metaData) => useFetchData<SearchCustomerForReceiveQuery, SearchCustomerForReceiveQueryVariables>(SearchCustomerForReceiveDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveOrderDocument = `
    query searchReceiveOrder($first: Int, $after: String, $filter: SearchReceiveOrderHeaderFilter, $sort: [ReceiveOrderHeaderSortEnum]) {
  searchReceiveOrder(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchReceiveOrderFields
      }
    }
  }
}
    ${SearchReceiveOrderFieldsFragmentDoc}`;
export const useSearchReceiveOrderQuery = <
      TData = SearchReceiveOrderQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderQueryVariables,
      options?: UseQueryOptions<SearchReceiveOrderQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveOrderQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrder'] : ['searchReceiveOrder', variables],
      useFetchData<SearchReceiveOrderQuery, SearchReceiveOrderQueryVariables>(SearchReceiveOrderDocument).bind(null, variables),
      options
    );

useSearchReceiveOrderQuery.getKey = (variables?: SearchReceiveOrderQueryVariables) => variables === undefined ? ['searchReceiveOrder'] : ['searchReceiveOrder', variables];
;

export const useInfiniteSearchReceiveOrderQuery = <
      TData = SearchReceiveOrderQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveOrderQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrder.infinite'] : ['searchReceiveOrder.infinite', variables],
      (metaData) => useFetchData<SearchReceiveOrderQuery, SearchReceiveOrderQueryVariables>(SearchReceiveOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveOrderForConfirmedDocument = `
    query searchReceiveOrderForConfirmed($first: Int, $after: String, $filter: SearchReceiveOrderHeaderFilter, $sort: [ReceiveOrderHeaderSortEnum]) {
  searchReceiveOrderForConfirmed(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchReceiveOrderFields
      }
    }
  }
}
    ${SearchReceiveOrderFieldsFragmentDoc}`;
export const useSearchReceiveOrderForConfirmedQuery = <
      TData = SearchReceiveOrderForConfirmedQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderForConfirmedQueryVariables,
      options?: UseQueryOptions<SearchReceiveOrderForConfirmedQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveOrderForConfirmedQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderForConfirmed'] : ['searchReceiveOrderForConfirmed', variables],
      useFetchData<SearchReceiveOrderForConfirmedQuery, SearchReceiveOrderForConfirmedQueryVariables>(SearchReceiveOrderForConfirmedDocument).bind(null, variables),
      options
    );

useSearchReceiveOrderForConfirmedQuery.getKey = (variables?: SearchReceiveOrderForConfirmedQueryVariables) => variables === undefined ? ['searchReceiveOrderForConfirmed'] : ['searchReceiveOrderForConfirmed', variables];
;

export const useInfiniteSearchReceiveOrderForConfirmedQuery = <
      TData = SearchReceiveOrderForConfirmedQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderForConfirmedQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveOrderForConfirmedQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveOrderForConfirmedQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderForConfirmed.infinite'] : ['searchReceiveOrderForConfirmed.infinite', variables],
      (metaData) => useFetchData<SearchReceiveOrderForConfirmedQuery, SearchReceiveOrderForConfirmedQueryVariables>(SearchReceiveOrderForConfirmedDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveOrderForApprovalDocument = `
    query searchReceiveOrderForApproval($first: Int, $after: String, $filter: SearchReceiveOrderHeaderFilter, $sort: [ReceiveOrderHeaderSortEnum]) {
  searchReceiveOrderForApproval(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchReceiveOrderFields
      }
    }
  }
}
    ${SearchReceiveOrderFieldsFragmentDoc}`;
export const useSearchReceiveOrderForApprovalQuery = <
      TData = SearchReceiveOrderForApprovalQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderForApprovalQueryVariables,
      options?: UseQueryOptions<SearchReceiveOrderForApprovalQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveOrderForApprovalQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderForApproval'] : ['searchReceiveOrderForApproval', variables],
      useFetchData<SearchReceiveOrderForApprovalQuery, SearchReceiveOrderForApprovalQueryVariables>(SearchReceiveOrderForApprovalDocument).bind(null, variables),
      options
    );

useSearchReceiveOrderForApprovalQuery.getKey = (variables?: SearchReceiveOrderForApprovalQueryVariables) => variables === undefined ? ['searchReceiveOrderForApproval'] : ['searchReceiveOrderForApproval', variables];
;

export const useInfiniteSearchReceiveOrderForApprovalQuery = <
      TData = SearchReceiveOrderForApprovalQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderForApprovalQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveOrderForApprovalQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveOrderForApprovalQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderForApproval.infinite'] : ['searchReceiveOrderForApproval.infinite', variables],
      (metaData) => useFetchData<SearchReceiveOrderForApprovalQuery, SearchReceiveOrderForApprovalQueryVariables>(SearchReceiveOrderForApprovalDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReciveOrderDivisionDocument = `
    query searchReciveOrderDivision($first: Int, $after: String, $filter: SearchReceiveOrderHeaderFilter, $sort: [ReceiveOrderHeaderSortEnum]) {
  searchReceiveOrder(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        receiveOrderId
        divisionCode
        customer {
          userDivisionCode
          salesReport {
            reportLayoutCode
            reportLayoutName
            activeReportFlg
            offsetFlg
            offsetX
            offsetY
          }
        }
      }
    }
  }
}
    `;
export const useSearchReciveOrderDivisionQuery = <
      TData = SearchReciveOrderDivisionQuery,
      TError = unknown
    >(
      variables?: SearchReciveOrderDivisionQueryVariables,
      options?: UseQueryOptions<SearchReciveOrderDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchReciveOrderDivisionQuery, TError, TData>(
      variables === undefined ? ['searchReciveOrderDivision'] : ['searchReciveOrderDivision', variables],
      useFetchData<SearchReciveOrderDivisionQuery, SearchReciveOrderDivisionQueryVariables>(SearchReciveOrderDivisionDocument).bind(null, variables),
      options
    );

useSearchReciveOrderDivisionQuery.getKey = (variables?: SearchReciveOrderDivisionQueryVariables) => variables === undefined ? ['searchReciveOrderDivision'] : ['searchReciveOrderDivision', variables];
;

export const useInfiniteSearchReciveOrderDivisionQuery = <
      TData = SearchReciveOrderDivisionQuery,
      TError = unknown
    >(
      variables?: SearchReciveOrderDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReciveOrderDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReciveOrderDivisionQuery, TError, TData>(
      variables === undefined ? ['searchReciveOrderDivision.infinite'] : ['searchReciveOrderDivision.infinite', variables],
      (metaData) => useFetchData<SearchReciveOrderDivisionQuery, SearchReciveOrderDivisionQueryVariables>(SearchReciveOrderDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchWarehouseForReceiveOrderDocument = `
    query searchWarehouseForReceiveOrder($first: Int, $after: String, $filter: SearchWarehouseFilter, $sort: [WarehouseSortEnum]) {
  searchWarehouse(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WarehouseForReceiveOrderFields
      }
    }
  }
}
    ${WarehouseForReceiveOrderFieldsFragmentDoc}`;
export const useSearchWarehouseForReceiveOrderQuery = <
      TData = SearchWarehouseForReceiveOrderQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseForReceiveOrderQueryVariables,
      options?: UseQueryOptions<SearchWarehouseForReceiveOrderQuery, TError, TData>
    ) =>
    useQuery<SearchWarehouseForReceiveOrderQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseForReceiveOrder'] : ['searchWarehouseForReceiveOrder', variables],
      useFetchData<SearchWarehouseForReceiveOrderQuery, SearchWarehouseForReceiveOrderQueryVariables>(SearchWarehouseForReceiveOrderDocument).bind(null, variables),
      options
    );

useSearchWarehouseForReceiveOrderQuery.getKey = (variables?: SearchWarehouseForReceiveOrderQueryVariables) => variables === undefined ? ['searchWarehouseForReceiveOrder'] : ['searchWarehouseForReceiveOrder', variables];
;

export const useInfiniteSearchWarehouseForReceiveOrderQuery = <
      TData = SearchWarehouseForReceiveOrderQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseForReceiveOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWarehouseForReceiveOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWarehouseForReceiveOrderQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseForReceiveOrder.infinite'] : ['searchWarehouseForReceiveOrder.infinite', variables],
      (metaData) => useFetchData<SearchWarehouseForReceiveOrderQuery, SearchWarehouseForReceiveOrderQueryVariables>(SearchWarehouseForReceiveOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const UpdateReceiveOrderStatusConfirmedDocument = `
    mutation updateReceiveOrderStatusConfirmed($input: UpdateReceiveOrderStatusConfirmedInput!) {
  updateReceiveOrderStatusConfirmed(input: $input) {
    receiveOrder {
      id
      receiveOrderId
    }
  }
}
    `;
export const useUpdateReceiveOrderStatusConfirmedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReceiveOrderStatusConfirmedMutation, TError, UpdateReceiveOrderStatusConfirmedMutationVariables, TContext>) =>
    useMutation<UpdateReceiveOrderStatusConfirmedMutation, TError, UpdateReceiveOrderStatusConfirmedMutationVariables, TContext>(
      'updateReceiveOrderStatusConfirmed',
      useFetchData<UpdateReceiveOrderStatusConfirmedMutation, UpdateReceiveOrderStatusConfirmedMutationVariables>(UpdateReceiveOrderStatusConfirmedDocument),
      options
    );
export const UpdateReceiveOrderStatusCancelDocument = `
    mutation updateReceiveOrderStatusCancel($input: UpdateReceiveOrderStatusCancelInput!) {
  updateReceiveOrderStatusCancel(input: $input) {
    receiveOrder {
      id
      receiveOrderId
    }
  }
}
    `;
export const useUpdateReceiveOrderStatusCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReceiveOrderStatusCancelMutation, TError, UpdateReceiveOrderStatusCancelMutationVariables, TContext>) =>
    useMutation<UpdateReceiveOrderStatusCancelMutation, TError, UpdateReceiveOrderStatusCancelMutationVariables, TContext>(
      'updateReceiveOrderStatusCancel',
      useFetchData<UpdateReceiveOrderStatusCancelMutation, UpdateReceiveOrderStatusCancelMutationVariables>(UpdateReceiveOrderStatusCancelDocument),
      options
    );
export const UpdateReceiveOrderCorrectionDocument = `
    mutation updateReceiveOrderCorrection($input: UpdateReceiveOrderCorrectionInput!) {
  updateReceiveOrderCorrection(input: $input) {
    receiveOrder {
      id
      receiveOrderId
    }
  }
}
    `;
export const useUpdateReceiveOrderCorrectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReceiveOrderCorrectionMutation, TError, UpdateReceiveOrderCorrectionMutationVariables, TContext>) =>
    useMutation<UpdateReceiveOrderCorrectionMutation, TError, UpdateReceiveOrderCorrectionMutationVariables, TContext>(
      'updateReceiveOrderCorrection',
      useFetchData<UpdateReceiveOrderCorrectionMutation, UpdateReceiveOrderCorrectionMutationVariables>(UpdateReceiveOrderCorrectionDocument),
      options
    );
export const SearchReceivedOrderDetailDocument = `
    query searchReceivedOrderDetail($filter: SearchReceiveOrderHeaderFilter, $sort: [ReceiveOrderHeaderSortEnum], $detailFilter: ReceiveOrderDetailFilter) {
  searchReceiveOrder(filter: $filter, sort: $sort) {
    edges {
      node {
        receiveOrderId
        receiveOrderDate
        customerCode
        deliveryDestinationCode
        deliveryDestinationName
        divisionCode
        salesUserCode
        salesTradeDivision
        deliveryDate
        estimateId
        customer {
          customerName
        }
        salesUser {
          userName
        }
        receiveOrderDetails(filter: $detailFilter) {
          edges {
            node {
              receiveDetailTradeType
              product {
                division {
                  divisionName
                }
                janCode
                attributeName
              }
              receiveOrderDecisionQuantity
              receiveOrderDetailStatus
              productCode
              productName
              receiveOrderQuantity
              salesUnitPrice
              receiveOrderUnit
              receiveOrderPrice
              taxationDivision
              detailMemo
            }
          }
        }
      }
    }
  }
}
    `;
export const useSearchReceivedOrderDetailQuery = <
      TData = SearchReceivedOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchReceivedOrderDetailQueryVariables,
      options?: UseQueryOptions<SearchReceivedOrderDetailQuery, TError, TData>
    ) =>
    useQuery<SearchReceivedOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchReceivedOrderDetail'] : ['searchReceivedOrderDetail', variables],
      useFetchData<SearchReceivedOrderDetailQuery, SearchReceivedOrderDetailQueryVariables>(SearchReceivedOrderDetailDocument).bind(null, variables),
      options
    );

useSearchReceivedOrderDetailQuery.getKey = (variables?: SearchReceivedOrderDetailQueryVariables) => variables === undefined ? ['searchReceivedOrderDetail'] : ['searchReceivedOrderDetail', variables];
;

export const useInfiniteSearchReceivedOrderDetailQuery = <
      TData = SearchReceivedOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchReceivedOrderDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceivedOrderDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceivedOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchReceivedOrderDetail.infinite'] : ['searchReceivedOrderDetail.infinite', variables],
      (metaData) => useFetchData<SearchReceivedOrderDetailQuery, SearchReceivedOrderDetailQueryVariables>(SearchReceivedOrderDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchReceiveOrderDetailDocument = `
    query searchReceiveOrderDetail($filter: SearchReceiveOrderDetailFilter) {
  searchReceiveOrderDetail(filter: $filter) {
    edges {
      node {
        ...SearchReceiveOrderDetailFields
      }
    }
  }
}
    ${SearchReceiveOrderDetailFieldsFragmentDoc}`;
export const useSearchReceiveOrderDetailQuery = <
      TData = SearchReceiveOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderDetailQueryVariables,
      options?: UseQueryOptions<SearchReceiveOrderDetailQuery, TError, TData>
    ) =>
    useQuery<SearchReceiveOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderDetail'] : ['searchReceiveOrderDetail', variables],
      useFetchData<SearchReceiveOrderDetailQuery, SearchReceiveOrderDetailQueryVariables>(SearchReceiveOrderDetailDocument).bind(null, variables),
      options
    );

useSearchReceiveOrderDetailQuery.getKey = (variables?: SearchReceiveOrderDetailQueryVariables) => variables === undefined ? ['searchReceiveOrderDetail'] : ['searchReceiveOrderDetail', variables];
;

export const useInfiniteSearchReceiveOrderDetailQuery = <
      TData = SearchReceiveOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchReceiveOrderDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchReceiveOrderDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchReceiveOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchReceiveOrderDetail.infinite'] : ['searchReceiveOrderDetail.infinite', variables],
      (metaData) => useFetchData<SearchReceiveOrderDetailQuery, SearchReceiveOrderDetailQueryVariables>(SearchReceiveOrderDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerLedgerDocument = `
    query searchCustomerLedger($first: Int, $after: String, $filter1: SearchCustomerSalesFilter, $filter2: SearchDepositCustomerSalesFilter, $filter3: SearchCustomerWithCarryOverFilter, $filter4: SearchDemandCustomerSalesFilter, $sort1: [SalesSortEnum], $sort2: [DepositSortEnum], $sort4: [DemandSortEnum]) {
  searchCustomerSales(
    first: $first
    after: $after
    filter: $filter1
    sort: $sort1
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SalesFields
      }
    }
  }
  searchDepositCustomerSales(
    first: $first
    after: $after
    filter: $filter2
    sort: $sort2
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        versionUuid
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        depositId
        depositDate
        depositRemark
        depositPriceTotal
        clearingPrice
        closingStatusCode
        depositTotalInMonth
        demandTotalInMonth
        depositDetail {
          edges {
            node {
              versionUuid
              createUserCode
              createUserName
              createDate
              updateUserCode
              updateUserName
              updateDate
              depositId
              numbering
              depositDivisionCode
              depositDivisionDetail
              billDate
              depositPrice
              detailMemo
              id
            }
          }
        }
        depositClearingDetail {
          edges {
            node {
              versionUuid
              createUserCode
              createUserName
              createDate
              updateUserCode
              updateUserName
              updateDate
              depositId
              demandId
              clearingPrice
              id
            }
          }
        }
        demandId
        demandCode
        customer {
          customerCode
          customerName
          customerFuri
          demandCode
          collectMethodCode
          collectCycleCode
          collectDate
          demandClosingGroupCode
          transferShareCost
          depositDivision {
            depositDivisionName
          }
          division {
            divisionName
          }
          balanceData
          id
        }
        userCode
        user {
          userCode
          userName
        }
        id
      }
    }
  }
  searchCustomerWithCarryOver(first: $first, after: $after, filter: $filter3) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        salesTaxType
        targetCarryOver
      }
    }
  }
  searchDemandCustomerSales(
    first: $first
    after: $after
    filter: $filter4
    sort: $sort4
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        versionUuid
        createUserCode
        createDate
        createUserName
        updateUserCode
        updateUserName
        updateDate
        demandId
        closingDate
        demandDate
        collectExpectedDate
        demandCode
        salesTaxType
        beforeDemandRemain
        depositPriceTotalInAccountMonth
        carryOverPrice
        excludingTaxTotalDemandPrice
        includedTaxTotalDemandPrice
        currentDemandExpectRemain
        includedTaxDemandClearingPrice
        exciseTaxTotal
        clearingState
        closingStatusCode
        closingTriggerId
        totalDemandFlag
        demandTradeDivision
        demandTaxDetails {
          edges {
            node {
              versionUuid
              demandId
              taxationDivision
              taxExcluded
              exciseTax
            }
          }
        }
        demandTaxAdjustDetails {
          edges {
            node {
              versionUuid
              demandId
              taxationDivision
              beforeAdjustExciseTax
              afterAdjustExciseTax
              adjust
            }
          }
        }
        customer {
          customerName
          customerFuri
        }
      }
    }
  }
}
    ${SalesFieldsFragmentDoc}`;
export const useSearchCustomerLedgerQuery = <
      TData = SearchCustomerLedgerQuery,
      TError = unknown
    >(
      variables?: SearchCustomerLedgerQueryVariables,
      options?: UseQueryOptions<SearchCustomerLedgerQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerLedgerQuery, TError, TData>(
      variables === undefined ? ['searchCustomerLedger'] : ['searchCustomerLedger', variables],
      useFetchData<SearchCustomerLedgerQuery, SearchCustomerLedgerQueryVariables>(SearchCustomerLedgerDocument).bind(null, variables),
      options
    );

useSearchCustomerLedgerQuery.getKey = (variables?: SearchCustomerLedgerQueryVariables) => variables === undefined ? ['searchCustomerLedger'] : ['searchCustomerLedger', variables];
;

export const useInfiniteSearchCustomerLedgerQuery = <
      TData = SearchCustomerLedgerQuery,
      TError = unknown
    >(
      variables?: SearchCustomerLedgerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerLedgerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerLedgerQuery, TError, TData>(
      variables === undefined ? ['searchCustomerLedger.infinite'] : ['searchCustomerLedger.infinite', variables],
      (metaData) => useFetchData<SearchCustomerLedgerQuery, SearchCustomerLedgerQueryVariables>(SearchCustomerLedgerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerSalesMonthlyDocument = `
    query searchCustomerSalesMonthly($first: Int, $after: String, $filter1: SearchCustomerSalesMontylyFilter, $filter2: SearchCustomerWithCarryOverFilter) {
  searchCustomerSalesMonthly(first: $first, after: $after, filter: $filter1) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerSalesMonthlyFields
      }
    }
  }
  searchCustomerWithCarryOver(first: $first, after: $after, filter: $filter2) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        salesTaxType
        targetCarryOver
      }
    }
  }
}
    ${CustomerSalesMonthlyFieldsFragmentDoc}`;
export const useSearchCustomerSalesMonthlyQuery = <
      TData = SearchCustomerSalesMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchCustomerSalesMonthlyQueryVariables,
      options?: UseQueryOptions<SearchCustomerSalesMonthlyQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerSalesMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchCustomerSalesMonthly'] : ['searchCustomerSalesMonthly', variables],
      useFetchData<SearchCustomerSalesMonthlyQuery, SearchCustomerSalesMonthlyQueryVariables>(SearchCustomerSalesMonthlyDocument).bind(null, variables),
      options
    );

useSearchCustomerSalesMonthlyQuery.getKey = (variables?: SearchCustomerSalesMonthlyQueryVariables) => variables === undefined ? ['searchCustomerSalesMonthly'] : ['searchCustomerSalesMonthly', variables];
;

export const useInfiniteSearchCustomerSalesMonthlyQuery = <
      TData = SearchCustomerSalesMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchCustomerSalesMonthlyQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerSalesMonthlyQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerSalesMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchCustomerSalesMonthly.infinite'] : ['searchCustomerSalesMonthly.infinite', variables],
      (metaData) => useFetchData<SearchCustomerSalesMonthlyQuery, SearchCustomerSalesMonthlyQueryVariables>(SearchCustomerSalesMonthlyDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesFromDeliveryOrderIdDocument = `
    query searchSalesFromDeliveryOrderId($first: Int, $after: String, $filter: SearchSalesFromDeliveryOrderIdFilter, $sort: [SalesSortEnum]) {
  searchSalesFromDeliveryOrderId(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        salesId
        demandId
        closingTiming
        closingStatusCode
        demand {
          collectExpectedDate
          customer {
            customerName
          }
          clearingState
        }
      }
    }
  }
}
    `;
export const useSearchSalesFromDeliveryOrderIdQuery = <
      TData = SearchSalesFromDeliveryOrderIdQuery,
      TError = unknown
    >(
      variables?: SearchSalesFromDeliveryOrderIdQueryVariables,
      options?: UseQueryOptions<SearchSalesFromDeliveryOrderIdQuery, TError, TData>
    ) =>
    useQuery<SearchSalesFromDeliveryOrderIdQuery, TError, TData>(
      variables === undefined ? ['searchSalesFromDeliveryOrderId'] : ['searchSalesFromDeliveryOrderId', variables],
      useFetchData<SearchSalesFromDeliveryOrderIdQuery, SearchSalesFromDeliveryOrderIdQueryVariables>(SearchSalesFromDeliveryOrderIdDocument).bind(null, variables),
      options
    );

useSearchSalesFromDeliveryOrderIdQuery.getKey = (variables?: SearchSalesFromDeliveryOrderIdQueryVariables) => variables === undefined ? ['searchSalesFromDeliveryOrderId'] : ['searchSalesFromDeliveryOrderId', variables];
;

export const useInfiniteSearchSalesFromDeliveryOrderIdQuery = <
      TData = SearchSalesFromDeliveryOrderIdQuery,
      TError = unknown
    >(
      variables?: SearchSalesFromDeliveryOrderIdQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesFromDeliveryOrderIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesFromDeliveryOrderIdQuery, TError, TData>(
      variables === undefined ? ['searchSalesFromDeliveryOrderId.infinite'] : ['searchSalesFromDeliveryOrderId.infinite', variables],
      (metaData) => useFetchData<SearchSalesFromDeliveryOrderIdQuery, SearchSalesFromDeliveryOrderIdQueryVariables>(SearchSalesFromDeliveryOrderIdDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTrustSalesDocument = `
    query searchTrustSales($first: Int, $after: String, $filter: SearchTrustSalesFilter, $sort: [SalesSortEnum]) {
  searchTrustSales(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...SalesFields
      }
    }
  }
}
    ${SalesFieldsFragmentDoc}`;
export const useSearchTrustSalesQuery = <
      TData = SearchTrustSalesQuery,
      TError = unknown
    >(
      variables?: SearchTrustSalesQueryVariables,
      options?: UseQueryOptions<SearchTrustSalesQuery, TError, TData>
    ) =>
    useQuery<SearchTrustSalesQuery, TError, TData>(
      variables === undefined ? ['searchTrustSales'] : ['searchTrustSales', variables],
      useFetchData<SearchTrustSalesQuery, SearchTrustSalesQueryVariables>(SearchTrustSalesDocument).bind(null, variables),
      options
    );

useSearchTrustSalesQuery.getKey = (variables?: SearchTrustSalesQueryVariables) => variables === undefined ? ['searchTrustSales'] : ['searchTrustSales', variables];
;

export const useInfiniteSearchTrustSalesQuery = <
      TData = SearchTrustSalesQuery,
      TError = unknown
    >(
      variables?: SearchTrustSalesQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTrustSalesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTrustSalesQuery, TError, TData>(
      variables === undefined ? ['searchTrustSales.infinite'] : ['searchTrustSales.infinite', variables],
      (metaData) => useFetchData<SearchTrustSalesQuery, SearchTrustSalesQueryVariables>(SearchTrustSalesDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesPrintDocument = `
    query searchSalesPrint($first: Int, $after: String, $filter: SearchTrustSalesFilter, $sort: [SalesSortEnum]) {
  searchTrustSales(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        salesId
        customer {
          userDivisionCode
          salesReport {
            reportLayoutCode
            reportLayoutName
            activeReportFlg
          }
        }
      }
    }
  }
}
    `;
export const useSearchSalesPrintQuery = <
      TData = SearchSalesPrintQuery,
      TError = unknown
    >(
      variables?: SearchSalesPrintQueryVariables,
      options?: UseQueryOptions<SearchSalesPrintQuery, TError, TData>
    ) =>
    useQuery<SearchSalesPrintQuery, TError, TData>(
      variables === undefined ? ['searchSalesPrint'] : ['searchSalesPrint', variables],
      useFetchData<SearchSalesPrintQuery, SearchSalesPrintQueryVariables>(SearchSalesPrintDocument).bind(null, variables),
      options
    );

useSearchSalesPrintQuery.getKey = (variables?: SearchSalesPrintQueryVariables) => variables === undefined ? ['searchSalesPrint'] : ['searchSalesPrint', variables];
;

export const useInfiniteSearchSalesPrintQuery = <
      TData = SearchSalesPrintQuery,
      TError = unknown
    >(
      variables?: SearchSalesPrintQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesPrintQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesPrintQuery, TError, TData>(
      variables === undefined ? ['searchSalesPrint.infinite'] : ['searchSalesPrint.infinite', variables],
      (metaData) => useFetchData<SearchSalesPrintQuery, SearchSalesPrintQueryVariables>(SearchSalesPrintDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsCustomerDocument = `
    query searchSalesAnalyticsCustomer($first: Int, $after: String, $filter: SearchSalesAnalyticsCustomerFilter) {
  searchSalesAnalyticsCustomer(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        customerCode
        customerName
        janCode
        productName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
        isSubTotal
        receiveDetailTradeType
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsCustomerQuery = <
      TData = SearchSalesAnalyticsCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsCustomerQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsCustomerQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsCustomer'] : ['searchSalesAnalyticsCustomer', variables],
      useFetchData<SearchSalesAnalyticsCustomerQuery, SearchSalesAnalyticsCustomerQueryVariables>(SearchSalesAnalyticsCustomerDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsCustomerQuery.getKey = (variables?: SearchSalesAnalyticsCustomerQueryVariables) => variables === undefined ? ['searchSalesAnalyticsCustomer'] : ['searchSalesAnalyticsCustomer', variables];
;

export const useInfiniteSearchSalesAnalyticsCustomerQuery = <
      TData = SearchSalesAnalyticsCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsCustomer.infinite'] : ['searchSalesAnalyticsCustomer.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsCustomerQuery, SearchSalesAnalyticsCustomerQueryVariables>(SearchSalesAnalyticsCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsDeliverDocument = `
    query searchSalesAnalyticsDeliver($first: Int, $after: String, $filter: SearchSalesAnalyticsDeliverFilter) {
  searchSalesAnalyticsDeliver(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        deliveryDestinationCode
        deliveryDestinationName
        janCode
        productName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsDeliverQuery = <
      TData = SearchSalesAnalyticsDeliverQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDeliverQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsDeliverQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsDeliverQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDeliver'] : ['searchSalesAnalyticsDeliver', variables],
      useFetchData<SearchSalesAnalyticsDeliverQuery, SearchSalesAnalyticsDeliverQueryVariables>(SearchSalesAnalyticsDeliverDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsDeliverQuery.getKey = (variables?: SearchSalesAnalyticsDeliverQueryVariables) => variables === undefined ? ['searchSalesAnalyticsDeliver'] : ['searchSalesAnalyticsDeliver', variables];
;

export const useInfiniteSearchSalesAnalyticsDeliverQuery = <
      TData = SearchSalesAnalyticsDeliverQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDeliverQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsDeliverQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsDeliverQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDeliver.infinite'] : ['searchSalesAnalyticsDeliver.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsDeliverQuery, SearchSalesAnalyticsDeliverQueryVariables>(SearchSalesAnalyticsDeliverDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsProductDocument = `
    query searchSalesAnalyticsProduct($first: Int, $after: String, $filter: SearchSalesAnalyticsProductFilter) {
  searchSalesAnalyticsProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productCode
        productName
        customerCode
        customerName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
        isSubTotal
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsProductQuery = <
      TData = SearchSalesAnalyticsProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsProductQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsProductQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsProduct'] : ['searchSalesAnalyticsProduct', variables],
      useFetchData<SearchSalesAnalyticsProductQuery, SearchSalesAnalyticsProductQueryVariables>(SearchSalesAnalyticsProductDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsProductQuery.getKey = (variables?: SearchSalesAnalyticsProductQueryVariables) => variables === undefined ? ['searchSalesAnalyticsProduct'] : ['searchSalesAnalyticsProduct', variables];
;

export const useInfiniteSearchSalesAnalyticsProductQuery = <
      TData = SearchSalesAnalyticsProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsProduct.infinite'] : ['searchSalesAnalyticsProduct.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsProductQuery, SearchSalesAnalyticsProductQueryVariables>(SearchSalesAnalyticsProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsSalesUserDocument = `
    query searchSalesAnalyticsSalesUser($first: Int, $after: String, $filter: SearchSalesAnalyticsSalesUserFilter) {
  searchSalesAnalyticsSalesUser(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        userCode
        userName
        customerCode
        customerName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
        isSubTotal
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsSalesUserQuery = <
      TData = SearchSalesAnalyticsSalesUserQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsSalesUserQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsSalesUserQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsSalesUserQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsSalesUser'] : ['searchSalesAnalyticsSalesUser', variables],
      useFetchData<SearchSalesAnalyticsSalesUserQuery, SearchSalesAnalyticsSalesUserQueryVariables>(SearchSalesAnalyticsSalesUserDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsSalesUserQuery.getKey = (variables?: SearchSalesAnalyticsSalesUserQueryVariables) => variables === undefined ? ['searchSalesAnalyticsSalesUser'] : ['searchSalesAnalyticsSalesUser', variables];
;

export const useInfiniteSearchSalesAnalyticsSalesUserQuery = <
      TData = SearchSalesAnalyticsSalesUserQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsSalesUserQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsSalesUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsSalesUserQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsSalesUser.infinite'] : ['searchSalesAnalyticsSalesUser.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsSalesUserQuery, SearchSalesAnalyticsSalesUserQueryVariables>(SearchSalesAnalyticsSalesUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsDivisionDocument = `
    query searchSalesAnalyticsDivision($first: Int, $after: String, $filter: SearchSalesAnalyticsDivisionFilter) {
  searchSalesAnalyticsDivision(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        divisionCode
        divisionName
        customerCode
        customerName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsDivisionQuery = <
      TData = SearchSalesAnalyticsDivisionQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDivisionQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsDivisionQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDivision'] : ['searchSalesAnalyticsDivision', variables],
      useFetchData<SearchSalesAnalyticsDivisionQuery, SearchSalesAnalyticsDivisionQueryVariables>(SearchSalesAnalyticsDivisionDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsDivisionQuery.getKey = (variables?: SearchSalesAnalyticsDivisionQueryVariables) => variables === undefined ? ['searchSalesAnalyticsDivision'] : ['searchSalesAnalyticsDivision', variables];
;

export const useInfiniteSearchSalesAnalyticsDivisionQuery = <
      TData = SearchSalesAnalyticsDivisionQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsDivisionQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDivision.infinite'] : ['searchSalesAnalyticsDivision.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsDivisionQuery, SearchSalesAnalyticsDivisionQueryVariables>(SearchSalesAnalyticsDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsDivisionProductDocument = `
    query searchSalesAnalyticsDivisionProduct($first: Int, $after: String, $filter: SearchSalesAnalyticsDivisionProductFilter) {
  searchSalesAnalyticsDivisionProduct(
    first: $first
    after: $after
    filter: $filter
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        divisionCode
        divisionName
        janCode
        productName
        netSalesAmount
        compositionRatio
        netSalesQuantity
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsDivisionProductQuery = <
      TData = SearchSalesAnalyticsDivisionProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDivisionProductQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsDivisionProductQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsDivisionProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDivisionProduct'] : ['searchSalesAnalyticsDivisionProduct', variables],
      useFetchData<SearchSalesAnalyticsDivisionProductQuery, SearchSalesAnalyticsDivisionProductQueryVariables>(SearchSalesAnalyticsDivisionProductDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsDivisionProductQuery.getKey = (variables?: SearchSalesAnalyticsDivisionProductQueryVariables) => variables === undefined ? ['searchSalesAnalyticsDivisionProduct'] : ['searchSalesAnalyticsDivisionProduct', variables];
;

export const useInfiniteSearchSalesAnalyticsDivisionProductQuery = <
      TData = SearchSalesAnalyticsDivisionProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsDivisionProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsDivisionProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsDivisionProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsDivisionProduct.infinite'] : ['searchSalesAnalyticsDivisionProduct.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsDivisionProductQuery, SearchSalesAnalyticsDivisionProductQueryVariables>(SearchSalesAnalyticsDivisionProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesAnalyticsComparisontableDocument = `
    query searchSalesAnalyticsComparisontable($first: Int, $after: String, $filter: SearchSalesAnalyticsComparisonTableFilter) {
  searchSalesAnalyticsComparisontable(
    first: $first
    after: $after
    filter: $filter
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        userCode
        userName
        divisionCode
        divisionName
        aggregateResults
      }
    }
  }
}
    `;
export const useSearchSalesAnalyticsComparisontableQuery = <
      TData = SearchSalesAnalyticsComparisontableQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsComparisontableQueryVariables,
      options?: UseQueryOptions<SearchSalesAnalyticsComparisontableQuery, TError, TData>
    ) =>
    useQuery<SearchSalesAnalyticsComparisontableQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsComparisontable'] : ['searchSalesAnalyticsComparisontable', variables],
      useFetchData<SearchSalesAnalyticsComparisontableQuery, SearchSalesAnalyticsComparisontableQueryVariables>(SearchSalesAnalyticsComparisontableDocument).bind(null, variables),
      options
    );

useSearchSalesAnalyticsComparisontableQuery.getKey = (variables?: SearchSalesAnalyticsComparisontableQueryVariables) => variables === undefined ? ['searchSalesAnalyticsComparisontable'] : ['searchSalesAnalyticsComparisontable', variables];
;

export const useInfiniteSearchSalesAnalyticsComparisontableQuery = <
      TData = SearchSalesAnalyticsComparisontableQuery,
      TError = unknown
    >(
      variables?: SearchSalesAnalyticsComparisontableQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesAnalyticsComparisontableQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesAnalyticsComparisontableQuery, TError, TData>(
      variables === undefined ? ['searchSalesAnalyticsComparisontable.infinite'] : ['searchSalesAnalyticsComparisontable.infinite', variables],
      (metaData) => useFetchData<SearchSalesAnalyticsComparisontableQuery, SearchSalesAnalyticsComparisontableQueryVariables>(SearchSalesAnalyticsComparisontableDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesChangingListCustomerDocument = `
    query searchSalesChangingListCustomer($first: Int, $after: String, $filter: SearchSalesChangingListCustomerFilter) {
  searchSalesChangingListCustomer(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        customerCode
        customerName
        divisionCode
        divisionName
        salesUserCode
        userName
        budgetMonth1
        budgetMonth2
        budgetMonth3
        budgetMonth4
        budgetMonth5
        budgetMonth6
        budgetMonth7
        budgetMonth8
        budgetMonth9
        budgetMonth10
        budgetMonth11
        budgetMonth12
        budgetTotals
        salesMonth1
        salesMonth2
        salesMonth3
        salesMonth4
        salesMonth5
        salesMonth6
        salesMonth7
        salesMonth8
        salesMonth9
        salesMonth10
        salesMonth11
        salesMonth12
        salesTotals
        differenceMonth1
        differenceMonth2
        differenceMonth3
        differenceMonth4
        differenceMonth5
        differenceMonth6
        differenceMonth7
        differenceMonth8
        differenceMonth9
        differenceMonth10
        differenceMonth11
        differenceMonth12
        differenceTotals
        achievementRate1
        achievementRate2
        achievementRate3
        achievementRate4
        achievementRate5
        achievementRate6
        achievementRate7
        achievementRate8
        achievementRate9
        achievementRate10
        achievementRate11
        achievementRate12
        achievementRateTotals
        salesQuantityMonth1
        salesQuantityMonth2
        salesQuantityMonth3
        salesQuantityMonth4
        salesQuantityMonth5
        salesQuantityMonth6
        salesQuantityMonth7
        salesQuantityMonth8
        salesQuantityMonth9
        salesQuantityMonth10
        salesQuantityMonth11
        salesQuantityMonth12
        salesQuantityTotals
      }
    }
  }
}
    `;
export const useSearchSalesChangingListCustomerQuery = <
      TData = SearchSalesChangingListCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesChangingListCustomerQueryVariables,
      options?: UseQueryOptions<SearchSalesChangingListCustomerQuery, TError, TData>
    ) =>
    useQuery<SearchSalesChangingListCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesChangingListCustomer'] : ['searchSalesChangingListCustomer', variables],
      useFetchData<SearchSalesChangingListCustomerQuery, SearchSalesChangingListCustomerQueryVariables>(SearchSalesChangingListCustomerDocument).bind(null, variables),
      options
    );

useSearchSalesChangingListCustomerQuery.getKey = (variables?: SearchSalesChangingListCustomerQueryVariables) => variables === undefined ? ['searchSalesChangingListCustomer'] : ['searchSalesChangingListCustomer', variables];
;

export const useInfiniteSearchSalesChangingListCustomerQuery = <
      TData = SearchSalesChangingListCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesChangingListCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesChangingListCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesChangingListCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesChangingListCustomer.infinite'] : ['searchSalesChangingListCustomer.infinite', variables],
      (metaData) => useFetchData<SearchSalesChangingListCustomerQuery, SearchSalesChangingListCustomerQueryVariables>(SearchSalesChangingListCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesChangingListProductDocument = `
    query searchSalesChangingListProduct($first: Int, $after: String, $filter: SearchSalesChangingListProductFilter) {
  searchSalesChangingListProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productName
        salesMonth1
        salesMonth2
        salesMonth3
        salesMonth4
        salesMonth5
        salesMonth6
        salesMonth7
        salesMonth8
        salesMonth9
        salesMonth10
        salesMonth11
        salesMonth12
        salesTotals
        salesQuantityMonth1
        salesQuantityMonth2
        salesQuantityMonth3
        salesQuantityMonth4
        salesQuantityMonth5
        salesQuantityMonth6
        salesQuantityMonth7
        salesQuantityMonth8
        salesQuantityMonth9
        salesQuantityMonth10
        salesQuantityMonth11
        salesQuantityMonth12
        salesQuantityTotals
        productGroup1
        productGroup2
        productGroup3
        divisionCode
        divisionName
      }
    }
  }
}
    `;
export const useSearchSalesChangingListProductQuery = <
      TData = SearchSalesChangingListProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesChangingListProductQueryVariables,
      options?: UseQueryOptions<SearchSalesChangingListProductQuery, TError, TData>
    ) =>
    useQuery<SearchSalesChangingListProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesChangingListProduct'] : ['searchSalesChangingListProduct', variables],
      useFetchData<SearchSalesChangingListProductQuery, SearchSalesChangingListProductQueryVariables>(SearchSalesChangingListProductDocument).bind(null, variables),
      options
    );

useSearchSalesChangingListProductQuery.getKey = (variables?: SearchSalesChangingListProductQueryVariables) => variables === undefined ? ['searchSalesChangingListProduct'] : ['searchSalesChangingListProduct', variables];
;

export const useInfiniteSearchSalesChangingListProductQuery = <
      TData = SearchSalesChangingListProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesChangingListProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesChangingListProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesChangingListProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesChangingListProduct.infinite'] : ['searchSalesChangingListProduct.infinite', variables],
      (metaData) => useFetchData<SearchSalesChangingListProductQuery, SearchSalesChangingListProductQueryVariables>(SearchSalesChangingListProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDailyCustomerDocument = `
    query searchSalesDailyCustomer($first: Int, $after: String, $filter: SearchSalesDailyCustomerFilter) {
  searchSalesDailyCustomer(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        customerCode
        customerName
        salesUserCode
        userName
        salesTotals
        returnTotals
        discountTotals
        othersTotals
        netSales
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesDailyCustomerQuery = <
      TData = SearchSalesDailyCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyCustomerQueryVariables,
      options?: UseQueryOptions<SearchSalesDailyCustomerQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDailyCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyCustomer'] : ['searchSalesDailyCustomer', variables],
      useFetchData<SearchSalesDailyCustomerQuery, SearchSalesDailyCustomerQueryVariables>(SearchSalesDailyCustomerDocument).bind(null, variables),
      options
    );

useSearchSalesDailyCustomerQuery.getKey = (variables?: SearchSalesDailyCustomerQueryVariables) => variables === undefined ? ['searchSalesDailyCustomer'] : ['searchSalesDailyCustomer', variables];
;

export const useInfiniteSearchSalesDailyCustomerQuery = <
      TData = SearchSalesDailyCustomerQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyCustomerQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDailyCustomerQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDailyCustomerQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyCustomer.infinite'] : ['searchSalesDailyCustomer.infinite', variables],
      (metaData) => useFetchData<SearchSalesDailyCustomerQuery, SearchSalesDailyCustomerQueryVariables>(SearchSalesDailyCustomerDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDailyProductDocument = `
    query searchSalesDailyProduct($first: Int, $after: String, $filter: SearchSalesDailyProductFilter) {
  searchSalesDailyProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productName
        salesTotals
        returnTotals
        discountTotals
        othersTotals
        netSales
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesDailyProductQuery = <
      TData = SearchSalesDailyProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyProductQueryVariables,
      options?: UseQueryOptions<SearchSalesDailyProductQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDailyProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyProduct'] : ['searchSalesDailyProduct', variables],
      useFetchData<SearchSalesDailyProductQuery, SearchSalesDailyProductQueryVariables>(SearchSalesDailyProductDocument).bind(null, variables),
      options
    );

useSearchSalesDailyProductQuery.getKey = (variables?: SearchSalesDailyProductQueryVariables) => variables === undefined ? ['searchSalesDailyProduct'] : ['searchSalesDailyProduct', variables];
;

export const useInfiniteSearchSalesDailyProductQuery = <
      TData = SearchSalesDailyProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDailyProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDailyProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyProduct.infinite'] : ['searchSalesDailyProduct.infinite', variables],
      (metaData) => useFetchData<SearchSalesDailyProductQuery, SearchSalesDailyProductQueryVariables>(SearchSalesDailyProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDailySalesuserDocument = `
    query searchSalesDailySalesuser($first: Int, $after: String, $filter: SearchSalesDailySalesUserFilter) {
  searchSalesDailySalesuser(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        salesUserCode
        userName
        salesTotals
        returnTotals
        discountTotals
        othersTotals
        netSales
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesDailySalesuserQuery = <
      TData = SearchSalesDailySalesuserQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailySalesuserQueryVariables,
      options?: UseQueryOptions<SearchSalesDailySalesuserQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDailySalesuserQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailySalesuser'] : ['searchSalesDailySalesuser', variables],
      useFetchData<SearchSalesDailySalesuserQuery, SearchSalesDailySalesuserQueryVariables>(SearchSalesDailySalesuserDocument).bind(null, variables),
      options
    );

useSearchSalesDailySalesuserQuery.getKey = (variables?: SearchSalesDailySalesuserQueryVariables) => variables === undefined ? ['searchSalesDailySalesuser'] : ['searchSalesDailySalesuser', variables];
;

export const useInfiniteSearchSalesDailySalesuserQuery = <
      TData = SearchSalesDailySalesuserQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailySalesuserQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDailySalesuserQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDailySalesuserQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailySalesuser.infinite'] : ['searchSalesDailySalesuser.infinite', variables],
      (metaData) => useFetchData<SearchSalesDailySalesuserQuery, SearchSalesDailySalesuserQueryVariables>(SearchSalesDailySalesuserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDailyDivisionDocument = `
    query searchSalesDailyDivision($first: Int, $after: String, $filter: SearchSalesDailyDivisionFilter) {
  searchSalesDailyDivision(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        divisionCode
        divisionName
        salesTotals
        returnTotals
        discountTotals
        othersTotals
        netSales
        grossProfit
        roundGrossProfitrate
      }
    }
  }
}
    `;
export const useSearchSalesDailyDivisionQuery = <
      TData = SearchSalesDailyDivisionQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyDivisionQueryVariables,
      options?: UseQueryOptions<SearchSalesDailyDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDailyDivisionQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyDivision'] : ['searchSalesDailyDivision', variables],
      useFetchData<SearchSalesDailyDivisionQuery, SearchSalesDailyDivisionQueryVariables>(SearchSalesDailyDivisionDocument).bind(null, variables),
      options
    );

useSearchSalesDailyDivisionQuery.getKey = (variables?: SearchSalesDailyDivisionQueryVariables) => variables === undefined ? ['searchSalesDailyDivision'] : ['searchSalesDailyDivision', variables];
;

export const useInfiniteSearchSalesDailyDivisionQuery = <
      TData = SearchSalesDailyDivisionQuery,
      TError = unknown
    >(
      variables?: SearchSalesDailyDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDailyDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDailyDivisionQuery, TError, TData>(
      variables === undefined ? ['searchSalesDailyDivision.infinite'] : ['searchSalesDailyDivision.infinite', variables],
      (metaData) => useFetchData<SearchSalesDailyDivisionQuery, SearchSalesDailyDivisionQueryVariables>(SearchSalesDailyDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDetailDocument = `
    query searchSalesDetail($filter: SearchSalesFilter, $sort: [SalesSortEnum], $detailFilter: SalesDetailFilter) {
  searchSales(filter: $filter, sort: $sort) {
    edges {
      node {
        ...SalesDetailListHeaderFields
      }
    }
  }
}
    ${SalesDetailListHeaderFieldsFragmentDoc}`;
export const useSearchSalesDetailQuery = <
      TData = SearchSalesDetailQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailQueryVariables,
      options?: UseQueryOptions<SearchSalesDetailQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDetailQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetail'] : ['searchSalesDetail', variables],
      useFetchData<SearchSalesDetailQuery, SearchSalesDetailQueryVariables>(SearchSalesDetailDocument).bind(null, variables),
      options
    );

useSearchSalesDetailQuery.getKey = (variables?: SearchSalesDetailQueryVariables) => variables === undefined ? ['searchSalesDetail'] : ['searchSalesDetail', variables];
;

export const useInfiniteSearchSalesDetailQuery = <
      TData = SearchSalesDetailQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDetailQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetail.infinite'] : ['searchSalesDetail.infinite', variables],
      (metaData) => useFetchData<SearchSalesDetailQuery, SearchSalesDetailQueryVariables>(SearchSalesDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDetailProductDocument = `
    query searchSalesDetailProduct($filter: SearchSalesFilter, $sort: [SalesDetailSortEnum]) {
  searchSalesDetailProduct(filter: $filter, sort: $sort) {
    edges {
      node {
        janCode
        productName
        salesId
        receiveDetailTradeType
        receiveOrderQuantity
        salesUnitPrice
        sellingUnitPrice
        sellingPrice
        taxationDivision
        detailMemo
        deliveryOrderId
        sales {
          createUserCode
          createUserName
          salesDate
          customerCode
          customer {
            customerName
          }
          divisionCode
          salesTradeDivision
          closingTiming
          closingStatusCode
          salesTaxType
          deliveryDestinationCode
          deliveryDestinationName
          salesRemark
          salesUserCode
          salesUser {
            userName
          }
          salesVoucherType
          receiveOrderId
          receiveOrder {
            estimateId
            receiveOrderRemarks
            receiveOrderType
            receiveOrderMemo
          }
          trustSalesDivision
          trustInventory {
            trustInventoryId
          }
        }
        shipmentDetail {
          deliveryOrderDetailStatus
          shipment {
            deliveryOrderMemo
          }
        }
        totalQuantity
        totalTaxExcluded
      }
    }
  }
}
    `;
export const useSearchSalesDetailProductQuery = <
      TData = SearchSalesDetailProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailProductQueryVariables,
      options?: UseQueryOptions<SearchSalesDetailProductQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDetailProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetailProduct'] : ['searchSalesDetailProduct', variables],
      useFetchData<SearchSalesDetailProductQuery, SearchSalesDetailProductQueryVariables>(SearchSalesDetailProductDocument).bind(null, variables),
      options
    );

useSearchSalesDetailProductQuery.getKey = (variables?: SearchSalesDetailProductQueryVariables) => variables === undefined ? ['searchSalesDetailProduct'] : ['searchSalesDetailProduct', variables];
;

export const useInfiniteSearchSalesDetailProductQuery = <
      TData = SearchSalesDetailProductQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDetailProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDetailProductQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetailProduct.infinite'] : ['searchSalesDetailProduct.infinite', variables],
      (metaData) => useFetchData<SearchSalesDetailProductQuery, SearchSalesDetailProductQueryVariables>(SearchSalesDetailProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesDetailWTaxDocument = `
    query searchSalesDetailWTax($filter: SalesDetailWTaxFilter) {
  salesDetailWTax(filter: $filter) {
    summary {
      ...SalesDetailWTaxSummaryFields
    }
    details {
      ...SalesDetailWTaxDetailFields
    }
  }
}
    ${SalesDetailWTaxSummaryFieldsFragmentDoc}
${SalesDetailWTaxDetailFieldsFragmentDoc}`;
export const useSearchSalesDetailWTaxQuery = <
      TData = SearchSalesDetailWTaxQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailWTaxQueryVariables,
      options?: UseQueryOptions<SearchSalesDetailWTaxQuery, TError, TData>
    ) =>
    useQuery<SearchSalesDetailWTaxQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetailWTax'] : ['searchSalesDetailWTax', variables],
      useFetchData<SearchSalesDetailWTaxQuery, SearchSalesDetailWTaxQueryVariables>(SearchSalesDetailWTaxDocument).bind(null, variables),
      options
    );

useSearchSalesDetailWTaxQuery.getKey = (variables?: SearchSalesDetailWTaxQueryVariables) => variables === undefined ? ['searchSalesDetailWTax'] : ['searchSalesDetailWTax', variables];
;

export const useInfiniteSearchSalesDetailWTaxQuery = <
      TData = SearchSalesDetailWTaxQuery,
      TError = unknown
    >(
      variables?: SearchSalesDetailWTaxQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesDetailWTaxQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesDetailWTaxQuery, TError, TData>(
      variables === undefined ? ['searchSalesDetailWTax.infinite'] : ['searchSalesDetailWTax.infinite', variables],
      (metaData) => useFetchData<SearchSalesDetailWTaxQuery, SearchSalesDetailWTaxQueryVariables>(SearchSalesDetailWTaxDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesForTrustDocument = `
    query searchSalesForTrust($first: Int, $after: String, $filter: SearchTrustSalesFilter, $sort: [SalesSortEnum]) {
  searchTrustSales(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...SalesForTrustFields
      }
    }
  }
}
    ${SalesForTrustFieldsFragmentDoc}`;
export const useSearchSalesForTrustQuery = <
      TData = SearchSalesForTrustQuery,
      TError = unknown
    >(
      variables?: SearchSalesForTrustQueryVariables,
      options?: UseQueryOptions<SearchSalesForTrustQuery, TError, TData>
    ) =>
    useQuery<SearchSalesForTrustQuery, TError, TData>(
      variables === undefined ? ['searchSalesForTrust'] : ['searchSalesForTrust', variables],
      useFetchData<SearchSalesForTrustQuery, SearchSalesForTrustQueryVariables>(SearchSalesForTrustDocument).bind(null, variables),
      options
    );

useSearchSalesForTrustQuery.getKey = (variables?: SearchSalesForTrustQueryVariables) => variables === undefined ? ['searchSalesForTrust'] : ['searchSalesForTrust', variables];
;

export const useInfiniteSearchSalesForTrustQuery = <
      TData = SearchSalesForTrustQuery,
      TError = unknown
    >(
      variables?: SearchSalesForTrustQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesForTrustQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesForTrustQuery, TError, TData>(
      variables === undefined ? ['searchSalesForTrust.infinite'] : ['searchSalesForTrust.infinite', variables],
      (metaData) => useFetchData<SearchSalesForTrustQuery, SearchSalesForTrustQueryVariables>(SearchSalesForTrustDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SendOrderDocument = `
    query sendOrder($id: ID!) {
  sendOrder(id: $id) {
    ...SendOrderFields
  }
}
    ${SendOrderFieldsFragmentDoc}`;
export const useSendOrderQuery = <
      TData = SendOrderQuery,
      TError = unknown
    >(
      variables: SendOrderQueryVariables,
      options?: UseQueryOptions<SendOrderQuery, TError, TData>
    ) =>
    useQuery<SendOrderQuery, TError, TData>(
      ['sendOrder', variables],
      useFetchData<SendOrderQuery, SendOrderQueryVariables>(SendOrderDocument).bind(null, variables),
      options
    );

useSendOrderQuery.getKey = (variables: SendOrderQueryVariables) => ['sendOrder', variables];
;

export const useInfiniteSendOrderQuery = <
      TData = SendOrderQuery,
      TError = unknown
    >(
      variables: SendOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SendOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SendOrderQuery, TError, TData>(
      ['sendOrder.infinite', variables],
      (metaData) => useFetchData<SendOrderQuery, SendOrderQueryVariables>(SendOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateSendOrderDocument = `
    mutation createSendOrder($input: CreateSendOrderInput!) {
  createSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useCreateSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSendOrderMutation, TError, CreateSendOrderMutationVariables, TContext>) =>
    useMutation<CreateSendOrderMutation, TError, CreateSendOrderMutationVariables, TContext>(
      'createSendOrder',
      useFetchData<CreateSendOrderMutation, CreateSendOrderMutationVariables>(CreateSendOrderDocument),
      options
    );
export const CreateReturnSendOrderDocument = `
    mutation createReturnSendOrder($input: CreateReturnSendOrderInput!) {
  createReturnSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useCreateReturnSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReturnSendOrderMutation, TError, CreateReturnSendOrderMutationVariables, TContext>) =>
    useMutation<CreateReturnSendOrderMutation, TError, CreateReturnSendOrderMutationVariables, TContext>(
      'createReturnSendOrder',
      useFetchData<CreateReturnSendOrderMutation, CreateReturnSendOrderMutationVariables>(CreateReturnSendOrderDocument),
      options
    );
export const UpdateSendOrderDocument = `
    mutation updateSendOrder($input: UpdateSendOrderInput!) {
  updateSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useUpdateSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderMutation, TError, UpdateSendOrderMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderMutation, TError, UpdateSendOrderMutationVariables, TContext>(
      'updateSendOrder',
      useFetchData<UpdateSendOrderMutation, UpdateSendOrderMutationVariables>(UpdateSendOrderDocument),
      options
    );
export const UpdateReturnSendOrderDocument = `
    mutation updateReturnSendOrder($input: UpdateReturnSendOrderInput!) {
  updateReturnSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useUpdateReturnSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReturnSendOrderMutation, TError, UpdateReturnSendOrderMutationVariables, TContext>) =>
    useMutation<UpdateReturnSendOrderMutation, TError, UpdateReturnSendOrderMutationVariables, TContext>(
      'updateReturnSendOrder',
      useFetchData<UpdateReturnSendOrderMutation, UpdateReturnSendOrderMutationVariables>(UpdateReturnSendOrderDocument),
      options
    );
export const UpdateSendOrderBulkApprovalDocument = `
    mutation updateSendOrderBulkApproval($input: UpdateSendOrderBulkApprovalInput!) {
  updateSendOrderBulkApproval(input: $input) {
    result
  }
}
    `;
export const useUpdateSendOrderBulkApprovalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderBulkApprovalMutation, TError, UpdateSendOrderBulkApprovalMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderBulkApprovalMutation, TError, UpdateSendOrderBulkApprovalMutationVariables, TContext>(
      'updateSendOrderBulkApproval',
      useFetchData<UpdateSendOrderBulkApprovalMutation, UpdateSendOrderBulkApprovalMutationVariables>(UpdateSendOrderBulkApprovalDocument),
      options
    );
export const DeleteSendOrderDocument = `
    mutation deleteSendOrder($input: DeleteSendOrderInput!) {
  deleteSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useDeleteSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSendOrderMutation, TError, DeleteSendOrderMutationVariables, TContext>) =>
    useMutation<DeleteSendOrderMutation, TError, DeleteSendOrderMutationVariables, TContext>(
      'deleteSendOrder',
      useFetchData<DeleteSendOrderMutation, DeleteSendOrderMutationVariables>(DeleteSendOrderDocument),
      options
    );
export const DeleteReturnSendOrderDocument = `
    mutation deleteReturnSendOrder($input: DeleteReturnSendOrderInput!) {
  deleteReturnSendOrder(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useDeleteReturnSendOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReturnSendOrderMutation, TError, DeleteReturnSendOrderMutationVariables, TContext>) =>
    useMutation<DeleteReturnSendOrderMutation, TError, DeleteReturnSendOrderMutationVariables, TContext>(
      'deleteReturnSendOrder',
      useFetchData<DeleteReturnSendOrderMutation, DeleteReturnSendOrderMutationVariables>(DeleteReturnSendOrderDocument),
      options
    );
export const UpdateSendOrderApprovalDocument = `
    mutation updateSendOrderApproval($input: UpdateSendOrderApprovalInput!) {
  updateSendOrderApproval(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useUpdateSendOrderApprovalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderApprovalMutation, TError, UpdateSendOrderApprovalMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderApprovalMutation, TError, UpdateSendOrderApprovalMutationVariables, TContext>(
      'updateSendOrderApproval',
      useFetchData<UpdateSendOrderApprovalMutation, UpdateSendOrderApprovalMutationVariables>(UpdateSendOrderApprovalDocument),
      options
    );
export const UpdateSendOrderRemandDocument = `
    mutation updateSendOrderRemand($input: UpdateSendOrderRemandInput!) {
  updateSendOrderRemand(input: $input) {
    sendOrder {
      ...SendOrderMutationFields
    }
  }
}
    ${SendOrderMutationFieldsFragmentDoc}`;
export const useUpdateSendOrderRemandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderRemandMutation, TError, UpdateSendOrderRemandMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderRemandMutation, TError, UpdateSendOrderRemandMutationVariables, TContext>(
      'updateSendOrderRemand',
      useFetchData<UpdateSendOrderRemandMutation, UpdateSendOrderRemandMutationVariables>(UpdateSendOrderRemandDocument),
      options
    );
export const SearchVendorForSendOrderDocument = `
    query searchVendorForSendOrder($id: ID!) {
  vendor(id: $id) {
    ...VendorForSendOrderFields
  }
}
    ${VendorForSendOrderFieldsFragmentDoc}`;
export const useSearchVendorForSendOrderQuery = <
      TData = SearchVendorForSendOrderQuery,
      TError = unknown
    >(
      variables: SearchVendorForSendOrderQueryVariables,
      options?: UseQueryOptions<SearchVendorForSendOrderQuery, TError, TData>
    ) =>
    useQuery<SearchVendorForSendOrderQuery, TError, TData>(
      ['searchVendorForSendOrder', variables],
      useFetchData<SearchVendorForSendOrderQuery, SearchVendorForSendOrderQueryVariables>(SearchVendorForSendOrderDocument).bind(null, variables),
      options
    );

useSearchVendorForSendOrderQuery.getKey = (variables: SearchVendorForSendOrderQueryVariables) => ['searchVendorForSendOrder', variables];
;

export const useInfiniteSearchVendorForSendOrderQuery = <
      TData = SearchVendorForSendOrderQuery,
      TError = unknown
    >(
      variables: SearchVendorForSendOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SearchVendorForSendOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchVendorForSendOrderQuery, TError, TData>(
      ['searchVendorForSendOrder.infinite', variables],
      (metaData) => useFetchData<SearchVendorForSendOrderQuery, SearchVendorForSendOrderQueryVariables>(SearchVendorForSendOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchWarehouseForSendOrderDocument = `
    query searchWarehouseForSendOrder($first: Int, $after: String, $filter: SearchWarehouseFilter, $sort: [WarehouseSortEnum]) {
  searchWarehouse(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WarehouseForSendOrderFields
      }
    }
  }
}
    ${WarehouseForSendOrderFieldsFragmentDoc}`;
export const useSearchWarehouseForSendOrderQuery = <
      TData = SearchWarehouseForSendOrderQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseForSendOrderQueryVariables,
      options?: UseQueryOptions<SearchWarehouseForSendOrderQuery, TError, TData>
    ) =>
    useQuery<SearchWarehouseForSendOrderQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseForSendOrder'] : ['searchWarehouseForSendOrder', variables],
      useFetchData<SearchWarehouseForSendOrderQuery, SearchWarehouseForSendOrderQueryVariables>(SearchWarehouseForSendOrderDocument).bind(null, variables),
      options
    );

useSearchWarehouseForSendOrderQuery.getKey = (variables?: SearchWarehouseForSendOrderQueryVariables) => variables === undefined ? ['searchWarehouseForSendOrder'] : ['searchWarehouseForSendOrder', variables];
;

export const useInfiniteSearchWarehouseForSendOrderQuery = <
      TData = SearchWarehouseForSendOrderQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseForSendOrderQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWarehouseForSendOrderQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWarehouseForSendOrderQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseForSendOrder.infinite'] : ['searchWarehouseForSendOrder.infinite', variables],
      (metaData) => useFetchData<SearchWarehouseForSendOrderQuery, SearchWarehouseForSendOrderQueryVariables>(SearchWarehouseForSendOrderDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSendOrderDetailDocument = `
    query searchSendOrderDetail($first: Int, $after: String, $filter: SearchSendOrderDetailFilter, $sort: [SendOrderDetailSortEnum]) {
  searchSendOrderDetail(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        orderId
        numbering
        frontNumbering
        orderTradeTypeCode
        orderDetailStatus
        janCode
        productCode
        productName
        warehouseCode
        orderQuantity
        totalQuantity
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        purchasePrice
        purchasePriceDollar
        detailMemo
        receivedQuantity
        taxationDivision
        product {
          productName
          attr1
          attr2
          clothGroup
          productGroup1 {
            productGroupName
          }
          productGroup2 {
            productGroupName
          }
          productGroup3 {
            productGroupName
          }
          division {
            divisionCode
            divisionName
          }
          unitYenDecimalDigits
          unitDollarDecimalDigits
          quantityDecimalDigits
        }
        Warehouse {
          divisionCode
        }
        sendOrder {
          orderId
          orderDate
          deliveryDate
          orderType
          orderMemo
          vendorCode
          vendorTradeDivision
          vendorTaxType
          shippingTypeCode
          shippingCode
          poCode
          orderRemarks
          vendor {
            vendorName
          }
        }
      }
    }
  }
}
    `;
export const useSearchSendOrderDetailQuery = <
      TData = SearchSendOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderDetailQueryVariables,
      options?: UseQueryOptions<SearchSendOrderDetailQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderDetail'] : ['searchSendOrderDetail', variables],
      useFetchData<SearchSendOrderDetailQuery, SearchSendOrderDetailQueryVariables>(SearchSendOrderDetailDocument).bind(null, variables),
      options
    );

useSearchSendOrderDetailQuery.getKey = (variables?: SearchSendOrderDetailQueryVariables) => variables === undefined ? ['searchSendOrderDetail'] : ['searchSendOrderDetail', variables];
;

export const useInfiniteSearchSendOrderDetailQuery = <
      TData = SearchSendOrderDetailQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderDetailQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderDetail.infinite'] : ['searchSendOrderDetail.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderDetailQuery, SearchSendOrderDetailQueryVariables>(SearchSendOrderDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSendOrderLotDocument = `
    query searchSendOrderLot($first: Int, $after: String, $filter: SearchSendOrderLotFilter, $sort: [SendOrderLotSortEnum]) {
  searchSendOrderLot(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SendOrderLotFields
        productVariants {
          edges {
            node {
              lotGroupCode
            }
          }
        }
      }
    }
  }
}
    ${SendOrderLotFieldsFragmentDoc}`;
export const useSearchSendOrderLotQuery = <
      TData = SearchSendOrderLotQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderLotQueryVariables,
      options?: UseQueryOptions<SearchSendOrderLotQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderLotQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderLot'] : ['searchSendOrderLot', variables],
      useFetchData<SearchSendOrderLotQuery, SearchSendOrderLotQueryVariables>(SearchSendOrderLotDocument).bind(null, variables),
      options
    );

useSearchSendOrderLotQuery.getKey = (variables?: SearchSendOrderLotQueryVariables) => variables === undefined ? ['searchSendOrderLot'] : ['searchSendOrderLot', variables];
;

export const useInfiniteSearchSendOrderLotQuery = <
      TData = SearchSendOrderLotQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderLotQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderLotQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderLotQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderLot.infinite'] : ['searchSendOrderLot.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderLotQuery, SearchSendOrderLotQueryVariables>(SearchSendOrderLotDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateSendOrderLotDocument = `
    mutation createSendOrderLot($input: CreateSendOrderLotInput!) {
  createSendOrderLot(input: $input) {
    sendOrderLot {
      ...SendOrderLotFields
    }
  }
}
    ${SendOrderLotFieldsFragmentDoc}`;
export const useCreateSendOrderLotMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSendOrderLotMutation, TError, CreateSendOrderLotMutationVariables, TContext>) =>
    useMutation<CreateSendOrderLotMutation, TError, CreateSendOrderLotMutationVariables, TContext>(
      'createSendOrderLot',
      useFetchData<CreateSendOrderLotMutation, CreateSendOrderLotMutationVariables>(CreateSendOrderLotDocument),
      options
    );
export const UpdateSendOrderLotDocument = `
    mutation updateSendOrderLot($input: UpdateSendOrderLotInput!) {
  updateSendOrderLot(input: $input) {
    sendOrderLot {
      ...SendOrderLotFields
    }
  }
}
    ${SendOrderLotFieldsFragmentDoc}`;
export const useUpdateSendOrderLotMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderLotMutation, TError, UpdateSendOrderLotMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderLotMutation, TError, UpdateSendOrderLotMutationVariables, TContext>(
      'updateSendOrderLot',
      useFetchData<UpdateSendOrderLotMutation, UpdateSendOrderLotMutationVariables>(UpdateSendOrderLotDocument),
      options
    );
export const DeleteSendOrderLotDocument = `
    mutation deleteSendOrderLot($input: DeleteSendOrderLotInput!) {
  deleteSendOrderLot(input: $input) {
    sendOrderLot {
      ...SendOrderLotFields
    }
  }
}
    ${SendOrderLotFieldsFragmentDoc}`;
export const useDeleteSendOrderLotMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSendOrderLotMutation, TError, DeleteSendOrderLotMutationVariables, TContext>) =>
    useMutation<DeleteSendOrderLotMutation, TError, DeleteSendOrderLotMutationVariables, TContext>(
      'deleteSendOrderLot',
      useFetchData<DeleteSendOrderLotMutation, DeleteSendOrderLotMutationVariables>(DeleteSendOrderLotDocument),
      options
    );
export const UpdateSendOrderPurchaseUnitPriceDocument = `
    mutation updateSendOrderPurchaseUnitPrice($input: UpdateSendOrderDetailPurchaseUnitPriceInput!) {
  updateSendOrderPurchaseUnitPrice(input: $input) {
    sendOrderDetail {
      orderId
      numbering
      versionUuid
      id
    }
  }
}
    `;
export const useUpdateSendOrderPurchaseUnitPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSendOrderPurchaseUnitPriceMutation, TError, UpdateSendOrderPurchaseUnitPriceMutationVariables, TContext>) =>
    useMutation<UpdateSendOrderPurchaseUnitPriceMutation, TError, UpdateSendOrderPurchaseUnitPriceMutationVariables, TContext>(
      'updateSendOrderPurchaseUnitPrice',
      useFetchData<UpdateSendOrderPurchaseUnitPriceMutation, UpdateSendOrderPurchaseUnitPriceMutationVariables>(UpdateSendOrderPurchaseUnitPriceDocument),
      options
    );
export const SearchSendOrderPurchaseUnitPriceUpdateDocument = `
    query searchSendOrderPurchaseUnitPriceUpdate($first: Int, $after: String, $filter: SearchSendOrderPurchaseUnitPriceUpdateFilter) {
  searchSendOrderPurchaseUnitPriceUpdate(
    first: $first
    after: $after
    filter: $filter
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        orderId
        orderDate
        vendorCode
        vendorName
        orderQuantity
        productCode
        janCode
        productName
        purchaseUnitPriceYen
        purchaseUnitPriceDollar
        productPurchaseUnitPriceYen
        productPurchaseUnitPriceDollar
        rate
      }
    }
  }
}
    `;
export const useSearchSendOrderPurchaseUnitPriceUpdateQuery = <
      TData = SearchSendOrderPurchaseUnitPriceUpdateQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderPurchaseUnitPriceUpdateQueryVariables,
      options?: UseQueryOptions<SearchSendOrderPurchaseUnitPriceUpdateQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderPurchaseUnitPriceUpdateQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderPurchaseUnitPriceUpdate'] : ['searchSendOrderPurchaseUnitPriceUpdate', variables],
      useFetchData<SearchSendOrderPurchaseUnitPriceUpdateQuery, SearchSendOrderPurchaseUnitPriceUpdateQueryVariables>(SearchSendOrderPurchaseUnitPriceUpdateDocument).bind(null, variables),
      options
    );

useSearchSendOrderPurchaseUnitPriceUpdateQuery.getKey = (variables?: SearchSendOrderPurchaseUnitPriceUpdateQueryVariables) => variables === undefined ? ['searchSendOrderPurchaseUnitPriceUpdate'] : ['searchSendOrderPurchaseUnitPriceUpdate', variables];
;

export const useInfiniteSearchSendOrderPurchaseUnitPriceUpdateQuery = <
      TData = SearchSendOrderPurchaseUnitPriceUpdateQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderPurchaseUnitPriceUpdateQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderPurchaseUnitPriceUpdateQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderPurchaseUnitPriceUpdateQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderPurchaseUnitPriceUpdate.infinite'] : ['searchSendOrderPurchaseUnitPriceUpdate.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderPurchaseUnitPriceUpdateQuery, SearchSendOrderPurchaseUnitPriceUpdateQueryVariables>(SearchSendOrderPurchaseUnitPriceUpdateDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSendOrderViewDocument = `
    query searchSendOrderView($first: Int, $after: String, $filter: SearchSendOrderViewFilter, $sort: [SendOrderViewSortEnum]) {
  searchSendOrderView(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SendOrderViewFields
      }
    }
  }
}
    ${SendOrderViewFieldsFragmentDoc}`;
export const useSearchSendOrderViewQuery = <
      TData = SearchSendOrderViewQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderViewQueryVariables,
      options?: UseQueryOptions<SearchSendOrderViewQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderViewQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderView'] : ['searchSendOrderView', variables],
      useFetchData<SearchSendOrderViewQuery, SearchSendOrderViewQueryVariables>(SearchSendOrderViewDocument).bind(null, variables),
      options
    );

useSearchSendOrderViewQuery.getKey = (variables?: SearchSendOrderViewQueryVariables) => variables === undefined ? ['searchSendOrderView'] : ['searchSendOrderView', variables];
;

export const useInfiniteSearchSendOrderViewQuery = <
      TData = SearchSendOrderViewQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderViewQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderViewQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderViewQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderView.infinite'] : ['searchSendOrderView.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderViewQuery, SearchSendOrderViewQueryVariables>(SearchSendOrderViewDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSendOrderViewUnapprovedDocument = `
    query searchSendOrderViewUnapproved($first: Int, $after: String, $filter: SearchSendOrderViewUnapprovedFilter, $sort: [SendOrderViewSortEnum]) {
  searchSendOrderViewUnapproved(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SendOrderViewUnapprovedFields
      }
    }
  }
}
    ${SendOrderViewUnapprovedFieldsFragmentDoc}`;
export const useSearchSendOrderViewUnapprovedQuery = <
      TData = SearchSendOrderViewUnapprovedQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderViewUnapprovedQueryVariables,
      options?: UseQueryOptions<SearchSendOrderViewUnapprovedQuery, TError, TData>
    ) =>
    useQuery<SearchSendOrderViewUnapprovedQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderViewUnapproved'] : ['searchSendOrderViewUnapproved', variables],
      useFetchData<SearchSendOrderViewUnapprovedQuery, SearchSendOrderViewUnapprovedQueryVariables>(SearchSendOrderViewUnapprovedDocument).bind(null, variables),
      options
    );

useSearchSendOrderViewUnapprovedQuery.getKey = (variables?: SearchSendOrderViewUnapprovedQueryVariables) => variables === undefined ? ['searchSendOrderViewUnapproved'] : ['searchSendOrderViewUnapproved', variables];
;

export const useInfiniteSearchSendOrderViewUnapprovedQuery = <
      TData = SearchSendOrderViewUnapprovedQuery,
      TError = unknown
    >(
      variables?: SearchSendOrderViewUnapprovedQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSendOrderViewUnapprovedQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSendOrderViewUnapprovedQuery, TError, TData>(
      variables === undefined ? ['searchSendOrderViewUnapproved.infinite'] : ['searchSendOrderViewUnapproved.infinite', variables],
      (metaData) => useFetchData<SearchSendOrderViewUnapprovedQuery, SearchSendOrderViewUnapprovedQueryVariables>(SearchSendOrderViewUnapprovedDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShipmentDocument = `
    query searchShipment($first: Int, $after: String, $filter: SearchShipmentFilter, $sort: [ShipmentSortEnum]) {
  searchShipment(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        id
        deliveryOrderId
        deliveryOrderDate
        deliveryOrderMemo
        customerWarehouseCode
        receiveOrderId
        shipmentDetails {
          edges {
            node {
              sellingPrice
            }
          }
        }
        updateUserName
        updateDate
      }
    }
  }
}
    `;
export const useSearchShipmentQuery = <
      TData = SearchShipmentQuery,
      TError = unknown
    >(
      variables?: SearchShipmentQueryVariables,
      options?: UseQueryOptions<SearchShipmentQuery, TError, TData>
    ) =>
    useQuery<SearchShipmentQuery, TError, TData>(
      variables === undefined ? ['searchShipment'] : ['searchShipment', variables],
      useFetchData<SearchShipmentQuery, SearchShipmentQueryVariables>(SearchShipmentDocument).bind(null, variables),
      options
    );

useSearchShipmentQuery.getKey = (variables?: SearchShipmentQueryVariables) => variables === undefined ? ['searchShipment'] : ['searchShipment', variables];
;

export const useInfiniteSearchShipmentQuery = <
      TData = SearchShipmentQuery,
      TError = unknown
    >(
      variables?: SearchShipmentQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShipmentQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShipmentQuery, TError, TData>(
      variables === undefined ? ['searchShipment.infinite'] : ['searchShipment.infinite', variables],
      (metaData) => useFetchData<SearchShipmentQuery, SearchShipmentQueryVariables>(SearchShipmentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ShipmentDocument = `
    query shipment($id: ID!) {
  shipment(id: $id) {
    ...ShipmentSearchFields
  }
}
    ${ShipmentSearchFieldsFragmentDoc}`;
export const useShipmentQuery = <
      TData = ShipmentQuery,
      TError = unknown
    >(
      variables: ShipmentQueryVariables,
      options?: UseQueryOptions<ShipmentQuery, TError, TData>
    ) =>
    useQuery<ShipmentQuery, TError, TData>(
      ['shipment', variables],
      useFetchData<ShipmentQuery, ShipmentQueryVariables>(ShipmentDocument).bind(null, variables),
      options
    );

useShipmentQuery.getKey = (variables: ShipmentQueryVariables) => ['shipment', variables];
;

export const useInfiniteShipmentQuery = <
      TData = ShipmentQuery,
      TError = unknown
    >(
      variables: ShipmentQueryVariables,
      options?: UseInfiniteQueryOptions<ShipmentQuery, TError, TData>
    ) =>
    useInfiniteQuery<ShipmentQuery, TError, TData>(
      ['shipment.infinite', variables],
      (metaData) => useFetchData<ShipmentQuery, ShipmentQueryVariables>(ShipmentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateShipmentDocument = `
    mutation createShipment($input: CreateShipmentInput!) {
  createShipment(input: $input) {
    shipment {
      ...ShipmentMutationFields
    }
  }
}
    ${ShipmentMutationFieldsFragmentDoc}`;
export const useCreateShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateShipmentMutation, TError, CreateShipmentMutationVariables, TContext>) =>
    useMutation<CreateShipmentMutation, TError, CreateShipmentMutationVariables, TContext>(
      'createShipment',
      useFetchData<CreateShipmentMutation, CreateShipmentMutationVariables>(CreateShipmentDocument),
      options
    );
export const UpdateShipmentDocument = `
    mutation updateShipment($input: UpdateShipmentInput!) {
  updateShipment(input: $input) {
    shipment {
      ...ShipmentMutationFields
    }
  }
}
    ${ShipmentMutationFieldsFragmentDoc}`;
export const useUpdateShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShipmentMutation, TError, UpdateShipmentMutationVariables, TContext>) =>
    useMutation<UpdateShipmentMutation, TError, UpdateShipmentMutationVariables, TContext>(
      'updateShipment',
      useFetchData<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument),
      options
    );
export const DeleteShipmentDocument = `
    mutation deleteShipment($input: DeleteShipmentInput!) {
  deleteShipment(input: $input) {
    shipment {
      ...ShipmentMutationFields
    }
  }
}
    ${ShipmentMutationFieldsFragmentDoc}`;
export const useDeleteShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteShipmentMutation, TError, DeleteShipmentMutationVariables, TContext>) =>
    useMutation<DeleteShipmentMutation, TError, DeleteShipmentMutationVariables, TContext>(
      'deleteShipment',
      useFetchData<DeleteShipmentMutation, DeleteShipmentMutationVariables>(DeleteShipmentDocument),
      options
    );
export const ReceiveForShipmentDocument = `
    query receiveForShipment($id: ID!) {
  receiveOrderHeader(id: $id) {
    ...ReceiveForShipmentFields
  }
}
    ${ReceiveForShipmentFieldsFragmentDoc}`;
export const useReceiveForShipmentQuery = <
      TData = ReceiveForShipmentQuery,
      TError = unknown
    >(
      variables: ReceiveForShipmentQueryVariables,
      options?: UseQueryOptions<ReceiveForShipmentQuery, TError, TData>
    ) =>
    useQuery<ReceiveForShipmentQuery, TError, TData>(
      ['receiveForShipment', variables],
      useFetchData<ReceiveForShipmentQuery, ReceiveForShipmentQueryVariables>(ReceiveForShipmentDocument).bind(null, variables),
      options
    );

useReceiveForShipmentQuery.getKey = (variables: ReceiveForShipmentQueryVariables) => ['receiveForShipment', variables];
;

export const useInfiniteReceiveForShipmentQuery = <
      TData = ReceiveForShipmentQuery,
      TError = unknown
    >(
      variables: ReceiveForShipmentQueryVariables,
      options?: UseInfiniteQueryOptions<ReceiveForShipmentQuery, TError, TData>
    ) =>
    useInfiniteQuery<ReceiveForShipmentQuery, TError, TData>(
      ['receiveForShipment.infinite', variables],
      (metaData) => useFetchData<ReceiveForShipmentQuery, ReceiveForShipmentQueryVariables>(ReceiveForShipmentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchSalesForShipmentDocument = `
    query searchSalesForShipment($first: Int, $after: String, $filter: SearchSalesFromDeliveryOrderId2Filter, $sort: [SalesSortEnum]) {
  searchSalesFromDeliveryOrderId2(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...SalesForShipment
      }
    }
  }
}
    ${SalesForShipmentFragmentDoc}`;
export const useSearchSalesForShipmentQuery = <
      TData = SearchSalesForShipmentQuery,
      TError = unknown
    >(
      variables?: SearchSalesForShipmentQueryVariables,
      options?: UseQueryOptions<SearchSalesForShipmentQuery, TError, TData>
    ) =>
    useQuery<SearchSalesForShipmentQuery, TError, TData>(
      variables === undefined ? ['searchSalesForShipment'] : ['searchSalesForShipment', variables],
      useFetchData<SearchSalesForShipmentQuery, SearchSalesForShipmentQueryVariables>(SearchSalesForShipmentDocument).bind(null, variables),
      options
    );

useSearchSalesForShipmentQuery.getKey = (variables?: SearchSalesForShipmentQueryVariables) => variables === undefined ? ['searchSalesForShipment'] : ['searchSalesForShipment', variables];
;

export const useInfiniteSearchSalesForShipmentQuery = <
      TData = SearchSalesForShipmentQuery,
      TError = unknown
    >(
      variables?: SearchSalesForShipmentQueryVariables,
      options?: UseInfiniteQueryOptions<SearchSalesForShipmentQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchSalesForShipmentQuery, TError, TData>(
      variables === undefined ? ['searchSalesForShipment.infinite'] : ['searchSalesForShipment.infinite', variables],
      (metaData) => useFetchData<SearchSalesForShipmentQuery, SearchSalesForShipmentQueryVariables>(SearchSalesForShipmentDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShipmentReportDocument = `
    query searchShipmentReport($first: Int, $after: String, $filter: SearchShipmentFilter, $sort: [ShipmentSortEnum]) {
  searchShipment(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        deliveryOrderId
        receiveOrder {
          customer {
            userDivisionCode
            salesReport {
              reportLayoutCode
              reportLayoutName
              activeReportFlg
              offsetFlg
              offsetX
              offsetY
            }
          }
        }
      }
    }
  }
}
    `;
export const useSearchShipmentReportQuery = <
      TData = SearchShipmentReportQuery,
      TError = unknown
    >(
      variables?: SearchShipmentReportQueryVariables,
      options?: UseQueryOptions<SearchShipmentReportQuery, TError, TData>
    ) =>
    useQuery<SearchShipmentReportQuery, TError, TData>(
      variables === undefined ? ['searchShipmentReport'] : ['searchShipmentReport', variables],
      useFetchData<SearchShipmentReportQuery, SearchShipmentReportQueryVariables>(SearchShipmentReportDocument).bind(null, variables),
      options
    );

useSearchShipmentReportQuery.getKey = (variables?: SearchShipmentReportQueryVariables) => variables === undefined ? ['searchShipmentReport'] : ['searchShipmentReport', variables];
;

export const useInfiniteSearchShipmentReportQuery = <
      TData = SearchShipmentReportQuery,
      TError = unknown
    >(
      variables?: SearchShipmentReportQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShipmentReportQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShipmentReportQuery, TError, TData>(
      variables === undefined ? ['searchShipmentReport.infinite'] : ['searchShipmentReport.infinite', variables],
      (metaData) => useFetchData<SearchShipmentReportQuery, SearchShipmentReportQueryVariables>(SearchShipmentReportDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShipmentDetailDocument = `
    query searchShipmentDetail($first: Int, $after: String, $filter: SearchShipmentFilter, $sort: [ShipmentSortEnum], $detailFilter: ShipmentDetailFilter, $customSort: [ShipmentCustomSortEnum]) {
  searchShipment(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
    customSort: $customSort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        createUserCode
        createUserName
        createDate
        updateUserCode
        updateUserName
        updateDate
        deliveryOrderId
        deliveryOrderDate
        deliveryOrderMemo
        salesRemark
        receiveOrderId
        shipmentDetails(filter: $detailFilter) {
          edges {
            node {
              id
              deliveryOrderId
              numbering
              frontNumbering
              deliveryDetailTradeType
              deliveryOrderDetailStatus
              janCode
              productCode
              productName
              warehouseCode
              deliveryOrderQuantity
              salesUnitPrice
              retailPrice
              sellingUnitPrice
              sellingPrice
              taxationDivision
              detailMemo
              receiveOrderDetailNumbering
              detailMainFlg
              outWarehouseFlg
              totalQuantity
              totalTaxExcluded
            }
          }
        }
        receiveOrder {
          receiveOrderId
          receiveOrderType
          salesTradeDivision
          salesTaxType
          deliveryDestinationCode
          deliveryDestinationName
          receiveOrderRemarks
          salesUserCode
          estimateId
          receiveOrderMemo
          receiveOrderDate
          customer {
            customerCode
            customerName
            taxRoundType
          }
          division {
            divisionCode
            divisionName
          }
          salesUser {
            userCode
            userName
          }
        }
        shipmentTaxDetails {
          edges {
            node {
              taxationDivision
              exciseTax
              taxExcluded
              taxIncluded
            }
          }
        }
      }
    }
  }
}
    `;
export const useSearchShipmentDetailQuery = <
      TData = SearchShipmentDetailQuery,
      TError = unknown
    >(
      variables?: SearchShipmentDetailQueryVariables,
      options?: UseQueryOptions<SearchShipmentDetailQuery, TError, TData>
    ) =>
    useQuery<SearchShipmentDetailQuery, TError, TData>(
      variables === undefined ? ['searchShipmentDetail'] : ['searchShipmentDetail', variables],
      useFetchData<SearchShipmentDetailQuery, SearchShipmentDetailQueryVariables>(SearchShipmentDetailDocument).bind(null, variables),
      options
    );

useSearchShipmentDetailQuery.getKey = (variables?: SearchShipmentDetailQueryVariables) => variables === undefined ? ['searchShipmentDetail'] : ['searchShipmentDetail', variables];
;

export const useInfiniteSearchShipmentDetailQuery = <
      TData = SearchShipmentDetailQuery,
      TError = unknown
    >(
      variables?: SearchShipmentDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShipmentDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShipmentDetailQuery, TError, TData>(
      variables === undefined ? ['searchShipmentDetail.infinite'] : ['searchShipmentDetail.infinite', variables],
      (metaData) => useFetchData<SearchShipmentDetailQuery, SearchShipmentDetailQueryVariables>(SearchShipmentDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShipmentDetailProductDocument = `
    query searchShipmentDetailProduct($first: Int, $after: String, $filter: SearchShipmentFilter, $sort: [ShipmentDetailSortEnum]) {
  searchShipmentDetailProduct(
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    edges {
      node {
        id
        deliveryOrderId
        numbering
        frontNumbering
        deliveryDetailTradeType
        deliveryOrderDetailStatus
        janCode
        productCode
        productName
        warehouseCode
        deliveryOrderQuantity
        salesUnitPrice
        retailPrice
        sellingUnitPrice
        sellingPrice
        taxationDivision
        detailMemo
        receiveOrderDetailNumbering
        detailMainFlg
        outWarehouseFlg
        totalQuantity
        totalTaxExcluded
        shipment {
          createUserCode
          createUserName
          createDate
          updateUserCode
          updateUserName
          updateDate
          deliveryOrderId
          deliveryOrderDate
          deliveryOrderMemo
          salesRemark
          receiveOrderId
          receiveOrder {
            receiveOrderId
            receiveOrderType
            salesTradeDivision
            salesTaxType
            deliveryDestinationCode
            deliveryDestinationName
            receiveOrderRemarks
            salesUserCode
            estimateId
            receiveOrderMemo
            receiveOrderDate
            customer {
              customerCode
              customerName
              taxRoundType
            }
            division {
              divisionCode
              divisionName
            }
            salesUser {
              userCode
              userName
            }
          }
          shipmentTaxDetails {
            edges {
              node {
                taxationDivision
                exciseTax
                taxExcluded
                taxIncluded
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useSearchShipmentDetailProductQuery = <
      TData = SearchShipmentDetailProductQuery,
      TError = unknown
    >(
      variables?: SearchShipmentDetailProductQueryVariables,
      options?: UseQueryOptions<SearchShipmentDetailProductQuery, TError, TData>
    ) =>
    useQuery<SearchShipmentDetailProductQuery, TError, TData>(
      variables === undefined ? ['searchShipmentDetailProduct'] : ['searchShipmentDetailProduct', variables],
      useFetchData<SearchShipmentDetailProductQuery, SearchShipmentDetailProductQueryVariables>(SearchShipmentDetailProductDocument).bind(null, variables),
      options
    );

useSearchShipmentDetailProductQuery.getKey = (variables?: SearchShipmentDetailProductQueryVariables) => variables === undefined ? ['searchShipmentDetailProduct'] : ['searchShipmentDetailProduct', variables];
;

export const useInfiniteSearchShipmentDetailProductQuery = <
      TData = SearchShipmentDetailProductQuery,
      TError = unknown
    >(
      variables?: SearchShipmentDetailProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShipmentDetailProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShipmentDetailProductQuery, TError, TData>(
      variables === undefined ? ['searchShipmentDetailProduct.infinite'] : ['searchShipmentDetailProduct.infinite', variables],
      (metaData) => useFetchData<SearchShipmentDetailProductQuery, SearchShipmentDetailProductQueryVariables>(SearchShipmentDetailProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShopsTrustInventoryDocument = `
    query searchShopsTrustInventory($filter: SearchShopsTrustInventoryFilter) {
  searchShopsTrustInventory(filter: $filter) {
    trustInventoryId
    inventoryMonth
    inventoryFrom
    inventoryTo
    customerCode
    customerName
    divisionCode
    divisionName
    salesUserCode
    salesUserName
    inventoryStatus
    inventoryStatusLabel
    remark
  }
}
    `;
export const useSearchShopsTrustInventoryQuery = <
      TData = SearchShopsTrustInventoryQuery,
      TError = unknown
    >(
      variables?: SearchShopsTrustInventoryQueryVariables,
      options?: UseQueryOptions<SearchShopsTrustInventoryQuery, TError, TData>
    ) =>
    useQuery<SearchShopsTrustInventoryQuery, TError, TData>(
      variables === undefined ? ['searchShopsTrustInventory'] : ['searchShopsTrustInventory', variables],
      useFetchData<SearchShopsTrustInventoryQuery, SearchShopsTrustInventoryQueryVariables>(SearchShopsTrustInventoryDocument).bind(null, variables),
      options
    );

useSearchShopsTrustInventoryQuery.getKey = (variables?: SearchShopsTrustInventoryQueryVariables) => variables === undefined ? ['searchShopsTrustInventory'] : ['searchShopsTrustInventory', variables];
;

export const useInfiniteSearchShopsTrustInventoryQuery = <
      TData = SearchShopsTrustInventoryQuery,
      TError = unknown
    >(
      variables?: SearchShopsTrustInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShopsTrustInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShopsTrustInventoryQuery, TError, TData>(
      variables === undefined ? ['searchShopsTrustInventory.infinite'] : ['searchShopsTrustInventory.infinite', variables],
      (metaData) => useFetchData<SearchShopsTrustInventoryQuery, SearchShopsTrustInventoryQueryVariables>(SearchShopsTrustInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchShopsTrustInventoryOperatorsDocument = `
    query searchShopsTrustInventoryOperators($filter: SearchShopsTrustInventoryOperatorsFilter) {
  searchShopsTrustInventoryOperators(filter: $filter) {
    trustInventoryId
    operatorType
    operatorCode
    operatorBelong
    operatorName
    operationAt
  }
}
    `;
export const useSearchShopsTrustInventoryOperatorsQuery = <
      TData = SearchShopsTrustInventoryOperatorsQuery,
      TError = unknown
    >(
      variables?: SearchShopsTrustInventoryOperatorsQueryVariables,
      options?: UseQueryOptions<SearchShopsTrustInventoryOperatorsQuery, TError, TData>
    ) =>
    useQuery<SearchShopsTrustInventoryOperatorsQuery, TError, TData>(
      variables === undefined ? ['searchShopsTrustInventoryOperators'] : ['searchShopsTrustInventoryOperators', variables],
      useFetchData<SearchShopsTrustInventoryOperatorsQuery, SearchShopsTrustInventoryOperatorsQueryVariables>(SearchShopsTrustInventoryOperatorsDocument).bind(null, variables),
      options
    );

useSearchShopsTrustInventoryOperatorsQuery.getKey = (variables?: SearchShopsTrustInventoryOperatorsQueryVariables) => variables === undefined ? ['searchShopsTrustInventoryOperators'] : ['searchShopsTrustInventoryOperators', variables];
;

export const useInfiniteSearchShopsTrustInventoryOperatorsQuery = <
      TData = SearchShopsTrustInventoryOperatorsQuery,
      TError = unknown
    >(
      variables?: SearchShopsTrustInventoryOperatorsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchShopsTrustInventoryOperatorsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchShopsTrustInventoryOperatorsQuery, TError, TData>(
      variables === undefined ? ['searchShopsTrustInventoryOperators.infinite'] : ['searchShopsTrustInventoryOperators.infinite', variables],
      (metaData) => useFetchData<SearchShopsTrustInventoryOperatorsQuery, SearchShopsTrustInventoryOperatorsQueryVariables>(SearchShopsTrustInventoryOperatorsDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const ApproveTrustInventoryDocument = `
    mutation approveTrustInventory($input: ApproveTrustInventoryInput!) {
  approveTrustInventory(input: $input) {
    trustInventory {
      trustInventoryId
    }
  }
}
    `;
export const useApproveTrustInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveTrustInventoryMutation, TError, ApproveTrustInventoryMutationVariables, TContext>) =>
    useMutation<ApproveTrustInventoryMutation, TError, ApproveTrustInventoryMutationVariables, TContext>(
      'approveTrustInventory',
      useFetchData<ApproveTrustInventoryMutation, ApproveTrustInventoryMutationVariables>(ApproveTrustInventoryDocument),
      options
    );
export const SendBackTrustInventoryDocument = `
    mutation sendBackTrustInventory($input: SendBackTrustInventoryInput!) {
  sendBackTrustInventory(input: $input) {
    trustInventory {
      trustInventoryId
    }
  }
}
    `;
export const useSendBackTrustInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendBackTrustInventoryMutation, TError, SendBackTrustInventoryMutationVariables, TContext>) =>
    useMutation<SendBackTrustInventoryMutation, TError, SendBackTrustInventoryMutationVariables, TContext>(
      'sendBackTrustInventory',
      useFetchData<SendBackTrustInventoryMutation, SendBackTrustInventoryMutationVariables>(SendBackTrustInventoryDocument),
      options
    );
export const SearchStockAdjustDocument = `
    query searchStockAdjust($first: Int, $after: String, $filter: SearchStockAdjustFilter) {
  searchStockAdjust(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAdjustFields
      }
    }
  }
}
    ${StockAdjustFieldsFragmentDoc}`;
export const useSearchStockAdjustQuery = <
      TData = SearchStockAdjustQuery,
      TError = unknown
    >(
      variables?: SearchStockAdjustQueryVariables,
      options?: UseQueryOptions<SearchStockAdjustQuery, TError, TData>
    ) =>
    useQuery<SearchStockAdjustQuery, TError, TData>(
      variables === undefined ? ['searchStockAdjust'] : ['searchStockAdjust', variables],
      useFetchData<SearchStockAdjustQuery, SearchStockAdjustQueryVariables>(SearchStockAdjustDocument).bind(null, variables),
      options
    );

useSearchStockAdjustQuery.getKey = (variables?: SearchStockAdjustQueryVariables) => variables === undefined ? ['searchStockAdjust'] : ['searchStockAdjust', variables];
;

export const useInfiniteSearchStockAdjustQuery = <
      TData = SearchStockAdjustQuery,
      TError = unknown
    >(
      variables?: SearchStockAdjustQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAdjustQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAdjustQuery, TError, TData>(
      variables === undefined ? ['searchStockAdjust.infinite'] : ['searchStockAdjust.infinite', variables],
      (metaData) => useFetchData<SearchStockAdjustQuery, SearchStockAdjustQueryVariables>(SearchStockAdjustDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const StockAdjustDocument = `
    query stockAdjust($id: ID!) {
  stockAdjust(id: $id) {
    ...StockAdjustFields
  }
}
    ${StockAdjustFieldsFragmentDoc}`;
export const useStockAdjustQuery = <
      TData = StockAdjustQuery,
      TError = unknown
    >(
      variables: StockAdjustQueryVariables,
      options?: UseQueryOptions<StockAdjustQuery, TError, TData>
    ) =>
    useQuery<StockAdjustQuery, TError, TData>(
      ['stockAdjust', variables],
      useFetchData<StockAdjustQuery, StockAdjustQueryVariables>(StockAdjustDocument).bind(null, variables),
      options
    );

useStockAdjustQuery.getKey = (variables: StockAdjustQueryVariables) => ['stockAdjust', variables];
;

export const useInfiniteStockAdjustQuery = <
      TData = StockAdjustQuery,
      TError = unknown
    >(
      variables: StockAdjustQueryVariables,
      options?: UseInfiniteQueryOptions<StockAdjustQuery, TError, TData>
    ) =>
    useInfiniteQuery<StockAdjustQuery, TError, TData>(
      ['stockAdjust.infinite', variables],
      (metaData) => useFetchData<StockAdjustQuery, StockAdjustQueryVariables>(StockAdjustDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateStockAdjustDocument = `
    mutation createStockAdjust($input: CreateStockAdjustInput!) {
  createStockAdjust(input: $input) {
    stockAdjust {
      ...StockAdjustMutationFields
    }
  }
}
    ${StockAdjustMutationFieldsFragmentDoc}`;
export const useCreateStockAdjustMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateStockAdjustMutation, TError, CreateStockAdjustMutationVariables, TContext>) =>
    useMutation<CreateStockAdjustMutation, TError, CreateStockAdjustMutationVariables, TContext>(
      'createStockAdjust',
      useFetchData<CreateStockAdjustMutation, CreateStockAdjustMutationVariables>(CreateStockAdjustDocument),
      options
    );
export const UpdateStockAdjustDocument = `
    mutation updateStockAdjust($input: UpdateStockAdjustInput!) {
  updateStockAdjust(input: $input) {
    stockAdjust {
      ...StockAdjustMutationFields
    }
  }
}
    ${StockAdjustMutationFieldsFragmentDoc}`;
export const useUpdateStockAdjustMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateStockAdjustMutation, TError, UpdateStockAdjustMutationVariables, TContext>) =>
    useMutation<UpdateStockAdjustMutation, TError, UpdateStockAdjustMutationVariables, TContext>(
      'updateStockAdjust',
      useFetchData<UpdateStockAdjustMutation, UpdateStockAdjustMutationVariables>(UpdateStockAdjustDocument),
      options
    );
export const DeleteStockAdjustDocument = `
    mutation deleteStockAdjust($input: DeleteStockAdjustInput!) {
  deleteStockAdjust(input: $input) {
    stockAdjust {
      ...StockAdjustMutationFields
    }
  }
}
    ${StockAdjustMutationFieldsFragmentDoc}`;
export const useDeleteStockAdjustMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteStockAdjustMutation, TError, DeleteStockAdjustMutationVariables, TContext>) =>
    useMutation<DeleteStockAdjustMutation, TError, DeleteStockAdjustMutationVariables, TContext>(
      'deleteStockAdjust',
      useFetchData<DeleteStockAdjustMutation, DeleteStockAdjustMutationVariables>(DeleteStockAdjustDocument),
      options
    );
export const StockAlertDocument = `
    query stockAlert($productDivisionCodes: [String]) {
  stockAlert(filter: {productDivisionCodes: $productDivisionCodes}) {
    purchaseOrder
    division
  }
}
    `;
export const useStockAlertQuery = <
      TData = StockAlertQuery,
      TError = unknown
    >(
      variables?: StockAlertQueryVariables,
      options?: UseQueryOptions<StockAlertQuery, TError, TData>
    ) =>
    useQuery<StockAlertQuery, TError, TData>(
      variables === undefined ? ['stockAlert'] : ['stockAlert', variables],
      useFetchData<StockAlertQuery, StockAlertQueryVariables>(StockAlertDocument).bind(null, variables),
      options
    );

useStockAlertQuery.getKey = (variables?: StockAlertQueryVariables) => variables === undefined ? ['stockAlert'] : ['stockAlert', variables];
;

export const useInfiniteStockAlertQuery = <
      TData = StockAlertQuery,
      TError = unknown
    >(
      variables?: StockAlertQueryVariables,
      options?: UseInfiniteQueryOptions<StockAlertQuery, TError, TData>
    ) =>
    useInfiniteQuery<StockAlertQuery, TError, TData>(
      variables === undefined ? ['stockAlert.infinite'] : ['stockAlert.infinite', variables],
      (metaData) => useFetchData<StockAlertQuery, StockAlertQueryVariables>(StockAlertDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockListByProductDocument = `
    query searchStockListByProduct($first: Int, $after: String, $filter: SearchStockListByProductFilter) {
  searchStockListByProduct(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productCode
        productName
        retailPrice
        domOverFlg
        manufacturer
        productGroupName1
        productGroupName2
        productGroupName3
        tags
        discontinueFlg
        allQuantity
        allStockPrice
        sendBaseQuantity
        divisionBaseQuantity
        mainQuantity
        mainStockPrice
        externalQuantity
        externalStockPrice
        outsourceQuantity
        outsourceStockPrice
        receivePossibleQuantity
        receiveRemainQuantity
        sendRemainQuantity
      }
    }
  }
}
    `;
export const useSearchStockListByProductQuery = <
      TData = SearchStockListByProductQuery,
      TError = unknown
    >(
      variables?: SearchStockListByProductQueryVariables,
      options?: UseQueryOptions<SearchStockListByProductQuery, TError, TData>
    ) =>
    useQuery<SearchStockListByProductQuery, TError, TData>(
      variables === undefined ? ['searchStockListByProduct'] : ['searchStockListByProduct', variables],
      useFetchData<SearchStockListByProductQuery, SearchStockListByProductQueryVariables>(SearchStockListByProductDocument).bind(null, variables),
      options
    );

useSearchStockListByProductQuery.getKey = (variables?: SearchStockListByProductQueryVariables) => variables === undefined ? ['searchStockListByProduct'] : ['searchStockListByProduct', variables];
;

export const useInfiniteSearchStockListByProductQuery = <
      TData = SearchStockListByProductQuery,
      TError = unknown
    >(
      variables?: SearchStockListByProductQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockListByProductQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockListByProductQuery, TError, TData>(
      variables === undefined ? ['searchStockListByProduct.infinite'] : ['searchStockListByProduct.infinite', variables],
      (metaData) => useFetchData<SearchStockListByProductQuery, SearchStockListByProductQueryVariables>(SearchStockListByProductDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockListByDivisionDocument = `
    query searchStockListByDivision($first: Int, $after: String, $filter: SearchStockListByDivisionFilter) {
  searchStockListByDivision(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productCode
        productName
        retailPrice
        domOverFlg
        manufacturer
        productGroupName1
        productGroupName2
        productGroupName3
        tags
        discontinueFlg
        divisionName
        allQuantity
        allStockPrice
        mainQuantity
        mainStockPrice
        externalQuantity
        externalStockPrice
        outsourceQuantity
        outsourceStockPrice
      }
    }
  }
}
    `;
export const useSearchStockListByDivisionQuery = <
      TData = SearchStockListByDivisionQuery,
      TError = unknown
    >(
      variables?: SearchStockListByDivisionQueryVariables,
      options?: UseQueryOptions<SearchStockListByDivisionQuery, TError, TData>
    ) =>
    useQuery<SearchStockListByDivisionQuery, TError, TData>(
      variables === undefined ? ['searchStockListByDivision'] : ['searchStockListByDivision', variables],
      useFetchData<SearchStockListByDivisionQuery, SearchStockListByDivisionQueryVariables>(SearchStockListByDivisionDocument).bind(null, variables),
      options
    );

useSearchStockListByDivisionQuery.getKey = (variables?: SearchStockListByDivisionQueryVariables) => variables === undefined ? ['searchStockListByDivision'] : ['searchStockListByDivision', variables];
;

export const useInfiniteSearchStockListByDivisionQuery = <
      TData = SearchStockListByDivisionQuery,
      TError = unknown
    >(
      variables?: SearchStockListByDivisionQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockListByDivisionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockListByDivisionQuery, TError, TData>(
      variables === undefined ? ['searchStockListByDivision.infinite'] : ['searchStockListByDivision.infinite', variables],
      (metaData) => useFetchData<SearchStockListByDivisionQuery, SearchStockListByDivisionQueryVariables>(SearchStockListByDivisionDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockListByWarehouseDocument = `
    query searchStockListByWarehouse($first: Int, $after: String, $filter: SearchStockListByWarehouseFilter) {
  searchStockListByWarehouse(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        janCode
        productCode
        productName
        retailPrice
        domOverFlg
        manufacturer
        productGroupName1
        productGroupName2
        productGroupName3
        tags
        discontinueFlg
        divisionName
        warehouseType
        warehouseName
        warehouseQuantity
        warehouseStockPrice
      }
    }
  }
}
    `;
export const useSearchStockListByWarehouseQuery = <
      TData = SearchStockListByWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchStockListByWarehouseQueryVariables,
      options?: UseQueryOptions<SearchStockListByWarehouseQuery, TError, TData>
    ) =>
    useQuery<SearchStockListByWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchStockListByWarehouse'] : ['searchStockListByWarehouse', variables],
      useFetchData<SearchStockListByWarehouseQuery, SearchStockListByWarehouseQueryVariables>(SearchStockListByWarehouseDocument).bind(null, variables),
      options
    );

useSearchStockListByWarehouseQuery.getKey = (variables?: SearchStockListByWarehouseQueryVariables) => variables === undefined ? ['searchStockListByWarehouse'] : ['searchStockListByWarehouse', variables];
;

export const useInfiniteSearchStockListByWarehouseQuery = <
      TData = SearchStockListByWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchStockListByWarehouseQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockListByWarehouseQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockListByWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchStockListByWarehouse.infinite'] : ['searchStockListByWarehouse.infinite', variables],
      (metaData) => useFetchData<SearchStockListByWarehouseQuery, SearchStockListByWarehouseQueryVariables>(SearchStockListByWarehouseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsInventoryDocument = `
    query searchStockAnalyticsInventory($first: Int, $after: String, $filter: SearchStockAnalyticsInventoryFilter) {
  searchStockAnalyticsInventory(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsInventoryFields
      }
    }
  }
}
    ${StockAnalyticsInventoryFieldsFragmentDoc}`;
export const useSearchStockAnalyticsInventoryQuery = <
      TData = SearchStockAnalyticsInventoryQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsInventoryQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsInventoryQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsInventoryQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsInventory'] : ['searchStockAnalyticsInventory', variables],
      useFetchData<SearchStockAnalyticsInventoryQuery, SearchStockAnalyticsInventoryQueryVariables>(SearchStockAnalyticsInventoryDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsInventoryQuery.getKey = (variables?: SearchStockAnalyticsInventoryQueryVariables) => variables === undefined ? ['searchStockAnalyticsInventory'] : ['searchStockAnalyticsInventory', variables];
;

export const useInfiniteSearchStockAnalyticsInventoryQuery = <
      TData = SearchStockAnalyticsInventoryQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsInventoryQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsInventory.infinite'] : ['searchStockAnalyticsInventory.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsInventoryQuery, SearchStockAnalyticsInventoryQueryVariables>(SearchStockAnalyticsInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsInventoryUniqueDocument = `
    query searchStockAnalyticsInventoryUnique($first: Int, $after: String, $filter: SearchStockAnalyticsInventoryFilter) {
  searchStockAnalyticsInventoryUnique(
    first: $first
    after: $after
    filter: $filter
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsInventoryFields
      }
    }
  }
}
    ${StockAnalyticsInventoryFieldsFragmentDoc}`;
export const useSearchStockAnalyticsInventoryUniqueQuery = <
      TData = SearchStockAnalyticsInventoryUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsInventoryUniqueQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsInventoryUniqueQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsInventoryUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsInventoryUnique'] : ['searchStockAnalyticsInventoryUnique', variables],
      useFetchData<SearchStockAnalyticsInventoryUniqueQuery, SearchStockAnalyticsInventoryUniqueQueryVariables>(SearchStockAnalyticsInventoryUniqueDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsInventoryUniqueQuery.getKey = (variables?: SearchStockAnalyticsInventoryUniqueQueryVariables) => variables === undefined ? ['searchStockAnalyticsInventoryUnique'] : ['searchStockAnalyticsInventoryUnique', variables];
;

export const useInfiniteSearchStockAnalyticsInventoryUniqueQuery = <
      TData = SearchStockAnalyticsInventoryUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsInventoryUniqueQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsInventoryUniqueQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsInventoryUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsInventoryUnique.infinite'] : ['searchStockAnalyticsInventoryUnique.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsInventoryUniqueQuery, SearchStockAnalyticsInventoryUniqueQueryVariables>(SearchStockAnalyticsInventoryUniqueDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const InventoryDateForStockAnalyticsInventoryDocument = `
    query inventoryDateForStockAnalyticsInventory($id: ID!) {
  inventory(id: $id) {
    inventoryBaseFrom
    inventoryBaseTo
  }
}
    `;
export const useInventoryDateForStockAnalyticsInventoryQuery = <
      TData = InventoryDateForStockAnalyticsInventoryQuery,
      TError = unknown
    >(
      variables: InventoryDateForStockAnalyticsInventoryQueryVariables,
      options?: UseQueryOptions<InventoryDateForStockAnalyticsInventoryQuery, TError, TData>
    ) =>
    useQuery<InventoryDateForStockAnalyticsInventoryQuery, TError, TData>(
      ['inventoryDateForStockAnalyticsInventory', variables],
      useFetchData<InventoryDateForStockAnalyticsInventoryQuery, InventoryDateForStockAnalyticsInventoryQueryVariables>(InventoryDateForStockAnalyticsInventoryDocument).bind(null, variables),
      options
    );

useInventoryDateForStockAnalyticsInventoryQuery.getKey = (variables: InventoryDateForStockAnalyticsInventoryQueryVariables) => ['inventoryDateForStockAnalyticsInventory', variables];
;

export const useInfiniteInventoryDateForStockAnalyticsInventoryQuery = <
      TData = InventoryDateForStockAnalyticsInventoryQuery,
      TError = unknown
    >(
      variables: InventoryDateForStockAnalyticsInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<InventoryDateForStockAnalyticsInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<InventoryDateForStockAnalyticsInventoryQuery, TError, TData>(
      ['inventoryDateForStockAnalyticsInventory.infinite', variables],
      (metaData) => useFetchData<InventoryDateForStockAnalyticsInventoryQuery, InventoryDateForStockAnalyticsInventoryQueryVariables>(InventoryDateForStockAnalyticsInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsMonthDocument = `
    query searchStockAnalyticsMonth($first: Int, $after: String, $filter: SearchStockAnalyticsMonthFilter) {
  searchStockAnalyticsMonth(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsMonthFields
      }
    }
  }
}
    ${StockAnalyticsMonthFieldsFragmentDoc}`;
export const useSearchStockAnalyticsMonthQuery = <
      TData = SearchStockAnalyticsMonthQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsMonthQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsMonthQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsMonthQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsMonth'] : ['searchStockAnalyticsMonth', variables],
      useFetchData<SearchStockAnalyticsMonthQuery, SearchStockAnalyticsMonthQueryVariables>(SearchStockAnalyticsMonthDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsMonthQuery.getKey = (variables?: SearchStockAnalyticsMonthQueryVariables) => variables === undefined ? ['searchStockAnalyticsMonth'] : ['searchStockAnalyticsMonth', variables];
;

export const useInfiniteSearchStockAnalyticsMonthQuery = <
      TData = SearchStockAnalyticsMonthQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsMonthQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsMonthQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsMonthQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsMonth.infinite'] : ['searchStockAnalyticsMonth.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsMonthQuery, SearchStockAnalyticsMonthQueryVariables>(SearchStockAnalyticsMonthDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsMonthUniqueDocument = `
    query searchStockAnalyticsMonthUnique($first: Int, $after: String, $filter: SearchStockAnalyticsMonthFilter) {
  searchStockAnalyticsMonthUnique(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsMonthFields
      }
    }
  }
}
    ${StockAnalyticsMonthFieldsFragmentDoc}`;
export const useSearchStockAnalyticsMonthUniqueQuery = <
      TData = SearchStockAnalyticsMonthUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsMonthUniqueQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsMonthUniqueQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsMonthUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsMonthUnique'] : ['searchStockAnalyticsMonthUnique', variables],
      useFetchData<SearchStockAnalyticsMonthUniqueQuery, SearchStockAnalyticsMonthUniqueQueryVariables>(SearchStockAnalyticsMonthUniqueDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsMonthUniqueQuery.getKey = (variables?: SearchStockAnalyticsMonthUniqueQueryVariables) => variables === undefined ? ['searchStockAnalyticsMonthUnique'] : ['searchStockAnalyticsMonthUnique', variables];
;

export const useInfiniteSearchStockAnalyticsMonthUniqueQuery = <
      TData = SearchStockAnalyticsMonthUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsMonthUniqueQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsMonthUniqueQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsMonthUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsMonthUnique.infinite'] : ['searchStockAnalyticsMonthUnique.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsMonthUniqueQuery, SearchStockAnalyticsMonthUniqueQueryVariables>(SearchStockAnalyticsMonthUniqueDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsTermDocument = `
    query searchStockAnalyticsTerm($first: Int, $after: String, $filter: SearchStockAnalyticsTermFilter) {
  searchStockAnalyticsTerm(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsFields
      }
    }
  }
}
    ${StockAnalyticsFieldsFragmentDoc}`;
export const useSearchStockAnalyticsTermQuery = <
      TData = SearchStockAnalyticsTermQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsTermQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsTermQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsTermQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsTerm'] : ['searchStockAnalyticsTerm', variables],
      useFetchData<SearchStockAnalyticsTermQuery, SearchStockAnalyticsTermQueryVariables>(SearchStockAnalyticsTermDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsTermQuery.getKey = (variables?: SearchStockAnalyticsTermQueryVariables) => variables === undefined ? ['searchStockAnalyticsTerm'] : ['searchStockAnalyticsTerm', variables];
;

export const useInfiniteSearchStockAnalyticsTermQuery = <
      TData = SearchStockAnalyticsTermQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsTermQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsTermQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsTermQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsTerm.infinite'] : ['searchStockAnalyticsTerm.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsTermQuery, SearchStockAnalyticsTermQueryVariables>(SearchStockAnalyticsTermDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockAnalyticsTermUniqueDocument = `
    query searchStockAnalyticsTermUnique($first: Int, $after: String, $filter: SearchStockAnalyticsTermFilter) {
  searchStockAnalyticsTermUnique(first: $first, after: $after, filter: $filter) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockAnalyticsFields
      }
    }
  }
}
    ${StockAnalyticsFieldsFragmentDoc}`;
export const useSearchStockAnalyticsTermUniqueQuery = <
      TData = SearchStockAnalyticsTermUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsTermUniqueQueryVariables,
      options?: UseQueryOptions<SearchStockAnalyticsTermUniqueQuery, TError, TData>
    ) =>
    useQuery<SearchStockAnalyticsTermUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsTermUnique'] : ['searchStockAnalyticsTermUnique', variables],
      useFetchData<SearchStockAnalyticsTermUniqueQuery, SearchStockAnalyticsTermUniqueQueryVariables>(SearchStockAnalyticsTermUniqueDocument).bind(null, variables),
      options
    );

useSearchStockAnalyticsTermUniqueQuery.getKey = (variables?: SearchStockAnalyticsTermUniqueQueryVariables) => variables === undefined ? ['searchStockAnalyticsTermUnique'] : ['searchStockAnalyticsTermUnique', variables];
;

export const useInfiniteSearchStockAnalyticsTermUniqueQuery = <
      TData = SearchStockAnalyticsTermUniqueQuery,
      TError = unknown
    >(
      variables?: SearchStockAnalyticsTermUniqueQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockAnalyticsTermUniqueQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockAnalyticsTermUniqueQuery, TError, TData>(
      variables === undefined ? ['searchStockAnalyticsTermUnique.infinite'] : ['searchStockAnalyticsTermUnique.infinite', variables],
      (metaData) => useFetchData<SearchStockAnalyticsTermUniqueQuery, SearchStockAnalyticsTermUniqueQueryVariables>(SearchStockAnalyticsTermUniqueDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchStockByWarehouseDocument = `
    query searchStockByWarehouse($first: Int, $after: String, $filter: SearchStockByWarehouseFilter) {
  searchStockByWarehouse(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...StockByWarehouseFields
      }
    }
  }
}
    ${StockByWarehouseFieldsFragmentDoc}`;
export const useSearchStockByWarehouseQuery = <
      TData = SearchStockByWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchStockByWarehouseQueryVariables,
      options?: UseQueryOptions<SearchStockByWarehouseQuery, TError, TData>
    ) =>
    useQuery<SearchStockByWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchStockByWarehouse'] : ['searchStockByWarehouse', variables],
      useFetchData<SearchStockByWarehouseQuery, SearchStockByWarehouseQueryVariables>(SearchStockByWarehouseDocument).bind(null, variables),
      options
    );

useSearchStockByWarehouseQuery.getKey = (variables?: SearchStockByWarehouseQueryVariables) => variables === undefined ? ['searchStockByWarehouse'] : ['searchStockByWarehouse', variables];
;

export const useInfiniteSearchStockByWarehouseQuery = <
      TData = SearchStockByWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchStockByWarehouseQueryVariables,
      options?: UseInfiniteQueryOptions<SearchStockByWarehouseQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchStockByWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchStockByWarehouse.infinite'] : ['searchStockByWarehouse.infinite', variables],
      (metaData) => useFetchData<SearchStockByWarehouseQuery, SearchStockByWarehouseQueryVariables>(SearchStockByWarehouseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTermsAndConditionsDocument = `
    query searchTermsAndConditions {
  searchTermsAndConditions {
    edges {
      node {
        termsId
        enactmentDate
      }
    }
  }
}
    `;
export const useSearchTermsAndConditionsQuery = <
      TData = SearchTermsAndConditionsQuery,
      TError = unknown
    >(
      variables?: SearchTermsAndConditionsQueryVariables,
      options?: UseQueryOptions<SearchTermsAndConditionsQuery, TError, TData>
    ) =>
    useQuery<SearchTermsAndConditionsQuery, TError, TData>(
      variables === undefined ? ['searchTermsAndConditions'] : ['searchTermsAndConditions', variables],
      useFetchData<SearchTermsAndConditionsQuery, SearchTermsAndConditionsQueryVariables>(SearchTermsAndConditionsDocument).bind(null, variables),
      options
    );

useSearchTermsAndConditionsQuery.getKey = (variables?: SearchTermsAndConditionsQueryVariables) => variables === undefined ? ['searchTermsAndConditions'] : ['searchTermsAndConditions', variables];
;

export const useInfiniteSearchTermsAndConditionsQuery = <
      TData = SearchTermsAndConditionsQuery,
      TError = unknown
    >(
      variables?: SearchTermsAndConditionsQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTermsAndConditionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTermsAndConditionsQuery, TError, TData>(
      variables === undefined ? ['searchTermsAndConditions.infinite'] : ['searchTermsAndConditions.infinite', variables],
      (metaData) => useFetchData<SearchTermsAndConditionsQuery, SearchTermsAndConditionsQueryVariables>(SearchTermsAndConditionsDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTradeHistoryForDialogDocument = `
    query searchTradeHistoryForDialog($first: Int, $after: String, $filter: SearchTradeHistoryForDialogFilter) {
  searchTradeHistoryForDialog(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...TradeHistoryDialogFields
      }
    }
  }
}
    ${TradeHistoryDialogFieldsFragmentDoc}`;
export const useSearchTradeHistoryForDialogQuery = <
      TData = SearchTradeHistoryForDialogQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryForDialogQueryVariables,
      options?: UseQueryOptions<SearchTradeHistoryForDialogQuery, TError, TData>
    ) =>
    useQuery<SearchTradeHistoryForDialogQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryForDialog'] : ['searchTradeHistoryForDialog', variables],
      useFetchData<SearchTradeHistoryForDialogQuery, SearchTradeHistoryForDialogQueryVariables>(SearchTradeHistoryForDialogDocument).bind(null, variables),
      options
    );

useSearchTradeHistoryForDialogQuery.getKey = (variables?: SearchTradeHistoryForDialogQueryVariables) => variables === undefined ? ['searchTradeHistoryForDialog'] : ['searchTradeHistoryForDialog', variables];
;

export const useInfiniteSearchTradeHistoryForDialogQuery = <
      TData = SearchTradeHistoryForDialogQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryForDialogQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTradeHistoryForDialogQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTradeHistoryForDialogQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryForDialog.infinite'] : ['searchTradeHistoryForDialog.infinite', variables],
      (metaData) => useFetchData<SearchTradeHistoryForDialogQuery, SearchTradeHistoryForDialogQueryVariables>(SearchTradeHistoryForDialogDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTradeHistoryDocument = `
    query searchTradeHistory($first: Int, $after: String, $filter: SearchTradeHistoryFilter, $sort: [TradeHistorySortEnum]) {
  searchTradeHistory(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...TradeHistoryFields
      }
    }
  }
}
    ${TradeHistoryFieldsFragmentDoc}`;
export const useSearchTradeHistoryQuery = <
      TData = SearchTradeHistoryQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryQueryVariables,
      options?: UseQueryOptions<SearchTradeHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchTradeHistoryQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistory'] : ['searchTradeHistory', variables],
      useFetchData<SearchTradeHistoryQuery, SearchTradeHistoryQueryVariables>(SearchTradeHistoryDocument).bind(null, variables),
      options
    );

useSearchTradeHistoryQuery.getKey = (variables?: SearchTradeHistoryQueryVariables) => variables === undefined ? ['searchTradeHistory'] : ['searchTradeHistory', variables];
;

export const useInfiniteSearchTradeHistoryQuery = <
      TData = SearchTradeHistoryQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTradeHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTradeHistoryQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistory.infinite'] : ['searchTradeHistory.infinite', variables],
      (metaData) => useFetchData<SearchTradeHistoryQuery, SearchTradeHistoryQueryVariables>(SearchTradeHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTradeHistoryByMonthDocument = `
    query searchTradeHistoryByMonth($first: Int, $after: String, $filter: SearchTradeHistoryByMonthFilter) {
  searchTradeHistoryByMonth(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        month
        period
        averageUnitPrice
        inputQuantity
        outputQuantity
        moveQuantity
        inventory
      }
    }
  }
}
    `;
export const useSearchTradeHistoryByMonthQuery = <
      TData = SearchTradeHistoryByMonthQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryByMonthQueryVariables,
      options?: UseQueryOptions<SearchTradeHistoryByMonthQuery, TError, TData>
    ) =>
    useQuery<SearchTradeHistoryByMonthQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryByMonth'] : ['searchTradeHistoryByMonth', variables],
      useFetchData<SearchTradeHistoryByMonthQuery, SearchTradeHistoryByMonthQueryVariables>(SearchTradeHistoryByMonthDocument).bind(null, variables),
      options
    );

useSearchTradeHistoryByMonthQuery.getKey = (variables?: SearchTradeHistoryByMonthQueryVariables) => variables === undefined ? ['searchTradeHistoryByMonth'] : ['searchTradeHistoryByMonth', variables];
;

export const useInfiniteSearchTradeHistoryByMonthQuery = <
      TData = SearchTradeHistoryByMonthQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryByMonthQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTradeHistoryByMonthQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTradeHistoryByMonthQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryByMonth.infinite'] : ['searchTradeHistoryByMonth.infinite', variables],
      (metaData) => useFetchData<SearchTradeHistoryByMonthQuery, SearchTradeHistoryByMonthQueryVariables>(SearchTradeHistoryByMonthDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchTradeHistoryStockDocument = `
    query searchTradeHistoryStock($carryOverFilter: SearchTradeHistoryStockFilter, $currentStockFilter: SearchTradeHistoryStockFilter) {
  carryOver: searchTradeHistoryStock(filter: $carryOverFilter) {
    stock
  }
  currentStock: searchTradeHistoryStock(filter: $currentStockFilter) {
    stock
  }
}
    `;
export const useSearchTradeHistoryStockQuery = <
      TData = SearchTradeHistoryStockQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryStockQueryVariables,
      options?: UseQueryOptions<SearchTradeHistoryStockQuery, TError, TData>
    ) =>
    useQuery<SearchTradeHistoryStockQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryStock'] : ['searchTradeHistoryStock', variables],
      useFetchData<SearchTradeHistoryStockQuery, SearchTradeHistoryStockQueryVariables>(SearchTradeHistoryStockDocument).bind(null, variables),
      options
    );

useSearchTradeHistoryStockQuery.getKey = (variables?: SearchTradeHistoryStockQueryVariables) => variables === undefined ? ['searchTradeHistoryStock'] : ['searchTradeHistoryStock', variables];
;

export const useInfiniteSearchTradeHistoryStockQuery = <
      TData = SearchTradeHistoryStockQuery,
      TError = unknown
    >(
      variables?: SearchTradeHistoryStockQueryVariables,
      options?: UseInfiniteQueryOptions<SearchTradeHistoryStockQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchTradeHistoryStockQuery, TError, TData>(
      variables === undefined ? ['searchTradeHistoryStock.infinite'] : ['searchTradeHistoryStock.infinite', variables],
      (metaData) => useFetchData<SearchTradeHistoryStockQuery, SearchTradeHistoryStockQueryVariables>(SearchTradeHistoryStockDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchProductTradeHistoryDocument = `
    query searchProductTradeHistory($first: Int, $filter: SearchProductViewFilter) {
  searchProductView(first: $first, filter: $filter) {
    edges {
      cursor
      node {
        janCode
        productCode
        attributeName
      }
    }
  }
}
    `;
export const useSearchProductTradeHistoryQuery = <
      TData = SearchProductTradeHistoryQuery,
      TError = unknown
    >(
      variables?: SearchProductTradeHistoryQueryVariables,
      options?: UseQueryOptions<SearchProductTradeHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchProductTradeHistoryQuery, TError, TData>(
      variables === undefined ? ['searchProductTradeHistory'] : ['searchProductTradeHistory', variables],
      useFetchData<SearchProductTradeHistoryQuery, SearchProductTradeHistoryQueryVariables>(SearchProductTradeHistoryDocument).bind(null, variables),
      options
    );

useSearchProductTradeHistoryQuery.getKey = (variables?: SearchProductTradeHistoryQueryVariables) => variables === undefined ? ['searchProductTradeHistory'] : ['searchProductTradeHistory', variables];
;

export const useInfiniteSearchProductTradeHistoryQuery = <
      TData = SearchProductTradeHistoryQuery,
      TError = unknown
    >(
      variables?: SearchProductTradeHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchProductTradeHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchProductTradeHistoryQuery, TError, TData>(
      variables === undefined ? ['searchProductTradeHistory.infinite'] : ['searchProductTradeHistory.infinite', variables],
      (metaData) => useFetchData<SearchProductTradeHistoryQuery, SearchProductTradeHistoryQueryVariables>(SearchProductTradeHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDispTrustinventoryDocument = `
    query createDispTrustinventory($first: Int, $after: String, $filter: SearchCreateDispTrustInventoryFilter) {
  createDispTrustinventory(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...CreateDispTrustInventoryFields
      }
    }
  }
}
    ${CreateDispTrustInventoryFieldsFragmentDoc}`;
export const useCreateDispTrustinventoryQuery = <
      TData = CreateDispTrustinventoryQuery,
      TError = unknown
    >(
      variables?: CreateDispTrustinventoryQueryVariables,
      options?: UseQueryOptions<CreateDispTrustinventoryQuery, TError, TData>
    ) =>
    useQuery<CreateDispTrustinventoryQuery, TError, TData>(
      variables === undefined ? ['createDispTrustinventory'] : ['createDispTrustinventory', variables],
      useFetchData<CreateDispTrustinventoryQuery, CreateDispTrustinventoryQueryVariables>(CreateDispTrustinventoryDocument).bind(null, variables),
      options
    );

useCreateDispTrustinventoryQuery.getKey = (variables?: CreateDispTrustinventoryQueryVariables) => variables === undefined ? ['createDispTrustinventory'] : ['createDispTrustinventory', variables];
;

export const useInfiniteCreateDispTrustinventoryQuery = <
      TData = CreateDispTrustinventoryQuery,
      TError = unknown
    >(
      variables?: CreateDispTrustinventoryQueryVariables,
      options?: UseInfiniteQueryOptions<CreateDispTrustinventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<CreateDispTrustinventoryQuery, TError, TData>(
      variables === undefined ? ['createDispTrustinventory.infinite'] : ['createDispTrustinventory.infinite', variables],
      (metaData) => useFetchData<CreateDispTrustinventoryQuery, CreateDispTrustinventoryQueryVariables>(CreateDispTrustinventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateDispTrustinventoryUniqueCodeDocument = `
    query createDispTrustinventoryUniqueCode($first: Int, $after: String, $filter: SearchCreateDispTrustInventoryFilter) {
  createDispTrustinventoryUniqueCode(
    first: $first
    after: $after
    filter: $filter
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...CreateDispTrustInventoryFields
      }
    }
  }
}
    ${CreateDispTrustInventoryFieldsFragmentDoc}`;
export const useCreateDispTrustinventoryUniqueCodeQuery = <
      TData = CreateDispTrustinventoryUniqueCodeQuery,
      TError = unknown
    >(
      variables?: CreateDispTrustinventoryUniqueCodeQueryVariables,
      options?: UseQueryOptions<CreateDispTrustinventoryUniqueCodeQuery, TError, TData>
    ) =>
    useQuery<CreateDispTrustinventoryUniqueCodeQuery, TError, TData>(
      variables === undefined ? ['createDispTrustinventoryUniqueCode'] : ['createDispTrustinventoryUniqueCode', variables],
      useFetchData<CreateDispTrustinventoryUniqueCodeQuery, CreateDispTrustinventoryUniqueCodeQueryVariables>(CreateDispTrustinventoryUniqueCodeDocument).bind(null, variables),
      options
    );

useCreateDispTrustinventoryUniqueCodeQuery.getKey = (variables?: CreateDispTrustinventoryUniqueCodeQueryVariables) => variables === undefined ? ['createDispTrustinventoryUniqueCode'] : ['createDispTrustinventoryUniqueCode', variables];
;

export const useInfiniteCreateDispTrustinventoryUniqueCodeQuery = <
      TData = CreateDispTrustinventoryUniqueCodeQuery,
      TError = unknown
    >(
      variables?: CreateDispTrustinventoryUniqueCodeQueryVariables,
      options?: UseInfiniteQueryOptions<CreateDispTrustinventoryUniqueCodeQuery, TError, TData>
    ) =>
    useInfiniteQuery<CreateDispTrustinventoryUniqueCodeQuery, TError, TData>(
      variables === undefined ? ['createDispTrustinventoryUniqueCode.infinite'] : ['createDispTrustinventoryUniqueCode.infinite', variables],
      (metaData) => useFetchData<CreateDispTrustinventoryUniqueCodeQuery, CreateDispTrustinventoryUniqueCodeQueryVariables>(CreateDispTrustinventoryUniqueCodeDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const UpdateDispTrustinventoryDocument = `
    query updateDispTrustinventory($id: ID!) {
  updateDispTrustinventory(id: $id) {
    ...UpdateDispTrustInventoryFields
  }
}
    ${UpdateDispTrustInventoryFieldsFragmentDoc}`;
export const useUpdateDispTrustinventoryQuery = <
      TData = UpdateDispTrustinventoryQuery,
      TError = unknown
    >(
      variables: UpdateDispTrustinventoryQueryVariables,
      options?: UseQueryOptions<UpdateDispTrustinventoryQuery, TError, TData>
    ) =>
    useQuery<UpdateDispTrustinventoryQuery, TError, TData>(
      ['updateDispTrustinventory', variables],
      useFetchData<UpdateDispTrustinventoryQuery, UpdateDispTrustinventoryQueryVariables>(UpdateDispTrustinventoryDocument).bind(null, variables),
      options
    );

useUpdateDispTrustinventoryQuery.getKey = (variables: UpdateDispTrustinventoryQueryVariables) => ['updateDispTrustinventory', variables];
;

export const useInfiniteUpdateDispTrustinventoryQuery = <
      TData = UpdateDispTrustinventoryQuery,
      TError = unknown
    >(
      variables: UpdateDispTrustinventoryQueryVariables,
      options?: UseInfiniteQueryOptions<UpdateDispTrustinventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<UpdateDispTrustinventoryQuery, TError, TData>(
      ['updateDispTrustinventory.infinite', variables],
      (metaData) => useFetchData<UpdateDispTrustinventoryQuery, UpdateDispTrustinventoryQueryVariables>(UpdateDispTrustinventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateTrustInventoryJanUnitDocument = `
    mutation createTrustInventoryJanUnit($input: CreateTrustInventoryJanUnitInput!) {
  createTrustInventoryJanUnit(input: $input) {
    trustInventory {
      ...TrustInventoryMutationFields
    }
  }
}
    ${TrustInventoryMutationFieldsFragmentDoc}`;
export const useCreateTrustInventoryJanUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTrustInventoryJanUnitMutation, TError, CreateTrustInventoryJanUnitMutationVariables, TContext>) =>
    useMutation<CreateTrustInventoryJanUnitMutation, TError, CreateTrustInventoryJanUnitMutationVariables, TContext>(
      'createTrustInventoryJanUnit',
      useFetchData<CreateTrustInventoryJanUnitMutation, CreateTrustInventoryJanUnitMutationVariables>(CreateTrustInventoryJanUnitDocument),
      options
    );
export const CreateTrustInventoryDocument = `
    mutation createTrustInventory($input: CreateTrustInventoryInput!) {
  createTrustInventory(input: $input) {
    trustInventory {
      ...TrustInventoryMutationFields
    }
  }
}
    ${TrustInventoryMutationFieldsFragmentDoc}`;
export const useCreateTrustInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTrustInventoryMutation, TError, CreateTrustInventoryMutationVariables, TContext>) =>
    useMutation<CreateTrustInventoryMutation, TError, CreateTrustInventoryMutationVariables, TContext>(
      'createTrustInventory',
      useFetchData<CreateTrustInventoryMutation, CreateTrustInventoryMutationVariables>(CreateTrustInventoryDocument),
      options
    );
export const UpdateTrustInventoryJanUnitDocument = `
    mutation updateTrustInventoryJanUnit($input: UpdateTrustInventoryJanUnitInput!) {
  updateTrustInventoryJanUnit(input: $input) {
    trustInventory {
      ...TrustInventoryMutationFields
    }
  }
}
    ${TrustInventoryMutationFieldsFragmentDoc}`;
export const useUpdateTrustInventoryJanUnitMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrustInventoryJanUnitMutation, TError, UpdateTrustInventoryJanUnitMutationVariables, TContext>) =>
    useMutation<UpdateTrustInventoryJanUnitMutation, TError, UpdateTrustInventoryJanUnitMutationVariables, TContext>(
      'updateTrustInventoryJanUnit',
      useFetchData<UpdateTrustInventoryJanUnitMutation, UpdateTrustInventoryJanUnitMutationVariables>(UpdateTrustInventoryJanUnitDocument),
      options
    );
export const UpdateTrustInventoryDocument = `
    mutation updateTrustInventory($input: UpdateTrustInventoryInput!) {
  updateTrustInventory(input: $input) {
    trustInventory {
      ...TrustInventoryMutationFields
    }
  }
}
    ${TrustInventoryMutationFieldsFragmentDoc}`;
export const useUpdateTrustInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTrustInventoryMutation, TError, UpdateTrustInventoryMutationVariables, TContext>) =>
    useMutation<UpdateTrustInventoryMutation, TError, UpdateTrustInventoryMutationVariables, TContext>(
      'updateTrustInventory',
      useFetchData<UpdateTrustInventoryMutation, UpdateTrustInventoryMutationVariables>(UpdateTrustInventoryDocument),
      options
    );
export const DeleteTrustInventoryDocument = `
    mutation deleteTrustInventory($input: DeleteTrustInventoryInput!) {
  deleteTrustInventory(input: $input) {
    trustInventory {
      ...TrustInventoryMutationFields
    }
  }
}
    ${TrustInventoryMutationFieldsFragmentDoc}`;
export const useDeleteTrustInventoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteTrustInventoryMutation, TError, DeleteTrustInventoryMutationVariables, TContext>) =>
    useMutation<DeleteTrustInventoryMutation, TError, DeleteTrustInventoryMutationVariables, TContext>(
      'deleteTrustInventory',
      useFetchData<DeleteTrustInventoryMutation, DeleteTrustInventoryMutationVariables>(DeleteTrustInventoryDocument),
      options
    );
export const SearchExistTrustInventoryDocument = `
    query searchExistTrustInventory($first: Int, $after: String, $filter: SearchTrustInventoryFilter) {
  searchTrustInventory(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        trustInventoryId
      }
    }
  }
}
    `;
export const useSearchExistTrustInventoryQuery = <
      TData = SearchExistTrustInventoryQuery,
      TError = unknown
    >(
      variables?: SearchExistTrustInventoryQueryVariables,
      options?: UseQueryOptions<SearchExistTrustInventoryQuery, TError, TData>
    ) =>
    useQuery<SearchExistTrustInventoryQuery, TError, TData>(
      variables === undefined ? ['searchExistTrustInventory'] : ['searchExistTrustInventory', variables],
      useFetchData<SearchExistTrustInventoryQuery, SearchExistTrustInventoryQueryVariables>(SearchExistTrustInventoryDocument).bind(null, variables),
      options
    );

useSearchExistTrustInventoryQuery.getKey = (variables?: SearchExistTrustInventoryQueryVariables) => variables === undefined ? ['searchExistTrustInventory'] : ['searchExistTrustInventory', variables];
;

export const useInfiniteSearchExistTrustInventoryQuery = <
      TData = SearchExistTrustInventoryQuery,
      TError = unknown
    >(
      variables?: SearchExistTrustInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchExistTrustInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchExistTrustInventoryQuery, TError, TData>(
      variables === undefined ? ['searchExistTrustInventory.infinite'] : ['searchExistTrustInventory.infinite', variables],
      (metaData) => useFetchData<SearchExistTrustInventoryQuery, SearchExistTrustInventoryQueryVariables>(SearchExistTrustInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerInfoTrustInventoryDocument = `
    query searchCustomerInfoTrustInventory($id: ID!) {
  customer(id: $id) {
    ...CustomerInfoTrustInventoryFields
  }
}
    ${CustomerInfoTrustInventoryFieldsFragmentDoc}`;
export const useSearchCustomerInfoTrustInventoryQuery = <
      TData = SearchCustomerInfoTrustInventoryQuery,
      TError = unknown
    >(
      variables: SearchCustomerInfoTrustInventoryQueryVariables,
      options?: UseQueryOptions<SearchCustomerInfoTrustInventoryQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerInfoTrustInventoryQuery, TError, TData>(
      ['searchCustomerInfoTrustInventory', variables],
      useFetchData<SearchCustomerInfoTrustInventoryQuery, SearchCustomerInfoTrustInventoryQueryVariables>(SearchCustomerInfoTrustInventoryDocument).bind(null, variables),
      options
    );

useSearchCustomerInfoTrustInventoryQuery.getKey = (variables: SearchCustomerInfoTrustInventoryQueryVariables) => ['searchCustomerInfoTrustInventory', variables];
;

export const useInfiniteSearchCustomerInfoTrustInventoryQuery = <
      TData = SearchCustomerInfoTrustInventoryQuery,
      TError = unknown
    >(
      variables: SearchCustomerInfoTrustInventoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerInfoTrustInventoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerInfoTrustInventoryQuery, TError, TData>(
      ['searchCustomerInfoTrustInventory.infinite', variables],
      (metaData) => useFetchData<SearchCustomerInfoTrustInventoryQuery, SearchCustomerInfoTrustInventoryQueryVariables>(SearchCustomerInfoTrustInventoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchUnitHistoryDocument = `
    query searchUnitHistory($first: Int, $after: String, $filter: SearchUnitHistoryFilter) {
  searchUnitHistory(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...SearchUnitHistoryFields
      }
    }
  }
}
    ${SearchUnitHistoryFieldsFragmentDoc}`;
export const useSearchUnitHistoryQuery = <
      TData = SearchUnitHistoryQuery,
      TError = unknown
    >(
      variables?: SearchUnitHistoryQueryVariables,
      options?: UseQueryOptions<SearchUnitHistoryQuery, TError, TData>
    ) =>
    useQuery<SearchUnitHistoryQuery, TError, TData>(
      variables === undefined ? ['searchUnitHistory'] : ['searchUnitHistory', variables],
      useFetchData<SearchUnitHistoryQuery, SearchUnitHistoryQueryVariables>(SearchUnitHistoryDocument).bind(null, variables),
      options
    );

useSearchUnitHistoryQuery.getKey = (variables?: SearchUnitHistoryQueryVariables) => variables === undefined ? ['searchUnitHistory'] : ['searchUnitHistory', variables];
;

export const useInfiniteSearchUnitHistoryQuery = <
      TData = SearchUnitHistoryQuery,
      TError = unknown
    >(
      variables?: SearchUnitHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<SearchUnitHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchUnitHistoryQuery, TError, TData>(
      variables === undefined ? ['searchUnitHistory.infinite'] : ['searchUnitHistory.infinite', variables],
      (metaData) => useFetchData<SearchUnitHistoryQuery, SearchUnitHistoryQueryVariables>(SearchUnitHistoryDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchCustomerPriceInUnitPriceDocument = `
    query searchCustomerPriceInUnitPrice($first: Int, $after: String, $filter: SearchCustomerPriceFilter, $sort: [CustomerPriceSortEnum]) {
  searchCustomerPrice(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...CustomerPriceInUnitPriceFields
      }
    }
  }
}
    ${CustomerPriceInUnitPriceFieldsFragmentDoc}`;
export const useSearchCustomerPriceInUnitPriceQuery = <
      TData = SearchCustomerPriceInUnitPriceQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceInUnitPriceQueryVariables,
      options?: UseQueryOptions<SearchCustomerPriceInUnitPriceQuery, TError, TData>
    ) =>
    useQuery<SearchCustomerPriceInUnitPriceQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPriceInUnitPrice'] : ['searchCustomerPriceInUnitPrice', variables],
      useFetchData<SearchCustomerPriceInUnitPriceQuery, SearchCustomerPriceInUnitPriceQueryVariables>(SearchCustomerPriceInUnitPriceDocument).bind(null, variables),
      options
    );

useSearchCustomerPriceInUnitPriceQuery.getKey = (variables?: SearchCustomerPriceInUnitPriceQueryVariables) => variables === undefined ? ['searchCustomerPriceInUnitPrice'] : ['searchCustomerPriceInUnitPrice', variables];
;

export const useInfiniteSearchCustomerPriceInUnitPriceQuery = <
      TData = SearchCustomerPriceInUnitPriceQuery,
      TError = unknown
    >(
      variables?: SearchCustomerPriceInUnitPriceQueryVariables,
      options?: UseInfiniteQueryOptions<SearchCustomerPriceInUnitPriceQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchCustomerPriceInUnitPriceQuery, TError, TData>(
      variables === undefined ? ['searchCustomerPriceInUnitPrice.infinite'] : ['searchCustomerPriceInUnitPrice.infinite', variables],
      (metaData) => useFetchData<SearchCustomerPriceInUnitPriceQuery, SearchCustomerPriceInUnitPriceQueryVariables>(SearchCustomerPriceInUnitPriceDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchUnitHistoryTrustDocument = `
    query searchUnitHistoryTrust($first: Int, $after: String, $filter: SearchUnitHistoryTrustFilter) {
  searchUnitHistoryTrust(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        salesDate
        salesNumber
        customerName
        quantity
        unitPrice
      }
    }
  }
}
    `;
export const useSearchUnitHistoryTrustQuery = <
      TData = SearchUnitHistoryTrustQuery,
      TError = unknown
    >(
      variables?: SearchUnitHistoryTrustQueryVariables,
      options?: UseQueryOptions<SearchUnitHistoryTrustQuery, TError, TData>
    ) =>
    useQuery<SearchUnitHistoryTrustQuery, TError, TData>(
      variables === undefined ? ['searchUnitHistoryTrust'] : ['searchUnitHistoryTrust', variables],
      useFetchData<SearchUnitHistoryTrustQuery, SearchUnitHistoryTrustQueryVariables>(SearchUnitHistoryTrustDocument).bind(null, variables),
      options
    );

useSearchUnitHistoryTrustQuery.getKey = (variables?: SearchUnitHistoryTrustQueryVariables) => variables === undefined ? ['searchUnitHistoryTrust'] : ['searchUnitHistoryTrust', variables];
;

export const useInfiniteSearchUnitHistoryTrustQuery = <
      TData = SearchUnitHistoryTrustQuery,
      TError = unknown
    >(
      variables?: SearchUnitHistoryTrustQueryVariables,
      options?: UseInfiniteQueryOptions<SearchUnitHistoryTrustQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchUnitHistoryTrustQuery, TError, TData>(
      variables === undefined ? ['searchUnitHistoryTrust.infinite'] : ['searchUnitHistoryTrust.infinite', variables],
      (metaData) => useFetchData<SearchUnitHistoryTrustQuery, SearchUnitHistoryTrustQueryVariables>(SearchUnitHistoryTrustDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const UserDocument = `
    query User($id: ID!) {
  user(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options?: UseQueryOptions<UserQuery, TError, TData>
    ) =>
    useQuery<UserQuery, TError, TData>(
      ['User', variables],
      useFetchData<UserQuery, UserQueryVariables>(UserDocument).bind(null, variables),
      options
    );

useUserQuery.getKey = (variables: UserQueryVariables) => ['User', variables];
;

export const useInfiniteUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      variables: UserQueryVariables,
      options?: UseInfiniteQueryOptions<UserQuery, TError, TData>
    ) =>
    useInfiniteQuery<UserQuery, TError, TData>(
      ['User.infinite', variables],
      (metaData) => useFetchData<UserQuery, UserQueryVariables>(UserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchUserDocument = `
    query searchUser($first: Int, $after: String, $filter: SearchUserFilter, $sort: [UserSortEnum]) {
  searchUser(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...UserFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const useSearchUserQuery = <
      TData = SearchUserQuery,
      TError = unknown
    >(
      variables?: SearchUserQueryVariables,
      options?: UseQueryOptions<SearchUserQuery, TError, TData>
    ) =>
    useQuery<SearchUserQuery, TError, TData>(
      variables === undefined ? ['searchUser'] : ['searchUser', variables],
      useFetchData<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument).bind(null, variables),
      options
    );

useSearchUserQuery.getKey = (variables?: SearchUserQueryVariables) => variables === undefined ? ['searchUser'] : ['searchUser', variables];
;

export const useInfiniteSearchUserQuery = <
      TData = SearchUserQuery,
      TError = unknown
    >(
      variables?: SearchUserQueryVariables,
      options?: UseInfiniteQueryOptions<SearchUserQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchUserQuery, TError, TData>(
      variables === undefined ? ['searchUser.infinite'] : ['searchUser.infinite', variables],
      (metaData) => useFetchData<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateUserDocument = `
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      userCode
      versionUuid
    }
  }
}
    `;
export const useCreateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>) =>
    useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
      'createUser',
      useFetchData<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument),
      options
    );
export const UpdateUserDocument = `
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      userCode
      versionUuid
    }
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      'updateUser',
      useFetchData<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument),
      options
    );
export const DeleteUserDocument = `
    mutation deleteUser($input: DeleteUserInput!) {
  deleteUser(input: $input) {
    user {
      userCode
      versionUuid
    }
  }
}
    `;
export const useDeleteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>) =>
    useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      'deleteUser',
      useFetchData<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument),
      options
    );
export const VendorDocument = `
    query Vendor($id: ID!) {
  vendor(id: $id) {
    ...VendorFields
  }
}
    ${VendorFieldsFragmentDoc}`;
export const useVendorQuery = <
      TData = VendorQuery,
      TError = unknown
    >(
      variables: VendorQueryVariables,
      options?: UseQueryOptions<VendorQuery, TError, TData>
    ) =>
    useQuery<VendorQuery, TError, TData>(
      ['Vendor', variables],
      useFetchData<VendorQuery, VendorQueryVariables>(VendorDocument).bind(null, variables),
      options
    );

useVendorQuery.getKey = (variables: VendorQueryVariables) => ['Vendor', variables];
;

export const useInfiniteVendorQuery = <
      TData = VendorQuery,
      TError = unknown
    >(
      variables: VendorQueryVariables,
      options?: UseInfiniteQueryOptions<VendorQuery, TError, TData>
    ) =>
    useInfiniteQuery<VendorQuery, TError, TData>(
      ['Vendor.infinite', variables],
      (metaData) => useFetchData<VendorQuery, VendorQueryVariables>(VendorDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateVendorDocument = `
    mutation createVendor($input: CreateVendorInput!) {
  createVendor(input: $input) {
    vendor {
      vendorCode
      versionUuid
    }
  }
}
    `;
export const useCreateVendorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateVendorMutation, TError, CreateVendorMutationVariables, TContext>) =>
    useMutation<CreateVendorMutation, TError, CreateVendorMutationVariables, TContext>(
      'createVendor',
      useFetchData<CreateVendorMutation, CreateVendorMutationVariables>(CreateVendorDocument),
      options
    );
export const UpdateVendorDocument = `
    mutation updateVendor($input: UpdateVendorInput!) {
  updateVendor(input: $input) {
    vendor {
      vendorCode
      versionUuid
    }
  }
}
    `;
export const useUpdateVendorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateVendorMutation, TError, UpdateVendorMutationVariables, TContext>) =>
    useMutation<UpdateVendorMutation, TError, UpdateVendorMutationVariables, TContext>(
      'updateVendor',
      useFetchData<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument),
      options
    );
export const DeleteVendorDocument = `
    mutation deleteVendor($input: DeleteVendorInput!) {
  deleteVendor(input: $input) {
    vendor {
      vendorCode
      versionUuid
    }
  }
}
    `;
export const useDeleteVendorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteVendorMutation, TError, DeleteVendorMutationVariables, TContext>) =>
    useMutation<DeleteVendorMutation, TError, DeleteVendorMutationVariables, TContext>(
      'deleteVendor',
      useFetchData<DeleteVendorMutation, DeleteVendorMutationVariables>(DeleteVendorDocument),
      options
    );
export const SearchVendorDocument = `
    query searchVendor($first: Int, $after: String, $filter: SearchVendorFilter, $sort: [VendorSortEnum]) {
  searchVendor(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...VendorFields
      }
    }
  }
}
    ${VendorFieldsFragmentDoc}`;
export const useSearchVendorQuery = <
      TData = SearchVendorQuery,
      TError = unknown
    >(
      variables?: SearchVendorQueryVariables,
      options?: UseQueryOptions<SearchVendorQuery, TError, TData>
    ) =>
    useQuery<SearchVendorQuery, TError, TData>(
      variables === undefined ? ['searchVendor'] : ['searchVendor', variables],
      useFetchData<SearchVendorQuery, SearchVendorQueryVariables>(SearchVendorDocument).bind(null, variables),
      options
    );

useSearchVendorQuery.getKey = (variables?: SearchVendorQueryVariables) => variables === undefined ? ['searchVendor'] : ['searchVendor', variables];
;

export const useInfiniteSearchVendorQuery = <
      TData = SearchVendorQuery,
      TError = unknown
    >(
      variables?: SearchVendorQueryVariables,
      options?: UseInfiniteQueryOptions<SearchVendorQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchVendorQuery, TError, TData>(
      variables === undefined ? ['searchVendor.infinite'] : ['searchVendor.infinite', variables],
      (metaData) => useFetchData<SearchVendorQuery, SearchVendorQueryVariables>(SearchVendorDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const WarehouseDocument = `
    query Warehouse($id: ID!) {
  warehouse(id: $id) {
    ...WarehouseFields
  }
}
    ${WarehouseFieldsFragmentDoc}`;
export const useWarehouseQuery = <
      TData = WarehouseQuery,
      TError = unknown
    >(
      variables: WarehouseQueryVariables,
      options?: UseQueryOptions<WarehouseQuery, TError, TData>
    ) =>
    useQuery<WarehouseQuery, TError, TData>(
      ['Warehouse', variables],
      useFetchData<WarehouseQuery, WarehouseQueryVariables>(WarehouseDocument).bind(null, variables),
      options
    );

useWarehouseQuery.getKey = (variables: WarehouseQueryVariables) => ['Warehouse', variables];
;

export const useInfiniteWarehouseQuery = <
      TData = WarehouseQuery,
      TError = unknown
    >(
      variables: WarehouseQueryVariables,
      options?: UseInfiniteQueryOptions<WarehouseQuery, TError, TData>
    ) =>
    useInfiniteQuery<WarehouseQuery, TError, TData>(
      ['Warehouse.infinite', variables],
      (metaData) => useFetchData<WarehouseQuery, WarehouseQueryVariables>(WarehouseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateWarehouseDocument = `
    mutation createWarehouse($input: CreateWarehouseInput!) {
  createWarehouse(input: $input) {
    warehouse {
      versionUuid
      warehouseCode
    }
  }
}
    `;
export const useCreateWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWarehouseMutation, TError, CreateWarehouseMutationVariables, TContext>) =>
    useMutation<CreateWarehouseMutation, TError, CreateWarehouseMutationVariables, TContext>(
      'createWarehouse',
      useFetchData<CreateWarehouseMutation, CreateWarehouseMutationVariables>(CreateWarehouseDocument),
      options
    );
export const UpdateWarehouseDocument = `
    mutation updateWarehouse($input: UpdateWarehouseInput!) {
  updateWarehouse(input: $input) {
    warehouse {
      versionUuid
      warehouseCode
    }
  }
}
    `;
export const useUpdateWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWarehouseMutation, TError, UpdateWarehouseMutationVariables, TContext>) =>
    useMutation<UpdateWarehouseMutation, TError, UpdateWarehouseMutationVariables, TContext>(
      'updateWarehouse',
      useFetchData<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>(UpdateWarehouseDocument),
      options
    );
export const DeleteWarehouseDocument = `
    mutation deleteWarehouse($input: DeleteWarehouseInput!) {
  deleteWarehouse(input: $input) {
    warehouse {
      warehouseCode
      versionUuid
    }
  }
}
    `;
export const useDeleteWarehouseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWarehouseMutation, TError, DeleteWarehouseMutationVariables, TContext>) =>
    useMutation<DeleteWarehouseMutation, TError, DeleteWarehouseMutationVariables, TContext>(
      'deleteWarehouse',
      useFetchData<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>(DeleteWarehouseDocument),
      options
    );
export const SearchWarehouseDocument = `
    query searchWarehouse($first: Int, $after: String, $filter: SearchWarehouseFilter, $sort: [WarehouseSortEnum]) {
  searchWarehouse(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WarehouseFields
      }
    }
  }
}
    ${WarehouseFieldsFragmentDoc}`;
export const useSearchWarehouseQuery = <
      TData = SearchWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseQueryVariables,
      options?: UseQueryOptions<SearchWarehouseQuery, TError, TData>
    ) =>
    useQuery<SearchWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchWarehouse'] : ['searchWarehouse', variables],
      useFetchData<SearchWarehouseQuery, SearchWarehouseQueryVariables>(SearchWarehouseDocument).bind(null, variables),
      options
    );

useSearchWarehouseQuery.getKey = (variables?: SearchWarehouseQueryVariables) => variables === undefined ? ['searchWarehouse'] : ['searchWarehouse', variables];
;

export const useInfiniteSearchWarehouseQuery = <
      TData = SearchWarehouseQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWarehouseQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWarehouseQuery, TError, TData>(
      variables === undefined ? ['searchWarehouse.infinite'] : ['searchWarehouse.infinite', variables],
      (metaData) => useFetchData<SearchWarehouseQuery, SearchWarehouseQueryVariables>(SearchWarehouseDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const WarehouseMoveDocument = `
    query warehouseMove($id: ID!) {
  warehouseMove(id: $id) {
    ...WarehouseMoveFields
  }
}
    ${WarehouseMoveFieldsFragmentDoc}`;
export const useWarehouseMoveQuery = <
      TData = WarehouseMoveQuery,
      TError = unknown
    >(
      variables: WarehouseMoveQueryVariables,
      options?: UseQueryOptions<WarehouseMoveQuery, TError, TData>
    ) =>
    useQuery<WarehouseMoveQuery, TError, TData>(
      ['warehouseMove', variables],
      useFetchData<WarehouseMoveQuery, WarehouseMoveQueryVariables>(WarehouseMoveDocument).bind(null, variables),
      options
    );

useWarehouseMoveQuery.getKey = (variables: WarehouseMoveQueryVariables) => ['warehouseMove', variables];
;

export const useInfiniteWarehouseMoveQuery = <
      TData = WarehouseMoveQuery,
      TError = unknown
    >(
      variables: WarehouseMoveQueryVariables,
      options?: UseInfiniteQueryOptions<WarehouseMoveQuery, TError, TData>
    ) =>
    useInfiniteQuery<WarehouseMoveQuery, TError, TData>(
      ['warehouseMove.infinite', variables],
      (metaData) => useFetchData<WarehouseMoveQuery, WarehouseMoveQueryVariables>(WarehouseMoveDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchWarehouseMoveDocument = `
    query searchWarehouseMove($first: Int, $after: String, $filter: SearchWarehouseMoveFilter, $sort: [WarehouseMoveSortEnum]) {
  searchWarehouseMove(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WarehouseMoveFields
      }
    }
  }
}
    ${WarehouseMoveFieldsFragmentDoc}`;
export const useSearchWarehouseMoveQuery = <
      TData = SearchWarehouseMoveQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseMoveQueryVariables,
      options?: UseQueryOptions<SearchWarehouseMoveQuery, TError, TData>
    ) =>
    useQuery<SearchWarehouseMoveQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseMove'] : ['searchWarehouseMove', variables],
      useFetchData<SearchWarehouseMoveQuery, SearchWarehouseMoveQueryVariables>(SearchWarehouseMoveDocument).bind(null, variables),
      options
    );

useSearchWarehouseMoveQuery.getKey = (variables?: SearchWarehouseMoveQueryVariables) => variables === undefined ? ['searchWarehouseMove'] : ['searchWarehouseMove', variables];
;

export const useInfiniteSearchWarehouseMoveQuery = <
      TData = SearchWarehouseMoveQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseMoveQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWarehouseMoveQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWarehouseMoveQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseMove.infinite'] : ['searchWarehouseMove.infinite', variables],
      (metaData) => useFetchData<SearchWarehouseMoveQuery, SearchWarehouseMoveQueryVariables>(SearchWarehouseMoveDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateWarehouseMoveDocument = `
    mutation createWarehouseMove($input: CreateWarehouseMoveInput!) {
  createWarehouseMove(input: $input) {
    warehouseMove {
      ...WarehouseMoveMutationFields
    }
  }
}
    ${WarehouseMoveMutationFieldsFragmentDoc}`;
export const useCreateWarehouseMoveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWarehouseMoveMutation, TError, CreateWarehouseMoveMutationVariables, TContext>) =>
    useMutation<CreateWarehouseMoveMutation, TError, CreateWarehouseMoveMutationVariables, TContext>(
      'createWarehouseMove',
      useFetchData<CreateWarehouseMoveMutation, CreateWarehouseMoveMutationVariables>(CreateWarehouseMoveDocument),
      options
    );
export const UpdateWarehouseMoveDocument = `
    mutation updateWarehouseMove($input: UpdateWarehouseMoveInput!) {
  updateWarehouseMove(input: $input) {
    warehouseMove {
      ...WarehouseMoveMutationFields
    }
  }
}
    ${WarehouseMoveMutationFieldsFragmentDoc}`;
export const useUpdateWarehouseMoveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWarehouseMoveMutation, TError, UpdateWarehouseMoveMutationVariables, TContext>) =>
    useMutation<UpdateWarehouseMoveMutation, TError, UpdateWarehouseMoveMutationVariables, TContext>(
      'updateWarehouseMove',
      useFetchData<UpdateWarehouseMoveMutation, UpdateWarehouseMoveMutationVariables>(UpdateWarehouseMoveDocument),
      options
    );
export const UpdateWarehouseMoveApproveDocument = `
    mutation updateWarehouseMoveApprove($input: UpdateWarehouseMoveApproveInput!) {
  updateWarehouseMoveApprove(input: $input) {
    warehouseMove {
      ...WarehouseMoveMutationFields
    }
  }
}
    ${WarehouseMoveMutationFieldsFragmentDoc}`;
export const useUpdateWarehouseMoveApproveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWarehouseMoveApproveMutation, TError, UpdateWarehouseMoveApproveMutationVariables, TContext>) =>
    useMutation<UpdateWarehouseMoveApproveMutation, TError, UpdateWarehouseMoveApproveMutationVariables, TContext>(
      'updateWarehouseMoveApprove',
      useFetchData<UpdateWarehouseMoveApproveMutation, UpdateWarehouseMoveApproveMutationVariables>(UpdateWarehouseMoveApproveDocument),
      options
    );
export const UpdateWarehouseMoveRejectDocument = `
    mutation updateWarehouseMoveReject($input: UpdateWarehouseMoveRejectInput!) {
  updateWarehouseMoveReject(input: $input) {
    warehouseMove {
      ...WarehouseMoveMutationFields
    }
  }
}
    ${WarehouseMoveMutationFieldsFragmentDoc}`;
export const useUpdateWarehouseMoveRejectMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWarehouseMoveRejectMutation, TError, UpdateWarehouseMoveRejectMutationVariables, TContext>) =>
    useMutation<UpdateWarehouseMoveRejectMutation, TError, UpdateWarehouseMoveRejectMutationVariables, TContext>(
      'updateWarehouseMoveReject',
      useFetchData<UpdateWarehouseMoveRejectMutation, UpdateWarehouseMoveRejectMutationVariables>(UpdateWarehouseMoveRejectDocument),
      options
    );
export const DeleteWarehouseMoveDocument = `
    mutation deleteWarehouseMove($input: DeleteWarehouseMoveInput!) {
  deleteWarehouseMove(input: $input) {
    warehouseMove {
      ...WarehouseMoveMutationFields
    }
  }
}
    ${WarehouseMoveMutationFieldsFragmentDoc}`;
export const useDeleteWarehouseMoveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWarehouseMoveMutation, TError, DeleteWarehouseMoveMutationVariables, TContext>) =>
    useMutation<DeleteWarehouseMoveMutation, TError, DeleteWarehouseMoveMutationVariables, TContext>(
      'deleteWarehouseMove',
      useFetchData<DeleteWarehouseMoveMutation, DeleteWarehouseMoveMutationVariables>(DeleteWarehouseMoveDocument),
      options
    );
export const SearchWarehouseMoveDetailDocument = `
    query searchWarehouseMoveDetail($first: Int, $after: String, $filter: SearchWarehouseMoveDetailFilter) {
  searchWarehouseMoveDetail(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        moveDate
        tradeHistoryType
        tradeTargetId
        sourceDivisionCode
        sourceDivisionName
        sourceWarehouseCode
        sourceWarehouseName
        destinationDivisionCode
        destinationDivisionName
        destinationWarehouseCode
        destinationWarehouseName
        destinationJanCode
        destinationAttributeName
        moveQuantity
        destinationSalesUnitPrice
        destinationPrice
        sourceJanCode
        sourceAttributeName
        sourceSalesUnitPrice
        sourcePrice
        detailMemo
        receiveOrderId
        deliveryOrderId
        warehouseMoveId
        adjustId
      }
    }
  }
}
    `;
export const useSearchWarehouseMoveDetailQuery = <
      TData = SearchWarehouseMoveDetailQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseMoveDetailQueryVariables,
      options?: UseQueryOptions<SearchWarehouseMoveDetailQuery, TError, TData>
    ) =>
    useQuery<SearchWarehouseMoveDetailQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseMoveDetail'] : ['searchWarehouseMoveDetail', variables],
      useFetchData<SearchWarehouseMoveDetailQuery, SearchWarehouseMoveDetailQueryVariables>(SearchWarehouseMoveDetailDocument).bind(null, variables),
      options
    );

useSearchWarehouseMoveDetailQuery.getKey = (variables?: SearchWarehouseMoveDetailQueryVariables) => variables === undefined ? ['searchWarehouseMoveDetail'] : ['searchWarehouseMoveDetail', variables];
;

export const useInfiniteSearchWarehouseMoveDetailQuery = <
      TData = SearchWarehouseMoveDetailQuery,
      TError = unknown
    >(
      variables?: SearchWarehouseMoveDetailQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWarehouseMoveDetailQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWarehouseMoveDetailQuery, TError, TData>(
      variables === undefined ? ['searchWarehouseMoveDetail.infinite'] : ['searchWarehouseMoveDetail.infinite', variables],
      (metaData) => useFetchData<SearchWarehouseMoveDetailQuery, SearchWarehouseMoveDetailQueryVariables>(SearchWarehouseMoveDetailDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const WithdrawalDocument = `
    query Withdrawal($id: ID!) {
  withdrawal(id: $id) {
    ...WithdrawalFields
  }
}
    ${WithdrawalFieldsFragmentDoc}`;
export const useWithdrawalQuery = <
      TData = WithdrawalQuery,
      TError = unknown
    >(
      variables: WithdrawalQueryVariables,
      options?: UseQueryOptions<WithdrawalQuery, TError, TData>
    ) =>
    useQuery<WithdrawalQuery, TError, TData>(
      ['Withdrawal', variables],
      useFetchData<WithdrawalQuery, WithdrawalQueryVariables>(WithdrawalDocument).bind(null, variables),
      options
    );

useWithdrawalQuery.getKey = (variables: WithdrawalQueryVariables) => ['Withdrawal', variables];
;

export const useInfiniteWithdrawalQuery = <
      TData = WithdrawalQuery,
      TError = unknown
    >(
      variables: WithdrawalQueryVariables,
      options?: UseInfiniteQueryOptions<WithdrawalQuery, TError, TData>
    ) =>
    useInfiniteQuery<WithdrawalQuery, TError, TData>(
      ['Withdrawal.infinite', variables],
      (metaData) => useFetchData<WithdrawalQuery, WithdrawalQueryVariables>(WithdrawalDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchWithdrawalDocument = `
    query searchWithdrawal($first: Int, $after: String, $filter: SearchWithdrawalFilter, $sort: [WithdrawalSortEnum], $detailFilter: WithdrawalDetailFilter) {
  searchWithdrawal(first: $first, after: $after, filter: $filter, sort: $sort) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...SearchWithdrawalFields
        withdrawalDetails(filter: $detailFilter) {
          edges {
            node {
              ...WithdrawalDetailFields
            }
          }
        }
      }
    }
  }
}
    ${SearchWithdrawalFieldsFragmentDoc}
${WithdrawalDetailFieldsFragmentDoc}`;
export const useSearchWithdrawalQuery = <
      TData = SearchWithdrawalQuery,
      TError = unknown
    >(
      variables?: SearchWithdrawalQueryVariables,
      options?: UseQueryOptions<SearchWithdrawalQuery, TError, TData>
    ) =>
    useQuery<SearchWithdrawalQuery, TError, TData>(
      variables === undefined ? ['searchWithdrawal'] : ['searchWithdrawal', variables],
      useFetchData<SearchWithdrawalQuery, SearchWithdrawalQueryVariables>(SearchWithdrawalDocument).bind(null, variables),
      options
    );

useSearchWithdrawalQuery.getKey = (variables?: SearchWithdrawalQueryVariables) => variables === undefined ? ['searchWithdrawal'] : ['searchWithdrawal', variables];
;

export const useInfiniteSearchWithdrawalQuery = <
      TData = SearchWithdrawalQuery,
      TError = unknown
    >(
      variables?: SearchWithdrawalQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWithdrawalQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWithdrawalQuery, TError, TData>(
      variables === undefined ? ['searchWithdrawal.infinite'] : ['searchWithdrawal.infinite', variables],
      (metaData) => useFetchData<SearchWithdrawalQuery, SearchWithdrawalQueryVariables>(SearchWithdrawalDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const SearchWithdrawalMonthlyDocument = `
    query searchWithdrawalMonthly($first: Int, $after: String, $filter: SearchWithDrawalsMonthlyFilter) {
  searchWithdrawalMonthly(first: $first, after: $after, filter: $filter) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...WithdrawalMonthlyFields
      }
    }
  }
}
    ${WithdrawalMonthlyFieldsFragmentDoc}`;
export const useSearchWithdrawalMonthlyQuery = <
      TData = SearchWithdrawalMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchWithdrawalMonthlyQueryVariables,
      options?: UseQueryOptions<SearchWithdrawalMonthlyQuery, TError, TData>
    ) =>
    useQuery<SearchWithdrawalMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchWithdrawalMonthly'] : ['searchWithdrawalMonthly', variables],
      useFetchData<SearchWithdrawalMonthlyQuery, SearchWithdrawalMonthlyQueryVariables>(SearchWithdrawalMonthlyDocument).bind(null, variables),
      options
    );

useSearchWithdrawalMonthlyQuery.getKey = (variables?: SearchWithdrawalMonthlyQueryVariables) => variables === undefined ? ['searchWithdrawalMonthly'] : ['searchWithdrawalMonthly', variables];
;

export const useInfiniteSearchWithdrawalMonthlyQuery = <
      TData = SearchWithdrawalMonthlyQuery,
      TError = unknown
    >(
      variables?: SearchWithdrawalMonthlyQueryVariables,
      options?: UseInfiniteQueryOptions<SearchWithdrawalMonthlyQuery, TError, TData>
    ) =>
    useInfiniteQuery<SearchWithdrawalMonthlyQuery, TError, TData>(
      variables === undefined ? ['searchWithdrawalMonthly.infinite'] : ['searchWithdrawalMonthly.infinite', variables],
      (metaData) => useFetchData<SearchWithdrawalMonthlyQuery, SearchWithdrawalMonthlyQueryVariables>(SearchWithdrawalMonthlyDocument).bind(null, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );

export const CreateWithdrawalDocument = `
    mutation createWithdrawal($input: CreateWithdrawalInput!) {
  createWithdrawal(input: $input) {
    withdrawal {
      versionUuid
      payId
    }
  }
}
    `;
export const useCreateWithdrawalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWithdrawalMutation, TError, CreateWithdrawalMutationVariables, TContext>) =>
    useMutation<CreateWithdrawalMutation, TError, CreateWithdrawalMutationVariables, TContext>(
      'createWithdrawal',
      useFetchData<CreateWithdrawalMutation, CreateWithdrawalMutationVariables>(CreateWithdrawalDocument),
      options
    );
export const UpdateWithdrawalDocument = `
    mutation updateWithdrawal($input: UpdateWithdrawalInput!) {
  updateWithdrawal(input: $input) {
    withdrawal {
      versionUuid
      payId
    }
  }
}
    `;
export const useUpdateWithdrawalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWithdrawalMutation, TError, UpdateWithdrawalMutationVariables, TContext>) =>
    useMutation<UpdateWithdrawalMutation, TError, UpdateWithdrawalMutationVariables, TContext>(
      'updateWithdrawal',
      useFetchData<UpdateWithdrawalMutation, UpdateWithdrawalMutationVariables>(UpdateWithdrawalDocument),
      options
    );
export const DeleteWithdrawalDocument = `
    mutation deleteWithdrawal($input: DeleteWithdrawalInput!) {
  deleteWithdrawal(input: $input) {
    withdrawal {
      versionUuid
      payId
    }
  }
}
    `;
export const useDeleteWithdrawalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWithdrawalMutation, TError, DeleteWithdrawalMutationVariables, TContext>) =>
    useMutation<DeleteWithdrawalMutation, TError, DeleteWithdrawalMutationVariables, TContext>(
      'deleteWithdrawal',
      useFetchData<DeleteWithdrawalMutation, DeleteWithdrawalMutationVariables>(DeleteWithdrawalDocument),
      options
    );
export const CreateAutomaticWithdrawalDocument = `
    mutation createAutomaticWithdrawal($input: CreateAutomaticWithdrawalsInput!) {
  createAutomaticWithdrawal(input: $input) {
    automaticWithdrawal {
      versionUuid
      payId
    }
  }
}
    `;
export const useCreateAutomaticWithdrawalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAutomaticWithdrawalMutation, TError, CreateAutomaticWithdrawalMutationVariables, TContext>) =>
    useMutation<CreateAutomaticWithdrawalMutation, TError, CreateAutomaticWithdrawalMutationVariables, TContext>(
      'createAutomaticWithdrawal',
      useFetchData<CreateAutomaticWithdrawalMutation, CreateAutomaticWithdrawalMutationVariables>(CreateAutomaticWithdrawalDocument),
      options
    );
export const DeleteAutomaticWithdrawalDocument = `
    mutation deleteAutomaticWithdrawal($input: DeleteAutomaticWithdrawalsInput!) {
  deleteAutomaticWithdrawal(input: $input) {
    payment {
      versionUuid
      paymentId
    }
  }
}
    `;
export const useDeleteAutomaticWithdrawalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAutomaticWithdrawalMutation, TError, DeleteAutomaticWithdrawalMutationVariables, TContext>) =>
    useMutation<DeleteAutomaticWithdrawalMutation, TError, DeleteAutomaticWithdrawalMutationVariables, TContext>(
      'deleteAutomaticWithdrawal',
      useFetchData<DeleteAutomaticWithdrawalMutation, DeleteAutomaticWithdrawalMutationVariables>(DeleteAutomaticWithdrawalDocument),
      options
    );